webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export url */
var url = {
      Url: {}
};


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WS_API_URL; });
// export const BASE_URL = "http://192.168.0.103:9090";

// 根据环境来选择api地址
var baseUrl = window.location.hostname;
var BASE_URL_FOR_API = "";
var BASE_URL_FOR_STOCK = "";
var WS_URL = "";
console.log(baseUrl);
switch (baseUrl) {
    case "localhost":
        // BASE_URL_FOR_API = 'https://prod-api.huoxingy.com/';
        // BASE_URL_FOR_STOCK = "https://prod-api.huoxingy.com/v1/stock/"
        BASE_URL_FOR_API = 'https://staging-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://staging-api.huoxingy.com/v1/stock/";
        WS_URL = "https://staging-ws.huoxingy.com/";
        break;
    case "10.0.0.23":
        BASE_URL_FOR_API = 'https://staging-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://staging-api.huoxingy.com/v1/stock/";
        WS_URL = "https://staging-ws.huoxingy.com/";
        break;
    case "192.168.2.68":
        BASE_URL_FOR_API = 'https://staging-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://staging-api.huoxingy.com/v1/stock/";
        WS_URL = "https://staging-ws.huoxingy.com/";
        break;
    case "staging-admin.huoxingy.com":
        BASE_URL_FOR_API = 'https://staging-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://staging-api.huoxingy.com/v1/stock/";
        WS_URL = "https://staging-ws.huoxingy.com/";
        break;
    case "prod-test-admin.huoxingy.com":
        BASE_URL_FOR_API = 'https://prod-test-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://prod-test-api.huoxingy.com/v1/stock/";
        WS_URL = "https://prod-test-ws.huoxingy.com/";
        break;
    default:
        BASE_URL_FOR_API = 'https://prod-api.huoxingy.com/';
        BASE_URL_FOR_STOCK = "https://prod-api.huoxingy.com/v1/stock/";
        WS_URL = "https://prod-ws.huoxingy.com/";
        break;
}
//
var BASE_URL = BASE_URL_FOR_STOCK;
var API_BASE_URL = BASE_URL_FOR_API;
var WS_API_URL = WS_URL;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(762)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(940),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(765)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(943),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4919c285",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_login_login_vue__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_login_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_login_login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_register_register_vue__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_register_register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_register_register_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_store_store_vue__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_store_store_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_store_store_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_addStore_addStore_vue__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_addStore_addStore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_addStore_addStore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_index_index_vue__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_index_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_index_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_indexRouters_home_home_vue__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_indexRouters_home_home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_indexRouters_home_home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_indexRouters_statement_statement_vue__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_indexRouters_statement_statement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_indexRouters_statement_statement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_indexRouters_employee_employee_vue__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_indexRouters_employee_employee_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_indexRouters_employee_employee_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_indexRouters_employee_wechatList_vue__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_indexRouters_employee_wechatList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_indexRouters_employee_wechatList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_indexRouters_employee_achievement_vue__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_indexRouters_employee_achievement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_indexRouters_employee_achievement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_indexRouters_jobs_jobs_vue__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_indexRouters_jobs_jobs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_indexRouters_jobs_jobs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_indexRouters_vipMan_vipMan_vue__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_indexRouters_vipMan_vipMan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_indexRouters_vipMan_vipMan_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_indexRouters_vipMan_lostVip_vue__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_indexRouters_vipMan_lostVip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_indexRouters_vipMan_lostVip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_indexRouters_vipMan_vipCons_vue__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_indexRouters_vipMan_vipCons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_indexRouters_vipMan_vipCons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_indexRouters_vipMan_chargeInfo_vue__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_indexRouters_vipMan_chargeInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_indexRouters_vipMan_chargeInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_indexRouters_vipMan_vipRecharge_vue__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_indexRouters_vipMan_vipRecharge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_indexRouters_vipMan_vipRecharge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_indexRouters_vipMan_wechatOrder_vue__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_indexRouters_vipMan_wechatOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_indexRouters_vipMan_wechatOrder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_indexRouters_saleInfo_exchangeWork_exchangeWork_vue__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_indexRouters_saleInfo_exchangeWork_exchangeWork_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_indexRouters_saleInfo_exchangeWork_exchangeWork_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_indexRouters_saleInfo_exchangeWork_exchangeWorkNew_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_indexRouters_saleInfo_exchangeWork_exchangeWorkNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_indexRouters_saleInfo_exchangeWork_exchangeWorkNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_indexRouters_saleInfo_settleCount_settleCount_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_indexRouters_saleInfo_settleCount_settleCount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_indexRouters_saleInfo_settleCount_settleCount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_indexRouters_saleInfo_exchangeWork_subpages_staffGrade__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_indexRouters_saleInfo_exchangeWork_subpages_staffGrade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_indexRouters_saleInfo_exchangeWork_subpages_staffGrade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_indexRouters_saleInfo_dailyGrade_dailyGrade_vue__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_indexRouters_saleInfo_dailyGrade_dailyGrade_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_indexRouters_saleInfo_dailyGrade_dailyGrade_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_indexRouters_saleInfo_ringReport_ringReport_vue__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_indexRouters_saleInfo_ringReport_ringReport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_indexRouters_saleInfo_ringReport_ringReport_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_indexRouters_callAndReward_rewardInfo_rewardInfo_vue__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_indexRouters_callAndReward_rewardInfo_rewardInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_indexRouters_callAndReward_rewardInfo_rewardInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_indexRouters_callAndReward_ratingInfo_ratingInfo_vue__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_indexRouters_callAndReward_ratingInfo_ratingInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_indexRouters_callAndReward_ratingInfo_ratingInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_indexRouters_callAndReward_getWithdraw_getWithdraw_vue__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_indexRouters_callAndReward_getWithdraw_getWithdraw_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_indexRouters_callAndReward_getWithdraw_getWithdraw_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_indexRouters_callAndReward_putWithdraw_putWithdraw_vue__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_indexRouters_callAndReward_putWithdraw_putWithdraw_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_indexRouters_callAndReward_putWithdraw_putWithdraw_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_indexRouters_callAndReward_setWithdraw_setWithdraw_vue__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_indexRouters_callAndReward_setWithdraw_setWithdraw_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_indexRouters_callAndReward_setWithdraw_setWithdraw_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_indexRouters_callAndReward_dlCall_dlCall_vue__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_indexRouters_callAndReward_dlCall_dlCall_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_indexRouters_callAndReward_dlCall_dlCall_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_indexRouters_saleInfo_totalSales_totalSales_vue__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_indexRouters_saleInfo_totalSales_totalSales_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_indexRouters_saleInfo_totalSales_totalSales_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_indexRouters_saleInfo_elecSales_elecSales_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_indexRouters_saleInfo_elecSales_elecSales_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_indexRouters_saleInfo_elecSales_elecSales_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_indexRouters_saleInfo_stockSummary_stockSummary_vue__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_indexRouters_saleInfo_stockSummary_stockSummary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_indexRouters_saleInfo_stockSummary_stockSummary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_indexRouters_saleInfo_stockData_stockData_vue__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_indexRouters_saleInfo_stockData_stockData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_indexRouters_saleInfo_stockData_stockData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_indexRouters_saleInfo_orderSearch_orderSearch_vue__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_indexRouters_saleInfo_orderSearch_orderSearch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_indexRouters_saleInfo_orderSearch_orderSearch_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_indexRouters_goods_info_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_indexRouters_goods_info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_indexRouters_goods_info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_indexRouters_goods_spec_vue__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_indexRouters_goods_spec_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_indexRouters_goods_spec_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_indexRouters_goods_goodsLog_vue__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_indexRouters_goods_goodsLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_indexRouters_goods_goodsLog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_indexRouters_goods_classify_vue__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_indexRouters_goods_classify_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_indexRouters_goods_classify_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_indexRouters_goods_interval_vue__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_indexRouters_goods_interval_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_indexRouters_goods_interval_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_indexRouters_MerchantInformation_merCert_vue__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_indexRouters_MerchantInformation_merCert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_indexRouters_MerchantInformation_merCert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_indexRouters_topUp_topUp_vue__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_indexRouters_topUp_topUp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_indexRouters_topUp_topUp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_indexRouters_createCode_createCode_vue__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_indexRouters_createCode_createCode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_indexRouters_createCode_createCode_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_indexRouters_setting_setting_vue__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_indexRouters_setting_setting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_indexRouters_setting_setting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_indexRouters_coupon_addcoupon_vue__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_indexRouters_coupon_addcoupon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_indexRouters_coupon_addcoupon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_indexRouters_coupon_coupondetail_vue__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_indexRouters_coupon_coupondetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_indexRouters_coupon_coupondetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_indexRouters_coupon_couponProfile_vue__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_indexRouters_coupon_couponProfile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_indexRouters_coupon_couponProfile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_indexRouters_coupon_verifiCoupon_vue__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_indexRouters_coupon_verifiCoupon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_indexRouters_coupon_verifiCoupon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_indexRouters_voucher_voucher_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_indexRouters_voucher_voucher_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_indexRouters_voucher_voucher_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_indexRouters_voiceCall_voiceCall_vue__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_indexRouters_voiceCall_voiceCall_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_indexRouters_voiceCall_voiceCall_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_indexRouters_market_market_vue__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_indexRouters_market_market_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_indexRouters_market_market_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_indexRouters_market_address_vue__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_indexRouters_market_address_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_indexRouters_market_address_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_indexRouters_market_orderInfo_vue__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_indexRouters_market_orderInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_indexRouters_market_orderInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_indexRouters_activity_second_second_vue__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_indexRouters_activity_second_second_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_indexRouters_activity_second_second_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_indexRouters_activity_second_modifySecond_index_vue__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_indexRouters_activity_second_modifySecond_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_indexRouters_activity_second_modifySecond_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_indexRouters_material_matUnit_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_indexRouters_material_matUnit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_indexRouters_material_matUnit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_indexRouters_material_matGoods_vue__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_indexRouters_material_matGoods_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_indexRouters_material_matGoods_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_indexRouters_peiGoods_info_vue__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_indexRouters_peiGoods_info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_indexRouters_peiGoods_info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_indexRouters_computer_region_vue__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_indexRouters_computer_region_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_indexRouters_computer_region_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_indexRouters_waitSite_region_vue__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_indexRouters_waitSite_region_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_indexRouters_waitSite_region_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_indexRouters_waitSite_regionType_vue__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_indexRouters_waitSite_regionType_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_indexRouters_waitSite_regionType_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_indexRouters_computer_site_vue__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_indexRouters_computer_site_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_indexRouters_computer_site_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_indexRouters_goods_catchRateGoods_vue__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_indexRouters_goods_catchRateGoods_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_indexRouters_goods_catchRateGoods_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_indexRouters_goods_bigScreenGoods_vue__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_indexRouters_goods_bigScreenGoods_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_indexRouters_goods_bigScreenGoods_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_bigScreen_index_vue__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_bigScreen_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_bigScreen_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_bigScreenFrontEnd_index_vue__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_bigScreenFrontEnd_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_bigScreenFrontEnd_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_bigScreenFrontEndWithoutAutoScreen_index_vue__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_bigScreenFrontEndWithoutAutoScreen_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_bigScreenFrontEndWithoutAutoScreen_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_goodsBigScreen_index_vue__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_goodsBigScreen_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_goodsBigScreen_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_indexRouters_rent_cate_index_vue__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_indexRouters_rent_cate_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_indexRouters_rent_cate_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_indexRouters_rent_goods_index_vue__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_indexRouters_rent_goods_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_indexRouters_rent_goods_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_indexRouters_rent_ruleMana_index_vue__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_indexRouters_rent_ruleMana_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_indexRouters_rent_ruleMana_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_indexRouters_rent_rentOrder_rentOrder_vue__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_indexRouters_rent_rentOrder_rentOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_indexRouters_rent_rentOrder_rentOrder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_indexRouters_rent_rentDetail_rentDetail_vue__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_indexRouters_rent_rentDetail_rentDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_indexRouters_rent_rentDetail_rentDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_indexRouters_rent_hello_index_vue__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_indexRouters_rent_hello_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_indexRouters_rent_hello_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_indexRouters_rent_goodsLog_goodsLog_vue__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_indexRouters_rent_goodsLog_goodsLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_indexRouters_rent_goodsLog_goodsLog_vue__);








// index routers

 //报表
 //员工列表
 //微信通知列表
 //员工业绩
 //岗位
 //会员资料
 //流失会员
 //会员消费记录
 //会员充值记录
 //会员充值规则记录
 //微信点单列表
// import invAdd from '@/components/indexRouters/inventory/addGoods.vue'//商品入库
// import invList from '@/components/indexRouters/inventory/invList.vue'//盘点历史
// import invDetails from '@/components/indexRouters/inventory/details.vue'//库存详情
// import invDestroy from '@/components/indexRouters/inventory/destroy.vue'//商品报损
// import invWarning from '@/components/indexRouters/inventory/warning.vue'//库存预警
 //交接班记录
 //交接班记录
 //
 //员工的对账单
 //对账单
 //同期报表
 //打赏记录
 //打赏记录
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //商品资料
 //商品资料
 //商品资料
 //商品分类
 //商品时段
 //商户认证
// import keyCert from '@/components/indexRouters/MerchantInformation/keyCert.vue'//秘钥认证
 //充值中心
 //创建二维码
 //创建二维码
 //优惠券
 //优惠券
 //优惠券
 //优惠券

 //优惠券
//语音呼叫设置界面





// 活动
 //商品时段
 //商品时段
// 
 //商品时段
 //商品时段
 //商品时段

 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //
 //商品资料

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        //重定向
        path: '*',
        redirect: '/login',
        meta: {
            isKeep: false
        }
    }, {
        path: '/login',
        name: 'login',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_login_login_vue___default.a,
        meta: {
            isKeep: false
        }
    }, {
        path: '/register/:foo',
        name: 'register',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_register_register_vue___default.a,
        meta: {
            isKeep: false
        }
    }, {
        path: '/register',
        name: 'register',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_register_register_vue___default.a,
        meta: {
            isKeep: false
        }
    }, {
        path: '/store',
        name: 'store',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_store_store_vue___default.a,
        meta: {
            isKeep: false
        }
    }, {
        path: '/sys/:id',
        name: 'sys',
        redirect: '/sys/:id/Statement',
        component: __WEBPACK_IMPORTED_MODULE_6__pages_index_index_vue___default.a,
        children: [{
            path: '/sys/:id/rentRule',
            name: 'rentRule',
            component: __WEBPACK_IMPORTED_MODULE_71__components_indexRouters_rent_ruleMana_index_vue___default.a,
            meta: {
                isKeep: false,
                tabName: '计费规则'
            }
        }, {
            path: '/sys/:id/rentHello',
            name: 'rentHello',
            component: __WEBPACK_IMPORTED_MODULE_74__components_indexRouters_rent_hello_index_vue___default.a,
            meta: {
                isKeep: false,
                tabName: '计费规则'
            }
        }, {
            path: '/sys/:id/rentDetail',
            name: 'rentDetail',
            component: __WEBPACK_IMPORTED_MODULE_73__components_indexRouters_rent_rentDetail_rentDetail_vue___default.a,
            meta: {
                isKeep: false,
                tabName: '租赁明细'
            }
        }, {
            path: '/sys/:id/rentOrder',
            name: 'rentOrder',
            component: __WEBPACK_IMPORTED_MODULE_72__components_indexRouters_rent_rentOrder_rentOrder_vue___default.a,
            meta: {
                isKeep: false,
                tabName: '租赁明细'
            }
        }, {
            path: '/sys/:id/rentCate',
            name: 'rentCate',
            component: __WEBPACK_IMPORTED_MODULE_69__components_indexRouters_rent_cate_index_vue___default.a,
            meta: {
                isKeep: false,
                tabName: '分类管理'
            }
        }, {
            path: '/sys/:id/rentGoods',
            name: 'rentGoods',
            component: __WEBPACK_IMPORTED_MODULE_70__components_indexRouters_rent_goods_index_vue___default.a,
            meta: {
                isKeep: false,
                tabName: '商品管理'
            }
        }, {
            path: '/sys/:id/bigScreenGoods',
            name: 'bigScreenGoods',
            component: __WEBPACK_IMPORTED_MODULE_64__components_indexRouters_goods_bigScreenGoods_vue___default.a,
            meta: {
                isKeep: false,
                tabName: '排单机'
            }
        }, {
            path: '/sys/:id/goodsBigScreen',
            name: 'goodsBigScreen',
            component: __WEBPACK_IMPORTED_MODULE_68__components_goodsBigScreen_index_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '排单机'
            }
        }, {
            path: '/sys/:id/catchRateGoods',
            name: 'catchRateGoods',
            component: __WEBPACK_IMPORTED_MODULE_63__components_indexRouters_goods_catchRateGoods_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '捕获率商品'
            }
        }, {
            path: '/sys/:id/matUnit',
            name: 'matUnit',
            component: __WEBPACK_IMPORTED_MODULE_56__components_indexRouters_material_matUnit_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '原料单位管理'
            }
        }, {
            path: '/sys/:id/matGoods',
            name: 'matGoods',
            component: __WEBPACK_IMPORTED_MODULE_57__components_indexRouters_material_matGoods_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '原料商品管理'
            }
        }, {
            path: '/sys/:id/region',
            name: 'region',
            component: __WEBPACK_IMPORTED_MODULE_59__components_indexRouters_computer_region_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '区域管理'
            }
        }, {
            path: '/sys/:id/regionType',
            name: 'regionType',
            component: __WEBPACK_IMPORTED_MODULE_61__components_indexRouters_waitSite_regionType_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '区域分类'
            }
        }, {
            path: '/sys/:id/waitRegion',
            name: 'waitRegion',
            component: __WEBPACK_IMPORTED_MODULE_60__components_indexRouters_waitSite_region_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '排号管理'
            }
        }, {
            path: '/sys/:id/site',
            name: 'site',
            component: __WEBPACK_IMPORTED_MODULE_62__components_indexRouters_computer_site_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '机位设置'
            }
        },
        // 
        {
            path: '/sys/:id/bigScreen',
            name: 'site',
            component: __WEBPACK_IMPORTED_MODULE_65__components_bigScreen_index_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '机位大屏'
            }
        }, {
            path: '/sys/:id/bigScreenFrontEnd',
            name: 'bigScreenFrontEnd',
            component: __WEBPACK_IMPORTED_MODULE_66__components_bigScreenFrontEnd_index_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '机位大屏'
            }
        }, {
            path: '/sys/:id/bigScreenFrontEndWithoutAutoScreen',
            name: 'bigScreenFrontEndWithoutAutoScreen',
            component: __WEBPACK_IMPORTED_MODULE_67__components_bigScreenFrontEndWithoutAutoScreen_index_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '机位大屏'
            }
        },
        // 
        {
            path: '/sys/:id/peiGoods',
            name: 'peiGoods',
            component: __WEBPACK_IMPORTED_MODULE_58__components_indexRouters_peiGoods_info_vue___default.a,
            meta: {
                isKeep: true,
                tabName: '配品列表'
            }
        }, {
            path: '/sys/:id/home',
            name: 'home',
            component: __WEBPACK_IMPORTED_MODULE_7__components_indexRouters_home_home_vue___default.a,
            meta: {
                isKeep: false
            }
        }, {
            path: '/sys/:id/Statement',
            name: 'Statement',
            component: __WEBPACK_IMPORTED_MODULE_8__components_indexRouters_statement_statement_vue___default.a,
            meta: {
                tabName: '店铺报表',
                isKeep: true
            }
        }, {
            path: '/sys/:id/addcoupon',
            name: 'addcoupon',
            component: __WEBPACK_IMPORTED_MODULE_45__components_indexRouters_coupon_addcoupon_vue___default.a,
            meta: {
                tabName: '创建中心',
                isKeep: true

            }
        }, {
            path: '/sys/:id/couponProfile',
            name: 'couponProfile',
            component: __WEBPACK_IMPORTED_MODULE_47__components_indexRouters_coupon_couponProfile_vue___default.a,
            meta: {
                tabName: '优惠券详情',
                isKeep: false

            }
        }, {
            path: '/sys/:id/couponDetail',
            name: 'couponDetail',
            component: __WEBPACK_IMPORTED_MODULE_46__components_indexRouters_coupon_coupondetail_vue___default.a,
            meta: {
                tabName: '派发记录',
                isKeep: true

            }
        }, {
            path: '/sys/:id/verifiCoupon',
            name: 'verifiCoupon',
            component: __WEBPACK_IMPORTED_MODULE_48__components_indexRouters_coupon_verifiCoupon_vue___default.a,
            meta: {
                tabName: '核销详情',
                isKeep: true
            }
        }, {
            path: '/sys/:id/voucher',
            name: 'voucher',
            component: __WEBPACK_IMPORTED_MODULE_49__components_indexRouters_voucher_voucher_vue___default.a,
            meta: {
                tabName: '',
                isKeep: false
            }
        }, {
            path: '/sys/:id/employee',
            name: 'employee',
            component: __WEBPACK_IMPORTED_MODULE_9__components_indexRouters_employee_employee_vue___default.a,
            meta: {
                tabName: '员工列表',
                isKeep: true
            }
        }, {
            path: '/sys/:id/wechatList',
            name: 'wechatList',
            component: __WEBPACK_IMPORTED_MODULE_10__components_indexRouters_employee_wechatList_vue___default.a,
            meta: {
                tabName: '微信通知',
                isKeep: true
            }
        }, {
            path: '/sys/:id/achievement',
            name: 'achievement',
            component: __WEBPACK_IMPORTED_MODULE_11__components_indexRouters_employee_achievement_vue___default.a,
            meta: {
                tabName: '员工业绩',
                isKeep: true

            }
        }, {
            path: '/sys/:id/jobs',
            name: 'jobs',
            component: __WEBPACK_IMPORTED_MODULE_12__components_indexRouters_jobs_jobs_vue___default.a,
            meta: {
                tabName: '岗位设置',
                isKeep: true
            }
        }, {
            path: '/sys/:id/vipMan',
            name: 'vipMan',
            component: __WEBPACK_IMPORTED_MODULE_13__components_indexRouters_vipMan_vipMan_vue___default.a,
            meta: {
                tabName: '',
                isKeep: false
            }
        }, {
            path: '/sys/:id/lostVip/:type',
            name: 'lostVip',
            component: __WEBPACK_IMPORTED_MODULE_14__components_indexRouters_vipMan_lostVip_vue___default.a,
            meta: {
                tabName: '会员资料',
                isKeep: true
            }
        }, {
            path: '/sys/:id/vipCons',
            name: 'vipCons',
            component: __WEBPACK_IMPORTED_MODULE_15__components_indexRouters_vipMan_vipCons_vue___default.a,
            meta: {
                tabName: '',
                isKeep: false
            }
        }, {
            path: '/sys/:id/vipRecharge',
            name: 'vipRecharge',
            component: __WEBPACK_IMPORTED_MODULE_17__components_indexRouters_vipMan_vipRecharge_vue___default.a,
            meta: {
                tabName: '会员充值规则',
                isKeep: true
            }
        }, {
            path: '/sys/:id/chargeInfo',
            name: 'chargeInfo',
            component: __WEBPACK_IMPORTED_MODULE_16__components_indexRouters_vipMan_chargeInfo_vue___default.a,
            meta: {
                tabName: '会员充值记录',
                isKeep: true
            }
        }, {
            path: '/sys/:id/wechatOrder',
            name: 'wechatOrder',
            component: __WEBPACK_IMPORTED_MODULE_18__components_indexRouters_vipMan_wechatOrder_vue___default.a,
            meta: {
                tabName: '微信点单',
                isKeep: true
            }
        },
        // {
        //     path: '/sys/:id/invList',
        //     name: 'invList',
        //     component: invList
        // },{
        //     path: '/sys/:id/invDetails',
        //     name: 'invDetails',
        //     component: invDetails
        // },{
        //     path: '/sys/:id/invDestroy',
        //     name: 'invDestroy',
        //     component: invDestroy
        // },{
        //     path: '/sys/:id/invWarning',
        //     name: 'invWarning',
        //     component: invWarning
        // },{
        //     path: '/sys/:id/invAdd',
        //     name: 'invAdd',
        //     component: invAdd
        // },
        {
            path: '/sys/:id/exchangeWork',
            name: 'exchangeWork',
            component: __WEBPACK_IMPORTED_MODULE_19__components_indexRouters_saleInfo_exchangeWork_exchangeWork_vue___default.a,
            meta: {
                tabName: '交接班记录',
                isKeep: true
            },
            children: [{
                path: '/sys/:id/exchangeWork/staffGrade',
                name: 'staffGrade',
                component: __WEBPACK_IMPORTED_MODULE_22__components_indexRouters_saleInfo_exchangeWork_subpages_staffGrade___default.a,
                meta: {
                    tabName: '交接班详情',
                    isKeep: false
                }
            }]
        }, {
            path: '/sys/:id/dailyGrade',
            name: 'dailyGrade',
            component: __WEBPACK_IMPORTED_MODULE_23__components_indexRouters_saleInfo_dailyGrade_dailyGrade_vue___default.a,
            meta: {
                tabName: '对账单',
                isKeep: true
            }
        }, {
            path: '/sys/:id/exchangeWorkNew',
            name: 'exchangeWorkNew',
            component: __WEBPACK_IMPORTED_MODULE_20__components_indexRouters_saleInfo_exchangeWork_exchangeWorkNew_vue___default.a,
            meta: {
                tabName: '班次销售统计',
                isKeep: true
            }
        }, {
            path: '/sys/:id/settleCount',
            name: 'settleCount',
            component: __WEBPACK_IMPORTED_MODULE_21__components_indexRouters_saleInfo_settleCount_settleCount_vue___default.a,
            meta: {
                tabName: '结算查询',
                isKeep: true
            }
        }, {
            path: '/sys/:id/ringReport',
            name: 'ringReport',
            component: __WEBPACK_IMPORTED_MODULE_24__components_indexRouters_saleInfo_ringReport_ringReport_vue___default.a,
            meta: {
                tabName: '同期日报表',
                isKeep: true
            }
        }, {
            path: '/sys/:id/rewardInfo',
            name: 'rewardInfo',
            component: __WEBPACK_IMPORTED_MODULE_25__components_indexRouters_callAndReward_rewardInfo_rewardInfo_vue___default.a,
            meta: {
                tabName: '打赏记录',
                isKeep: true
            }
        }, {
            path: '/sys/:id/ratingInfo',
            name: 'ratingInfo',
            component: __WEBPACK_IMPORTED_MODULE_26__components_indexRouters_callAndReward_ratingInfo_ratingInfo_vue___default.a,
            meta: {
                tabName: '评价记录',
                isKeep: true
            }
        }, {
            path: '/sys/:id/getWithdraw',
            name: 'getWithdraw',
            component: __WEBPACK_IMPORTED_MODULE_27__components_indexRouters_callAndReward_getWithdraw_getWithdraw_vue___default.a,
            meta: {
                tabName: '提现记录',
                isKeep: true
            }
        }, {
            path: '/sys/:id/putWithdraw',
            name: 'putWithdraw',
            component: __WEBPACK_IMPORTED_MODULE_28__components_indexRouters_callAndReward_putWithdraw_putWithdraw_vue___default.a,
            meta: {
                tabName: '我要提现',
                isKeep: true
            }
        }, {
            path: '/sys/:id/setWithdraw',
            name: 'setWithdraw',
            component: __WEBPACK_IMPORTED_MODULE_29__components_indexRouters_callAndReward_setWithdraw_setWithdraw_vue___default.a,
            meta: {
                tabName: '设置提现信息',
                isKeep: true
            }
        }, {
            path: '/sys/:id/dlCall',
            name: 'dlCall',
            component: __WEBPACK_IMPORTED_MODULE_30__components_indexRouters_callAndReward_dlCall_dlCall_vue___default.a,
            meta: {
                tabName: '语音软件下载',
                isKeep: true
            }
        }, {
            path: '/sys/:id/orderSearch',
            name: 'orderSearch',
            component: __WEBPACK_IMPORTED_MODULE_35__components_indexRouters_saleInfo_orderSearch_orderSearch_vue___default.a,
            meta: {
                tabName: '',
                isKeep: false
            }
        }, {
            path: '/sys/:id/totalSales',
            name: 'totalSales',
            component: __WEBPACK_IMPORTED_MODULE_31__components_indexRouters_saleInfo_totalSales_totalSales_vue___default.a,
            meta: {
                tabName: '销售汇总',
                isKeep: true
            }
        }, {
            path: '/sys/:id/elecSales',
            name: 'elecSales',
            component: __WEBPACK_IMPORTED_MODULE_32__components_indexRouters_saleInfo_elecSales_elecSales_vue___default.a,
            meta: {
                tabName: '电子对账单',
                isKeep: true
            }
        }, {
            path: '/sys/:id/stockSummary',
            name: 'stockSummary',
            component: __WEBPACK_IMPORTED_MODULE_33__components_indexRouters_saleInfo_stockSummary_stockSummary_vue___default.a,
            meta: {
                tabName: '采购汇总',
                isKeep: true
            }
        }, {
            path: '/sys/:id/stockData',
            name: 'stockData',
            component: __WEBPACK_IMPORTED_MODULE_34__components_indexRouters_saleInfo_stockData_stockData_vue___default.a,
            meta: {
                tabName: '库存汇总',
                isKeep: true
            }
        }, {
            path: '/sys/:id/spec',
            name: 'spec',
            component: __WEBPACK_IMPORTED_MODULE_37__components_indexRouters_goods_spec_vue___default.a,
            meta: {
                tabName: '规格管理',
                isKeep: true
            }
        }, {
            path: '/sys/:id/goodsInfo',
            name: 'goodsInfo',
            component: __WEBPACK_IMPORTED_MODULE_36__components_indexRouters_goods_info_vue___default.a,
            meta: {
                tabName: '商品资料',
                isKeep: true
            }
        }, {
            path: '/sys/:id/goodsLog',
            name: 'goodsLog',
            component: __WEBPACK_IMPORTED_MODULE_38__components_indexRouters_goods_goodsLog_vue___default.a,
            meta: {
                tabName: '商品资料变动记录',
                isKeep: true
            }
        }, {
            path: '/sys/:id/goodsLogForRent',
            name: 'goodsLogForRent',
            component: __WEBPACK_IMPORTED_MODULE_75__components_indexRouters_rent_goodsLog_goodsLog_vue___default.a,
            meta: {
                tabName: '租赁商品变动记录',
                isKeep: true
            }
        }, {
            path: '/sys/:id/goodsClassify',
            name: 'goodsClassify',
            component: __WEBPACK_IMPORTED_MODULE_39__components_indexRouters_goods_classify_vue___default.a,
            meta: {
                tabName: '商品分类',
                isKeep: true
            }
        }, {
            path: '/sys/:id/goodsInterval',
            name: 'goodsInterval',
            component: __WEBPACK_IMPORTED_MODULE_40__components_indexRouters_goods_interval_vue___default.a,
            meta: {
                tabName: '销售时段管理',
                isKeep: true
            }
        }, {
            path: '/sys/:id/merCert',
            name: 'merCert',
            component: __WEBPACK_IMPORTED_MODULE_41__components_indexRouters_MerchantInformation_merCert_vue___default.a,
            meta: {
                tabName: '商户认证',
                isKeep: true
            }
        },
        // {
        //     path: '/sys/:id/keyCert',
        //     name: 'keyCert',
        //     component: keyCert
        // },
        {
            path: '/sys/:id/topUp',
            name: 'topUp',
            component: __WEBPACK_IMPORTED_MODULE_42__components_indexRouters_topUp_topUp_vue___default.a,
            meta: {
                tabName: '',
                isKeep: false
            }
        }, {
            path: '/sys/:id/createCode',
            name: 'createCode',
            component: __WEBPACK_IMPORTED_MODULE_43__components_indexRouters_createCode_createCode_vue___default.a,
            meta: {
                tabName: '下载中心',
                isKeep: true
            }
        }, {
            path: '/sys/:id/setting',
            name: 'setting',
            component: __WEBPACK_IMPORTED_MODULE_44__components_indexRouters_setting_setting_vue___default.a,
            meta: {
                tabName: '系统设置',
                isKeep: true
            }
        }, {
            path: '/sys/:id/voiceCall',
            name: 'voiceCall',
            component: __WEBPACK_IMPORTED_MODULE_50__components_indexRouters_voiceCall_voiceCall_vue___default.a,
            meta: {
                tabName: '',
                isKeep: false
            }
        }, {
            path: '/sys/:id/market',
            name: 'market',
            component: __WEBPACK_IMPORTED_MODULE_51__components_indexRouters_market_market_vue___default.a,
            meta: {
                tabName: '原料商城',
                isKeep: true
            }
        }, {
            path: '/sys/:id/address',
            name: 'address',
            component: __WEBPACK_IMPORTED_MODULE_52__components_indexRouters_market_address_vue___default.a,
            meta: {
                tabName: '收货地址',
                isKeep: true
            }
        }, {
            path: '/sys/:id/orderInfo',
            name: 'orderInfo',
            component: __WEBPACK_IMPORTED_MODULE_53__components_indexRouters_market_orderInfo_vue___default.a,
            meta: {
                tabName: '订单记录',
                isKeep: true
            }
        }, {
            path: '/sys/:id/second',
            name: 'second',
            component: __WEBPACK_IMPORTED_MODULE_54__components_indexRouters_activity_second_second_vue___default.a,
            meta: {
                tabName: '第二份优惠',
                isKeep: true
            }
        }, {
            path: '/sys/:id/modifySecond',
            name: 'modifySecond',
            component: __WEBPACK_IMPORTED_MODULE_55__components_indexRouters_activity_second_modifySecond_index_vue___default.a,
            meta: {
                tabName: '第二份优惠(新增/编辑)',
                isKeep: true
            }
        }]
    }, {
        path: '/addStore',
        name: 'addStore',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_addStore_addStore_vue___default.a,
        meta: {
            tabName: '',
            isKeep: false
        }
    }, {
        path: '/addStore/:isFirst',
        name: 'addStore',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_addStore_addStore_vue___default.a,
        meta: {
            tabName: '',
            isKeep: false
        }
    }]
}));

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(803)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(980),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */,
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(812)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(989),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__urlConfig_index__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "bigScreen",
  props: ["curStoreId"],
  data: function data() {
    return {
      textVal: "",
      textColor: "#000",
      //
      showExtra: false,
      canCreate: true,
      noData: true,
      coverImgMaxSize: 15 * 1024 * 1024, // 图片最大字节数
      sites: [],
      activeNames: ["1"],
      showDrawer: false,
      form: {
        background: "",
        computerNodeType: "text",
        computerNodeSize: 70,
        canvasJsonText: "",
        computerFillColor: "#e66a6a",
        computerTextColor: "#fff",
        extra: []
      },
      options: [{
        label: "文本式",
        value: "text"
      }, {
        label: "电脑图标式",
        value: "computer"
      }],
      computerObj: {
        ip: "192.168.0.1",
        status: "free",
        name: "001",
        offset: {
          x: 0,
          y: 0,
          rotation: 0,
          skewX: 0,
          skewY: 0
        }
      },
      textObj: {
        type: "text",
        uuidName: "",
        fontSize: 30,
        content: "",
        fill: "",
        offset: {
          x: 0,
          y: 0,
          rotation: 0,
          skewX: 0,
          skewY: 0,
          scaleX: 1,
          scaleY: 1
        }
      },
      imageObj: {
        type: "image",
        uuidName: "",
        path: "",
        offset: {
          x: 0,
          y: 0,
          width: 200,
          height: 200,
          rotation: 0,
          skewX: 0,
          skewY: 0,
          scaleX: 1,
          scaleY: 1
        }
      },
      stageWidth: "",
      stageHeight: "",
      stage: null,
      layer: null,
      computerLayer: null,
      contextMenuNode: null,
      rollComputer: null,
      container: null,
      nowSelGroup: null,
      delta: 0.5,
      computers: [],
      bigScreenUrl: "",
      rollExtra: null,
      extraType: "text",
      siteNamesObj: {},
      bigScreenUrlForAd: ""
    };
  },

  watch: {
    showExtra: function showExtra(val) {
      if (!val) {
        this.textVal = "";
      }
    }
  },
  methods: {
    changeComputerColor: function changeComputerColor() {
      var _this2 = this;

      console.log("lll", this.form.computerFillColor);
      setTimeout(function () {
        _this2.createStage();
      }, 50);
    },
    changeComputerTextColor: function changeComputerTextColor() {
      var _this3 = this;

      console.log("lll", this.form.computerTextColor);
      setTimeout(function () {
        _this3.createStage();
      }, 50);
    },

    // 
    doAddExtra: function doAddExtra() {
      this.showExtra = false;
      if (!String(this.textVal).trim()) {
        return;
      }
      if (this.extraType == "text") {
        this.$set(this.textObj, "content", this.textVal);
        this.$set(this.textObj, "fill", this.textColor);
        this.createExtra(this.extraType, this.textObj, true);
      }
    },
    addExtra: function addExtra(type) {
      this.showExtra = true;
      $(".context-menu-extra").css({
        display: "none"
      });
      $(".context-menu").css({
        display: "none"
      });
      this.extraType = type;
    },

    //
    openBigScreen: function openBigScreen() {
      window.open(this.bigScreenUrl, "_blank");
    },
    openBigScreenForAd: function openBigScreenForAd() {
      window.open(this.bigScreenUrlForAd, "_blank");
    },
    copy: function copy() {
      var range = document.createRange();
      range.selectNode(document.getElementById("copyData"));
      var selection = window.getSelection();
      if (selection.rangeCount > 0) {
        selection.removeAllRanges();
      }
      selection.addRange(range);
      document.execCommand("copy");
      this.$message({
        customClass: "success",
        message: "复制成功"
      });
      selection.removeAllRanges();
    },
    save: function save() {
      var _this4 = this;

      if (!this.computerLayer || !this.form.background) {
        return;
      }
      console.log("this.computerLayer.getChildren", this.computers);
      var tempComputers = [];
      this.computerLayer.getChildren(function (node) {
        console.log("node", node);
        if (node.getClassName() == "Group") {
          var ipArr = node.attrs.name.split(".");
          tempComputers.push({
            ip: node.attrs.name,
            name: _this4.siteNamesObj[node.attrs.name],
            // name:ipArr[ipArr.length - 1],
            offset: {
              x: node.attrs.x > 1920 ? 1910 : node.attrs.x,
              y: node.attrs.y > 1080 ? 1070 : node.attrs.y,
              rotation: node.attrs.rotation,
              skewX: node.attrs.skewX,
              skewY: node.attrs.skewY
            },
            status: "free"
          });
        }
      });
      console.log("tempComputers", tempComputers);
      // this.computerLayer.getChildren((node) => {
      //   if (node.getClassName() == "Group") {
      //     this.computers.forEach((it) => {
      //       console.log("node.attrs.name",node.attrs.name);
      //       if (node.attrs.name == it.ip) {
      //         it.offset = {
      //           x: node.attrs.x,
      //           y: node.attrs.y,
      //           rotation: node.attrs.rotation,
      //           skewX: node.attrs.skewX,
      //           skewY: node.attrs.skewY,
      //         };
      //       }
      //     });
      //   }
      // });
      var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.form));
      var extra = [];
      if (form.hasOwnProperty("extra") && Array.isArray(form.extra)) {
        extra = form.extra;
      }
      this.extraDrawLayer.getChildren(function (node) {
        console.log(node);
        if (node.textArr && Array.isArray(node.textArr) && node.textArr.length) {
          var textObj = {
            type: "text",
            uuidName: node.attrs.uuidName,
            fontSize: 30,
            content: node.attrs.text,
            fill: node.attrs.fill,
            offset: {
              x: node.attrs.x > 1920 ? 1910 : node.attrs.x,
              y: node.attrs.y > 1080 ? 1070 : node.attrs.y,
              rotation: node.attrs.rotation,
              skewX: node.attrs.skewX,
              skewY: node.attrs.skewY,
              scaleX: node.attrs.scaleX,
              scaleY: node.attrs.scaleY
            }
          };
          extra.push(textObj);
        }
      });
      this.extraDrawLayerForImage.getChildren(function (node) {
        console.log(node.getClassName());
        if (node.attrs.hasOwnProperty("image")) {
          var imageObj = {
            type: "image",
            uuidName: node.attrs.uuidName,
            path: node.attrs.path,
            offset: {
              x: node.attrs.x > 1920 ? 1910 : node.attrs.x,
              y: node.attrs.y > 1080 ? 1070 : node.attrs.y,
              width: node.attrs.width,
              height: node.attrs.height,
              rotation: node.attrs.rotation,
              skewX: node.attrs.skewX,
              skewY: node.attrs.skewY,
              scaleX: node.attrs.scaleX,
              scaleY: node.attrs.scaleY
            }
          };
          extra.push(imageObj);
        }
      });
      if (extra && Array.isArray(extra)) {
        extra = extra.filter(function (it) {
          if (!it.hasOwnProperty("uuidName")) {
            return false;
          }
          return true;
        });
        var extraObj = {};
        extra.forEach(function (it) {
          extraObj[it.uuidName] = it;
        });
        var tempExtra = [];
        for (var k in extraObj) {
          tempExtra.push(extraObj[k]);
        }
        extra = tempExtra;
      }
      var finalComputerArr = [];
      var obj = {};
      if (Array.isArray(tempComputers)) {
        try {
          tempComputers.forEach(function (it) {
            console.log("it", it);
            obj[it.ip] = it;
          });
        } catch (error) {}
        for (var _k in obj) {
          finalComputerArr.push(obj[_k]);
        }
      }
      // 
      // console.log("finalComputerArr",finalComputerArr)
      // finalComputerArr.forEach(it=>{
      //   console.log("it",it)
      //   it.ip = this.replaceIPPrefix(it.ip, '192.168.0','192.168.68');
      // })
      // console.log("finalComputerArr end",finalComputerArr)
      // return;
      // 
      setTimeout(function () {
        var jsonText = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this4.form, {
          extra: extra,
          // canvasJsonText: this.computers,
          canvasJsonText: finalComputerArr
        });
        console.log("jsonText", jsonText);
        _this4.$http({
          url: "map/update",
          method: "POST",
          data: {
            storeId: _this4.curStoreId,
            h5JsonText: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsonText)
          }
        }).then(function (res) {
          _this4.$message({ customClass: "success", message: "保存成功" });
        });
      }, 100);
    },
    replaceIPPrefix: function replaceIPPrefix(str, from, to) {
      // return str.replace(new RegExp(from, 'g'), to);
    },
    changeComputerNodeSize: function changeComputerNodeSize(e) {
      var _this5 = this;

      console.log(e);
      this.form.computerNodeSize = e;
      setTimeout(function () {
        _this5.createStage();
      }, 50);
    },
    changeNodeType: function changeNodeType(e) {
      var _this6 = this;

      console.log(e);
      setTimeout(function () {
        _this6.createStage();
      }, 50);
    },
    createExtra: function createExtra(type, obj) {
      var _this7 = this;

      var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (type == "text") {
        var text = new Konva.Text({
          uuidName: obj.uuidName ? obj.uuidName : this.$uuid.create(1).hex,
          x: obj.offset.x,
          y: obj.offset.y,
          rotation: obj.offset.rotation,
          skewX: obj.offset.skewX,
          skewY: obj.offset.skewY,
          scaleX: obj.offset.scaleX,
          scaleY: obj.offset.scaleY,
          text: obj.content,
          fontSize: obj.fontSize,
          fill: obj.fill,
          draggable: true
        });
        text.on("dblclick", function (e) {
          if (e.evt.button === 2) {
            return;
          }
          _this7.rollExtra = new Konva.Transformer({
            nodes: [e.currentTarget],
            centeredScaling: true,
            rotationSnaps: [0, 90, 180, 270],
            resizeEnabled: true
          });

          // this.rollExtra.anchorStyleFunc((anchor) => {
          //   anchor.fill("#00ff00");
          //   anchor.attrs.stroke = "rgb(247,186,42)";
          //   if (anchor.attrs.name == "rotater _anchor") {
          //     anchor.fill(undefined);
          //     anchor.attrs.offsetX = 12;
          //     anchor.attrs.offsetY = 24;
          //     anchor.attrs.width = 25;
          //     anchor.attrs.height = 25;
          //     const anchorGroup = anchor.getParent();
          //     console.log("anchorGroup",anchorGroup);
          //     this.anchor.attrs.x = anchorGroup.width() / 2;
          //     this.anchor.attrs.y = -75;
          //     anchorGroup.add(this.anchor);
          //   }
          //   anchor.cornerRadius(anchor.width() / 2);
          // });

          _this7.extraDrawLayer.add(_this7.rollExtra);
        });
        text.on("click", function (e) {
          if (e.evt.button === 2) {
            console.log(_this7.stage.getPointerPosition());
            console.log(e.currentTarget);
            _this7.contextMenuNode = e.currentTarget;

            $(".context-menu").css({
              display: "block",
              top: _this7.stage.getPointerPosition().y + 10 + "px",
              left: _this7.stage.getPointerPosition().x + 10 + "px"
            });
            setTimeout(function () {
              $(".context-menu-extra").css({
                display: "none"
              });
            }, 50);
          }
        });
        this.extraDrawLayer.add(text);
        if (init) {
          this.rollExtra = new Konva.Transformer({
            nodes: [text],
            centeredScaling: true,
            rotateAnchorOffset: 30,
            rotationSnaps: [0, 90, 180, 270],
            resizeEnabled: true
          });
          this.extraDrawLayer.add(this.rollExtra);
        }
      } else if (type == "image") {
        Konva.Image.fromURL(obj.path, function (darthNode) {
          darthNode.setAttrs({
            uuidName: obj.uuidName ? obj.uuidName : _this7.$uuid.create(1).hex,
            path: obj.path,
            x: obj.offset.x,
            y: obj.offset.y,
            width: obj.offset.width,
            height: obj.offset.height,
            rotation: obj.offset.rotation,
            skewX: obj.offset.skewX,
            skewY: obj.offset.skewY,
            scaleX: obj.offset.scaleX,
            scaleY: obj.offset.scaleY,
            keepRatio: true,
            draggable: true
          });
          console.log(darthNode);
          darthNode.on("dblclick", function (e) {
            if (e.evt.button === 2) {
              return;
            }
            _this7.rollExtra = new Konva.Transformer({
              nodes: [e.currentTarget],
              centeredScaling: true,
              rotationSnaps: [0, 90, 180, 270],
              resizeEnabled: true
            });
            _this7.extraDrawLayerForImage.add(_this7.rollExtra);
          });
          darthNode.on("click", function (e) {
            if (e.evt.button === 2) {
              console.log(_this7.stage.getPointerPosition());
              console.log(e.currentTarget);
              _this7.contextMenuNode = e.currentTarget;

              $(".context-menu").css({
                display: "block",
                top: _this7.stage.getPointerPosition().y + 10 + "px",
                left: _this7.stage.getPointerPosition().x + 10 + "px"
              });
              setTimeout(function () {
                $(".context-menu-extra").css({
                  display: "none"
                });
              }, 50);
            }
          });
          _this7.extraDrawLayerForImage.add(darthNode);
          if (init) {
            _this7.rollExtra = new Konva.Transformer({
              nodes: [darthNode],
              centeredScaling: true,
              rotationSnaps: [0, 90, 180, 270],
              resizeEnabled: true
            });
            _this7.extraDrawLayerForImage.add(_this7.rollExtra);
          }
        });
      }
    },
    createStage: function createStage(time) {
      var _this8 = this;

      if (!this.canCreate) {
        return;
      }
      this.canCreate = false;
      var bigScreenEle = document.querySelector("#canvasWrap");
      this.stageWidth = bigScreenEle.clientWidth;
      console.log("stageWidth", this.stageWidth);
      this.stageHeight = bigScreenEle.clientHeight;
      this.stage = new Konva.Stage({
        container: "canvasWrap",
        width: this.stageWidth,
        height: this.stageHeight
      });
      this.layer = new Konva.Layer();
      this.computerLayer = new Konva.Layer();
      this.extraDrawLayer = new Konva.Layer();
      this.extraDrawLayerForImage = new Konva.Layer();
      this.stage.add(this.layer);
      this.stage.add(this.computerLayer);
      this.stage.add(this.extraDrawLayerForImage);
      this.stage.add(this.extraDrawLayer);
      this.stage.on("contextmenu", function (e) {
        e.evt.preventDefault();
      });
      //
      //
      Konva.Image.fromURL(this.form.background, function (darthNode) {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: _this8.stage.width(),
          height: _this8.stage.height(),
          keepRatio: true
        });
        _this8.computerLayer.add(darthNode);
        _this8.computerLayer.batchDraw();
        _this8.computerLayer.on("click", function (event) {
          event.cancelBubble = true;
          if (_this8.rollComputer) {
            _this8.rollComputer.stopTransform();
            _this8.rollComputer.hide();
          }
          if (_this8.rollExtra) {
            _this8.rollExtra.stopTransform();
            _this8.rollExtra.hide();
          }
        });
      });
      //
      this.container = this.stage.container();
      this.container.addEventListener("dragover", function (e) {
        e.preventDefault();
      });
      this.container.addEventListener("contextmenu", function (e) {
        console.log(e);
        e.stopPropagation();
        $(".context-menu-extra").css({
          display: "block",
          top: _this8.stage.getPointerPosition().y + 10 + "px",
          left: _this8.stage.getPointerPosition().x + 10 + "px"
        });
      });
      this.container.addEventListener("drop", function (e) {
        e.preventDefault();
        _this8.stage.setPointersPositions(e);
        var url = "/static/bigScreen/assets/computer_free.png";
        if (_this8.form.computerNodeType == "text") {
          url = "/static/bigScreen/assets/computer_free_text.png";
        }
        console.log(_this8.stage.getPointerPosition());
        var stagePointerPosition = _this8.stage.getPointerPosition();
        _this8.$set(_this8.computerObj.offset, "x", stagePointerPosition.x - 16);
        _this8.$set(_this8.computerObj.offset, "y", stagePointerPosition.y - 16);
        if (!_this8.computerObj.ip) {
          _this8.$message({ customClass: "error", message: "此机位已添加" });
          return;
        }
        var computers = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this8.computers));
        if (computers && Array.isArray(computers)) {
          computers.push(_this8.computerObj);
        } else {
          computers = [];
          computers.push(_this8.computerObj);
        }

        var obj = {};
        console.log("computers", computers);
        if (computers && Array.isArray(computers)) {
          computers.forEach(function (it) {
            obj[it.ip] = it;
          });
        }
        console.log("obj", obj);
        var tempComputers = [];
        for (var k in obj) {
          tempComputers.push(obj[k]);
        }

        _this8.$set(_this8, "computers", tempComputers);
        // this.$set(this, "computers", computers);
        _this8.drawComputer(_this8.computerObj, url, true);
      });
      this.container.tabIndex = 1;
      this.container.focus();
      this.container.addEventListener("keydown", function (e) {
        console.log(_this8.nowSelGroup);
        if (e.keyCode === 37) {
          _this8.nowSelGroup.x(_this8.nowSelGroup.x() - _this8.delta);
        } else if (e.keyCode === 38) {
          _this8.nowSelGroup.y(_this8.nowSelGroup.y() - _this8.delta);
        } else if (e.keyCode === 39) {
          _this8.nowSelGroup.x(_this8.nowSelGroup.x() + _this8.delta);
        } else if (e.keyCode === 40) {
          _this8.nowSelGroup.y(_this8.nowSelGroup.y() + _this8.delta);
        } else {
          return;
        }
        e.preventDefault();
      });
      this.container.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".context-menu").css({
          display: "none"
        });
        $(".context-menu-extra").css({
          display: "none"
        });
      });
      //
      this.anchor = new Konva.Path({
        x: 0,
        y: 0,
        width: 32,
        height: 32,
        data: "M148.361503 873.076215a33.27639 33.27639 0 0 1 0.204778-47.150084 33.583556 33.583556 0 0 1 47.354862 0.204778A444.316592 444.316592 0 0 0 511.944454 957.291078c104.436669 0 203.293143-35.938501 280.852728-99.317224l35.580139-32.81564a33.583556 33.583556 0 0 1 47.303668 1.791806 33.27639 33.27639 0 0 1-1.791806 47.09889l-37.064778 34.146695A511.176537 511.176537 0 0 1 511.944454 1023.99744a511.43251 511.43251 0 0 1-363.582951-150.921225z m863.49671-248.497838a33.481167 33.481167 0 0 1-65.426501-14.385639 443.139119 443.139119 0 0 0-299.129144-518.394954A33.327584 33.327584 0 1 1 667.575568 28.265477a509.58951 509.58951 0 0 1 344.180256 596.3129zM275.374922 138.640701a443.036731 443.036731 0 0 0-198.788032 467.456481 33.481167 33.481167 0 0 1-65.52889 13.771306A509.999065 509.999065 0 0 1 279.624061 59.596478C328.821923 31.439533 431.415591-4.191801 507.336954 0.620477c8.549472-1.689417 17.96925 0 25.597223 5.938555 6.4505 5.119445 9.982917 12.081889 11.109194 20.273001 0.255972 2.713306-0.409556 5.221833-1.023889 8.037528a22.832723 22.832723 0 0 1-7.781555 12.133083L341.262173 263.759926a28.208139 28.208139 0 0 1-29.999945 6.91125 30.204723 30.204723 0 0 1-20.836139-23.703028l-15.051167-108.378641z m-4.965861 785.322793c-2.969278-0.46075-7.269611 31.740556-34.402668 17.918056-48.225168-24.624528-138.225003-97.781391-174.93142-168.736892a31.331001 31.331001 0 0 1-8.037528-24.931695c1.023889-8.191111 5.221833-14.846389 11.62114-19.965834 2.201361-1.638222 4.658695-2.354944 7.423194-3.276444a22.832723 22.832723 0 0 1 14.385639 0.409555l285.7162 54.675668c10.392472 1.945389 18.839556 10.750834 21.399278 22.116a30.204723 30.204723 0 0 1-9.573361 30.102334l-113.651669 91.689252z m716.671041-436.688619c1.126278 2.815694 30.921445-10.085306 33.020417 20.273 3.737195 54.061334-12.542639 168.890475-54.522084 236.825504a31.331001 31.331001 0 0 1-17.201334 19.812251 29.999945 29.999945 0 0 1-23.139889 0.307167c-2.559722-1.023889-4.402722-2.815694-6.655278-4.709889a22.832723 22.832723 0 0 1-7.013639-12.54264l-100.341113-273.071171a28.208139 28.208139 0 0 1 7.986333-29.692779 30.204723 30.204723 0 0 1 30.716668-7.320805l137.149919 50.170556z",
        fill: "white",
        scaleX: 0.025,
        scaleY: 0.025
      });
      var extra = [];
      if (this.form.hasOwnProperty("extra")) {
        var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.form));
        extra = form.extra;
      }
      if (time) {
        setTimeout(function () {
          _this8.computers.forEach(function (it) {
            var url = "/static/bigScreen/assets/computer_" + it.status + ".png";

            if (_this8.form.computerNodeType == "text") {
              url = "/static/bigScreen/assets/computer_" + it.status + "_text.png";
            }
            _this8.drawComputer(it, url);
          });
          //
          if (extra && Array.isArray(extra)) {
            extra.forEach(function (it) {
              // if (it.type == "text") {
              _this8.createExtra(it.type, it);
              // }
            });
          }
          //
        }, time);
      } else {
        setTimeout(function () {
          _this8.computers.forEach(function (it) {
            var url = "/static/bigScreen/assets/computer_" + it.status + ".png";

            if (_this8.form.computerNodeType == "text") {
              url = "/static/bigScreen/assets/computer_" + it.status + "_text.png";
            }
            _this8.drawComputer(it, url);
          });
          //
          if (extra && Array.isArray(extra)) {
            extra.forEach(function (it) {
              // if (it.type == "text") {
              _this8.createExtra(it.type, it);
              // }
            });
          }
          //
        }, 599);
      }
      setTimeout(function () {
        _this8.canCreate = true;
      }, 1999);
    },
    drawComputer: function drawComputer(it, url) {
      var _this9 = this;

      var isSel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // 
      var multFlag = false;
      this.computerLayer.getChildren(function (node) {
        if (node.getClassName() == "Group") {
          if (it.ip == node.attrs.name) {
            multFlag = true;
          }
        }
      });
      if (multFlag) {
        console.log("当前有重复的机位");
        return;
      }
      // 
      var _this = this;
      var group = new Konva.Group({
        width: 32,
        height: 32,
        draggable: true,
        keepRatio: true,
        x: it.offset.x / 1920 * this.stageWidth,
        y: it.offset.y / 1080 * this.stageHeight,
        rotation: it.offset.rotation,
        name: it.ip,
        scale: {
          x: this.form.computerNodeSize / 100,
          y: this.form.computerNodeSize / 100
        },
        skewX: it.offset.skewX ? it.offset.skewX : 0,
        skewY: it.offset.skewY ? it.offset.skewY : 0
      });

      Konva.Image.fromURL(url, function (darthNode) {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: 32,
          height: 27,
          fill: _this9.form.computerFillColor
        });
        var simpleText = new Konva.Text({
          x: 16,
          y: 7,
          align: "center",
          text: it.name,
          fontSize: 16,
          // fontFamily: "Calibri",
          // fill: "#fff",
          fill: _this9.form.computerTextColor
        });
        simpleText.offsetX(simpleText.width() / 2);

        group.add(darthNode);
        group.add(simpleText);
        _this9.computerLayer.batchDraw();
      });
      group.on("mouseover", function () {
        document.body.style.cursor = "pointer";
      });
      group.on("dragend", function (e) {
        var posObj = this.absolutePosition();
        it.offset.x = posObj.x;
        it.offset.y = posObj.y;
        document.body.style.cursor = "default";
      });
      group.on("dblclick", function (e) {
        if (e.evt.button === 2) {
          return;
        }
        _this.rollComputer = new Konva.Transformer({
          nodes: [e.currentTarget],
          centeredScaling: true,
          rotationSnaps: [0, 90, 180, 270],
          resizeEnabled: false
        });
        //
        _this.rollComputer.borderEnabled(false);
        _this.rollComputer.anchorSize(25);
        _this.rollComputer.anchorStyleFunc(function (anchor) {
          if (anchor.attrs.name == "rotater _anchor") {
            anchor.fill(undefined);
            _this.anchor.attrs.x = anchor.attrs.x - 12.5;
            _this.anchor.attrs.y = anchor.attrs.y + 12.5;

            var anchorGroup = anchor.getParent();
            anchorGroup.add(_this.anchor);
            console.log(anchorGroup);
            anchor.attrs.offsetY = -13.5;
            anchor.attrs.stroke = undefined;
            anchor.cornerRadius(anchor.width() / 2);
          }
        });
        //
        _this.rollComputer.on("transformend", function (te) {
          console.log(group);
        });
        _this.computerLayer.add(_this.rollComputer);
        _this.nowSelGroup = e.currentTarget;
      });
      group.on("click", function (e) {
        console.log(e);
        if (e.evt.button === 2) {
          console.log(_this9.stage.getPointerPosition());
          _this9.contextMenuNode = e.currentTarget;

          $(".context-menu").css({
            display: "block",
            top: _this9.stage.getPointerPosition().y + 10 + "px",
            left: _this9.stage.getPointerPosition().x + 10 + "px"
          });
          setTimeout(function () {
            $(".context-menu-extra").css({
              display: "none"
            });
          }, 50);
        }
      });
      if (isSel) {
        this.nowSelGroup = group;
      }
      this.computerLayer.add(group);
    },

    //
    delNode: function delNode() {
      var tempNode = this.contextMenuNode.destroy();
      try {
        var computers = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.computers));
        if (computers && Array.isArray(computers)) {
          var flagIndex = -1;
          computers.forEach(function (it, ind) {
            if (it.ip == tempNode.attrs.name) {
              flagIndex = ind;
            }
          });
          if (flagIndex != -1) {
            computers.splice(flagIndex, 1);
          }
          this.$set(this, "computers", computers);
        }
      } catch (error) {
        console.log(error);
      }
      try {
        var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.form));
        if (form.extra && Array.isArray(form.extra)) {
          var _flagIndex = -1;
          form.extra.forEach(function (it, ind) {
            if (it.hasOwnProperty("uuidName") && it.uuidName == tempNode.attrs.uuidName) {
              _flagIndex = ind;
            }
          });
          if (_flagIndex != -1) {
            form.extra.splice(_flagIndex, 1);
          }
          this.$set(this.form, "extra", form.extra);
        }
      } catch (error) {
        console.log(error);
      }

      $(".context-menu").css({
        display: "none"
      });
    },

    //
    coverImg: function coverImg(e) {
      var reader = new FileReader();
      var that = this;
      var fileObj = e.target.files[0];

      if (e.target.files.length == 0) {
        return false;
      }
      // 判断图片大小
      if (fileObj.size > this.coverImgMaxSize) {
        this.errorMsg = "上传图片的大小不能超过15MB";
        this.openErrorTip = true;
        this.$message({
          message: "上传图片的大小不能超过15MB",
          customClass: "error"
        });
        return false;
      }

      reader.onload = function (file) {
        return function (e) {
          var that2 = this; // 缓存当前this
          var img = new Image();
          img.src = this.result;
          img.onload = function () {
            // 
            console.log("width", this.width);
            console.log("height", this.height);
            if (this.width != 1920 && this.height != 1080) {
              that.$message({
                message: "请上传 1920x1080 像素的照片！",
                customClass: "error"
              });
              return false;
            }
            // 
            var imgBase64 = that2.result; //获得图片的base64的数据
            that.mobileUploadImg(imgBase64);
          };
          $(".pcImgFile").val("");
        };
      }(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    mobileUploadImg: function mobileUploadImg(imgBase64) {
      var _this10 = this;

      var loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__urlConfig_index__["b" /* API_BASE_URL */] + "v1/image/json/upload?storeId=" + this.curStoreId, {
        file: imgBase64
      }).then(function (res) {
        _this10.form.background = res.data.path;
        _this10.$message({ customClass: "success", message: "上传成功" });
        _this10.noData = false;
        _this10.$nextTick(function () {
          _this10.createStage(1999);
        });
        loading.close();
      }).catch(function () {
        loading.close();
      });
    },
    upImage: function upImage(e) {
      $(".context-menu-extra").css({
        display: "none"
      });
      var reader = new FileReader();
      var that = this;
      var fileObj = e.target.files[0];

      if (e.target.files.length == 0) {
        return false;
      }

      // 判断图片大小
      if (fileObj.size > this.coverImgMaxSize) {
        this.errorMsg = "上传图片的大小不能超过15MB";
        this.openErrorTip = true;
        this.$message({
          message: "上传图片的大小不能超过15MB",
          customClass: "error"
        });
        return false;
      }

      reader.onload = function (file) {
        return function (e) {
          var that2 = this; // 缓存当前this
          var img = new Image();
          img.src = this.result;
          img.onload = function () {
            var imgBase64 = that2.result; //获得图片的base64的数据
            that.doUpimg(imgBase64);
          };
          $(".upImage").val("");
        };
      }(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    doUpimg: function doUpimg(imgBase64) {
      var _this11 = this;

      var loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__urlConfig_index__["b" /* API_BASE_URL */] + "v1/image/json/upload?storeId=" + this.curStoreId, {
        file: imgBase64
      }).then(function (res) {
        _this11.createExtra("image", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this11.imageObj, { path: res.data.path }), true);
        _this11.$message({ customClass: "success", message: "上传成功" });
        loading.close();
      }).catch(function () {
        loading.close();
      });
    },
    //
    doShowDrawer: function doShowDrawer() {
      var _this12 = this;

      this.showDrawer = true;
      this.$nextTick(function () {
        console.log($(".site-img img"));
        $(".site-img img").each(function (ind, ite) {
          $(ite).on("dragstart", function (e) {
            console.log($(e.target).data());
            var ipImgData = $(e.target).data();
            var flag = false;
            if (_this12.computerLayer) {
              _this12.computerLayer.getChildren(function (node) {
                if (node.getClassName() == "Group") {
                  if (node.attrs.name == ipImgData.fillname) {
                    flag = true;
                  }
                }
              });
            }

            if (flag) {
              _this12.$set(_this12.computerObj, "ip", "");
              _this12.$message({ customClass: "error", message: "此机位已添加" });
              return;
            } else {
              _this12.$set(_this12.computerObj, "ip", ipImgData.ipaddress);
              _this12.$set(_this12.computerObj, "name", ipImgData.fillname);
              // this.$set(this.computerObj, "fillName", ipImgData.fillname);
              console.log("this.computerObj", _this12.computerObj);
            }
          });
        });
      });
    },
    computedIpNo: function computedIpNo(ip) {
      var tempIp = ip.trim();
      var ipArr = tempIp.split(".");
      return ipArr[ipArr.length - 1];
    },
    getSite: function getSite() {
      var _this13 = this;

      this.$http({
        url: "region/list",
        method: "POST",
        data: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this13.sites = res.data;
        var siteNamesObj = {};
        if (res.data && Array.isArray(res.data)) {
          res.data.forEach(function (it) {
            if (it.nums && Array.isArray(it.nums)) {
              it.nums.forEach(function (ite) {
                siteNamesObj[ite.ipAddress] = ite.name;
              });
            }
          });
        }
        _this13.siteNamesObj = siteNamesObj;
      });
    },
    getScreenDetail: function getScreenDetail() {
      var _this14 = this;

      this.$http({
        url: "map/detail",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        console.log(res);
        if (res.data) {
          _this14.noData = false;
          if (!res.data.h5JsonText) {
            _this14.noData = true;
          }
          try {
            if (res.data.h5JsonText) {
              var jsonText = JSON.parse(res.data.h5JsonText);
              if (jsonText.hasOwnProperty("computerFillColor")) {
                _this14.form = jsonText;
              } else {
                _this14.form = jsonText;
                _this14.form.computerFillColor = "#e66a6a";
              }
              if (!jsonText.hasOwnProperty("computerTextColor")) {
                _this14.form.computerTextColor = "#fff";
              }
              _this14.$forceUpdate();
              if (jsonText.hasOwnProperty("canvasJsonText")) {
                var obj = {};
                try {
                  jsonText.canvasJsonText.forEach(function (it) {
                    obj[it.ip] = it;
                  });
                } catch (error) {}
                var tempComputers = [];
                for (var k in obj) {
                  tempComputers.push(obj[k]);
                }
                _this14.computers = tempComputers;
              }
              console.log(_this14.form);
              console.log(_this14.computers);
              setTimeout(function () {
                _this14.createStage();
              }, 100);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          _this14.noData = true;
          try {
            // let jsonText = localStorage.getItem("jsonText");
            // if (jsonText) {
            //   jsonText = JSON.parse(jsonText);
            //   this.form = jsonText;
            //   if (jsonText.hasOwnProperty("canvasJsonText")) {
            //     this.computers = jsonText.canvasJsonText;
            //   }
            //   console.log(this.form);
            //   this.$nextTick(() => {
            //     this.createStage();
            //   });
            // }
          } catch (error) {
            console.log(error);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    console.log(window.location);
    this.bigScreenUrl = window.location.origin + "/#/sys/" + this.curStoreId + "/bigScreenFrontEnd";
    this.bigScreenUrlForAd = window.location.origin + "/#/sys/" + this.curStoreId + "/bigScreenFrontEndWithoutAutoScreen";
    this.getSite();
    this.getScreenDetail();
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__urlConfig_index__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "bigScreen",
  props: ["curStoreId"],
  data: function data() {
    return {
      showFullScreen: true,
      showMask: false,
      noData: true,
      coverImgMaxSize: 15 * 1024 * 1024, // 图片最大字节数
      sites: [],
      activeNames: ["1"],
      showDrawer: false,
      form: {
        background: "",
        computerNodeType: "computer",
        computerNodeSize: 70,
        canvasJsonText: "",
        extra: []
      },
      options: [{
        label: "文本式",
        value: "text"
      }, {
        label: "电脑图标式",
        value: "computer"
      }],
      computerObj: {
        ip: "192.168.0.1",
        status: "free",
        name: "001",
        offset: {
          x: 0,
          y: 0,
          rotation: 0,
          skewX: 0,
          skewY: 0
        }
      },
      stageWidth: "",
      stageHeight: "",
      stage: null,
      layer: null,
      computerLayer: null,
      contextMenuNode: null,
      rollComputer: null,
      container: null,
      nowSelGroup: null,
      delta: 1,
      numsInfo: [],
      computers: [],
      deskStatus: {
        0: "free",
        1: "busy",
        2: "book"
      },
      fullScreen: false
    };
  },

  methods: {
    doFullScreen: function doFullScreen() {
      if (!this.fullScreen) {
        var docElm = document.documentElement;
        if (docElm.requestFullscreen) {
          this.fullScreen = true;
          docElm.requestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          this.fullScreen = false;
          document.exitFullscreen();
        }
      }
    },
    createStage: function createStage() {
      var _this = this;

      var bigScreenEle = document.querySelector("#canvasWrap");
      this.stageWidth = bigScreenEle.clientWidth;
      console.log("stageWidth", this.stageWidth);
      this.stageHeight = bigScreenEle.clientHeight;
      this.stage = new Konva.Stage({
        container: "canvasWrap",
        width: this.stageWidth,
        height: this.stageHeight
      });
      this.layer = new Konva.Layer();
      this.computerLayer = new Konva.Layer();
      this.computerDrawLayer = new Konva.Layer();
      this.extraDrawLayer = new Konva.Layer();
      this.extraDrawLayerForImage = new Konva.Layer();
      this.stage.add(this.layer);
      this.stage.add(this.computerLayer);
      this.stage.add(this.computerDrawLayer);
      this.stage.add(this.extraDrawLayerForImage);
      this.stage.add(this.extraDrawLayer);
      this.stage.on("contextmenu", function (e) {
        e.evt.preventDefault();
      });
      //
      console.log("bgurl", this.form.background);
      //
      Konva.Image.fromURL(this.form.background, function (darthNode) {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: _this.stage.width(),
          height: _this.stage.height(),
          keepRatio: true
        });
        _this.computerLayer.add(darthNode);
        _this.computerLayer.batchDraw();
        _this.computerLayer.on("click", function (event) {
          event.cancelBubble = true;
          if (_this.rollComputer) {
            _this.rollComputer.stopTransform();
            _this.rollComputer.hide();
          }
        });
      });
      //
      this.container = this.stage.container();
      this.container.addEventListener("dragover", function (e) {
        e.preventDefault();
      });
      this.container.addEventListener("drop", function (e) {
        e.preventDefault();
        _this.stage.setPointersPositions(e);
        var url = "/static/bigScreen/assets/computer_free.png";
        if (_this.form.computerNodeType == "text") {
          url = "/static/bigScreen/assets/computer_free_text.png";
        }
        console.log(_this.stage.getPointerPosition());
        var stagePointerPosition = _this.stage.getPointerPosition();
        _this.$set(_this.computerObj.offset, "x", stagePointerPosition.x - 16);
        _this.$set(_this.computerObj.offset, "y", stagePointerPosition.y - 16);
        if (!_this.computerObj.ip) {
          _this.$message({ customClass: "error", message: "此机位已添加" });
          return;
        }
        var computers = localStorage.getItem("computers");
        if (computers && Array.isArray(JSON.parse(computers))) {
          computers = JSON.parse(computers);
          computers.push(_this.computerObj);
        } else {
          computers = [];
          computers.push(_this.computerObj);
        }
        _this.$set(_this, "computers", computers);
        localStorage.setItem("computers", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(computers));
        _this.drawComputer(_this.computerObj, "/static/bigScreen/assets/computer_free_text.png");
      });
      this.container.tabIndex = 1;
      this.container.focus();
      this.container.addEventListener("keydown", function (e) {
        console.log(_this.nowSelGroup);
        if (e.keyCode === 37) {
          _this.nowSelGroup.x(_this.nowSelGroup.x() - _this.delta);
        } else if (e.keyCode === 38) {
          _this.nowSelGroup.y(_this.nowSelGroup.y() - _this.delta);
        } else if (e.keyCode === 39) {
          _this.nowSelGroup.x(_this.nowSelGroup.x() + _this.delta);
        } else if (e.keyCode === 40) {
          _this.nowSelGroup.y(_this.nowSelGroup.y() + _this.delta);
        } else {
          return;
        }
        e.preventDefault();
      });
      //
      var extra = [];
      if (this.form.hasOwnProperty("extra")) {
        var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.form));
        extra = form.extra;
      }
      setTimeout(function () {
        _this.computers.forEach(function (it) {
          // let url = `/static/bigScreen/assets/computer_${it.status}.png`;
          // if (this.form.computerNodeType == "text") {
          //   url = `/static/bigScreen/assets/computer_${it.status}_text.png`;
          // }
          // this.drawComputer(it, url);
          _this.drawComputer(it, "/static/bigScreen/assets/computer_free_text.png");
        });
        //
        if (extra && Array.isArray(extra)) {
          extra.forEach(function (it) {
            // if (it.type == "text") {
            _this.createExtra(it.type, it);
            // }
          });
        }
        //
      }, 599);
    },
    createExtra: function createExtra(type, obj) {
      var _this2 = this;

      var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (type == "text") {
        var text = new Konva.Text({
          uuidName: obj.uuidName ? obj.uuidName : this.$uuid.create(1).hex,
          x: obj.offset.x,
          y: obj.offset.y,
          rotation: obj.offset.rotation,
          skewX: obj.offset.skewX,
          skewY: obj.offset.skewY,
          scaleX: obj.offset.scaleX,
          scaleY: obj.offset.scaleY,
          text: obj.content,
          fontSize: obj.fontSize,
          fill: obj.fill
        });
        this.extraDrawLayer.add(text);
      } else if (type == "image") {
        Konva.Image.fromURL(obj.path, function (darthNode) {
          darthNode.setAttrs({
            uuidName: obj.uuidName ? obj.uuidName : _this2.$uuid.create(1).hex,
            path: obj.path,
            x: obj.offset.x,
            y: obj.offset.y,
            width: obj.offset.width,
            height: obj.offset.height,
            rotation: obj.offset.rotation,
            skewX: obj.offset.skewX,
            skewY: obj.offset.skewY,
            scaleX: obj.offset.scaleX,
            scaleY: obj.offset.scaleY,
            keepRatio: true
          });
          _this2.extraDrawLayerForImage.add(darthNode);
        });
      }
    },
    drawComputer: function drawComputer(it, url) {
      var _this3 = this;

      var group = new Konva.Group({
        width: 32,
        height: 32,
        keepRatio: true,
        x: it.offset.x / 1920 * this.stageWidth,
        y: it.offset.y / 1080 * this.stageHeight,
        rotation: it.offset.rotation,
        name: it.ip,
        scale: {
          x: this.form.computerNodeSize / 100,
          y: this.form.computerNodeSize / 100
        },
        skewX: it.offset.skewX ? it.offset.skewX : 0,
        skewY: it.offset.skewY ? it.offset.skewY : 0
      });
      var fillColor = "#333";
      if (it.status == "free") {
        fillColor = "#333";
      } else if (it.status == "book") {
        fillColor = "#ff9f4c";
      } else if (it.status == "busy") {
        fillColor = this.form.computerFillColor;
      }
      Konva.Image.fromURL(url, function (darthNode) {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: 32,
          height: 27,
          fill: fillColor
        });
        var simpleText = new Konva.Text({
          x: 16,
          y: 7,
          align: "center",
          // text: it.name,
          text: parseInt(it.name),
          fontSize: 16,
          // fontFamily: "Calibri",
          fill: _this3.form.computerTextColor
        });
        simpleText.offsetX(simpleText.width() / 2);

        group.add(darthNode);
        group.add(simpleText);
        _this3.computerDrawLayer.batchDraw();
      });
      this.computerDrawLayer.add(group);
    },
    computedIpNo: function computedIpNo(ip) {
      var tempIp = ip.trim();
      var ipArr = tempIp.split(".");
      return ipArr[ipArr.length - 1];
    },
    getScreenDetail: function getScreenDetail() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$http({
          url: "map/detail",
          method: "GET",
          params: {
            storeId: _this4.curStoreId
          }
        }).then(function (res) {
          console.log(res);
          if (res.data) {
            _this4.noData = false;
            try {
              if (res.data.h5JsonText) {
                var jsonText = JSON.parse(res.data.h5JsonText);
                if (jsonText.hasOwnProperty("computerFillColor")) {
                  _this4.form = jsonText;
                } else {
                  _this4.form = jsonText;
                  _this4.form.computerFillColor = "#e66a6a";
                }
                if (!jsonText.hasOwnProperty("computerTextColor")) {
                  _this4.form.computerTextColor = "#fff";
                }
                _this4.$forceUpdate();
                if (jsonText.hasOwnProperty("canvasJsonText")) {
                  if (_this4.numsInfo && Array.isArray(_this4.numsInfo)) {
                    if (Array.isArray(jsonText.canvasJsonText)) {
                      _this4.numsInfo.forEach(function (it) {
                        jsonText.canvasJsonText.forEach(function (ite) {
                          if (ite.ip == it.ipAddress) {
                            ite.status = _this4.deskStatus[it.status];
                          }
                        });
                      });
                      _this4.computers = jsonText.canvasJsonText;
                    }
                  }
                }
                console.log(_this4.form);
                console.log(_this4.computers);
                setTimeout(function () {
                  _this4.createStage();
                }, 100);
              }
            } catch (error) {
              console.log(error);
            }
          } else {
            _this4.noData = true;
            try {
              var _jsonText = localStorage.getItem("jsonText");
              if (_jsonText) {
                _jsonText = JSON.parse(_jsonText);
                _this4.form = _jsonText;
                if (_jsonText.hasOwnProperty("canvasJsonText")) {
                  if (_this4.numsInfo && Array.isArray(_this4.numsInfo)) {
                    if (Array.isArray(_jsonText.canvasJsonText)) {
                      _this4.numsInfo.forEach(function (it) {
                        _jsonText.canvasJsonText.forEach(function (ite) {
                          if (ite.ip == it.ipAddress) {
                            ite.status = _this4.deskStatus[it.status];
                          }
                        });
                      });
                      _this4.computers = _jsonText.canvasJsonText;
                    }
                  }
                }
                console.log(_this4.form);
                _this4.$nextTick(function () {
                  _this4.createStage();
                });
              }
            } catch (error) {
              console.log(error);
            }
          }
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    isMobile: function isMobile() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    getPar: function getPar() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$http({
          url: "region/list",
          method: "POST",
          data: {
            storeId: _this5.curStoreId
          }
        }).then(function (res) {
          var nums = [];
          if (res.data && Array.isArray(res.data)) {
            res.data.forEach(function (it) {
              if (Array.isArray(it.nums)) {
                nums = nums.concat(it.nums);
              }
            });
          }
          console.log("nums", nums);
          _this5.numsInfo = nums;
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    rollPar: function rollPar() {
      var _this6 = this;

      this.$http({
        url: "region/list",
        method: "POST",
        data: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        var nums = [];
        if (res.data && Array.isArray(res.data)) {
          res.data.forEach(function (it) {
            if (Array.isArray(it.nums)) {
              nums = nums.concat(it.nums);
            }
          });
        }
        _this6.numsInfo = nums;
        var computers = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this6.computers));
        if (_this6.numsInfo && Array.isArray(_this6.numsInfo)) {
          if (Array.isArray(computers)) {
            _this6.numsInfo.forEach(function (it) {
              computers.forEach(function (ite) {
                if (ite.ip == it.ipAddress) {
                  ite.status = _this6.deskStatus[it.status];
                }
              });
            });
            _this6.computers = computers;
            setTimeout(function () {
              _this6.computers.forEach(function (it) {
                // let url = `/static/bigScreen/assets/computer_${it.status}.png`;
                // if (this.form.computerNodeType == "text") {
                //   url = `/static/bigScreen/assets/computer_${it.status}_text.png`;
                // }
                var url = "/static/bigScreen/assets/computer_free_text.png";
                _this6.computerDrawLayer.getChildren(function (node) {
                  if (node.getClassName() == "Group" && it.ip == node.attrs.name) {
                    var img = document.createElement("img");
                    img.src = url;
                    console.log("node", node);
                    if (node.children && Array.isArray(node.children) && node.children.length) {
                      console.log("node.children[0].image", node.children[0]);
                      node.children[0].image(img);
                      var fillColor = "#333";
                      if (it.status == "free") {
                        fillColor = "#333";
                      } else if (it.status == "book") {
                        fillColor = "#ff9f4c";
                      } else if (it.status == "busy") {
                        fillColor = _this6.form.computerFillColor;
                      }
                      node.children[0].attrs.fill = fillColor;
                    }
                  }
                });
              });
            }, 599);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var clientWidth, clientHeight, viewport, scaleNum, scaleX, scaleY, _scaleX, _scaleY;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this7.curStoreId == "1c85336c-25c2-11f0-96a6-67ef79deeeed")) {
                _context2.next = 3;
                break;
              }

              window.close();
              return _context2.abrupt("return");

            case 3:
              _context2.next = 5;
              return _this7.getPar();

            case 5:
              _context2.next = 7;
              return _this7.getScreenDetail();

            case 7:
              _this7.timer = setInterval(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _this7.rollPar();

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, _this7);
              })), 5 * 1000);
              console.log(document.body.clientWidth);

              if (!_this7.isMobile()) {
                console.log("手机");
                _this7.showMask = true;
                clientWidth = document.body.clientWidth;
                clientHeight = document.body.clientHeight;

                $("html").css({
                  width: clientWidth + "px",
                  height: clientHeight + "px"
                  // overflow:"hidden",
                  // width: "1920px",
                  // height: "1080px",
                });
                viewport = document.querySelector("meta[name=viewport]");

                if (window.devicePixelRatio == 1) {
                  viewport.setAttribute("content", "width=device-width,initial-scale=1, minimum-scale=1, user-scalable=yes");
                } else if (window.devicePixelRatio == 2) {
                  viewport.setAttribute("content", "width=device-width,initial-scale=0.5, minimum-scale=0.5, user-scalable=yes");
                } else if (window.devicePixelRatio == 3) {
                  viewport.setAttribute("content", "width=device-width,initial-scale=0.3333333333333333, minimum-scale=0.3333333333333333, user-scalable=yes");
                } else {
                  scaleNum = 1 / window.devicePixelRatio;

                  viewport.setAttribute("content", "width=device-width,initial-scale=" + scaleNum + ", minimum-scale=" + scaleNum + ", user-scalable=yes");
                }
                scaleX = document.body.clientWidth / 1920;
                scaleY = document.body.clientHeight / 1080;

                $("#app").css({
                  "min-width": "initial"
                });
                $("#canvasWrap").css({
                  transform: "scaleX(" + scaleX + ") scaleY(" + scaleY + ")"
                });
                $("#canvasWrap").css({
                  transform: "rotate(90deg)",
                  width: "100vh",
                  height: "100vw"
                  // "transform-origin":"top left"
                });
                // window.screen.orientation.lock("landscape").then(
                //   (success) => console.log(success),
                //   (failure) => console.log(failure)
                // );
              } else {
                _scaleX = document.body.clientWidth / 1920;
                _scaleY = document.body.clientHeight / 1080;

                $("#canvasWrap").css({
                  transform: "scaleX(" + _scaleX + ") scaleY(" + _scaleY + ")"
                });
                _this7.$message({
                  customClass: "success",
                  message: "双击可进入全屏/退出全屏!"
                });
              }
              document.addEventListener("fullscreenchange", function () {
                setTimeout(function () {
                  var scaleX = document.body.clientWidth / 1920;
                  var scaleY = document.body.clientHeight / 1080;
                  // $("canvas").css({
                  //   width:document.body.clientWidth+"px",
                  //   height:document.body.clientHeight+"px",
                  // })
                  $("#canvasWrap").css({
                    transform: "scaleX(" + scaleX + ") scaleY(" + scaleY + ")"
                  });
                }, 250);
              }, false);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this7);
    }))();
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__urlConfig_index__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "bigScreen",
  props: ["curStoreId"],
  data: function data() {
    return {
      showFullScreen: true,
      showMask: false,
      noData: true,
      coverImgMaxSize: 15 * 1024 * 1024, // 图片最大字节数
      sites: [],
      activeNames: ["1"],
      showDrawer: false,
      form: {
        background: "",
        computerNodeType: "computer",
        computerNodeSize: 70,
        canvasJsonText: "",
        extra: []
      },
      options: [{
        label: "文本式",
        value: "text"
      }, {
        label: "电脑图标式",
        value: "computer"
      }],
      computerObj: {
        ip: "192.168.0.1",
        status: "free",
        name: "001",
        offset: {
          x: 0,
          y: 0,
          rotation: 0,
          skewX: 0,
          skewY: 0
        }
      },
      stageWidth: "",
      stageHeight: "",
      stage: null,
      layer: null,
      computerLayer: null,
      contextMenuNode: null,
      rollComputer: null,
      container: null,
      nowSelGroup: null,
      delta: 1,
      numsInfo: [],
      computers: [],
      deskStatus: {
        0: "free",
        1: "busy",
        2: "book"
      },
      fullScreen: false
    };
  },

  methods: {
    doFullScreen: function doFullScreen() {
      if (!this.fullScreen) {
        var docElm = document.documentElement;
        if (docElm.requestFullscreen) {
          this.fullScreen = true;
          docElm.requestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          this.fullScreen = false;
          document.exitFullscreen();
        }
      }
    },
    createStage: function createStage() {
      var _this = this;

      var bigScreenEle = document.querySelector("#canvasWrap");
      this.stageWidth = bigScreenEle.clientWidth;
      console.log("stageWidth", this.stageWidth);
      this.stageHeight = bigScreenEle.clientHeight;
      this.stage = new Konva.Stage({
        container: "canvasWrap",
        width: this.stageWidth,
        height: this.stageHeight
      });
      this.layer = new Konva.Layer();
      this.computerLayer = new Konva.Layer();
      this.computerDrawLayer = new Konva.Layer();
      this.extraDrawLayer = new Konva.Layer();
      this.extraDrawLayerForImage = new Konva.Layer();
      this.stage.add(this.layer);
      this.stage.add(this.computerLayer);
      this.stage.add(this.computerDrawLayer);
      this.stage.add(this.extraDrawLayerForImage);
      this.stage.add(this.extraDrawLayer);
      this.stage.on("contextmenu", function (e) {
        e.evt.preventDefault();
      });
      //
      console.log("bgurl", this.form.background);
      //
      Konva.Image.fromURL(this.form.background, function (darthNode) {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: _this.stage.width(),
          height: _this.stage.height(),
          keepRatio: true
        });
        _this.computerLayer.add(darthNode);
        _this.computerLayer.batchDraw();
        _this.computerLayer.on("click", function (event) {
          event.cancelBubble = true;
          if (_this.rollComputer) {
            _this.rollComputer.stopTransform();
            _this.rollComputer.hide();
          }
        });
      });
      //
      this.container = this.stage.container();
      this.container.addEventListener("dragover", function (e) {
        e.preventDefault();
      });
      this.container.addEventListener("drop", function (e) {
        e.preventDefault();
        _this.stage.setPointersPositions(e);
        var url = "/static/bigScreen/assets/computer_free.png";
        if (_this.form.computerNodeType == "text") {
          url = "/static/bigScreen/assets/computer_free_text.png";
        }
        console.log(_this.stage.getPointerPosition());
        var stagePointerPosition = _this.stage.getPointerPosition();
        _this.$set(_this.computerObj.offset, "x", stagePointerPosition.x - 16);
        _this.$set(_this.computerObj.offset, "y", stagePointerPosition.y - 16);
        if (!_this.computerObj.ip) {
          _this.$message({ customClass: "error", message: "此机位已添加" });
          return;
        }
        var computers = localStorage.getItem("computers");
        if (computers && Array.isArray(JSON.parse(computers))) {
          computers = JSON.parse(computers);
          computers.push(_this.computerObj);
        } else {
          computers = [];
          computers.push(_this.computerObj);
        }
        _this.$set(_this, "computers", computers);
        localStorage.setItem("computers", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(computers));
        _this.drawComputer(_this.computerObj, "/static/bigScreen/assets/computer_free_text.png");
      });
      this.container.tabIndex = 1;
      this.container.focus();
      this.container.addEventListener("keydown", function (e) {
        console.log(_this.nowSelGroup);
        if (e.keyCode === 37) {
          _this.nowSelGroup.x(_this.nowSelGroup.x() - _this.delta);
        } else if (e.keyCode === 38) {
          _this.nowSelGroup.y(_this.nowSelGroup.y() - _this.delta);
        } else if (e.keyCode === 39) {
          _this.nowSelGroup.x(_this.nowSelGroup.x() + _this.delta);
        } else if (e.keyCode === 40) {
          _this.nowSelGroup.y(_this.nowSelGroup.y() + _this.delta);
        } else {
          return;
        }
        e.preventDefault();
      });
      //
      var extra = [];
      if (this.form.hasOwnProperty("extra")) {
        var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.form));
        extra = form.extra;
      }
      setTimeout(function () {
        _this.computers.forEach(function (it) {
          // let url = `/static/bigScreen/assets/computer_${it.status}.png`;
          // if (this.form.computerNodeType == "text") {
          //   url = `/static/bigScreen/assets/computer_${it.status}_text.png`;
          // }
          // this.drawComputer(it, url);
          _this.drawComputer(it, "/static/bigScreen/assets/computer_free_text.png");
        });
        //
        if (extra && Array.isArray(extra)) {
          extra.forEach(function (it) {
            // if (it.type == "text") {
            _this.createExtra(it.type, it);
            // }
          });
        }
        //
      }, 599);
    },
    createExtra: function createExtra(type, obj) {
      var _this2 = this;

      var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (type == "text") {
        var text = new Konva.Text({
          uuidName: obj.uuidName ? obj.uuidName : this.$uuid.create(1).hex,
          x: obj.offset.x,
          y: obj.offset.y,
          rotation: obj.offset.rotation,
          skewX: obj.offset.skewX,
          skewY: obj.offset.skewY,
          scaleX: obj.offset.scaleX,
          scaleY: obj.offset.scaleY,
          text: obj.content,
          fontSize: obj.fontSize,
          fill: obj.fill
        });
        this.extraDrawLayer.add(text);
      } else if (type == "image") {
        Konva.Image.fromURL(obj.path, function (darthNode) {
          darthNode.setAttrs({
            uuidName: obj.uuidName ? obj.uuidName : _this2.$uuid.create(1).hex,
            path: obj.path,
            x: obj.offset.x,
            y: obj.offset.y,
            width: obj.offset.width,
            height: obj.offset.height,
            rotation: obj.offset.rotation,
            skewX: obj.offset.skewX,
            skewY: obj.offset.skewY,
            scaleX: obj.offset.scaleX,
            scaleY: obj.offset.scaleY,
            keepRatio: true
          });
          _this2.extraDrawLayerForImage.add(darthNode);
        });
      }
    },
    drawComputer: function drawComputer(it, url) {
      var _this3 = this;

      var group = new Konva.Group({
        width: 32,
        height: 32,
        keepRatio: true,
        x: it.offset.x / 1920 * this.stageWidth,
        y: it.offset.y / 1080 * this.stageHeight,
        rotation: it.offset.rotation,
        name: it.ip,
        scale: {
          x: this.form.computerNodeSize / 100,
          y: this.form.computerNodeSize / 100
        },
        skewX: it.offset.skewX ? it.offset.skewX : 0,
        skewY: it.offset.skewY ? it.offset.skewY : 0
      });
      var fillColor = "#333";
      if (it.status == "free") {
        fillColor = "#333";
      } else if (it.status == "book") {
        fillColor = "#ff9f4c";
      } else if (it.status == "busy") {
        fillColor = this.form.computerFillColor;
      }
      Konva.Image.fromURL(url, function (darthNode) {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: 32,
          height: 27,
          fill: fillColor
        });
        var simpleText = new Konva.Text({
          x: 16,
          y: 7,
          align: "center",
          // text: it.name,
          text: parseInt(it.name),
          fontSize: 16,
          // fontFamily: "Calibri",
          fill: _this3.form.computerTextColor
        });
        simpleText.offsetX(simpleText.width() / 2);

        group.add(darthNode);
        group.add(simpleText);
        _this3.computerDrawLayer.batchDraw();
      });
      this.computerDrawLayer.add(group);
    },
    computedIpNo: function computedIpNo(ip) {
      var tempIp = ip.trim();
      var ipArr = tempIp.split(".");
      return ipArr[ipArr.length - 1];
    },
    getScreenDetail: function getScreenDetail() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$http({
          url: "map/detail",
          method: "GET",
          params: {
            storeId: _this4.curStoreId
          }
        }).then(function (res) {
          console.log(res);
          if (res.data) {
            _this4.noData = false;
            try {
              if (res.data.h5JsonText) {
                var jsonText = JSON.parse(res.data.h5JsonText);
                if (jsonText.hasOwnProperty("computerFillColor")) {
                  _this4.form = jsonText;
                } else {
                  _this4.form = jsonText;
                  _this4.form.computerFillColor = "#e66a6a";
                }
                if (!jsonText.hasOwnProperty("computerTextColor")) {
                  _this4.form.computerTextColor = "#fff";
                }
                _this4.$forceUpdate();
                if (jsonText.hasOwnProperty("canvasJsonText")) {
                  if (_this4.numsInfo && Array.isArray(_this4.numsInfo)) {
                    if (Array.isArray(jsonText.canvasJsonText)) {
                      _this4.numsInfo.forEach(function (it) {
                        jsonText.canvasJsonText.forEach(function (ite) {
                          if (ite.ip == it.ipAddress) {
                            ite.status = _this4.deskStatus[it.status];
                          }
                        });
                      });
                      _this4.computers = jsonText.canvasJsonText;
                    }
                  }
                }
                console.log(_this4.form);
                console.log(_this4.computers);
                setTimeout(function () {
                  _this4.createStage();
                }, 100);
              }
            } catch (error) {
              console.log(error);
            }
          } else {
            _this4.noData = true;
            try {
              var _jsonText = localStorage.getItem("jsonText");
              if (_jsonText) {
                _jsonText = JSON.parse(_jsonText);
                _this4.form = _jsonText;
                if (_jsonText.hasOwnProperty("canvasJsonText")) {
                  if (_this4.numsInfo && Array.isArray(_this4.numsInfo)) {
                    if (Array.isArray(_jsonText.canvasJsonText)) {
                      _this4.numsInfo.forEach(function (it) {
                        _jsonText.canvasJsonText.forEach(function (ite) {
                          if (ite.ip == it.ipAddress) {
                            ite.status = _this4.deskStatus[it.status];
                          }
                        });
                      });
                      _this4.computers = _jsonText.canvasJsonText;
                    }
                  }
                }
                console.log(_this4.form);
                _this4.$nextTick(function () {
                  _this4.createStage();
                });
              }
            } catch (error) {
              console.log(error);
            }
          }
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    isMobile: function isMobile() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    getPar: function getPar() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$http({
          url: "region/list",
          method: "POST",
          data: {
            storeId: _this5.curStoreId
          }
        }).then(function (res) {
          var nums = [];
          if (res.data && Array.isArray(res.data)) {
            res.data.forEach(function (it) {
              if (Array.isArray(it.nums)) {
                nums = nums.concat(it.nums);
              }
            });
          }
          console.log("nums", nums);
          _this5.numsInfo = nums;
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    rollPar: function rollPar() {
      var _this6 = this;

      this.$http({
        url: "region/list",
        method: "POST",
        data: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        var nums = [];
        if (res.data && Array.isArray(res.data)) {
          res.data.forEach(function (it) {
            if (Array.isArray(it.nums)) {
              nums = nums.concat(it.nums);
            }
          });
        }
        _this6.numsInfo = nums;
        var computers = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this6.computers));
        if (_this6.numsInfo && Array.isArray(_this6.numsInfo)) {
          if (Array.isArray(computers)) {
            _this6.numsInfo.forEach(function (it) {
              computers.forEach(function (ite) {
                if (ite.ip == it.ipAddress) {
                  ite.status = _this6.deskStatus[it.status];
                }
              });
            });
            _this6.computers = computers;
            setTimeout(function () {
              _this6.computers.forEach(function (it) {
                // let url = `/static/bigScreen/assets/computer_${it.status}.png`;
                // if (this.form.computerNodeType == "text") {
                //   url = `/static/bigScreen/assets/computer_${it.status}_text.png`;
                // }
                var url = "/static/bigScreen/assets/computer_free_text.png";
                _this6.computerDrawLayer.getChildren(function (node) {
                  if (node.getClassName() == "Group" && it.ip == node.attrs.name) {
                    var img = document.createElement("img");
                    img.src = url;
                    console.log("node", node);
                    if (node.children && Array.isArray(node.children) && node.children.length) {
                      console.log("node.children[0].image", node.children[0]);
                      node.children[0].image(img);
                      var fillColor = "#333";
                      if (it.status == "free") {
                        fillColor = "#333";
                      } else if (it.status == "book") {
                        fillColor = "#ff9f4c";
                      } else if (it.status == "busy") {
                        fillColor = _this6.form.computerFillColor;
                      }
                      node.children[0].attrs.fill = fillColor;
                    }
                  }
                });
              });
            }, 599);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var clientWidth, clientHeight, viewport, scaleNum, scaleX, scaleY, _scaleX, _scaleY;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this7.curStoreId == "1c85336c-25c2-11f0-96a6-67ef79deeeed")) {
                _context2.next = 3;
                break;
              }

              window.close();
              return _context2.abrupt("return");

            case 3:
              _context2.next = 5;
              return _this7.getPar();

            case 5:
              _context2.next = 7;
              return _this7.getScreenDetail();

            case 7:
              _this7.timer = setInterval(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _this7.rollPar();

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, _this7);
              })), 5 * 1000);
              console.log(document.body.clientWidth);

              if (!_this7.isMobile()) {
                console.log("手机");
                _this7.showMask = true;
                clientWidth = document.body.clientWidth;
                clientHeight = document.body.clientHeight;

                $("html").css({
                  width: clientWidth + "px",
                  height: clientHeight + "px"
                  // overflow:"hidden",
                  // width: "1920px",
                  // height: "1080px",
                });
                viewport = document.querySelector("meta[name=viewport]");

                if (window.devicePixelRatio == 1) {
                  viewport.setAttribute("content", "width=device-width,initial-scale=1, minimum-scale=1, user-scalable=yes");
                } else if (window.devicePixelRatio == 2) {
                  viewport.setAttribute("content", "width=device-width,initial-scale=0.5, minimum-scale=0.5, user-scalable=yes");
                } else if (window.devicePixelRatio == 3) {
                  viewport.setAttribute("content", "width=device-width,initial-scale=0.3333333333333333, minimum-scale=0.3333333333333333, user-scalable=yes");
                } else {
                  scaleNum = 1 / window.devicePixelRatio;

                  viewport.setAttribute("content", "width=device-width,initial-scale=" + scaleNum + ", minimum-scale=" + scaleNum + ", user-scalable=yes");
                }
                scaleX = document.body.clientWidth / 1920;
                scaleY = document.body.clientHeight / 1080;

                $("#app").css({
                  "min-width": "initial"
                });
                $("#canvasWrap").css({
                  transform: "scaleX(" + scaleX + ") scaleY(" + scaleY + ")"
                });
                // $("#canvasWrap").css({
                //   transform:"rotate(90deg)",
                //   width:"100vh",
                //   height:"100vw"
                //   // "transform-origin":"top left"
                // })
                // window.screen.orientation.lock("landscape").then(
                //   (success) => console.log(success),
                //   (failure) => console.log(failure)
                // );
              } else {
                _scaleX = document.body.clientWidth / 1920;
                _scaleY = document.body.clientHeight / 1080;

                $("#canvasWrap").css({
                  transform: "scaleX(" + _scaleX + ") scaleY(" + _scaleY + ")"
                });
                _this7.$message({
                  customClass: "success",
                  message: "双击可进入全屏/退出全屏!"
                });
              }
              document.addEventListener("fullscreenchange", function () {
                setTimeout(function () {
                  var scaleX = document.body.clientWidth / 1920;
                  var scaleY = document.body.clientHeight / 1080;
                  // $("canvas").css({
                  //   width:document.body.clientWidth+"px",
                  //   height:document.body.clientHeight+"px",
                  // })
                  $("#canvasWrap").css({
                    transform: "scaleX(" + scaleX + ") scaleY(" + scaleY + ")"
                  });
                }, 250);
              }, false);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this7);
    }))();
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["showCartInfo", "secondInfo", "nowSelName", "begin", "end", "mobile", "storeId", "vipInfo", "showType", "vipConsumeInfo", "orderInfo", "nowExcInfo", "nowPackageTotalSalesInfo", "nowDeskSalesInfo", "nowEmpSalesInfo"],
  data: function data() {
    return {
      salesGoodsInfo: {},
      formInline: {
        startTime: "",
        endTime: ""
      },
      totalElementsForSales: 0,
      nowPageForSales: 1,
      nowPage: 1,
      pageSize: 10,
      pageSizeForSales: 10,
      goodsInfoForSecond: {},
      typeOptions: {
        "discount": "折扣",
        "reduce": "减免金额"
      },
      nowSelIndex: -1,
      itemDetail: [],
      modeInfo: {
        0: "正常",
        1: "免单",
        2: "挂单",
        3: "反结账单"
      },
      titInfo: { "vipChargeInfo": "会员充值详情", "vipConsume": "会员消费详情", "exchangeInfo": "销售详情", "packageTotalSales": "详情", "deskSalesInfo": '详情', "empSalesInfo": '业绩详情' },
      channelType: { // 结算方式
        // ALIPAY: '支付宝',
        // CASH: '现金',
        // WECHATPAY: '微信',
        // MEMBER : '会员支付',
        // WECHATPAY_CASH : '线下微信',
        // ALIPAY_CASH : '线下支付宝',
        "CASH": "现金",
        "ALIPAY": "支付宝",
        "WECHATPAY": "微信",
        "UNIONPAY": "银联",
        "pay.weixin.micropay": "微信刷卡",
        "pay.wechat.micropay": "微信刷卡",
        "pay.alipay.micropay": "支付宝刷卡",
        "pay.jdpay.micropay": "京东刷卡",
        "pay.qq.micropay": "QQ钱包刷卡",
        "pay.shiming.micropay": "会员卡",
        "pay.unionpay.micropay": "银联支付",
        "pay.bestpay.micropay": "翼支付",
        "pay.weixin.native": "微信扫码",
        "pay.wechat.native": "微信扫码",
        "pay.alipay.native": "支付宝扫码",
        "ALIPAY_CASH": "支付宝线下",
        "WECHATPAY_CASH": "微信线下",
        "COUPON": "优惠券",
        "MEMBER": "会员",
        "pay.wechat.jspay": "微信网页支付",
        "pay.alipay.jspay": "支付宝网页支付"
      }
    };
  },

  watch: {
    showCartInfo: function showCartInfo(val) {
      if (!val) {
        this.showType = "";
      } else if (this.showType == 'secondActivity' && val) {
        this.getGoodsInfo();
      }
    },
    nowPage: function nowPage(val) {
      this.getGoodsInfo();
    },
    nowPageForSales: function nowPageForSales(val) {
      this.getSlesInfo();
    }
  },
  methods: {
    cancelActivity: function cancelActivity() {
      var _this = this;

      this.$http({
        url: "dp/cancel",
        method: "GET",
        params: {
          id: this.secondInfo.id
        }
      }).then(function (res) {
        _this.$message({
          message: '操作成功',
          customClass: 'success'
        });
        _this.$emit("closeCartInfo");
      });
    },
    handleCurrentChangeForSales: function handleCurrentChangeForSales(val) {
      console.log("\u5F53\u524D\u9875: " + val);
      this.nowPageForSales = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: " + val);
      this.nowPage = val;
    },
    onSubmit: function onSubmit() {
      this.getSlesInfo();
    },
    getSlesInfo: function getSlesInfo() {
      var _this2 = this;

      if (new Date(this.formInline.endTime).getTime() - new Date(this.formInline.startTime).getTime() > 1000 * 60 * 60 * 24 * 35) {
        this.$message({
          message: '只能查询35天内的数据',
          customClass: 'error'
        });
        return;
      }
      if (this.formInline.startTime !== '' && this.formInline.endTime !== '') {
        if (new Date(this.formInline.startTime) > new Date(this.formInline.endTime)) {
          this.$message({
            message: '结束时间不能比开始时间小',
            customClass: 'error'
          });
          return;
        }
      } else if (String(this.formInline.startTime) == "" || String(this.formInline.endTime) == "") {
        this.$message({
          message: '请选择时间',
          customClass: 'error'
        });
        return;
      }
      this.$http({
        url: "dp/sales/list",
        method: "GET",
        params: {
          promotionId: this.secondInfo.id,
          begin: new Date(this.formInline.startTime).Format("yyyy-MM-dd hh:mm:ss"),
          end: new Date(this.formInline.endTime).Format("yyyy-MM-dd hh:mm:ss"),
          page: this.nowPageForSales - 1,
          size: this.pageSizeForSales
        }
      }).then(function (res) {
        _this2.salesGoodsInfo = res.data;
        _this2.totalElementsForSales = res.data.totalElements;
      });
    },
    getGoodsInfo: function getGoodsInfo() {
      var _this3 = this;

      this.$http({
        url: "dp/product/list",
        method: "GET",
        params: {
          promotionId: this.secondInfo.id,
          page: this.nowPage - 1,
          size: this.pageSize
        }
      }).then(function (res) {
        _this3.goodsInfoForSecond = res.data;
        _this3.totalElements = res.data.totalElements;
      });
    },
    formatTimeRange: function formatTimeRange(item) {
      if (item.beginHour && item.endHour) {
        return item.beginHour + "\u81F3" + item.endHour;
      } else {
        return '';
      }
    },
    formatTime: function formatTime(item) {
      if (item.timeType == "forever") {
        return '永久有效';
      } else if (item.timeType == "custom") {
        return new Date(item.beginTime).Format("yyyy-MM-dd") + "\u81F3" + new Date(item.endTime).Format("yyyy-MM-dd");
      }
    },
    formatDiscount: function formatDiscount(item) {
      if (item.discountType == "discount") {
        return item.discount / 10 + "\u6298";
      } else if (item.discountType == "reduce") {
        return item.reduceAmount / 100 + "\u5143";
      }
    },
    closeCartInfo: function closeCartInfo() {
      this.nowSelIndex = -1;
      this.itemDetail = [];
      this.$emit("closeCartInfo", "");
    },
    showGoodsDetail: function showGoodsDetail(it, idx) {
      var _this4 = this;

      // console.log($(".goods-detail")[idx]);
      // if(!$($(".goods-detail")[idx]).hasClass('act')){
      //   // $($(".goods-detail")[idx]).addClass("act");
      //   $($(".goods-detail")[idx]).find(".arrow").addClass("bot");
      // }else{
      //   // $($(".goods-detail")[idx]).removeClass("act");
      //   $($(".goods-detail")[idx]).find(".arrow").removeClass("bot");
      // }
      var beginTime = new Date(this.begin).Format("yyyy-MM-dd hh:mm:ss");
      var endTime = new Date(this.end).Format("yyyy-MM-dd hh:mm:ss");
      if (idx == this.nowSelIndex) {
        this.nowSelIndex = -1;
        return;
      }
      this.nowSelIndex = idx;
      this.$http({
        url: "get-total-itemDetails",
        method: "GET",
        params: {
          begin: beginTime,
          end: endTime,
          mobile: this.mobile,
          typeName: it.typeName,
          storeId: this.storeId
        }
      }).then(function (res) {
        // this.$nextTick(()=>{
        //   this.nowExcInfo.itemDetails[idx].itemDetail = res.data;
        // })
        if (!res.data.length) {
          _this4.$message({
            message: "暂无数据",
            customClass: 'error'
          });
        }
        _this4.itemDetail = res.data;
      });
    }
  },
  mounted: function mounted() {},
  updated: function updated() {}
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__urlConfig_index__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var normalBg = __webpack_require__(827);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "goodsBigScreen",
  props: ["curStoreId"],
  data: function data() {
    return {
      isBold: "-1",
      textColor: "#333",
      makeBackUrl: {},
      timer: null,
      backgroundImage: "",
      codeArr: [],
      nowGetItem: null,
      code: "",
      showGetOrder: false,
      deliveryOrder: [],
      ingOrder: [],
      status: true,
      stompClient: null, // stomp客户端对象
      stompClientNotice: null // stomp客户端对象(语音服务)
    };
  },

  methods: {
    formatTime: function formatTime(time) {
      var nowTime = new Date().getTime();
      var makeTime = new Date(time).getTime();
      var minTimes = nowTime - makeTime;
      if (Math.floor(minTimes / 1000 / 60) < 1) {
        return "已等待0分钟";
      } else {
        return "\u5DF2\u7B49\u5F85" + Math.floor(minTimes / 1000 / 60) + "\u5206\u949F";
      }
    },
    getStoreInfo: function getStoreInfo() {
      var _this2 = this;

      this.$http({
        url: "stores/" + this.curStoreId,
        method: "GET"
      }).then(function (res) {
        // if (res.data.makeBackUrl) {
        //   this.backgroundImage = res.data.makeBackUrl;
        // } else {
        //   this.backgroundImage = normalBg;
        // }
        if (res.data.makeBackUrl && res.data.makeBackUrl.indexOf("{") != -1) {
          _this2.makeBackUrl = JSON.parse(res.data.makeBackUrl);
          if (_this2.makeBackUrl.hasOwnProperty("textColor") && _this2.makeBackUrl.textColor) {
            _this2.textColor = _this2.makeBackUrl.textColor;
          }
          if (_this2.makeBackUrl.hasOwnProperty("isBold")) {
            _this2.isBold = _this2.makeBackUrl.isBold;
          } else {
            _this2.isBold = "-1";
          }
        } else {
          _this2.makeBackUrl = {
            bg: res.data.makeBackUrl,
            textColor: "#333",
            isBold: "-1"
          };
          _this2.textColor = _this2.makeBackUrl.textColor;
          _this2.isBold = _this2.makeBackUrl.isBold;
        }
        if (_this2.makeBackUrl && _this2.makeBackUrl.bg) {
          _this2.backgroundImage = _this2.makeBackUrl.bg;
        } else {
          _this2.backgroundImage = normalBg;
        }
        console.log("bold", _this2.isBold);
      });
    },

    //
    connect: function connect() {
      var authStr = localStorage.getItem("token");
      var socket = new SockJS(__WEBPACK_IMPORTED_MODULE_3__urlConfig_index__["c" /* WS_API_URL */] + "gs-guide-websocket");
      this.stompClient = Stomp.over(socket);
      var that = this;
      this.stompClient.connect({ "Auth-Token": authStr }, function (frame) {
        that.stompClient.ws.onerror = function (evnt) {
          that.connect();
        };
        that.stompClient.ws.onclose = function (evnt) {
          that.connect();
        };
        that.stompClient.subscribe("/message/" + that.curStoreId, function (event) {
          console.log("我收到了服务器消息");
          var res = JSON.parse(event.body);
          console.log("source", res.source);
          if (res.source == "MAKE") {
            that.getData();
          }
        });
      });
      this.stompClient.ws.onclose = function (evnt) {
        setTimeout(function () {
          that.connect();
        }, 1000);
      };
      this.stompClient.debug = function (str) {
        console.log(str);
      };
    },
    disconnect: function disconnect() {
      if (this.stompClient !== null) {
        this.stompClient.disconnect();
      }
    },

    //
    checkInputFocus: function checkInputFocus(selector) {
      document.getElementById("inp").focus();
      setTimeout(function () {
        var input = document.querySelector(selector);
        if (input === document.activeElement) {
          console.log("focused");
        } else {
          document.getElementById("inp").focus();
        }
      }, 100);
    },
    test: function test(it) {
      this.code = it;
      this.checkOrder();
    },
    checkOrder: function checkOrder() {
      var _this3 = this;

      console.log("code", this.code);
      var itemIds = [];
      if (this.code) {
        itemIds = this.code.split(";");
      }
      if (!itemIds.length) {
        return;
      }
      this.code = "";
      this.$http({
        url: "/update/type",
        method: "POST",
        data: {
          itemIds: itemIds,
          type: "deliveryIng"
        }
      }).then(function (res) {
        console.log("res", res);
        try {
          _this3.nowGetItem = res.data[0];
          _this3.showGetOrder = true;
          _this3.getData();
        } catch (error) {
          console.log("error", error);
        }
        // this.playVoice(res.data[0].code);
        setTimeout(function () {
          _this3.showGetOrder = false;
        }, 4599);
      });
    },
    playVoice: function playVoice(code) {
      return;
      var codeArr = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.codeArr));
      codeArr.push(code);
      codeArr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(codeArr)));
      //
      var _this = this;
      if (codeArr && codeArr.length) {
        var _playAudio = function _playAudio(audioIndex) {
          if (audioIndex < codeArr.length) {
            var audio = "<audio style=\"display:none;\" controls=\"\" class=\"getAudio\" src=\"" + __WEBPACK_IMPORTED_MODULE_3__urlConfig_index__["b" /* API_BASE_URL */] + "v1/pos/speech?tex=" + codeArr[audioIndex] + ",\u8BF7\u53D6\u9910&vol=9&per=0&spd=5&pit=5\" autoplay=\"autoplay\"></audio>";
            $("#goodsBigScreen").append(audio);

            $(".getAudio").on("playing", function () {
              _this.status = false; //正在播放
              console.log("正在播放");
            });
            $(".getAudio").on("ended", function () {
              this.remove();
              _playAudio(audioIndex + 1);
            });
          } else {
            console.log("播放完毕");
          }
        };

        var audioIndex = 0;

        _playAudio(audioIndex);
        return;
      }
      //
      // $(".getAudio").remove();
      // let audio = `<audio style="display:none;" controls="" class="getAudio" src="${API_BASE_URL}v1/pos/speech?tex=${code},请取餐&vol=9&per=0&spd=5&pit=5" autoplay="autoplay"></audio>`;
      // $("#goodsBigScreen").append(audio);
      // try {
      //   $(".getAudio").remove();
      // } catch (error) {}
    },
    getData: function getData() {
      var _this4 = this;

      this.$http({
        url: "/get/by/type",
        method: "POST",
        data: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        console.log("res", res);
        if (res.data && res.data.hasOwnProperty("ingItem") && res.data.hasOwnProperty("deliveryItem")) {
          _this4.ingOrder = Array.isArray(res.data.ingItem) ? res.data.ingItem : [];
          _this4.deliveryOrder = Array.isArray(res.data.deliveryItem) ? res.data.deliveryItem : [];
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.disconnect();
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.getStoreInfo();
    this.connect();
    this.timer = setInterval(function () {
      _this5.getData();
    }, 1000);
    this.checkInputFocus("input.inp");
    setInterval(function () {
      _this5.checkInputFocus("input.inp");
    }, 1000 * 60);
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    /* 
        oldImg 传入图片base64
        showCrop 控制显示隐藏
        curCropW 需要图片宽度
        curCropH 需要图片高度
    */
    props: ['oldImg', 'curCropW', 'curCropH', 'curStoreId'],
    data: function data() {
        return {
            cropImg: '', // 剪切后图片base64

            startX: '', // 图片裁剪的开始x坐标
            startY: '', // 图片裁剪的开始y坐标
            imgWidth: '', // 图片裁剪宽度
            imgHeight: '', // 图片裁剪高度
            ratio: '', // 图片缩放比例
            imgCropload: false
        };
    },

    watch: {
        oldImg: function oldImg(newVal, oldVal) {
            var _this = this;

            var img = new Image();
            img.src = newVal;
            if (img.width / img.height > 4 / 3) {
                $('#targetImg').width(400);
                this.ratio = img.width / 400;
            } else {
                $('#targetImg').height(300);
                this.ratio = img.height / 300;
            }
            setTimeout(function () {
                _this.handleJcrop();
            }, 500);
        }
    },
    methods: {
        // 保存图片裁剪
        save: function save() {
            var _this2 = this;

            // 判断如果没有裁剪就返回整个图片
            this.imgCropload = true;
            if (!this.startX && !this.imgWidth) {
                this.$http.post(__WEBPACK_IMPORTED_MODULE_0__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/image/json/upload?storeId=' + this.curStoreId, { file: this.oldImg }).then(function (res) {
                    _this2.$emit('getCropImgBase', res.data.path);
                    _this2.closeCrop();
                }).catch(function () {
                    _this2.closeCrop();
                });
                return;
            }

            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");

            var img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');
            img.src = this.oldImg;
            img.onload = function () {
                canvas.width = _this2.curCropW;
                canvas.height = _this2.curCropH;
                ctx.drawImage(img, _this2.ratio * _this2.startX, _this2.ratio * _this2.startY, _this2.ratio * _this2.imgWidth, _this2.ratio * _this2.imgHeight, 0, 0, _this2.curCropW, _this2.curCropH);
                _this2.$http.post(__WEBPACK_IMPORTED_MODULE_0__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/image/json/upload?storeId=' + _this2.curStoreId, { file: canvas.toDataURL() }).then(function (res) {
                    _this2.$emit('getCropImgBase', res.data.path);
                    _this2.closeCrop();
                }).catch(function () {
                    _this2.closeCrop();
                });
            };
        },
        // 关闭裁剪框
        closeCrop: function closeCrop() {
            this.$emit('closeImgCrop', false);
        },
        handleJcrop: function handleJcrop() {
            var jcrop_api = void 0,
                boundx = void 0,
                boundy = void 0,
                xsize = this.curCropW,
                ysize = this.curCropH;

            $('#targetImg').Jcrop({
                onChange: updatePreview,
                onSelect: updatePreview,
                aspectRatio: xsize / ysize
            }, function () {
                var bounds = this.getBounds();
                boundx = bounds[0];
                boundy = bounds[1];
            });

            var that = this;
            function updatePreview(c) {
                if (parseInt(c.w) > 0) {
                    var rx = xsize / c.w;
                    var ry = ysize / c.h;
                    that.startX = c.x;
                    that.startY = c.y;
                    that.imgWidth = c.w;
                    that.imgHeight = c.h;
                }
            };
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        var img = new Image();
        img.src = this.oldImg;
        if (img.width / img.height > 4 / 3) {
            $('#targetImg').width(400);
            this.ratio = img.width / 400;
        } else {
            $('#targetImg').height(300);
            this.ratio = img.height / 300;
        }
        setTimeout(function () {
            _this3.handleJcrop();
        }, 500);
    }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'storeData'],
    data: function data() {
        return {
            innerImage: "", //内景照片
            barImage: "", //吧台照片
            bankCardImage: "", //银行卡照片
            curMerId: '', //提交资料id
            coverImgMaxSize: 5 * 1024 * 1024, // 图片最大字节数
            contact: {
                "name": "",
                "nicNumber": "",
                "mobile": "",
                "wechatId": ""
            },
            info: {
                "name": "",
                "abbrName": "",
                "licenseNumber": "",
                "adName": "",
                "addr": "",
                "email": "",
                "customerServiceTele": ""
            },
            card: {
                "accountHolder": "",
                "nicNumber": "",
                "mobile": "",
                "debitCardNumber": "",
                "bankName": "",
                "adName": "",
                "branchBankName": ""
            },
            businessLicenseImage: '', //营业执照
            nicCardUpSideImage: '', //身份证人像面
            nicCardDownSideImage: '', //身份证反面
            nicCardUpSideImageForConcat: "", //联系人身份证正面
            nicCardDownSideImageForConcat: "", //联系人身份证反面
            bankCardDowmImage: "", //银行卡背面
            otherImageOne: "", //其他资料1
            otherImageTwo: "", //其他资料2
            storeImage: '', //传门头照
            willSendData: {},

            showSelectAdd: false, // 显示地址选择框

            provinceList: [],
            cityList: [],
            countryList: [],

            curProvinceIdx: null,
            curCityIdx: null,
            curCountryIdx: null,

            isBankArea: false
        };
    },

    methods: {
        regFn: function regFn() {
            if (!this.contact.name) {
                this.$message({
                    message: '请输入联系人姓名',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.contact.nicNumber) {
                this.$message({
                    message: '请输入身份证号码',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.contact.mobile) {
                this.$message({
                    message: '经营者手机号格式不对',
                    customClass: 'error'
                });
                return true;
            }
            // if(!this.contact.wechatId){
            //     this.$message({
            //         message: '经营者微信号格式不对',
            //         customClass: 'error'
            //     });
            //     return true;
            // }
            // if(!this.contact.wechatId){
            //     this.$message({
            //         message: '经营者微信号格式不对',
            //         customClass: 'error'
            //     });
            //     return true;
            // }
            if (!this.info.name) {
                this.$message({
                    message: '商户名称格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.info.abbrName) {
                this.$message({
                    message: '商户简称格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.info.licenseNumber) {
                this.$message({
                    message: '营业执照注册号格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.info.adName) {
                this.$message({
                    message: '请选择商户省市区',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.info.addr) {
                this.$message({
                    message: '商户详细地址格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.info.email) {
                this.$message({
                    message: '联系邮箱格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.info.customerServiceTele) {
                this.$message({
                    message: '客服电话格式不对',
                    customClass: 'error'
                });
                return true;
            }

            if (!this.card.accountHolder) {
                this.$message({
                    message: '开户人格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.card.nicNumber) {
                this.$message({
                    message: '开户身份证格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.card.mobile) {
                this.$message({
                    message: '预留手机号格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.card.debitCardNumber) {
                this.$message({
                    message: '银行卡号格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.card.bankName) {
                this.$message({
                    message: '开户银行格式不对',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.card.adName) {
                this.$message({
                    message: '请选择开户省市',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.card.branchBankName) {
                this.$message({
                    message: '开户支行格式不对',
                    customClass: 'error'
                });
                return true;
            }

            if (!this.businessLicenseImage) {
                this.$message({
                    message: '请上传营业执照',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.nicCardUpSideImage) {
                this.$message({
                    message: '请上传法人身份证人像面',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.nicCardDownSideImage) {
                this.$message({
                    message: '请上传法人身份证国徽面',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.storeImage) {
                this.$message({
                    message: '请上传门头照',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.innerImage) {
                this.$message({
                    message: '请上传内景照片',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.barImage) {
                this.$message({
                    message: '请上传吧台照片',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.bankCardImage) {
                this.$message({
                    message: '请上传银行卡照片',
                    customClass: 'error'
                });
                return true;
            }
        },

        //商户信息
        merInfo: function merInfo() {
            var _this2 = this;

            this.curMerId = this.curMerId ? this.curMerId : this.$uuid.create(1).hex;
            var body = {
                "storeId": this.curStoreId,
                "businessLicenseImage": this.businessLicenseImage,
                "nicCardUpSideImage": this.nicCardUpSideImage,
                "nicCardDownSideImage": this.nicCardDownSideImage,
                "storeImage": this.storeImage,
                "contact": this.contact,
                "info": this.info,
                "card": this.card,
                "bankCard": this.bankCardImage,
                "innerCard": this.innerImage,
                "barCard": this.barImage,
                "bankCardSide": this.bankCardDowmImage, //跟后端字段名有点出入,这里是银行卡背面信息，非必填
                "oneManagePlace": this.nicCardUpSideImageForConcat, //联系人身份证正面信息,非必填
                "twoManagePlace": this.nicCardDownSideImageForConcat, //联系人身份证反面信息,非必填
                "otherImageOne": this.otherImageOne, //其他资料,非必填
                "otherImageTwo": this.otherImageTwo //其他资料,非必填
            };
            console.log(this.curMerId);
            this.$http.put('/profile', body).then(function (res) {
                _this2.$message({
                    message: '操作成功！',
                    customClass: 'success'
                });
                _this2.getMerInfo();
            });
        },

        //获取商户资料
        getMerInfo: function getMerInfo() {
            var _this3 = this;

            this.$http.get('profile?storeId=' + this.curStoreId).then(function (res) {
                _this3.contact = res.data.contact;
                _this3.info = res.data.info;
                _this3.card = res.data.card;
                _this3.curMerId = res.data.id;
                _this3.businessLicenseImage = res.data.businessLicenseImage;
                _this3.nicCardUpSideImage = res.data.nicCardUpSideImage;
                _this3.nicCardDownSideImage = res.data.nicCardDownSideImage;
                _this3.storeImage = res.data.storeImage;
                _this3.bankCardImage = res.data.bankCard;
                _this3.innerImage = res.data.innerCard;
                _this3.barImage = res.data.barCard;
                // 
                _this3.bankCardDowmImage = res.data.bankCardSide;
                _this3.nicCardUpSideImageForConcat = res.data.oneManagePlace;
                _this3.nicCardDownSideImageForConcat = res.data.twoManagePlace;
                _this3.otherImageOne = res.data.otherImageOne;
                _this3.otherImageTwo = res.data.otherImageTwo;
            }).catch(function (err) {});
        },

        //确定上传资料
        upLoad: function upLoad() {
            var _this4 = this;

            if (this.regFn()) {
                return;
            };
            this.$confirm('确认提交数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this4.merInfo();
            }).catch(function () {});
        },

        //上传照片
        coverImg: function coverImg(e, ind) {
            //ind为区分四张图片
            var reader = new FileReader();
            var that = this;
            var fileObj = e.target.files[0];

            if (e.target.files.length == 0) {
                return false;
            }
            // 判断图片大小
            if (fileObj.size > this.coverImgMaxSize) {
                this.errorMsg = '上传图片的大小不能超过5MB';
                this.openErrorTip = true;
                this.$message({
                    message: '上传图片的大小不能超过5MB',
                    customClass: 'error'
                });
                return false;
            }
            reader.onload = function (file) {
                return function (e) {
                    //         innerImage:"",//内景照片
                    // barImage:"",//吧台照片
                    // bankCardImage:"",//银行卡照片
                    that.$http.post(__WEBPACK_IMPORTED_MODULE_0__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/image/json/upload?storeId=' + this.curStoreId, { file: this.result }).then(function (res) {
                        if (ind == 'businessLicenseImage') {
                            that.businessLicenseImage = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'nicCardUpSideImage') {
                            that.nicCardUpSideImage = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'nicCardDownSideImage') {
                            that.nicCardDownSideImage = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'storeImage') {
                            that.storeImage = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'innerImage') {
                            that.innerImage = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'barImage') {
                            that.barImage = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'bankCardImage') {
                            that.bankCardImage = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'bankCardDowmImage') {
                            that.bankCardDowmImage = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'nicCardUpSideImageForConcat') {
                            that.nicCardUpSideImageForConcat = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'nicCardDownSideImageForConcat') {
                            that.nicCardDownSideImageForConcat = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'otherImageOne') {
                            that.otherImageOne = res.data.path; //获得图片的base64的数据
                        } else if (ind == 'otherImageTwo') {
                            that.otherImageTwo = res.data.path; //获得图片的base64的数据
                        }
                    }).catch(function () {});
                };
            }(e.target.files[0]);
            reader.readAsDataURL(e.target.files[0]);
        },

        // 选择省
        selectProvince: function selectProvince(item, idx) {
            this.curProvinceIdx = idx;
            this.curCityIdx = null;
            this.curCountryIdx = null;
            this.cityList = [];
            this.countryList = [];

            var _this = this;
            $.get("https://restapi.amap.com/v3/config/district?key=ffb08209d403b98295cff1f4309f0652&subdistrict=1&extensions=base&keywords=" + item.adcode, function (result) {
                _this.cityList = result.districts[0].districts;
            });
        },

        // 选择市
        selectCity: function selectCity(item, idx) {
            this.curCityIdx = idx;
            this.curCountryIdx = null;
            this.countryList = [];

            var _this = this;
            $.get("https://restapi.amap.com/v3/config/district?key=ffb08209d403b98295cff1f4309f0652&subdistrict=1&extensions=base&keywords=" + item.adcode, function (result) {
                _this.countryList = result.districts[0].districts;
            });
        },

        // 选择区
        selectCountry: function selectCountry(item, idx) {
            this.curCountryIdx = idx;
        },

        // 确认选择地区 
        saveAdd: function saveAdd() {
            if (!(this.curProvinceIdx >= 0 && this.curCityIdx >= 0 && this.curCountryIdx >= 0)) {
                this.$message({
                    message: '请选择地区',
                    customClass: 'error'
                });
                return;
            }

            if (this.isBankArea) {
                this.card.adName = this.provinceList[this.curProvinceIdx].name + " " + this.cityList[this.curCityIdx].name + " " + this.countryList[this.curCountryIdx].name;
            } else {
                this.info.adName = this.provinceList[this.curProvinceIdx].name + " " + this.cityList[this.curCityIdx].name + " " + this.countryList[this.curCountryIdx].name;
            }

            this.showSelectAdd = false;
            this.curProvinceIdx = null;
            this.curCityIdx = null;
            this.curCountryIdx = null;
            this.cityList = [];
            this.countryList = [];
        }

    },
    created: function created() {
        this.getMerInfo();
        var _this = this;
        $.get("https://restapi.amap.com/v3/config/district?key=ffb08209d403b98295cff1f4309f0652&subdistrict=1&extensions=base", function (result) {
            _this.provinceList = result.districts[0].districts;
        });
    },
    mounted: function mounted() {}
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__urlConfig__ = __webpack_require__(6);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "discountManaEdit",
  props: ["curStoreId"],
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() + 24 * 60 * 60 * 1000 < Date.now();
        }
      },
      isAllWeek: false,
      canClick: true,
      secondInfo: {
        name: "",
        type: "discount",
        discount: "",
        reduceAmount: "",
        timeEnableType: "custom",
        timeForAuto: [],
        timeRange: [],
        week: []
      },
      tableDataForMeal: [],
      nowPage: 1,
      setMealIds: [],
      size: 1000,
      searchVal: "",
      curSelType: null,
      formInline: {
        user: "",
        region: ""
      },
      levelsList: [], //会员等级列表
      disCoutFirst: [{
        id: 0,
        name: "暂无"
      }, {
        id: 1,
        name: "会员"
      }, {
        id: 2,
        name: "时间段"
      }],
      labelPosition: "right",
      newDiscount: {
        name: "",
        region: "",
        type: "",
        week: [],
        nowHours: "",
        tomorrowHour: "",
        discountMethod: ""
      },
      weeks: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"],
      options: [],
      modifyDiscountItem: {},
      tableData: [{
        date: "2016-05-03",
        name: "王小虎",
        address: "上海市普陀区金沙江路 1518 弄"
      }],
      types: [],
      nowSelClassGoods: [],
      multipleSelection: [],
      totalPage: 0,
      totalElements: 0
    };
  },

  watch: {
    "secondInfo.week": function secondInfoWeek(val) {
      if (val.length < this.weeks.length) {
        this.isAllWeek = false;
      } else if (val.length == this.weeks.length) {
        this.isAllWeek = true;
      }
    },
    curSelType: function curSelType(val) {
      this.nowPage = 1;
      this.getGoods(this.nowPage - 1);
      this.isSearch = false;
    },
    searchVal: function searchVal(val) {
      if (val == "") {
        // this.isSearch = false;
        return;
      }
      //   this.searchGoods();
    }
  },
  methods: {
    handleChangeWeeksAll: function handleChangeWeeksAll(val) {
      console.log();
      if (this.isAllWeek) {
        this.secondInfo.week = this.weeks;
      } else {
        this.secondInfo.week = [];
      }
    },
    checkInfo: function checkInfo() {
      if (String(this.secondInfo.name).trim() == "") {
        this.$message({
          message: "请填写名称",
          customClass: "error"
        });
        $(".el-message").css({
          top: "50%"
        });
        return true;
      }
      if (this.secondInfo.type == "reduce") {
        if (this.secondInfo.reduceAmount == "") {
          this.$message({
            message: "请填写金额",
            customClass: "error"
          });
          $(".el-message").css({
            top: "50%"
          });
          return true;
        }
        if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.secondInfo.reduceAmount)) {
          this.$message({
            message: "价格格式有误",
            customClass: "error"
          });
          $(".el-message").css({
            top: "50%"
          });
          return true;
        }
      }

      if (this.secondInfo.type == "discount") {
        if (!/^0|[1-9][0-9]*$/.test(this.secondInfo.discount)) {
          this.$message({
            message: "请正确填写折扣",
            customClass: "error"
          });
          $(".el-message").css({
            top: "50%"
          });
          return true;
        }
      }
      if (this.secondInfo.timeEnableType == "custom") {
        if (this.secondInfo.timeForAuto.length == 0) {
          this.$message({
            message: "请选择时间",
            customClass: "error"
          });
          $(".el-message").css({
            top: "50%"
          });
          return true;
        }
      }
      if (this.secondInfo.timeRange.length == 0) {
        this.$message({
          message: "请选择时间范围",
          customClass: "error"
        });
        $(".el-message").css({
          top: "50%"
        });
        return true;
      }
      if (this.secondInfo.week.length == 0) {
        this.$message({
          message: "请选择星期",
          customClass: "error"
        });
        $(".el-message").css({
          top: "50%"
        });
        return true;
      }
      return false;
    },
    submit: function submit() {
      var _this = this;

      if (this.checkInfo()) {
        return;
      }
      console.log(this.secondInfo);
      var data = {
        name: this.secondInfo.name,
        storeId: this.curStoreId,
        discountType: this.secondInfo.type,
        timeType: this.secondInfo.timeEnableType,
        week: this.secondInfo.week.join()
      };
      var products = [];
      console.log(this.$refs.multipleTable.selection);
      for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
        if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.$refs.multipleTable.selection[i].discountCommission)) {
          this.$message({
            message: "提成格式有误",
            customClass: "error"
          });
          return true;
        }
        var obj = {
          productId: this.$refs.multipleTable.selection[i].id,
          discountCommission: this.$refs.multipleTable.selection[i].discountCommission * 100
        };
        products.push(obj);
      }
      if (!products.length) {
        this.$message({
          message: "请选择商品",
          customClass: "error"
        });
        return;
      }
      data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(data, {
        products: products
      });
      if (this.secondInfo.type == "discount") {
        data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(data, {
          discount: this.secondInfo.discount * 10
        });
      } else if (this.secondInfo.type == "reduce") {
        data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(data, {
          reduceAmount: this.secondInfo.reduceAmount * 100
        });
      }

      if (this.secondInfo.timeEnableType == "custom") {
        console.log(new Date(this.secondInfo.timeRange[0]).getTime());
        console.log(new Date().getTime());
        // if (
        //   new Date(this.secondInfo.timeRange[0]).getTime() <
        //   new Date().getTime()
        // ) {
        //   this.$message({
        //     message: "开始时间不能小于当前时间",
        //     customClass: "error",
        //   });
        //   return;
        // }
        data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(data, {
          begin: new Date(this.secondInfo.timeForAuto[0]).Format("yyyy-MM-dd") + " 00:00:00",
          end: new Date(this.secondInfo.timeForAuto[1]).Format("yyyy-MM-dd") + " 23:59:59",
          beginHour: new Date(this.secondInfo.timeRange[0]).Format("hh:mm:ss"),
          endHour: new Date(this.secondInfo.timeRange[1]).Format("hh:mm:ss")
        });
      } else if (this.secondInfo.timeEnableType == "forever") {
        data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(data, {
          beginHour: new Date(this.secondInfo.timeRange[0]).Format("hh:mm:ss"),
          endHour: new Date(this.secondInfo.timeRange[1]).Format("hh:mm:ss")
        });
      }

      if (!this.canClick) {
        return;
      }
      this.canClick = false;
      this.$http({
        url: "dp/add",
        method: "POST",
        data: data
      }).then(function (res) {
        _this.$message({
          message: "操作成功",
          customClass: "success"
        });
        _this.secondInfo = {
          name: "",
          type: "discount",
          discount: "",
          reduceAmount: "",
          timeEnableType: "custom",
          timeForAuto: [],
          timeRange: [],
          week: []
        };
        _this.$refs.multipleTable.clearSelection();
        console.log(_this.$route.name);
        if (JSON.parse(sessionStorage.getItem("tabNames"))) {
          var tabNamesList = JSON.parse(sessionStorage.getItem("tabNames"));
          tabNamesList.forEach(function (item, index) {
            if (item.name == _this.$route.name) {
              console.log(item);
              tabNamesList.splice(index, 1);
            }
          });
          sessionStorage.setItem("tabNames", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(tabNamesList));
        }
        _this.$router.push({
          name: "second"
        });
        // location.reload()
        setTimeout(function () {
          _this.canClick = true;
        }, 1000);
      }).catch(function (err) {
        setTimeout(function () {
          _this.canClick = true;
        }, 1000);
      });
    },
    getRowKeys: function getRowKeys(row) {
      return row.productId;
    },

    // 新增优惠方式
    check: function check() {
      //正则验证方法
      if (!this.newDiscount.name) {
        this.$message({
          message: "请输入优惠名称",
          customClass: "error"
        });
        return true;
      }
      if (this.newDiscount.discountEnabled) {
        if (this.newDiscount.discountJudgeMethod == 0) {
          this.$message({
            message: "请选择折扣方式，选择会员需确保当前商品有会员折扣",
            customClass: "error"
          });
          return true;
        }
        if (this.newDiscount.discountJudgeMethod == 1 && this.newDiscount.discountMethod == 3) {
          this.$message({
            message: "当前商品没有设置会员折扣",
            customClass: "error"
          });
          return true;
        }
        if (!this.newDiscount.disPrice) {
          this.$message({
            message: "请输入折扣百分比",
            customClass: "error"
          });
          return true;
        }
        if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newDiscount.disPrice)) {
          this.$message({
            message: "折扣格式有误",
            customClass: "error"
          });
          return true;
        }
        if (!this.newDiscount.nowHours || !this.newDiscount.tomorrowHour) {
          this.$message({
            message: "折扣时间有误",
            customClass: "error"
          });
          return true;
        }
        if (this.newDiscount.nowHours == "aN:aN:aN" || this.newDiscount.tomorrowHour == "aN:aN:aN") {
          this.$message({
            message: "折扣时间有误",
            customClass: "error"
          });
          return true;
        }
        if (new Date(this.newDiscount.nowHours).getTime() > new Date(this.newDiscount.tomorrowHour).getTime()) {
          this.$message({
            message: "折扣起始时间应小于截止时间",
            customClass: "error"
          });
          return true;
        }

        if (this.newDiscount.week == "") {
          this.$message({
            message: "请选择星期",
            customClass: "error"
          });
          return true;
        }
      }

      // if (this.multipleSelection.length == 0) {
      //   this.$message({
      //     message: "请选择商品",
      //     customClass: "error",
      //   });
      //   return true;
      // }
      if (this.newDiscount.discountMethod == 2) {
        for (var i = 0; i < this.levelsList.length; i++) {
          if (this.levelsList[i].nowSetPrice != "") {
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.levelsList[i].nowSetPrice)) {
              this.$message({
                message: "会员另设折扣格式错误",
                customClass: "error"
              });
              return true;
            }
          } else {
            this.$message({
              message: "请填写会员价格",
              customClass: "error"
            });
            return true;
          }
        }
      }
      if (!this.newDiscount.discountEnabled && this.newDiscount.discountMethod == 3) {
        this.$message({
          message: "请选择折扣方式",
          customClass: "error"
        });
        return true;
      }
      return false;
    },
    save: function save() {
      var _this2 = this;

      if (this.check()) {
        return;
      }
      var productIds = [];
      var setMealIds = [];
      // for (let i = 0; i < this.proIds.length; i++) {
      //   if (this.proIds[i].productId) {
      //     productIds.push(this.proIds[i].productId);
      //   }
      // }

      console.log("seled", this.nowSelClassGoods);
      // return;
      for (var i = 0; i < this.nowSelClassGoods.length; i++) {
        if (this.nowSelClassGoods[i].productId) {
          if (this.nowSelClassGoods[i].setMealId == 0) {
            productIds.push(this.nowSelClassGoods[i].productId);
          }
        }
        if (this.nowSelClassGoods[i].setMealId != 0 && this.nowSelClassGoods[i].setMealId) {
          setMealIds.push(this.nowSelClassGoods[i].setMealId);
        }
      }

      var otherPrices = [];
      for (var _i = 0; _i < this.levelsList.length; _i++) {
        if (this.levelsList[_i].nowSetPrice != "") {
          var obj = {
            levelName: this.levelsList[_i].name,
            levelId: this.levelsList[_i].id,
            price: (Number(this.levelsList[_i].nowSetPrice) / 100).toFixed(2)
          };
          otherPrices.push(obj);
        }
      }
      this.newDiscount.productIds = productIds;
      this.newDiscount.prices = otherPrices;
      this.$http({
        url: "group-update",
        method: "POST",
        data: {
          groupId: this.newDiscount.groupId,
          storeId: this.curStoreId,
          name: this.newDiscount.name,
          discountMethod: this.newDiscount.discountMethod,
          prices: this.newDiscount.discountMethod == 2 ? otherPrices : null,
          discountEnabled: this.newDiscount.discountEnabled,
          week: this.newDiscount.week.join(),
          discountJudgeMethod: this.newDiscount.discountJudgeMethod,
          nowHours: this.newDiscount.discountEnabled ? new Date(this.newDiscount.nowHours).Format("hh:mm:ss") : "",
          tomorrowHour: this.newDiscount.discountEnabled ? new Date(this.newDiscount.tomorrowHour).Format("hh:mm:ss") : "",
          disPrice: this.newDiscount.disPrice,
          productIds: productIds,
          setMealIds: setMealIds
        }
      }).then(function (res) {
        if (res.data.code == 200) {
          _this2.$message({
            message: res.data.msg,
            customClass: "success"
          });
          // this.getGoods(0);
          var modifyDiscountItem = JSON.parse(sessionStorage.getItem("modifyDiscountItem"));
          modifyDiscountItem.goods = _this2.nowSelClassGoods;
          sessionStorage.setItem("modifyDiscountItem", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(modifyDiscountItem));
          // if (this.$route.query.type == "add") {
          //   this.$router.back(-1);
          // } else {
          //   window.location.reload(true);
          // }
          // this.$router.back(-1);
        } else if (res.data.code == 400) {
          _this2.$message({
            message: res.data.msg,
            customClass: "error"
          });
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.nowPage = val;
      if (this.isSearch) {
        this.searchGoods(this.nowPage - 1);
      } else {
        this.getGoods(this.nowPage - 1);
      }
    },

    // 商品检索
    searchGoods: function searchGoods() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var typeId = this.curSelType ? this.curSelType : "";
      this.nowPage = page;
      this.isSearch = true;
      this.$http({
        url: "products/search",
        params: {
          storeId: this.curStoreId,
          q: this.searchVal,
          typeId: "",
          page: this.nowPage - 1,
          size: 1000
        }
      }).then(function (res) {
        var goodsList = res.data.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].isChecked = false;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }
        var newGoodsData = [];
        for (var j = 0; j < goodsList.length; j++) {
          var obj = {
            price: goodsList[j].price,
            productId: goodsList[j].productId,
            productName: goodsList[j].productName,
            setMealEnabled: goodsList[j].setMealEnabled,
            setMealId: goodsList[j].setMealId,
            typeId: goodsList[j].typeId,
            typeName: goodsList[j].typeName,
            isChecked: goodsList[j].isChecked
          };
          newGoodsData.push(obj);
        }
        _this3.tableData = newGoodsData;
        _this3.totalPage = res.data.totalPage;
        _this3.totalElements = res.data.totalElements;
        _this3.canChangePage = true;
        setTimeout(function () {
          if (_this3.$route.query.type == "edit") {
            _this3.filterData();
          }
        }, 250);
      });
    },
    getLevels: function getLevels() {
      var _this4 = this;

      this.$http({
        url: "level-list",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
          var data, i, item, _i2, j;

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  data = res.data;

                  for (i = 0; i < data.length; i++) {
                    data[i].nowSetPrice = "";
                  }
                  _this4.levelsList = data;
                  if (_this4.$route.query.type == "edit") {
                    item = JSON.parse(sessionStorage.getItem("modifyDiscountItem"));

                    if (item.prices.length > 0) {
                      for (_i2 = 0; _i2 < item.prices.length; _i2++) {
                        for (j = 0; j < data.length; j++) {
                          if (item.prices[_i2].levelId == data[j].id) {
                            data[j].nowSetPrice = Number(item.prices[_i2].price) * 100;
                          }
                        }
                      }
                    }
                    _this4.levelsList = data;
                  }
                  _context.next = 6;
                  return _this4.getGoods(0);

                case 6:
                  _context.next = 8;
                  return _this4.getType();

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleChangeWeeks: function handleChangeWeeks(value) {
      this.newDiscount.week = value;
    },
    toggleSelectionAll: function toggleSelectionAll(rows) {
      var _this5 = this;

      console.log(rows);
      for (var i = 0; i < this.tableData.length; i++) {
        this.tableData[i].isChecked = false;
      }
      rows.forEach(function (item) {
        for (var _i3 = 0; _i3 < _this5.tableData.length; _i3++) {
          if (item.productId == _this5.tableData[_i3].productId) {
            _this5.tableData[_i3].isChecked = true;
          }
        }
      });
      var nowSelClassGoods = this.nowSelClassGoods;
      var nowSelIds = [];
      nowSelClassGoods.forEach(function (item) {
        nowSelIds.push(item.productId);
      });
      console.log(nowSelClassGoods);
      if (rows.length) {
        for (var _i4 = 0; _i4 < this.tableData.length; _i4++) {
          var flag = false;
          var index = void 0;
          console.log(this.tableData[_i4]);
          if (this.tableData[_i4].isChecked) {
            if (nowSelIds.indexOf(this.tableData[_i4].productId) == -1) {
              nowSelClassGoods.push(this.tableData[_i4]);
            }
          } else {
            if (nowSelIds.indexOf(this.tableData[_i4].productId) != -1) {
              for (var j = 0; j < nowSelClassGoods.length; j++) {
                if (nowSelClassGoods[j].productId == this.tableData[_i4].productId) {
                  flag = true;
                  index = j;
                }
              }
              if (flag) {
                nowSelClassGoods.splice(index, 1);
              }
            }
          }
        }
      } else {
        for (var _i5 = 0; _i5 < this.tableData.length; _i5++) {
          var _flag = false;
          var _index = void 0;
          this.tableData[_i5].isChecked = false;
          if (nowSelIds.indexOf(this.tableData[_i5].productId) != -1) {
            for (var _j = 0; _j < nowSelClassGoods.length; _j++) {
              if (nowSelClassGoods[_j].productId == this.tableData[_i5].productId) {
                _flag = true;
                _index = _j;
              }
            }
            if (_flag) {
              nowSelClassGoods.splice(_index, 1);
            }
          }
        }
      }
      console.log(nowSelClassGoods);
      this.nowSelClassGoods = nowSelClassGoods;
    },
    toggleSelectionAllForMeals: function toggleSelectionAllForMeals(rows) {
      var _this6 = this;

      console.log(rows);
      for (var i = 0; i < this.tableDataForMeal.length; i++) {
        this.tableDataForMeal[i].isChecked = false;
      }
      rows.forEach(function (item) {
        for (var _i6 = 0; _i6 < _this6.tableDataForMeal.length; _i6++) {
          if (item.productId == _this6.tableDataForMeal[_i6].productId) {
            _this6.tableDataForMeal[_i6].isChecked = true;
          }
        }
      });
      var nowSelClassGoods = this.nowSelClassGoods;
      var nowSelIds = [];
      nowSelClassGoods.forEach(function (item) {
        nowSelIds.push(item.productId);
      });
      console.log(nowSelClassGoods);
      if (rows.length) {
        for (var _i7 = 0; _i7 < this.tableDataForMeal.length; _i7++) {
          var flag = false;
          var index = void 0;
          console.log(this.tableDataForMeal[_i7]);
          if (this.tableDataForMeal[_i7].isChecked) {
            if (nowSelIds.indexOf(this.tableDataForMeal[_i7].productId) == -1) {
              nowSelClassGoods.push(this.tableDataForMeal[_i7]);
            }
          } else {
            if (nowSelIds.indexOf(this.tableDataForMeal[_i7].productId) != -1) {
              for (var j = 0; j < nowSelClassGoods.length; j++) {
                if (nowSelClassGoods[j].productId == this.tableDataForMeal[_i7].productId) {
                  flag = true;
                  index = j;
                }
              }
              if (flag) {
                nowSelClassGoods.splice(index, 1);
              }
            }
          }
        }
      } else {
        for (var _i8 = 0; _i8 < this.tableDataForMeal.length; _i8++) {
          var _flag2 = false;
          var _index2 = void 0;
          this.tableDataForMeal[_i8].isChecked = false;
          if (nowSelIds.indexOf(this.tableDataForMeal[_i8].productId) != -1) {
            for (var _j2 = 0; _j2 < nowSelClassGoods.length; _j2++) {
              if (nowSelClassGoods[_j2].productId == this.tableDataForMeal[_i8].productId) {
                _flag2 = true;
                _index2 = _j2;
              }
            }
            if (_flag2) {
              nowSelClassGoods.splice(_index2, 1);
            }
          }
        }
      }
      console.log(nowSelClassGoods);
      this.nowSelClassGoods = nowSelClassGoods;
    },
    toggleSelection: function toggleSelection(selection, rows) {
      var _this7 = this;

      rows.isChecked = !rows.isChecked;
      console.log(rows);
      console.log(selection);
      var nowSelClassGoods = this.nowSelClassGoods;
      var flag = false;
      var index = -1;
      for (var i = 0; i < nowSelClassGoods.length; i++) {
        if (nowSelClassGoods[i].productId == rows.productId) {
          flag = true;
          index = i;
        }
      }
      if (flag) {
        nowSelClassGoods.splice(index, 1);
      } else {
        nowSelClassGoods.push(rows);
      }
      this.nowSelClassGoods = nowSelClassGoods;
      selection.forEach(function (item) {
        if (item.isChecked) {
          _this7.$refs.multipleTable.toggleRowSelection(item, true);
          var _flag3 = false;
          var _index3 = -1;
          for (var _i9 = 0; _i9 < nowSelClassGoods.length; _i9++) {
            if (nowSelClassGoods[_i9].productId == item.productId) {
              _flag3 = true;
              _index3 = _i9;
            }
          }
          if (!_flag3) {
            nowSelClassGoods.push(item);
          }
          _this7.nowSelClassGoods = nowSelClassGoods;
        } else {
          _this7.$refs.multipleTable.toggleRowSelection(item, false);
          var _flag4 = false;
          var _index4 = -1;
          for (var _i10 = 0; _i10 < nowSelClassGoods.length; _i10++) {
            if (nowSelClassGoods[_i10].productId == item.productId) {
              _flag4 = true;
              _index4 = _i10;
            }
          }
          if (_flag4) {
            nowSelClassGoods.splice(_index4, 1);
          }
          _this7.nowSelClassGoods = nowSelClassGoods;
        }
      });
    },
    toggleSelectionForMeals: function toggleSelectionForMeals(selection, rows) {
      var _this8 = this;

      rows.isChecked = !rows.isChecked;
      console.log(rows);
      console.log(selection);
      var nowSelClassGoods = this.nowSelClassGoods;
      var flag = false;
      var index = -1;
      for (var i = 0; i < nowSelClassGoods.length; i++) {
        if (nowSelClassGoods[i].productId == rows.productId) {
          flag = true;
          index = i;
        }
      }
      if (flag) {
        nowSelClassGoods.splice(index, 1);
      } else {
        nowSelClassGoods.push(rows);
      }
      this.nowSelClassGoods = nowSelClassGoods;
      // console.log(nowSelClassGoods)
      selection.forEach(function (item) {
        if (item.isChecked) {
          _this8.$refs.multipleTableForMeals.toggleRowSelection(item, true);
          var _flag5 = false;
          var _index5 = -1;
          for (var _i11 = 0; _i11 < nowSelClassGoods.length; _i11++) {
            if (nowSelClassGoods[_i11].productId == item.productId) {
              _flag5 = true;
              _index5 = _i11;
            }
          }
          if (!_flag5) {
            nowSelClassGoods.push(item);
          }
          _this8.nowSelClassGoods = nowSelClassGoods;
        } else {
          _this8.$refs.multipleTableForMeals.toggleRowSelection(item, false);
          var _flag6 = false;
          var _index6 = -1;
          for (var _i12 = 0; _i12 < nowSelClassGoods.length; _i12++) {
            if (nowSelClassGoods[_i12].productId == item.productId) {
              _flag6 = true;
              _index6 = _i12;
            }
          }
          if (_flag6) {
            nowSelClassGoods.splice(_index6, 1);
          }
          _this8.nowSelClassGoods = nowSelClassGoods;
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    filterData: function filterData() {
      var _this9 = this;

      var arr = [];
      for (var j = 0; j < this.nowSelClassGoods.length; j++) {
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].productId == this.nowSelClassGoods[j].productId) {
            this.tableData[i].isChecked = true;
            arr.push(this.tableData[i]);
          }
        }
      }
      arr.forEach(function (item) {
        _this9.$refs.multipleTable.toggleRowSelection(item, true);
      });
    },
    filterDataForMeals: function filterDataForMeals() {
      var _this10 = this;

      var item = JSON.parse(sessionStorage.getItem("modifyDiscountItem"));
      var nowSelClassGoods = [];
      // let proIds = [];
      // let setMealIds = [];
      for (var i = 0; i < item.goods.length; i++) {
        nowSelClassGoods.push({
          price: item.goods[i].price,
          productId: item.goods[i].setMealEnabled ? item.goods[i].setMealId : item.goods[i].productId,
          productName: item.goods[i].productName,
          typeId: item.goods[i].typeId,
          typeName: item.goods[i].typeName,
          setMealEnabled: item.goods[i].setMealEnabled,
          setMealId: item.goods[i].setMealId,
          isChecked: true
        });
      }
      this.nowSelClassGoods = nowSelClassGoods;
      var arr = [];
      for (var j = 0; j < this.nowSelClassGoods.length; j++) {
        for (var _i13 = 0; _i13 < this.tableDataForMeal.length; _i13++) {
          if (this.tableDataForMeal[_i13].productId == this.nowSelClassGoods[j].productId) {
            this.tableDataForMeal[_i13].isChecked = true;
            arr.push(this.tableDataForMeal[_i13]);
          }
        }
      }
      arr.forEach(function (item) {
        _this10.$refs.multipleTableForMeals.toggleRowSelection(item, true);
      });
    },
    initInfo: function initInfo() {
      var _this11 = this;

      var item = JSON.parse(sessionStorage.getItem("modifyDiscountItem"));
      var nowSelClassGoods = [];
      // let proIds = [];
      // let setMealIds = [];
      for (var i = 0; i < item.goods.length; i++) {
        nowSelClassGoods.push({
          price: item.goods[i].price,
          productId: item.goods[i].setMealEnabled ? item.goods[i].setMealId : item.goods[i].productId,
          productName: item.goods[i].productName,
          typeId: item.goods[i].typeId,
          typeName: item.goods[i].typeName,
          setMealEnabled: item.goods[i].setMealEnabled,
          setMealId: item.goods[i].setMealId,
          isChecked: true
        });
      }
      this.nowSelClassGoods = nowSelClassGoods;
      console.log(nowSelClassGoods);
      this.newDiscount = {
        groupId: item.id,
        name: item.name,
        beginTime: "",
        endTime: "",
        discountMethod: item.discountMethod,
        prices: null,
        discountEnabled: item.discountEnabled,
        week: item.week.split(","),
        discountJudgeMethod: item.discountJudgeMethod,
        nowHours: item.nowHours ? new Date("2018-11-11 " + item.nowHours) : "",
        tomorrowHour: item.tomorrowHour ? new Date("2018-11-11 " + item.tomorrowHour) : "",
        disPrice: item.disPrice //折扣百分比
        // productIds: productIds, //用户选择的商品id
      };
      var arr = [];
      for (var j = 0; j < nowSelClassGoods.length; j++) {
        for (var _i14 = 0; _i14 < this.tableData.length; _i14++) {
          if (this.tableData[_i14].productId == nowSelClassGoods[j].productId) {
            arr.push(this.tableData[_i14]);
          }
        }
      }

      arr.forEach(function (item) {
        _this11.$refs.multipleTable.toggleRowSelection(item, true);
      });
    },

    // 获取商品
    getGoods: function getGoods(page) {
      var _this12 = this;

      this.$http({
        url: "/get-ps",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        var goodsList = res.data;
        _this12.tableData = goodsList;
        _this12.totalPage = res.data.totalPage;
        _this12.totalElements = res.data.totalElements;
        _this12.canChangePage = true;
        setTimeout(function () {
          if (_this12.$route.query.type == "edit") {
            _this12.filterData();
          }
        }, 250);
      });
    },
    getMeals: function getMeals(typeId) {
      var _this13 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this13.$http({
          url: "/meal/get-all-ps",
          method: "GET",
          params: {
            storeId: _this13.curStoreId,
            page: 0,
            size: _this13.size,
            typeId: typeId
          }
        }).then(function (res) {
          var goodsList = res.data.data;
          var newGoodsData = [];
          for (var i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            goodsList[i].isChecked = false;
            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          for (var j = 0; j < goodsList.length; j++) {
            var obj = {
              price: goodsList[j].price,
              productId: goodsList[j].productId,
              productName: goodsList[j].productName,
              setMealEnabled: goodsList[j].setMealEnabled,
              setMealId: goodsList[j].setMealId,
              typeId: goodsList[j].typeId,
              typeName: goodsList[j].typeName,
              isChecked: goodsList[j].isChecked
            };
            newGoodsData.push(obj);
          }
          resolve(newGoodsData);
          // this.tableDataForMeal = newGoodsData;
        });
      });
    },

    // 获取商品分类
    getType: function getType() {
      var _this14 = this;

      this.$http({
        url: "get-type",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
          var funArr, i, fun;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this14.types = res.data;
                  funArr = [];

                  for (i = 0; i < res.data.length; i++) {
                    if (res.data[i].setMealEnabled) {
                      fun = _this14.getMeals(res.data[i].id);

                      funArr.push(fun);
                    }
                  }
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(funArr).then(function (res) {
                    console.log(res);
                    var mealsArr = [];
                    for (var _i15 = 0; _i15 < res.length; _i15++) {
                      mealsArr = mealsArr.concat(res[_i15]);
                    }
                    console.log(mealsArr);
                    _this14.tableDataForMeal = mealsArr;
                    setTimeout(function () {
                      if (_this14.$route.query.type == "edit") {
                        _this14.filterDataForMeals();
                      }
                    }, 250);
                  }).catch(function (error) {
                    console.log(error);
                  });

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this14);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  },
  activated: function activated() {
    this.$refs.multipleTable.clearSelection();
    this.nowPage = 1;
    this.getGoods();
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    components: { cartInfo: __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo___default.a },
    data: function data() {
        return {
            secondInfo: {},
            showCartInfo: false,
            totalElements: 0,
            typeOptions: {
                "discount": "折扣",
                "reduce": "减免金额"
            },
            nowPage: 1,
            pageSize: 10,
            nowSelType: "ing", //over结束，//cancel取消,ing进行中
            dataList: [], // 岗位列表
            timeName: '',
            curJobId: '', // 时段id
            addJobVisible: false, // 控制新增弹框显示隐藏
            addJobApiBtn: true, // 控制新增岗位接口
            time: {
                beginHour: '',
                beginMinute: '',
                endHour: '',
                endMinute: ''
            }
        };
    },

    watch: {
        nowSelType: function nowSelType(val) {
            this.getList();
        },
        nowPage: function nowPage(val) {
            this.getList();
        }
    },
    methods: {
        closeCartInfo: function closeCartInfo() {
            this.showCartInfo = false;
            this.getList();
        },
        detail: function detail(item) {
            var _this = this;

            this.$http({
                url: "dp/detail",
                method: "GET",
                params: {
                    id: item.id
                }
            }).then(function (res) {
                _this.secondInfo = res.data;
                _this.showCartInfo = true;
            });
        },
        getGoodsInfo: function getGoodsInfo(item) {
            this.$http({
                url: "dp/product/list",
                method: "GET",
                params: {
                    promotionId: item.id,
                    page: this.nowPage,
                    size: this.pageSize
                }
            }).then(function (res) {});
        },

        //分页方法
        handleCurrentChange: function handleCurrentChange(val) {
            console.log('\u5F53\u524D\u9875: ' + val);
            this.nowPage = val;
        },
        formatTimeRange: function formatTimeRange(item) {
            if (item.beginHour && item.endHour) {
                return item.beginHour + '\u81F3' + item.endHour;
            } else {
                return '';
            }
        },
        formatTime: function formatTime(item) {
            if (item.timeType == "forever") {
                return '永久有效';
            } else if (item.timeType == "custom") {
                return new Date(item.beginTime).Format("yyyy-MM-dd") + '\u81F3' + new Date(item.endTime).Format("yyyy-MM-dd");
            }
        },
        formatDiscount: function formatDiscount(item) {
            if (item.discountType == "discount") {
                return item.discount / 10 + '\u6298';
            } else if (item.discountType == "reduce") {
                return item.reduceAmount / 100 + '\u5143';
            }
        },
        modifySecond: function modifySecond() {
            this.$router.push({
                path: '/sys/' + this.curStoreId + '/modifySecond'
            });
        },

        // 获取岗位列表
        getList: function getList() {
            var _this2 = this;

            this.$http({
                url: "dp/list",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    type: this.nowSelType,
                    page: this.nowPage - 1,
                    size: this.pageSize
                }
            }).then(function (res) {
                _this2.dataList = res.data.content;
                _this2.totalElements = res.data.totalElements;
                var number = _this2.pageSize - _this2.dataList.length;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this2.dataList.push({
                            name: ''
                        });
                    }
                }
            });
            // this.$http.get('/product-supply-time?storeId='+this.curStoreId).then((res)=>{
            //     this.dataList = res.data;
            //     for (let i = 0; i <  this.dataList.length; i++) {
            //         if(this.dataList[i].id){
            //             this.dataList[i].time = (this.dataList[i].beginHour<10?'0'+this.dataList[i].beginHour:this.dataList[i].beginHour)+':'
            //             +(this.dataList[i].beginMinute<10?'0'+this.dataList[i].beginMinute:this.dataList[i].beginMinute)+'~'
            //             +(this.dataList[i].endHour<10?'0'+this.dataList[i].endHour:this.dataList[i].endHour)+':'
            //             +(this.dataList[i].endMinute<10?'0'+this.dataList[i].endMinute:this.dataList[i].endMinute)
            //         }
            //     }
            //     let number = this.pageSize - this.dataList.length;
            //     if ( number > 0 ) {
            //         for (let i = 0; i < number; i++) {
            //             this.dataList.push({
            //                 name:''
            //             });
            //         }
            //     }
            // }).catch((err)=>{

            // })
        },
        // 新增, 更新岗位
        addJob: function addJob() {
            var _this3 = this;

            if (!this.timeName) {
                this.$message({
                    message: '请输入时段名',
                    customClass: 'error'
                });
                return;
            }
            if (this.time.beginHour.length > 2 || parseInt(this.time.beginHour) > 23 || !/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.beginHour))) {
                this.$message({
                    message: '开始小时数设置有误',
                    customClass: 'error'
                });
                return;
            }
            if (this.time.beginMinute.length > 2 || !/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.beginMinute)) || parseInt(this.time.beginMinute) > 59) {
                this.$message({
                    message: '开始分钟数设置有误',
                    customClass: 'error'
                });
                return;
            }
            if (this.time.endHour.length > 2 || !/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.endHour)) || parseInt(this.time.endHour) > 23) {
                this.$message({
                    message: '结束小时数设置有误',
                    customClass: 'error'
                });
                return;
            }
            if (this.time.endMinute.length > 2 || !/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.endMinute)) || parseInt(this.time.endMinute) > 59) {
                this.$message({
                    message: '结束分钟数设置有误',
                    customClass: 'error'
                });
                return;
            }
            if (!this.addJobApiBtn) {
                return;
            }
            this.addJobApiBtn = false;
            var body = {
                id: this.curJobId ? this.curJobId : this.$uuid.create(1).hex,
                storeId: this.curStoreId,
                name: this.timeName,
                beginHour: parseInt(this.time.beginHour),
                beginMinute: parseInt(this.time.beginMinute),
                endHour: parseInt(this.time.endHour),
                endMinute: parseInt(this.time.endMinute)
            };
            this.$http.post('/product-supply-time', body).then(function (res) {
                _this3.addJobVisible = false;
                _this3.addJobApiBtn = true;
                _this3.getList();
                _this3.$message({
                    message: '操作成功',
                    customClass: 'success'
                });
            }).catch(function (err) {
                _this3.addJobApiBtn = true;
            });
        },
        // 删除岗位
        delJob: function delJob(jobId) {
            var _this4 = this;

            this.$confirm('此操作将删除该时段, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除岗位
                _this4.$http.delete('/product-supply-time?id=' + jobId).then(function (res) {
                    _this4.$message({
                        message: '删除成功',
                        customClass: 'success'
                    });
                    _this4.getList();
                }).catch(function (err) {});
            }).catch(function () {});
        },
        // 获得当前岗位信息
        getCurJob: function getCurJob(item) {
            this.curJobId = item.id;
            this.timeName = item.name;
            this.time = {
                beginHour: item.beginHour,
                beginMinute: item.beginMinute,
                endHour: item.endHour,
                endMinute: item.endMinute
            };
            this.addJobVisible = true;
        },
        // 清除信息
        clear: function clear() {
            this.timeName = '';
            this.time = {
                beginHour: '',
                beginMinute: '',
                endHour: '',
                endMinute: ''
            };
            this.checkedCities = [];
            this.curJobId = '';
            this.addJobVisible = true;
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.dataList.push({
                name: ''
            });
        }
    },
    activated: function activated() {
        this.getList();
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {};
    },
    mounted: function mounted() {}
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["curStoreId", "pageSize"],
  data: function data() {
    return {
      allAmount: 0, //总金额
      allQty: 0, //总数量
      withdrawData: [],
      getBtn: true, // 控制翻页请求
      size: 10,
      totalElements: 0
    };
  },

  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.getWithdrawData(this.curStoreId, val - 1);
    },
    getWithdrawData: function getWithdrawData(storeId, page) {
      var _this = this;

      this.$http({
        url: "get-withdraw",
        method: "GET",
        params: {
          storeId: storeId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        console.log(res);
        if (res.status == 200) {
          _this.withdrawData = res.data.content;
          _this.totalElements = res.data.totalElements;
        }
      });
    }
  },
  activated: function activated() {
    this.getWithdrawData(this.curStoreId, 0);
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["curStoreId", "pageSize"],
  data: function data() {
    return {
      allAmount: 0, //总金额
      allQty: 0, //总数量
      withdrawData: [],
      getBtn: true, // 控制翻页请求
      size: 10,
      totalElements: 0,
      data: {
        amount: 0
      },
      canClick: true,
      amount: 0,
      isShowCodeTip: false, // 是否显示验证嘛提示
      isGetCode: false, // 是否获取验证码
      time: 60,
      phone: "", // 手机号
      code: "", // 验证码
      info: []
    };
  },

  methods: {
    getCode: function getCode() {
      var _this = this;

      // this.phone = this.phone.replace(/\s+/g, "");
      if (!this.data.username) {
        this.$message({
          message: "请检查设置提现信息页面手机号是否有误",
          customClass: "error"
        });
        return;
      }
      if (/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.data.username)) {
        this.isGetCode = true;
        this.$http.post(__WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + "v1/verify-code?mobile=" + this.data.username + "&type=ACCOUNT").then(function (res) {
          _this.isShowCodeTip = true;
          var intervalCode = setInterval(function () {
            _this.time--;
            if (_this.time <= 0) {
              _this.isGetCode = false;
              _this.isShowCodeTip = false;
              _this.time = 60;
              clearInterval(intervalCode);
            }
          }, 1000);
        }).catch(function (err) {
          _this.isGetCode = false;
          _this.isShowCodeTip = false;
        });
      } else {
        this.$message({
          message: "请输入正确的手机号",
          customClass: "error"
        });
        return;
      }
    },
    getWithdrawData: function getWithdrawData(storeId, page) {
      var _this2 = this;

      this.$http({
        url: "get-withdraw",
        method: "GET",
        params: {
          storeId: storeId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        console.log(res);
        if (res.status == 200) {
          _this2.withdrawData = res.data.content;
          _this2.totalElements = res.data.totalElements;
        }
      });
    },
    getInfo: function getInfo() {
      var _this3 = this;

      this.$http({
        url: "get-account",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this3.data = res.data;
        console.log(res.data);
        if (res.data.username == "") {
          _this3.$message({
            message: "请先填写提现资料",
            customClass: "error"
          });
          _this3.$router.push("/sys/" + _this3.$route.params.id + "/setWithdraw");
        }
      });
    },
    withdraw: function withdraw() {
      var _this4 = this;

      if (this.data.amount <= 100 || this.amount <= 100) {
        this.$message({
          message: "提现金额小于100，暂不能提现。",
          customClass: "error"
        });
        return;
      }
      if (!/\d/.test(this.amount)) {
        this.$message({
          message: "金额填写错误",
          customClass: "error"
        });
        return;
      }
      if (this.amount <= 0) {
        this.$message({
          message: "金额必须大于0",
          customClass: "error"
        });
        return;
      }
      if (!this.canClick) {
        return;
      }
      this.canClick = false;
      this.$http({
        url: "put-withdraw",
        method: "POST",
        data: {
          storeId: this.curStoreId,
          amount: this.amount,
          userName: this.data.username,
          accountPayee: this.data.accountPayee,
          accountPeople: this.data.accountPeople,
          verCode: this.code
        }
      }).then(function (res) {
        setTimeout(function () {
          _this4.canClick = true;
        }, 500);
        console.log(res.data);
        if (res.data.result.code == 200) {
          _this4.$message({
            message: res.data.result.msg,
            customClass: "success"
          });
          _this4.getInfo();
        } else if (res.data.result.code == 400) {
          _this4.$message({
            message: res.data.result.msg,
            customClass: "error"
          });
        }
      }).catch(function (err) {
        setTimeout(function () {
          _this4.canClick = true;
        }, 500);
      });
    }
  },
  activated: function activated() {
    this.getInfo();
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["curStoreId", "pageSize"],
  data: function data() {
    return {
      nowEmpName: '',
      nowEmpId: "",
      empName: "",
      empNameData: [],
      typeMonth: false,
      pickerOptions0: {
        //时间禁用,今天以后的时间禁用。
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() || time.getTime() < new Date('2017,01,01').getTime();
        }
      },
      yearMonth: '', //年月
      nowType: "bar", //当前查询方式
      getBtn: true, // 控制翻页请求
      size: 15,
      ratingData: [], //评价记录
      ratingDataForEmp: [], //员工的评价记录
      rating: {
        VERY_GOOD: "非常满意",
        GOOD: "满意",
        BAD: "不满意"
      },
      pageForBar: 1,
      pageForEmp: 1,
      totalElementsForBar: 0,
      totalElementsForEmp: 0,
      centerDialogVisible: false,
      nowText: ""
    };
  },

  watch: {
    //   empName(val){
    //       if(!val){
    //           this.empNameData = [];
    //           this.nowEmpId = "";
    //           return;
    //       }
    //       if(this.nowEmpName == val){
    //           this.empNameData = [];
    //           return;
    //       }
    //       this.$http({
    //           url:"find-emp",
    //           method:"GET",
    //           params:{
    //               storeId:this.curStoreId,
    //               name:val
    //           }
    //       }).then(res=>{
    //           this.empNameData = res.data;
    //       });
    //   },
    nowType: function nowType(val) {
      this.typeMonth = false;
      if (val == "bar") {
        this.getRatingData(this.pageForBar - 1);
      } else {
        this.getRatingDataForEmp(this.pageForEmp - 1);
      }
    }
  },
  methods: {
    search: function search() {
      if (!this.yearMonth) {
        this.$message({
          message: '请选择月份',
          customClass: 'error'
        });
        return;
      }
      if (this.nowType == "bar") {

        this.typeMonth = true;
        this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM"); //给日期插件赋值为选择时间
        var year = this.yearMonth.split('-')[0]; //选择的年
        var month = this.yearMonth.split('-')[1]; //选则的月

        // 
        var timeStr = new Date(this.yearMonth + "-01").getTime() + "-" + new Date(this.yearMonth + "-01").getTime();
        var nowTime = new Date().getTime();
        if (!this.$canClickSelect("ratingInfoBar", timeStr, nowTime)) {
          this.$message({
            message: '5秒内禁止重复查询相同数据',
            customClass: 'error'
          });
          return;
        }
        //


        this.getRatingDataByMonth(0, year, month);
      } else {
        this.typeMonth = true;
        this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM"); //给日期插件赋值为选择时间
        var _year = this.yearMonth.split('-')[0]; //选择的年
        var _month = this.yearMonth.split('-')[1]; //选则的月

        if (this.nowEmpId) {
          // 
          var _timeStr = new Date(this.yearMonth + "-01").getTime() + "-" + this.nowEmpId + "-" + new Date(this.yearMonth + "-01").getTime();
          var _nowTime = new Date().getTime();
          if (!this.$canClickSelect("ratingInfoEmp", _timeStr, _nowTime)) {
            this.$message({
              message: '5秒内禁止重复查询相同数据',
              customClass: 'error'
            });
            return;
          }
          //
          this.getRatingDataForEmpByMonth(0, _year, _month, this.nowEmpId);
        } else {
          // 
          var _timeStr2 = new Date(this.yearMonth + "-01").getTime() + "-" + new Date(this.yearMonth + "-01").getTime();
          var _nowTime2 = new Date().getTime();
          if (!this.$canClickSelect("ratingInfoEmp", _timeStr2, _nowTime2)) {
            this.$message({
              message: '5秒内禁止重复查询相同数据',
              customClass: 'error'
            });
            return;
          }
          //
          this.getRatingDataForEmpByMonth(0, _year, _month);
        }
      }
    },

    //日历插件 
    cutDataFn: function cutDataFn() {
      // console.log(this.yearMonth)

      this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");
    },
    showText: function showText(item) {
      this.nowText = item.message ? item.message : "暂无留言";
      this.centerDialogVisible = true;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      if (this.typeMonth) {
        this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM"); //给日期插件赋值为选择时间
        var year = this.yearMonth.split('-')[0]; //选择的年
        var month = this.yearMonth.split('-')[1]; //选则的月
        this.getRatingDataByMonth(val - 1, year, month);
        this.pageForBar = val;
      } else {
        this.getRatingData(val - 1);
        this.pageForBar = val;
      }
    },
    handleCurrentChangeForEmp: function handleCurrentChangeForEmp(val) {
      if (this.typeMonth) {
        this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM"); //给日期插件赋值为选择时间
        var year = this.yearMonth.split('-')[0]; //选择的年
        var month = this.yearMonth.split('-')[1]; //选则的月
        if (this.nowEmpId) {
          this.getRatingDataForEmpByMonth(val - 1, year, month, this.nowEmpId);
        } else {
          this.getRatingDataForEmpByMonth(val - 1, year, month);
        }
      } else {
        this.getRatingDataForEmp(val - 1);
        this.pageForEmp = val;
      }
    },
    getRatingData: function getRatingData(page) {
      var _this = this;

      this.$http({
        url: "get-netApp",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        console.log(res);
        _this.ratingData = res.data.content;
        _this.totalElementsForBar = res.data.totalElements;
      });
    },
    getRatingDataByMonth: function getRatingDataByMonth(page, year, month) {
      var _this2 = this;

      this.$http({
        url: "get-netApp",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page: page,
          size: this.size,
          year: year,
          month: month,
          type: "MONTH"
        }
      }).then(function (res) {
        console.log(res);
        _this2.ratingData = res.data.content;
        _this2.totalElementsForBar = res.data.totalElements;
      });
    },
    getRatingDataForEmp: function getRatingDataForEmp(page) {
      var _this3 = this;

      this.$http({
        url: "get-empApp",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        console.log(res);
        _this3.ratingDataForEmp = res.data.content;
        _this3.totalElementsForEmp = res.data.totalElements;
      });
    },
    getRatingDataForEmpByMonth: function getRatingDataForEmpByMonth(page, year, month) {
      var _this4 = this;

      var empId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

      this.$http({
        url: "get-empApp",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page: page,
          size: this.size,
          year: year,
          month: month,
          empId: empId,
          type: "MONTH"
        }
      }).then(function (res) {
        console.log(res);
        _this4.ratingDataForEmp = res.data.content;
        _this4.totalElementsForEmp = res.data.totalElements;
      });
    },
    getEmp: function getEmp() {
      var _this5 = this;

      this.$http({
        url: "find-emp",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this5.empNameData = res.data;
      });
    }
  },
  activated: function activated() {
    this.getRatingData(0);
    this.getEmp();
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            judge: "ALL",
            empList: [], //员工列表
            searchByWhichType: "dayOrMonth", //按照时间段或者是按月份。按日的形式查询，dayOrMonth,timeRange，时间段暂时没有
            valueForMonth: '', //月份信息
            allAmount: 0, //总金额
            allQtyForMonth: 0, //按月份总数量
            allAmountForMonth: 0,
            allQty: 0, //总数量
            nowDay: '', //当前日期
            nowType: "day", //当前查询方式，如日报，按月份
            rewardData: [],
            rewardDataForMonth: [],
            getBtn: true, // 控制翻页请求
            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },

            pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },

            timeFrom: '', //开始时间
            timeTo: '', //截止时间
            searchList: [], // 搜索结果数组
            goodSearchBtn: true, // 控制搜索框
            canSearch: true, //
            options: []
        };
    },

    methods: {
        // 搜索
        searchConfirm: function searchConfirm() {
            var date = new Date(this.nowDay).Format("yyyy-MM-dd");
            var dateForMonth = new Date(this.valueForMonth);
            var dateForMonthObj = {
                year: dateForMonth.getFullYear(),
                month: dateForMonth.getMonth() + 1
            };

            if (this.searchByWhichType === "dayOrMonth") {
                if (this.nowType == 'month') {
                    if (dateForMonth) {
                        this.getRewardData(dateForMonthObj, "MONTH", this.judge);
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                    }
                } else {
                    if (date) {
                        this.getRewardData(date, "DAY", this.judge);
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                    }
                }
            }
        },
        getRewardData: function getRewardData(date, source, judge) {
            var _this = this;

            var params = void 0;
            if (this.searchByWhichType === "dayOrMonth") {
                if (source == "DAY") {
                    params = {
                        storeId: this.curStoreId,
                        from: date,
                        type: "STORE",
                        source: source,
                        judge: judge
                        // 
                    };var timeStr = new Date(date).getTime() + "-" + judge + "-" + new Date(date).getTime();
                    var nowTime = new Date().getTime();
                    if (!this.$canClickSelect("rewardInfoDay", timeStr, nowTime)) {
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    //
                } else {
                    params = {
                        storeId: this.curStoreId,
                        year: date.year,
                        month: date.month,
                        type: "STORE",
                        source: source,
                        judge: judge
                        // 
                    };var _timeStr = new Date(date.year + "-" + date.month + "-01").getTime() + "-" + judge + "-" + new Date(date.year + "-" + date.month + "-01").getTime();
                    var _nowTime = new Date().getTime();
                    if (!this.$canClickSelect("rewardInfoMonth", _timeStr, _nowTime)) {
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    //
                }
            }
            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + "v1/clerk/get-reward",
                method: "GET",
                params: params
            }).then(function (res) {
                console.log(res);
                if (_this.searchByWhichType === "dayOrMonth") {
                    if (source == "DAY") {
                        _this.rewardData = res.data.rews;
                        _this.allAmount = res.data.total;
                        _this.allQty = res.data.count;
                    } else {
                        _this.rewardDataForMonth = res.data.rews;
                        _this.allAmountForMonth = res.data.total;
                        _this.allQtyForMonth = res.data.count;
                    }
                }
            });
        },

        // 获取员工列表
        getEmpList: function getEmpList() {
            var _this2 = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + "v1/clerk/get-empRe",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this2.empList = res.data;
            });
        }
    },
    activated: function activated() {
        this.nowDay = new Date();
        this.valueForMonth = new Date();
        this.getEmpList();
    }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            name: "",
            idCard: "",
            card: "",
            bank: "",
            isShowCodeTip: false, // 是否显示验证嘛提示
            isGetCode: false, // 是否获取验证码
            time: 60,
            phone: '', // 手机号
            code: '', // 验证码
            info: [],
            dataInfo: {}
        };
    },

    methods: {
        getCode: function getCode() {
            var _this = this;

            this.phone = this.phone.replace(/\s+/g, "");
            if (/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.phone)) {
                this.isGetCode = true;
                this.$http.post(__WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/verify-code?mobile=' + this.phone + '&type=ACCOUNT').then(function (res) {
                    _this.isShowCodeTip = true;
                    var intervalCode = setInterval(function () {
                        _this.time--;
                        if (_this.time <= 0) {
                            _this.isGetCode = false;
                            _this.isShowCodeTip = false;
                            _this.time = 60;
                            clearInterval(intervalCode);
                        }
                    }, 1000);
                }).catch(function (err) {
                    _this.isGetCode = false;
                    _this.isShowCodeTip = false;
                });
            } else {
                this.$message({
                    message: '请输入正确的手机号',
                    customClass: 'error'
                });
                return;
            }
        },
        save: function save() {
            var _this2 = this;

            if (!this.phone || !this.name || !this.bank || !this.code || !this.idCard || !this.card) {
                this.$message({
                    message: '请完整填写信息',
                    customClass: 'error'
                });
                return;
            }
            if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.phone)) {
                this.$message({
                    message: '手机号格式不正确',
                    customClass: 'error'
                });
                return;
            }
            this.$http({
                url: "update-account",
                method: "POST",
                data: {
                    username: this.phone,
                    name: this.name,
                    accountPayee: this.card,
                    verCode: this.code,
                    bankName: this.bank,
                    accountPeople: this.name,
                    storeId: this.curStoreId,
                    cdCard: this.idCard
                }
            }).then(function (res) {
                console.log(res);
                if (res.data.result.code == 200) {
                    _this2.$message({
                        message: res.data.result.msg,
                        customClass: 'success'
                    });
                } else if (res.data.result.code == 400) {
                    _this2.$message({
                        message: res.data.result.msg,
                        customClass: 'error'
                    });
                }
            });
        },
        getInfo: function getInfo() {
            var _this3 = this;

            this.$http({
                url: "get-account",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                var data = res.data;
                _this3.dataInfo = data;
                _this3.name = data.name;
                _this3.idCard = data.cdCard;
                _this3.card = data.accountPayee;
                _this3.bank = data.bankName;
                _this3.phone = data.username;
            });
        }
    },
    mounted: function mounted() {
        this.getInfo();
    }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_url_js__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            newBatchSite: {
                regionId: "",
                beginIp: "",
                count: ""
            },
            showModifySiteBatch: false,
            siteType: "",
            nowSelRegion: null,
            newSite: {
                name: '',
                id: 0,
                regionId: "",
                ipAddress: "",
                queue: 0
            },
            showModifySite: false,
            // 
            addJobVisible: false,
            btn: false, //分类下拉三角样式
            typeData: [],
            obj: {
                name: '',
                id: '',
                queue: 0
            },
            typeBtn: '',
            typeName: '',
            addJobBtn: true,
            systemData: []
        };
    },

    watch: {
        showModifySite: function showModifySite(val) {
            if (!val) {
                this.newSite = {
                    name: '',
                    id: 0,
                    regionId: "",
                    ipAddress: "",
                    queue: 0
                };
            }
        }
    },
    methods: {
        addSiteBatch: function addSiteBatch(item) {
            this.newBatchSite.regionId = item.id;
            this.showModifySiteBatch = true;
        },

        // 
        check: function check() {
            //正则验证方法
            if (!this.obj.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            if (!/^[1-9]\d*|0$/.test(this.obj.queue)) {
                this.$message({
                    message: '排序值输入有误',
                    customClass: 'error'
                });
                return true;
            }
            return false;
        },
        addDiscount: function addDiscount() {
            var _this = this;

            if (this.check()) {
                return;
            }
            this.$http({
                url: "region/edit",
                method: "POST",
                data: {
                    storeId: this.$route.params.id,
                    name: this.obj.name,
                    queue: this.obj.queue,
                    id: this.obj.id
                }
            }).then(function (res) {
                _this.$message({
                    message: res.data,
                    customClass: 'success'
                });
                _this.addJobVisible = false;
                _this.obj.queue = "";
                _this.initData();
                _this.getDataList();
            });
        },
        initData: function initData() {
            this.obj = {
                name: '',
                id: 0
            };
        },

        //添加或者修改分类
        addJob: function addJob() {
            var _this2 = this;

            if (!this.obj.name) {
                this.$message({
                    message: '分类名称有误',
                    customClass: 'error'
                });
                return;
            }
            this.$set(this.obj, "name", this.obj.name.replace(/\s*/g, ""));
            if (this.typeBtn == 1) {
                //添加父类
                var data = {
                    "id": this.$uuid.create(1).hex,
                    "sequence": -1,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": ''
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', data).then(function (res) {
                    _this2.getDataList();
                    _this2.addJobVisible = false;
                    _this2.addJobBtn = true;
                }).catch(function () {
                    _this2.addJobBtn = true;
                });
            } else if (this.typeBtn == 2) {
                //添加子类
                var _data = {
                    "id": this.$uuid.create(1).hex,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.id
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data).then(function (res) {
                    _this2.getDataList();
                    _this2.addJobVisible = false;
                    _this2.addJobBtn = true;
                }).catch(function () {
                    _this2.addJobBtn = true;
                });
            } else if (this.typeBtn == 3) {
                //、、修改父类
                var _data2 = {
                    "id": this.obj.id,
                    "sequence": this.obj.sequence,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": ''
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data2).then(function (res) {
                    _this2.getDataList();
                    _this2.addJobVisible = false;
                    _this2.addJobBtn = true;
                }).catch(function () {
                    _this2.addJobBtn = true;
                });
            } else if (this.typeBtn == 4) {
                //、、修改子类
                var _data3 = {
                    "id": this.obj.id,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.arId
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data3).then(function (res) {
                    _this2.getDataList();
                    _this2.addJobVisible = false;
                    _this2.addJobBtn = true;
                }).catch(function () {
                    _this2.addJobBtn = true;
                });
            }
        },
        sortingChild: function sortingChild(boo, item, ind, pItem) {
            var _this3 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = pItem.children.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": pItem.children[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == pItem.children.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i = 0, _len = pItem.children.length; _i < _len; _i++) {
                    var _body = {
                        "productTypeId": pItem.children[_i].id,
                        "sequence": _i
                    };
                    list.push(_body);
                    if (ind == _i) {
                        list[_i].sequence = _i + 1;
                        num = _i + 1;
                    }
                    if (num == _i) {
                        list[num].sequence = _i - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this3.getDataList();
            }).catch(function (err) {});
        },

        //排序
        sorting: function sorting(boo, item, ind) {
            var _this4 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = this.typeData.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": this.typeData[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == this.typeData.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i2 = 0, _len2 = this.typeData.length; _i2 < _len2; _i2++) {
                    var _body2 = {
                        "productTypeId": this.typeData[_i2].id,
                        "sequence": _i2
                    };
                    list.push(_body2);
                    if (ind == _i2) {
                        list[_i2].sequence = _i2 + 1;
                        num = _i2 + 1;
                    }
                    if (num == _i2) {
                        list[num].sequence = _i2 - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this4.getDataList();
            }).catch(function (err) {});
        },
        getDataList: function getDataList() {
            var _this5 = this;

            this.$http({
                url: "region/list",
                method: "POST",
                data: {
                    storeId: this.$route.params.id
                }
            }).then(function (res) {
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        it.children = [];
                        it.isOpen = true;
                        _this5.btn = true;
                        if (it.nums && Array.isArray(it.nums)) {
                            it.children = it.nums;
                        }
                    });
                }
                _this5.typeData = res.data;
            });
        },
        addClassify: function addClassify(id) {
            //添加分类
            this.typeName = "添加/编辑";
            this.obj = {
                name: '',
                id: '',
                arId: ''
            };
            this.addJobVisible = true;
            this.obj.id = id ? id : '';
            this.typeBtn = id ? 2 : 1;
        },
        checkSite: function checkSite() {
            //正则验证方法
            var ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            if (!this.newSite.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            if (!ipReg.test(this.newSite.ipAddress)) {
                this.$message({
                    message: 'ip地址有误',
                    customClass: 'error'
                });
                return true;
            }
            // if(!/^[1-9]\d*|0$/.test(this.newSite.queue)){
            //     this.$message({
            //         message: '排序值输入有误',
            //         customClass: 'error'
            //     })
            //     return true;
            // }
            // 
            if (this.siteType != "edit") {
                if (this.typeData && Array.isArray(this.typeData)) {
                    var typeData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.typeData));
                    var ips = [];
                    typeData.forEach(function (it) {
                        if (it.nums && Array.isArray(it.nums)) {
                            it.nums.forEach(function (ite) {
                                ips.push(ite.ipAddress);
                            });
                        }
                    });
                    if (ips.indexOf(this.newSite.ipAddress) != -1) {
                        this.$message({
                            message: '已添加过此IP',
                            customClass: 'error'
                        });
                        return true;
                    }
                }
            }

            // 
            return false;
        },
        doAddNewSiteBatch: function doAddNewSiteBatch() {
            var _this6 = this;

            var ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            if (!ipReg.test(this.newBatchSite.beginIp)) {
                this.$message({
                    message: 'ip地址有误',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.newBatchSite.count || this.newBatchSite.count < 1 || this.newBatchSite.count > 256) {
                this.$message({
                    message: '数量填写有误',
                    customClass: 'error'
                });
                return true;
            }
            this.$http({
                url: "region/batch/add/num",
                method: "POST",
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.newBatchSite)
            }).then(function (res) {
                _this6.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                _this6.newBatchSite = {
                    regionId: "",
                    beginIp: "",
                    count: ""
                };
                _this6.showModifySiteBatch = false;
                _this6.getDataList();
            });
        },
        doAddNewSite: function doAddNewSite() {
            var _this7 = this;

            if (this.checkSite()) {
                return;
            }
            this.$http({
                url: this.siteType ? "region/edit/num" : "region/add/num",
                method: "POST",
                data: {
                    storeId: this.$route.params.id,
                    name: this.newSite.name,
                    id: this.newSite.id,
                    regionId: this.nowSelRegion.id,
                    ipAddress: this.newSite.ipAddress,
                    queue: this.newSite.queue
                }
            }).then(function (res) {
                _this7.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                if (_this7.siteType == "edit") {
                    _this7.showModifySite = false;
                    _this7.initDataForSite();
                }
                _this7.siteType = "";
                _this7.getDataList();
            });
        },
        initDataForSite: function initDataForSite() {
            this.newSite = {
                name: '',
                id: 0,
                regionId: "",
                ipAddress: "",
                queue: ""
            };
        },
        addSite: function addSite(item) {
            this.siteType = "";
            this.nowSelRegion = item;
            this.showModifySite = true;
        },
        upClassify: function upClassify(item, oitem) {
            //修改分类
            this.typeName = "修改";
            if (!oitem) {
                this.obj = {
                    name: item.name,
                    id: item.id,
                    queue: item.queue
                };
                this.addJobVisible = true;
                this.typeBtn = oitem ? 4 : 3;
            }
        },
        modifySite: function modifySite(item, oitem) {
            this.nowSelRegion = item;
            this.newSite = {
                name: oitem.name,
                id: oitem.id,
                regionId: item.id,
                ipAddress: oitem.ipAddress,
                queue: oitem.queue
            };
            this.showModifySite = true;
            this.siteType = "edit";
        },
        delSite: function delSite(item, oitem) {
            var _this8 = this;

            this.$confirm("\u662F\u5426\u5220\u9664\u8BE5\u673A\u4F4D", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this8.$http({
                    url: "region/delete/num",
                    method: "POST",
                    data: {
                        id: oitem.id
                    }
                }).then(function (res) {
                    _this8.getDataList();
                });
            }).catch(function () {});
        },
        delClassify: function delClassify(item, oitem) {
            var _this9 = this;

            this.$confirm("\u662F\u5426\u5220\u9664 " + (oitem ? oitem.name + ' 区域?' : item.name + ' 区域及该区域下所有机位?'), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this9.$http({
                    url: "region/delete",
                    method: "POST",
                    data: {
                        id: item.id
                    }
                }).then(function (res) {
                    _this9.getDataList();
                });
            }).catch(function () {});
        },
        handle: function handle(item, ind) {
            if (this.typeData[ind].isOpen) {
                this.btn = !this.btn;
            } else {
                this.btn = true;
            }
            for (var i = 0, len = this.typeData.length; i < len; i++) {
                this.typeData[i].isOpen = false;
            }
            this.typeData[ind].isOpen = true;
        }
    },
    activated: function activated() {
        this.getDataList();
        //就怕sequence会大于数组的长度
        // this.$http.get('/product-types?storeId='+this.$route.params.id+'&parentId='+'').then((res)=>{
        //     console.log(res.data)
        //     let body = res.data.data;
        //     this.systemData = res.data.systemData;
        //     let newArr = []; 
        //     for (let i = 0, len = body.length; i < len; i++) {
        //         if ( !body[i].parent ) {
        //             body[i].isOpen = false;
        //             newArr.push(body[i]);
        //             newArr[newArr.length-1].children = [];
        //             for (let j = 0, len = body.length; j < len; j++) {
        //                 if ( body[j].parent&&body[i].id==body[j].parent.id) {
        //                     newArr[newArr.length-1].children.push(body[j]);
        //                 }
        //             }
        //         }
        //     }
        //     let list = [];
        //     for (let i = 0, len = newArr.length; i < len; i++) {
        //         let bodys = {
        //             "productTypeId":newArr[i].id,
        //             "sequence":i
        //         };
        //         list.push(bodys)
        //     }
        //     if(!list.length){
        //         return;
        //     }
        //     this.$http.put('/product-sequence',{"products":list}).then((res)=>{
        //         this.getDataList();
        //     }).catch((err) => {
        //     });
        // }).catch((err) => {
        // });
    }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__urlConfig__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    components: {},
    data: function data() {
        return {
            // 
            isAllWeek: false,
            setMealIds: [],
            disCoutFirst: [{
                id: 0,
                name: '暂无'
            }, {
                id: 1,
                name: '会员'
            }, {
                id: 2,
                name: '时间段'
            }],
            weeks: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"],
            levelsList: [], //会员等级列表
            unitFormat: {},
            newDiscount: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                name: '',
                id: 0,
                regionId: "",
                ipAddress: "",
                queue: 0
            }, 'ipAddress', 0),
            // 
            nowSelClassGoods: [], //当前所选优惠内的商品
            nowSelClass: {},
            showSelGoods: false,
            printEr: [],
            mealInfo: false,
            fliter_type: "",
            typeList: [], //分类列表
            addJobVisible: false,
            btn: false, //分类下拉三角样式
            typeData: [],
            obj: {
                name: '',
                id: '',
                price: 0,
                typeId: "",
                kitchenPrintEnabled: 0,
                ipId: ""
            },
            typeBtn: '',
            typeName: '',
            addJobBtn: true,
            systemData: [],
            mealInfoData: [], //优惠商品详情
            nowSelMealId: "", //当前查看的优惠id
            nowSelGoods: [],
            proIds: [],
            canGetClassGoods: true,
            unitOptions: []
        };
    },

    watch: {
        addJobVisible: function addJobVisible(val) {
            if (!val) {
                this.initData();
            }
        }
    },
    methods: {
        handleChangeWeeksAll: function handleChangeWeeksAll(val) {
            if (this.isAllWeek) {
                this.newDiscount.week = this.weeks;
            } else {
                this.newDiscount.week = [];
            }
        },
        getLevels: function getLevels() {
            var _this = this;

            this.$http({
                url: "level-list",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                var data = res.data;
                for (var i = 0; i < data.length; i++) {
                    data[i].nowSetPrice = "";
                }
                _this.levelsList = data;
                console.log(data);
            });
        },

        // new add
        handleChangeWeeks: function handleChangeWeeks(value) {
            console.log(value);
            this.newDiscount.week = value;
        },
        check: function check() {
            //正则验证方法
            if (!this.newDiscount.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            // if(!this.newDiscount.qty){
            //     this.$message({
            //         message: '请输入数量',
            //         customClass: 'error'
            //     })
            //     return true;
            // }
            if (!this.newDiscount.unitId) {
                this.$message({
                    message: '请选择原料单位',
                    customClass: 'error'
                });
                return true;
            }
            return false;
        },

        // 新增优惠方式
        addDiscount: function addDiscount() {
            var _this2 = this;

            if (this.check()) {
                return;
            }
            this.$http({
                url: "region/add/num",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    name: this.newDiscount.name,
                    id: this.newDiscount.id,
                    regionId: this.newDiscount.unitId,
                    ipAddress: this.newDiscount.ipAddress,
                    queue: this.newDiscount.queue
                }
            }).then(function (res) {
                _this2.$message({
                    message: res.data,
                    customClass: 'success'
                });
                _this2.addJobVisible = false;
                _this2.initData();
                _this2.getDataList();
                // if(res.data.code == 200){
                //     this.$message({
                //         message: res.data.msg,
                //         customClass: 'success'
                //     });
                //     this.addJobVisible = false;
                //     this.initData();
                //     this.getDataList();
                // }else if(res.data.code == 400){
                //     this.$message({
                //         message: res.data.msg,
                //         customClass: 'error'
                //     });
                // }
            });
        },
        initData: function initData() {
            this.newDiscount = {
                name: '',
                qty: 0,
                unitId: '',
                id: 0
            };
        },
        reduceClassGoods: function reduceClassGoods(item) {
            console.log(item);
            // return;
            var index = void 0;
            var flag = false;
            console.log(this.nowSelClassGoods);
            console.log(item);
            for (var i = 0; i < this.nowSelClassGoods.length; i++) {
                if (this.nowSelClassGoods[i].productId == item.productId) {
                    flag = true;
                    index = i;
                }
            }
            if (flag) {
                var nowSelClassGoods = this.nowSelClassGoods;
                nowSelClassGoods.splice(index, 1);
                this.nowSelClassGoods = nowSelClassGoods;
                var proIds = [];
                var setMealIds = [];
                for (var _i = 0; _i < nowSelClassGoods.length; _i++) {
                    var obj = {
                        productId: nowSelClassGoods[_i].productId,
                        setMealQty: nowSelClassGoods[_i].count
                        // productName:this.nowSelectGoods[i].productName,
                    };
                    if (!nowSelClassGoods[_i].setMealEnabled) {
                        proIds.push(obj);
                    } else {
                        setMealIds.push(nowSelClassGoods[_i].productId);
                    }
                    // proIds.push(obj);
                }
                this.proIds = proIds;
                this.setMealIds = setMealIds;
            }
        },
        closeSelGoods: function closeSelGoods() {
            this.showSelGoods = false;
            // this.getClassGoos();
        },

        //获取优惠内商品
        getClassGoos: function getClassGoos() {
            var _this3 = this;

            if (!this.canGetClassGoods) {
                return;
            }
            console.log(this.nowSelClass);
            this.$http({
                url: "/meal/get-product",
                method: "GET",
                params: {
                    mealId: this.nowSelClass.id
                }
            }).then(function (res) {
                _this3.nowSelClassGoods = res.data;
                var proIds = [];
                for (var i = 0; i < res.data.length; i++) {
                    var obj = {
                        productId: res.data[i].productId,
                        setMealQty: res.data[i].count
                    };
                    proIds.push(obj);
                }
                _this3.proIds = proIds;
            });
        },

        //添加或删除优惠商品
        updateOrAddClass: function updateOrAddClass() {
            this.$http({
                url: "/meal/add-pro",
                method: "POST",
                data: {
                    id: this.nowSelClass.id,
                    proIds: this.proIds
                }
            }).then(function (res) {
                if (res.data.code == 200) {}
            });
        },
        selOk: function selOk(data) {
            // this.nowSelGoods = data.nowSelectGoods;
            console.log(data.nowSelectGoods);
            var setMealIds = [];
            // this.nowSelClassGoods = data.nowSelectGoods;
            if (data.nowSelectGoods.length) {
                var nowSelClassGoods = data.nowSelectGoods;
                for (var i = 0; i < data.nowSelectGoods.length; i++) {
                    if (data.nowSelectGoods[i].productId) {
                        nowSelClassGoods[i].id = data.nowSelectGoods[i].productId;
                    }
                    if (data.nowSelectGoods[i].setMealEnabled) {
                        setMealIds.push(data.nowSelectGoods[i].productId);
                    }
                }
                this.nowSelClassGoods = nowSelClassGoods;
                this.nowSelGoods = nowSelClassGoods;
            }
            this.proIds = data.proIds;
            console.log(setMealIds);
            this.setMealIds = setMealIds;
            this.showSelGoods = false;
        },

        // 获取打印数据
        getPrintIpInfo: function getPrintIpInfo() {
            var _this4 = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_2__urlConfig__["a" /* BASE_URL */] + "/v1/ip/get-ip",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this4.printEr = res.data;
                console.log(res);
            });
        },

        // 删除优惠商品
        delMealGoods: function delMealGoods(item) {
            var _this5 = this;

            console.log(item);
            if (!this.nowSelMealId) {
                return;
            }
            this.$http({
                url: "/meal/delete-pro",
                method: "POST",
                data: {
                    id: this.nowSelMealId,
                    proIds: [{
                        productId: item.id
                    }]
                }
            }).then(function (res) {
                if (res.data.code == 200) {
                    _this5.showMealInfo({ id: _this5.nowSelMealId });
                    _this5.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    return;
                } else {
                    _this5.$message({
                        message: res,
                        customClass: 'error'
                    });
                }
            });
        },

        // 查看优惠商品详情
        showMealInfo: function showMealInfo(item) {
            var _this6 = this;

            this.nowSelMealId = item.id;
            this.mealInfo = true;
            this.$http({
                url: "/meal/find-pro",
                method: "GET",
                params: {
                    mealId: item.id
                }
            }).then(function (res) {
                _this6.mealInfoData = res.data;
            });
        },

        //添加或者修改分类
        addJob: function addJob() {
            var _this7 = this;

            if (!this.obj.name) {
                this.$message({
                    message: '优惠名称有误',
                    customClass: 'error'
                });
                return;
            }
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.obj.price)) {
                this.$message({
                    message: '优惠价格有误',
                    customClass: 'error'
                });
                return;
            }
            if (!this.obj.typeId) {
                this.$message({
                    message: '请选择优惠所属分类',
                    customClass: 'error'
                });
                return;
            }
            if (this.typeBtn == 1) {
                //添加父类
                var data = void 0;
                if (this.obj.kitchenPrintEnabled) {
                    data = {
                        // "id"      : this.$uuid.create(1).hex,
                        // "sequence":-1,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "storeId": this.$route.params.id,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        "ipId": this.obj.ipId,
                        proIds: this.proIds
                        // "parentId": ''
                    };
                } else {
                    data = {
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "storeId": this.$route.params.id,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        proIds: this.proIds
                    };
                }
                // let data = {
                //     // "id"      : this.$uuid.create(1).hex,
                //     // "sequence":-1,
                //     "name"    : this.obj.name,
                //     "price":this.obj.price,
                //     "typeId":this.obj.typeId,
                //     "storeId" : this.$route.params.id,
                //     "kitchenPrintEnabled":this.obj.kitchenPrintEnabled,
                //     "ipId":this.obj.ipId
                //     // "parentId": ''
                // }
                if (!this.addJobBtn) {
                    return;
                }

                this.addJobBtn = false;
                this.$http.post('/meal/add-meal', data).then(function (res) {
                    if (res.data.code == 400) {
                        _this7.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                        _this7.addJobBtn = true;
                        return;
                    }
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                    // this.updateOrAddClass();
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 2) {
                //添加子类
                var _data = {
                    "id": this.$uuid.create(1).hex,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.id
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data).then(function (res) {
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 3) {
                this.canGetClassGoods = true;
                //、、修改父类
                if (!this.obj.name) {
                    this.$message({
                        message: '优惠名称有误',
                        customClass: 'error'
                    });
                    return;
                }
                if (!this.obj.typeId) {
                    this.$message({
                        message: '请选择优惠所属分类',
                        customClass: 'error'
                    });
                    return;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.obj.price)) {
                    this.$message({
                        message: '优惠价格有误',
                        customClass: 'error'
                    });
                    return;
                }
                var _data2 = void 0;
                if (this.obj.kitchenPrintEnabled) {
                    _data2 = {
                        "id": this.obj.id,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        "ipId": this.obj.ipId,
                        proIds: this.proIds

                    };
                } else {
                    _data2 = {
                        "id": this.obj.id,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        proIds: this.proIds

                    };
                }
                if (!this.addJobBtn) {
                    return;
                }

                this.addJobBtn = false;
                this.$http.post('/meal/update-meal', _data2).then(function (res) {
                    if (res.data.code == 400) {
                        _this7.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                        _this7.addJobBtn = true;
                        return;
                    }
                    // this.updateOrAddClass();
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                    _this7.$message({
                        message: '修改成功',
                        customClass: 'success'
                    });
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 4) {
                //、、修改子类
                var _data3 = {
                    "id": this.obj.id,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.arId
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data3).then(function (res) {
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            }
        },

        //排序
        sorting: function sorting(boo, item, ind) {
            var _this8 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = this.typeData.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": this.typeData[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == this.typeData.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i2 = 0, _len = this.typeData.length; _i2 < _len; _i2++) {
                    var _body = {
                        "productTypeId": this.typeData[_i2].id,
                        "sequence": _i2
                    };
                    list.push(_body);
                    if (ind == _i2) {
                        list[_i2].sequence = _i2 + 1;
                        num = _i2 + 1;
                    }
                    if (num == _i2) {
                        list[num].sequence = _i2 - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this8.getDataList();
            }).catch(function (err) {});
        },
        getDataList: function getDataList() {
            var _this9 = this;

            this.$http({
                url: "region/list/num",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this9.typeData = res.data;
                console.log(_this9.typeData);
            });
        },
        getUnitList: function getUnitList() {
            var _this10 = this;

            this.$http({
                url: "region/list ",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this10.unitOptions = res.data;
                var unitFormat = {};
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        unitFormat[it.id] = it.name;
                    });
                }
                console.log(unitFormat);
                _this10.unitFormat = unitFormat;
                _this10.getDataList();
            });
        },
        addClassify: function addClassify(id) {
            // this.$router.push({name:"discountManaEdit",query:{type:"add"}});
            this.addJobVisible = true;
            return;
            this.initData();
            //添加分类
            this.typeName = "添加折扣方式";
            this.canGetClassGoods = false;
            this.obj = {
                name: '',
                id: '',
                price: 0,
                kitchenPrintEnabled: 0
            };
            this.nowSelClassGoods = [];
            this.addJobVisible = true;
            this.obj.id = id ? id : '';
            this.typeBtn = id ? 2 : 1;
            // this.nowSelClass = {};
        },
        upClassify: function upClassify(item, oitem) {
            console.log(item);
            this.newDiscount = {
                id: item.id,
                name: item.name,
                unitId: item.unitId,
                qty: item.qty
            };
            this.addJobVisible = true;
        },
        delClassify: function delClassify(item, oitem) {
            var _this11 = this;

            this.$confirm('\u6E29\u99A8\u63D0\u793A\uFF1A\u5220\u9664\u8BE5\u539F\u6599\u5546\u54C1(' + item.name + ')\u540E\uFF0C\u4E0E\u4E4B\u7ED1\u5B9A\u7684\u5546\u54C1\u5173\u8054\u5C06\u53D6\u6D88', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除
                _this11.$http({
                    url: "material/delete",
                    method: "GET",
                    params: {
                        id: item.id
                    }
                }).then(function (res) {
                    if (res.data.code == 200) {} else {
                        _this11.$message({
                            message: res.data,
                            customClass: 'success'
                        });
                    }
                    _this11.getDataList();
                });
            }).catch(function () {});
        },
        handle: function handle(item, ind) {
            if (this.typeData[ind].isOpen) {
                this.btn = !this.btn;
            } else {
                this.btn = true;
            }
            for (var i = 0, len = this.typeData.length; i < len; i++) {
                this.typeData[i].isOpen = false;
            }
            this.typeData[ind].isOpen = true;
        }
    },
    activated: function activated() {
        this.getUnitList();
        sessionStorage.setItem("modifyDiscountItem", "{}");
        // this.getPrintIpInfo();

        //就怕sequence会大于数组的长度
        // this.$http.get('/get-type?storeId='+this.$route.params.id).then((res)=>{
        //     console.log(res.data)
        //     let body = res.data;
        //     // this.systemData = res.data.systemData;
        //     let newArr = []; 
        //     for (let i = 0, len = body.length; i < len; i++) {
        //         if ( !body[i].parent ) {
        //             body[i].isOpen = false;
        //             newArr.push(body[i]);
        //             newArr[newArr.length-1].children = [];
        //             for (let j = 0, len = body.length; j < len; j++) {
        //                 if ( body[j].parent&&body[i].id==body[j].parent.id) {
        //                     newArr[newArr.length-1].children.push(body[j]);
        //                 }
        //             }
        //         }
        //     }
        //     let list = [];
        //     for (let i = 0, len = newArr.length; i < len; i++) {
        //         let bodys = {
        //             "productTypeId":newArr[i].id,
        //             "sequence":i
        //         };
        //         list.push(bodys)
        //     }
        //     if(!list.length){
        //         return;
        //     }
        //     this.$http.put('/product-sequence',{"products":list}).then((res)=>{
        //         this.getDataList();
        //     }).catch((err) => {
        //     });
        // }).catch((err) => {
        // });
    }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_imgCrop_imgCrop_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_imgCrop_imgCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_imgCrop_imgCrop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__urlConfig_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selCouponGoods_selGoods__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selCouponGoods_selGoods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_selCouponGoods_selGoods__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    components: { imgCrop: __WEBPACK_IMPORTED_MODULE_3__components_imgCrop_imgCrop_vue___default.a, selCouponGoods: __WEBPACK_IMPORTED_MODULE_5__components_selCouponGoods_selGoods___default.a },
    props: ['pageSize', 'curStoreId'],
    data: function data() {
        return {
            isShowOld: false,
            editCouponBtn: false,
            openLimitEnabled: false,
            nowSelProIds: [],
            seledGoods: [],
            showCouponGoods: false,
            showType: "ING",
            dialogVisible: false,
            addCouponBtn: false, //添加规则按钮
            couponList: [], //规则列表
            rulesId: '', //规则id
            couponType: 'GET_ITEM_FREE',
            couponTypeText: {
                'GET_ITEM_FREE': '商品抵用券',
                "REDUCE": "代金券"
            },
            newCoupon: {
                id: '', // 新优惠券id
                title: '', // 名称
                notice: '', // 使用说明
                description: '', // 详细说明
                type: 'GET_ITEM_FREE', // 优惠券类型
                productId: '', // 商品id
                productName: '', // 商品名称
                source: 'STORE', // 优惠券来源
                storeId: this.curStoreId, // 店铺id
                shareable: false, // 是否可分享
                expireDays: 0, // 过期时间
                logoURL: '', // 优惠券图片
                openLimitEnabled: false,
                limitCount: "",
                expireDay: ""
            },
            shareable: 'OFF', // 是否可分享
            goodCheckArr: [], // 商品检索数组
            keyWords: '', // 商品检索关键字
            goodSearchBtn: true, // 控制商品检索请求
            curGoodIdx: 0, // 商品检索索引

            coverImgMaxSize: 5000 * 1024, // 图片最大字节数
            oldImgBase64: '', // 原图base64
            showCrop: false, // 控制图片裁剪显示隐藏
            curCropW: 600, // 裁剪宽度
            curCropH: 600, // 裁剪高度
            infoload: false, // loading

            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0, //总共条

            addCouponApiBtn: true, // 控制新增接口

            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() <= Date.now() - 1000 * 60 * 60 * 24;
                }
            },
            timeFromTo: ['', ''],
            timeFrom: '',
            timeTo: ''
        };
    },


    watch: {
        keyWords: function keyWords(val) {
            if (this.newCoupon.productName == this.keyWords) {
                this.goodCheckArr = [];
                return;
            }
            this.goodSearch();
        },
        showType: function showType(val) {
            this.getCouponList();
        },
        addCouponBtn: function addCouponBtn(val) {
            if (!val) {
                this.nowSelProIds = [];
                this.seledGoods = [];
            }
        },
        "newCoupon.limitCount": function newCouponLimitCount(val) {
            if (val < 0) {
                this.newCoupon.limitCount = 0;
                this.$forceUpdate();
            }
        },
        editCouponBtn: function editCouponBtn(val) {
            if (!val) {
                this.nowSelProIds = [];
                this.seledGoods = [];
                this.addCouponApiBtn = true;
            }
        }
    },
    methods: {
        cancelCouponGoods: function cancelCouponGoods(tag) {
            console.log(tag);
            var seledGoods = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.seledGoods));
            var index = void 0;
            var flag = false;
            if (seledGoods && Array.isArray(seledGoods) && seledGoods.length) {
                seledGoods.forEach(function (it, ind) {
                    if (it.id == tag.id) {
                        index = ind;
                        flag = true;
                    }
                });
            }
            seledGoods.splice(index, 1);
            this.seledGoods = seledGoods;
        },
        selOk: function selOk(data) {
            console.log(data);
            this.seledGoods = data.nowSelectGoods;
            this.nowSelProIds = data.proIds;
            this.showCouponGoods = false;
        },

        // 
        toDetail: function toDetail(item) {
            this.$router.push({
                name: "couponProfile",
                query: {
                    id: item.id,
                    createName: item.createName,
                    couponName: item.title,
                    cteateTime: item.addTime,
                    startTime: item.startTime ? item.startTime : "",
                    endTime: item.endTime ? item.endTime : "",
                    expireDay: item.expireDay ? item.expireDay : "",
                    sendCount: item.sendCount,
                    useCount: item.useCount,
                    goodsName: item.productName,
                    status: this.showType == "STOP" ? "STOP" : "NORMAL",
                    statusType: this.showType
                }
            });
        },
        showUpBox: function showUpBox(item) {
            this.timeTo = '';
            this.timeFrom = '';
            this.addCouponBtn = true;
            this.newCoupon = {
                id: this.$uuid.create(1).hex, // 新优惠券id
                title: '', // 名称
                notice: '1、每位会员每单限使用一张，不可叠加使用。 2、本券不可兑换现金且不退不换，不与其它活动同享，使用本券不提供发票。 3、一切解释权归发行方所有', // 使用说明
                description: '', // 详细说明
                type: 'GET_ITEM_FREE', // 优惠券类型
                productId: '', // 商品id
                productName: '', // 商品名称
                source: 'STORE', // 优惠券来源
                storeId: this.curStoreId, // 店铺id
                shareable: false, // 是否可分享
                expireDays: 1, // 过期时间
                openLimitEnabled: false,
                limitCount: "",
                expireDay: "",
                logoURL: 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png' // 优惠券图片
            };
            this.keyWords = '';
            this.shareable = 'OFF';
        },

        // 保存优惠券
        saveCoupon: function saveCoupon() {
            var _this = this;

            if (this.shareable == 'ON') {
                this.newCoupon.shareable = true;
            } else {
                this.newCoupon.shareable = false;
            }

            if (!this.newCoupon.title) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return;
            }
            if (this.couponType == "REDUCE") {
                if (!this.newCoupon.couponAmount) {
                    this.$message({
                        message: '请输入代金券金额',
                        customClass: 'error'
                    });
                    return;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newCoupon.couponAmount)) {
                    this.$message({
                        message: '代金券金额格式有误',
                        customClass: 'error'
                    });
                    return;
                }
            }
            if (!this.newCoupon.notice) {
                this.$message({
                    message: '请输入使用说明',
                    customClass: 'error'
                });
                return;
            }
            // if ( !this.newCoupon.productId ) {
            //     this.$message({
            //         message: '请选择商品',
            //         customClass: 'error'
            //     })
            //     return;
            // }
            // if(this.newCoupon.couponType!="REDUCE"){
            if (!this.nowSelProIds || !this.nowSelProIds.length) {
                this.$message({
                    message: '请选择商品',
                    customClass: 'error'
                });
                return;
            }
            // }

            // if ( !this.timeFrom ) {
            //     this.$message({
            //         message: '请选择优惠券(代金券)使用开始时间',
            //         customClass: 'error'
            //     })
            //     return;
            // }
            // if ( !this.timeTo ) {
            //     this.$message({
            //         message: '请选择优惠券(代金券)过期时间',
            //         customClass: 'error'
            //     })
            //     return;
            // }
            // if ( new Date(this.timeTo).getTime()< new Date(this.timeFrom).getTime() ) {
            //     this.$message({
            //         message: '开始时间不能大于过期时间',
            //         customClass: 'error'
            //     })
            //     return;
            // }

            if (!this.newCoupon.expireDay) {
                this.$message({
                    message: '有效天数填写有误',
                    customClass: 'error'
                });
                return;
            }

            if (!/^\d+$/.test(this.newCoupon.expireDay)) {
                this.$message({
                    message: '有效天数填写有误',
                    customClass: 'error'
                });
                return;
            }

            if (this.newCoupon.expireDay <= 0) {
                this.$message({
                    message: '有效天数填写有误',
                    customClass: 'error'
                });
                return;
            }

            if (this.newCoupon.openLimitEnabled) {
                if (!/\d+/.test(this.newCoupon.limitCount)) {
                    this.$message({
                        message: '限制数量填写有误',
                        customClass: 'error'
                    });
                    return;
                }
                if (this.newCoupon.limitCount <= 0) {
                    this.$message({
                        message: '限制数量填写有误',
                        customClass: 'error'
                    });
                    return;
                }
            }

            if (!this.addCouponApiBtn) {
                return;
            }
            this.addCouponApiBtn = false;
            var productId = [],
                productName = [];
            if (this.seledGoods && Array.isArray(this.seledGoods) && this.seledGoods.length) {
                this.seledGoods.forEach(function (it) {
                    productId.push(it.id);
                    productName.push(it.name);
                });
            }
            console.log(productName);
            var aNewCoupon = {
                description: this.newCoupon.description,
                // startDate: new Date(this.timeFrom).Format('yyyy-MM-dd'),
                // endDate: new Date(this.timeTo).Format('yyyy-MM-dd'),
                id: this.newCoupon.id,
                logoURL: this.newCoupon.logoURL,
                notice: this.newCoupon.notice,
                productId: productId.join(","),
                productName: productName.join(","),
                shareable: this.couponType == "REDUCE" ? false : this.newCoupon.shareable,
                source: this.newCoupon.source,
                storeId: this.newCoupon.storeId,
                title: this.newCoupon.title,
                // type:this.newCoupon.type,
                type: this.couponType,
                couponAmount: this.couponType == "REDUCE" ? this.newCoupon.couponAmount : "",
                openLimitEnabled: this.newCoupon.openLimitEnabled,
                limitCount: this.newCoupon.openLimitEnabled ? this.newCoupon.limitCount : "",
                createName: localStorage.getItem("username"),
                expireDay: this.newCoupon.expireDay
            };
            if (!aNewCoupon.logoURL) {
                aNewCoupon.logoURL = 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
            }
            this.$http.post('coupon', aNewCoupon).then(function (res) {
                _this.addCouponApiBtn = true;
                _this.addCouponBtn = false;
                _this.getCouponList();
            }).catch(function () {
                _this.addCouponApiBtn = true;
            });
        },
        editCoupon: function editCoupon() {
            var _this2 = this;

            var productId = [],
                productName = [];
            if (this.seledGoods && Array.isArray(this.seledGoods) && this.seledGoods.length) {
                this.seledGoods.forEach(function (it) {
                    productId.push(it.id);
                    productName.push(it.name);
                });
            }
            if (!productId || !productId.length) {
                this.$message({
                    message: '请选择商品',
                    customClass: 'error'
                });
                return;
            }
            if (!this.addCouponApiBtn) {
                return;
            }
            this.addCouponApiBtn = false;
            var params = {
                id: this.newCoupon.id,
                storeId: this.curStoreId,
                productId: productId.join(","),
                productName: productName.join(",")
            };
            if (this.isShowOld) {
                if (!this.timeTo) {
                    this.$message({
                        message: '请选择过期时间',
                        customClass: 'error'
                    });
                    return;
                }
                params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, {
                    endDate: new Date(this.timeTo).Format('yyyy-MM-dd')
                });
            }
            this.$http.post('coupon', params).then(function (res) {
                _this2.addCouponApiBtn = true;
                _this2.editCouponBtn = false;
                _this2.getCouponList();
            }).catch(function () {
                _this2.addCouponApiBtn = true;
            });
        },

        // 删除优惠券
        delCoupon: function delCoupon(couponId) {
            var _this3 = this;

            this.$confirm('此操作将删除该券, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除商品
                _this3.$http.delete('coupon?id=' + couponId).then(function (res) {
                    if (res.status) {
                        _this3.getCouponList();
                    }
                });
            }).catch(function () {});
        },

        // 修改优惠券
        uploadCoupon: function uploadCoupon(item) {
            // if ( !item.startTime ) {
            //     this.timeFrom = '';
            //     this.timeTo = '';
            // } else {
            //     this.timeFrom = new Date(item.startTime);
            //     this.timeTo = new Date(item.endTime);
            // }
            this.isShowOld = false;
            this.newCoupon.title = item.title;
            this.newCoupon.id = item.id;
            var seledGoods = [];
            this.editCouponBtn = true;
            if (item.productId && item.productName) {
                var productIds = item.productId.split(",");
                var productNames = item.productName.split(",");
                for (var i = 0; i < productIds.length; i++) {
                    var obj = {
                        id: productIds[i],
                        name: productNames[i],
                        count: 1
                    };
                    seledGoods.push(obj);
                }
            }
            this.seledGoods = seledGoods;
            if (item.expireDay == 0 && item.endTime) {
                this.timeTo = item.endTime;
                this.isShowOld = true;
            }
            // this.newCoupon = {
            //     // 
            //     id: item.id, // 新优惠券id
            //     title: item.title, // 名称
            //     notice: item.notice, // 使用说明
            //     description: item.description, // 详细说明
            //     type: item.type, // 优惠券类型
            //     productId: item.productId, // 商品id
            //     productName: item.productName, // 商品名称
            //     source: item.source, // 优惠券来源
            //     storeId: item.storeId, // 店铺id
            //     shareable: item.shareable, // 是否可分享
            //     expireDays: item.expireDays, // 过期时间
            //     logoURL: item.logoURL, // 优惠券图片
            // };
            // if (  this.newCoupon.shareable) {
            //     this.shareable = 'ON' ;
            // } else {
            //     this.shareable = 'OFF' ;
            // }
            // this.keyWords = item.productName;
            // this.addCouponBtn = true;
        },
        //列表翻页
        changePage: function changePage(boo) {
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            this.getCouponList();
        },
        // 获取优惠券列表
        getCouponList: function getCouponList() {
            var _this4 = this;

            this.$http.get('coupon?storeId=' + this.curStoreId + '&page=' + this.curPage + '&pageSize=' + this.pageSize + '&status=' + this.showType).then(function (res) {
                console.log(res);
                _this4.couponList = res.data.dtos;
                _this4.totalPage = res.data.totalPages;
                _this4.totalElements = res.data.totalElements;
                if (_this4.couponList.length < _this4.pageSize) {
                    for (var i = 0, len = _this4.pageSize - _this4.couponList.length; i < len; i++) {
                        _this4.couponList.push({});
                    }
                }
            }).catch(function () {});
        },
        // 选择检索商品
        selSearchGood: function selSearchGood(item) {
            // console.log(item);
            this.newCoupon.productName = item.name;
            this.newCoupon.productId = item.id;
            this.keyWords = item.name;
            this.goodCheckArr = [];
        },
        // 商品检索
        goodSearch: function goodSearch() {
            var _this5 = this;

            var val = this.keyWords;
            if (!val) {
                this.goodCheckArr = [];
                return;
            }
            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http.get('products/search?storeId=' + this.curStoreId + '&q=' + encodeURI(val)).then(function (res) {
                _this5.goodCheckArr = res.data;
                var btn = true;
                for (var i = 0, len = _this5.goodCheckArr.length; i < len; i++) {
                    if (_this5.keyWords == _this5.goodCheckArr[i].name) {
                        _this5.newCoupon.productId = _this5.goodCheckArr[i].id;
                        _this5.newCoupon.productName = _this5.goodCheckArr[i].name;
                        btn = false;
                        break;
                    }
                }
                if (btn) {
                    _this5.newCoupon.productName = '';
                    _this5.newCoupon.productId = '';
                }

                setTimeout(function () {
                    var that = _this5;
                    $('.goodCheckList li').hover(function () {
                        that.curGoodIdx = $(this).index() - 1;
                    }, function () {
                        that.curGoodIdx = 0;
                    });
                }, 0);
                _this5.goodSearchBtn = true;
            }).catch(function () {
                _this5.goodSearchBtn = true;
            });
        },
        coverImg: function coverImg(e) {
            var reader = new FileReader();
            var that = this;
            var fileObj = e.target.files[0];

            if (e.target.files.length == 0) {
                return false;
            }

            // 判断图片大小
            if (fileObj.size > this.coverImgMaxSize) {
                this.errorMsg = '上传图片的大小不能超过5MB';
                this.openErrorTip = true;
                this.$message({
                    message: '上传图片的大小不能超过5MB',
                    customClass: 'error'
                });
                return false;
            }

            reader.onload = function (file) {
                return function (e) {
                    var that2 = this; // 缓存当前this
                    var img = new Image();
                    img.src = this.result;
                    img.onload = function () {
                        var imgBase64 = that2.result; //获得图片的base64的数据


                        // 判断是否是移动端设备
                        var sUserAgent = navigator.userAgent.toLowerCase();
                        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
                        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                        var bIsAndroid = sUserAgent.match(/android/i) == "android";
                        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                            that.mobileUploadImg(imgBase64);
                        } else {
                            that.oldImgBase64 = imgBase64;
                            that.showCrop = true;
                        }
                    };
                    $('.pcImgFile').val('');
                    $('.mobileImgFile').val('');
                };
            }(e.target.files[0]);
            reader.readAsDataURL(e.target.files[0]);
        },
        // 移动端上传图片
        mobileUploadImg: function mobileUploadImg(imgBase64) {
            var _this6 = this;

            this.infoload = true;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_4__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/image/json/upload?storeId=' + this.curStoreId, { file: imgBase64 }).then(function (res) {
                _this6.newCoupon.logoURL = res.data.path;
                _this6.infoload = false;
            }).catch(function () {
                _this6.infoload = false;
            });
        },
        // 获得裁剪后图片base64
        getCropImgBase: function getCropImgBase(imgUrl) {
            this.newCoupon.logoURL = imgUrl;
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.couponList.push({});
        }
    },
    activated: function activated() {
        if (this.$route.query.type) {
            this.showType = this.$route.query.type;
        }
        this.getCouponList();
    }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    data: function data() {
        return {
            filterStatus: "NORMAL",
            pageSize: 9,
            stautsOprions: {
                NORMAL: "未使用",
                STOP: "已作废",
                EXPIRED: "已过期",
                VERIFIED: "已核销"
            },
            nowSelVip: null,
            nowVipIndex: 0,
            searchData: [],
            searchPhone: "",
            nowSelFilter: "today",
            couponList: [],
            nowType: "TIME_RANGE",
            startTime: '', //按时间段查询的起始时间
            endTime: '', //按时间段查询的结束时间
            pickerOptions: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            dateStr: new Date().Format("yyyy-MM-dd"),
            currentPage: 1,
            totalElements: 0, //数据总条数
            canClick: true
        };
    },

    watch: {
        dateStr: function dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM-dd"));
            var nowDate = new Date(val).Format("yyyy-MM-dd");
            this.dateStr = nowDate;
            this.getCouponDetail(0, nowDate);
        },
        searchPhone: function searchPhone(val) {
            if (!val) {
                this.nowSelVip = null;
                this.searchData = [];
                this.getCouponDetail();
                // this.getVipData("AMOUNT","DOWN");
                return;
            }
            this.searchVip();
        },
        nowSelVip: function nowSelVip(val) {
            if (!val) {
                return;
            }
            this.getCouponDetail();
        }
    },
    methods: {
        computedTime: function computedTime(item) {
            if (item.id && item.addTime) {
                var daysTimes = (this.$route.query.expireDay - 1) * 1000 * 60 * 60 * 24;
                return new Date(new Date(new Date(item.addTime).Format("yyyy/MM/dd 00:00:00")).getTime() + daysTimes).Format("yyyy-MM-dd 23:59:59");
            }
        },

        // 
        stop: function stop() {
            var _this = this;

            this.$confirm('确认停用该优惠券吗？停用后该优惠券将整体作废，不能继续派发！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this.$http({
                    url: "/stop/coupon",
                    method: "GET",
                    params: {
                        id: _this.$route.query.id
                    }
                }).then(function (res) {
                    _this.getCouponDetail();
                    _this.$router.push({
                        name: "addcoupon",
                        query: {
                            type: "STOP"
                        }
                    });
                });
            });
        },
        filterCoupon: function filterCoupon(type) {
            this.filterStatus = type;
            this.currentPage = 1;
            this.getCouponDetail();
        },
        stopItem: function stopItem(item) {
            var _this2 = this;

            this.$confirm('确认操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.$http({
                    url: "/stop/member/coupon",
                    method: "GET",
                    params: {
                        id: item.id
                    }
                }).then(function (res) {
                    _this2.getCouponDetail();
                });
            });
        },
        searchVip: function searchVip() {
            var _this3 = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + "v1/pos/members",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    q: this.searchPhone
                }
            }).then(function (res) {
                _this3.searchData = res.data;
            });
        },

        //分页方法
        handleCurrentChange: function handleCurrentChange(val) {
            console.log('\u5F53\u524D\u9875: ' + val);
            this.getCouponDetail();
        },
        setNowSearchVip: function setNowSearchVip(item) {
            this.nowSelVip = item;
            this.searchData = [];
        },
        filter: function filter(type) {
            var timeRangeArr = [];
            this.nowSelFilter = type;
            switch (type) {
                case "today":
                    // this.yearMonth = new Date().Format("yyyy-MM");
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    // let year = new Date().Format("yyyy");
                    // let month = new Date().Format("MM");
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastDay":
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 00:00:00';
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "week":
                    timeRangeArr = this.$dateRange.getThisWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastWeek":
                    timeRangeArr = this.$dateRange.getLastWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "month":
                    timeRangeArr = this.$dateRange.getThisMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastMonth":
                    timeRangeArr = this.$dateRange.getLastMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                default:
                    break;
            }
        },

        // 搜索
        searchConfirm: function searchConfirm() {
            // 
            var timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
            var nowTime = new Date().getTime();
            if (!this.$canClickSelect("couponDetailTimeRange", timeStr, nowTime)) {
                this.$message({
                    message: '5秒内禁止重复查询相同数据',
                    customClass: 'error'
                });
                return;
            }
            // 
            if (new Date(this.endTime).getTime() - new Date(this.startTime).getTime() > 1000 * 60 * 60 * 24 * 35) {
                this.$message({
                    message: '只能查询35天内的数据',
                    customClass: 'error'
                });
                return;
            }
            if (this.startTime !== '' && this.endTime !== '') {
                if (new Date(this.startTime) > new Date(this.endTime)) {
                    this.$message({
                        message: '结束时间不能比开始时间小',
                        customClass: 'error'
                    });
                    return;
                }
                if (this.canClick) {
                    this.canClick = false;
                    this.getCouponDetail(0, this.dateStr, "ARB");
                }
            } else {
                this.$message({
                    message: '请选择查询时间段',
                    customClass: 'error'
                });
                return;
            }
        },
        getCouponDetail: function getCouponDetail() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            var _this4 = this;

            var date = arguments[1];
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "DAY";


            var params = void 0;

            params = {
                memberId: this.nowSelVip ? this.nowSelVip.id : "",
                couponId: this.$route.query.id,
                status: this.filterStatus,
                page: this.currentPage - 1,
                size: this.pageSize
            };

            this.$http({
                url: "/coupon/detail",
                method: "GET",
                params: params
            }).then(function (res) {
                setTimeout(function () {
                    _this4.canClick = true;
                }, 500);
                var body = res.data;
                console.log(res);
                _this4.couponList = body.data;
                _this4.totalElements = body.totalElements;
                var number = _this4.pageSize - _this4.couponList.length;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this4.couponList.push({});
                    }
                }
            }).catch(function (err) {
                setTimeout(function () {
                    _this4.canClick = true;
                }, 500);
            });
        }
    },
    activated: function activated() {
        for (var i = 0; i < this.pageSize; i++) {
            this.couponList.push({
                id: '', // 员工id
                name: '', // 员工姓名
                code: '', // 编号
                mobile: '', // 手机
                groupName: '' // 岗位id
            });
        }
        this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
        var year = new Date().Format("yyyy");
        var month = new Date().Format("MM");
        this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
        // 获取员工列表
        this.filterStatus = "NORMAL";
        this.getCouponDetail(0, this.dateStr, "ARB");
    },
    mounted: function mounted() {
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            nowSelFilter: "today",
            couponList: [],
            nowType: "TIME_RANGE",
            startTime: '', //按时间段查询的起始时间
            endTime: '', //按时间段查询的结束时间
            pickerOptions: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            dateStr: new Date().Format("yyyy-MM-dd"),
            currentPage: 1,
            totalElements: 0, //数据总条数
            canClick: true
        };
    },

    watch: {
        dateStr: function dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM-dd"));
            var nowDate = new Date(val).Format("yyyy-MM-dd");
            this.dateStr = nowDate;
            this.getCouponDetail(0, nowDate);
        }
    },
    methods: {
        filter: function filter(type) {
            var timeRangeArr = [];
            this.nowSelFilter = type;
            switch (type) {
                case "today":
                    // this.yearMonth = new Date().Format("yyyy-MM");
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    // let year = new Date().Format("yyyy");
                    // let month = new Date().Format("MM");
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastDay":
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 00:00:00';
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "week":
                    timeRangeArr = this.$dateRange.getThisWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastWeek":
                    timeRangeArr = this.$dateRange.getLastWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "month":
                    timeRangeArr = this.$dateRange.getThisMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastMonth":
                    timeRangeArr = this.$dateRange.getLastMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                default:
                    break;
            }
        },

        // 搜索
        searchConfirm: function searchConfirm() {
            // 
            var timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
            var nowTime = new Date().getTime();
            if (!this.$canClickSelect("couponDetailTimeRange", timeStr, nowTime)) {
                this.$message({
                    message: '5秒内禁止重复查询相同数据',
                    customClass: 'error'
                });
                return;
            }
            // 
            if (new Date(this.endTime).getTime() - new Date(this.startTime).getTime() > 1000 * 60 * 60 * 24 * 35) {
                this.$message({
                    message: '只能查询35天内的数据',
                    customClass: 'error'
                });
                return;
            }
            if (this.startTime !== '' && this.endTime !== '') {
                if (new Date(this.startTime) > new Date(this.endTime)) {
                    this.$message({
                        message: '结束时间不能比开始时间小',
                        customClass: 'error'
                    });
                    return;
                }
                if (this.canClick) {
                    this.canClick = false;
                    this.getCouponDetail(0, this.dateStr, "ARB");
                }
            } else {
                this.$message({
                    message: '请选择查询时间段',
                    customClass: 'error'
                });
                return;
            }
        },
        getCouponDetail: function getCouponDetail() {
            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            var _this = this;

            var date = arguments[1];
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "DAY";


            var params = void 0;
            if (type == "DAY") {
                params = {
                    storeId: this.curStoreId,
                    time: date,
                    type: type,
                    page: page,
                    size: this.pageSize
                };
            } else {
                var begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                var end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                params = {
                    storeId: this.curStoreId,
                    begin: begin,
                    end: end,
                    type: type,
                    page: page,
                    size: this.pageSize
                };
            }

            this.$http({
                url: "/coupon-instance",
                method: "GET",
                params: params
            }).then(function (res) {
                setTimeout(function () {
                    _this.canClick = true;
                }, 500);
                var body = res.data;
                _this.couponList = body;
                var number = _this.pageSize - _this.couponList.length;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this.couponList.push({});
                    }
                }
            }).catch(function (err) {
                setTimeout(function () {
                    _this.canClick = true;
                }, 500);
            });
        }
    },
    activated: function activated() {
        for (var i = 0; i < this.pageSize; i++) {
            this.couponList.push({
                id: '', // 员工id
                name: '', // 员工姓名
                code: '', // 编号
                mobile: '', // 手机
                groupName: '' // 岗位id
            });
        }
        this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
        var year = new Date().Format("yyyy");
        var month = new Date().Format("MM");
        this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
        // 获取员工列表
        this.getCouponDetail(0, this.dateStr, "ARB");
    },
    mounted: function mounted() {
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            nowSelGoods: undefined,
            goods: "",
            nowSelFilter: "today",
            verifiList: [], // 核销详情
            nowType: "TIME_RANGE",
            startTime: '', //按时间段查询的起始时间
            endTime: '', //按时间段查询的结束时间
            pickerOptions: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            dateStr: new Date().Format("yyyy-MM-dd"),
            currentPage: 1,
            totalElements: 0, //数据总条数
            canClick: true,
            goodSearchBtn: true,
            goodCheckArr: [],
            curGoodIdx: 0
        };
    },

    watch: {
        dateStr: function dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM-dd"));
            var nowDate = new Date(val).Format("yyyy-MM-dd");
            this.dateStr = nowDate;
            this.getVerifiInfo(0, nowDate);
        },

        goods: function goods(val) {
            if (val) {
                this.searchGoods(val, null);
            } else {
                this.goodCheckArr = [];
                this.goods = undefined;
                this.nowSelGoods = undefined;
                this.goodSearchBtn = true;
            }
        }
    },
    methods: {
        selSearchGood: function selSearchGood(item, boo) {
            var _this = this;

            this.goods = item.name;
            this.nowSelGoods = item;
            this.searchConfirm();
            // this.goodSearchBtn = false;
            setTimeout(function () {
                _this.goodCheckArr = [];
            }, 500);
        },

        // 
        searchGoods: function searchGoods(val, id) {
            var _this2 = this;

            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http.get('get/coupon/product?storeId=' + (id ? id : this.curStoreId)).then(function (res) {
                var filterRes = [];
                var tempVal = String(val).trim();
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        if (it.name.indexOf(tempVal) != -1) {
                            filterRes.push(it);
                        }
                    });
                }
                if (id) {
                    _this2.addGoodCheckArr = filterRes;
                    _this2.isAutoSearchBtn = false;
                    setTimeout(function () {
                        _this2.isAutoSearchBtn = true;
                    }, 2000);
                    setTimeout(function () {
                        var that = _this2;
                        $('.add_details_search li').hover(function () {
                            that.addCurGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.addCurGoodIdx = 0;
                        });
                    }, 0);
                } else {
                    _this2.goodCheckArr = filterRes;
                    setTimeout(function () {
                        var that = _this2;
                        $('.details_search li').hover(function () {
                            that.curGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.curGoodIdx = 0;
                        });
                    }, 0);
                }
                _this2.goodSearchBtn = true;
            }).catch(function () {
                _this2.goodSearchBtn = true;
            });
        },

        // 
        filter: function filter(type) {
            var timeRangeArr = [];
            this.nowSelFilter = type;
            switch (type) {
                case "today":
                    // this.yearMonth = new Date().Format("yyyy-MM");
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    // let year = new Date().Format("yyyy");
                    // let month = new Date().Format("MM");
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastDay":
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 00:00:00';
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "week":
                    timeRangeArr = this.$dateRange.getThisWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastWeek":
                    timeRangeArr = this.$dateRange.getLastWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "month":
                    timeRangeArr = this.$dateRange.getThisMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastMonth":
                    timeRangeArr = this.$dateRange.getLastMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                default:
                    break;
            }
        },

        //分页方法
        handleCurrentChange: function handleCurrentChange(val) {
            console.log('\u5F53\u524D\u9875: ' + val);
            console.log(this.dateStr);
            if (this.nowType == "DAY") {
                this.getVerifiInfo(val - 1, this.dateStr, "DAY");
            } else {
                this.getVerifiInfo(val - 1, this.dateStr, "ARB");
            }
        },

        // 搜索
        searchConfirm: function searchConfirm() {
            // 
            var timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
            var nowTime = new Date().getTime();
            if (!this.$canClickSelect("verifiCouponTimeRange", timeStr, nowTime)) {
                this.$message({
                    message: '5秒内禁止重复查询相同数据',
                    customClass: 'error'
                });
                return;
            }
            // 
            if (new Date(this.endTime).getTime() - new Date(this.startTime).getTime() > 1000 * 60 * 60 * 24 * 35) {
                this.$message({
                    message: '只能查询35天内的数据',
                    customClass: 'error'
                });
                return;
            }
            if (this.startTime !== '' && this.endTime !== '') {
                if (new Date(this.startTime) > new Date(this.endTime)) {
                    this.$message({
                        message: '结束时间不能比开始时间小',
                        customClass: 'error'
                    });
                    return;
                }
                if (this.canClick) {
                    this.canClick = false;
                    this.getVerifiInfo(0, this.dateStr, "ARB");
                }
            } else {
                this.$message({
                    message: '请选择查询时间段',
                    customClass: 'error'
                });
                return;
            }
        },
        // 获取核销详情
        getVerifiInfo: function getVerifiInfo(page, date) {
            var _this3 = this;

            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "DAY";

            var params = void 0;
            if (type == "DAY") {
                params = {
                    storeId: this.curStoreId,
                    time: date,
                    type: type,
                    page: page,
                    size: this.pageSize
                };
            } else {
                var beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                var endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                var productId = "";
                if (this.nowSelGoods) {
                    productId = this.nowSelGoods.id;
                }
                params = {
                    storeId: this.curStoreId,
                    beginTime: beginTime,
                    endTime: endTime,
                    // type,
                    // page,
                    // size: this.pageSize,
                    productId: productId
                };
            }

            this.$http({
                url: "get/coupon/product/list",
                method: "GET",
                params: params
            }).then(function (res) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
                var body = res.data;
                _this3.verifiList = body;
                var number = _this3.pageSize - _this3.verifiList.length;
                _this3.totalElements = res.data.totalElements;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this3.verifiList.push({
                            id: '', // 员工id
                            name: '', // 员工姓名
                            code: '', // 编号
                            mobile: '', // 手机
                            groupName: '' // 岗位id
                        });
                    }
                }
            }).catch(function (err) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
            });
        }
    },
    activated: function activated() {
        for (var i = 0; i < this.pageSize; i++) {
            this.verifiList.push({
                id: '', // 员工id
                name: '', // 员工姓名
                code: '', // 编号
                mobile: '', // 手机
                groupName: '' // 岗位id
            });
        }
        this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
        var year = new Date().Format("yyyy");
        var month = new Date().Format("MM");
        this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
        // 获取员工列表
        this.getVerifiInfo(0, this.dateStr, "ARB");
    },
    mounted: function mounted() {
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'storeData'],
    data: function data() {
        return {
            hasCall: "",
            url: '',
            configUrl: '',
            batUrl: '',
            options: [{
                value: '选项1',
                label: '360极速浏览器'
            }],
            value: ''
        };
    },

    methods: {
        getZip: function getZip() {
            this.$message({
                message: '下载中，请稍等...',
                customClass: 'success',
                duration: 5900
            });
            // this.$http({
            //     url:"/clientGet",
            //     method:"GET",
            //     params:{
            //         storeId:this.curStoreId,
            //         base:"huoxingy.zip",
            //     }
            // })
        },
        downLoadQrcodeForVip: function downLoadQrcodeForVip() {
            var qrcodeForVipDom = document.getElementById("qrcodeForVip");
            var cans = qrcodeForVipDom.children[0];
            // console.log(qrcodeForVipDom.children[0]);
            function imgType(ty) {
                var type = ty.toLowerCase().replace(/jpg/i, 'jpeg');
                var r = type.match(/png|jpeg|bmp|gif/)[0];
                return 'image/' + r;
            }
            var saveFile = function saveFile(data, fileName) {
                var save_link = document.createElement('a');
                save_link.href = data;
                save_link.download = fileName;
                // if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) { 
                //     console.log('ie')
                //     // return;
                //  }; //判断是否IE浏览器
                var event = document.createEvent('MouseEvents');
                event.initEvent("click", true, false);
                save_link.dispatchEvent(event);
            };
            var type = "png";
            var img_png_src = cans.toDataURL("image/png");
            var imgData = img_png_src.replace(imgType(type), 'image/octet-stream');
            var filename = '店铺会员二维码' + '.' + type; //下载图片的文件名
            saveFile(imgData, filename);
        },

        // 获取会员二维码
        getQrcodeForVip: function getQrcodeForVip() {
            this.$http({
                url: 'stores/' + this.curStoreId + '/QRCode',
                method: "POST"
                // params:{
                //     storeId:this.curStoreId
                // }
            }).then(function (res) {
                console.log(res);
                // $("#qrcodeForVip").qrcode({
                //     width:200,
                //     height:200,
                //     text:res.data.qrcode
                // })
                var qrcode = new QRCode("qrcodeForVip", {
                    text: res.data.qrcode,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H
                });
            });
        },
        browserDown: function browserDown() {
            console.log(this.value);
            window.location.herf = 'www.baidu.com';
        },

        // 复制数据
        copyData: function copyData(event) {
            $(event.target).prev().children('input')[0].select();
            document.execCommand("Copy"); // 执行浏览器复制命令
        },
        getQrcode: function getQrcode(foo) {
            var _this = this;

            $('#qrcode')[0].innerHTML = '';

            var qrcode = new QRCode("qrcode", {
                text: __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + 'wechat/member/openid?type=WECHAT-ORDER&storeId=' + this.curStoreId,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
            });

            setTimeout(function () {
                _this.downloadImg();
            }, 500);
        },

        // 下载图片
        downloadImg: function downloadImg() {
            this.oDownLoad($('.codeImg img')[0].src);
        },

        oDownLoad: function oDownLoad(url) {
            console.log(this.myBrowser());

            if (this.myBrowser() === "IE") {
                //IE  //|| myBrowser() === "Edge"
                // odownLoad.href = "#";

                // SaveAs5(url);
                downloadFile("微信点单二维码.jpg", url);
            } else {
                //!IE 
                var blob = this.base64Img2Blob(url);
                url = window.URL.createObjectURL(blob);

                $('#downloadImg').attr('href', url);
                $('#downloadImg').attr('download', '微信点单二维码');
            }
        },

        downloadFile: function downloadFile(fileName, content) {
            var blob = base64Img2Blob(content);
            //支持IE11  
            window.navigator.msSaveBlob(blob, fileName);
        },

        base64Img2Blob: function base64Img2Blob(code) {
            var parts = code.split(';base64,');
            var contentType = parts[0].split(':')[1];
            var raw = window.atob(parts[1]);
            var rawLength = raw.length;

            var uInt8Array = new Uint8Array(rawLength);

            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }

            return new Blob([uInt8Array], { type: contentType });
        },

        myBrowser: function myBrowser() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
            var isOpera = userAgent.indexOf("OPR") > -1;if (isOpera) {
                return "Opera";
            }; //判断是否Opera浏览器 OPR/43.0.2442.991  

            //if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) { return "IE"; }; //判断是否IE浏览器   

            if (userAgent.indexOf("Firefox") > -1) {
                return "FF";
            } //判断是否Firefox浏览器  Firefox/51.0  
            if (userAgent.indexOf("Trident") > -1) {
                return "IE";
            } //判断是否IE浏览器  Trident/7.0; rv:11.0  
            if (userAgent.indexOf("Edge") > -1) {
                return "Edge";
            } //判断是否Edge浏览器  Edge/14.14393  
            if (userAgent.indexOf("Chrome") > -1) {
                return "Chrome";
            } // Chrome/56.0.2924.87  
            if (userAgent.indexOf("Safari") > -1) {
                return "Safari";
            } //判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2  
        }

    },
    created: function created() {
        this.configUrl = __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/admin/clientGet?storeId=' + this.curStoreId + '&base=huoxingy.zip';
        // this.configUrl = `https://images.huoxingy.com/client/1072f5a6-f4ef-11e7-abdc-696684f6a39b.zip`;
        // if(this.storeData.clientUrl){
        //     this.configUrl = this.storeData.clientUrl;
        // }else{
        //     this.$http.get('/stores/'+this.curStoreId).then((res)=>{
        //         this.configUrl = res.data.clientUrl;
        //     });
        // }
        this.batUrl = 'http://hxypic.oss-cn-hangzhou.aliyuncs.com/client/' + this.curStoreId + '/ie.bat';
    },
    mounted: function mounted() {
        this.hasCall = sessionStorage.getItem("call");
        this.getQrcode();
        this.url = "https://pc-order.huoxingy.com?storeId=" + this.curStoreId + "&tableNo=";
        // 获取会员固定二维码
        this.getQrcodeForVip();
    }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            nowSelFilter: "month",
            nowType: "timeRange",
            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now() || time.getTime() < new Date('2017,01,01').getTime();
                }
            },
            pickerOptionsForTimeRange: {
                disabledDate: function disabledDate(time) {

                    //    let date = (new Date(time));
                    // //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
                    // //    let newDate = new Date(dateStr).getTime();
                    // //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
                    // //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
                    //     let curDate = (new Date()).getTime();
                    //     let three = 30 * 24 * 3600 * 1000;
                    //     let threeDays = curDate - three;
                    //     return time.getTime() > Date.now() || time.getTime() < threeDays;
                }
            },
            employeeInfo: {
                employeeName: '', //姓名
                productCount: '', //商品总数
                totalAmount: '', //
                totalElements: '', //
                totalPages: ''
            }, //订单信息
            commissionOrder: [], //订单数组
            openLoss: false, //订单详情弹出框
            moneyDetail: false, //总营业额详情弹出框
            moneyDetailData: [],
            nowMoneyDetailName: "",
            yearMonth: '', //年月
            startTime: '', //按时间段查询的起始时间
            endTime: '', //按时间段查询的结束时间
            achieveArr: [], //员工信息数组
            num: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'], //月份string
            curMonth: parseInt(new Date().getMonth() + 1), //当前月份
            curPage: 1, //当前页
            curSize: 10, //每页条数
            curEmployeeId: '', //当前员工id
            showChildIndex: -1
        };
    },

    watch: {
        nowType: function nowType(val) {
            this.achieveArr = [];
        }
    },
    methods: {
        filter: function filter(type) {
            var timeRangeArr = [];
            this.nowSelFilter = type;
            switch (type) {
                case "today":
                    // this.yearMonth = new Date().Format("yyyy-MM");
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    // let year = new Date().Format("yyyy");
                    // let month = new Date().Format("MM");
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "lastDay":
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 00:00:00';
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "week":
                    timeRangeArr = this.$dateRange.getThisWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "lastWeek":
                    timeRangeArr = this.$dateRange.getLastWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "month":
                    timeRangeArr = this.$dateRange.getThisMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "lastMonth":
                    timeRangeArr = this.$dateRange.getLastMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                default:
                    break;
            }
        },

        // 搜索
        searchConfirm: function searchConfirm() {

            // 
            var timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
            var nowTime = new Date().getTime();
            console.log();
            if (!this.$canClickSelect("achievement", timeStr, nowTime)) {
                this.$message({
                    message: '5秒内禁止重复查询相同数据',
                    customClass: 'error'
                });
                return;
            }
            // 


            if (this.startTime !== '' && this.endTime !== '') {
                if (new Date(this.startTime) > new Date(this.endTime)) {
                    this.$message({
                        message: '结束时间不能比开始时间小',
                        customClass: 'error'
                    });
                    return;
                }
                if (this.nowType == "month") {
                    this.getdata("MONTH");
                } else {
                    this.getdata(this.nowType);
                }
            } else {
                this.$message({
                    message: '请选择查询时间段',
                    customClass: 'error'
                });
                return;
            }
        },
        openMoneyDetail: function openMoneyDetail(item) {
            var _this = this;

            if (!item.id) {
                return;
            }

            // console.log(item.id);

            this.nowMoneyDetailName = item.employeeName;

            var year = this.yearMonth.split('-')[0];
            var month = this.yearMonth.split('-')[1];

            // console.log("year:"+year,"month:"+month);
            var params = void 0;
            if (this.nowType == "month") {
                params = {
                    year: year,
                    month: month,
                    storeId: this.curStoreId,
                    date: '' + year + month,
                    type: this.nowType == "month" ? "MONTH" : this.nowType
                };
            } else {
                var from = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                var to = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                params = {
                    year: year,
                    month: month,
                    storeId: this.curStoreId,
                    date: '' + year + month,
                    type: this.nowType == "month" ? "MONTH" : this.nowType,
                    from: from,
                    to: to
                };
            }

            this.$http({
                url: "/employees/" + item.id + "/sales-statics",
                params: params
            }).then(function (res) {
                // 
                var parentObj = {};
                var formatRes = [];
                if (res.data.items && Array.isArray(res.data.items) && res.data.items.length) {
                    res.data.items.forEach(function (it) {
                        if (it.parentTypeId && it.parentTypeId != "null") {
                            parentObj[it.parentTypeId] = {
                                amount: 0,
                                commission: 0,
                                qty: 0,
                                typeName: "",
                                data: []
                            };
                        } else {
                            formatRes.push(it);
                        }
                    });

                    var _loop = function _loop(k) {
                        res.data.items.forEach(function (it) {
                            if (it.parentTypeId == k) {
                                parentObj[k].data.push(it);
                                parentObj[k].amount += Number(it.amount);
                                parentObj[k].commission += Number(it.commission);
                                parentObj[k].qty += Number(it.qty);
                            }
                        });
                        if (parentObj[k].data && Array.isArray(parentObj[k].data) && parentObj[k].data.length) {
                            parentObj[k].typeName = parentObj[k].data[0].parentTypeName;
                        }
                    };

                    for (var k in parentObj) {
                        _loop(k);
                    }
                }
                // 
                var formatData = [];

                var _loop2 = function _loop2(k) {
                    var flag = false;
                    formatRes.forEach(function (it) {
                        if (it.typeId == k) {
                            flag = true;
                            if (parentObj[k].data && Array.isArray(parentObj[k].data) && parentObj[k].data.length) {
                                parentObj[k].data.sort(function (a, b) {
                                    return b.amount - a.amount;
                                });
                            }

                            it["data"] = parentObj[k].data;
                            it["qty"] = Number(parentObj[k].qty) + Number(it["qty"]);
                            it["diffQty"] = it["qty"] - parentObj[k].qty;
                            it["amount"] = Number(parentObj[k].amount) + Number(it["amount"]);
                            it["diffAmount"] = it["amount"] - parentObj[k].amount;
                            it["commission"] = Number(parentObj[k].commission) + Number(it["commission"]);
                            it["diffCommission"] = it["commission"] - parentObj[k].commission;
                        }
                    });
                    if (!flag) {
                        if (parentObj[k].data && Array.isArray(parentObj[k].data) && parentObj[k].data.length) {
                            parentObj[k].data.sort(function (a, b) {
                                return b.amount - a.amount;
                            });
                        }
                        formatRes.push(parentObj[k]);
                    }
                };

                for (var k in parentObj) {
                    _loop2(k);
                }

                // 
                console.log(parentObj);
                // formatRes = [...formatRes,...Object.values(parentObj)]
                console.log(formatRes);
                // 
                if (formatRes && Array.isArray(formatRes) && formatRes.length) {
                    formatRes.sort(function (a, b) {
                        return b.amount - a.amount;
                    });
                }

                _this.moneyDetailData = formatRes;
                // this.moneyDetailData = res.data.items;
                // console.log(res);
            });

            this.moneyDetail = true;
        },

        // 
        doShowChild: function doShowChild(ind) {
            if (this.showChildIndex == ind) {
                this.showChildIndex = -1;
                return;
            }
            this.showChildIndex = ind;
        },

        //日历插件 
        cutDataFn: function cutDataFn() {
            // console.log(this.yearMonth)
            if (!this.yearMonth) {
                this.curMonth = 'nan';
                return;
            }
            this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");
            this.curMonth = parseInt(this.yearMonth.split('-')[1]);
            this.getdata("MONTH");
        },

        //上月，下月按钮 
        cutMonth: function cutMonth(foo) {
            if (this.curMonth == 'nan') {
                this.$message({
                    message: '请选择时间',
                    customClass: 'error'
                });
                return;
            }
            this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM"); //给日期插件赋值为选择时间
            var year = this.yearMonth.split('-')[0]; //选择的年
            var month = this.yearMonth.split('-')[1]; //选则的月
            if (foo == 0) {
                //上月
                if (new Date('2017,01,01').Format("yyyy-MM") == new Date(this.yearMonth).Format("yyyy-MM")) {
                    this.$message({
                        message: '不能选择2017年以前的时间!',
                        customClass: 'error'
                    });
                    return;
                }
                this.curMonth--;
                if (this.curMonth == 0) {
                    year = parseInt(year) - 1;
                    this.curMonth = 12;
                }
            } else if (foo == 1) {
                //下月
                if (new Date().Format("yyyy-MM") == new Date(this.yearMonth).Format("yyyy-MM")) {
                    this.$message({
                        message: '已经是最新一个月了！',
                        customClass: 'error'
                    });
                    return;
                }
                this.curMonth++;
                if (this.curMonth == 13) {
                    year = parseInt(year) + 1;
                    this.curMonth = 1;
                }
            }
            this.yearMonth = year + '-' + this.num[parseInt(this.curMonth) - 1];
        },
        curPageFn: function curPageFn(foo) {
            // console.log(this.curEmployeeId);
            if (this.employeeInfo.totalPages <= 1) {
                return;
            }
            if (foo == 2) {
                if (this.curPage == 1) {
                    return;
                }
                this.curPage--;
            } else if (foo == 1) {
                if (this.curPage == this.employeeInfo.totalPages) {
                    return;
                }
                this.curPage++;
            }
            this.commissionDetail({ id: this.curEmployeeId });
        },

        //员工订单详情
        commissionDetail: function commissionDetail(item) {
            var _this2 = this;

            if (!item.id) {
                return;
            }
            console.log(item.id);
            console.log(item);
            this.commissionOrder = [];
            this.curEmployeeId = item ? item.id : this.curEmployeeId; //有item就更换员工id，没有就不改变。
            if (this.nowType == "month") {
                this.$http.get('employee-commission/' + this.curEmployeeId + '?year=' + this.yearMonth.split('-')[0] + '&month=' + this.yearMonth.split('-')[1] + '&page=' + (this.curPage - 1) + '&size=' + this.curSize + '&storeId=' + this.curStoreId + '&type=MONTH').then(function (res) {
                    _this2.openLoss = true;
                    _this2.commissionOrder = res.data;
                    _this2.employeeInfo = {
                        employeeName: item.employeeName,
                        productCount: item.qty,
                        totalAmount: item.totalCommission,
                        totalElements: res.data.totalElements,
                        totalPages: res.data.totalPages
                    };
                });
            } else {
                var from = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                var to = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                this.$http.get('employee-commission/' + this.curEmployeeId + '?year=' + this.yearMonth.split('-')[0] + '&month=' + this.yearMonth.split('-')[1] + '&page=' + (this.curPage - 1) + '&size=' + this.curSize + '&storeId=' + this.curStoreId + '&type=timeRange' + '&from=' + from + '&to=' + to).then(function (res) {
                    _this2.openLoss = true;
                    _this2.commissionOrder = res.data;
                    _this2.employeeInfo = {
                        employeeName: item.employeeName,
                        productCount: item.qty,
                        totalAmount: item.totalCommission,
                        totalElements: res.data.totalElements,
                        totalPages: res.data.totalPages
                    };
                });
            }
        },

        //导出按钮
        excel: function excel() {
            var data = void 0;
            if (!this.achieveArr.length) {
                this.$message({
                    message: '无数据可导出',
                    customClass: 'error'
                });
                return;
            }
            data = this.achieveArr;

            var html = '<tr>' + '<td style="font-size:18px">姓名</td>' + '<td style="font-size:18px">总订单量</td>' + '<td style="font-size:18px">总营业额</td>' + '<td style="font-size:18px">推荐会员数</td>' + '<td style="font-size:18px">提成金额</td>' + '</tr>';
            for (var i = 0; i < data.length; i++) {
                html += '<tr>' + '<td>' + data[i].employeeName + '</td>' + '<td>' + data[i].orderCount + '</td>' + '<td>' + data[i].totalAmount + '</td>' + '<td>' + data[i].addMemberNumber + '</td>' + '<td>' + data[i].totalCommission + '</td>' + '</tr>';
            }
            document.getElementById('scrollBox').innerHTML = html;
            window.method5(scrollBox);
        },

        //获取员工业绩数据
        getdata: function getdata(type) {
            var _this3 = this;

            var params = void 0;
            if (type == "MONTH") {
                params = {
                    storeId: this.curStoreId,
                    year: this.yearMonth.split('-')[0],
                    month: this.yearMonth.split('-')[1],
                    type: type
                };
            } else {
                var from = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                var to = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                params = {
                    storeId: this.curStoreId,
                    from: from,
                    to: to,
                    type: type
                };
            }
            this.$http({
                url: "employee-commission",
                method: "GET",
                params: params
            }).then(function (res) {
                for (var i = 0, len = res.data.length; i < len; i++) {
                    res.data[i].totalAmount = res.data[i].totalAmount.toFixed(2);
                }
                _this3.achieveArr = res.data;
                var number = _this3.pageSize - _this3.achieveArr.length;
                if (number > 0) {
                    for (var _i = 0; _i < number; _i++) {
                        _this3.achieveArr.push({
                            id: '', // 员工id
                            employeeName: '', // 员工姓名
                            employeeCode: '', // 编号
                            groupName: '', // 岗位名字
                            orderCount: '', // 总订单量
                            totalAmount: '', // 总营业额
                            totalCommission: '' // 提成金额
                        });
                    }
                }
            });
            // this.$http.get('employee-commission?storeId='+this.curStoreId+'&year='+this.yearMonth.split('-')[0]+'&month='+this.yearMonth.split('-')[1]).then((res)=>{
            //     for (let i = 0, len = res.data.length; i < len; i++) {
            //         res.data[i].totalAmount = res.data[i].totalAmount.toFixed(2);
            //     }
            //     this.achieveArr = res.data;
            //     let number = this.pageSize - this.achieveArr.length;
            //     if ( number > 0 ) {
            //         for (let i = 0; i < number; i++) {
            //             this.achieveArr.push({
            //                 id: '', // 员工id
            //                 employeeName: '', // 员工姓名
            //                 employeeCode: '', // 编号
            //                 groupName: '', // 岗位名字
            //                 orderCount: '', // 总订单量
            //                 totalAmount: '', // 总营业额
            //                 totalCommission: '', // 提成金额
            //             });
            //         }
            //     }
            // })
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.achieveArr.push({});
        }
        this.yearMonth = new Date().Format("yyyy-MM");
        this.startTime = new Date().Format("yyyy/MM") + '/01 00:00:00';
        var year = new Date().Format("yyyy");
        var month = new Date().Format("MM");
        this.endTime = new Date(year, month, 0).Format("yyyy/MM/dd") + ' 23:59:59';
    },

    activated: function activated() {
        // this.getdata("MONTH");
        this.getdata("timeRange");
    }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__urlConfig_index__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: { imgCrop: __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue___default.a },
    props: ['curStoreId', 'pageSize', 'storeData'],
    data: function data() {
        return {
            leaseProductEnabled: false,
            deliveryEnabled: false,
            isSendCodeBtn: true,
            isSendCodeTimer: 59,
            payUrlBtn: false,
            code: '',
            codeBtn: false,
            disclaimer: true,
            shopmanBtn: false,
            shopman: {
                wechatPayUrl: '', // 微信二维码
                aliPayUrl: '', // 支付宝二维码
                verifyCode: '' // 验证码
            },
            shopmanCtrol: true,
            addEmplVisible: false,
            employeeList: [], // 员工列表
            jobsList: [], // 岗位列表
            newEmployee: {
                id: '', // 员工id
                name: '', // 员工姓名
                code: '', // 编号
                mobile: '', // 手机
                storeId: this.curStoreId, // 商铺id
                groupId: '', // 岗位id
                verifyCode: '', // 验证码
                wechatPayUrl: '', // 微信二维码
                aliPayUrl: '', // 支付宝二维码
                target: '', // 销售目标
                photo: '',
                sendCouponEnabled: 0,
                deliveryEnabled: false,
                leaseEnabled: false
            },
            addEmployeeApiBtn: true, // 控制新增员工接口
            isEdter: false, //是否是修改员工


            coverImgMaxSize: 5 * 1024 * 1024, // 图片最大字节数
            oldImgBase64: '', // 原图base64
            showCrop: false, // 控制图片裁剪显示隐藏
            curCropW: 600, // 裁剪宽度
            curCropH: 600, // 裁剪高度
            infoload: false, // loading
            urlType: '', //收款码类型

            employeeStatus: true, //员工状态
            searchVal: "",
            oriEmps: []
        };
    },

    watch: {
        employeeStatus: function employeeStatus(val) {
            this.getEmployees();
        },
        searchVal: function searchVal(val, oldVal) {
            var _this = this;

            console.log("oldVal", oldVal);
            console.log("val", val);
            var flag = false;
            if (val.length - oldVal.length < 0) {
                flag = true;
            }
            if (val) {
                setTimeout(function () {
                    var employeeList = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.employeeList));
                    if (flag) {
                        employeeList = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.oriEmps));
                    }
                    var newList = employeeList.filter(function (it) {
                        if (it.name && it.name.indexOf(val) != -1 || it.mobile && it.mobile.indexOf(val) != -1) {
                            return it;
                        }
                    });

                    console.log(newList);

                    var number = _this.pageSize - newList.length;
                    if (number > 0) {
                        for (var i = 0; i < number; i++) {
                            newList.push({
                                id: '', // 员工id
                                name: '', // 员工姓名
                                code: '', // 编号
                                mobile: '', // 手机
                                groupName: '' // 岗位id
                            });
                        }
                    }
                    _this.employeeList = newList;
                }, 100);
            } else {
                // 获取员工列表
                this.getEmployees();
                // 获取岗位列表
                this.getJobsList();
            }
        }
    },
    methods: {
        // 删除图片
        delImg: function delImg(type) {
            if (type === 'wechat') {
                // console.log('微信');
                this.newEmployee.wechatPayUrl = '';
            } else if (type === 'ali') {
                // console.log('ali');
                this.newEmployee.aliPayUrl = '';
            } else if (type === 'bossWechat') {
                // console.log('bossWechat');
                this.shopman.wechatPayUrl = ''; // 微信二维码
            } else if (type === 'bossAli') {
                this.shopman.aliPayUrl = ''; // 
                // console.log('bossAli');
            }
        },

        //获取店主短信验证码
        getCode: function getCode() {
            var _this2 = this;

            this.$http.post(this.curStoreId + '/verify-code').then(function (res) {
                _this2.$message({
                    message: '发送成功！',
                    customClass: 'success'
                });
                _this2.isSendCodeBtn = false;
                var timer = void 0;
                timer = setInterval(function () {
                    _this2.isSendCodeTimer--;
                    if (_this2.isSendCodeTimer == 0) {
                        clearInterval(timer);
                        _this2.isSendCodeTimer = 59;
                        _this2.isSendCodeBtn = true;
                    }
                }, 1000);
            });
        },
        codeFn: function codeFn() {
            var _this3 = this;

            this.code = this.code.replace(/(^\s*)|(\s*$)/g, "");
            if (!/^\d{4}$/.test(this.code)) {
                this.$message({
                    message: '验证码格式有误！',
                    customClass: 'error'
                });
                return;
            }
            this.$http.post(this.curStoreId + '/validate-code', this.code).then(function (res) {
                localStorage.setItem('verifyCode', _this3.code);
                _this3.code = '';
                _this3.codeBtn = false;
                _this3.$message({
                    message: '操作成功！',
                    customClass: 'success'
                });
            });
        },

        //店主上传二维码
        shopmanShow: function shopmanShow() {
            var _this4 = this;

            this.$http.get(this.curStoreId + '/shopman').then(function (res) {
                if (res.data.wechatPayUrl) {
                    _this4.shopman.wechatPayUrl = res.data.wechatPayUrl;
                } else {
                    _this4.shopman.wechatPayUrl = '';
                }
                if (res.data.aliPayUrl) {
                    _this4.shopman.aliPayUrl = res.data.aliPayUrl;
                } else {
                    _this4.shopman.aliPayUrl = '';
                }
                _this4.disclaimer = true;
                _this4.shopmanBtn = true;
            });
        },

        //店主添加收款码
        shopmanFn: function shopmanFn() {
            var _this5 = this;

            if (!this.shopman.wechatPayUrl && !this.shopman.aliPayUrl) {
                this.$message({
                    message: '请上传收款二维码',
                    customClass: 'error'
                });
                return;
            }
            if (!this.shopmanCtrol) {
                return;
            }
            this.shopmanCtrol = false;
            this.shopman.verifyCode = localStorage.getItem('verifyCode', this.code);
            var body = this.shopman;
            this.$http.post(this.curStoreId + '/shopman', body).then(function (res) {
                _this5.shopman = {
                    wechatPayUrl: '', // 微信二维码
                    aliPayUrl: '' // 支付宝二维码
                };
                _this5.shopmanCtrol = true;
                _this5.shopmanBtn = false;
            }).catch(function (err) {
                _this5.shopmanCtrol = true;
            });
        },

        // 新增，更新员工
        addEmployee: function addEmployee() {
            var _this6 = this;

            if (!this.newEmployee.code) {
                this.$message({
                    message: '请输入员工工号',
                    customClass: 'error'
                });
                return;
            }
            if (!/^[a-zA-Z0-9]+$/.test(this.newEmployee.code)) {
                this.$message({
                    message: '工号仅允许字母和数字',
                    customClass: 'error'
                });
                return;
            }
            if (!this.newEmployee.name) {
                this.$message({
                    message: '请输入员工姓名',
                    customClass: 'error'
                });
                return;
            }
            if (!this.newEmployee.mobile) {
                this.$message({
                    message: '请输入员工电话',
                    customClass: 'error'
                });
                return;
            }

            // 手机号正则
            if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.newEmployee.mobile)) {
                this.$message({
                    message: '请正确输入员工电话',
                    customClass: 'error'
                });
                return;
            }
            // 

            if (!this.newEmployee.groupId) {
                this.$message({
                    message: '请选择岗位',
                    customClass: 'error'
                });
                return;
            }
            this.newEmployee.target = this.newEmployee.target.replace(/\s+/g, "");
            if (this.newEmployee.target && !/^[0-9]*[1-9][0-9]*$/.test(this.newEmployee.target)) {
                this.$message({
                    message: '员工业绩请输入正整数',
                    customClass: 'error'
                });
                return;
            }
            if (this.newEmployee.target > 200000) {
                this.$message({
                    message: '员工业绩线不能超过二十万',
                    customClass: 'error'
                });
                return;
            }
            if (!this.newEmployee.id) {
                this.newEmployee.id = this.$uuid.create(1).hex;
            }
            if (!this.addEmployeeApiBtn) {
                return;
            }
            this.newEmployee.verifyCode = localStorage.getItem('verifyCode', this.code);
            this.addEmployeeApiBtn = false;
            this.$http.put('/employees', this.newEmployee).then(function (res) {
                _this6.addEmplVisible = false;
                _this6.addEmployeeApiBtn = true;
                _this6.$message({
                    message: '操作成功！',
                    customClass: 'success'
                });
                _this6.getEmployees();
            }).catch(function (err) {
                _this6.addEmployeeApiBtn = true;
            });
        },
        // 获取员工列表
        getEmployees: function getEmployees() {
            var _this7 = this;

            var isEnabled = this.employeeStatus == true ? true : false;
            this.$http.get('/employees?storeId=' + this.curStoreId + '&enabled=' + isEnabled).then(function (res) {
                var body = res.data;
                // if ( body && body[0] ) {
                _this7.employeeList = body;
                // }
                _this7.oriEmps = body;
                var number = _this7.pageSize - _this7.employeeList.length;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this7.employeeList.push({
                            id: '', // 员工id
                            name: '', // 员工姓名
                            code: '', // 编号
                            mobile: '', // 手机
                            groupName: '' // 岗位id
                        });
                    }
                }
            }).catch(function (err) {});
        },
        // 获得当前员工信息
        getCurEmployee: function getCurEmployee(item) {
            this.newEmployee = {
                id: item.id, // 员工id
                name: item.name, // 员工姓名
                code: item.code, // 编号
                mobile: item.mobile, // 手机
                storeId: this.curStoreId, // 商铺id
                groupId: item.groupId, // 岗位id
                wechatPayUrl: item.wechatPayUrl, // 微信二维码
                aliPayUrl: item.aliPayUrl, // 支付宝二维码
                target: item.target <= 0 ? '' : item.target + '', // 销售目标
                photo: item.photo ? item.photo : "https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png",
                sendCouponEnabled: item.sendCouponEnabled ? 1 : 0,
                deliveryEnabled: item.deliveryEnabled,
                leaseEnabled: item.leaseEnabled
            };
            // if(item.aliPayUrl||item.wechatPayUrl){
            //     this.payUrlBtn = true;
            // }
            this.disclaimer = true;
            this.addEmplVisible = true;
            this.isEdter = true;
        },
        // 启用 禁用员工
        enabledEmployee: function enabledEmployee(item) {
            var _this8 = this;

            this.$http.post('/employees?id=' + item.id + '&status=' + !item.enabled, {}).then(function (res) {
                _this8.getEmployees();
            });
        },

        // 获取岗位列表
        getJobsList: function getJobsList() {
            var _this9 = this;

            this.$http.get('/employee-groups?storeId=' + this.curStoreId).then(function (res) {
                _this9.jobsList = res.data;
            }).catch(function (err) {});
        },
        // 清除信息
        clear: function clear() {
            this.newEmployee = {
                id: '', // 员工id
                name: '', // 员工姓名
                code: '', // 编号
                mobile: '', // 手机
                storeId: this.curStoreId, // 商铺id
                groupId: '', // 岗位id
                wechatPayUrl: '', // 微信二维码
                aliPayUrl: '', // 支付宝二维码
                target: '',
                photo: '',
                sendCouponEnabled: 0,
                deliveryEnabled: false,
                leaseEnabled: false
            };
            this.addEmplVisible = true;
            this.isEdter = false;
        },
        coverImg: function coverImg(e, type) {
            this.urlType = type;
            var reader = new FileReader();
            var that = this;
            var fileObj = e.target.files[0];

            if (e.target.files.length == 0) {
                return false;
            }

            // 判断图片大小
            if (fileObj.size > this.coverImgMaxSize) {
                this.errorMsg = '上传图片的大小不能超过5MB';
                this.openErrorTip = true;
                this.$message({
                    message: '上传图片的大小不能超过5MB',
                    customClass: 'error'
                });
                return false;
            }

            reader.onload = function (file) {
                return function (e) {
                    var that2 = this; // 缓存当前this
                    var img = new Image();
                    img.src = this.result;
                    img.onload = function () {
                        var imgBase64 = that2.result; //获得图片的base64的数据

                        // 判断是否是移动端设备
                        var sUserAgent = navigator.userAgent.toLowerCase();
                        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
                        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                        var bIsAndroid = sUserAgent.match(/android/i) == "android";
                        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                            that.mobileUploadImg(imgBase64);
                        } else {
                            that.oldImgBase64 = imgBase64;
                            that.showCrop = true;
                        }
                    };
                    $('.pcImgFile').val('');
                    $('.mobileImgFile').val('');
                };
            }(e.target.files[0]);
            reader.readAsDataURL(e.target.files[0]);
        },
        // 移动端上传图片
        mobileUploadImg: function mobileUploadImg(imgBase64) {
            var _this10 = this;

            this.infoload = true;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_2__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/image/json/upload?storeId=' + this.curStoreId, { file: imgBase64 }).then(function (res) {
                if (_this10.urlType == 'wechatPayUrl') {
                    _this10.newEmployee.wechatPayUrl = res.data.path;
                } else if (_this10.urlType == 'aliPayUrl') {
                    _this10.newEmployee.aliPayUrl = res.data.path;
                } else if (_this10.urlType == 'shopmanWechatPayUrl') {
                    _this10.shopman.wechatPayUrl = res.data.path;
                } else if (_this10.urlType == 'shopmanAliPayUrl') {
                    _this10.shopman.aliPayUrl = res.data.path;
                };
                _this10.infoload = false;
            }).catch(function () {
                _this10.infoload = false;
            });
        },
        // 获得裁剪后图片base64
        getCropImgBase: function getCropImgBase(imgUrl) {
            if (this.urlType == 'wechatPayUrl') {
                this.newEmployee.wechatPayUrl = imgUrl;
            } else if (this.urlType == 'aliPayUrl') {
                this.newEmployee.aliPayUrl = imgUrl;
            } else if (this.urlType == 'shopmanWechatPayUrl') {
                this.shopman.wechatPayUrl = imgUrl;
            } else if (this.urlType == 'shopmanAliPayUrl') {
                this.shopman.aliPayUrl = imgUrl;
            } else if (this.urlType == "avatar") {
                this.newEmployee.photo = imgUrl;
            };
        }
    },
    created: function created() {
        var _this11 = this;

        for (var i = 0; i < this.pageSize; i++) {
            this.employeeList.push({
                id: '', // 员工id
                name: '', // 员工姓名
                code: '', // 编号
                mobile: '', // 手机
                groupName: '' // 岗位id
            });
        }
        if (this.storeData && this.storeData.payMode == 'CASHIER') {
            this.payUrlBtn = true;
        } else {
            this.$http.get('/stores/' + this.curStoreId).then(function (res) {
                if (res.data.payMode == 'CASHIER') {
                    _this11.payUrlBtn = true;
                }
            });
        }
        // // this.payUrlBtn = true;
        // // 获取员工列表
        // this.getEmployees();
        // // 获取岗位列表
        // this.getJobsList();
    },
    activated: function activated() {
        var _this12 = this;

        console.log("kkk");
        // 获取员工列表
        this.getEmployees();
        // 获取岗位列表
        this.getJobsList();
        // 
        this.$http.get('/stores/' + this.curStoreId).then(function (res) {
            _this12.deliveryEnabled = res.data.deliveryEnabled;
            try {
                _this12.leaseProductEnabled = res.data.leaseProductEnabled;
            } catch (error) {}
        });
    },

    mounted: function mounted() {
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["curStoreId", "pageSize", "storeData"],
  data: function data() {
    return {
      name: null,
      showQrCode: false,
      wechatList: [],
      infoload: false, // loading
      codeBtn: false
    };
  },

  watch: {
    name: function name(val) {
      this.showQrCode = false;
      if (!val) {
        this.showQrCode = false;
      }
    },
    codeBtn: function codeBtn(val) {
      if (!val) {
        this.name = null;
        this.showQrCode = false;
      }
    }
  },
  methods: {
    doShowQrcode: function doShowQrcode() {
      this.showQrCode = false;
      this.getWechatCode();
    },
    doActive: function doActive(item) {
      var _this = this;

      this.$confirm("此操作将删除该微信绑定, 该微信将无法收到相关推送消息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.$http({
          url: "/open-enabled",
          method: "GET",
          params: {
            id: item.id,
            enabled: item.enabled ? false : true
          }
        }).then(function (res) {
          _this.$message({
            message: "操作成功",
            customClass: "success"
          });
          _this.getWechatList();
        });
      }).catch(function () {});
    },
    getWechatCode: function getWechatCode() {
      var _this2 = this;

      this.showQrCode = false;
      this.$http({
        url: "/openId",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          name: this.name
        }
      }).then(function (res) {
        _this2.showQrCode = true;
        setTimeout(function () {
          $("#qrcode")[0].innerHTML = "";

          var qrcode = new QRCode("qrcode", {
            text: res.data,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H
          });
        }, 900);
      });
    },
    getWechatList: function getWechatList() {
      var _this3 = this;

      this.$http({
        url: "/open-notice",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this3.wechatList = res.data;
        var number = _this3.pageSize - _this3.wechatList.length;
        if (number > 0) {
          for (var i = 0; i < number; i++) {
            _this3.wechatList.push({});
          }
        }
      });
    }
  },
  created: function created() {
    for (var i = 0; i < this.pageSize; i++) {
      this.wechatList.push({});
    }

    this.getWechatList();
  },
  mounted: function mounted() {
    // 改变关闭样式
    $(document).ready(function () {
      $(".el-dialog__headerbtn i").attr("class", "el-dialog__close iconfont icon-guanbi");
    });
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__urlConfig__ = __webpack_require__(6);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "goodsBigScreen",
  props: ["curStoreId"],
  data: function data() {
    return {
      isBold: "-1",
      makeBackUrl: {},
      textColor: "#333",
      allProductIds: [],
      typeId: "",
      systemData: [],
      typeList: [],
      tableDataForMeals: [],
      nowPage: 1,
      setMealIds: [],
      size: 1000,
      searchVal: "",
      curSelType: null,
      formInline: {
        user: "",
        region: ""
      },
      labelPosition: "right",
      newDiscount: {
        name: "",
        region: "",
        type: "",
        week: [],
        nowHours: "",
        tomorrowHour: "",
        discountMethod: ""
      },
      coverImgMaxSize: 15 * 1024 * 1024, // 图片最大字节数
      options: [],
      modifyDiscountItem: {},
      tableData: [],
      types: [],
      nowSelClassGoods: [],
      multipleSelection: [],
      multipleSelectionForMeal: [],
      totalPage: 0,
      totalElements: 0
    };
  },

  methods: {
    clearBg: function clearBg() {
      var _this = this;

      this.$confirm('确认恢复默认背景?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.upDateImage("");
        _this.textColor = "#333";
      });
    },

    //
    coverImg: function coverImg(e) {
      var reader = new FileReader();
      var that = this;
      var fileObj = e.target.files[0];

      if (e.target.files.length == 0) {
        return false;
      }

      // 判断图片大小
      if (fileObj.size > this.coverImgMaxSize) {
        this.errorMsg = "上传图片的大小不能超过15MB";
        this.openErrorTip = true;
        this.$message({
          message: "上传图片的大小不能超过15MB",
          customClass: "error"
        });
        return false;
      }

      reader.onload = function (file) {
        return function (e) {
          var that2 = this; // 缓存当前this
          var img = new Image();
          img.src = this.result;
          img.onload = function () {
            var imgBase64 = that2.result; //获得图片的base64的数据
            that.mobileUploadImg(imgBase64);
          };
          $(".pcImgFile").val("");
        };
      }(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    mobileUploadImg: function mobileUploadImg(imgBase64) {
      var _this2 = this;

      var loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$http.post(__WEBPACK_IMPORTED_MODULE_6__urlConfig__["b" /* API_BASE_URL */] + "v1/image/json/upload?storeId=" + this.curStoreId, {
        file: imgBase64
      }).then(function (res) {
        console.log(res.data.path);
        _this2.$message({ customClass: "success", message: "上传成功" });
        _this2.$nextTick(function () {
          var paramsInfo = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            bg: res.data.path,
            textColor: _this2.makeBackUrl.textColor,
            isBold: _this2.isBold
          });
          _this2.upDateImage(paramsInfo);
        });
        loading.close();
      }).catch(function () {
        loading.close();
      });
    },
    upDateImage: function upDateImage(makeBackUrl) {
      var _this3 = this;

      this.$http({
        url: "update/back",
        method: "POST",
        data: {
          storeId: this.curStoreId,
          makeBackUrl: makeBackUrl
        }
      }).then(function (res) {
        _this3.$message({
          message: "操作成功",
          customClass: "success"
        });
        _this3.getStoreInfo();
      });
    },

    // 
    openBigScreen: function openBigScreen() {
      window.open(this.bigScreenUrl, "_blank");
    },
    getRowKeys: function getRowKeys(row) {
      return row.productId;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSelectionChangeForMeal: function handleSelectionChangeForMeal(val) {
      this.multipleSelectionForMeal = val;
      console.log(val);
    },

    // 新增优惠方式
    save: function save() {
      var _this4 = this;

      var productIds = [];
      var schedulingEnabledProductIds = [];
      var notSchedulingEnabledProductIds = [];
      var notCatchGoodsIds = [];
      var setMealIds = [];
      // 
      if (this.tableData && Array.isArray(this.tableData)) {
        this.tableData.forEach(function (it) {
          if (it.makeEnable) {
            productIds.push(it.productId);
          }
        });
      }
      // 
      if (this.tableData && Array.isArray(this.tableData)) {
        this.tableData.forEach(function (it) {
          if (it.schedulingEnabled) {
            schedulingEnabledProductIds.push(it.productId);
          }
        });
      }
      // 
      // for (let j = 0; j < this.multipleSelection.length; j++) {
      //   productIds.push(this.multipleSelection[j].productId);
      // }
      for (var i = 0; i < this.multipleSelectionForMeal.length; i++) {
        setMealIds.push(this.multipleSelectionForMeal[i].productId);
      }
      // console.log("seled", this.multipleSelection);
      // let labels = [];
      // for (let i = 0; i < this.tableData.length; i++) {
      //   let obj = {
      //     labelEnabled:false,
      //     productId:this.tableData[i].productId
      //   }
      //   for(let j=0;j<this.multipleSelection.length;j++){
      //     if(this.multipleSelection[j].productId == this.tableData[i].productId){
      //       obj.labelEnabled = true;
      //     }
      //   }
      //   labels.push(obj);
      // }

      if (this.allProductIds && Array.isArray(this.allProductIds) && this.allProductIds.length) {
        if (productIds && Array.isArray(productIds)) {
          this.allProductIds.forEach(function (it) {
            if (productIds.indexOf(it) == -1) {
              notCatchGoodsIds.push(it);
            }
          });
        }
        // 
        if (schedulingEnabledProductIds && Array.isArray(schedulingEnabledProductIds)) {
          this.allProductIds.forEach(function (it) {
            if (schedulingEnabledProductIds.indexOf(it) == -1) {
              notSchedulingEnabledProductIds.push(it);
            }
          });
        }
        // 
      }
      // 
      try {
        var paramsInfo = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.makeBackUrl, {
          textColor: this.textColor,
          isBold: this.isBold
        }));
        console.log("paramsInfo", paramsInfo);
        console.log("makeBackUrl", this.makeBackUrl);
        this.upDateImage(paramsInfo);
      } catch (error) {
        console.log(error);
      }
      // 
      this.$http({
        url: "make",
        method: "POST",
        data: {
          productIds: productIds,
          makeEnabled: true
          // storeId: this.curStoreId,
        }
      }).then(function (res) {
        _this4.$message({
          message: "操作成功",
          customClass: "success"
        });
      });
      this.$http({
        url: "make",
        method: "POST",
        data: {
          productIds: notCatchGoodsIds,
          makeEnabled: false
          // storeId: this.curStoreId,
        }
      }).then(function (res) {});
      // 
      this.$http({
        url: "schedul",
        method: "POST",
        data: {
          productIds: schedulingEnabledProductIds,
          schedulingEnabled: true
          // storeId: this.curStoreId,
        }
      }).then(function (res) {
        // this.$message({
        //   message: "操作成功",
        //   customClass: "success",
        // });
      });
      this.$http({
        url: "schedul",
        method: "POST",
        data: {
          productIds: notSchedulingEnabledProductIds,
          schedulingEnabled: false
          // storeId: this.curStoreId,
        }
      }).then(function (res) {});
    },

    // 获取商品
    getGoods: function getGoods(page) {
      var _this5 = this;

      this.$http({
        url: "/products",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          isStock: -1,
          kitchen: -1,
          typeId: this.typeId
          // page,
          // size: this.size,
          // typeId:1,
        }
      }).then(function (res) {
        var goodsList = res.data;
        var newGoodsData = [];
        if (!_this5.allProductIds || !Array.isArray(_this5.allProductIds) || !_this5.allProductIds.length) {
          var allProductIds = [];
          for (var i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            allProductIds.push(goodsList[i].id);
            goodsList[i].isChecked = goodsList[i].makeEnabled;

            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          _this5.allProductIds = allProductIds;
        }

        for (var j = 0; j < goodsList.length; j++) {
          var obj = {
            price: goodsList[j].salesPrice,
            productId: goodsList[j].id,
            productName: goodsList[j].name,
            setMealEnabled: goodsList[j].setMealEnabled,
            setMealId: goodsList[j].setMealId,
            typeId: goodsList[j].typeId,
            typeName: goodsList[j].typeName,
            isChecked: goodsList[j].isChecked,
            makeEnable: goodsList[j].isChecked,
            schedulingEnabled: goodsList[j].schedulingEnabled,
            tips: goodsList[j].tips ? goodsList[j].tips : ["", ""]
          };
          newGoodsData.push(obj);
        }
        var arr = [];
        for (var _i = 0; _i < newGoodsData.length; _i++) {
          if (newGoodsData[_i].isChecked) {
            arr.push(newGoodsData[_i]);
          }
        }
        arr.forEach(function (item) {
          _this5.$refs.multipleTable.toggleRowSelection(item, true);
        });
        // this.goodsList = goodsList;
        _this5.tableData = newGoodsData;
        _this5.totalPage = res.data.totalPage;
        _this5.totalElements = res.data.totalElements;
        _this5.canChangePage = true;
        _this5.$forceUpdate();
      });
    },
    saveTips: function saveTips(row) {
      var _this6 = this;

      console.log(row);
      if (row.tips && Array.isArray(row.tips) && row.tips.length) {
        var flag = false;
        row.tips.forEach(function (it) {
          if (String(it).length > 12) {
            flag = true;
          }
        });
        if (flag) {
          this.$message({
            message: "商品描述限制在12字以内",
            customClass: "error"
          });
          return;
        }
      }
      if (row.productId) {
        this.$http({
          url: "/make/tips",
          method: "POST",
          data: {
            productId: row.productId,
            tips: row.tips
          }
        }).then(function (res) {
          _this6.$message({
            message: "操作成功",
            customClass: "success"
          });
        });
      }
    },
    getMeals: function getMeals(typeId) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.$http({
          url: "/meal/get-all-ps",
          method: "GET",
          params: {
            storeId: _this7.curStoreId,
            page: 0,
            size: _this7.size,
            typeId: typeId
          }
        }).then(function (res) {
          var goodsList = res.data.data;
          var newGoodsData = [];
          for (var i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            goodsList[i].isChecked = goodsList[i].wechatEnabled;
            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          for (var j = 0; j < goodsList.length; j++) {
            var obj = {
              price: goodsList[j].price,
              productId: goodsList[j].productId,
              productName: goodsList[j].productName,
              setMealEnabled: goodsList[j].setMealEnabled,
              setMealId: goodsList[j].setMealId,
              typeId: goodsList[j].typeId,
              typeName: goodsList[j].typeName,
              isChecked: goodsList[j].isChecked,
              tips: goodsList[j].tips
            };
            newGoodsData.push(obj);
          }
          resolve(newGoodsData);
          _this7.tableDataForMeals = newGoodsData;
        });
      });
    },
    getType: function getType() {
      var _this8 = this;

      this.$http({
        url: "product-types",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
          var typeList, systemData;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  typeList = [];
                  systemData = [];

                  if (res.data && res.data.data && Array.isArray(res.data.data)) {
                    typeList = res.data.data;
                  }
                  if (res.data && res.data.systemData && Array.isArray(res.data.systemData)) {
                    systemData = res.data.systemData;
                  }
                  _this8.typeList = typeList;
                  _this8.systemData = systemData;
                  // let funArr = [];
                  // for (let i = 0; i < res.data.length; i++) {
                  //   if (res.data[i].setMealEnabled) {
                  //     let fun = this.getMeals(res.data[i].id);
                  //     funArr.push(fun);
                  //   }
                  // }
                  // Promise.all(funArr)
                  //   .then((res) => {
                  //     console.log(res);
                  //     let mealsArr = [];
                  //     for (let i = 0; i < res.length; i++) {
                  //       mealsArr = mealsArr.concat(res[i]);
                  //     }
                  //     console.log(mealsArr);

                  //     let arr = [];
                  //     for (let i = 0; i < mealsArr.length; i++) {
                  //       if(mealsArr[i].isChecked){
                  //         arr.push(mealsArr[i]);
                  //       }
                  //     }
                  //     arr.forEach((item) => {
                  //       this.$refs.multipleTableForMeals.toggleRowSelection(item, true);
                  //     });

                  //     this.tableDataForMeals = mealsArr;
                  //   })
                  //   .catch((error) => {
                  //     console.log(error);
                  //   });

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this8);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getStoreInfo: function getStoreInfo() {
      var _this9 = this;

      this.$http({
        url: "stores/" + this.curStoreId,
        method: "GET"
      }).then(function (res) {
        if (res.data.makeBackUrl && res.data.makeBackUrl.indexOf("{") != -1) {
          _this9.makeBackUrl = JSON.parse(res.data.makeBackUrl);
          if (_this9.makeBackUrl.hasOwnProperty("textColor") && _this9.makeBackUrl.textColor) {
            _this9.textColor = _this9.makeBackUrl.textColor;
          }
          if (_this9.makeBackUrl.hasOwnProperty("isBold")) {
            _this9.isBold = _this9.makeBackUrl.isBold;
          } else {
            _this9.isBold = "-1";
          }
        } else {
          _this9.makeBackUrl = {
            bg: res.data.makeBackUrl,
            textColor: "#333",
            isBold: "-1" //-1不加粗,1加粗
          };
          _this9.textColor = _this9.makeBackUrl.textColor;
          _this9.isBold = _this9.makeBackUrl.isBold;
        }
      });
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this10.bigScreenUrl = window.location.origin + "/#/sys/" + _this10.curStoreId + "/goodsBigScreen";
              _this10.getGoods(0);
              _this10.getStoreInfo();
              _context2.next = 5;
              return _this10.getType();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this10);
    }))();
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__urlConfig__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "labelPrint",
  props: ["curStoreId"],
  data: function data() {
    return {
      allProductIds: [],
      typeId: "",
      systemData: [],
      typeList: [],
      tableDataForMeals: [],
      nowPage: 1,
      setMealIds: [],
      size: 1000,
      searchVal: "",
      curSelType: null,
      formInline: {
        user: "",
        region: ""
      },
      labelPosition: "right",
      newDiscount: {
        name: "",
        region: "",
        type: "",
        week: [],
        nowHours: "",
        tomorrowHour: "",
        discountMethod: ""
      },
      options: [],
      modifyDiscountItem: {},
      tableData: [],
      types: [],
      nowSelClassGoods: [],
      multipleSelection: [],
      multipleSelectionForMeal: [],
      totalPage: 0,
      totalElements: 0
    };
  },

  methods: {
    getRowKeys: function getRowKeys(row) {
      return row.productId;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSelectionChangeForMeal: function handleSelectionChangeForMeal(val) {
      this.multipleSelectionForMeal = val;
      console.log(val);
    },

    // 新增优惠方式
    save: function save() {
      var _this = this;

      var productIds = [];
      var notCatchGoodsIds = [];
      var setMealIds = [];
      for (var j = 0; j < this.multipleSelection.length; j++) {
        productIds.push(this.multipleSelection[j].productId);
      }
      for (var i = 0; i < this.multipleSelectionForMeal.length; i++) {
        setMealIds.push(this.multipleSelectionForMeal[i].productId);
      }
      // console.log("seled", this.multipleSelection);
      // let labels = [];
      // for (let i = 0; i < this.tableData.length; i++) {
      //   let obj = {
      //     labelEnabled:false,
      //     productId:this.tableData[i].productId
      //   }
      //   for(let j=0;j<this.multipleSelection.length;j++){
      //     if(this.multipleSelection[j].productId == this.tableData[i].productId){
      //       obj.labelEnabled = true;
      //     }
      //   }
      //   labels.push(obj);
      // }

      if (this.allProductIds && Array.isArray(this.allProductIds) && this.allProductIds.length) {
        if (productIds && Array.isArray(productIds)) {
          this.allProductIds.forEach(function (it) {
            if (productIds.indexOf(it) == -1) {
              notCatchGoodsIds.push(it);
            }
          });
        }
      }
      this.$http({
        url: "capture",
        method: "POST",
        data: {
          productIds: productIds,
          capture: true
          // storeId: this.curStoreId,
        }
      }).then(function (res) {
        _this.$message({
          message: "操作成功",
          customClass: "success"
        });
      });
      this.$http({
        url: "capture",
        method: "POST",
        data: {
          productIds: notCatchGoodsIds,
          capture: false
          // storeId: this.curStoreId,
        }
      }).then(function (res) {});
    },

    // 获取商品
    getGoods: function getGoods(page) {
      var _this2 = this;

      this.$http({
        url: "/products",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          isStock: -1,
          kitchen: -1,
          typeId: this.typeId
          // page,
          // size: this.size,
          // typeId:1,
        }
      }).then(function (res) {
        var goodsList = res.data;
        var newGoodsData = [];
        if (!_this2.allProductIds || !Array.isArray(_this2.allProductIds) || !_this2.allProductIds.length) {
          var allProductIds = [];
          for (var i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            allProductIds.push(goodsList[i].id);
            goodsList[i].isChecked = goodsList[i].capture;

            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          _this2.allProductIds = allProductIds;
        }

        for (var j = 0; j < goodsList.length; j++) {
          var obj = {
            price: goodsList[j].salesPrice,
            productId: goodsList[j].id,
            productName: goodsList[j].name,
            setMealEnabled: goodsList[j].setMealEnabled,
            setMealId: goodsList[j].setMealId,
            typeId: goodsList[j].typeId,
            typeName: goodsList[j].typeName,
            isChecked: goodsList[j].isChecked
          };
          newGoodsData.push(obj);
        }
        var arr = [];
        for (var _i = 0; _i < newGoodsData.length; _i++) {
          if (newGoodsData[_i].isChecked) {
            arr.push(newGoodsData[_i]);
          }
        }
        arr.forEach(function (item) {
          _this2.$refs.multipleTable.toggleRowSelection(item, true);
        });
        // this.goodsList = goodsList;
        _this2.tableData = newGoodsData;
        _this2.totalPage = res.data.totalPage;
        _this2.totalElements = res.data.totalElements;
        _this2.canChangePage = true;
      });
    },
    getMeals: function getMeals(typeId) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$http({
          url: "/meal/get-all-ps",
          method: "GET",
          params: {
            storeId: _this3.curStoreId,
            page: 0,
            size: _this3.size,
            typeId: typeId
          }
        }).then(function (res) {
          var goodsList = res.data.data;
          var newGoodsData = [];
          for (var i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            goodsList[i].isChecked = goodsList[i].wechatEnabled;
            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          for (var j = 0; j < goodsList.length; j++) {
            var obj = {
              price: goodsList[j].price,
              productId: goodsList[j].productId,
              productName: goodsList[j].productName,
              setMealEnabled: goodsList[j].setMealEnabled,
              setMealId: goodsList[j].setMealId,
              typeId: goodsList[j].typeId,
              typeName: goodsList[j].typeName,
              isChecked: goodsList[j].isChecked
            };
            newGoodsData.push(obj);
          }
          resolve(newGoodsData);
          _this3.tableDataForMeals = newGoodsData;
        });
      });
    },
    getType: function getType() {
      var _this4 = this;

      this.$http({
        url: "product-types",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
          var typeList, systemData;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  typeList = [];
                  systemData = [];

                  if (res.data && res.data.data && Array.isArray(res.data.data)) {
                    typeList = res.data.data;
                  }
                  if (res.data && res.data.systemData && Array.isArray(res.data.systemData)) {
                    systemData = res.data.systemData;
                  }
                  _this4.typeList = typeList;
                  _this4.systemData = systemData;
                  // let funArr = [];
                  // for (let i = 0; i < res.data.length; i++) {
                  //   if (res.data[i].setMealEnabled) {
                  //     let fun = this.getMeals(res.data[i].id);
                  //     funArr.push(fun);
                  //   }
                  // }
                  // Promise.all(funArr)
                  //   .then((res) => {
                  //     console.log(res);
                  //     let mealsArr = [];
                  //     for (let i = 0; i < res.length; i++) {
                  //       mealsArr = mealsArr.concat(res[i]);
                  //     }
                  //     console.log(mealsArr);

                  //     let arr = [];
                  //     for (let i = 0; i < mealsArr.length; i++) {
                  //       if(mealsArr[i].isChecked){
                  //         arr.push(mealsArr[i]);
                  //       }
                  //     }
                  //     arr.forEach((item) => {
                  //       this.$refs.multipleTableForMeals.toggleRowSelection(item, true);
                  //     });

                  //     this.tableDataForMeals = mealsArr;
                  //   })
                  //   .catch((error) => {
                  //     console.log(error);
                  //   });

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  activated: function activated() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this5.getGoods(0);
              _context2.next = 3;
              return _this5.getType();

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_url_js__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            addJobVisible: false,
            btn: false, //分类下拉三角样式
            typeData: [],
            obj: {
                name: '',
                id: '',
                arId: ''
            },
            typeBtn: '',
            typeName: '',
            addJobBtn: true,
            systemData: []
        };
    },

    methods: {
        //添加或者修改分类
        addJob: function addJob() {
            var _this = this;

            if (!this.obj.name) {
                this.$message({
                    message: '分类名称有误',
                    customClass: 'error'
                });
                return;
            }
            this.$set(this.obj, "name", this.obj.name.replace(/\s*/g, ""));
            if (this.typeBtn == 1) {
                var _data;

                //添加父类
                var data = (_data = {
                    "id": this.$uuid.create(1).hex,
                    "sequence": -1,
                    "name": this.obj.name
                }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_data, 'sequence', this.obj.sequence), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_data, "storeId", this.$route.params.id), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_data, "parentId", ''), _data);
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', data).then(function (res) {
                    _this.getDataList();
                    _this.addJobVisible = false;
                    _this.addJobBtn = true;
                }).catch(function () {
                    _this.addJobBtn = true;
                });
            } else if (this.typeBtn == 2) {
                //添加子类
                var _data2 = {
                    "id": this.$uuid.create(1).hex,
                    "name": this.obj.name,
                    "sequence": this.obj.sequence,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.id
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data2).then(function (res) {
                    _this.getDataList();
                    _this.addJobVisible = false;
                    _this.addJobBtn = true;
                }).catch(function () {
                    _this.addJobBtn = true;
                });
            } else if (this.typeBtn == 3) {
                //、、修改父类
                var _data3 = {
                    "id": this.obj.id,
                    "sequence": this.obj.sequence,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": ''
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data3).then(function (res) {
                    _this.getDataList();
                    _this.addJobVisible = false;
                    _this.addJobBtn = true;
                }).catch(function () {
                    _this.addJobBtn = true;
                });
            } else if (this.typeBtn == 4) {
                //、、修改子类
                var _data4 = {
                    "id": this.obj.id,
                    "name": this.obj.name,
                    "sequence": this.obj.sequence,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.arId
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data4).then(function (res) {
                    _this.getDataList();
                    _this.addJobVisible = false;
                    _this.addJobBtn = true;
                }).catch(function () {
                    _this.addJobBtn = true;
                });
            }
        },
        sortingChild: function sortingChild(boo, item, ind, pItem) {
            var _this2 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = pItem.children.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": pItem.children[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == pItem.children.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i = 0, _len = pItem.children.length; _i < _len; _i++) {
                    var _body = {
                        "productTypeId": pItem.children[_i].id,
                        "sequence": _i
                    };
                    list.push(_body);
                    if (ind == _i) {
                        list[_i].sequence = _i + 1;
                        num = _i + 1;
                    }
                    if (num == _i) {
                        list[num].sequence = _i - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this2.getDataList();
            }).catch(function (err) {});
        },

        //排序
        sorting: function sorting(boo, item, ind) {
            var _this3 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = this.typeData.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": this.typeData[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == this.typeData.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i2 = 0, _len2 = this.typeData.length; _i2 < _len2; _i2++) {
                    var _body2 = {
                        "productTypeId": this.typeData[_i2].id,
                        "sequence": _i2
                    };
                    list.push(_body2);
                    if (ind == _i2) {
                        list[_i2].sequence = _i2 + 1;
                        num = _i2 + 1;
                    }
                    if (num == _i2) {
                        list[num].sequence = _i2 - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this3.getDataList();
            }).catch(function (err) {});
        },
        getDataList: function getDataList() {
            var _this4 = this;

            this.$http.get('/product-types?storeId=' + this.$route.params.id + '&parentId=' + '').then(function (res) {
                var body = res.data.data;
                _this4.systemData = res.data.systemData;

                var newArr = [];
                for (var i = 0, len = body.length; i < len; i++) {
                    if (!body[i].parent) {
                        body[i].isOpen = false;
                        newArr.push(body[i]);
                        newArr[newArr.length - 1].children = [];
                        for (var j = 0, _len3 = body.length; j < _len3; j++) {
                            if (body[j].parent && body[i].id == body[j].parent.id) {
                                newArr[newArr.length - 1].children.push(body[j]);
                            }
                        }
                    }
                }
                var sequenceArr = []; //排序数组

                for (var _i3 = 0, _len4 = newArr.length; _i3 < _len4; _i3++) {
                    for (var _j = 0, _len5 = newArr.length; _j < _len5; _j++) {
                        if (newArr[_j].sequence == _i3) {
                            sequenceArr.push(newArr[_j]);
                        }
                    }
                }
                // 
                for (var _i4 = 0; _i4 < sequenceArr.length; _i4++) {
                    if (sequenceArr.children && sequenceArr.children.length) {
                        var tempArr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sequenceArr.children));
                        tempArr.sort(function (a, b) {
                            return a.sequence - b.sequence;
                        });
                        sequenceArr.children = tempArr;
                    }
                }
                // 
                _this4.typeData = sequenceArr;
            }).catch(function (err) {});
        },
        addClassify: function addClassify(id) {
            //添加分类
            this.typeName = "添加分类";
            this.obj = {
                name: '',
                id: '',
                arId: ''
            };
            this.addJobVisible = true;
            this.obj.id = id ? id : '';
            this.typeBtn = id ? 2 : 1;
        },
        upClassify: function upClassify(item, oitem) {
            //修改分类
            this.typeName = "修改分类";
            this.obj = {
                name: oitem ? oitem.name : item.name,
                id: oitem ? oitem.id : item.id,
                sequence: oitem ? oitem.sequence : item.sequence,
                arId: item.id
            };
            oitem ? '' : this.obj.sequence = item.sequence;
            this.addJobVisible = true;
            this.typeBtn = oitem ? 4 : 3;
        },
        delClassify: function delClassify(item, oitem) {
            var _this5 = this;

            this.$confirm('\u662F\u5426\u5220\u9664 ' + (oitem ? oitem.name + ' 分类?' : item.name + ' 分类及该类下所有子分类?'), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除分类
                _this5.$http.delete('/product-types?id=' + (oitem ? oitem.id : item.id)).then(function (res) {
                    _this5.getDataList();
                });
            }).catch(function () {});
        },
        handle: function handle(item, ind) {
            if (this.typeData[ind].isOpen) {
                this.btn = !this.btn;
            } else {
                this.btn = true;
            }
            for (var i = 0, len = this.typeData.length; i < len; i++) {
                this.typeData[i].isOpen = false;
            }
            this.typeData[ind].isOpen = true;
        }
    },
    activated: function activated() {
        var _this6 = this;

        //就怕sequence会大于数组的长度
        this.$http.get('/product-types?storeId=' + this.$route.params.id + '&parentId=' + '').then(function (res) {
            console.log(res.data);
            var body = res.data.data;
            _this6.systemData = res.data.systemData;
            var newArr = [];
            for (var i = 0, len = body.length; i < len; i++) {
                if (!body[i].parent) {
                    body[i].isOpen = false;
                    newArr.push(body[i]);
                    newArr[newArr.length - 1].children = [];
                    for (var j = 0, _len6 = body.length; j < _len6; j++) {
                        if (body[j].parent && body[i].id == body[j].parent.id) {
                            newArr[newArr.length - 1].children.push(body[j]);
                        }
                    }
                }
            }
            var list = [];
            for (var _i5 = 0, _len7 = newArr.length; _i5 < _len7; _i5++) {
                var bodys = {
                    "productTypeId": newArr[_i5].id,
                    "sequence": _i5
                };
                list.push(bodys);
            }
            if (!list.length) {
                return;
            }
            _this6.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this6.getDataList();
            }).catch(function (err) {});
        }).catch(function (err) {});
    }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            nowSelGoods: null,
            goodSearchBtn: true,
            curGoodIdx: 0, // 当前商品索引
            goodCheckArr: [],
            goods: "",
            // 
            stockArr: [],
            showStock: false,
            nowTypeName: '', //当前所选择的分类的名字
            nowItem: [
                // {
                //     amount: 0,
                //     name: "",
                //     qty: 0,
                //     seTypeName: "",
                //     typeName: ""
                // }
            ], //用户点击交班的分类的时候，所点击的分类下的商品
            showPutAllMask: false, //交班明细控制按钮
            showPutAllMask1: false, //销售明细控制按钮
            showPutAllMask2: false, //员工销售明细控制按钮
            workData: [],
            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0, //总共条

            getBtn: true, // 控制翻页请求

            inventoryList: [], //交班明细
            workDetailId: '', //某班id

            salesData: { cost: '', net: { qty: 0, amount: 0 }, itemDetails: [{ amount: 0, name: "", qty: 0, seTypeName: "", typeName: "" }] }, //销售明细
            salesCurPage: 0, //销售明细的当前页码

            staffArr: [], //员工销售明细
            curWorkData: {
                "cashAmount": '',
                "alipayAmount": '',
                "wechatAmount": '',
                "alipayCashAmount": '',
                "wechatCashAmount": '',
                "memberAmount": '',
                "couponAmount": ''
            } // 当前查看班次的数据

        };
    },

    watch: {
        goods: function goods(val) {
            if (val) {
                this.searchGoods(val, null);
            } else {
                this.goodCheckArr = [];
                this.nowSelGoods = null;
                this.curPage = 0;
                this.getAllData();
            }
        }
    },
    methods: {
        selSearchGood: function selSearchGood(item) {
            this.nowSelGoods = item;
            this.goodCheckArr = [];
            this.curPage = 0;
            this.getWordData();
        },

        // 商品检索
        searchGoods: function searchGoods(val, id) {
            var _this = this;

            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http.get('products/stores-search?storeId=' + (id ? id : this.curStoreId) + '&stockEnabled=false' + '&q=' + encodeURI(val)).then(function (res) {
                if (id) {
                    _this.addGoodCheckArr = res.data;
                    _this.isAutoSearchBtn = false;
                    setTimeout(function () {
                        _this.isAutoSearchBtn = true;
                    }, 2000);
                    setTimeout(function () {
                        var that = _this;
                        $('.add_details_search li').hover(function () {
                            that.addCurGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.addCurGoodIdx = 0;
                        });
                    }, 0);
                } else {
                    _this.goodCheckArr = res.data;
                    setTimeout(function () {
                        var that = _this;
                        $('.details_search li').hover(function () {
                            that.curGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.curGoodIdx = 0;
                        });
                    }, 0);
                }
                _this.goodSearchBtn = true;
            }).catch(function () {
                _this.goodSearchBtn = true;
            });
        },

        // 
        cutStockDetail: function cutStockDetail(item) {
            var _this2 = this;

            this.$http({
                url: "workStock/list",
                method: "GET",
                params: {
                    id: item.id
                }
            }).then(function (res) {
                console.log(res);
                _this2.showStock = true;
                _this2.stockArr = res.data;
            });
        },

        //关闭销售明细时的回调，用于清空当前销售明细的数据
        closeSaleDetail: function closeSaleDetail() {
            this.salesData = { cost: '', net: { qty: 0, amount: 0 }, itemDetails: [{ amount: 0, name: "", qty: 0, seTypeName: "", typeName: "" }] };
            this.nowTypeName = "";
        },

        //获取当前分类下的商品销售情况
        getNowTypeProducts: function getNowTypeProducts(name) {
            var _this3 = this;

            this.nowItem = [];
            console.log(name);
            if (this.nowTypeName === name || name === "") {
                this.nowTypeName = '';
                return;
            }
            this.nowTypeName = name;
            this.$http({
                url: "get-itemDetails",
                method: "GET",
                params: {
                    id: this.curWorkData.id,
                    storeId: this.curStoreId,
                    typeName: name
                }
            }).then(function (res) {
                _this3.nowItem = res.data;
                console.log(res);
            });
        },

        //列表翻页
        changePage: function changePage(boo) {
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            if (this.nowSelGoods) {
                this.getWordData();
            } else {
                this.getAllData();
            }
        },
        getAllData: function getAllData() {
            var _this4 = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.$http.get('/product/transaction/list?storeId=' + this.curStoreId + '&page=' + this.curPage + '&size=' + this.pageSize).then(function (res) {
                _this4.workData = res.data.content;
                _this4.totalPage = res.data.totalPages;
                _this4.totalElements = res.data.totalElements;
                if (_this4.workData.length < _this4.pageSize) {
                    for (var i = 0, len = _this4.pageSize - _this4.workData.length; i < len; i++) {
                        _this4.workData.push({});
                    }
                }
                // for(let i = 0,len=this.workData.length;i<len;i++){
                //     if(this.workData[i].id){
                //         this.workData[i].turnInAmount = this.workData[i].turnInAmount.toFixed(2);
                //         this.workData[i].cashAmount = this.workData[i].cashAmount.toFixed(2);
                //         this.workData[i].wechatAmount = this.workData[i].wechatAmount.toFixed(2);
                //         this.workData[i].alipayAmount = this.workData[i].alipayAmount.toFixed(2);
                //         this.workData[i].memberAmount = this.workData[i].memberAmount.toFixed(2);
                //         this.workData[i].wechatCashAmount = this.workData[i].wechatCashAmount.toFixed(2);
                //         this.workData[i].alipayCashAmount = this.workData[i].alipayCashAmount.toFixed(2);
                //     }
                // }
                _this4.getBtn = true;
            }).catch(function () {
                _this4.getBtn = true;
            });
        },
        getWordData: function getWordData() {
            var _this5 = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.$http.get('/product/transaction?productId=' + this.nowSelGoods.id + '&page=' + this.curPage + '&size=' + this.pageSize).then(function (res) {
                _this5.workData = res.data.content;
                _this5.totalPage = res.data.totalPages;
                _this5.totalElements = res.data.totalElements;
                if (_this5.workData.length < _this5.pageSize) {
                    for (var i = 0, len = _this5.pageSize - _this5.workData.length; i < len; i++) {
                        _this5.workData.push({});
                    }
                }
                // for(let i = 0,len=this.workData.length;i<len;i++){
                //     if(this.workData[i].id){
                //         this.workData[i].turnInAmount = this.workData[i].turnInAmount.toFixed(2);
                //         this.workData[i].cashAmount = this.workData[i].cashAmount.toFixed(2);
                //         this.workData[i].wechatAmount = this.workData[i].wechatAmount.toFixed(2);
                //         this.workData[i].alipayAmount = this.workData[i].alipayAmount.toFixed(2);
                //         this.workData[i].memberAmount = this.workData[i].memberAmount.toFixed(2);
                //         this.workData[i].wechatCashAmount = this.workData[i].wechatCashAmount.toFixed(2);
                //         this.workData[i].alipayCashAmount = this.workData[i].alipayCashAmount.toFixed(2);
                //     }
                // }
                _this5.getBtn = true;
            }).catch(function () {
                _this5.getBtn = true;
            });
        },

        //销售明细
        cutSalesDetail: function cutSalesDetail(item) {
            var _this6 = this;

            this.curWorkData = item;
            this.$http.get('workshift/' + item.id + '/details').then(function (res) {
                _this6.salesData = res.data;
                _this6.showPutAllMask1 = true;
            });
        },

        //员工业绩
        getStaff: function getStaff(item) {
            var _this7 = this;

            this.$http.get('workshift/' + item.id + '/staff').then(function (res) {
                _this7.staffArr = res.data;
                _this7.showPutAllMask2 = true;
                for (var i = 0, len = _this7.staffArr.length; i < len; i++) {
                    _this7.staffArr[i].totalAmount = _this7.staffArr[i].totalAmount.toFixed(2);
                }
            });
        },

        // 销售导出excel
        sales2Excel: function sales2Excel() {
            var _this8 = this;

            this.$http.get('get-excel?id=' + this.curWorkData.id).then(function (res) {
                var types = res.data.types;
                var coupons = res.data.coupons;

                var domstr = '<table style="border-collapse: collapse;">';
                domstr += '<tr>\n                                <th style="font-size:18px">\u5546\u54C1\u540D\u79F0</th>\n                                <th style="font-size:18px">\u552E\u4EF7</th>\n                                <th style="font-size:18px">\u6570\u91CF</th>\n                                <th style="font-size:18px">\u603B\u8BA1</th>\n                            </tr>';
                for (var i = 0, len = types.length; i < len; i++) {
                    domstr += '<tr>\n                                <td colspan="3" style="text-align:center;font-size:16px">---' + types[i].typeName + '---</td>\n                                <td style="font-size:16px;color:red">\uFFE5' + types[i].amount / 100 + '</td>\n                            </tr>';
                    for (var j = 0, len2 = types[i].products.length; j < len2; j++) {
                        domstr += '<tr>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].productName + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].amount / (types[i].products[j].quantity * 100) + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].quantity + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].amount / 100 + '</td>\n                                </tr>';
                    }
                }

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="7" style="font-size:18px;font-weight:900;text-align:center">\u603B\u9500\u552E\u989D</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:18px;">\u73B0\u91D1</td>\n                                <td style="font-size:18px;">\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u4F1A\u5458\u652F\u4ED8</td>\n                                <td style="font-size:18px;">\u4F18\u60E0\u5238\u62B5\u6263</td>\n                            </tr>\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.alipayAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.wechatAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.alipayCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.wechatCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.memberAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.couponAmount / 100 + '</td>\n                            </tr>\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td style="border:1px solid #ccc;font-weight:900;font-size:18px">\u603B\u9500\u552E\u989D\uFF1A</td>\n                                <td style="border:1px solid #ccc;font-size:20px;color:red;font-weight:600">' + _this8.curWorkData.turnInAmount + '</td>\n                            </tr>';

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="7" style="font-size:18px;font-weight:900;text-align:center">\u7F51\u8D39\u9500\u552E\u989D</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:18px;">\u73B0\u91D1</td>\n                                <td style="font-size:18px;">\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u4F1A\u5458\u652F\u4ED8</td>\n                                <td style="font-size:18px;">\u4F18\u60E0\u5238\u62B5\u6263</td>\n                            </tr>\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.cashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.alipayAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.wechatAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.alipayCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.wechatCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.memberAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.couponAmount / 100 + '</td>\n                            </tr>\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td style="border:1px solid #ccc;font-weight:900;font-size:18px">\u603B\u9500\u552E\u989D\uFF1A</td>\n                                <td style="border:1px solid #ccc;font-size:20px;color:red;font-weight:600">' + _this8.salesData.cost.turnInAmount / 100 + '</td>\n                            </tr>';

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="3" style="text-align:center;font-size:18px;font-weight:900">\u4F18\u60E0\u5238\u6838\u9500\u8BB0\u5F55</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:16px;font-weight:700;">\u4F18\u60E0\u5238\u540D\u79F0</td>\n                                <td style="font-size:16px;font-weight:700;">\u6570\u91CF</td>\n                                <td style="font-size:16px;font-weight:700;">\u603B\u91D1\u989D</td>\n                            </tr>';
                for (var i = 0, len = coupons.length; i < len; i++) {
                    domstr += '\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].productName + '</td>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].quantity + '</td>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].amount / 100 + '</td>\n                            </tr>';
                }
                domstr += '</table>';

                window.method5($(domstr)[0]);
            });
        },
        // 员工导出excel
        staff2Excel: function staff2Excel() {
            if (!this.staffArr[0]) {
                this.$message({
                    message: '无数据可导出',
                    customClass: 'error'
                });
                return;
            }

            var data = this.staffArr;
            var domstr = '<table style="border-collapse: collapse;">';
            domstr += '<tr>\n                            <th style="font-size:16px">\u5458\u5DE5\u540D\u79F0</th>\n                            <th style="font-size:16px">\u8BA2\u5355\u6570\u91CF</th>\n                            <th style="font-size:16px">\u9500\u552E\u91D1\u989D</th>\n                        </tr>';
            for (var i = 0, len = data.length; i < len; i++) {
                domstr += '<tr>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].creatorName + '</td>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].orderCount + '</td>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].totalAmount + '</td>\n                        </tr>';
            }

            domstr += '</table>';

            window.method5($(domstr)[0]);
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.workData.push({});
        }
    },
    activated: function activated() {
        this.getAllData();
        // console.log(this.$route)
    }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_imgCrop_imgCrop_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_imgCrop_imgCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_imgCrop_imgCrop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__urlConfig_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_selGoods_selGoods__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_selGoods_selGoods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_selGoods_selGoods__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_selPeiGoods_selGoods__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_selPeiGoods_selGoods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_selPeiGoods_selGoods__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selSpec_selGoods__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selSpec_selGoods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_selSpec_selGoods__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    components: { imgCrop: __WEBPACK_IMPORTED_MODULE_5__components_imgCrop_imgCrop_vue___default.a, selGoods: __WEBPACK_IMPORTED_MODULE_7__components_selGoods_selGoods___default.a, selPeiGoods: __WEBPACK_IMPORTED_MODULE_8__components_selPeiGoods_selGoods___default.a, selSpec: __WEBPACK_IMPORTED_MODULE_9__components_selSpec_selGoods___default.a },
    props: ['curStoreId'],
    data: function data() {
        return {
            tbForm: {
                storeIds: []
            },
            shareGoods: false,
            storeList: [],
            // 
            seledSpec: [],
            showSpec: false,
            specList: [],
            uploadSpecs: [],
            seledNorSpec: [],
            autoSpec: "",
            seledPeiGoods: [],
            showPei: false,
            showMat: false,
            specs: [],
            normalSpecs: ["冷", "热", "常温", "微辣", "中辣", "不辣", "加糖", "不加糖", "加冰", "不加冰"],
            seledMats: [],
            isAllWeek: false,
            weeks: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"],
            timeChoiceBtnForComm: false,
            printEr: [],
            pcEnable: true,
            pcBuyEnable: true,
            disCom: 0, //开启折扣价后的提成金额
            beginTime: "",
            endTime: "",
            // croseDay:false,
            discountEnable: false,
            discountPrice: 100, //折扣价格
            vipEnable: false,
            vipPrice: "", //会员价格
            systemData: [],
            timeList: [],
            timeChoice: '',
            timeChoiceForComm: ["", ""],
            timeChoiceBtn: false,
            newTimeList: [],
            newTimeListForComm: [{
                commission: "",
                timeRange: []
            }], //提成时间段
            checkeds: false,
            isStock: 'ON', //是否库存管理
            kitchenPrintEnabled: 'OFF', //是否厨房打印
            isDirectThermal: 'OFF', // 是否贴纸打印
            dialogVisible: false,
            newGoods: {
                timeRangeComm: false,
                sort: 0,
                salesCount: 0,
                salesShowEnabled: false,
                salesEnabled: false,
                // 
                labelEnabled: 0, //标签打印
                id: '', // 员工id
                productTypeId: '', // 员工id
                name: '', // 员工姓名
                barCode: '', // 条码
                // costPrice: '', // 进价
                salesPrice: '', // 出售价
                storeId: this.curStoreId, // 商铺id
                inStockNumber: '', // 库存
                supplierName: '', // 供应商
                supplyTimeEnd: '', // 起售时间
                supplyTimeBegin: '', // 止售时间
                productStatus: 'ON', // 状态
                imageURL: '', // 图片路径
                // stockQuantityRatio: '', // 每件多少个
                commission: '0', //提成价格，默认为0
                productQty: 1, //商品数量默认为1
                ipId: "",
                threshold: 0, //库存告警值
                note: "",
                week: [],
                // openMatchEnabled:false,
                specIds: []
            },
            vipData: [], //所有商品列表
            goodsNum: {
                pageNum: 1,
                pageSize: 6,
                total: 0
            },
            btnId: '', //添加或修改商品按钮
            addId: '',
            coverImgMaxSize: 20 * 1024 * 1024, // 图片最大字节数
            oldImgBase64: '', // 原图base64
            showCrop: false, // 控制图片裁剪显示隐藏
            curCropW: 600, // 裁剪宽度
            curCropH: 600, // 裁剪高度
            infoload: false, // loading

            addGoodApiBtn: true, // 控制添加商品接口

            goodCheckArr: [],
            addGoodCheckArr: [], //添加商品搜索出来的商品列表
            isAutoSearchBtn: true, //添加商品是否开启检索
            addCurGoodIdx: 0, // 当前商品索引
            goods: '',
            curGoodIdx: 0, // 当前商品索引
            goodSearchBtn: true,

            fliter_type: '', // 当前筛选条件
            fliter_status: '', // 当前筛选条件
            fliter_stock: '', // 当前筛选条件
            fliter_kitchen: '', // 当前筛选条件
            typeList: [],
            multipleSelection: [],
            matData: [],
            unitOptions: [],
            unitFormat: {},
            // 
            jobTypeList: [],
            newJobListForComm: [{
                commission: "",
                groupId: "",
                id: ""
            }]
        };
    },

    watch: {
        // "newGoods.timeRangeComm":function(val){
        //     if(val){
        //        $("#comm").parents(".msgItem").css("margin-bottom",this.newTimeListForComm.length * 25);
        //     }else{
        //         this.newTimeListForComm = [];
        //     }
        // },
        // newTimeListForComm:function(val){
        //     // if(this.newTimeListForComm.length){
        //        $("#comm").parents(".msgItem").css("margin-bottom",val.length * 25);
        //     // }
        // },
        newTimeList: function newTimeList(val) {
            // if(this.newTimeListForComm.length){
            console.log($("#timeSales").parents(".msgItem").css("margin-bottom", val.length * 25));
            // }
        },
        goods: function goods(val) {
            if (val) {
                this.searchGoods(val, null);
            } else {
                this.goodCheckArr = [];
                this.getGoodsData();
            }
        },
        'newGoods.name': function newGoodsName(val) {
            if (val) {
                // if(this.isAutoSearchBtn){
                this.searchGoods(val, '9f5afd60-e952-11e7-a26a-83436326b6c5');
                // }else {

                // }
            } else {
                this.addGoodCheckArr = [];
                // this.getGoodsData();
            }
        },
        timeChoice: function timeChoice(val) {
            if (val == '') {
                return;
            }
            if (this.newTimeList.length >= 3) {
                this.$message({
                    message: '最多只能添加3个时间段',
                    customClass: 'error'
                });
                this.timeChoice = '';
                return;
            }
            for (var i = 0; i < this.timeList.length; i++) {
                if (val == this.timeList[i].id) {

                    var isPush = true;
                    for (var j = 0; j < this.newTimeList.length; j++) {
                        if (this.newTimeList[j].id == val) {
                            isPush = false;
                            this.$message({
                                message: '已经有该时段',
                                customClass: 'error'
                            });
                        }
                    }
                    if (isPush) {
                        this.newTimeList.push(this.timeList[i]);
                    }
                }
            }
            this.timeChoiceBtn = false;
            this.timeChoice = '';
        },

        // timeChoiceForComm(val){
        //     console.log(val)
        //     return;
        //     if(val==''){
        //         return;
        //     }
        //     if(this.newTimeListForComm.length>=5){
        //         this.$message({
        //             message: '最多只能添加5个时间段',
        //             customClass: 'error'
        //         })
        //         this.timeChoiceForComm = '';
        //         return;
        //     }
        //     this.newTimeListForComm.push(val); 
        //     this.timeChoiceForComm = '';
        // }
        dialogVisible: function dialogVisible(val) {
            if (!val) {
                this.seledMats = [];
                this.seledPeiGoods = [];
                this.seledSpec = [];
            }
        }
    },
    methods: {
        modifyNorSpecs: function modifyNorSpecs(tag) {
            console.log(tag);
            var seledNorSpec = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.seledNorSpec));
            if (seledNorSpec.indexOf(tag) != -1) {
                seledNorSpec.splice(seledNorSpec.indexOf(tag), 1);
            } else {
                seledNorSpec.push(tag);
            }
            this.seledNorSpec = seledNorSpec;
        },
        modifySpec: function modifySpec(type, index) {
            var specs = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.specs));
            if (type == "add") {
                if (!String(this.autoSpec).trim()) {
                    this.$message({
                        message: '请输入规格名称',
                        customClass: 'error'
                    });
                    return;
                }
                specs.push(this.autoSpec);
                this.autoSpec = '';
            } else if (type == "del") {
                specs.splice(index, 1);
            }
            this.specs = specs;
        },

        // 
        getJobType: function getJobType() {
            var _this = this;

            this.$http.get('/employee-groups?storeId=' + this.curStoreId).then(function (res) {
                _this.jobTypeList = res.data;
            }).catch(function (err) {});
        },
        delJobComList: function delJobComList(item, index) {
            var newJobListForComm = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.newJobListForComm));
            newJobListForComm.splice(index, 1);
            this.newJobListForComm = newJobListForComm;
        },

        // 
        delTimeList: function delTimeList(item, index) {
            var newTimeListForComm = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.newTimeListForComm));
            newTimeListForComm.splice(index, 1);
            this.newTimeListForComm = newTimeListForComm;
        },

        // 
        closeSpec: function closeSpec(tag) {
            console.log(tag);
            var seledSpec = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.seledSpec));
            var index = void 0;
            var flag = false;
            if (seledSpec && Array.isArray(seledSpec) && seledSpec.length) {
                seledSpec.forEach(function (it, ind) {
                    if (it.id == tag.id) {
                        index = ind;
                        flag = true;
                    }
                });
            }
            seledSpec.splice(index, 1);
            this.seledSpec = seledSpec;
        },

        // 
        closePei: function closePei(tag) {
            console.log(tag);
            var seledPeiGoods = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.seledPeiGoods));
            var index = void 0;
            var flag = false;
            if (seledPeiGoods && Array.isArray(seledPeiGoods) && seledPeiGoods.length) {
                seledPeiGoods.forEach(function (it, ind) {
                    if (it.id == tag.id) {
                        index = ind;
                        flag = true;
                    }
                });
            }
            seledPeiGoods.splice(index, 1);
            this.seledPeiGoods = seledPeiGoods;
            console.log(this.btnId);
            if (flag && this.btnId) {
                this.delPeiGoods(tag);
            }
        },
        delPeiGoods: function delPeiGoods(tag) {
            var _this2 = this;

            this.$http({
                url: "match/product/delete",
                method: "POST",
                data: {
                    productId: this.btnId,
                    matchProductId: tag.id
                }
            }).then(function (res) {
                _this2.$message({
                    message: '操作成功',
                    customClass: 'success'
                });
            });
        },
        addPeiGoods: function addPeiGoods() {
            this.showPei = true;
        },
        saveSeledMats: function saveSeledMats() {
            var seledMats = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.seledMats));
            var willbeSel = this.multipleSelection;
            seledMats = willbeSel;
            this.seledMats = seledMats;
            console.log(seledMats);
            this.showMat = false;
        },
        getUnitList: function getUnitList() {
            var _this3 = this;

            this.$http({
                url: "material/unit/list",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this3.unitOptions = res.data;
                var unitFormat = {};
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        unitFormat[it.id] = it.name;
                    });
                }
                console.log(unitFormat);
                _this3.unitFormat = unitFormat;
                _this3.getDataList();
            });
        },
        getDataList: function getDataList() {
            var _this4 = this;

            this.$http({
                url: "material/search/list",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this4.matData = res.data;
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        addSpec: function addSpec() {
            this.showSpec = true;
            // this.getUnitList();
        },
        addMatGoods: function addMatGoods() {
            this.showMat = true;
            // this.getUnitList();
        },
        handleChangeWeeks: function handleChangeWeeks(value) {
            console.log(value);
            // this.newGoods.week = value;
        },
        handleChangeWeeksAll: function handleChangeWeeksAll(val) {
            if (this.isAllWeek) {
                this.newGoods.week = this.weeks;
            } else {
                this.newGoods.week = [];
            }
        },
        addCommJob: function addCommJob() {
            var obj = {
                commission: "",
                groupId: "",
                id: ""
            };
            this.newJobListForComm.push(obj);
        },
        addCommTime: function addCommTime() {
            var obj = {
                commission: "",
                timeRange: []
            };
            this.newTimeListForComm.push(obj);
        },
        setTimeForComm: function setTimeForComm() {
            console.log(new Date(this.timeChoiceForComm[0]).Format("hh:mm"));
            if (this.newTimeListForComm.length >= 5) {
                this.$message({
                    message: '最多只能添加5个时间段',
                    customClass: 'error'
                });
                this.timeChoiceForComm = '';
                return;
            }
            var obj = {
                commPrice: "",
                start: "",
                end: ""
            };
            this.newTimeListForComm.push(obj);
            this.timeChoiceForComm = '';
        },

        // 获取打印数据
        getPrintIpInfo: function getPrintIpInfo() {
            var _this5 = this;

            this.$http({
                url: "ip-list",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this5.printEr = res.data;
                console.log(res);
            });
        },

        // 隐藏添加商品、修改商品时的商品名字检索
        hideSearchList: function hideSearchList() {
            this.addGoodCheckArr = [];
        },

        // 删除修改商品时的图片
        delImg: function delImg() {
            this.$refs.goodsImg.src = 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
            this.newGoods.imageURL = 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
        },
        selSearchGood: function selSearchGood(item, boo) {
            var _this6 = this;

            this.$http.get(item.id + '/product').then(function (res) {
                if (boo == 'add') {
                    console.log(res.data);
                    _this6.addGoodCheckArr = [];
                    _this6.addId = item.id;
                    _this6.newGoods = {
                        // barCode       : res.data.barCode,
                        // salesPrice    : res.data.salesPrice,
                        // inStockNumber : res.data.inStockNumber,
                        // supplierName  : res.data.supplierName,
                        name: res.data.name,
                        imageURL: res.data.imageURL,
                        productQty: 1,
                        sort: 0,
                        productStatus: 'OFF',
                        labelEnabled: 0,
                        timeRangeComm: false,
                        salesEnabled: false,
                        // stockQuantityRatio : res.data.stockQuantityRatio,
                        commission: 0,
                        week: res.data.week ? Array.isArray(res.data.week) ? res.data.week : res.data.week.split(",") : []
                        // productQty:res.data.productQty
                    };
                    _this6.timeChoiceBtn = false;
                    _this6.isStock = 'OFF';
                    _this6.vipEnable = false;
                    _this6.kitchenPrintEnabled = 'OFF';
                    _this6.isDirectThermal = 'OFF';
                    _this6.dialogVisible = true;
                    _this6.pcEnable = true;
                    _this6.pcBuyEnable = true;
                    _this6.addCurGoodIdx = 0;
                    _this6.discountEnable = false;
                } else if (boo == 'search') {
                    _this6.goodCheckArr = [];
                    _this6.vipData = [res.data];
                    if (_this6.vipData.length < 6) {
                        for (var i = 0, len = 6 - _this6.vipData.length; i < len; i++) {
                            _this6.vipData.push({});
                        }
                    }
                }
            });
        },

        // 商品检索
        searchGoods: function searchGoods(val, id) {
            var _this7 = this;

            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http.get('products/stores-search?storeId=' + (id ? id : this.curStoreId) + '&stockEnabled=false' + '&q=' + encodeURI(val)).then(function (res) {
                if (id) {
                    _this7.addGoodCheckArr = res.data;
                    _this7.isAutoSearchBtn = false;
                    setTimeout(function () {
                        _this7.isAutoSearchBtn = true;
                    }, 2000);
                    setTimeout(function () {
                        var that = _this7;
                        $('.add_details_search li').hover(function () {
                            that.addCurGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.addCurGoodIdx = 0;
                        });
                    }, 0);
                } else {
                    _this7.goodCheckArr = res.data;
                    setTimeout(function () {
                        var that = _this7;
                        $('.details_search li').hover(function () {
                            that.curGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.curGoodIdx = 0;
                        });
                    }, 0);
                }
                _this7.goodSearchBtn = true;
            }).catch(function () {
                _this7.goodSearchBtn = true;
            });
        },

        //删除时段
        removeTimes: function removeTimes(item) {
            for (var i = 0; i < this.newTimeList.length; i++) {
                if (this.newTimeList[i].id == item.id) {
                    this.newTimeList.splice(i, 1);
                }
            }
        },

        //删除时段
        removeTimesForComm: function removeTimesForComm(item) {
            for (var i = 0; i < this.newTimeListForComm.length; i++) {
                if (this.newTimeListForComm[i].id == item.id) {
                    this.newTimeListForComm.splice(i, 1);
                }
            }
        },
        addTimesForComm: function addTimesForComm() {
            this.timeChoiceBtnForComm = true;
        },

        //添加时段
        addTimes: function addTimes(item) {
            this.timeChoiceBtn = true;
        },

        // 获取时段列表
        getTimesList: function getTimesList() {
            var _this8 = this;

            this.$http.get('/product-supply-time?storeId=' + this.curStoreId).then(function (res) {
                var body = res.data;
                if (body && body[0]) {
                    _this8.timeList = body;
                }
            }).catch(function (err) {});
        },
        selOkForSpec: function selOkForSpec(data) {
            console.log(data);
            this.seledSpec = data.nowSelectGoods;
            this.showSpec = false;
        },
        selOkForPei: function selOkForPei(data) {
            console.log(data);
            this.seledPeiGoods = data.nowSelectGoods;
            this.showPei = false;
        },
        selOk: function selOk(data) {
            console.log(data);
            this.seledMats = data.nowSelectGoods;
            this.showMat = false;
        },
        uploadGood: function uploadGood(item) {
            var _this9 = this;

            //修改商品
            this.btnId = item.id;
            this.addGoodCheckArr = [];
            this.isAutoSearchBtn = false;
            if (item.specs && Array.isArray(item.specs)) {
                var norArr = [];
                var tempSpec = [];
                item.specs.forEach(function (it) {
                    if (_this9.normalSpecs.indexOf(it) != -1) {
                        norArr.push(it);
                    } else {
                        tempSpec.push(it);
                    }
                });
                this.seledNorSpec = norArr;
                this.specs = tempSpec;
            }
            // 
            var specIds = [];
            if (item.productSpecs && Array.isArray(item.productSpecs) && item.productSpecs.length) {
                item.productSpecs.forEach(function (it) {
                    specIds.push(it.id);
                });
                this.seledSpec = item.productSpecs;
            }
            // 
            this.newGoods = {
                productTypeId: item.typeId,
                barCode: item.barCode,
                // costPrice     : item.costPrice,
                salesPrice: item.salesPrice,
                inStockNumber: item.inStockNumber,
                supplierName: item.supplierName,
                name: item.name,
                imageURL: item.imageURL,
                // productStatus : item.productStatus?'OFF':'ON',
                // stockQuantityRatio : item.stockQuantityRatio,
                commission: item.commission,
                memberShow: item.memberShow,
                disShow: item.disShow,
                productQty: item.productQty,
                labelEnabled: item.labelEnabled ? 1 : 0,
                ipId: item.ipId == 0 ? "" : item.ipId,
                threshold: item.threshold, //库存告警值
                // 
                sort: item.sort,
                salesCount: item.salesCount,
                salesShowEnabled: item.salesShowEnabled,
                salesEnabled: item.salesEnabled,
                timeRangeComm: item.openTimeEnabled,
                note: item.note,
                week: item.week ? item.week.split(",") : [],
                // 
                postEnabled: item.postEnabled,
                // 
                specIds: specIds
            };
            console.log(this.newGoods);
            if (this.newGoods.week && this.newGoods.week.length && this.newGoods.week.length == 7) {
                this.isAllWeek = true;
            } else {
                this.isAllWeek = false;
            }
            if (item.productMaterialItems && Array.isArray(item.productMaterialItems) && item.productMaterialItems.length) {
                item.productMaterialItems.forEach(function (it) {
                    it.formId = it.id;
                    it.name = it.productMaterialName;
                    it.count = it.qty;
                });
            }
            this.seledMats = item.productMaterialItems;
            var newTimeListForComm = [];
            for (var _i = 0; _i < item.list.length; _i++) {
                var obj = {
                    commission: item.list[_i].commission,
                    timeRange: [new Date("2020/01/01 " + item.list[_i].begin), new Date("2020/01/01 " + item.list[_i].end)]
                };
                if (item.list[_i].begin == "aN:aN:00" || item.list[_i].end == "aN:aN:59") {
                    obj = {
                        commission: item.list[_i].commission,
                        timeRange: ["", ""]
                    };
                }

                newTimeListForComm.push(obj);
            }
            this.newTimeListForComm = newTimeListForComm;
            //岗位提成信息 
            var newJobListForComm = [];
            for (var _i2 = 0; _i2 < item.postCommissions.length; _i2++) {
                var _obj = {
                    commission: item.postCommissions[_i2].commission,
                    groupId: item.postCommissions[_i2].groupId,
                    id: item.postCommissions[_i2].id
                };

                newJobListForComm.push(_obj);
            }
            this.newJobListForComm = newJobListForComm;
            // 
            if (item.supplyTimes) {
                this.newTimeList = [];
                var supplyTimes = JSON.parse(item.supplyTimes);
                for (var i = 0; i < supplyTimes.length; i++) {
                    if (supplyTimes[i].id) {
                        this.newTimeList.push(supplyTimes[i]);
                    }
                }
            } else {
                this.newTimeList = [];
            }
            this.timeChoiceBtn = false;
            this.isStock = item.stockEnabled ? 'ON' : 'OFF';
            this.kitchenPrintEnabled = item.kitchenPrintEnabled ? 'ON' : 'OFF';
            this.isDirectThermal = item.isDirectThermal ? 'ON' : 'OFF';
            this.getPeiWithGoods(item);
            // this.dialogVisible = true ;
            // 
            this.vipEnable = item.memberShow; //是否开启会员价格
            this.vipPrice = item.memberPrice; //会员价格
            this.discountEnable = item.disShow; //是否开启折扣
            this.discountPrice = item.disPrice * 100; //折扣百分比
            var dateForBeg = new Date("2018-11-11 " + item.nowHours);
            var dateForEnd = new Date("2018-11-11 " + item.tomorrowHour);
            this.beginTime = dateForBeg; //折扣起始时间
            this.endTime = dateForEnd; //折扣终止时间
            this.disCom = item.disCom;
            // this.croseDay = item.cross;//折扣时间是否跨天s

            // 是否显示在客户端和是否是否允许购买
            this.pcEnable = item.showEnabled;
            this.pcBuyEnable = item.purchaseEnabled;
        },
        getPeiWithGoods: function getPeiWithGoods(item) {
            var _this10 = this;

            this.$http({
                url: "match/product/list",
                method: "POST",
                data: {
                    productId: item.id
                }
            }).then(function (res) {
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        it.count = 1;
                    });
                }
                _this10.seledPeiGoods = res.data ? res.data : [];
                _this10.dialogVisible = true;
            });
        },

        //初始化 商品数据
        initDate: function initDate() {
            this.timeChoiceBtn = false;
            this.isAutoSearchBtn = true;
            this.btnId = null;
            this.addId = null;
            this.tbForm = {
                storeIds: []
            };
            this.newGoods = {
                id: '', // 员工id
                productTypeId: '', // 商品id
                name: '', // 员工姓名
                barCode: '', // 条码
                // costPrice: '', // 进价
                salesPrice: '', // 出售价
                storeId: this.curStoreId, // 商铺id
                inStockNumber: '', // 库存
                supplierName: '', // 供应商
                productStatus: 'ON', // 状态
                imageURL: '', // 图片路径
                // stockQuantityRatio : '',
                commission: '0', //商品提成
                productQty: 1, //默认商品数量
                labelEnabled: 0,
                ipId: "",
                threshold: 0,
                // 
                sort: 0,
                salesCount: 0,
                salesShowEnabled: false,
                salesEnabled: false,
                timeRangeComm: false,
                note: "",
                week: [],
                postEnabled: false,
                // openMatchEnabled:false,
                specIds: []
            };

            this.newTimeList = [];
            this.newTimeListForComm = [{
                commission: "",
                timeRange: []
            }];
            // 
            this.newJobListForComm = [{
                commission: "",
                groupId: "",
                id: ""
            }];
            // 
            this.isStock = 'OFF';
            // 
            this.discountEnable = false;
            this.vipEnable = false;
            this.discountPrice = 100, this.vipPrice = "";
            this.beginTime = "";
            this.endTime = "";
            this.disCom = 0;
            this.seledMats = [];
            this.seledSpec = [];
            this.seledPeiGoods = [];
            // 
        },
        addGoods: function addGoods() {
            //点击添加商品，清空 newGoods并获取获取商品分类
            this.dialogVisible = true;
            this.initDate();
        },

        // 筛选商品
        fliterGoods: function fliterGoods() {
            var _this11 = this;

            var fliter_stock = '-1';
            var fliter_kitchen = '-1';
            if (this.fliter_stock == 'true') {
                fliter_stock = 1;
            } else if (this.fliter_stock == 'false') {
                fliter_stock = 0;
            }
            if (this.fliter_kitchen == 'true') {
                fliter_kitchen = 1;
            } else if (this.fliter_kitchen == 'false') {
                fliter_kitchen = 0;
            }

            this.$http.get('/products?storeId=' + this.curStoreId + '&typeId=' + this.fliter_type + '&isStock=' + fliter_stock + '&kitchen=' + fliter_kitchen).then(function (res) {
                _this11.vipData = res.data;
                _this11.goodsNum.total = res.data.length;
                if (_this11.vipData.length < 6) {
                    for (var i = 0, len = 6 - _this11.vipData.length; i < len; i++) {
                        _this11.vipData.push({});
                    }
                }
            });
        },

        // 删除商品
        delGoods: function delGoods(goodId) {
            var _this12 = this;

            this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除商品
                _this12.$http.delete('/products?id=' + goodId).then(function (res) {
                    if (res.status) {
                        if (_this12.fliter_type != '' || _this12.fliter_stock != '' || _this12.fliter_kitchen != '') {
                            _this12.fliterGoods();
                        } else {
                            _this12.getGoodsData();
                        }
                    }
                });
            }).catch(function () {});
        },
        getGoodsData: function getGoodsData() {
            var _this13 = this;

            // this.$http.get('/products?storeId='+this.curStoreId).then((res)=>{
            this.$http.get('/get-ps?storeId=' + this.curStoreId).then(function (res) {
                _this13.vipData = res.data;
                _this13.goodsNum.total = res.data.length;
                if (_this13.vipData.length < 6) {
                    for (var i = 0, len = 6 - _this13.vipData.length; i < len; i++) {
                        _this13.vipData.push({});
                    }
                }
            });
        },
        checkFn: function checkFn() {
            //正则验证方法
            if (!this.newGoods.name) {
                this.$message({
                    message: '请输入商品名',
                    customClass: 'error'
                });
                return true;
            }
            if (this.newGoods.note != null) {
                if (this.newGoods.note.length > 15) {
                    this.$message({
                        message: '商品描述最长15个字符',
                        customClass: 'error'
                    });
                    return true;
                }
            }

            // 分类限制，如果选择了网费分类，商品名则必须含有网费字眼，其他商品转为网费分类同样需要网费字眼
            if (this.newGoods.productTypeId == 1) {
                if (!/(\u7f51\u8d39)/.test(this.newGoods.name)) {
                    this.$message({
                        message: '当前选择了火星网费分类，商品名必须含有网费字眼。',
                        customClass: 'error'
                    });
                    return true;
                }
            } else {
                if (/(\u7f51\u8d39)/.test(this.newGoods.name)) {
                    this.$message({
                        message: '当前分类下，商品名不能含有网费字眼。',
                        customClass: 'error'
                    });
                    return true;
                }
            }
            // 
            if (this.isStock == "ON") {
                if (!/(^0{1}$)|(^[1-9][0-9]*$)/.test(this.newGoods.threshold)) {
                    this.$message({
                        message: '数量输入有误',
                        customClass: 'error'
                    });
                    return true;
                }
            } else if (this.isStock == "OFF") {
                // if(!/^\d+(\.{0,1}\d+){0,1}$/.test(this.newGoods.stockQuantityRatio)){
                //     this.$message({
                //         message: '商品规格格式有误',
                //         customClass: 'error'
                //     })
                //     return true;
                // }
            }
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newGoods.salesPrice)) {
                this.$message({
                    message: '销售价格格式有误',
                    customClass: 'error'
                });
                return true;
            }
            if (!/^[1-9][0-9]*$/.test(this.newGoods.productQty)) {
                this.$message({
                    message: '数量输入有误',
                    customClass: 'error'
                });
                return true;
            }
            if (this.vipEnable) {
                if (!this.vipPrice) {
                    this.$message({
                        message: '请输入会员价',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.vipPrice)) {
                    this.$message({
                        message: '会员价格格式有误',
                        customClass: 'error'
                    });
                    return true;
                }
            }
            if (this.discountEnable) {
                if (!this.discountPrice) {
                    this.$message({
                        message: '请输入折扣百分比',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.discountPrice)) {
                    this.$message({
                        message: '折扣格式有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.disCom)) {
                    this.$message({
                        message: '提成价格格式有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!this.beginTime || !this.endTime) {
                    this.$message({
                        message: '折扣时间有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if (this.beginTime == "aN:aN:aN" || this.endTime == "aN:aN:aN") {
                    this.$message({
                        message: '折扣时间有误',
                        customClass: 'error'
                    });
                    return true;
                }
            }

            if (!this.newGoods.productTypeId) {
                this.$message({
                    message: '请选择分类',
                    customClass: 'error'
                });
                return true;
            }
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newGoods.commission)) {
                this.$message({
                    message: '商品提成格式有误',
                    customClass: 'error'
                });
                return true;
            }
            if (this.newGoods.salesShowEnabled) {
                if (!/^\d*$/.test(this.newGoods.salesCount)) {
                    this.$message({
                        message: '基础数量输入有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!/^\d*$/.test(this.newGoods.sort)) {
                    this.$message({
                        message: '排序输入错误',
                        customClass: 'error'
                    });
                    return true;
                }
            }
        },
        beforeUpGoods: function beforeUpGoods() {
            var _this14 = this;

            if (!this.btnId && Array.isArray(this.storeList) && this.storeList.length > 1) {
                this.$confirm('是否将此商品同步到其它店铺 （其它店铺需要建立相同分类名）？', '提示', {
                    confirmButtonText: '否，不用同步',
                    cancelButtonText: '是，同步到其他店',
                    type: 'warning',
                    showClose: false,
                    distinguishCancelAndClose: true,
                    closeOnPressEscape: false,
                    closeOnClickModal: false
                }).then(function () {
                    _this14.tbForm = {
                        storeIds: []
                    };
                    _this14.upGoods();
                }).catch(function (err) {
                    _this14.shareGoods = true;
                });
            } else {
                this.tbForm = {
                    storeIds: []
                };
                this.upGoods();
            }
        },
        doUpGoods: function doUpGoods() {
            var _this15 = this;

            if (!this.tbForm.storeIds || !Array.isArray(this.tbForm.storeIds) || !this.tbForm.storeIds.length) {
                this.$confirm('未选择同步店铺，是否仅将商品添加到此店铺', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    showClose: false,
                    distinguishCancelAndClose: true,
                    closeOnPressEscape: false,
                    closeOnClickModal: false
                }).then(function () {
                    _this15.shareGoods = false;
                    _this15.upGoods();
                }).catch(function (err) {});
            } else {
                this.shareGoods = false;
                this.upGoods();
            }
        },
        cancelTb: function cancelTb() {
            this.shareGoods = false;
            this.tbForm = {
                storeIds: []
                // this.$confirm('确认取消将商品同步到其他店铺?', '提示', {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     }).then(() => {
                //         this.shareGoods = false;
                //         this.tbForm = {
                //             storeIds:[]
                //         }
                //     })
            };
        },
        upGoods: function upGoods() {
            var _this16 = this;

            // console.log(this.newTimeListForComm);
            // console.log(new Date((this.newTimeListForComm[0].timeRange[0])).Format("hh:mm:00"))
            // return;
            if (this.checkFn()) {
                //正则验证
                return;
            }
            // 
            // 
            if (!this.addGoodApiBtn) {
                return;
            }
            this.addGoodApiBtn = false;
            var commTimeArr = [];
            var postParams = [];
            if (this.newGoods.timeRangeComm && !this.newGoods.postEnabled) {
                for (var _i3 = 0; _i3 < this.newTimeListForComm.length; _i3++) {
                    if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newTimeListForComm[_i3].commission)) {
                        this.$message({
                            message: '商品提成格式有误',
                            customClass: 'error'
                        });
                        this.addGoodApiBtn = true;
                        return true;
                    }
                    if (!this.newTimeListForComm[_i3].timeRange || !this.newTimeListForComm[_i3].timeRange[0] || !this.newTimeListForComm[_i3].timeRange[1] || this.newTimeListForComm[_i3].timeRange.length == 0) {
                        this.$message({
                            message: '请选择时间',
                            customClass: 'error'
                        });
                        this.addGoodApiBtn = true;
                        return true;
                    }
                    var obj = {
                        commission: Number(this.newTimeListForComm[_i3].commission),
                        begin: new Date(this.newTimeListForComm[_i3].timeRange[0]).Format("hh:mm:00"),
                        end: new Date(this.newTimeListForComm[_i3].timeRange[1]).Format("hh:mm:59")
                    };
                    commTimeArr.push(obj);
                }
            }
            // 
            if (this.newGoods.postEnabled) {
                var had = {};
                var hadFlag = false;
                for (var _i4 = 0; _i4 < this.newJobListForComm.length; _i4++) {
                    if (!had[this.newJobListForComm[_i4].groupId]) {
                        had[this.newJobListForComm[_i4].groupId] = true;
                    } else {
                        hadFlag = true;
                    }
                }
                if (hadFlag) {
                    this.$message({
                        message: '岗位设置不可重复',
                        customClass: 'error'
                    });
                    this.addGoodApiBtn = true;
                    return true;
                }
                for (var _i5 = 0; _i5 < this.newJobListForComm.length; _i5++) {
                    if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newJobListForComm[_i5].commission)) {
                        this.$message({
                            message: '商品提成格式有误',
                            customClass: 'error'
                        });
                        this.addGoodApiBtn = true;
                        return true;
                    }
                    if (!this.newJobListForComm[_i5].groupId) {
                        this.$message({
                            message: '请选择岗位',
                            customClass: 'error'
                        });
                        this.addGoodApiBtn = true;
                        return true;
                    }
                    var _obj2 = {
                        commission: Number(this.newJobListForComm[_i5].commission),
                        groupId: this.newJobListForComm[_i5].groupId,
                        id: this.newJobListForComm[_i5].id ? this.newJobListForComm[_i5].id : undefined
                    };
                    postParams.push(_obj2);
                }
            }
            console.log(this.newJobListForComm);
            // 

            var flag = false;
            var newTimeListForComm = commTimeArr;
            if (newTimeListForComm.length > 1) {
                for (var _i6 = 1; _i6 < newTimeListForComm.length; _i6++) {

                    var tempArrMax = [new Date("2020/01/01 " + newTimeListForComm[0].begin).getTime(), new Date("2020/01/01 " + newTimeListForComm[_i6].begin).getTime()];
                    var tempArrMin = [new Date("2020/01/01 " + newTimeListForComm[0].end).getTime(), new Date("2020/01/01 " + newTimeListForComm[_i6].end).getTime()];

                    // let tempArrMax = [item.startTimeForFee,newTimeListForComm[i].startTimeForFee];
                    // let tempArrMin = [item.endTimeForFee,newTimeListForComm[i].endTimeForFee];
                    if (Math.max.apply(null, tempArrMax) <= Math.min.apply(null, tempArrMin)) {
                        flag = true;
                    }
                }
            }
            if (flag) {
                this.$message({
                    message: "时间不允许重叠，请重新选择",
                    customClass: 'error'
                });
                this.addGoodApiBtn = true;
                return;
            }

            var arr1 = this.newTimeList;
            var arr2 = this.timeList;
            var supplyTimes = [];
            if (arr1.length) {
                for (var i = 0; i < arr1.length; i++) {
                    for (var j = 0; j < arr2.length; j++) {
                        if (arr1[i].id == arr2[j].id) {
                            supplyTimes.push(arr2[j]);
                        }
                    }
                }
            }
            var ipName = "";
            var port = 0;
            var ipAddress = "";

            if (this.newGoods.ipId != 0 && this.newGoods.ipId) {
                for (var _i7 = 0; _i7 < this.printEr.length; _i7++) {
                    if (this.printEr[_i7].id == this.newGoods.ipId) {
                        ipName = this.printEr[_i7].name;
                        port = this.printEr[_i7].port;
                        ipAddress = this.printEr[_i7].ipAddress;
                    }
                }
            }
            var gname = String(this.newGoods.name.replace(/\s*/g, ""));
            // 
            if (this.newGoods.timeRangeComm && !this.newGoods.postEnabled) {
                if (!commTimeArr || !commTimeArr.length) {
                    this.$message({
                        message: "请添加时间段",
                        customClass: 'error'
                    });
                    this.addGoodApiBtn = true;
                    return;
                }
            }
            if (this.newGoods.postEnabled && (!postParams || !postParams.length)) {
                this.$message({
                    message: "请添加岗位提成信息",
                    customClass: 'error'
                });
                this.addGoodApiBtn = true;
                return;
            }
            // 
            var specIds = [];
            if (this.seledSpec && Array.isArray(this.seledSpec) && this.seledSpec.length) {
                this.seledSpec.forEach(function (it) {
                    specIds.push(it.id);
                });
            }
            var goods = {
                "id": this.btnId ? this.btnId : this.$uuid.create(1).hex,
                "storeId": this.curStoreId,
                "name": gname,
                "barCode": this.newGoods.barCode,
                // "costPrice"     :  parseFloat(this.newGoods.costPrice),

                "salesPrice": parseFloat(this.newGoods.salesPrice),
                "inStockNumber": parseFloat(this.newGoods.inStockNumber),
                "productTypeId": this.newGoods.productTypeId,
                "productQty": this.newGoods.productQty,
                "imageURL": this.newGoods.imageURL ? this.newGoods.imageURL : 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png',
                "supplierName": this.newGoods.supplierName,
                "supplyTimes": __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(supplyTimes),
                "productStatus": this.newGoods.productStatus,
                "commission": parseFloat(this.newGoods.commission),
                "stockEnabled": this.isStock === 'OFF' ? false : true,
                "kitchenPrintEnabled": this.kitchenPrintEnabled === 'OFF' ? false : true,
                "isDirectThermal": this.isDirectThermal === 'OFF' ? false : true,
                labelEnabled: this.newGoods.labelEnabled,
                "ipId": this.kitchenPrintEnabled === 'OFF' ? "" : this.newGoods.ipId,
                ipName: this.kitchenPrintEnabled === 'OFF' ? "" : ipName,
                port: this.kitchenPrintEnabled === 'OFF' ? "" : port,
                ipAddress: this.kitchenPrintEnabled === 'OFF' ? "" : ipAddress,
                "threshold": this.isStock == "ON" ? this.newGoods.threshold : 0,
                // "stockQuantityRatio" : parseFloat(this.newGoods.stockQuantityRatio),
                // 
                // 
                sort: this.newGoods.sort,
                salesCount: this.newGoods.salesCount,
                salesShowEnabled: this.newGoods.salesShowEnabled,
                salesEnabled: this.newGoods.salesEnabled,
                // 
                items: commTimeArr,
                openTimeEnabled: this.newGoods.timeRangeComm,
                // 
                note: this.newGoods.note,
                week: Array.isArray(this.newGoods.week) ? this.newGoods.week.join() : this.newGoods.week,
                // 
                postParams: postParams,
                postEnabled: this.newGoods.postEnabled,
                specIds: specIds
                // specs:[...this.seledNorSpec,...this.specs]
            };
            if (!this.btnId && this.tbForm.storeIds && Array.isArray(this.tbForm.storeIds) && this.tbForm.storeIds.length) {
                goods = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, goods, { storeIds: this.tbForm.storeIds });
            }
            this.$http.put('/products', goods).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    var dateBeg, dateEnd, resFlag, _dateBeg, _dateEnd, _resFlag, params, paramsForPei;

                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _this16.addGoodApiBtn = true;
                                    _this16.isAutoSearchBtn = true;

                                    if (_this16.btnId) {
                                        _context.next = 13;
                                        break;
                                    }

                                    dateBeg = new Date(_this16.beginTime);
                                    dateEnd = new Date(_this16.endTime);
                                    _context.next = 7;
                                    return _this16.disOrVip(goods.id, _this16.vipPrice, _this16.discountPrice, _this16.disCom, dateBeg.Format("hh:mm:ss"), dateEnd.Format("hh:mm:ss"), _this16.tbForm.storeIds);

                                case 7:
                                    resFlag = _context.sent;
                                    _context.next = 10;
                                    return _this16.setForPc(goods.id, _this16.pcEnable, _this16.pcBuyEnable, _this16.tbForm.storeIds);

                                case 10:
                                    // }
                                    // this.dialogVisible = false;
                                    if (resFlag) {
                                        _this16.$message({
                                            message: '添加商品成功',
                                            customClass: 'success'
                                        });
                                        setTimeout(function () {
                                            _this16.initDate();
                                        }, 500);
                                    }

                                    _context.next = 21;
                                    break;

                                case 13:
                                    _dateBeg = new Date(_this16.beginTime);
                                    _dateEnd = new Date(_this16.endTime);
                                    // 是否显示在客户端和是否在客户端允许购买

                                    _context.next = 17;
                                    return _this16.setForPc(_this16.btnId, _this16.pcEnable, _this16.pcBuyEnable);

                                case 17:
                                    _context.next = 19;
                                    return _this16.disOrVip(_this16.btnId, _this16.vipPrice, _this16.discountPrice, _this16.disCom, _dateBeg.Format("hh:mm:ss"), _dateEnd.Format("hh:mm:ss"));

                                case 19:
                                    _resFlag = _context.sent;

                                    if (_resFlag) {
                                        _this16.$message({
                                            message: '修改商品成功',
                                            customClass: 'success'
                                        });
                                    }

                                case 21:

                                    // 
                                    params = [];

                                    if (_this16.seledMats && Array.isArray(_this16.seledMats) && _this16.seledMats.length) {
                                        _this16.seledMats.forEach(function (it) {
                                            var obj = {
                                                id: it.formId ? it.formId : 0,
                                                qty: it.count,
                                                productMaterialId: it.productMaterialId,
                                                productMaterialName: it.name
                                            };
                                            params.push(obj);
                                        });
                                    }
                                    _context.next = 25;
                                    return _this16.upOriGoods(res.data.id, params);

                                case 25:
                                    // 
                                    paramsForPei = [];

                                    if (_this16.seledPeiGoods && Array.isArray(_this16.seledPeiGoods) && _this16.seledPeiGoods.length) {
                                        _this16.seledPeiGoods.forEach(function (it) {
                                            // let obj = {
                                            //     id:it.formId?it.formId:0,
                                            //     qty:it.count,
                                            //     productId:it.productMaterialId,
                                            //     productMaterialName:it.name,
                                            // }
                                            paramsForPei.push(it.id);
                                        });
                                    }
                                    console.log(paramsForPei);
                                    _context.next = 30;
                                    return _this16.upPeiGoods(res.data.id, paramsForPei);

                                case 30:
                                    setTimeout(function () {
                                        // this.getGoodsData();
                                        if (_this16.fliter_type != '' || _this16.fliter_stock != '' || _this16.fliter_kitchen != '') {
                                            _this16.fliterGoods();
                                        } else {
                                            _this16.getGoodsData();
                                        }
                                        if (_this16.btnId) {
                                            _this16.dialogVisible = false;
                                        }
                                    }, 250);
                                    // 

                                case 31:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this16);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function () {
                // this.tbForm = {
                //     storeIds:[]
                // }
                _this16.addGoodApiBtn = true;
            });
        },
        upPeiGoods: function upPeiGoods(productId, productIds) {
            var _this17 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this17.$http({
                    url: "match/product/add",
                    method: "POST",
                    data: {
                        productId: productId,
                        productIds: productIds
                    }
                }).then(function (res) {
                    resolve(res);
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        upOriGoods: function upOriGoods(productId, params) {
            var _this18 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this18.$http({
                    url: "edit/material",
                    method: "POST",
                    data: {
                        productId: productId,
                        params: params
                    }
                }).then(function (res) {
                    resolve();
                }).catch(function (err) {
                    reject();
                });
            });
        },

        // 设置客户端是否允许购买和显示
        setForPc: function setForPc(productId, showEnabled, purchaseEnabled) {
            var _this19 = this;

            var storeIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this19.$http({
                    url: "show-enabled",
                    method: "POST",
                    data: {
                        productId: productId,
                        showEnabled: showEnabled ? 1 : 0,
                        purchaseEnabled: purchaseEnabled ? 1 : 0,
                        storeIds: storeIds ? storeIds : undefined
                    }
                }).then(function (res) {
                    resolve(res);
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        disOrVip: function disOrVip(productId, memberPrice, disPrice, disCom, beginTime, endTime) {
            var _this20 = this;

            var storeIds = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (beginTime != "aN:aN:aN" && endTime != "aN:aN:aN" && _this20.discountEnable) {
                    if (new Date("2020/01/01 " + endTime).getTime() <= new Date("2020/01/01 " + beginTime).getTime()) {
                        _this20.$message({
                            message: '折扣结束时间不能小于开始时间',
                            customClass: 'error'
                        });
                        reject(false);
                    }
                }
                var data = {
                    productId: productId,
                    beginTime: beginTime == "aN:aN:aN" ? "" : beginTime,
                    endTime: endTime == "aN:aN:aN" ? "" : endTime,
                    disShow: _this20.discountEnable ? 1 : 0,
                    disPrice: (disPrice / 100).toFixed(2),
                    memberShow: _this20.vipEnable ? 1 : 0,
                    memberPrice: memberPrice,
                    disCom: disCom,
                    storeIds: storeIds ? storeIds : undefined
                };
                _this20.$http({
                    url: "update-slot",
                    method: "POST",
                    data: data
                }).then(function (res) {
                    console.log(res);
                });
                resolve(true);
            });
        },

        coverImg: function coverImg(e) {
            var reader = new FileReader();
            var that = this;
            var fileObj = e.target.files[0];

            if (e.target.files.length == 0) {
                return false;
            }

            // 判断图片大小
            if (fileObj.size > this.coverImgMaxSize) {
                this.errorMsg = '上传图片的大小不能超过20MB';
                this.openErrorTip = true;
                this.$message({
                    message: '上传图片的大小不能超过20MB',
                    customClass: 'error'
                });
                return false;
            }

            reader.onload = function (file) {
                return function (e) {
                    var that2 = this; // 缓存当前this
                    var img = new Image();
                    img.src = this.result;
                    img.onload = function () {
                        var imgBase64 = that2.result; //获得图片的base64的数据


                        // 判断是否是移动端设备
                        var sUserAgent = navigator.userAgent.toLowerCase();
                        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
                        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                        var bIsAndroid = sUserAgent.match(/android/i) == "android";
                        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                            that.mobileUploadImg(imgBase64);
                        } else {
                            that.oldImgBase64 = imgBase64;
                            that.showCrop = true;
                        }
                    };
                    $('.pcImgFile').val('');
                    $('.mobileImgFile').val('');
                };
            }(e.target.files[0]);
            reader.readAsDataURL(e.target.files[0]);
        },
        // 移动端上传图片
        mobileUploadImg: function mobileUploadImg(imgBase64) {
            var _this21 = this;

            this.infoload = true;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_6__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/image/json/upload?storeId=' + this.curStoreId, { file: imgBase64 }).then(function (res) {
                _this21.newGoods.imageURL = res.data.path;
                _this21.infoload = false;
            }).catch(function () {
                _this21.infoload = false;
            });
        },
        // 获得裁剪后图片base64
        getCropImgBase: function getCropImgBase(imgUrl) {
            this.newGoods.imageURL = imgUrl;
        },
        getSpecs: function getSpecs() {
            var _this22 = this;

            this.$http({
                url: "spec/list",
                method: "POST",
                data: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                console.log(res);
                _this22.specList = res.data;
            });
        }
    },
    activated: function activated() {
        var _this23 = this;

        this.$http.get('/stores').then(function (res) {
            _this23.storeList = res.data;
        }).catch(function (err) {});
        for (var i = 0; i < 6; i++) {
            this.vipData.push({});
        }

        //获取商品分类
        /*this.$http.get('/product-types-all?storeId='+this.curStoreId+'&parentId='+'').then((res)=>{
            this.typeList = this.typeList.concat(res.data);
           
            this.typeOptions.push({label: '全部',value: ''});
            for (var i = 0; i < res.data.length; i++) {
                let obj={
                    value:res.data[i].id,
                    label:res.data[i].name
                }
                if(res.data[i].productTypeVos.length){
                    let son = res.data[i].productTypeVos;
                    let arr = [
                        {value:res.data[i].id,label:res.data[i].name}
                    ];
                    for (var j = 0; j < son.length; j++) {
                         let sonobj={
                            value:son[j].id,
                            label:"- "+son[j].name
                        }
                        arr.push(sonobj)
                    }
                    obj.children = arr;
                }
                this.typeOptions.push(obj);
            }
        })*/
        this.$http.get('/product-types?storeId=' + this.curStoreId + '&parentId=' + '').then(function (res) {
            _this23.typeList = res.data.data;
            _this23.systemData = res.data.systemData;
        });
        if (this.fliter_type != '' || this.fliter_stock != '' || this.fliter_kitchen != '') {
            this.fliterGoods();
        } else {
            this.getGoodsData();
        }
        // 
        this.getSpecs();
        // 
        this.getTimesList();
        this.getPrintIpInfo();
        this.getJobType();
    },
    mounted: function mounted() {
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            $('.el-message-box__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            jobsList: [], // 岗位列表
            timeName: '',
            curJobId: '', // 时段id
            addJobVisible: false, // 控制新增弹框显示隐藏
            addJobApiBtn: true, // 控制新增岗位接口
            time: {
                beginHour: '',
                beginMinute: '',
                endHour: '',
                endMinute: ''
            }
        };
    },

    watch: {},
    methods: {
        // 获取岗位列表
        getJobsList: function getJobsList() {
            var _this = this;

            this.$http.get('/product-supply-time?storeId=' + this.curStoreId).then(function (res) {
                _this.jobsList = res.data;
                for (var i = 0; i < _this.jobsList.length; i++) {
                    if (_this.jobsList[i].id) {
                        _this.jobsList[i].time = (_this.jobsList[i].beginHour < 10 ? '0' + _this.jobsList[i].beginHour : _this.jobsList[i].beginHour) + ':' + (_this.jobsList[i].beginMinute < 10 ? '0' + _this.jobsList[i].beginMinute : _this.jobsList[i].beginMinute) + '~' + (_this.jobsList[i].endHour < 10 ? '0' + _this.jobsList[i].endHour : _this.jobsList[i].endHour) + ':' + (_this.jobsList[i].endMinute < 10 ? '0' + _this.jobsList[i].endMinute : _this.jobsList[i].endMinute);
                    }
                }
                var number = _this.pageSize - _this.jobsList.length;
                if (number > 0) {
                    for (var _i = 0; _i < number; _i++) {
                        _this.jobsList.push({
                            name: ''
                        });
                    }
                }
            }).catch(function (err) {});
        },
        // 新增, 更新岗位
        addJob: function addJob() {
            var _this2 = this;

            if (!this.timeName) {
                this.$message({
                    message: '请输入时段名',
                    customClass: 'error'
                });
                return;
            }
            if (this.time.beginHour.length > 2 || parseInt(this.time.beginHour) > 23 || !/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.beginHour))) {
                this.$message({
                    message: '开始小时数设置有误',
                    customClass: 'error'
                });
                return;
            }
            if (this.time.beginMinute.length > 2 || !/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.beginMinute)) || parseInt(this.time.beginMinute) > 59) {
                this.$message({
                    message: '开始分钟数设置有误',
                    customClass: 'error'
                });
                return;
            }
            if (this.time.endHour.length > 2 || !/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.endHour)) || parseInt(this.time.endHour) > 23) {
                this.$message({
                    message: '结束小时数设置有误',
                    customClass: 'error'
                });
                return;
            }
            if (this.time.endMinute.length > 2 || !/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.endMinute)) || parseInt(this.time.endMinute) > 59) {
                this.$message({
                    message: '结束分钟数设置有误',
                    customClass: 'error'
                });
                return;
            }
            if (!this.addJobApiBtn) {
                return;
            }
            this.addJobApiBtn = false;
            var body = {
                id: this.curJobId ? this.curJobId : this.$uuid.create(1).hex,
                storeId: this.curStoreId,
                name: this.timeName,
                beginHour: parseInt(this.time.beginHour),
                beginMinute: parseInt(this.time.beginMinute),
                endHour: parseInt(this.time.endHour),
                endMinute: parseInt(this.time.endMinute)
            };
            this.$http.post('/product-supply-time', body).then(function (res) {
                _this2.addJobVisible = false;
                _this2.addJobApiBtn = true;
                _this2.getJobsList();
                _this2.$message({
                    message: '操作成功',
                    customClass: 'success'
                });
            }).catch(function (err) {
                _this2.addJobApiBtn = true;
            });
        },
        // 删除岗位
        delJob: function delJob(jobId) {
            var _this3 = this;

            this.$confirm('此操作将删除该时段, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除岗位
                _this3.$http.delete('/product-supply-time?id=' + jobId).then(function (res) {
                    _this3.$message({
                        message: '删除成功',
                        customClass: 'success'
                    });
                    _this3.getJobsList();
                }).catch(function (err) {});
            }).catch(function () {});
        },
        // 获得当前岗位信息
        getCurJob: function getCurJob(item) {
            this.curJobId = item.id;
            this.timeName = item.name;
            this.time = {
                beginHour: item.beginHour,
                beginMinute: item.beginMinute,
                endHour: item.endHour,
                endMinute: item.endMinute
            };
            this.addJobVisible = true;
        },
        // 清除信息
        clear: function clear() {
            this.timeName = '';
            this.time = {
                beginHour: '',
                beginMinute: '',
                endHour: '',
                endMinute: ''
            };
            this.checkedCities = [];
            this.curJobId = '';
            this.addJobVisible = true;
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.jobsList.push({
                name: ''
            });
        }
    },
    activated: function activated() {
        this.getJobsList();
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__urlConfig__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['pageSize', 'curStoreId'],
    data: function data() {
        return {
            specs: [],
            defaultSpec: "",
            autoSpec: "",
            dialogVisible: false,
            addAddrBtn: false, //添加地址按钮
            addressData: [], //地址列表
            addr: '', //收货地址
            name: '', //姓名
            phone: "",
            userName: "", //用户手机号
            id: ""
        };
    },


    methods: {
        modifySpec: function modifySpec(type, index) {
            var specs = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.specs));
            if (type == "add") {
                if (!String(this.autoSpec).trim()) {
                    this.$message({
                        message: '请输入规格名称',
                        customClass: 'error'
                    });
                    return;
                }
                specs.push(this.autoSpec);
                this.autoSpec = '';
            } else if (type == "del") {
                specs.splice(index, 1);
            }
            this.specs = specs;
        },

        // 
        //删除地址
        delAddr: function delAddr(item) {
            var _this = this;

            this.$confirm('此操作将删除该规格组, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this.$http({
                    url: "spec/delete",
                    method: "POST",
                    data: {
                        id: item.id
                    }
                }).then(function (res) {
                    _this.getSpecs();
                });
            }).catch(function () {});
        },

        //新建或更新地址
        addAddrFn: function addAddrFn(id) {
            var _this2 = this;

            if (!this.name) {
                this.$message({
                    message: '请填写规格组名称',
                    customClass: 'error'
                });
                return;
            }
            if (!this.specs || !Array.isArray(this.specs) || !this.specs.length) {
                this.$message({
                    message: '请添加规格',
                    customClass: 'error'
                });
                return;
            }
            if (!this.defaultSpec) {
                this.$message({
                    message: '请选择默认规格',
                    customClass: 'error'
                });
                return;
            }

            this.$http({
                url: "edit/spec",
                method: "POST",
                data: {
                    id: this.id ? this.id : 0,
                    name: this.name,
                    storeId: this.curStoreId,
                    specs: this.specs,
                    defaultSpec: this.defaultSpec
                }
            }).then(function (res) {
                _this2.getSpecs();
                _this2.addAddrBtn = false;
                _this2.name = '';
                _this2.id = '';
                _this2.defaultSpec = '';
                _this2.specs = [];
                _this2.$message({
                    message: '操作成功！',
                    customClass: 'success'
                });
            });
        },
        showUpBox: function showUpBox(item) {
            if (item) {
                this.id = item.id;
                this.name = item.name;
                this.specs = item.specs;
                this.defaultSpec = item.defaultSpec ? item.defaultSpec : "";
            } else {
                this.id = "";
                this.name = "";
                this.specs = [];
                this.defaultSpec = "";
            }
            this.addAddrBtn = true;
        },
        getSpecs: function getSpecs() {
            var _this3 = this;

            this.$http({
                url: "spec/list",
                method: "POST",
                data: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this3.addressData = res.data;
                if (_this3.addressData.length < _this3.pageSize) {
                    for (var i = 0, len = _this3.pageSize - _this3.addressData.length; i < len; i++) {
                        _this3.addressData.push({});
                    }
                }
            });
        }
    },
    created: function created() {
        this.userName = localStorage.getItem("username");
        for (var i = 0; i < this.pageSize; i++) {
            this.addressData.push({});
        }
    },
    activated: function activated() {
        this.getSpecs();
    }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    data: function data() {
        return {};
    },

    methods: {},
    created: function created() {},
    mounted: function mounted() {}
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            jobsList: [], // 岗位列表
            // 新增岗位
            newJob: {
                name: '',
                storeId: this.curStoreId,
                groupRoles: ['ROLE_CLERK'] //待选择权限的数组
            },
            curJobId: '', // 岗位id
            addJobVisible: false, // 控制新增弹框显示隐藏
            addJobApiBtn: true // 控制新增岗位接口
        };
    },

    methods: {
        changeReward: function changeReward(item) {
            var _this = this;

            console.log(item);
            this.$http({
                url: "employee-groups/update-empR",
                method: "GET",
                params: {
                    groupId: item.id,
                    reward: !item.reward ? 0 : 1
                }
            }).then(function (res) {
                _this.getJobsList();
            });
        },

        //是否将此岗位的人员显示在语音呼叫客户端
        changeShowStatue: function changeShowStatue(item) {
            var _this2 = this;

            this.$http({
                url: "update-show",
                method: "GET",
                params: {
                    id: item.id,
                    show: !item.show ? 0 : 1
                }
            }).then(function (res) {
                console.log(res);
                if (res.data.code == 200) {
                    _this2.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    _this2.getJobsList();
                }
            });
        },

        // 获取岗位列表
        getJobsList: function getJobsList() {
            var _this3 = this;

            this.$http.get('/employee-groups?storeId=' + this.curStoreId).then(function (res) {
                var body = res.data;
                if (body && body[0]) {
                    _this3.jobsList = body;
                }
                var number = _this3.pageSize - _this3.jobsList.length;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this3.jobsList.push({
                            name: ''
                        });
                    }
                }
            }).catch(function (err) {});
        },
        // 新增, 更新岗位
        addJob: function addJob() {
            var _this4 = this;

            if (!this.newJob.name) {
                this.$message({
                    message: '请输入岗位名',
                    customClass: 'error'
                });
                return;
            }
            if (!this.curJobId) {
                this.curJobId = this.$uuid.create(1).hex;
            }
            if (!this.newJob.groupRoles || !this.newJob.groupRoles[0]) {
                this.$message({
                    message: '请选择权限',
                    customClass: 'error'
                });
                return;
            }
            if (!this.addJobApiBtn) {
                return;
            }
            this.addJobApiBtn = false;
            this.$http.put('/employee-groups/' + this.curJobId, this.newJob).then(function (res) {
                _this4.addJobVisible = false;
                _this4.addJobApiBtn = true;
                _this4.getJobsList();
            }).catch(function (err) {
                _this4.addJobApiBtn = true;
            });
        },
        // 删除岗位
        delJob: function delJob(jobId) {
            var _this5 = this;

            this.$confirm('此操作将删除该岗位, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除岗位
                _this5.$http.delete('/employee-groups/' + jobId).then(function (res) {
                    _this5.getJobsList();
                }).catch(function (err) {});
            }).catch(function () {});
        },
        // 获得当前岗位信息
        getCurJob: function getCurJob(item) {
            console.log(item);
            this.curJobId = item.id;
            this.newJob.name = item.name;
            this.newJob.groupRoles = [];
            this.addJobVisible = true;
            this.newJob.groupRoles = JSON.parse(item.roles);
        },
        // 清除信息
        clear: function clear() {
            this.newJob = {
                name: '',
                groupRoles: ['ROLE_CLERK'],
                storeId: this.curStoreId
            };
            this.checkedCities = [];
            this.curJobId = '';
            this.addJobVisible = true;
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.jobsList.push({
                name: ''
            });
        }
    },
    activated: function activated() {
        this.getJobsList();
    }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['pageSize', 'curStoreId'],
    data: function data() {
        return {
            dialogVisible: false,
            addAddrBtn: false, //添加地址按钮
            addressData: [], //地址列表
            addr: '', //收货地址
            name: '', //姓名
            phone: "",
            userName: "", //用户手机号
            addrId: ""
        };
    },


    methods: {
        //删除地址
        delAddr: function delAddr(item) {
            var _this = this;

            this.$confirm('此操作将删除该收货地址, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除地址
                _this.$http({
                    url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "info-remove",
                    method: "POST",
                    data: {
                        id: item.id
                    }
                }).then(function (res) {
                    _this.getAddress();
                });
            }).catch(function () {});
        },

        //新建或更新地址
        addAddrFn: function addAddrFn(id) {
            var _this2 = this;

            if (!this.addr) {
                this.$message({
                    message: '请填写收货地址',
                    customClass: 'error'
                });
                return;
            }
            if (!this.name) {
                this.$message({
                    message: '请填写收货人姓名',
                    customClass: 'error'
                });
                return;
            }
            if (!this.phone) {
                this.$message({
                    message: '请填写手机号',
                    customClass: 'error'
                });
                return;
            }

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "info-merge",
                method: "POST",
                data: {
                    id: this.addrId ? this.addrId : 0,
                    name: this.name,
                    mobile: this.phone,
                    address: this.addr,
                    userName: this.userName
                }
            }).then(function (res) {
                _this2.getAddress();
                _this2.addAddrBtn = false;
                _this2.addr = '';
                _this2.name = '';
                _this2.phone = '';
                _this2.$message({
                    message: '操作成功！',
                    customClass: 'success'
                });
            });
        },
        showUpBox: function showUpBox(item) {
            this.addAddrBtn = true;
            this.addrId = item.id;
            this.addr = item.address;
            this.phone = item.mobile;
            this.name = item.name;
        },
        getAddress: function getAddress() {
            var _this3 = this;

            //获取地址列表
            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "info-list",
                method: "GET",
                params: {
                    userName: this.userName
                }
            }).then(function (res) {
                _this3.addressData = res.data;
                if (_this3.addressData.length < _this3.pageSize) {
                    for (var i = 0, len = _this3.pageSize - _this3.addressData.length; i < len; i++) {
                        _this3.addressData.push({});
                    }
                }
            });
        }
    },
    created: function created() {
        this.userName = localStorage.getItem("username");
        for (var i = 0; i < this.pageSize; i++) {
            this.addressData.push({});
        }
    },
    activated: function activated() {
        this.getAddress();
    }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    data: function data() {
        return {
            payOutTime: "", //支付剩余时间
            payCode: "", //支付二维码
            showPayCode: false, //是否显示支付二维码
            orderId: "", //订单id
            addrList: [], //收货地址列表
            userName: "", //当前登录名(手机号)
            addr: "", //收货地址
            showPayType: false,
            totalAmount: 0, //总金额
            showNotice: false,
            note: "",
            typeId: "",
            showBigImg: false,
            bigImgUrl: '',
            checkeds: false,
            dialogVisible: false,

            vipData: [], //所有商品列表
            goodsNum: {
                pageNum: 1,
                pageSize: 6,
                total: 0
            },
            infoload: false, // loading
            fliter_type: '', // 当前筛选条件
            typeList: [],
            cartList: [], //购物车列表
            seledGoodCount: 0
        };
    },

    watch: {
        showPayCode: function showPayCode(val) {
            if (!val) {
                clearInterval(this.countTimer);
            }
        },


        goods: function goods(val) {
            if (val) {
                this.searchGoods(val, null);
            } else {
                this.goodCheckArr = [];
                this.getGoodsData();
            }
        },
        'newGoods.name': function newGoodsName(val) {
            if (val) {
                if (this.isAutoSearchBtn) {
                    this.searchGoods(val, '9f5afd60-e952-11e7-a26a-83436326b6c5');
                } else {}
            } else {
                this.addGoodCheckArr = [];
                // this.getGoodsData();
            }
        },
        timeChoice: function timeChoice(val) {
            if (val == '') {
                return;
            }
            if (this.newTimeList.length >= 3) {
                this.$message({
                    message: '最多只能添加3个时间段',
                    customClass: 'error'
                });
                this.timeChoice = '';
                return;
            }
            for (var i = 0; i < this.timeList.length; i++) {
                if (val == this.timeList[i].id) {

                    var isPush = true;
                    for (var j = 0; j < this.newTimeList.length; j++) {
                        if (this.newTimeList[j].id == val) {
                            isPush = false;
                            this.$message({
                                message: '已经有该时段',
                                customClass: 'error'
                            });
                        }
                    }
                    if (isPush) {
                        this.newTimeList.push(this.timeList[i]);
                    }
                }
            }
            this.timeChoiceBtn = false;
            this.timeChoice = '';
        }
    },
    methods: {
        getAddress: function getAddress() {
            var _this = this;

            //获取地址列表
            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "info-list",
                method: "GET",
                params: {
                    userName: this.userName
                }
            }).then(function (res) {
                _this.addrList = res.data;
            });
        },
        selPayType: function selPayType(type) {
            var _this2 = this;

            if (!this.orderId) {
                this.$message({
                    message: '请重新操作',
                    customClass: 'error'
                });
                return;
            }
            var data = void 0;
            if (type == "ali" || type == "wechat") {
                data = {
                    orderId: this.orderId,
                    type: type == "ali" ? true : false,
                    source: "PAY"
                };
            } else {
                data = {
                    orderId: this.orderId,
                    source: "UNPAY"
                };
            }
            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "pay",
                method: "POST",
                data: data
            }).then(function (res) {
                if (type == "other") {
                    _this2.$confirm('确认提交此订单？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        setTimeout(function () {
                            window.location.reload(true);
                        }, 500);
                        _this2.$message({
                            message: '提交成功',
                            customClass: 'success'
                        });
                        return;
                    });
                } else {
                    _this2.showPayCode = true;
                    _this2.showPayType = false;
                    // this.payCode = res.data.url;
                    // 
                    setTimeout(function () {
                        var qrcode = new QRCode("qrCode", {
                            text: res.data.url,
                            colorDark: "#000000",
                            colorLight: "#ffffff",
                            correctLevel: QRCode.CorrectLevel.H
                        });
                    }, 100);
                    // 
                    _this2.clearPayTime();
                }
            });
        },

        // 
        clearPayTime: function clearPayTime() {
            var _this3 = this;

            var maxTime = 60 * 3; //三分钟
            var nowCountTime = void 0;
            this.countTimer = setInterval(function () {
                if (maxTime >= 0) {
                    var minutes = Math.floor(maxTime / 60);
                    var seconds = Math.floor(maxTime % 60);
                    seconds = seconds < 10 ? "0" + seconds : seconds;
                    nowCountTime = minutes + "\u5206" + seconds + "\u79D2";
                    _this3.payOutTime = nowCountTime;
                    --maxTime;
                    _this3.runPay();
                } else {
                    clearInterval(_this3.countTimer);
                    _this3.payOutTime = "3分00秒";
                    _this3.showPayCode = false;
                }
            }, 1000);
        },

        // 支付轮训
        runPay: function runPay() {
            var _this4 = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "order-one",
                method: "GET",
                params: {
                    orderId: this.orderId
                }
            }).then(function (res) {
                if (res.data.code == 200) {
                    _this4.$message({
                        message: '支付成功',
                        customClass: 'success'
                    });
                    clearInterval(_this4.countTimer);
                    // this.payOutTime = "3分00秒";
                    // this.showPayCode = false;
                    // this.dialogVisible = false;
                    // this.cartList = [];
                    // this.orderId = "";
                    setTimeout(function () {
                        window.location.reload(true);
                    }, 500);
                    return;
                }
            });
        },
        goSelPayType: function goSelPayType() {
            var _this5 = this;

            if (this.cartList.length == 0) {
                this.$message({
                    message: '请先选择商品',
                    customClass: 'error'
                });
                return;
            }
            if (!this.addr) {
                this.$message({
                    message: '请选择收货地址',
                    customClass: 'error'
                });
                return;
            }
            var addressObj = {};
            for (var i = 0; i < this.addrList.length; i++) {
                if (this.addrList[i].id == this.addr) {
                    addressObj = this.addrList[i];
                }
            }
            console.log(this.cartList);
            var items = [];
            for (var j = 0; j < this.cartList.length; j++) {
                var obj = {
                    productId: this.cartList[j].id,
                    qty: this.cartList[j].count,
                    spec: this.cartList[j].spec,
                    amount: Number(this.cartList[j].amount) * Number(this.cartList[j].count),
                    productName: this.cartList[j].productName,
                    productTypeId: this.cartList[j].productTypeId,
                    typeName: this.cartList[j].productTypeName
                };
                items.push(obj);
            }
            // let orderId = this.$uuid.create(1).hex;
            // this.orderId = orderId;
            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "shop-order",
                method: "POST",
                data: {
                    // id:orderId,
                    count: this.seledGoodCount,
                    amount: this.totalAmount,
                    address: addressObj.address,
                    mobile: addressObj.mobile,
                    name: addressObj.name,
                    orderUserName: this.userName,
                    items: items
                }
            }).then(function (res) {
                if (res.data.result.code == 200) {
                    // this.$message({
                    //     message: res.data.result.msg,
                    //     customClass: 'success'
                    // });
                    _this5.orderId = res.data.data.id;
                    _this5.showPayType = true;
                } else {
                    _this5.$message({
                        message: res.data.result.msg,
                        customClass: 'error'
                    });
                }
            });
        },
        notice: function notice(item) {
            this.note = item.notice;
            this.showNotice = true;
        },
        reduCount: function reduCount(item) {
            if (item.count == 1) {
                for (var i = 0; i < this.cartList.length; i++) {
                    if (this.cartList[i].id == item.id) {
                        this.cartList.splice(i, 1);
                    }
                }
                if (this.cartList.length == 0) {
                    this.seledGoodCount = 0;
                    this.totalAmount = 0;
                    return;
                }
            }
            item.count--;
            this.seledGoodCount--;
            var totalAmount = this.totalAmount;
            totalAmount = Number(totalAmount) - Number(item.amount);
            this.totalAmount = Number(totalAmount).toFixed(2);
        },
        addCount: function addCount(item) {
            item.count++;
            this.seledGoodCount++;
            var totalAmount = this.totalAmount;
            totalAmount = Number(totalAmount) + Number(item.amount);
            this.totalAmount = Number(totalAmount).toFixed(2);
        },
        addCart: function addCart(item) {
            // console.log(item.count);
            var seledCount = 0;
            var itemStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item);
            this.cartList.push(JSON.parse(itemStr));

            for (var i = 0; i < this.cartList.length; i++) {
                seledCount += Number(this.cartList[i].count);
            }

            this.seledGoodCount = seledCount;
            // this.initOrderInfo();
        },
        bigImg: function bigImg(item) {
            this.showBigImg = true;
            this.bigImgUrl = item.image;
        },
        addGoods: function addGoods() {
            //点击添加商品，清空 newGoods并获取获取商品分类
            this.dialogVisible = true;
            this.initOrderInfo();
        },
        initOrderInfo: function initOrderInfo() {
            var cartObj = {};
            var totalAmount = 0;
            for (var i = 0; i < this.cartList.length; i++) {
                if (!cartObj[this.cartList[i].id]) {
                    cartObj[this.cartList[i].id] = this.cartList[i];
                } else {
                    var nowItemCount = cartObj[this.cartList[i].id].count;
                    nowItemCount = Number(nowItemCount) + Number(this.cartList[i].count);
                    cartObj[this.cartList[i].id].count = Number(nowItemCount);
                }
            }
            var newCartList = [];
            for (var key in cartObj) {
                newCartList.push(cartObj[key]);
            }
            this.cartList = newCartList;
            for (var j = 0; j < newCartList.length; j++) {
                totalAmount += Number(newCartList[j].amount) * Number(newCartList[j].count);
            }
            this.totalAmount = Number(totalAmount).toFixed(2);
        },

        // 筛选商品
        fliterGoods: function fliterGoods() {
            this.typeId = this.fliter_type;
            this.getGoodsData();
        },
        getGoodsData: function getGoodsData() {
            var _this6 = this;

            // this.$http.get('/products?storeId='+this.curStoreId).then((res)=>{
            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "pro-list",
                method: "GET",
                params: {
                    type: this.typeId ? this.typeId : 0
                }
            }).then(function (res) {
                for (var i = 0; i < res.data.length; i++) {
                    res.data[i].count = 1;
                }
                _this6.vipData = res.data;
                _this6.goodsNum.total = res.data.length;
                if (_this6.vipData.length < 6) {
                    for (var _i = 0, len = 6 - _this6.vipData.length; _i < len; _i++) {
                        _this6.vipData.push({});
                    }
                }
            });
        }
    },
    activated: function activated() {
        var _this7 = this;

        for (var i = 0; i < 6; i++) {
            this.vipData.push({});
        }
        this.$http({
            url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "type-list",
            method: "GET",
            params: {}
        }).then(function (res) {
            _this7.typeList = res.data;
        });
        this.userName = localStorage.getItem("username");
        this.getGoodsData();
        this.getAddress();
    },
    mounted: function mounted() {
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            $('.el-message-box__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["curStoreId", "pageSize"],
  data: function data() {
    return {
      pickerOptions0: {
        //时间禁用,今天以后的时间禁用。
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() || time.getTime() < new Date("2017,01,01").getTime();
        }
      },
      totalElements: 0,
      ratingData: [],
      getBtn: true, // 控制翻页请求
      size: 15,
      nowPage: 0,
      detailInfo: [], //订单详情
      showDetail: false
    };
  },

  watch: {},
  methods: {
    doShowDetail: function doShowDetail(item) {
      this.detailInfo = item.items;
      this.showDetail = true;
    },

    //日历插件
    cutDataFn: function cutDataFn() {
      this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.getOrderInfo(val - 1);
      this.nowPage = val;
    },
    getOrderInfo: function getOrderInfo(page) {
      var _this = this;

      this.$http({
        url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "shop-list",
        method: "GET",
        params: {
          userName: this.userName,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        console.log(res);
        _this.ratingData = res.data.content;
        _this.totalElements = res.data.totalElements;
      });
    }
  },
  created: function created() {
    this.userName = localStorage.getItem("username");
  },
  activated: function activated() {
    this.getOrderInfo(0);
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    components: {},
    data: function data() {
        return {
            // 
            isAllWeek: false,
            setMealIds: [],
            disCoutFirst: [{
                id: 0,
                name: '暂无'
            }, {
                id: 1,
                name: '会员'
            }, {
                id: 2,
                name: '时间段'
            }],
            weeks: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"],
            levelsList: [], //会员等级列表
            unitFormat: {},
            newDiscount: {
                name: '',
                id: 0,
                unitId: "",
                qty: 0
            },
            // 
            nowSelClassGoods: [], //当前所选优惠内的商品
            nowSelClass: {},
            showSelGoods: false,
            printEr: [],
            mealInfo: false,
            fliter_type: "",
            typeList: [], //分类列表
            addJobVisible: false,
            btn: false, //分类下拉三角样式
            typeData: [],
            obj: {
                name: '',
                id: '',
                price: 0,
                typeId: "",
                kitchenPrintEnabled: 0,
                ipId: ""
            },
            typeBtn: '',
            typeName: '',
            addJobBtn: true,
            systemData: [],
            mealInfoData: [], //优惠商品详情
            nowSelMealId: "", //当前查看的优惠id
            nowSelGoods: [],
            proIds: [],
            canGetClassGoods: true,
            unitOptions: []
        };
    },

    watch: {
        addJobVisible: function addJobVisible(val) {
            if (!val) {
                this.initData();
            }
        }
    },
    methods: {
        handleChangeWeeksAll: function handleChangeWeeksAll(val) {
            if (this.isAllWeek) {
                this.newDiscount.week = this.weeks;
            } else {
                this.newDiscount.week = [];
            }
        },
        getLevels: function getLevels() {
            var _this = this;

            this.$http({
                url: "level-list",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                var data = res.data;
                for (var i = 0; i < data.length; i++) {
                    data[i].nowSetPrice = "";
                }
                _this.levelsList = data;
                console.log(data);
            });
        },

        // new add
        handleChangeWeeks: function handleChangeWeeks(value) {
            console.log(value);
            this.newDiscount.week = value;
        },
        check: function check() {
            //正则验证方法
            if (!this.newDiscount.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            // if(!this.newDiscount.qty){
            //     this.$message({
            //         message: '请输入数量',
            //         customClass: 'error'
            //     })
            //     return true;
            // }
            if (!this.newDiscount.unitId) {
                this.$message({
                    message: '请选择原料单位',
                    customClass: 'error'
                });
                return true;
            }
            return false;
        },

        // 新增优惠方式
        addDiscount: function addDiscount() {
            var _this2 = this;

            if (this.check()) {
                return;
            }
            this.$http({
                url: "material/edit",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    name: this.newDiscount.name,
                    id: this.newDiscount.id,
                    unitId: this.newDiscount.unitId,
                    qty: this.newDiscount.qty
                }
            }).then(function (res) {
                _this2.$message({
                    message: res.data,
                    customClass: 'success'
                });
                _this2.addJobVisible = false;
                _this2.initData();
                _this2.getDataList();
                // if(res.data.code == 200){
                //     this.$message({
                //         message: res.data.msg,
                //         customClass: 'success'
                //     });
                //     this.addJobVisible = false;
                //     this.initData();
                //     this.getDataList();
                // }else if(res.data.code == 400){
                //     this.$message({
                //         message: res.data.msg,
                //         customClass: 'error'
                //     });
                // }
            });
        },
        initData: function initData() {
            this.newDiscount = {
                name: '',
                qty: 0,
                unitId: '',
                id: 0
            };
        },
        reduceClassGoods: function reduceClassGoods(item) {
            console.log(item);
            // return;
            var index = void 0;
            var flag = false;
            console.log(this.nowSelClassGoods);
            console.log(item);
            for (var i = 0; i < this.nowSelClassGoods.length; i++) {
                if (this.nowSelClassGoods[i].productId == item.productId) {
                    flag = true;
                    index = i;
                }
            }
            if (flag) {
                var nowSelClassGoods = this.nowSelClassGoods;
                nowSelClassGoods.splice(index, 1);
                this.nowSelClassGoods = nowSelClassGoods;
                var proIds = [];
                var setMealIds = [];
                for (var _i = 0; _i < nowSelClassGoods.length; _i++) {
                    var obj = {
                        productId: nowSelClassGoods[_i].productId,
                        setMealQty: nowSelClassGoods[_i].count
                        // productName:this.nowSelectGoods[i].productName,
                    };
                    if (!nowSelClassGoods[_i].setMealEnabled) {
                        proIds.push(obj);
                    } else {
                        setMealIds.push(nowSelClassGoods[_i].productId);
                    }
                    // proIds.push(obj);
                }
                this.proIds = proIds;
                this.setMealIds = setMealIds;
            }
        },
        closeSelGoods: function closeSelGoods() {
            this.showSelGoods = false;
            // this.getClassGoos();
        },

        //获取优惠内商品
        getClassGoos: function getClassGoos() {
            var _this3 = this;

            if (!this.canGetClassGoods) {
                return;
            }
            console.log(this.nowSelClass);
            this.$http({
                url: "/meal/get-product",
                method: "GET",
                params: {
                    mealId: this.nowSelClass.id
                }
            }).then(function (res) {
                _this3.nowSelClassGoods = res.data;
                var proIds = [];
                for (var i = 0; i < res.data.length; i++) {
                    var obj = {
                        productId: res.data[i].productId,
                        setMealQty: res.data[i].count
                    };
                    proIds.push(obj);
                }
                _this3.proIds = proIds;
            });
        },

        //添加或删除优惠商品
        updateOrAddClass: function updateOrAddClass() {
            this.$http({
                url: "/meal/add-pro",
                method: "POST",
                data: {
                    id: this.nowSelClass.id,
                    proIds: this.proIds
                }
            }).then(function (res) {
                if (res.data.code == 200) {}
            });
        },
        selOk: function selOk(data) {
            // this.nowSelGoods = data.nowSelectGoods;
            console.log(data.nowSelectGoods);
            var setMealIds = [];
            // this.nowSelClassGoods = data.nowSelectGoods;
            if (data.nowSelectGoods.length) {
                var nowSelClassGoods = data.nowSelectGoods;
                for (var i = 0; i < data.nowSelectGoods.length; i++) {
                    if (data.nowSelectGoods[i].productId) {
                        nowSelClassGoods[i].id = data.nowSelectGoods[i].productId;
                    }
                    if (data.nowSelectGoods[i].setMealEnabled) {
                        setMealIds.push(data.nowSelectGoods[i].productId);
                    }
                }
                this.nowSelClassGoods = nowSelClassGoods;
                this.nowSelGoods = nowSelClassGoods;
            }
            this.proIds = data.proIds;
            console.log(setMealIds);
            this.setMealIds = setMealIds;
            this.showSelGoods = false;
        },

        // 获取打印数据
        getPrintIpInfo: function getPrintIpInfo() {
            var _this4 = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "/v1/ip/get-ip",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this4.printEr = res.data;
                console.log(res);
            });
        },

        // 删除优惠商品
        delMealGoods: function delMealGoods(item) {
            var _this5 = this;

            console.log(item);
            if (!this.nowSelMealId) {
                return;
            }
            this.$http({
                url: "/meal/delete-pro",
                method: "POST",
                data: {
                    id: this.nowSelMealId,
                    proIds: [{
                        productId: item.id
                    }]
                }
            }).then(function (res) {
                if (res.data.code == 200) {
                    _this5.showMealInfo({ id: _this5.nowSelMealId });
                    _this5.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    return;
                } else {
                    _this5.$message({
                        message: res,
                        customClass: 'error'
                    });
                }
            });
        },

        // 查看优惠商品详情
        showMealInfo: function showMealInfo(item) {
            var _this6 = this;

            this.nowSelMealId = item.id;
            this.mealInfo = true;
            this.$http({
                url: "/meal/find-pro",
                method: "GET",
                params: {
                    mealId: item.id
                }
            }).then(function (res) {
                _this6.mealInfoData = res.data;
            });
        },

        //添加或者修改分类
        addJob: function addJob() {
            var _this7 = this;

            if (!this.obj.name) {
                this.$message({
                    message: '优惠名称有误',
                    customClass: 'error'
                });
                return;
            }
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.obj.price)) {
                this.$message({
                    message: '优惠价格有误',
                    customClass: 'error'
                });
                return;
            }
            if (!this.obj.typeId) {
                this.$message({
                    message: '请选择优惠所属分类',
                    customClass: 'error'
                });
                return;
            }
            if (this.typeBtn == 1) {
                //添加父类
                var data = void 0;
                if (this.obj.kitchenPrintEnabled) {
                    data = {
                        // "id"      : this.$uuid.create(1).hex,
                        // "sequence":-1,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "storeId": this.$route.params.id,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        "ipId": this.obj.ipId,
                        proIds: this.proIds
                        // "parentId": ''
                    };
                } else {
                    data = {
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "storeId": this.$route.params.id,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        proIds: this.proIds
                    };
                }
                // let data = {
                //     // "id"      : this.$uuid.create(1).hex,
                //     // "sequence":-1,
                //     "name"    : this.obj.name,
                //     "price":this.obj.price,
                //     "typeId":this.obj.typeId,
                //     "storeId" : this.$route.params.id,
                //     "kitchenPrintEnabled":this.obj.kitchenPrintEnabled,
                //     "ipId":this.obj.ipId
                //     // "parentId": ''
                // }
                if (!this.addJobBtn) {
                    return;
                }

                this.addJobBtn = false;
                this.$http.post('/meal/add-meal', data).then(function (res) {
                    if (res.data.code == 400) {
                        _this7.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                        _this7.addJobBtn = true;
                        return;
                    }
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                    // this.updateOrAddClass();
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 2) {
                //添加子类
                var _data = {
                    "id": this.$uuid.create(1).hex,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.id
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data).then(function (res) {
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 3) {
                this.canGetClassGoods = true;
                //、、修改父类
                if (!this.obj.name) {
                    this.$message({
                        message: '优惠名称有误',
                        customClass: 'error'
                    });
                    return;
                }
                if (!this.obj.typeId) {
                    this.$message({
                        message: '请选择优惠所属分类',
                        customClass: 'error'
                    });
                    return;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.obj.price)) {
                    this.$message({
                        message: '优惠价格有误',
                        customClass: 'error'
                    });
                    return;
                }
                var _data2 = void 0;
                if (this.obj.kitchenPrintEnabled) {
                    _data2 = {
                        "id": this.obj.id,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        "ipId": this.obj.ipId,
                        proIds: this.proIds

                    };
                } else {
                    _data2 = {
                        "id": this.obj.id,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        proIds: this.proIds

                    };
                }
                if (!this.addJobBtn) {
                    return;
                }

                this.addJobBtn = false;
                this.$http.post('/meal/update-meal', _data2).then(function (res) {
                    if (res.data.code == 400) {
                        _this7.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                        _this7.addJobBtn = true;
                        return;
                    }
                    // this.updateOrAddClass();
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                    _this7.$message({
                        message: '修改成功',
                        customClass: 'success'
                    });
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 4) {
                //、、修改子类
                var _data3 = {
                    "id": this.obj.id,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.arId
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data3).then(function (res) {
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            }
        },

        //排序
        sorting: function sorting(boo, item, ind) {
            var _this8 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = this.typeData.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": this.typeData[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == this.typeData.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i2 = 0, _len = this.typeData.length; _i2 < _len; _i2++) {
                    var _body = {
                        "productTypeId": this.typeData[_i2].id,
                        "sequence": _i2
                    };
                    list.push(_body);
                    if (ind == _i2) {
                        list[_i2].sequence = _i2 + 1;
                        num = _i2 + 1;
                    }
                    if (num == _i2) {
                        list[num].sequence = _i2 - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this8.getDataList();
            }).catch(function (err) {});
        },
        getDataList: function getDataList() {
            var _this9 = this;

            this.$http({
                url: "material/search/list",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this9.typeData = res.data;
                console.log(_this9.typeData);
            });
        },
        getUnitList: function getUnitList() {
            var _this10 = this;

            this.$http({
                url: "material/unit/list",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this10.unitOptions = res.data;
                var unitFormat = {};
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        unitFormat[it.id] = it.name;
                    });
                }
                console.log(unitFormat);
                _this10.unitFormat = unitFormat;
                _this10.getDataList();
            });
        },
        addClassify: function addClassify(id) {
            // this.$router.push({name:"discountManaEdit",query:{type:"add"}});
            this.addJobVisible = true;
            return;
            this.initData();
            //添加分类
            this.typeName = "添加折扣方式";
            this.canGetClassGoods = false;
            this.obj = {
                name: '',
                id: '',
                price: 0,
                kitchenPrintEnabled: 0
            };
            this.nowSelClassGoods = [];
            this.addJobVisible = true;
            this.obj.id = id ? id : '';
            this.typeBtn = id ? 2 : 1;
            // this.nowSelClass = {};
        },
        upClassify: function upClassify(item, oitem) {
            console.log(item);
            this.newDiscount = {
                id: item.id,
                name: item.name,
                unitId: item.unitId,
                qty: item.qty
            };
            this.addJobVisible = true;
        },
        delClassify: function delClassify(item, oitem) {
            var _this11 = this;

            this.$confirm('\u6E29\u99A8\u63D0\u793A\uFF1A\u5220\u9664\u8BE5\u539F\u6599\u5546\u54C1(' + item.name + ')\u540E\uFF0C\u4E0E\u4E4B\u7ED1\u5B9A\u7684\u5546\u54C1\u5173\u8054\u5C06\u53D6\u6D88', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除
                _this11.$http({
                    url: "material/delete",
                    method: "GET",
                    params: {
                        id: item.id
                    }
                }).then(function (res) {
                    if (res.data.code == 200) {} else {
                        _this11.$message({
                            message: res.data,
                            customClass: 'success'
                        });
                    }
                    _this11.getDataList();
                });
            }).catch(function () {});
        },
        handle: function handle(item, ind) {
            if (this.typeData[ind].isOpen) {
                this.btn = !this.btn;
            } else {
                this.btn = true;
            }
            for (var i = 0, len = this.typeData.length; i < len; i++) {
                this.typeData[i].isOpen = false;
            }
            this.typeData[ind].isOpen = true;
        }
    },
    activated: function activated() {
        this.getUnitList();
        sessionStorage.setItem("modifyDiscountItem", "{}");
        // this.getPrintIpInfo();

        //就怕sequence会大于数组的长度
        // this.$http.get('/get-type?storeId='+this.$route.params.id).then((res)=>{
        //     console.log(res.data)
        //     let body = res.data;
        //     // this.systemData = res.data.systemData;
        //     let newArr = []; 
        //     for (let i = 0, len = body.length; i < len; i++) {
        //         if ( !body[i].parent ) {
        //             body[i].isOpen = false;
        //             newArr.push(body[i]);
        //             newArr[newArr.length-1].children = [];
        //             for (let j = 0, len = body.length; j < len; j++) {
        //                 if ( body[j].parent&&body[i].id==body[j].parent.id) {
        //                     newArr[newArr.length-1].children.push(body[j]);
        //                 }
        //             }
        //         }
        //     }
        //     let list = [];
        //     for (let i = 0, len = newArr.length; i < len; i++) {
        //         let bodys = {
        //             "productTypeId":newArr[i].id,
        //             "sequence":i
        //         };
        //         list.push(bodys)
        //     }
        //     if(!list.length){
        //         return;
        //     }
        //     this.$http.put('/product-sequence',{"products":list}).then((res)=>{
        //         this.getDataList();
        //     }).catch((err) => {
        //     });
        // }).catch((err) => {
        // });
    }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    components: {},
    data: function data() {
        return {
            // 
            isAllWeek: false,
            setMealIds: [],
            disCoutFirst: [{
                id: 0,
                name: '暂无'
            }, {
                id: 1,
                name: '会员'
            }, {
                id: 2,
                name: '时间段'
            }],
            weeks: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"],
            levelsList: [], //会员等级列表
            newDiscount: {
                name: '',
                id: 0
            },
            // 
            nowSelClassGoods: [], //当前所选优惠内的商品
            nowSelClass: {},
            showSelGoods: false,
            printEr: [],
            mealInfo: false,
            fliter_type: "",
            typeList: [], //分类列表
            addJobVisible: false,
            btn: false, //分类下拉三角样式
            typeData: [],
            obj: {
                name: '',
                id: '',
                price: 0,
                typeId: "",
                kitchenPrintEnabled: 0,
                ipId: ""
            },
            typeBtn: '',
            typeName: '',
            addJobBtn: true,
            systemData: [],
            mealInfoData: [], //优惠商品详情
            nowSelMealId: "", //当前查看的优惠id
            nowSelGoods: [],
            proIds: [],
            canGetClassGoods: true
        };
    },

    watch: {
        addJobVisible: function addJobVisible(val) {
            if (!val) {
                this.initData();
            }
        }
    },
    methods: {
        handleChangeWeeksAll: function handleChangeWeeksAll(val) {
            if (this.isAllWeek) {
                this.newDiscount.week = this.weeks;
            } else {
                this.newDiscount.week = [];
            }
        },
        getLevels: function getLevels() {
            var _this = this;

            this.$http({
                url: "level-list",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                var data = res.data;
                for (var i = 0; i < data.length; i++) {
                    data[i].nowSetPrice = "";
                }
                _this.levelsList = data;
                console.log(data);
            });
        },

        // new add
        handleChangeWeeks: function handleChangeWeeks(value) {
            console.log(value);
            this.newDiscount.week = value;
        },
        check: function check() {
            //正则验证方法
            if (!this.newDiscount.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            return false;
        },

        // 新增优惠方式
        addDiscount: function addDiscount() {
            var _this2 = this;

            if (this.check()) {
                return;
            }
            this.$http({
                url: "material/unit/edit",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    name: this.newDiscount.name,
                    id: this.newDiscount.id
                }
            }).then(function (res) {
                _this2.$message({
                    message: res.data,
                    customClass: 'success'
                });
                _this2.addJobVisible = false;
                _this2.initData();
                _this2.getDataList();
                // if(res.data.code == 200){
                //     this.$message({
                //         message: res.data.msg,
                //         customClass: 'success'
                //     });
                //     this.addJobVisible = false;
                //     this.initData();
                //     this.getDataList();
                // }else if(res.data.code == 400){
                //     this.$message({
                //         message: res.data.msg,
                //         customClass: 'error'
                //     });
                // }
            });
        },
        initData: function initData() {
            this.newDiscount = {
                name: '',
                id: 0
            };
        },
        reduceClassGoods: function reduceClassGoods(item) {
            console.log(item);
            // return;
            var index = void 0;
            var flag = false;
            console.log(this.nowSelClassGoods);
            console.log(item);
            for (var i = 0; i < this.nowSelClassGoods.length; i++) {
                if (this.nowSelClassGoods[i].productId == item.productId) {
                    flag = true;
                    index = i;
                }
            }
            if (flag) {
                var nowSelClassGoods = this.nowSelClassGoods;
                nowSelClassGoods.splice(index, 1);
                this.nowSelClassGoods = nowSelClassGoods;
                var proIds = [];
                var setMealIds = [];
                for (var _i = 0; _i < nowSelClassGoods.length; _i++) {
                    var obj = {
                        productId: nowSelClassGoods[_i].productId,
                        setMealQty: nowSelClassGoods[_i].count
                        // productName:this.nowSelectGoods[i].productName,
                    };
                    if (!nowSelClassGoods[_i].setMealEnabled) {
                        proIds.push(obj);
                    } else {
                        setMealIds.push(nowSelClassGoods[_i].productId);
                    }
                    // proIds.push(obj);
                }
                this.proIds = proIds;
                this.setMealIds = setMealIds;
            }
        },
        closeSelGoods: function closeSelGoods() {
            this.showSelGoods = false;
            // this.getClassGoos();
        },

        //获取优惠内商品
        getClassGoos: function getClassGoos() {
            var _this3 = this;

            if (!this.canGetClassGoods) {
                return;
            }
            console.log(this.nowSelClass);
            this.$http({
                url: "/meal/get-product",
                method: "GET",
                params: {
                    mealId: this.nowSelClass.id
                }
            }).then(function (res) {
                _this3.nowSelClassGoods = res.data;
                var proIds = [];
                for (var i = 0; i < res.data.length; i++) {
                    var obj = {
                        productId: res.data[i].productId,
                        setMealQty: res.data[i].count
                    };
                    proIds.push(obj);
                }
                _this3.proIds = proIds;
            });
        },

        //添加或删除优惠商品
        updateOrAddClass: function updateOrAddClass() {
            this.$http({
                url: "/meal/add-pro",
                method: "POST",
                data: {
                    id: this.nowSelClass.id,
                    proIds: this.proIds
                }
            }).then(function (res) {
                if (res.data.code == 200) {}
            });
        },
        selOk: function selOk(data) {
            // this.nowSelGoods = data.nowSelectGoods;
            console.log(data.nowSelectGoods);
            var setMealIds = [];
            // this.nowSelClassGoods = data.nowSelectGoods;
            if (data.nowSelectGoods.length) {
                var nowSelClassGoods = data.nowSelectGoods;
                for (var i = 0; i < data.nowSelectGoods.length; i++) {
                    if (data.nowSelectGoods[i].productId) {
                        nowSelClassGoods[i].id = data.nowSelectGoods[i].productId;
                    }
                    if (data.nowSelectGoods[i].setMealEnabled) {
                        setMealIds.push(data.nowSelectGoods[i].productId);
                    }
                }
                this.nowSelClassGoods = nowSelClassGoods;
                this.nowSelGoods = nowSelClassGoods;
            }
            this.proIds = data.proIds;
            console.log(setMealIds);
            this.setMealIds = setMealIds;
            this.showSelGoods = false;
        },

        // 获取打印数据
        getPrintIpInfo: function getPrintIpInfo() {
            var _this4 = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig__["a" /* BASE_URL */] + "/v1/ip/get-ip",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this4.printEr = res.data;
                console.log(res);
            });
        },

        // 删除优惠商品
        delMealGoods: function delMealGoods(item) {
            var _this5 = this;

            console.log(item);
            if (!this.nowSelMealId) {
                return;
            }
            this.$http({
                url: "/meal/delete-pro",
                method: "POST",
                data: {
                    id: this.nowSelMealId,
                    proIds: [{
                        productId: item.id
                    }]
                }
            }).then(function (res) {
                if (res.data.code == 200) {
                    _this5.showMealInfo({ id: _this5.nowSelMealId });
                    _this5.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    return;
                }
            });
        },

        // 查看优惠商品详情
        showMealInfo: function showMealInfo(item) {
            var _this6 = this;

            this.nowSelMealId = item.id;
            this.mealInfo = true;
            this.$http({
                url: "/meal/find-pro",
                method: "GET",
                params: {
                    mealId: item.id
                }
            }).then(function (res) {
                _this6.mealInfoData = res.data;
            });
        },

        //添加或者修改分类
        addJob: function addJob() {
            var _this7 = this;

            if (!this.obj.name) {
                this.$message({
                    message: '优惠名称有误',
                    customClass: 'error'
                });
                return;
            }
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.obj.price)) {
                this.$message({
                    message: '优惠价格有误',
                    customClass: 'error'
                });
                return;
            }
            if (!this.obj.typeId) {
                this.$message({
                    message: '请选择优惠所属分类',
                    customClass: 'error'
                });
                return;
            }
            if (this.typeBtn == 1) {
                //添加父类
                var data = void 0;
                if (this.obj.kitchenPrintEnabled) {
                    data = {
                        // "id"      : this.$uuid.create(1).hex,
                        // "sequence":-1,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "storeId": this.$route.params.id,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        "ipId": this.obj.ipId,
                        proIds: this.proIds
                        // "parentId": ''
                    };
                } else {
                    data = {
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "storeId": this.$route.params.id,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        proIds: this.proIds
                    };
                }
                // let data = {
                //     // "id"      : this.$uuid.create(1).hex,
                //     // "sequence":-1,
                //     "name"    : this.obj.name,
                //     "price":this.obj.price,
                //     "typeId":this.obj.typeId,
                //     "storeId" : this.$route.params.id,
                //     "kitchenPrintEnabled":this.obj.kitchenPrintEnabled,
                //     "ipId":this.obj.ipId
                //     // "parentId": ''
                // }
                if (!this.addJobBtn) {
                    return;
                }

                this.addJobBtn = false;
                this.$http.post('/meal/add-meal', data).then(function (res) {
                    if (res.data.code == 400) {
                        _this7.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                        _this7.addJobBtn = true;
                        return;
                    }
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                    // this.updateOrAddClass();
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 2) {
                //添加子类
                var _data = {
                    "id": this.$uuid.create(1).hex,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.id
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data).then(function (res) {
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 3) {
                this.canGetClassGoods = true;
                //、、修改父类
                if (!this.obj.name) {
                    this.$message({
                        message: '优惠名称有误',
                        customClass: 'error'
                    });
                    return;
                }
                if (!this.obj.typeId) {
                    this.$message({
                        message: '请选择优惠所属分类',
                        customClass: 'error'
                    });
                    return;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.obj.price)) {
                    this.$message({
                        message: '优惠价格有误',
                        customClass: 'error'
                    });
                    return;
                }
                var _data2 = void 0;
                if (this.obj.kitchenPrintEnabled) {
                    _data2 = {
                        "id": this.obj.id,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        "ipId": this.obj.ipId,
                        proIds: this.proIds

                    };
                } else {
                    _data2 = {
                        "id": this.obj.id,
                        "name": this.obj.name,
                        "price": this.obj.price,
                        "typeId": this.obj.typeId,
                        "kitchenPrintEnabled": this.obj.kitchenPrintEnabled,
                        proIds: this.proIds

                    };
                }
                if (!this.addJobBtn) {
                    return;
                }

                this.addJobBtn = false;
                this.$http.post('/meal/update-meal', _data2).then(function (res) {
                    if (res.data.code == 400) {
                        _this7.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                        _this7.addJobBtn = true;
                        return;
                    }
                    // this.updateOrAddClass();
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                    _this7.$message({
                        message: '修改成功',
                        customClass: 'success'
                    });
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            } else if (this.typeBtn == 4) {
                //、、修改子类
                var _data3 = {
                    "id": this.obj.id,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.arId
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data3).then(function (res) {
                    _this7.getDataList();
                    _this7.addJobVisible = false;
                    _this7.addJobBtn = true;
                }).catch(function () {
                    _this7.addJobBtn = true;
                });
            }
        },

        //排序
        sorting: function sorting(boo, item, ind) {
            var _this8 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = this.typeData.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": this.typeData[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == this.typeData.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i2 = 0, _len = this.typeData.length; _i2 < _len; _i2++) {
                    var _body = {
                        "productTypeId": this.typeData[_i2].id,
                        "sequence": _i2
                    };
                    list.push(_body);
                    if (ind == _i2) {
                        list[_i2].sequence = _i2 + 1;
                        num = _i2 + 1;
                    }
                    if (num == _i2) {
                        list[num].sequence = _i2 - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this8.getDataList();
            }).catch(function (err) {});
        },
        getDataList: function getDataList() {
            var _this9 = this;

            this.$http({
                url: "material/unit/list",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this9.typeData = res.data;
                console.log(_this9.typeData);
            });
        },
        addClassify: function addClassify(id) {
            // this.$router.push({name:"discountManaEdit",query:{type:"add"}});
            this.addJobVisible = true;
            return;
            this.initData();
            //添加分类
            this.typeName = "添加折扣方式";
            this.canGetClassGoods = false;
            this.obj = {
                name: '',
                id: '',
                price: 0,
                kitchenPrintEnabled: 0
            };
            this.nowSelClassGoods = [];
            this.addJobVisible = true;
            this.obj.id = id ? id : '';
            this.typeBtn = id ? 2 : 1;
            // this.nowSelClass = {};
        },
        upClassify: function upClassify(item, oitem) {
            console.log(item);
            this.newDiscount = {
                id: item.id,
                name: item.name
            };
            this.addJobVisible = true;
        },
        delClassify: function delClassify(item, oitem) {
            var _this10 = this;

            this.$confirm('\u662F\u5426\u5220\u9664 ' + item.name + ' ?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除
                _this10.$http({
                    url: "material/unit/delete",
                    method: "GET",
                    params: {
                        id: item.id
                    }
                }).then(function (res) {
                    if (res.data.code == 200) {} else {
                        _this10.$message({
                            message: res.data,
                            customClass: 'success'
                        });
                    }
                    _this10.getDataList();
                });
            }).catch(function () {});
        },
        handle: function handle(item, ind) {
            if (this.typeData[ind].isOpen) {
                this.btn = !this.btn;
            } else {
                this.btn = true;
            }
            for (var i = 0, len = this.typeData.length; i < len; i++) {
                this.typeData[i].isOpen = false;
            }
            this.typeData[ind].isOpen = true;
        }
    },
    activated: function activated() {
        this.getDataList();
        sessionStorage.setItem("modifyDiscountItem", "{}");
        // this.getPrintIpInfo();

        //就怕sequence会大于数组的长度
        // this.$http.get('/get-type?storeId='+this.$route.params.id).then((res)=>{
        //     console.log(res.data)
        //     let body = res.data;
        //     // this.systemData = res.data.systemData;
        //     let newArr = []; 
        //     for (let i = 0, len = body.length; i < len; i++) {
        //         if ( !body[i].parent ) {
        //             body[i].isOpen = false;
        //             newArr.push(body[i]);
        //             newArr[newArr.length-1].children = [];
        //             for (let j = 0, len = body.length; j < len; j++) {
        //                 if ( body[j].parent&&body[i].id==body[j].parent.id) {
        //                     newArr[newArr.length-1].children.push(body[j]);
        //                 }
        //             }
        //         }
        //     }
        //     let list = [];
        //     for (let i = 0, len = newArr.length; i < len; i++) {
        //         let bodys = {
        //             "productTypeId":newArr[i].id,
        //             "sequence":i
        //         };
        //         list.push(bodys)
        //     }
        //     if(!list.length){
        //         return;
        //     }
        //     this.$http.put('/product-sequence',{"products":list}).then((res)=>{
        //         this.getDataList();
        //     }).catch((err) => {
        //     });
        // }).catch((err) => {
        // });
    }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__urlConfig_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_selGoods_selGoods__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_selGoods_selGoods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_selGoods_selGoods__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    components: { imgCrop: __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue___default.a, selGoods: __WEBPACK_IMPORTED_MODULE_3__components_selGoods_selGoods___default.a },
    props: ['curStoreId'],
    data: function data() {
        return {
            showMat: false,
            seledMats: [],
            isAllWeek: false,
            weeks: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"],
            timeChoiceBtnForComm: false,
            printEr: [],
            pcEnable: true,
            pcBuyEnable: true,
            disCom: 0, //开启折扣价后的提成金额
            beginTime: "",
            endTime: "",
            // croseDay:false,
            discountEnable: false,
            discountPrice: 100, //折扣价格
            vipEnable: false,
            vipPrice: "", //会员价格
            systemData: [],
            timeList: [],
            timeChoice: '',
            timeChoiceForComm: ["", ""],
            timeChoiceBtn: false,
            newTimeList: [],
            newTimeListForComm: [{
                commission: "",
                timeRange: []
            }], //提成时间段
            checkeds: false,
            isStock: 'ON', //是否库存管理
            kitchenPrintEnabled: 'OFF', //是否厨房打印
            isDirectThermal: 'OFF', // 是否贴纸打印
            dialogVisible: false,
            newGoods: {
                timeRangeComm: false,
                sort: 0,
                salesCount: 0,
                salesShowEnabled: false,
                salesEnabled: false,
                // 
                labelEnabled: 0, //标签打印
                id: '', // 员工id
                productTypeId: '', // 员工id
                name: '', // 员工姓名
                barCode: '', // 条码
                // costPrice: '', // 进价
                salesPrice: '', // 出售价
                storeId: this.curStoreId, // 商铺id
                inStockNumber: '', // 库存
                supplierName: '', // 供应商
                supplyTimeEnd: '', // 起售时间
                supplyTimeBegin: '', // 止售时间
                productStatus: 'ON', // 状态
                imageURL: '', // 图片路径
                // stockQuantityRatio: '', // 每件多少个
                commission: '0', //提成价格，默认为0
                productQty: 1, //配品数量默认为1
                ipId: "",
                threshold: 0, //库存告警值
                note: "",
                week: []
            },
            vipData: [], //所有配品列表
            goodsNum: {
                pageNum: 1,
                pageSize: 6,
                total: 0
            },
            btnId: '', //添加或修改配品按钮
            addId: '',
            coverImgMaxSize: 5 * 1024 * 1024, // 图片最大字节数
            oldImgBase64: '', // 原图base64
            showCrop: false, // 控制图片裁剪显示隐藏
            curCropW: 600, // 裁剪宽度
            curCropH: 600, // 裁剪高度
            infoload: false, // loading

            addGoodApiBtn: true, // 控制添加配品接口

            goodCheckArr: [],
            addGoodCheckArr: [], //添加配品搜索出来的配品列表
            isAutoSearchBtn: true, //添加配品是否开启检索
            addCurGoodIdx: 0, // 当前配品索引
            goods: '',
            curGoodIdx: 0, // 当前配品索引
            goodSearchBtn: true,

            fliter_type: '', // 当前筛选条件
            fliter_status: '', // 当前筛选条件
            fliter_stock: '', // 当前筛选条件
            fliter_kitchen: '', // 当前筛选条件
            typeList: [],
            multipleSelection: [],
            matData: [],
            unitOptions: [],
            unitFormat: {}
        };
    },

    watch: {
        // "newGoods.timeRangeComm":function(val){
        //     if(val){
        //        $("#comm").parents(".msgItem").css("margin-bottom",this.newTimeListForComm.length * 25);
        //     }else{
        //         this.newTimeListForComm = [];
        //     }
        // },
        // newTimeListForComm:function(val){
        //     // if(this.newTimeListForComm.length){
        //        $("#comm").parents(".msgItem").css("margin-bottom",val.length * 25);
        //     // }
        // },
        newTimeList: function newTimeList(val) {
            // if(this.newTimeListForComm.length){
            console.log($("#timeSales").parents(".msgItem").css("margin-bottom", val.length * 25));
            // }
        },
        goods: function goods(val) {
            if (val) {
                this.searchGoods(val, null);
            } else {
                this.goodCheckArr = [];
                this.getGoodsData();
            }
        },
        'newGoods.name': function newGoodsName(val) {
            if (val) {
                // if(this.isAutoSearchBtn){
                this.searchGoods(val, '9f5afd60-e952-11e7-a26a-83436326b6c5');
                // }else {

                // }
            } else {
                this.addGoodCheckArr = [];
                // this.getGoodsData();
            }
        },
        timeChoice: function timeChoice(val) {
            if (val == '') {
                return;
            }
            if (this.newTimeList.length >= 3) {
                this.$message({
                    message: '最多只能添加3个时间段',
                    customClass: 'error'
                });
                this.timeChoice = '';
                return;
            }
            for (var i = 0; i < this.timeList.length; i++) {
                if (val == this.timeList[i].id) {

                    var isPush = true;
                    for (var j = 0; j < this.newTimeList.length; j++) {
                        if (this.newTimeList[j].id == val) {
                            isPush = false;
                            this.$message({
                                message: '已经有该时段',
                                customClass: 'error'
                            });
                        }
                    }
                    if (isPush) {
                        this.newTimeList.push(this.timeList[i]);
                    }
                }
            }
            this.timeChoiceBtn = false;
            this.timeChoice = '';
        },

        // timeChoiceForComm(val){
        //     console.log(val)
        //     return;
        //     if(val==''){
        //         return;
        //     }
        //     if(this.newTimeListForComm.length>=5){
        //         this.$message({
        //             message: '最多只能添加5个时间段',
        //             customClass: 'error'
        //         })
        //         this.timeChoiceForComm = '';
        //         return;
        //     }
        //     this.newTimeListForComm.push(val); 
        //     this.timeChoiceForComm = '';
        // }
        dialogVisible: function dialogVisible(val) {
            if (!val) {
                this.seledMats = [];
            }
        }
    },
    methods: {
        saveSeledMats: function saveSeledMats() {
            var seledMats = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seledMats));
            var willbeSel = this.multipleSelection;
            seledMats = willbeSel;
            this.seledMats = seledMats;
            console.log(seledMats);
            this.showMat = false;
        },
        getUnitList: function getUnitList() {
            var _this = this;

            this.$http({
                url: "material/unit/list",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this.unitOptions = res.data;
                var unitFormat = {};
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        unitFormat[it.id] = it.name;
                    });
                }
                console.log(unitFormat);
                _this.unitFormat = unitFormat;
                _this.getDataList();
            });
        },
        getDataList: function getDataList() {
            var _this2 = this;

            this.$http({
                url: "material/search/list",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 10000
                }
            }).then(function (res) {
                _this2.matData = res.data;
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        addMatGoods: function addMatGoods() {
            this.showMat = true;
            // this.getUnitList();
        },
        handleChangeWeeks: function handleChangeWeeks(value) {
            console.log(value);
            // this.newGoods.week = value;
        },
        handleChangeWeeksAll: function handleChangeWeeksAll(val) {
            if (this.isAllWeek) {
                this.newGoods.week = this.weeks;
            } else {
                this.newGoods.week = [];
            }
        },
        addCommTime: function addCommTime() {
            var obj = {
                commission: "",
                timeRange: []
            };
            this.newTimeListForComm.push(obj);
        },
        setTimeForComm: function setTimeForComm() {
            console.log(new Date(this.timeChoiceForComm[0]).Format("hh:mm"));
            if (this.newTimeListForComm.length >= 5) {
                this.$message({
                    message: '最多只能添加5个时间段',
                    customClass: 'error'
                });
                this.timeChoiceForComm = '';
                return;
            }
            var obj = {
                commPrice: "",
                start: "",
                end: ""
            };
            this.newTimeListForComm.push(obj);
            this.timeChoiceForComm = '';
        },

        // 获取打印数据
        getPrintIpInfo: function getPrintIpInfo() {
            var _this3 = this;

            this.$http({
                url: "ip-list",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this3.printEr = res.data;
                console.log(res);
            });
        },

        // 隐藏添加配品、修改配品时的配品名字检索
        hideSearchList: function hideSearchList() {
            this.addGoodCheckArr = [];
        },

        // 删除修改配品时的图片
        delImg: function delImg() {
            this.$refs.goodsImg.src = 'https://hxypic.oss-cn-hangzhou.aliyuncs.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
            this.newGoods.imageURL = 'https://hxypic.oss-cn-hangzhou.aliyuncs.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
        },
        selSearchGood: function selSearchGood(item, boo) {
            var _this4 = this;

            this.$http.get(item.id + '/product').then(function (res) {
                if (boo == 'add') {
                    console.log(res.data);
                    _this4.addGoodCheckArr = [];
                    _this4.addId = item.id;
                    _this4.newGoods = {
                        // barCode       : res.data.barCode,
                        // salesPrice    : res.data.salesPrice,
                        // inStockNumber : res.data.inStockNumber,
                        // supplierName  : res.data.supplierName,
                        name: res.data.name,
                        imageURL: res.data.imageURL,
                        productStatus: 'OFF',
                        labelEnabled: 0,
                        timeRangeComm: false,
                        salesEnabled: false,
                        // stockQuantityRatio : res.data.stockQuantityRatio,
                        commission: 0,
                        week: res.data.week ? Array.isArray(res.data.week) ? res.data.week : res.data.week.split(",") : []
                        // productQty:res.data.productQty
                    };
                    _this4.timeChoiceBtn = false;
                    _this4.isStock = 'OFF';
                    _this4.vipEnable = false;
                    _this4.kitchenPrintEnabled = 'OFF';
                    _this4.isDirectThermal = 'OFF';
                    _this4.dialogVisible = true;
                    _this4.pcEnable = true;
                    _this4.pcBuyEnable = true;
                    _this4.addCurGoodIdx = 0;
                    _this4.discountEnable = false;
                } else if (boo == 'search') {
                    _this4.goodCheckArr = [];
                    _this4.vipData = [res.data];
                    if (_this4.vipData.length < 6) {
                        for (var i = 0, len = 6 - _this4.vipData.length; i < len; i++) {
                            _this4.vipData.push({});
                        }
                    }
                }
            });
        },

        // 配品检索
        searchGoods: function searchGoods(val, id) {
            var _this5 = this;

            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http.get('products/stores-search?storeId=' + (id ? id : this.curStoreId) + '&stockEnabled=false' + '&q=' + encodeURI(val) + '&matchProductEnabled=true').then(function (res) {
                if (id) {
                    _this5.addGoodCheckArr = res.data;
                    _this5.isAutoSearchBtn = false;
                    setTimeout(function () {
                        _this5.isAutoSearchBtn = true;
                    }, 2000);
                    setTimeout(function () {
                        var that = _this5;
                        $('.add_details_search li').hover(function () {
                            that.addCurGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.addCurGoodIdx = 0;
                        });
                    }, 0);
                } else {
                    _this5.goodCheckArr = res.data;
                    setTimeout(function () {
                        var that = _this5;
                        $('.details_search li').hover(function () {
                            that.curGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.curGoodIdx = 0;
                        });
                    }, 0);
                }
                _this5.goodSearchBtn = true;
            }).catch(function () {
                _this5.goodSearchBtn = true;
            });
        },

        //删除时段
        removeTimes: function removeTimes(item) {
            for (var i = 0; i < this.newTimeList.length; i++) {
                if (this.newTimeList[i].id == item.id) {
                    this.newTimeList.splice(i, 1);
                }
            }
        },

        //删除时段
        removeTimesForComm: function removeTimesForComm(item) {
            for (var i = 0; i < this.newTimeListForComm.length; i++) {
                if (this.newTimeListForComm[i].id == item.id) {
                    this.newTimeListForComm.splice(i, 1);
                }
            }
        },
        addTimesForComm: function addTimesForComm() {
            this.timeChoiceBtnForComm = true;
        },

        //添加时段
        addTimes: function addTimes(item) {
            this.timeChoiceBtn = true;
        },

        // 获取时段列表
        getTimesList: function getTimesList() {
            var _this6 = this;

            this.$http.get('/product-supply-time?storeId=' + this.curStoreId).then(function (res) {
                var body = res.data;
                if (body && body[0]) {
                    _this6.timeList = body;
                }
            }).catch(function (err) {});
        },
        selOk: function selOk(data) {
            console.log(data);
            this.seledMats = data.nowSelectGoods;
            this.showMat = false;
        },
        uploadGood: function uploadGood(item) {
            //修改配品
            this.btnId = item.id;
            this.addGoodCheckArr = [];
            this.isAutoSearchBtn = false;
            this.newGoods = {
                productTypeId: item.typeId,
                barCode: item.barCode,
                // costPrice     : item.costPrice,
                salesPrice: item.salesPrice,
                inStockNumber: item.inStockNumber,
                supplierName: item.supplierName,
                name: item.name,
                imageURL: item.imageURL,
                // productStatus : item.productStatus?'OFF':'ON',
                // stockQuantityRatio : item.stockQuantityRatio,
                commission: item.commission,
                memberShow: item.memberShow,
                disShow: item.disShow,
                productQty: item.productQty,
                labelEnabled: item.labelEnabled ? 1 : 0,
                ipId: item.ipId == 0 ? "" : item.ipId,
                threshold: item.threshold, //库存告警值
                // 
                sort: item.sort,
                salesCount: item.salesCount,
                salesShowEnabled: item.salesShowEnabled,
                salesEnabled: item.salesEnabled,
                timeRangeComm: item.openTimeEnabled,
                note: item.note,
                week: item.week ? item.week.split(",") : []
            };
            console.log(this.newGoods);
            if (this.newGoods.week && this.newGoods.week.length && this.newGoods.week.length == 7) {
                this.isAllWeek = true;
            } else {
                this.isAllWeek = false;
            }
            if (item.productMaterialItems && Array.isArray(item.productMaterialItems) && item.productMaterialItems.length) {
                item.productMaterialItems.forEach(function (it) {
                    it.formId = it.id;
                    it.name = it.productMaterialName;
                    it.count = it.qty;
                });
            }
            this.seledMats = item.productMaterialItems;
            var newTimeListForComm = [];
            for (var _i = 0; _i < item.list.length; _i++) {
                var obj = {
                    commission: item.list[_i].commission,
                    timeRange: [new Date("2020/01/01 " + item.list[_i].begin), new Date("2020/01/01 " + item.list[_i].end)]
                };
                if (item.list[_i].begin == "aN:aN:00" || item.list[_i].end == "aN:aN:59") {
                    obj = {
                        commission: item.list[_i].commission,
                        timeRange: ["", ""]
                    };
                }

                newTimeListForComm.push(obj);
            }
            this.newTimeListForComm = newTimeListForComm;
            if (item.supplyTimes) {
                this.newTimeList = [];
                var supplyTimes = JSON.parse(item.supplyTimes);
                for (var i = 0; i < supplyTimes.length; i++) {
                    if (supplyTimes[i].id) {
                        this.newTimeList.push(supplyTimes[i]);
                    }
                }
            } else {
                this.newTimeList = [];
            }
            this.timeChoiceBtn = false;
            this.isStock = item.stockEnabled ? 'ON' : 'OFF';
            this.kitchenPrintEnabled = item.kitchenPrintEnabled ? 'ON' : 'OFF';
            this.isDirectThermal = item.isDirectThermal ? 'ON' : 'OFF';
            this.dialogVisible = true;
            // 
            this.vipEnable = item.memberShow; //是否开启会员价格
            this.vipPrice = item.memberPrice; //会员价格
            this.discountEnable = item.disShow; //是否开启折扣
            this.discountPrice = item.disPrice * 100; //折扣百分比
            var dateForBeg = new Date("2018-11-11 " + item.nowHours);
            var dateForEnd = new Date("2018-11-11 " + item.tomorrowHour);
            this.beginTime = dateForBeg; //折扣起始时间
            this.endTime = dateForEnd; //折扣终止时间
            this.disCom = item.disCom;
            // this.croseDay = item.cross;//折扣时间是否跨天s

            // 是否显示在客户端和是否是否允许购买
            this.pcEnable = item.showEnabled;
            this.pcBuyEnable = item.purchaseEnabled;
        },

        //初始化 配品数据
        initDate: function initDate() {
            this.timeChoiceBtn = false;
            this.isAutoSearchBtn = true;
            this.btnId = null;
            this.addId = null;
            this.newGoods = {
                id: '', // 员工id
                productTypeId: '', // 配品id
                name: '', // 员工姓名
                barCode: '', // 条码
                // costPrice: '', // 进价
                salesPrice: '', // 出售价
                storeId: this.curStoreId, // 商铺id
                inStockNumber: '', // 库存
                supplierName: '', // 供应商
                productStatus: 'ON', // 状态
                imageURL: '', // 图片路径
                // stockQuantityRatio : '',
                commission: '0', //配品提成
                productQty: 1, //默认配品数量
                labelEnabled: 0,
                ipId: "",
                threshold: 0,
                // 
                sort: 0,
                salesCount: 0,
                salesShowEnabled: false,
                salesEnabled: false,
                timeRangeComm: false,
                note: "",
                week: []
            };

            this.newTimeList = [];
            this.seledMats = [];
            this.newTimeListForComm = [{
                commission: "",
                timeRange: []
            }];
            this.isStock = 'OFF';
            // 
            this.discountEnable = false;
            this.vipEnable = false;
            this.discountPrice = 100, this.vipPrice = "";
            this.beginTime = "";
            this.endTime = "";
            this.disCom = 0;
            // 
        },
        addGoods: function addGoods() {
            //点击添加配品，清空 newGoods并获取获取配品分类
            this.dialogVisible = true;
            this.initDate();
        },

        // 筛选配品
        fliterGoods: function fliterGoods() {
            var _this7 = this;

            var fliter_stock = '-1';
            var fliter_kitchen = '-1';
            if (this.fliter_stock == 'true') {
                fliter_stock = 1;
            } else if (this.fliter_stock == 'false') {
                fliter_stock = 0;
            }
            if (this.fliter_kitchen == 'true') {
                fliter_kitchen = 1;
            } else if (this.fliter_kitchen == 'false') {
                fliter_kitchen = 0;
            }

            this.$http.get('/products?storeId=' + this.curStoreId + '&typeId=' + this.fliter_type + '&isStock=' + fliter_stock + '&kitchen=' + fliter_kitchen + "&matchProductEnabled=true").then(function (res) {
                _this7.vipData = res.data;
                _this7.goodsNum.total = res.data.length;
                if (_this7.vipData.length < 6) {
                    for (var i = 0, len = 6 - _this7.vipData.length; i < len; i++) {
                        _this7.vipData.push({});
                    }
                }
            });
        },

        // 删除配品
        delGoods: function delGoods(goodId) {
            var _this8 = this;

            this.$confirm('温馨提示：删除该配品后，与之绑定的商品关联将取消', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除配品
                _this8.$http.delete('/products?id=' + goodId).then(function (res) {
                    if (res.status) {
                        if (_this8.fliter_type != '' || _this8.fliter_stock != '' || _this8.fliter_kitchen != '') {
                            _this8.fliterGoods();
                        } else {
                            _this8.getGoodsData();
                        }
                    }
                });
            }).catch(function () {});
        },
        getGoodsData: function getGoodsData() {
            var _this9 = this;

            // this.$http.get('/products?storeId='+this.curStoreId).then((res)=>{
            this.$http.get('/get-ps?storeId=' + this.curStoreId + "&matchProductEnabled=true").then(function (res) {
                _this9.vipData = res.data;
                _this9.goodsNum.total = res.data.length;
                if (_this9.vipData.length < 6) {
                    for (var i = 0, len = 6 - _this9.vipData.length; i < len; i++) {
                        _this9.vipData.push({});
                    }
                }
            });
        },
        checkFn: function checkFn() {
            //正则验证方法
            if (!this.newGoods.name) {
                this.$message({
                    message: '请输入配品名',
                    customClass: 'error'
                });
                return true;
            }
            if (this.newGoods.note != null) {
                if (this.newGoods.note.length > 15) {
                    this.$message({
                        message: '配品描述最长15个字符',
                        customClass: 'error'
                    });
                    return true;
                }
            }

            // 分类限制，如果选择了网费分类，配品名则必须含有网费字眼，其他配品转为网费分类同样需要网费字眼
            if (this.newGoods.productTypeId == 1) {
                if (!/(\u7f51\u8d39)/.test(this.newGoods.name)) {
                    this.$message({
                        message: '当前选择了火星网费分类，配品名必须含有网费字眼。',
                        customClass: 'error'
                    });
                    return true;
                }
            } else {
                if (/(\u7f51\u8d39)/.test(this.newGoods.name)) {
                    this.$message({
                        message: '当前分类下，配品名不能含有网费字眼。',
                        customClass: 'error'
                    });
                    return true;
                }
            }
            // 
            if (this.isStock == "ON") {
                if (!/(^0{1}$)|(^[1-9][0-9]*$)/.test(this.newGoods.threshold)) {
                    this.$message({
                        message: '数量输入有误',
                        customClass: 'error'
                    });
                    return true;
                }
            } else if (this.isStock == "OFF") {
                // if(!/^\d+(\.{0,1}\d+){0,1}$/.test(this.newGoods.stockQuantityRatio)){
                //     this.$message({
                //         message: '配品规格格式有误',
                //         customClass: 'error'
                //     })
                //     return true;
                // }
            }
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newGoods.salesPrice)) {
                this.$message({
                    message: '销售价格格式有误',
                    customClass: 'error'
                });
                return true;
            }
            if (!/^[1-9][0-9]*$/.test(this.newGoods.productQty)) {
                this.$message({
                    message: '数量输入有误',
                    customClass: 'error'
                });
                return true;
            }
            if (this.vipEnable) {
                if (!this.vipPrice) {
                    this.$message({
                        message: '请输入会员价',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.vipPrice)) {
                    this.$message({
                        message: '会员价格格式有误',
                        customClass: 'error'
                    });
                    return true;
                }
            }
            if (this.discountEnable) {
                if (!this.discountPrice) {
                    this.$message({
                        message: '请输入折扣百分比',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.discountPrice)) {
                    this.$message({
                        message: '折扣格式有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.disCom)) {
                    this.$message({
                        message: '提成价格格式有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!this.beginTime || !this.endTime) {
                    this.$message({
                        message: '折扣时间有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if (this.beginTime == "aN:aN:aN" || this.endTime == "aN:aN:aN") {
                    this.$message({
                        message: '折扣时间有误',
                        customClass: 'error'
                    });
                    return true;
                }
            }

            if (!this.newGoods.productTypeId) {
                this.$message({
                    message: '请选择分类',
                    customClass: 'error'
                });
                return true;
            }
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newGoods.commission)) {
                this.$message({
                    message: '配品提成格式有误',
                    customClass: 'error'
                });
                return true;
            }
            if (this.newGoods.salesShowEnabled) {
                if (!/^\d*$/.test(this.newGoods.salesCount)) {
                    this.$message({
                        message: '基础数量输入有误',
                        customClass: 'error'
                    });
                    return true;
                }
                if (!/^\d*$/.test(this.newGoods.sort)) {
                    this.$message({
                        message: '排序输入错误',
                        customClass: 'error'
                    });
                    return true;
                }
            }
        },
        upGoods: function upGoods() {
            var _this10 = this;

            // console.log(this.newTimeListForComm);
            // console.log(new Date((this.newTimeListForComm[0].timeRange[0])).Format("hh:mm:00"))
            // return;

            if (this.checkFn()) {
                //正则验证
                return;
            }
            if (!this.addGoodApiBtn) {
                return;
            }
            this.addGoodApiBtn = false;
            var commTimeArr = [];
            if (this.newGoods.timeRangeComm) {
                for (var _i2 = 0; _i2 < this.newTimeListForComm.length; _i2++) {
                    if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newTimeListForComm[_i2].commission)) {
                        this.$message({
                            message: '配品提成格式有误',
                            customClass: 'error'
                        });
                        this.addGoodApiBtn = true;
                        return true;
                    }
                    if (!this.newTimeListForComm[_i2].timeRange || !this.newTimeListForComm[_i2].timeRange[0] || !this.newTimeListForComm[_i2].timeRange[1] || this.newTimeListForComm[_i2].timeRange.length == 0) {
                        this.$message({
                            message: '请选择时间',
                            customClass: 'error'
                        });
                        this.addGoodApiBtn = true;
                        return true;
                    }
                    var obj = {
                        commission: Number(this.newTimeListForComm[_i2].commission),
                        begin: new Date(this.newTimeListForComm[_i2].timeRange[0]).Format("hh:mm:00"),
                        end: new Date(this.newTimeListForComm[_i2].timeRange[1]).Format("hh:mm:59")
                    };
                    commTimeArr.push(obj);
                }
            }

            var flag = false;
            var newTimeListForComm = commTimeArr;
            if (newTimeListForComm.length > 1) {
                for (var _i3 = 1; _i3 < newTimeListForComm.length; _i3++) {

                    var tempArrMax = [new Date("2020/01/01 " + newTimeListForComm[0].begin).getTime(), new Date("2020/01/01 " + newTimeListForComm[_i3].begin).getTime()];
                    var tempArrMin = [new Date("2020/01/01 " + newTimeListForComm[0].end).getTime(), new Date("2020/01/01 " + newTimeListForComm[_i3].end).getTime()];

                    // let tempArrMax = [item.startTimeForFee,newTimeListForComm[i].startTimeForFee];
                    // let tempArrMin = [item.endTimeForFee,newTimeListForComm[i].endTimeForFee];
                    if (Math.max.apply(null, tempArrMax) <= Math.min.apply(null, tempArrMin)) {
                        flag = true;
                    }
                }
            }
            if (flag) {
                this.$message({
                    message: "时间不允许重叠，请重新选择",
                    customClass: 'error'
                });
                this.addGoodApiBtn = true;
                return;
            }

            var arr1 = this.newTimeList;
            var arr2 = this.timeList;
            var supplyTimes = [];
            if (arr1.length) {
                for (var i = 0; i < arr1.length; i++) {
                    for (var j = 0; j < arr2.length; j++) {
                        if (arr1[i].id == arr2[j].id) {
                            supplyTimes.push(arr2[j]);
                        }
                    }
                }
            }
            var ipName = "";
            var port = 0;
            var ipAddress = "";

            if (this.newGoods.ipId != 0 && this.newGoods.ipId) {
                for (var _i4 = 0; _i4 < this.printEr.length; _i4++) {
                    if (this.printEr[_i4].id == this.newGoods.ipId) {
                        ipName = this.printEr[_i4].name;
                        port = this.printEr[_i4].port;
                        ipAddress = this.printEr[_i4].ipAddress;
                    }
                }
            }
            var gname = String(this.newGoods.name.replace(/\s*/g, ""));
            var goods = {
                "id": this.btnId ? this.btnId : "",
                "storeId": this.curStoreId,
                "name": gname,
                "salesPrice": parseFloat(this.newGoods.salesPrice),
                "productTypeId": this.newGoods.productTypeId,
                "stockEnabled": this.isStock === 'OFF' ? false : true
            };
            this.$http.post('/match/product/edit', goods).then(function (res) {
                _this10.addGoodApiBtn = true;
                _this10.isAutoSearchBtn = true;
                if (!_this10.btnId) {
                    _this10.$message({
                        message: '添加配品成功',
                        customClass: 'success'
                    });
                    setTimeout(function () {
                        _this10.initDate();
                    }, 500);
                } else {
                    _this10.$message({
                        message: '修改配品成功',
                        customClass: 'success'
                    });
                    _this10.dialogVisible = false;
                }
                setTimeout(function () {
                    // this.getGoodsData();
                    if (_this10.fliter_type != '' || _this10.fliter_stock != '' || _this10.fliter_kitchen != '') {
                        _this10.fliterGoods();
                    } else {
                        _this10.getGoodsData();
                    }
                }, 1000);
                // 
                var params = [];
                if (_this10.seledMats && Array.isArray(_this10.seledMats) && _this10.seledMats.length) {
                    _this10.seledMats.forEach(function (it) {
                        var obj = {
                            id: it.formId ? it.formId : 0,
                            qty: it.count,
                            productMaterialId: it.productMaterialId,
                            productMaterialName: it.name
                        };
                        params.push(obj);
                    });
                }
                _this10.upOriGoods(res.data.id, params);
                // 
            }).catch(function () {
                _this10.addGoodApiBtn = true;
            });
        },
        upOriGoods: function upOriGoods(productId, params) {
            this.$http({
                url: "edit/material",
                method: "POST",
                data: {
                    productId: productId,
                    params: params
                }
            });
        },

        // 设置客户端是否允许购买和显示
        setForPc: function setForPc(productId, showEnabled, purchaseEnabled) {
            this.$http({
                url: "show-enabled",
                method: "POST",
                data: {
                    productId: productId,
                    showEnabled: showEnabled ? 1 : 0,
                    purchaseEnabled: purchaseEnabled ? 1 : 0
                }
            }).then(function (res) {
                console.log(res);
            });
        },
        disOrVip: function disOrVip(productId, memberPrice, disPrice, disCom, beginTime, endTime) {
            if (beginTime != "aN:aN:aN" && endTime != "aN:aN:aN" && this.discountEnable) {
                if (new Date("2020/01/01 " + endTime).getTime() <= new Date("2020/01/01 " + beginTime).getTime()) {
                    this.$message({
                        message: '折扣结束时间不能小于开始时间',
                        customClass: 'error'
                    });
                    return false;
                }
            }
            var data = {
                productId: productId,
                beginTime: beginTime == "aN:aN:aN" ? "" : beginTime,
                endTime: endTime == "aN:aN:aN" ? "" : endTime,
                disShow: this.discountEnable ? 1 : 0,
                disPrice: (disPrice / 100).toFixed(2),
                memberShow: this.vipEnable ? 1 : 0,
                memberPrice: memberPrice,
                disCom: disCom
            };
            this.$http({
                url: "update-slot",
                method: "POST",
                data: data
            }).then(function (res) {
                console.log(res);
            });
            return true;
        },

        coverImg: function coverImg(e) {
            var reader = new FileReader();
            var that = this;
            var fileObj = e.target.files[0];

            if (e.target.files.length == 0) {
                return false;
            }

            // 判断图片大小
            if (fileObj.size > this.coverImgMaxSize) {
                this.errorMsg = '上传图片的大小不能超过5MB';
                this.openErrorTip = true;
                this.$message({
                    message: '上传图片的大小不能超过5MB',
                    customClass: 'error'
                });
                return false;
            }

            reader.onload = function (file) {
                return function (e) {
                    var that2 = this; // 缓存当前this
                    var img = new Image();
                    img.src = this.result;
                    img.onload = function () {
                        var imgBase64 = that2.result; //获得图片的base64的数据


                        // 判断是否是移动端设备
                        var sUserAgent = navigator.userAgent.toLowerCase();
                        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
                        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                        var bIsAndroid = sUserAgent.match(/android/i) == "android";
                        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                            that.mobileUploadImg(imgBase64);
                        } else {
                            that.oldImgBase64 = imgBase64;
                            that.showCrop = true;
                        }
                    };
                    $('.pcImgFile').val('');
                    $('.mobileImgFile').val('');
                };
            }(e.target.files[0]);
            reader.readAsDataURL(e.target.files[0]);
        },
        // 移动端上传图片
        mobileUploadImg: function mobileUploadImg(imgBase64) {
            var _this11 = this;

            this.infoload = true;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_2__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/image/json/upload?storeId=' + this.curStoreId, { file: imgBase64 }).then(function (res) {
                _this11.newGoods.imageURL = res.data.path;
                _this11.infoload = false;
            }).catch(function () {
                _this11.infoload = false;
            });
        },
        // 获得裁剪后图片base64
        getCropImgBase: function getCropImgBase(imgUrl) {
            this.newGoods.imageURL = imgUrl;
        }
    },
    activated: function activated() {
        var _this12 = this;

        for (var i = 0; i < 6; i++) {
            this.vipData.push({});
        }

        //获取配品分类
        /*this.$http.get('/product-types-all?storeId='+this.curStoreId+'&parentId='+'').then((res)=>{
            this.typeList = this.typeList.concat(res.data);
           
            this.typeOptions.push({label: '全部',value: ''});
            for (var i = 0; i < res.data.length; i++) {
                let obj={
                    value:res.data[i].id,
                    label:res.data[i].name
                }
                if(res.data[i].productTypeVos.length){
                    let son = res.data[i].productTypeVos;
                    let arr = [
                        {value:res.data[i].id,label:res.data[i].name}
                    ];
                    for (var j = 0; j < son.length; j++) {
                         let sonobj={
                            value:son[j].id,
                            label:"- "+son[j].name
                        }
                        arr.push(sonobj)
                    }
                    obj.children = arr;
                }
                this.typeOptions.push(obj);
            }
        })*/
        this.$http.get('/product-types?storeId=' + this.curStoreId + '&parentId=' + '').then(function (res) {
            _this12.typeList = res.data.data;
            _this12.systemData = res.data.systemData;
        });
        if (this.fliter_type != '' || this.fliter_stock != '' || this.fliter_kitchen != '') {
            this.fliterGoods();
        } else {
            this.getGoodsData();
        }
        this.getTimesList();
        this.getPrintIpInfo();
    },
    mounted: function mounted() {
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            $('.el-message-box__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["pageSize", "curStoreId"],
  data: function data() {
    return {
      form: {
        id: 0,
        name: "",
        queue: ""
      },
      specs: [],
      defaultSpec: "",
      autoSpec: "",
      dialogVisible: false,
      addAddrBtn: false, //添加地址按钮
      listData: [], //地址列表
      addr: "", //收货地址
      name: "", //姓名
      phone: "",
      userName: "", //用户手机号
      id: ""
    };
  },


  methods: {
    modifySpec: function modifySpec(type, index) {
      var specs = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.specs));
      if (type == "add") {
        if (!String(this.autoSpec).trim()) {
          this.$message({
            message: "请输入规格名称",
            customClass: "error"
          });
          return;
        }
        specs.push(this.autoSpec);
        this.autoSpec = "";
      } else if (type == "del") {
        specs.splice(index, 1);
      }
      this.specs = specs;
    },

    //
    //删除地址
    delItem: function delItem(item) {
      var _this = this;

      this.$confirm("此操作将删除该分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.$http({
          url: "delete/lease/type",
          method: "POST",
          data: {
            id: item.id
          }
        }).then(function (res) {
          _this.getData();
        });
      }).catch(function () {});
    },

    //新建或更新地址
    addAddrFn: function addAddrFn(id) {
      var _this2 = this;

      if (!this.form.name) {
        this.$message({
          message: "请填写名称",
          customClass: "error"
        });
        return;
      }

      this.$http({
        url: "edit/lease/type",
        method: "POST",
        data: {
          id: this.form.id ? this.form.id : 0,
          name: this.form.name,
          queue: this.form.queue,
          sequence: this.form.queue,
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this2.getData();
        _this2.addAddrBtn = false;
        _this2.name = "";
        _this2.id = "";
        _this2.defaultSpec = "";
        _this2.specs = [];
        _this2.$message({
          message: "操作成功！",
          customClass: "success"
        });
      });
    },
    showUpBox: function showUpBox(item) {
      if (item) {
        this.form.id = item.id;
        this.form.name = item.name;
        this.form.queue = item.queue;
      } else {
        this.form.id = "";
        this.form.name = "";
        this.form.queue = 0;
      }
      this.addAddrBtn = true;
    },
    getData: function getData() {
      var _this3 = this;

      this.$http({
        url: "lease/type/list",
        method: "POST",
        data: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this3.listData = res.data;
        if (_this3.listData.length < _this3.pageSize) {
          for (var i = 0, len = _this3.pageSize - _this3.listData.length; i < len; i++) {
            _this3.listData.push({});
          }
        }
      });
    }
  },
  created: function created() {
    this.userName = localStorage.getItem("username");
    for (var i = 0; i < this.pageSize; i++) {
      this.listData.push({});
    }
  },
  activated: function activated() {
    this.getData();
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_imgCrop_imgCrop_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_imgCrop_imgCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_imgCrop_imgCrop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__urlConfig_index__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["pageSize", "curStoreId"],
  components: { imgCrop: __WEBPACK_IMPORTED_MODULE_3__components_imgCrop_imgCrop_vue___default.a },
  data: function data() {
    return {
      regionData: [],
      showRule: true,
      typeList: [],
      form: {
        id: 0,
        name: "",
        image: "",
        queue: 0,
        productTypeId: "",
        productTypeName: "",
        totalCount: "",
        amount: "",
        enabled: true,
        showPcEnabled: true,
        buyEnabled: true,
        extras: []
      },
      specs: [],
      defaultSpec: "",
      autoSpec: "",
      dialogVisible: false,
      addAddrBtn: false, //添加地址按钮
      listData: [], //地址列表
      addr: "", //收货地址
      name: "", //姓名
      phone: "",
      userName: "", //用户手机号
      id: "",
      coverImgMaxSize: 20 * 1024 * 1024, // 图片最大字节数
      oldImgBase64: "", // 原图base64
      showCrop: false, // 控制图片裁剪显示隐藏
      curCropW: 600, // 裁剪宽度
      curCropH: 600, // 裁剪高度
      infoload: false, // loading
      ruleList: []
    };
  },


  methods: {
    getRegion: function getRegion() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$http({
          url: "region/list",
          method: "POST",
          data: {
            storeId: _this.$route.params.id
          }
        }).then(function (res) {
          _this.regionData = res.data;
          resolve();
        });
      }).catch(function (err) {
        reject();
      });
    },

    //
    changeItemRule: function changeItemRule(e, item) {
      console.log("e", e);
      this.ruleList.forEach(function (it) {
        if (it.id == e) {
          item.ruleName = it.name;
        }
      });
      console.log("item", item);
      this.$forceUpdate();
    },
    modifyExtra: function modifyExtra(type, index) {
      var extras = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.form.extras));
      if (type == "add") {
        var obj = {
          ruleName: "",
          ruleId: "",
          amount: "",
          options: [],
          defaultPcRule: false
        };
        if (extras && Array.isArray(extras)) {
          extras.push(obj);
        } else {
          extras = [obj];
        }
      } else {
        extras.splice(index, 1);
      }
      this.$set(this.form, "extras", extras);
    },

    // 删除修改商品时的图片
    delImg: function delImg() {
      this.$refs.goodsImg.src = "https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png";
      this.form.image = "https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png";
    },

    coverImg: function coverImg(e) {
      var reader = new FileReader();
      var that = this;
      var fileObj = e.target.files[0];

      if (e.target.files.length == 0) {
        return false;
      }

      // 判断图片大小
      if (fileObj.size > this.coverImgMaxSize) {
        this.errorMsg = "上传图片的大小不能超过20MB";
        this.openErrorTip = true;
        this.$message({
          message: "上传图片的大小不能超过20MB",
          customClass: "error"
        });
        return false;
      }

      reader.onload = function (file) {
        return function (e) {
          var that2 = this; // 缓存当前this
          var img = new Image();
          img.src = this.result;
          img.onload = function () {
            var imgBase64 = that2.result; //获得图片的base64的数据

            // 判断是否是移动端设备
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
              that.mobileUploadImg(imgBase64);
            } else {
              that.oldImgBase64 = imgBase64;
              that.showCrop = true;
            }
          };
          $(".pcImgFile").val("");
          $(".mobileImgFile").val("");
        };
      }(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    // 移动端上传图片
    mobileUploadImg: function mobileUploadImg(imgBase64) {
      var _this2 = this;

      this.infoload = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__urlConfig_index__["b" /* API_BASE_URL */] + "v1/image/json/upload?storeId=" + this.curStoreId, { file: imgBase64 }).then(function (res) {
        _this2.newGoods.imageURL = res.data.path;
        _this2.infoload = false;
      }).catch(function () {
        _this2.infoload = false;
      });
    },
    // 获得裁剪后图片base64
    getCropImgBase: function getCropImgBase(imgUrl) {
      this.form.image = imgUrl;
    },
    modifySpec: function modifySpec(type, index) {
      var specs = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.specs));
      if (type == "add") {
        if (!String(this.autoSpec).trim()) {
          this.$message({
            message: "请输入规格名称",
            customClass: "error"
          });
          return;
        }
        specs.push(this.autoSpec);
        this.autoSpec = "";
      } else if (type == "del") {
        specs.splice(index, 1);
      }
      this.specs = specs;
    },

    //
    //删除地址
    delItem: function delItem(item) {
      var _this3 = this;

      this.$confirm("此操作将删除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this3.$http({
          url: "delete/lease",
          method: "POST",
          data: {
            id: item.id
          }
        }).then(function (res) {
          _this3.getData();
        });
      }).catch(function () {});
    },

    //新建或更新地址
    addFn: function addFn(id) {
      var _this4 = this;

      if (!this.form.name) {
        this.$message({
          message: "请填写名称",
          customClass: "error"
        });
        return;
      }
      if (!this.form.productTypeId) {
        this.$message({
          message: "请选择分类",
          customClass: "error"
        });
        return;
      }
      // if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.form.amount)) {
      //   this.$message({
      //     message: "金额格式有误",
      //     customClass: "error",
      //   });
      //   return;
      // }
      if (!/^[1-9][0-9]*$/.test(this.form.totalCount)) {
        this.$message({
          message: "数量输入有误",
          customClass: "error"
        });
        return true;
      }
      if (!this.form.image) {
        this.$message({
          message: "请上传商品图片",
          customClass: "error"
        });
        return;
      }
      //
      if (!this.form.extras || !Array.isArray(this.form.extras) || !this.form.extras.length) {
        this.$message({
          message: "请添加商品押金",
          customClass: "error"
        });
        return;
      } else {
        var flag = false;
        var hasDefaultPcRule = 0;
        for (var i = 0; i < this.form.extras.length; i++) {
          if (!this.form.extras[i].ruleId) {
            this.$message({
              message: "请选择押金规则",
              customClass: "error"
            });
            flag = true;
            break;
          }
          if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.form.extras[i].amount)) {
            this.$message({
              message: "押金金额格式有误",
              customClass: "error"
            });
            flag = true;
            break;
          }
          if (this.form.extras[i].defaultPcRule) {
            hasDefaultPcRule++;
          }
        }
        if (flag) {
          return;
        }
        if (!hasDefaultPcRule || hasDefaultPcRule > 1) {
          this.$message({
            message: "默认规则必须选择一项",
            customClass: "error"
          });
          return;
        }
      }
      //
      var productTypeName = void 0;
      if (this.form.productTypeId) {
        this.typeList.forEach(function (it) {
          if (it.id == _this4.form.productTypeId) {
            productTypeName = it.name;
          }
        });
      }
      // 
      if (this.form.extras && Array.isArray(this.form.extras) && this.form.extras.length) {
        this.form.extras.forEach(function (it) {
          // 
          if (Array.isArray(it.options) && it.options.length) {
            var tempArr = [];
            it.options.forEach(function (ite) {
              _this4.regionData.forEach(function (regionItem) {
                if (regionItem.id == ite) {
                  tempArr.push({
                    regionId: ite,
                    regionName: regionItem.name
                  });
                }
              });
            });
            it.options = tempArr;
          }
          // 
        });
      }
      // 
      this.$http({
        url: "edit/lease",
        method: "POST",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.form, {
          productTypeName: productTypeName,
          id: this.form.id ? this.form.id : 0,
          storeId: this.curStoreId
        })
      }).then(function (res) {
        _this4.getData();
        _this4.addAddrBtn = false;
        _this4.name = "";
        _this4.id = "";
        _this4.defaultSpec = "";
        _this4.specs = [];
        _this4.$message({
          message: "操作成功！",
          customClass: "success"
        });
      });
    },
    showUpBox: function showUpBox(item) {
      var _this5 = this;

      if (item) {
        if (!item.extras || !Array.isArray(item.extras)) {
          item.extras = [];
        } else {
          // try {
          //   for (let i = 0; i < item.extras.length; i++) {
          //     console.log("extras", item.extras[i]);
          //     item.extras[i] = JSON.parse(item.extras[i]);
          //     if (item.extras[i]) {
          //       item.extras[i].ruleId = Number(item.extras[i].ruleId);
          //     }
          //   }
          // } catch (error) {
          //   console.log("error", error);
          // }
        }
        this.form = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
        this.showRule = false;
        setTimeout(function () {
          _this5.showRule = true;
        }, 250);
        console.log("this.form", this.form);
      } else {
        this.form = {
          id: 0,
          name: "",
          image: "",
          queue: 0,
          productTypeId: "",
          productTypeName: "",
          totalCount: "",
          amount: "",
          enabled: true,
          showPcEnabled: true,
          buyEnabled: true,
          extras: []
        };
      }
      this.addAddrBtn = true;
    },
    getData: function getData() {
      var _this6 = this;

      this.$http({
        url: "lease/product/list",
        method: "POST",
        data: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        try {
          if (res.data && Array.isArray(res.data) && res.data.length) {
            res.data.forEach(function (it) {
              if (it.extras && Array.isArray(it.extras) && it.extras.length) {
                it.extras.forEach(function (ite, ind) {
                  if (String(ite.options) == "null" || !ite.options) {
                    ite.options = [];
                  }
                  if (Array.isArray(ite.options) && ite.options.length) {
                    var tempArr = [];
                    ite.options.forEach(function (item) {
                      tempArr.push(item.regionId);
                    });
                    ite.options = tempArr;
                  }
                  if (typeof ite == "string") {
                    it.extras[ind] = JSON.parse(ite);
                  }
                });
              }
            });
          }
        } catch (error) {
          console.log("error", error);
        }
        console.log(res.data);
        _this6.listData = res.data;
        if (_this6.listData.length < _this6.pageSize) {
          for (var i = 0, len = _this6.pageSize - _this6.listData.length; i < len; i++) {
            _this6.listData.push({});
          }
        }
      });
    },
    getCates: function getCates() {
      var _this7 = this;

      this.$http({
        url: "lease/type/list",
        method: "POST",
        data: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this7.typeList = res.data;
      });
    },
    getRules: function getRules() {
      var _this8 = this;

      this.$http({
        url: "rule-list",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this8.ruleList = res.data;
      });
    }
  },
  created: function created() {
    this.userName = localStorage.getItem("username");
    for (var i = 0; i < this.pageSize; i++) {
      this.listData.push({});
    }
  },
  activated: function activated() {
    this.getCates();
    this.getRules();
    this.getData();
    this.getRegion();
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            nowSelGoods: null,
            goodSearchBtn: true,
            curGoodIdx: 0, // 当前商品索引
            goodCheckArr: [],
            goods: "",
            // 
            stockArr: [],
            showStock: false,
            nowTypeName: '', //当前所选择的分类的名字
            nowItem: [
                // {
                //     amount: 0,
                //     name: "",
                //     qty: 0,
                //     seTypeName: "",
                //     typeName: ""
                // }
            ], //用户点击交班的分类的时候，所点击的分类下的商品
            showPutAllMask: false, //交班明细控制按钮
            showPutAllMask1: false, //销售明细控制按钮
            showPutAllMask2: false, //员工销售明细控制按钮
            workData: [],
            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0, //总共条

            getBtn: true, // 控制翻页请求

            inventoryList: [], //交班明细
            workDetailId: '', //某班id

            salesData: { cost: '', net: { qty: 0, amount: 0 }, itemDetails: [{ amount: 0, name: "", qty: 0, seTypeName: "", typeName: "" }] }, //销售明细
            salesCurPage: 0, //销售明细的当前页码

            staffArr: [], //员工销售明细
            curWorkData: {
                "cashAmount": '',
                "alipayAmount": '',
                "wechatAmount": '',
                "alipayCashAmount": '',
                "wechatCashAmount": '',
                "memberAmount": '',
                "couponAmount": ''
            } // 当前查看班次的数据

        };
    },

    watch: {
        goods: function goods(val) {
            if (val) {
                this.searchGoods(val, null);
            } else {
                this.goodCheckArr = [];
                this.nowSelGoods = null;
                this.curPage = 0;
                this.getAllData();
            }
        }
    },
    methods: {
        selSearchGood: function selSearchGood(item) {
            this.nowSelGoods = item;
            this.goodCheckArr = [];
            this.curPage = 0;
            this.getWordData();
        },
        getRentProducts: function getRentProducts() {
            // this.$http({
            //     url: "lease/product/list",
            //     method: "POST",
            //     data: {
            //     storeId: this.curStoreId,
            //     },
            // }).then((res) => {
            //     this.goodCheckArr = res.data;
            // })
        },

        // 商品检索
        searchGoods: function searchGoods(val, id) {
            var _this = this;

            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http({
                url: "lease/product/list",
                method: "POST",
                data: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                var tempData = [];
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        if (it.name.indexOf(val) != -1) {
                            tempData.push(it);
                        }
                    });
                }
                if (id) {
                    _this.addGoodCheckArr = tempData;
                    _this.isAutoSearchBtn = false;
                    setTimeout(function () {
                        _this.isAutoSearchBtn = true;
                    }, 2000);
                    setTimeout(function () {
                        var that = _this;
                        $('.add_details_search li').hover(function () {
                            that.addCurGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.addCurGoodIdx = 0;
                        });
                    }, 0);
                } else {
                    _this.goodCheckArr = tempData;
                    setTimeout(function () {
                        var that = _this;
                        $('.details_search li').hover(function () {
                            that.curGoodIdx = $(this).index() - 1;
                        }, function () {
                            that.curGoodIdx = 0;
                        });
                    }, 0);
                }
                _this.goodSearchBtn = true;
            }).catch(function () {
                _this.goodSearchBtn = true;
            });
            // this.$http.get('lease/product/list?storeId='+(id?id:this.curStoreId)+'&stockEnabled=false'+'&q='+encodeURI(val)).then((res)=>{
            //     if(id){
            //         this.addGoodCheckArr = res.data;
            //         this.isAutoSearchBtn = false;
            //         setTimeout(()=>{
            //             this.isAutoSearchBtn = true;
            //         },2000)
            //         setTimeout(()=>{
            //             let that = this;
            //             $('.add_details_search li').hover( function () {
            //                 that.addCurGoodIdx = $(this).index()-1;
            //             }, function () {
            //                 that.addCurGoodIdx = 0;
            //             })
            //         },0)
            //     }else {
            //         this.goodCheckArr = res.data;
            //         setTimeout(()=>{
            //             let that = this;
            //             $('.details_search li').hover( function () {
            //                 that.curGoodIdx = $(this).index()-1;
            //             }, function () {
            //                 that.curGoodIdx = 0;
            //             })
            //         },0)
            //     }
            //     this.goodSearchBtn = true;
            // }).catch(()=>{
            //     this.goodSearchBtn = true;
            // })
        },

        // 
        cutStockDetail: function cutStockDetail(item) {
            var _this2 = this;

            this.$http({
                url: "workStock/list",
                method: "GET",
                params: {
                    id: item.id
                }
            }).then(function (res) {
                console.log(res);
                _this2.showStock = true;
                _this2.stockArr = res.data;
            });
        },

        //关闭销售明细时的回调，用于清空当前销售明细的数据
        closeSaleDetail: function closeSaleDetail() {
            this.salesData = { cost: '', net: { qty: 0, amount: 0 }, itemDetails: [{ amount: 0, name: "", qty: 0, seTypeName: "", typeName: "" }] };
            this.nowTypeName = "";
        },

        //获取当前分类下的商品销售情况
        getNowTypeProducts: function getNowTypeProducts(name) {
            var _this3 = this;

            this.nowItem = [];
            console.log(name);
            if (this.nowTypeName === name || name === "") {
                this.nowTypeName = '';
                return;
            }
            this.nowTypeName = name;
            this.$http({
                url: "get-itemDetails",
                method: "GET",
                params: {
                    id: this.curWorkData.id,
                    storeId: this.curStoreId,
                    typeName: name
                }
            }).then(function (res) {
                _this3.nowItem = res.data;
                console.log(res);
            });
        },

        //列表翻页
        changePage: function changePage(boo) {
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            if (this.nowSelGoods) {
                this.getWordData();
            } else {
                this.getAllData();
            }
        },
        getAllData: function getAllData() {
            var _this4 = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.$http.get('/lease/transaction/list?storeId=' + this.curStoreId + '&page=' + this.curPage + '&size=' + this.pageSize).then(function (res) {
                _this4.workData = res.data.content;
                _this4.totalPage = res.data.totalPages;
                _this4.totalElements = res.data.totalElements;
                if (_this4.workData.length < _this4.pageSize) {
                    for (var i = 0, len = _this4.pageSize - _this4.workData.length; i < len; i++) {
                        _this4.workData.push({});
                    }
                }
                // for(let i = 0,len=this.workData.length;i<len;i++){
                //     if(this.workData[i].id){
                //         this.workData[i].turnInAmount = this.workData[i].turnInAmount.toFixed(2);
                //         this.workData[i].cashAmount = this.workData[i].cashAmount.toFixed(2);
                //         this.workData[i].wechatAmount = this.workData[i].wechatAmount.toFixed(2);
                //         this.workData[i].alipayAmount = this.workData[i].alipayAmount.toFixed(2);
                //         this.workData[i].memberAmount = this.workData[i].memberAmount.toFixed(2);
                //         this.workData[i].wechatCashAmount = this.workData[i].wechatCashAmount.toFixed(2);
                //         this.workData[i].alipayCashAmount = this.workData[i].alipayCashAmount.toFixed(2);
                //     }
                // }
                _this4.getBtn = true;
            }).catch(function () {
                _this4.getBtn = true;
            });
        },
        getWordData: function getWordData() {
            var _this5 = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.$http.get('/product/transaction?productId=' + this.nowSelGoods.id + '&page=' + this.curPage + '&size=' + this.pageSize).then(function (res) {
                _this5.workData = res.data.content;
                _this5.totalPage = res.data.totalPages;
                _this5.totalElements = res.data.totalElements;
                if (_this5.workData.length < _this5.pageSize) {
                    for (var i = 0, len = _this5.pageSize - _this5.workData.length; i < len; i++) {
                        _this5.workData.push({});
                    }
                }
                // for(let i = 0,len=this.workData.length;i<len;i++){
                //     if(this.workData[i].id){
                //         this.workData[i].turnInAmount = this.workData[i].turnInAmount.toFixed(2);
                //         this.workData[i].cashAmount = this.workData[i].cashAmount.toFixed(2);
                //         this.workData[i].wechatAmount = this.workData[i].wechatAmount.toFixed(2);
                //         this.workData[i].alipayAmount = this.workData[i].alipayAmount.toFixed(2);
                //         this.workData[i].memberAmount = this.workData[i].memberAmount.toFixed(2);
                //         this.workData[i].wechatCashAmount = this.workData[i].wechatCashAmount.toFixed(2);
                //         this.workData[i].alipayCashAmount = this.workData[i].alipayCashAmount.toFixed(2);
                //     }
                // }
                _this5.getBtn = true;
            }).catch(function () {
                _this5.getBtn = true;
            });
        },

        //销售明细
        cutSalesDetail: function cutSalesDetail(item) {
            var _this6 = this;

            this.curWorkData = item;
            this.$http.get('workshift/' + item.id + '/details').then(function (res) {
                _this6.salesData = res.data;
                _this6.showPutAllMask1 = true;
            });
        },

        //员工业绩
        getStaff: function getStaff(item) {
            var _this7 = this;

            this.$http.get('workshift/' + item.id + '/staff').then(function (res) {
                _this7.staffArr = res.data;
                _this7.showPutAllMask2 = true;
                for (var i = 0, len = _this7.staffArr.length; i < len; i++) {
                    _this7.staffArr[i].totalAmount = _this7.staffArr[i].totalAmount.toFixed(2);
                }
            });
        },

        // 销售导出excel
        sales2Excel: function sales2Excel() {
            var _this8 = this;

            this.$http.get('get-excel?id=' + this.curWorkData.id).then(function (res) {
                var types = res.data.types;
                var coupons = res.data.coupons;

                var domstr = '<table style="border-collapse: collapse;">';
                domstr += '<tr>\n                                <th style="font-size:18px">\u5546\u54C1\u540D\u79F0</th>\n                                <th style="font-size:18px">\u552E\u4EF7</th>\n                                <th style="font-size:18px">\u6570\u91CF</th>\n                                <th style="font-size:18px">\u603B\u8BA1</th>\n                            </tr>';
                for (var i = 0, len = types.length; i < len; i++) {
                    domstr += '<tr>\n                                <td colspan="3" style="text-align:center;font-size:16px">---' + types[i].typeName + '---</td>\n                                <td style="font-size:16px;color:red">\uFFE5' + types[i].amount / 100 + '</td>\n                            </tr>';
                    for (var j = 0, len2 = types[i].products.length; j < len2; j++) {
                        domstr += '<tr>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].productName + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].amount / (types[i].products[j].quantity * 100) + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].quantity + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].amount / 100 + '</td>\n                                </tr>';
                    }
                }

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="7" style="font-size:18px;font-weight:900;text-align:center">\u603B\u9500\u552E\u989D</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:18px;">\u73B0\u91D1</td>\n                                <td style="font-size:18px;">\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u4F1A\u5458\u652F\u4ED8</td>\n                                <td style="font-size:18px;">\u4F18\u60E0\u5238\u62B5\u6263</td>\n                            </tr>\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.alipayAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.wechatAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.alipayCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.wechatCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.memberAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.couponAmount / 100 + '</td>\n                            </tr>\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td style="border:1px solid #ccc;font-weight:900;font-size:18px">\u603B\u9500\u552E\u989D\uFF1A</td>\n                                <td style="border:1px solid #ccc;font-size:20px;color:red;font-weight:600">' + _this8.curWorkData.turnInAmount + '</td>\n                            </tr>';

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="7" style="font-size:18px;font-weight:900;text-align:center">\u7F51\u8D39\u9500\u552E\u989D</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:18px;">\u73B0\u91D1</td>\n                                <td style="font-size:18px;">\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u4F1A\u5458\u652F\u4ED8</td>\n                                <td style="font-size:18px;">\u4F18\u60E0\u5238\u62B5\u6263</td>\n                            </tr>\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.cashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.alipayAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.wechatAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.alipayCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.wechatCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.memberAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this8.salesData.cost.couponAmount / 100 + '</td>\n                            </tr>\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td style="border:1px solid #ccc;font-weight:900;font-size:18px">\u603B\u9500\u552E\u989D\uFF1A</td>\n                                <td style="border:1px solid #ccc;font-size:20px;color:red;font-weight:600">' + _this8.salesData.cost.turnInAmount / 100 + '</td>\n                            </tr>';

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="3" style="text-align:center;font-size:18px;font-weight:900">\u4F18\u60E0\u5238\u6838\u9500\u8BB0\u5F55</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:16px;font-weight:700;">\u4F18\u60E0\u5238\u540D\u79F0</td>\n                                <td style="font-size:16px;font-weight:700;">\u6570\u91CF</td>\n                                <td style="font-size:16px;font-weight:700;">\u603B\u91D1\u989D</td>\n                            </tr>';
                for (var i = 0, len = coupons.length; i < len; i++) {
                    domstr += '\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].productName + '</td>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].quantity + '</td>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].amount / 100 + '</td>\n                            </tr>';
                }
                domstr += '</table>';

                window.method5($(domstr)[0]);
            });
        },
        // 员工导出excel
        staff2Excel: function staff2Excel() {
            if (!this.staffArr[0]) {
                this.$message({
                    message: '无数据可导出',
                    customClass: 'error'
                });
                return;
            }

            var data = this.staffArr;
            var domstr = '<table style="border-collapse: collapse;">';
            domstr += '<tr>\n                            <th style="font-size:16px">\u5458\u5DE5\u540D\u79F0</th>\n                            <th style="font-size:16px">\u8BA2\u5355\u6570\u91CF</th>\n                            <th style="font-size:16px">\u9500\u552E\u91D1\u989D</th>\n                        </tr>';
            for (var i = 0, len = data.length; i < len; i++) {
                domstr += '<tr>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].creatorName + '</td>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].orderCount + '</td>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].totalAmount + '</td>\n                        </tr>';
            }

            domstr += '</table>';

            window.method5($(domstr)[0]);
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.workData.push({});
        }
    },
    activated: function activated() {
        this.getAllData();
        this.getRentProducts();
        // console.log(this.$route)
    }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    data: function data() {
        return {
            pageSize: 20,
            clickBtn: true,
            totalInfo: {
                totalAmount: 0,
                getAmount: 0,
                refundAmount: 0
            },
            startTime: "",
            endTime: "",
            form: {
                mobile: "",
                beginTime: "",
                endTime: ""
            },
            canClick: true,
            pickerOptionsForTimeRange: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now() || time.getTime() < new Date('2017,01,01').getTime();
                }
            },
            judge: "ALL",
            tableList: [], //员工列表
            searchByWhichType: "dayOrMonth", //按照时间段或者是按月份。按日的形式查询，dayOrMonth,timeRange，时间段暂时没有
            valueForMonth: '', //月份信息
            allAmount: 0, //总金额
            allQtyForMonth: 0, //按月份总数量
            allAmountForMonth: 0,
            allQty: 0, //总数量
            nowDay: '', //当前日期
            nowType: "day", //当前查询方式，如日报，按月份
            rewardDataForMonth: [],
            getBtn: true, // 控制翻页请求
            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },

            pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },

            timeFrom: '', //开始时间
            timeTo: '', //截止时间
            searchList: [], // 搜索结果数组
            goodSearchBtn: true, // 控制搜索框
            canSearch: true, //
            options: [],
            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0 //总共条
        };
    },

    methods: {
        spanTime: function spanTime(start, end) {
            if (start && end) {
                var spanTime = new Date(end).getTime() - new Date(start).getTime();
                var hour = 60 * 1000 * 60;
                var min = 60 * 1000;
                var sec = 1000;
                var hours = Math.floor(spanTime / hour);
                var mins = Math.ceil(spanTime % hour / min);
                if (hours < 0) {
                    return '0\u5C0F\u65F60\u5206';
                }
                return hours + '\u5C0F\u65F6' + mins + '\u5206';
            } else {
                var _spanTime = new Date().getTime() - new Date(start).getTime();
                var _hour = 60 * 1000 * 60;
                var _min = 60 * 1000;
                var _sec = 1000;
                var _hours = Math.floor(_spanTime / _hour);
                var _mins = Math.ceil(_spanTime % _hour / _min);
                if (_hours < 0) {
                    return '0\u5C0F\u65F60\u5206';
                }
                return _hours + '\u5C0F\u65F6' + _mins + '\u5206';
            }
        },

        // 搜索
        searchConfirm: function searchConfirm() {
            if (this.form.mobile) {
                if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.form.mobile)) {
                    this.$message({
                        message: "请输入正确的手机号",
                        customClass: "error"
                    });
                    return;
                }
            }
            if (this.form.beginTime && this.form.endTime) {
                if (new Date(this.form.endTime).getTime() < new Date(this.form.beginTime).getTime()) {
                    this.$message({
                        message: "结束时间必须大于开始时间",
                        customClass: "error"
                    });
                    return;
                }
            }
            if (!this.form.beginTime && this.form.endTime || this.form.beginTime && !this.form.endTime) {
                this.$message({
                    message: "请完整选择开始时间和结束时间",
                    customClass: "error"
                });
                return;
            }
            this.getData();
        },
        getRewardData: function getRewardData(date, source, judge) {
            var _this = this;

            var params = void 0;
            if (this.searchByWhichType === "dayOrMonth") {
                if (source == "DAY") {
                    params = {
                        storeId: this.curStoreId,
                        from: date,
                        type: "STORE",
                        source: source,
                        judge: judge
                        // 
                    };var timeStr = new Date(date).getTime() + "-" + judge + "-" + new Date(date).getTime();
                    var nowTime = new Date().getTime();
                    if (!this.$canClickSelect("rewardInfoDay", timeStr, nowTime)) {
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    //
                } else {
                    params = {
                        storeId: this.curStoreId,
                        year: date.year,
                        month: date.month,
                        type: "STORE",
                        source: source,
                        judge: judge
                        // 
                    };var _timeStr = new Date(date.year + "-" + date.month + "-01").getTime() + "-" + judge + "-" + new Date(date.year + "-" + date.month + "-01").getTime();
                    var _nowTime = new Date().getTime();
                    if (!this.$canClickSelect("rewardInfoMonth", _timeStr, _nowTime)) {
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    //
                }
            }
            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + "v1/clerk/get-reward",
                method: "GET",
                params: params
            }).then(function (res) {
                console.log(res);
                if (_this.searchByWhichType === "dayOrMonth") {
                    if (source == "DAY") {
                        _this.tableList = res.data.rews;
                        _this.allAmount = res.data.total;
                        _this.allQty = res.data.count;
                    } else {
                        _this.rewardDataForMonth = res.data.rews;
                        _this.allAmountForMonth = res.data.total;
                        _this.allQtyForMonth = res.data.count;
                    }
                }
            });
        },

        changePage: function changePage(boo) {
            var _this2 = this;

            if (!this.clickBtn) {
                return;
            }
            this.clickBtn = false;
            this.curCheckArr = [];
            this.allCheckArr = false;
            setTimeout(function () {
                _this2.clickBtn = true;
            }, 800);
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            this.getData();
        },
        // 获取员工列表
        getData: function getData() {
            var _this3 = this;

            if (!this.canClick) {
                return;
            }
            this.canClick = false;
            this.$http({
                url: "sum/lease",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    // mobile:this.form.mobile,
                    // size:this.pageSize,
                    // page:this.curPage,
                    begin: this.form.beginTime ? new Date(this.form.beginTime).Format("yyyy-MM-dd hh:mm:ss") : undefined,
                    end: this.form.endTime ? new Date(this.form.endTime).Format("yyyy-MM-dd hh:mm:ss") : undefined
                }
            }).then(function (res) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
                _this3.tableList = res.data;
                if (res.data && res.data.hasOwnProperty("result") && res.data.result) {
                    _this3.totalInfo = res.data.result;
                }
                // this.totalElements = res.data.totalElements;
                // this.totalPage = res.data.totalPages;
            }).catch(function (err) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
            });
        }
    },
    activated: function activated() {
        this.nowDay = new Date();
        this.valueForMonth = new Date();
        this.form.beginTime = new Date().Format("yyyy-MM-dd 00:00:00");
        this.form.endTime = new Date().Format("yyyy-MM-dd 23:59:59");
        this.$forceUpdate();
        this.getData();
    }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    data: function data() {
        return {
            pageSize: 20,
            clickBtn: true,
            totalInfo: {
                totalAmount: 0,
                getAmount: 0,
                refundAmount: 0
            },
            form: {
                mobile: "",
                beginTime: "",
                endTime: ""
            },
            canClick: true,
            pickerOptionsForTimeRange: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now() || time.getTime() < new Date('2017,01,01').getTime();
                }
            },
            judge: "ALL",
            tableList: [], //员工列表
            searchByWhichType: "dayOrMonth", //按照时间段或者是按月份。按日的形式查询，dayOrMonth,timeRange，时间段暂时没有
            valueForMonth: '', //月份信息
            allAmount: 0, //总金额
            allQtyForMonth: 0, //按月份总数量
            allAmountForMonth: 0,
            allQty: 0, //总数量
            nowDay: '', //当前日期
            nowType: "day", //当前查询方式，如日报，按月份
            rewardDataForMonth: [],
            getBtn: true, // 控制翻页请求
            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },

            pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },

            timeFrom: '', //开始时间
            timeTo: '', //截止时间
            searchList: [], // 搜索结果数组
            goodSearchBtn: true, // 控制搜索框
            canSearch: true, //
            options: [],
            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0 //总共条
        };
    },

    methods: {
        spanTime: function spanTime(start, end) {
            if (start && end) {
                var spanTime = new Date(end).getTime() - new Date(start).getTime();
                var hour = 60 * 1000 * 60;
                var min = 60 * 1000;
                var sec = 1000;
                var hours = Math.floor(spanTime / hour);
                var mins = Math.ceil(spanTime % hour / min);
                if (hours < 0) {
                    return '0\u5C0F\u65F60\u5206';
                }
                return hours + '\u5C0F\u65F6' + mins + '\u5206';
            } else {
                var _spanTime = new Date().getTime() - new Date(start).getTime();
                var _hour = 60 * 1000 * 60;
                var _min = 60 * 1000;
                var _sec = 1000;
                var _hours = Math.floor(_spanTime / _hour);
                var _mins = Math.ceil(_spanTime % _hour / _min);
                if (_hours < 0) {
                    return '0\u5C0F\u65F60\u5206';
                }
                return _hours + '\u5C0F\u65F6' + _mins + '\u5206';
            }
        },

        // 搜索
        searchConfirm: function searchConfirm() {
            if (this.form.mobile) {
                if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.form.mobile)) {
                    this.$message({
                        message: "请输入正确的手机号",
                        customClass: "error"
                    });
                    return;
                }
            }
            if (this.form.beginTime && this.form.endTime) {
                if (new Date(this.form.endTime).getTime() < new Date(this.form.beginTime).getTime()) {
                    this.$message({
                        message: "结束时间必须大于开始时间",
                        customClass: "error"
                    });
                    return;
                }
            }
            if (!this.form.beginTime && this.form.endTime || this.form.beginTime && !this.form.endTime) {
                this.$message({
                    message: "请完整选择开始时间和结束时间",
                    customClass: "error"
                });
                return;
            }
            this.getData();
        },
        getRewardData: function getRewardData(date, source, judge) {
            var _this = this;

            var params = void 0;
            if (this.searchByWhichType === "dayOrMonth") {
                if (source == "DAY") {
                    params = {
                        storeId: this.curStoreId,
                        from: date,
                        type: "STORE",
                        source: source,
                        judge: judge
                        // 
                    };var timeStr = new Date(date).getTime() + "-" + judge + "-" + new Date(date).getTime();
                    var nowTime = new Date().getTime();
                    if (!this.$canClickSelect("rewardInfoDay", timeStr, nowTime)) {
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    //
                } else {
                    params = {
                        storeId: this.curStoreId,
                        year: date.year,
                        month: date.month,
                        type: "STORE",
                        source: source,
                        judge: judge
                        // 
                    };var _timeStr = new Date(date.year + "-" + date.month + "-01").getTime() + "-" + judge + "-" + new Date(date.year + "-" + date.month + "-01").getTime();
                    var _nowTime = new Date().getTime();
                    if (!this.$canClickSelect("rewardInfoMonth", _timeStr, _nowTime)) {
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    //
                }
            }
            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + "v1/clerk/get-reward",
                method: "GET",
                params: params
            }).then(function (res) {
                console.log(res);
                if (_this.searchByWhichType === "dayOrMonth") {
                    if (source == "DAY") {
                        _this.tableList = res.data.rews;
                        _this.allAmount = res.data.total;
                        _this.allQty = res.data.count;
                    } else {
                        _this.rewardDataForMonth = res.data.rews;
                        _this.allAmountForMonth = res.data.total;
                        _this.allQtyForMonth = res.data.count;
                    }
                }
            });
        },

        changePage: function changePage(boo) {
            var _this2 = this;

            if (!this.clickBtn) {
                return;
            }
            this.clickBtn = false;
            this.curCheckArr = [];
            this.allCheckArr = false;
            setTimeout(function () {
                _this2.clickBtn = true;
            }, 800);
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            this.getData();
        },
        // 获取员工列表
        getData: function getData() {
            var _this3 = this;

            if (!this.canClick) {
                return;
            }
            this.canClick = false;
            this.$http({
                url: "lease/order/list",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    mobile: this.form.mobile,
                    size: this.pageSize,
                    page: this.curPage,
                    beginTime: this.form.beginTime ? new Date(this.form.beginTime).Format("yyyy-MM-dd hh:mm:ss") : undefined,
                    endTime: this.form.endTime ? new Date(this.form.endTime).Format("yyyy-MM-dd hh:mm:ss") : undefined
                }
            }).then(function (res) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
                _this3.tableList = res.data.data;
                if (res.data && res.data.hasOwnProperty("result") && res.data.result) {
                    _this3.totalInfo = res.data.result;
                }
                _this3.totalElements = res.data.totalElements;
                _this3.totalPage = res.data.totalPages;
            }).catch(function (err) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
            });
        }
    },
    activated: function activated() {
        this.nowDay = new Date();
        this.valueForMonth = new Date();
        this.form.beginTime = new Date().Format("yyyy-MM-dd 00:00:00");
        this.form.endTime = new Date().Format("yyyy-MM-dd 23:59:59");
        this.$forceUpdate();
        this.getData();
    }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["curStoreId", "pageSize"],
  data: function data() {
    return {
      // ~~~
      changeItem: {}, //当前是否有选择修改某一项规则
      rulesList: [], //规则列表
      showRuleInfo: false,
      ruleInfo: {
        countType: 0,
        id: 0,
        enabled: true,
        ruleName: "",
        upTopFee: false, //是否封顶
        upTopFeeMoney: "", //封顶费用
        openAfter: {
          minute: 0,
          money: ""
        },
        billByHour: true,
        billByTimeRange: false,
        // 按小时
        perHourMoney: 0,
        actualEnabled: true, //超过小时数按实际分钟数来收费
        sectionEnabled: false, //超过小时数按分钟数区间来收费
        sectionInfo: {
          sectionFrom: 0, //多少分钟内免费
          sectionTo: 0 //超过此分钟按多少分钟计费
        },
        //
        // 包段
        setHourRange: 0, //包段时长
        perSetHourRangeMoney: 0, //包段金额
        // rangeInfo:{
        //    sectionFrom:0,//多少分钟内免费
        //    sectionTo:0,//超过此分钟按多少分钟计费
        // },
        //
        serviceEnabled: false, //是否加收服务费
        serviceInfo: {
          serviceAmount: 0, //服务费的金额
          serviceBegin: 0, //收取服务费开始时间
          serviceEnd: 0, //收取服务费结束时间
          serviceTo: 0, //服务费区段结束时间
          serviceFrom: 0 //好多分钟数内不收费
        }
      },
      nowFeeSty: "hour",
      minutes: 59,
      hours: 47,
      serviceHours: 23, //服务费加收时间段
      // ~~~
      totalElements: 0,
      currentPage: 1,
      area: "",
      areaList: [], //区域列表
      tableList: [], // 桌位列表
      // 新增桌位
      newTable: {
        parId: "",
        sort: "",
        numName: ""
      },
      curTableId: "", // 桌位id
      addTableVisible: false, // 控制新增弹框显示隐藏
      addJobApiBtn: true, // 控制新增桌位接口
      curTableItem: {}, //当前所选择的分区
      page: 0,
      size: 10
    };
  },

  watch: {
    showRuleInfo: function showRuleInfo(val) {
      if (!val) {
        this.changeItem = {};
        this.nowFeeSty = "hour";
      }
    }
  },
  methods: {
    // 添加计费规则
    saveRules: function saveRules() {
      var _this = this;

      console.log(this.ruleInfo);
      if (!this.checkRules()) {
        return;
      }
      var id = void 0;
      if (this.changeItem) {
        id = this.changeItem.id;
      } else {
        id = 0;
      }

      var data = {
        storeId: this.curStoreId,
        id: this.ruleInfo.id ? this.ruleInfo.id : 0,
        name: this.ruleInfo.ruleName,
        upAmount: this.ruleInfo.upTopFeeMoney,
        upEnabled: this.ruleInfo.upTopFee,
        beginOrderTime: this.ruleInfo.openAfter.minute,
        beginOrderAmount: this.ruleInfo.openAfter.money,
        hourEnabled: this.nowFeeSty == "hour" ? 1 : 0,
        regionEnabled: this.nowFeeSty != "hour" ? 1 : 0,
        oneHourAmount: this.ruleInfo.perHourMoney,
        actualEnabled: this.ruleInfo.actualEnabled ? 1 : 0,
        sectionEnabled: this.ruleInfo.sectionEnabled ? 1 : 0,
        sectionFrom: this.ruleInfo.sectionInfo.sectionFrom,
        sectionTo: this.ruleInfo.sectionInfo.sectionTo,
        serviceEnabled: this.ruleInfo.serviceEnabled ? 1 : 0,
        serviceBegin: this.ruleInfo.serviceInfo.serviceBegin,
        serviceEnd: this.ruleInfo.serviceInfo.serviceEnd,
        serviceFrom: this.ruleInfo.serviceInfo.serviceFrom,
        serviceTo: this.ruleInfo.serviceInfo.serviceTo,
        serviceAmount: this.ruleInfo.serviceInfo.serviceAmount,
        regionTime: this.ruleInfo.setHourRange,
        regionAmount: this.ruleInfo.perSetHourRangeMoney,
        countType: this.ruleInfo.countType,
        enabled: true
      };

      this.$http({
        url: "rule-merge",
        method: "POST",
        data: data
      }).then(function (res) {
        if (res.data.code == 200) {
          _this.$message({
            message: res.data.msg,
            customClass: "success"
          });
          _this.showRuleInfo = false;
          _this.getRules();
          return;
        }
      });
    },
    checkRules: function checkRules() {
      if (!this.ruleInfo.ruleName) {
        this.$message({
          message: "请填写规则名",
          customClass: "error"
        });
        return false;
      }
      // if(!this.ruleInfo.openAfter.money){
      //   this.$message({
      //     message: "请填写开单后金额",
      //     customClass: "error"
      //   });
      //   return false;
      // }
      if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.ruleInfo.openAfter.money)) {
        this.$message({
          message: "金额输入有误",
          customClass: "error",
          showClose: true,
          duration: 2000
        });
        return false;
      }
      if (this.nowFeeSty == "hour" || this.nowFeeSty != "hour" && this.ruleInfo.sectionEnabled) {
        if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.ruleInfo.perHourMoney)) {
          this.$message({
            message: "金额输入有误",
            customClass: "error",
            showClose: true,
            duration: 2000
          });
          return false;
        }
      }
      // if (this.nowFeeSty != "hour") {
      //   if (
      //     !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
      //       this.ruleInfo.perSetHourRangeMoney
      //     )
      //   ) {
      //     this.$message({
      //       message: "金额输入有误",
      //       customClass: "error",
      //       showClose: true,
      //       duration: 2000,
      //     });
      //     return false;
      //   }
      // }
      // if (this.ruleInfo.serviceEnabled) {
      //   if (
      //     !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
      //       this.ruleInfo.serviceInfo.serviceAmount
      //     )
      //   ) {
      //     this.$message({
      //       message: "金额输入有误",
      //       customClass: "error",
      //       showClose: true,
      //       duration: 2000,
      //     });
      //     return false;
      //   }
      // }
      if (this.ruleInfo.upTopFee && !this.ruleInfo.upTopFeeMoney) {
        this.$message({
          message: "请填写封顶金额",
          customClass: "error"
        });
        return false;
      }
      // if (this.ruleInfo.upTopFee) {
      //   if (
      //     !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
      //       this.ruleInfo.upTopFeeMoney
      //     )
      //   ) {
      //     this.$message({
      //       message: "金额输入有误",
      //       customClass: "error",
      //       showClose: true,
      //       duration: 2000,
      //     });
      //     return false;
      //   }
      // }
      return true;
    },

    //
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: " + val);
      this.getTableList(val - 1);
    },
    changeReward: function changeReward(item) {
      var _this2 = this;

      console.log(item);
      this.$http({
        url: "employee-groups/update-empR",
        method: "GET",
        params: {
          groupId: item.id,
          reward: item.reward ? 0 : 1
        }
      }).then(function (res) {
        _this2.getareaList();
      });
    },

    //是否将此桌位的人员显示在语音呼叫客户端
    changeShowStatue: function changeShowStatue(item) {
      var _this3 = this;

      this.$http({
        url: "update-show",
        method: "GET",
        params: {
          id: item.id,
          show: item.show ? 0 : 1
        }
      }).then(function (res) {
        console.log(res);
        if (res.data.code == 200) {
          _this3.$message({
            message: res.data.msg,
            customClass: "success"
          });
          _this3.getareaList();
        }
      });
    },

    getareaList: function getareaList() {
      var _this4 = this;

      this.$http.get("/par/all?storeId=" + this.curStoreId).then(function (res) {
        var body = res.data;
        _this4.areaList = body;
      });
    },
    // 获取桌位列表
    getTableList: function getTableList() {
      var _this5 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.$http({
        url: "/num/all",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        var body = res.data.content;
        _this5.tableList = body;
        _this5.totalElements = res.data.totalElements;
        var num = _this5.pageSize - body.length;
        if (num > 0) {
          for (var i = 0; i < num; i++) {
            _this5.tableList.push({
              parName: ""
            });
          }
        }
      });
    },
    // 新增, 更新桌位
    addTable: function addTable() {
      var _this6 = this;

      if (!this.newTable.numName) {
        this.$message({
          message: "请填写桌位号",
          customClass: "error"
        });
        return;
      }
      if (!this.newTable.parId) {
        this.$message({
          message: "请选择所属区域",
          customClass: "error"
        });
        return;
      }
      if (!/^(\d){1,3}$/.test(this.newTable.sort)) {
        this.$message({
          message: "排序值填写有误,排序范围在0-999",
          customClass: "error"
        });
        return;
      }
      if (this.newTable.sort > 1000 || this.newTable.sort < 0) {
        this.$message({
          message: "排序值填写有误,排序范围在0-999",
          customClass: "error"
        });
        return;
      }
      if (this.curTableId) {
        var data = void 0;
        if (this.curTableItem.numName == this.newTable.numName) {
          data = {
            parId: this.newTable.parId,
            sort: this.newTable.sort,
            numId: this.curTableItem.id
          };
        } else {
          data = {
            parId: this.newTable.parId,
            numName: this.newTable.numName,
            sort: this.newTable.sort,
            numId: this.curTableItem.id
          };
        }
        this.$http({
          url: "/num/update",
          method: "POST",
          data: data
        }).then(function (res) {
          if (res.data.code == 200) {
            _this6.$message({
              message: res.data.msg,
              customClass: "success"
            });
            _this6.addTableVisible = false;
            _this6.newTable = { parId: "", sort: "", numName: "" };
            _this6.getTableList();
            _this6.curTableId = "";
          } else {
            _this6.$message({
              message: res.data.msg,
              customClass: "error"
            });
          }
        });
      } else {
        var parName = "";
        for (var i = 0; i < this.areaList.length; i++) {
          if (this.areaList[i].id == this.newTable.parId) {
            parName = this.areaList[i].partitionName;
          }
        }
        var _data = {
          storeId: this.curStoreId,
          parId: this.newTable.parId,
          sort: this.newTable.sort,
          parName: parName,
          numName: this.newTable.numName
        };
        this.$http({
          url: "/num/add",
          method: "POST",
          data: _data
        }).then(function (res) {
          if (res.data.code == 200) {
            _this6.$message({
              message: res.data.msg,
              customClass: "success"
            });
            _this6.addTableVisible = false;
            _this6.newTable = { name: "", sort: "" };
            _this6.getTableList();
            _this6.curTableId = "";
          } else {
            _this6.$message({
              message: res.data.msg,
              customClass: "error"
            });
          }
        });
      }
    },

    // 删除桌位
    delRules: function delRules(id) {
      var _this7 = this;

      this.$confirm("此操作将删除该计费规则, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this7.$http.post("rule-remove", { id: id }).then(function (res) {
          _this7.getRules();
        });
      }).catch(function () {});
    },
    // 获得当前桌位信息
    getCurTable: function getCurTable(item) {
      console.log(item);
      this.changeItem = item;
      this.nowFeeSty = item.hourEnabled ? "hour" : "timerange";
      this.ruleInfo = {
        id: item.id,
        countType: item.countType,
        ruleName: item.name,
        upTopFee: item.upEnabled, //是否封顶
        upTopFeeMoney: item.upAmount, //封顶费用
        openAfter: {
          minute: item.beginOrderTime,
          money: item.beginOrderAmount
        },
        billByHour: true,
        billByTimeRange: false,
        // 按小时
        perHourMoney: item.oneHourAmount,
        actualEnabled: item.actualEnabled, //超过小时数按实际分钟数来收费
        sectionEnabled: item.sectionEnabled, //超过小时数按分钟数区间来收费
        sectionInfo: {
          sectionFrom: item.sectionFrom, //多少分钟内免费
          sectionTo: item.sectionTo //超过此分钟按多少分钟计费
        },
        //
        // 包段
        setHourRange: item.regionTime, //包段时长
        perSetHourRangeMoney: item.regionAmount, //包段金额
        // rangeInfo:{
        //    sectionFrom:0,//多少分钟内免费
        //    sectionTo:0,//超过此分钟按多少分钟计费
        // },
        //
        serviceEnabled: item.serviceEnabled, //是否加收服务费
        serviceInfo: {
          serviceAmount: item.serviceAmount, //服务费的金额
          serviceBegin: item.serviceBegin, //收取服务费开始时间
          serviceEnd: item.serviceEnd, //收取服务费结束时间
          serviceTo: item.serviceTo, //服务费区段结束时间
          serviceFrom: item.serviceFrom //好多分钟数内不收费
        }
      };
      this.showRuleInfo = true;
    },
    // 清除信息
    clear: function clear() {
      this.ruleInfo = {
        id: 0,
        countType: 0,
        enabled: true,
        ruleName: "",
        upTopFee: false, //是否封顶
        upTopFeeMoney: "", //封顶费用
        openAfter: {
          minute: 0,
          money: ""
        },
        billByHour: true,
        billByTimeRange: false,
        // 按小时
        perHourMoney: 0,
        actualEnabled: true, //超过小时数按实际分钟数来收费
        sectionEnabled: false, //超过小时数按分钟数区间来收费
        sectionInfo: {
          sectionFrom: 0, //多少分钟内免费
          sectionTo: 0 //超过此分钟按多少分钟计费
        },
        //
        // 包段
        setHourRange: 0, //包段时长
        perSetHourRangeMoney: 0, //包段金额
        // rangeInfo:{
        //    sectionFrom:0,//多少分钟内免费
        //    sectionTo:0,//超过此分钟按多少分钟计费
        // },
        //
        serviceEnabled: false, //是否加收服务费
        serviceInfo: {
          serviceAmount: 0, //服务费的金额
          serviceBegin: 0, //收取服务费开始时间
          serviceTo: 0, //收取服务费结束时间
          serviceFrom: 0 //好多分钟数内不收费
        }
      };
      this.showRuleInfo = true;
    },
    getRules: function getRules() {
      var _this8 = this;

      this.$http({
        url: "rule-list",
        method: "GET",
        params: {
          storeId: this.curStoreId
        }
      }).then(function (res) {
        _this8.rulesList = res.data;
        var num = _this8.pageSize - res.data.length;
        if (num > 0) {
          for (var i = 0; i < num; i++) {
            _this8.rulesList.push({
              name: ""
            });
          }
        }
      });
    }
  },
  created: function created() {},
  activated: function activated() {
    this.getRules();
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "dailyGrade",
  props: ["curStoreId"],
  data: function data() {
    return {
      curGoodIdx: 0, // 当前商品索引
      goods: "",
      goodCheckArr: [],
      showList: false,
      nowSelFilter: "today",
      isSmallScreen: false,
      emps: [],
      empMobile: "",
      // pickerOptionsForTimeRange:{
      //     disabledDate(time) {

      //        let date = (new Date(time));
      //     //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
      //     //    let newDate = new Date(dateStr).getTime();
      //     //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
      //     //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
      //         let curDate = (new Date()).getTime();
      //         let three = 35 * 24 * 3600 * 1000;
      //         let threeDays = curDate - three;
      //         return time.getTime() > Date.now() || time.getTime() < threeDays;
      //     } 
      // },
      sourceType: { // 订单来源类型
        POS: "收银台",
        WEB: "电脑点单",
        EMPLOYEE: "店员宝",
        WEIXIN: "微信点单",
        CONSUMER: "消费者，微信",
        TAKEOUT: "三方外卖"
      },
      showOutPie: false,
      canClick: true,
      startTime: '', //按时间段查询的起始时间
      endTime: '', //按时间段查询的结束时间
      nowType: "TIME_RANGE",
      orderDetailData: [],
      doShowOrderDetail: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      dateStr: new Date().Format("yyyy-MM-dd"),
      pieForIncome: null, //收入饼状图
      pieForOut: null, //支出饼状图
      currentPage: 1,
      pageSize: 10,
      gradeDataForPie: {
        adminPayBill: {
          ali: 0,
          cash: 0,
          returnTotal: 0,
          wx: 0
        },
        refundTotalAmount: 0, //退总款金额
        successTotalAmount: 0 //总收入
      }, //经营日报的数据
      gradeListData: [], //经营日报列表数据
      searchOrderId: "", //所搜索的订单id
      payType: {
        "CASH": "现金",
        "ALIPAY": "支付宝",
        "WECHATPAY": "微信",
        "UNIONPAY": "银联",
        "pay.weixin.micropay": "微信刷卡",
        "pay.wechat.micropay": "微信刷卡",
        "pay.alipay.micropay": "支付宝刷卡",
        "pay.jdpay.micropay": "京东刷卡",
        "pay.qq.micropay": "QQ钱包刷卡",
        "pay.shiming.micropay": "会员卡",
        "pay.unionpay.micropay": "银联支付",
        "pay.bestpay.micropay": "翼支付",
        "pay.weixin.native": "微信扫码",
        "pay.wechat.native": "微信扫码",
        "pay.alipay.native": "支付宝扫码",
        "ALIPAY_CASH": "支付宝线下",
        "WECHATPAY_CASH": "微信线下",
        "COUPON": "优惠券",
        "MEMBER": "会员",
        "pay.wechat.jspay": "微信网页支付",
        "pay.alipay.jspay": "支付宝网页支付"
      },
      totalElements: 0, //数据总条数
      loading: true,
      showPie: false, //在没有数据的情况下是否显示饼状图
      productName: undefined,
      showCharts: true,
      goodSearchBtn: true
    };
  },

  watch: {
    dateStr: function dateStr(val) {
      console.log(new Date(val).Format("yyyy-MM-dd"));
      var nowDate = new Date(val).Format("yyyy-MM-dd");
      this.dateStr = nowDate;
      this.getData(0, nowDate, this.empMobile);
    },
    nowType: function nowType(val) {
      this.showPie = false;
      this.showOutPie = false;
      this.gradeListData = [];
      this.totalElements = 0;
      this.empMobile = "";
    },
    empMobile: function empMobile(val) {
      if (this.nowType == "DAY") {
        this.getData(0, this.dateStr, val);
      }
    },

    goods: function goods(val) {
      if (val) {
        this.searchGoods(val, null);
      } else {
        this.goodCheckArr = [];
        this.goods = undefined;
        this.goodSearchBtn = true;
      }
    }
  },
  methods: {
    selSearchGood: function selSearchGood(item, boo) {
      var _this = this;

      this.goods = item.name;
      // this.goodSearchBtn = false;
      setTimeout(function () {
        _this.goodCheckArr = [];
      }, 250);
    },

    // 商品检索
    searchGoods: function searchGoods(val, id) {
      var _this2 = this;

      if (!this.goodSearchBtn) {
        return;
      }
      this.goodSearchBtn = false;
      this.$http.get('products/stores-search?storeId=' + (id ? id : this.curStoreId) + '&stockEnabled=false' + '&q=' + encodeURI(val)).then(function (res) {
        if (id) {
          _this2.addGoodCheckArr = res.data;
          _this2.isAutoSearchBtn = false;
          setTimeout(function () {
            _this2.isAutoSearchBtn = true;
          }, 2000);
          setTimeout(function () {
            var that = _this2;
            $('.add_details_search li').hover(function () {
              that.addCurGoodIdx = $(this).index() - 1;
            }, function () {
              that.addCurGoodIdx = 0;
            });
          }, 0);
        } else {
          _this2.goodCheckArr = res.data;
          setTimeout(function () {
            var that = _this2;
            $('.details_search li').hover(function () {
              that.curGoodIdx = $(this).index() - 1;
            }, function () {
              that.curGoodIdx = 0;
            });
          }, 0);
        }
        _this2.goodSearchBtn = true;
      }).catch(function () {
        _this2.goodSearchBtn = true;
      });
    },
    filter: function filter(type) {
      var timeRangeArr = [];
      this.nowSelFilter = type;
      switch (type) {
        case "today":
          // this.yearMonth = new Date().Format("yyyy-MM");
          this.startTime = new Date().Format("yyyy/MM/dd") + " 00:00:00";
          // let year = new Date().Format("yyyy");
          // let month = new Date().Format("MM");
          this.endTime = new Date().Format("yyyy/MM/dd") + " 23:59:59";
          this.searchConfirm();
          break;
        case "lastDay":
          this.startTime = new Date().Format("yyyy/MM/dd") + " 00:00:00";
          this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + " 00:00:00";
          this.endTime = new Date().Format("yyyy/MM/dd") + " 23:59:59";
          this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + " 23:59:59";
          this.searchConfirm();
          break;
        case "week":
          timeRangeArr = this.$dateRange.getThisWeek();
          this.startTime = timeRangeArr[0] + " 00:00:00";
          this.endTime = timeRangeArr[1] + " 23:59:59";
          this.searchConfirm();
          break;
        case "lastWeek":
          timeRangeArr = this.$dateRange.getLastWeek();
          this.startTime = timeRangeArr[0] + " 00:00:00";
          this.endTime = timeRangeArr[1] + " 23:59:59";
          this.searchConfirm();
          break;
        case "month":
          timeRangeArr = this.$dateRange.getThisMonth();
          console.log(timeRangeArr);
          this.startTime = timeRangeArr[0] + " 00:00:00";
          this.endTime = timeRangeArr[1] + " 23:59:59";
          this.searchConfirm();
          break;
        case "lastMonth":
          timeRangeArr = this.$dateRange.getLastMonth();
          console.log(timeRangeArr);
          this.startTime = timeRangeArr[0] + " 00:00:00";
          this.endTime = timeRangeArr[1] + " 23:59:59";
          this.searchConfirm();
          break;
        default:
          break;
      }
    },

    // 搜索
    searchConfirm: function searchConfirm() {

      // 
      var timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime() + "-" + this.empMobile;
      var nowTime = new Date().getTime();
      if (!this.$canClickSelect("dailyGradeTimeRange", timeStr, nowTime)) {
        this.$message({
          message: '5秒内禁止重复查询相同数据',
          customClass: 'error'
        });
        return;
      }
      // 

      if (new Date(this.endTime).getTime() - new Date(this.startTime).getTime() > 1000 * 60 * 60 * 24 * 35) {
        this.$message({
          message: '只能查询35天内的数据',
          customClass: 'error'
        });
        return;
      }
      if (this.startTime !== '' && this.endTime !== '') {
        if (new Date(this.startTime) > new Date(this.endTime)) {
          this.$message({
            message: '结束时间不能比开始时间小',
            customClass: 'error'
          });
          return;
        }
        if (this.canClick) {
          this.canClick = false;
          this.getData(0, this.dateStr, this.empMobile, "ARB", true);
        }
      } else {
        this.$message({
          message: '请选择查询时间段',
          customClass: 'error'
        });
        return;
      }
    },
    showOrderDetail: function showOrderDetail(item) {
      var _this3 = this;

      this.$http({
        url: "get-item",
        method: "GET",
        params: {
          orderId: item.orderId
        }
      }).then(function (res) {
        _this3.doShowOrderDetail = true;
        _this3.orderDetailData = res.data;
      });
    },

    //按订单查询
    searchByOrderId: function searchByOrderId() {
      var _this4 = this;

      this.$http({
        url: "get-storeBill",
        method: "GET",
        params: {
          orderId: this.searchOrderId
        }
      }).then(function (res) {
        console.log(res);
        _this4.gradeListData = res.data.data;
        _this4.totalElements = 0;
      });
    },

    //分页方法
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: " + val);
      console.log(this.dateStr);
      if (this.nowType == "DAY") {
        this.getData(val - 1, this.dateStr, this.empMobile, "DAY", false);
      } else {
        if (this.startTime !== '' && this.endTime !== '') {
          if (new Date(this.startTime) > new Date(this.endTime)) {
            this.$message({
              message: '结束时间不能比开始时间小',
              customClass: 'error'
            });
            return;
          }
        } else {
          return;
        }
        this.getData(val - 1, this.dateStr, this.empMobile, "ARB", false);
      }
    },
    drawPieForIncome: function drawPieForIncome(data, incomeData) {
      var _this5 = this;

      if (this.pieForIncome) {
        // this.pieForIncome.dispose();
      }
      this.pieForIncome = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(document.getElementById("income-pie"));
      var legendData = [];
      for (var i = 0; i < incomeData.length; i++) {
        legendData.push(incomeData[i].name);
      }
      var option = {
        title: {
          text: "\u603B\u6536\u5165:" + Number(data.successTotalAmount - data.refundTotalAmount).toFixed(2) + "( " + (data.successCount - data.refundCount) + "\u7B14)",
          x: "left",
          padding: 15,
          textStyle: {
            color: "#000",
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b} : {c} ({d}%)"
          formatter: "{a} <br/>{b} "
        },
        legend: {
          orient: "vertical",
          right: "20%",
          data: legendData,
          top: "middle",
          type: "scroll"
        },
        color: ["#55a8dc", "#6fcd58", "#e78d61", "#000000"],
        series: [{
          name: "收入来源",
          type: "pie",
          radius: "55%",
          center: ["35%", "50%"],
          label: {
            normal: {
              position: "inner",
              show: false
            }
          },
          data: incomeData,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      setTimeout(function () {
        _this5.pieForIncome.setOption(option);
      }, 200);
    },
    drawPieForOut: function drawPieForOut(data, outData) {
      var _this6 = this;

      if (this.pieForOut) {
        this.pieForOut.dispose();
      }
      this.pieForOut = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(document.getElementById("out-pie"));
      var legendData = [];
      for (var i = 0; i < outData.length; i++) {
        legendData.push(outData[i].name);
      }
      var option = {
        title: {
          text: "\u9000\u5355:" + Number(data.refundTotalAmount).toFixed(2) + "( " + data.refundCount + "\u7B14 )",
          x: "left",
          padding: 15,
          textStyle: {
            color: "#000",
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b} : {c} ({d}%)"
          formatter: "{a} <br/>{b} "
        },
        legend: {
          orient: "vertical",
          right: "20%",
          data: legendData,
          top: "middle",
          type: "scroll"
        },
        color: ["#37d6b7"],
        series: [{
          name: "退单",
          type: "pie",
          radius: "55%",
          center: ["35%", "50%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              position: "inner",
              show: false
            },
            emphasis: {
              show: false,
              textStyle: {
                fontSize: "30",
                fontWeight: "bold"
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          // data: [{ value: data.refundTotalAmount, name: "退款" }]
          data: outData
        }]
      };
      setTimeout(function () {
        _this6.pieForOut.setOption(option);
      }, 200);
    },
    formatData: function formatData(data) {
      var returnData = [];
      if (data.length) {
        this.showPie = true;
        // 提取信息
        for (var i = 0; i < data.length; i++) {
          var amountObj = {};
          amountObj.value = Number(data[i].amount).toFixed(2);
          amountObj.count = data[i].count;
          switch (data[i].channel) {
            // case "pay.weixin.micropay":
            //   amountObj.name = "微信刷卡";
            //   amountObj.itemStyle = { normal: { color: "#e29fbf" } };
            //   break;
            // case "pay.alipay.micropay":
            //   amountObj.name = "支付宝刷卡";
            //   amountObj.itemStyle = { normal: { color: "#d69947" } };
            //   break;
            // case "pay.jdpay.micropay":
            //   amountObj.name = "京东刷卡";
            //   amountObj.itemStyle = { normal: { color: "#d17c42" } };
            //   break;
            case "jdMicroPay":
              amountObj.name = "京东刷卡";
              amountObj.itemStyle = { normal: { color: "#d17c42" } };
              break;
            // case "pay.qq.micropay":
            //   amountObj.name = "QQ钱包刷卡";
            //   amountObj.itemStyle = { normal: { color: "#b3c125" } };
            //   break;
            case "qqMicroPay":
              amountObj.name = "QQ钱包刷卡";
              amountObj.itemStyle = { normal: { color: "#b3c125" } };
              break;
            // case "pay.shiming.micropay":
            //   amountObj.name = "会员卡";
            //   amountObj.itemStyle = { normal: { color: "#1c9cba" } };
            //   break;
            case "smMicroPay":
              amountObj.name = "会员卡";
              amountObj.itemStyle = { normal: { color: "#1c9cba" } };
              break;
            // case "pay.unionpay.micropay":
            //   amountObj.name = "银联支付";
            //   amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
            //   break;
            case "unionPay":
              amountObj.name = "银联支付";
              amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
              break;
            // case "pay.bestpay.micropay":
            //   amountObj.name = "翼支付";
            //   amountObj.itemStyle = { normal: { color: "#ea7f5e" } };
            //   break;
            case "wingPayAmount":
              amountObj.name = "翼支付";
              amountObj.itemStyle = { normal: { color: "#ea7f5e" } };
              break;
            // case "pay.weixin.native":
            //   amountObj.name = "微信扫码";
            //   amountObj.itemStyle = { normal: { color: "#8ecc52" } };
            //   break;
            // case "pay.alipay.native":
            //   amountObj.name = "支付宝扫码";
            //   amountObj.itemStyle = { normal: { color: "#41bbd8" } };
            //   break;
            case "CASH":
              amountObj.name = "现金";
              amountObj.itemStyle = { normal: { color: "#3bbddb" } };
              break;
            case "cashAmount":
              amountObj.name = "现金";
              amountObj.itemStyle = { normal: { color: "#3bbddb" } };
              break;
            case "WECHATPAY":
              amountObj.name = "微信";
              amountObj.itemStyle = { normal: { color: "#51c332" } };
              break;
            case "wechatAmount":
              amountObj.name = "微信";
              amountObj.itemStyle = { normal: { color: "#51c332" } };
              break;
            case "ALIPAY":
              amountObj.name = "支付宝";
              amountObj.itemStyle = { normal: { color: "#d69947" } };
              break;
            case "alipayAmount":
              amountObj.name = "支付宝";
              amountObj.itemStyle = { normal: { color: "#56abe4" } };
              break;
            case "UNIONPAY":
              amountObj.name = "银联";
              amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
              break;
            case "ALIPAY_CASH":
              amountObj.name = "支付宝线下";
              amountObj.itemStyle = { normal: { color: "#d69947" } };
              break;
            case "WECHATPAY_CASH":
              amountObj.name = "微信线下";
              amountObj.itemStyle = { normal: { color: "#51c332" } };
              break;
            case "COUPON":
              amountObj.name = "优惠券";
              amountObj.itemStyle = { normal: { color: "#619ce2" } };
              break;
            case "couponAmount":
              amountObj.name = "优惠券";
              amountObj.itemStyle = { normal: { color: "#619ce2" } };
              break;
            case "MEMBER":
              amountObj.name = "会员";
              amountObj.itemStyle = { normal: { color: "#1c9cba" } };
              break;
            case "memberAmount":
              amountObj.name = "会员";
              amountObj.itemStyle = { normal: { color: "#1c9cba" } };
              break;
            case "memberRechargeAmount":
              amountObj.name = "会员充值";
              amountObj.itemStyle = { normal: { color: "#1c9cba" } };
              break;
            default:
              break;
          }
          amountObj.name = amountObj.name + ":" + amountObj.value + "\u5143(" + amountObj.count + "\u7B14)";
          // amountObj[billInfo.amount[i][0]] =  billInfo.amount[i][1];
          returnData.push(amountObj);
        }
        console.log(returnData);
      }
      return returnData;
    },
    getEmps: function getEmps() {
      var _this7 = this;

      this.$http({
        url: "employees",
        params: {
          storeId: this.curStoreId,
          enabled: true
        }
      }).then(function (res) {
        _this7.emps = res.data;
      });
    },


    //获取数据
    getData: function getData(page, date) {
      var empMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      var _this8 = this;

      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "DAY";
      var isUpdatePie = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      var params = void 0;
      this.showList = false;
      if (type == "DAY") {
        params = {
          storeId: this.curStoreId,
          time: date,
          page: page,
          size: this.pageSize,
          source: "store",
          type: type,
          empMobile: empMobile ? empMobile : null,
          productName: this.goods ? this.goods.trim() : undefined
        };
      } else {
        var begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
        var end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
        params = {
          storeId: this.curStoreId,
          // time: date,
          page: page,
          size: this.pageSize,
          source: "store",
          type: type,
          begin: begin,
          end: end,
          empMobile: empMobile ? empMobile : null,
          productName: this.goods ? this.goods.trim() : undefined
        };
      }
      this.showCharts = true;
      if (params.productName) {
        this.showCharts = false;
      }
      this.loading = true;
      this.$http({
        url: "get-storeBill",
        method: "GET",
        params: params
      }).then(function (res) {
        setTimeout(function () {
          _this8.showList = true;
        }, 500);
        if (res.status === 200) {
          setTimeout(function () {
            _this8.canClick = true;
          }, 500);
          console.log(res);
          _this8.gradeDataForPie = res.data;
          _this8.gradeListData = res.data.data;
          _this8.totalElements = res.data.totalElements;

          var data = res.data;
          var billInfo = JSON.parse(data.adminPayBill);
          var refundBillInfo = JSON.parse(data.adminRefundBill);
          if (billInfo.adminPayBill.length) {
            _this8.showPie = true;
            var incomeData = _this8.formatData(billInfo.adminPayBill);
            console.log(incomeData);
            if (isUpdatePie) {
              setTimeout(function () {
                _this8.drawPieForIncome(data, incomeData);
              }, 150);
            }
            _this8.loading = false;
          } else {
            _this8.loading = false;
            _this8.showPie = false;
            if (_this8.pieForIncome) {
              _this8.pieForIncome.dispose();
            }
          }
          if (refundBillInfo.adminPayBill.length) {
            _this8.showOutPie = true;
            var outData = _this8.formatData(refundBillInfo.adminPayBill);
            if (isUpdatePie) {
              setTimeout(function () {
                _this8.drawPieForOut(data, outData);
                // this.drawPieForOut(this.gradeDataForPie);
              }, 150);
            }
            _this8.loading = false;
          } else {
            _this8.loading = false;
            _this8.showOutPie = false;
            if (_this8.pieForOut) {
              _this8.pieForOut.dispose();
            }
          }
        } else if (res.status === 500) {
          _this8.loading = false;
          _this8.$message({
            message: "系统运行错误",
            customClass: "error",
            showClose: true
          });
        }
      }).catch(function (err) {
        setTimeout(function () {
          _this8.showList = true;
        }, 500);
      });
    }
  },
  mounted: function mounted() {
    // 
    this.getData(0, this.dateStr);
    this.getEmps();
    if (document.body.clientWidth < 1500) {
      this.isSmallScreen = true;
    }
    this.startTime = new Date().Format("yyyy/MM/dd") + " 00:00:00";
    var year = new Date().Format("yyyy");
    var month = new Date().Format("MM");
    this.endTime = new Date().Format("yyyy/MM/dd") + " 23:59:59";
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_url_js__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId'],
    data: function data() {
        return {
            excelParams: {},
            refundAmount: 0, //退单金额
            serviceChargeAmount: 0, //手续费金额
            totalAmount: 0, //总金额
            currentPage: 1,
            totalElements: 0,
            pageSize: 20,
            channelInfo: null,
            orderSource: "ALL",
            orderSourceOptions: [{
                label: "全部",
                value: "ALL"
            }, {
                label: "收银端",
                value: "POS"
            }, {
                label: "店员宝",
                value: "EMPLOYEE"
            }, {
                label: "微信点单",
                value: "WEIXIN"
            }, {
                label: "客户端点单",
                value: "WEB"
            }],
            nowSelFilter: "today",
            isSelAll: true,
            selType: [],
            showType: false,
            rangeTime: [], //时间段的值
            isUseRangeTime: false, //是否使用时间段
            workDataForTimeRange: [],
            allAmountForTimeRange: 0,
            allQtyForTimeRange: 0,
            startTime: '', //开始时间
            endTime: '', //结束时间
            nowTimeRange: "",
            searchByWhichType: "timeRange", //按照时间段或者是日月报的形式查询，dayOrMonth,timeRange
            valueForMonth: '', //月份信息
            workDataForMonth: [], //月报数据
            allAmountForMonth: 0, //月报总金额
            allAmount: 0, //总金额
            allQtyForMonth: 0, //月报总数量
            allQty: 0, //总数量
            nowDay: '', //当前日期
            nowType: "day", //当前查询方式，如日报，月报
            workData: [],
            workCalculateData: {
                amount: 0,
                quantity: 0
            },
            getBtn: true, // 控制翻页请求
            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > new Date(Date.now()).getTime() - 1000 * 60 * 60 * 24;
                }
            },
            pickerOptionsForTimeRange: {
                disabledDate: function disabledDate(time) {

                    //    let date = (new Date(time));
                    // //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
                    // //    let newDate = new Date(dateStr).getTime();
                    // //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
                    // //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
                    //     let curDate = (new Date()).getTime();
                    //     let three = 30 * 24 * 3600 * 1000;
                    //     let threeDays = curDate - three;
                    //     return time.getTime() > Date.now() || time.getTime() < threeDays;
                }
            },
            pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            salesData: {
                turnInAmount: 0,
                cashAmount: 0,
                wechatAmount: 0,
                alipayAmount: 0,
                memberAmount: 0,
                couponAmount: 0,
                wechatCashAmount: 0,
                alipayCashAmount: 0
            }, //销售数据

            typeList: [{
                name: '全部',
                id: ''
            }], // 分类

            timeFrom: '', //开始时间
            timeTo: '', //截止时间
            typeId: ['ALL'], // 分类id
            goodId: '', // 商品id
            searchKeywords: '', // 搜索关键字
            searchList: [], // 搜索结果数组
            goodSearchBtn: true, // 控制搜索框
            canSearch: true, //
            options: []
        };
    },

    watch: {
        selType: function selType(val) {
            console.log(val);
            if (val.length == this.options.length) {
                this.isSelAll = true;
            } else {
                this.isSelAll = false;
            }
        },
        isUseRangeTime: function isUseRangeTime(val) {
            this.startTime = '';
            this.endTime = '';
        },

        searchKeywords: function searchKeywords(val) {
            if (this.canSearch) {
                this.goodSearch();
            } else {
                this.canSearch = true;
            }
        },
        endTime: function endTime(val) {
            console.log(val);
            var days = 1000 * 60 * 60 * 24 * 45;
            if (this.startTime !== "") {
                if (new Date(val) - new Date(this.startTime) > days) {
                    this.$message({
                        message: '查询时间段最多45天',
                        customClass: 'error'
                    });
                }
            } else {
                this.$message({
                    message: '请选择起始时间',
                    customClass: 'error'
                });
            }

            //    let dateStrForNextMonth = date.getFullYear()+'-'+(date.getMonth()+2)+'-'+'00';
            //    console.log(dateStrForNextMonth)
            //    let newDateForNextMonth = new Date(2018,11,0).getTime();
            //    let date = new Date(newDateForNextMonth);
            //    console.log(date.getDate())
        }
    },
    methods: {
        handleCurrentChange: function handleCurrentChange(val) {
            console.log('\u5F53\u524D\u9875: ' + val);
            this.currentPage = val;
            this.searchConfirm();
        },
        filter: function filter(type) {
            var timeRangeArr = [];
            this.nowSelFilter = type;
            switch (type) {
                case "today":
                    // this.yearMonth = new Date().Format("yyyy-MM");
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    // let year = new Date().Format("yyyy");
                    // let month = new Date().Format("MM");
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastDay":
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 00:00:00';
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "week":
                    timeRangeArr = this.$dateRange.getThisWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastWeek":
                    timeRangeArr = this.$dateRange.getLastWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "month":
                    timeRangeArr = this.$dateRange.getThisMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastMonth":
                    timeRangeArr = this.$dateRange.getLastMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                default:
                    break;
            }
        },
        selAll: function selAll() {
            this.isSelAll = !this.isSelAll;
            if (this.isSelAll) {
                var selType = [];
                for (var i = 0; i < this.options.length; i++) {
                    selType.push(this.options[i].value);
                }
                this.selType = selType;
            } else {
                this.selType = [];
            }
        },

        selGood: function selGood(item) {
            this.canSearch = false;
            this.searchKeywords = item.name;
            this.goodId = item.id;
            this.searchList = [];
        },
        // 商品检索
        goodSearch: function goodSearch() {
            var _this = this;

            var val = this.searchKeywords;
            if (!val) {
                this.searchList = [];
                return;
            }
            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http.get('products/search?storeId=' + this.curStoreId + '&q=' + encodeURI(val)).then(function (res) {
                _this.searchList = res.data;
                for (var i = 0, len = _this.searchList.length; i < len; i++) {
                    if (_this.searchKeywords == _this.searchList[i].name) {
                        _this.goodId = _this.searchList[i].id;
                        break;
                    } else {
                        _this.goodId = '';
                    }
                }
                _this.goodSearchBtn = true;
            }).catch(function () {
                _this.goodSearchBtn = true;
            });
        },
        // 搜索
        searchConfirm: function searchConfirm() {
            var date = new Date(this.nowDay).Format("yyyy-MM-dd");
            var dateForMonth = new Date(this.valueForMonth).Format("yyyy-MM");

            //分类形式
            // let type = this.typeId[0];
            if (this.selType.length == 0) {
                this.$message({
                    message: '请选择分类',
                    customClass: 'error'
                });
                return;
            }
            var type = this.selType.join(",");
            console.log(type);
            // return;
            if (this.searchByWhichType === "dayOrMonth") {
                if (this.nowType == 'month') {
                    if (dateForMonth) {
                        this.getSalesCount(dateForMonth, type, "MONTH");
                        // this.getWordData();
                        // this.getSales();
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                    }
                } else {
                    if (date) {
                        this.getSalesCount(date, type, "DAY");
                        // this.getWordData();
                        // this.getSales();
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                    }
                }
            } else {
                if (this.startTime !== '' && this.endTime !== '') {
                    if (new Date(this.startTime) > new Date(this.endTime)) {
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        });
                        return;
                    }
                    if (this.isUseRangeTime) {
                        if (!this.rangeTime || this.rangeTime.length < 2) {
                            this.$message({
                                message: '请选择每一天的时间段',
                                customClass: 'error'
                            });
                            return;
                        }
                        // let fromSecond = new Date(this.rangeTime[0]).getTime();
                        // let toSecond = new Date(this.rangeTime[1]).getTime();
                        // if(fromSecond>toSecond){
                        //     this.$message({
                        //         message: '起始时间应该小于截止时间',
                        //         customClass: 'error'
                        //     })
                        //     return;
                        // }
                    }
                    // if((new Date(this.startTime).getMonth()+1)!==(new Date(this.endTime).getMonth()+1)){
                    //     this.$message({
                    //         message: '只能选择所选月份内的时间段，不可跨月查询。',
                    //         customClass: 'error'
                    //     })
                    //     return;
                    // }
                    var days = 1000 * 60 * 60 * 24 * 45;
                    if (new Date(this.endTime) - new Date(this.startTime) > days) {
                        this.$message({
                            message: '查询时间段最多45天',
                            customClass: 'error'
                        });
                        return;
                    }
                    //起止时间
                    var startTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    var endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    if (this.isUseRangeTime) {
                        startTime = new Date(this.startTime).Format("yyyy-MM-dd") + " 00:00:00";
                        endTime = new Date(this.endTime).Format("yyyy-MM-dd") + " 23:59:59";
                    }
                    this.getSalesCount({ startTime: startTime, endTime: endTime }, type, "timeRange");
                } else {
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    });
                    return;
                }
            }

            // if(this.timeTo&&this.timeFrom){
            //     if(new Date(this.timeFrom)>new Date(this.timeTo)){
            //         this.$message({
            //             message: '结束时间不能比开始时间小',
            //             customClass: 'error'
            //         })
            //         return;
            //     }
            //     this.getWordData();
            //     this.getSales();
            // } else {
            //     this.$message({
            //         message: '请选择查询时间段',
            //         customClass: 'error'
            //     })
            // }
        },
        getSalesCount: function getSalesCount(date, type, source) {
            var _this2 = this;

            var params = void 0;
            if (this.searchByWhichType === "dayOrMonth") {
                if (source == "DAY") {
                    params = {
                        storeId: this.curStoreId,
                        time: date,
                        type: type,
                        source: source
                        // 
                    };var timeStr = new Date(date).getTime() + "-" + type + "-" + new Date(date).getTime();
                    var nowTime = new Date().getTime();
                    // if(!(this.$canClickSelect("totalSalesDay",timeStr,nowTime))){
                    //     this.$message({
                    //         message: '5秒内禁止重复查询相同数据',
                    //         customClass: 'error'
                    //     });
                    //     return;
                    // }
                    // 
                } else {
                    var dateObj = new Date(date);
                    var year = dateObj.getFullYear();
                    var month = dateObj.getMonth() + 1;
                    params = {
                        storeId: this.curStoreId,
                        type: type,
                        year: year,
                        month: month,
                        source: source
                        // 
                    };var _timeStr = new Date(date).getTime() + "-" + type + "-" + new Date(date).getTime();
                    var _nowTime = new Date().getTime();
                    // if(!(this.$canClickSelect("totalSalesMonth",timeStr,nowTime))){
                    //     this.$message({
                    //         message: '5秒内禁止重复查询相同数据',
                    //         customClass: 'error'
                    //     });
                    //     return;
                    // }
                    //
                }
            } else {
                var _dateObj = date;
                var startTime = date.startTime;
                var endTime = date.endTime;
                var judge = this.isUseRangeTime;
                var fromSecond = 0;
                var toSecond = 0;
                var nowDate = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
                if (this.isUseRangeTime) {
                    fromSecond = parseInt((this.rangeTime[0] - nowDate) / 1000);
                    toSecond = parseInt((this.rangeTime[1] - nowDate) / 1000);
                }
                params = {
                    storeId: this.curStoreId,
                    type: type,
                    from: startTime,
                    to: endTime,
                    source: source,
                    judge: judge,
                    fromSecond: fromSecond,
                    toSecond: toSecond
                    // 
                };var _timeStr2 = new Date(startTime).getTime() + "-" + type + "-" + new Date(endTime).getTime();
                var _nowTime2 = new Date().getTime();
                // if(!(this.$canClickSelect("totalSalesTimeRange",timeStr,nowTime))){
                //     this.$message({
                //         message: '5秒内禁止重复查询相同数据',
                //         customClass: 'error'
                //     });
                //     return;
                // }
                //
            }
            params["orderSource"] = this.orderSource;
            if (this.isSelAll) {
                params["typeAll"] = "ALL";
            } else {
                params["typeAll"] = "ELSE";
            }
            this.excelParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, {
                from: new Date(params.from).Format("yyyy-MM-dd"),
                to: new Date(params.to).Format("yyyy-MM-dd"),
                page: 0,
                size: 1000
            });
            this.$http({
                url: "third-party",
                method: "GET",
                params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, {
                    from: new Date(params.from).Format("yyyy-MM-dd"),
                    to: new Date(params.to).Format("yyyy-MM-dd"),
                    page: this.currentPage - 1,
                    size: this.pageSize
                })
            }).then(function (res) {
                console.log(res);
                _this2.workData = res.data.electronicBills;
                _this2.totalElements = res.data.totalElements;
                _this2.refundAmount = res.data.refundAmount;
                _this2.serviceChargeAmount = res.data.serviceChargeAmount;
                _this2.totalAmount = res.data.totalAmount;
                _this2.totalSingular = res.data.totalSingular;
            });
        },

        //搜索条件
        conditionFn: function conditionFn() {
            // console.log(this.typeId);
            var URL = '';
            this.timeFrom ? URL += '?from=' + new Date(this.timeFrom).Format('yyyy-MM-dd hh:mm:ss') : '';
            this.timeTo ? URL += '&to=' + new Date(this.timeTo).Format('yyyy-MM-dd hh:mm:ss') : '';
            URL += '&productTypeId=' + this.typeId[this.typeId.length - 1] + '&productId=' + this.goodId;
            return URL;
        },

        //获取消费记录列表
        getWordData: function getWordData() {
            var _this3 = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.workCalculateData.amount = 0;
            this.workCalculateData.quantity = 0;
            var url = this.conditionFn();
            this.$http.get(this.curStoreId + '/product-sales' + url).then(function (res) {
                _this3.workData = res.data;
                if (_this3.workData.length < _this3.pageSize) {
                    for (var i = 0, len = _this3.pageSize - _this3.workData.length; i < len; i++) {
                        _this3.workData.push({});
                    }
                }
                for (var _i = 0, _len = _this3.workData.length; _i < _len; _i++) {
                    if (_this3.workData[_i].productId) {
                        _this3.workData[_i].single = (_this3.workData[_i].amount / _this3.workData[_i].quantity).toFixed(2);
                        _this3.workCalculateData.amount += _this3.workData[_i].amount;
                        _this3.workCalculateData.quantity += _this3.workData[_i].quantity;
                    }
                }
                _this3.getBtn = true;
                _this3.workCalculateData.amount = _this3.workCalculateData.toFixed(2);
                _this3.workCalculateData.quantity = _this3.workCalculateData.quantity.toFixed(2);
            }).catch(function () {
                _this3.getBtn = true;
            });
        },
        getSales: function getSales() {
            var _this4 = this;

            var url = this.conditionFn();
            this.$http.get(this.curStoreId + '/sales-total' + url).then(function (res) {
                _this4.salesData = res.data;
            });
        },

        //导出按钮
        excel: function excel() {
            this.$http({
                url: "third-party",
                method: "GET",
                params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.excelParams)
            }).then(function (res) {
                console.log(res);
                if (!res.data.electronicBills || !Array.isArray(res.data.electronicBills) || !res.data.electronicBills.length) {
                    return;
                }
                // this.workData = res.data.electronicBills;
                // this.refundAmount = res.data.refundAmount;
                // this.serviceChargeAmount = res.data.serviceChargeAmount;
                // this.totalAmount = res.data.totalAmount;
                // this.totalSingular = res.data.totalSingular;
                var html = '<tr>' + '<td style="font-size:18px">收款金额</td>' + '<td style="font-size:18px">手续费</td>' + '<td style="font-size:18px">划账金额</td>' + '<td style="font-size:18px">日期</td>' + '</tr>';
                for (var i = 0; i < res.data.electronicBills.length; i++) {
                    html += '<tr>' + '<td>' + res.data.electronicBills[i].totalAmountIncome / 100 + '</td>' + '<td>' + res.data.electronicBills[i].serviceChargeAmount / 100 + '</td>' + '<td>' + (res.data.electronicBills[i].totalAmountIncome - res.data.electronicBills[i].serviceChargeAmount) / 100 + '</td>' + '<td>' + new Date(res.data.electronicBills[i].date).Format('yyyy-MM-dd') + '</td>' + '</tr>';
                }
                html += '<tr>' + '<td style="font-size:16px"></td>' + '<td></td>' + '<td></td>' + '<td></td>' + '</tr>';
                html += '<tr>' + '<td style="font-size:16px"></td>' + '<td></td>' + '<td></td>' + '<td></td>' + '</tr>';
                html += '<tr>' + '<td style="font-size:16px">收款金额</td>' + '<td></td>' + '<td></td>' + '<td>' + res.data.totalAmount / 100 + '</td>' + '</tr>';
                html += '<tr>' + '<td style="font-size:16px">手续费</td>' + '<td></td>' + '<td></td>' + '<td>' + res.data.serviceChargeAmount / 100 + '</td>' + '</tr>';
                html += '<tr>' + '<td style="font-size:16px">划账金额</td>' + '<td></td>' + '<td></td>' + '<td>' + (res.data.totalAmount - res.data.serviceChargeAmount) / 100 + '</td>' + '</tr>';
                document.getElementById('scrollBox').innerHTML = html;
                window.method5(scrollBox);
            });
        }
    },
    created: function created() {
        var _this5 = this;

        for (var i = 0; i < this.pageSize; i++) {}
        // this.workData.push({});


        //获取商品分类
        this.$http.get('/product-types-all?storeId=' + this.curStoreId + '&parentId=' + '').then(function (res) {
            _this5.typeList = _this5.typeList.concat(res.data);

            // this.options.push({label: '全部',value: 'ALL'});
            for (var i = 0; i < res.data.length; i++) {
                var obj = {
                    value: res.data[i].name,
                    label: res.data[i].name
                    // if(res.data[i].productTypeVos.length){
                    //     let son = res.data[i].productTypeVos;
                    //     let arr = [
                    //         {value:res.data[i].id,label:res.data[i].name}
                    //     ];
                    //     for (var j = 0; j < son.length; j++) {
                    //          let sonobj={
                    //             value:son[j].id,
                    //             label:"- "+son[j].name
                    //         }
                    //         arr.push(sonobj)
                    //     }
                    //     obj.children = arr;
                    // }
                };_this5.selType.push(res.data[i].name);
                _this5.options.push(obj);
            }
        });
    },
    mounted: function mounted() {
        this.nowDay = new Date();
        this.valueForMonth = new Date();
        // let date = new Date().Format("yyyy-MM-dd");
        // let dateForMonth = new Date().Format("yyyy-MM");
        // this.getSalesCount(date,"ALL");
        console.log(this.workData.length);
        this.startTime = new Date(new Date().Format("yyyy/MM/dd") + ' 00:00:00').getTime() - 1000 * 60 * 60 * 24;
        var year = new Date().Format("yyyy");
        var month = new Date().Format("MM");
        this.endTime = new Date(new Date().Format("yyyy/MM/dd") + ' 23:59:59').getTime() - 1000 * 60 * 60 * 24;
    }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__urlConfig_index_js__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            rentData: [],
            stockArr: [],
            showStock: false,
            nowTypeName: '', //当前所选择的分类的名字
            nowItem: [
                // {
                //     amount: 0,
                //     name: "",
                //     qty: 0,
                //     seTypeName: "",
                //     typeName: ""
                // }
            ], //用户点击交班的分类的时候，所点击的分类下的商品
            showPutAllMask: false, //交班明细控制按钮
            showPutAllMask1: false, //销售明细控制按钮
            showPutAllMask2: false, //员工销售明细控制按钮
            workData: [],
            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0, //总共条

            getBtn: true, // 控制翻页请求

            inventoryList: [], //交班明细
            workDetailId: '', //某班id

            salesData: { cost: '', net: { qty: 0, amount: 0 }, itemDetails: [{ amount: 0, name: "", qty: 0, seTypeName: "", typeName: "" }] }, //销售明细
            salesCurPage: 0, //销售明细的当前页码

            staffArr: [], //员工销售明细
            curWorkData: {
                "cashAmount": '',
                "alipayAmount": '',
                "wechatAmount": '',
                "alipayCashAmount": '',
                "wechatCashAmount": '',
                "memberAmount": '',
                "couponAmount": ''
            } // 当前查看班次的数据

        };
    },

    methods: {
        cutStockDetail: function cutStockDetail(item) {
            var _this = this;

            this.$http({
                url: "workStock/list",
                method: "GET",
                params: {
                    id: item.id
                }
            }).then(function (res) {
                console.log(res);
                _this.showStock = true;
                _this.stockArr = res.data;
            });
        },

        //关闭销售明细时的回调，用于清空当前销售明细的数据
        closeSaleDetail: function closeSaleDetail() {
            this.salesData = { cost: '', net: { qty: 0, amount: 0 }, itemDetails: [{ amount: 0, name: "", qty: 0, seTypeName: "", typeName: "" }] };
            this.nowTypeName = "";
        },

        //获取当前分类下的商品销售情况
        getNowTypeProducts: function getNowTypeProducts(name) {
            var _this2 = this;

            this.nowItem = [];
            console.log(name);
            if (this.nowTypeName === name || name === "") {
                this.nowTypeName = '';
                return;
            }
            this.nowTypeName = name;
            this.$http({
                url: "get-itemDetails",
                method: "GET",
                params: {
                    id: this.curWorkData.id,
                    storeId: this.curStoreId,
                    typeName: name
                }
            }).then(function (res) {
                _this2.nowItem = res.data;
                console.log(res);
            });
        },

        //列表翻页
        changePage: function changePage(boo) {
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            this.getWordData();
        },
        //获取交班列表
        getWordData: function getWordData() {
            var _this3 = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.$http.get('/workshift/list?storeId=' + this.curStoreId + '&page=' + this.curPage + '&pageSize=' + this.pageSize).then(function (res) {
                _this3.workData = res.data.workShifts;
                _this3.totalPage = res.data.totalPages;
                _this3.totalElements = res.data.totalElements;
                if (_this3.workData.length < _this3.pageSize) {
                    for (var i = 0, len = _this3.pageSize - _this3.workData.length; i < len; i++) {
                        _this3.workData.push({});
                    }
                }
                for (var _i = 0, _len = _this3.workData.length; _i < _len; _i++) {
                    if (_this3.workData[_i].id) {
                        _this3.workData[_i].turnInAmount = _this3.workData[_i].turnInAmount.toFixed(2);
                        _this3.workData[_i].cashAmount = _this3.workData[_i].cashAmount.toFixed(2);
                        _this3.workData[_i].wechatAmount = _this3.workData[_i].wechatAmount.toFixed(2);
                        _this3.workData[_i].alipayAmount = _this3.workData[_i].alipayAmount.toFixed(2);
                        _this3.workData[_i].memberAmount = _this3.workData[_i].memberAmount.toFixed(2);
                        _this3.workData[_i].wechatCashAmount = _this3.workData[_i].wechatCashAmount.toFixed(2);
                        _this3.workData[_i].alipayCashAmount = _this3.workData[_i].alipayCashAmount.toFixed(2);
                    }
                }
                _this3.getBtn = true;
            }).catch(function () {
                _this3.getBtn = true;
            });
        },
        getRentInfo: function getRentInfo(id) {
            var _this4 = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this4.$http({
                    // url:`${API_BASE_URL}v1/call/lease/printing`,
                    url: 'lease/printing',
                    method: "GET",
                    params: {
                        id: id
                    }
                }).then(function (res) {
                    try {
                        _this4.rentData = res.data.printing;
                    } catch (error) {
                        console.log(error);
                    }
                    resolve();
                }).catch(function (err) {
                    reject();
                });
            });
        },

        //销售明细
        cutSalesDetail: function cutSalesDetail(item) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this5.curWorkData = item;
                                _context.prev = 1;
                                _context.next = 4;
                                return _this5.getRentInfo(item.id);

                            case 4:
                                _context.next = 9;
                                break;

                            case 6:
                                _context.prev = 6;
                                _context.t0 = _context['catch'](1);

                                console.log("error", _context.t0);

                            case 9:
                                _this5.$http.get('workshift/' + item.id + '/details').then(function (res) {
                                    _this5.salesData = res.data;
                                    _this5.showPutAllMask1 = true;
                                });

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this5, [[1, 6]]);
            }))();
        },

        //员工业绩
        getStaff: function getStaff(item) {
            var _this6 = this;

            this.$http.get('workshift/' + item.id + '/staff').then(function (res) {
                _this6.staffArr = res.data;
                _this6.showPutAllMask2 = true;
                for (var i = 0, len = _this6.staffArr.length; i < len; i++) {
                    _this6.staffArr[i].totalAmount = _this6.staffArr[i].totalAmount.toFixed(2);
                }
            });
        },

        // 销售导出excel
        sales2Excel: function sales2Excel() {
            var _this7 = this;

            this.$http.get('get-excel?id=' + this.curWorkData.id).then(function (res) {
                var types = res.data.types;
                var coupons = res.data.coupons;

                var domstr = '<table style="border-collapse: collapse;">';
                domstr += '<tr>\n                                <th style="font-size:18px">\u5546\u54C1\u540D\u79F0</th>\n                                <th style="font-size:18px">\u552E\u4EF7</th>\n                                <th style="font-size:18px">\u6570\u91CF</th>\n                                <th style="font-size:18px">\u603B\u8BA1</th>\n                            </tr>';
                for (var i = 0, len = types.length; i < len; i++) {
                    domstr += '<tr>\n                                <td colspan="3" style="text-align:center;font-size:16px">---' + types[i].typeName + '---</td>\n                                <td style="font-size:16px;color:red">\uFFE5' + types[i].amount / 100 + '</td>\n                            </tr>';
                    for (var j = 0, len2 = types[i].products.length; j < len2; j++) {
                        domstr += '<tr>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].productName + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].amount / (types[i].products[j].quantity * 100) + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].quantity + '</td>\n                                    <td style="border:1px solid #ccc;font-size:14px">' + types[i].products[j].amount / 100 + '</td>\n                                </tr>';
                    }
                }

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="7" style="font-size:18px;font-weight:900;text-align:center">\u603B\u9500\u552E\u989D</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:18px;">\u73B0\u91D1</td>\n                                <td style="font-size:18px;">\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u4F1A\u5458\u652F\u4ED8</td>\n                                <td style="font-size:18px;">\u4F18\u60E0\u5238\u62B5\u6263</td>\n                            </tr>\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.cashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.alipayAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.wechatAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.alipayCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.wechatCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.memberAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.couponAmount / 100 + '</td>\n                            </tr>\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td style="border:1px solid #ccc;font-weight:900;font-size:18px">\u603B\u9500\u552E\u989D\uFF1A</td>\n                                <td style="border:1px solid #ccc;font-size:20px;color:red;font-weight:600">' + _this7.curWorkData.turnInAmount + '</td>\n                            </tr>';

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="7" style="font-size:18px;font-weight:900;text-align:center">\u7F51\u8D39\u9500\u552E\u989D</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:18px;">\u73B0\u91D1</td>\n                                <td style="font-size:18px;">\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u652F\u4ED8\u5B9D</td>\n                                <td style="font-size:18px;">\u7EBF\u4E0B\u5FAE\u4FE1</td>\n                                <td style="font-size:18px;">\u4F1A\u5458\u652F\u4ED8</td>\n                                <td style="font-size:18px;">\u4F18\u60E0\u5238\u62B5\u6263</td>\n                            </tr>\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.cost.cashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.cost.alipayAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.cost.wechatAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.cost.alipayCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.cost.wechatCashAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.cost.memberAmount / 100 + '</td>\n                                <td style="border:1px solid #ccc;font-size:16px">' + _this7.salesData.cost.couponAmount / 100 + '</td>\n                            </tr>\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                                <td style="border:1px solid #ccc;font-weight:900;font-size:18px">\u603B\u9500\u552E\u989D\uFF1A</td>\n                                <td style="border:1px solid #ccc;font-size:20px;color:red;font-weight:600">' + _this7.salesData.cost.turnInAmount / 100 + '</td>\n                            </tr>';

                domstr += '\n                            <tr>\n                                <td></td>\n                                <td></td>\n                                <td></td>\n                            </tr>\n                            <tr>\n                                <td colspan="3" style="text-align:center;font-size:18px;font-weight:900">\u4F18\u60E0\u5238\u6838\u9500\u8BB0\u5F55</td>\n                            </tr>\n                            <tr>\n                                <td style="font-size:16px;font-weight:700;">\u4F18\u60E0\u5238\u540D\u79F0</td>\n                                <td style="font-size:16px;font-weight:700;">\u6570\u91CF</td>\n                                <td style="font-size:16px;font-weight:700;">\u603B\u91D1\u989D</td>\n                            </tr>';
                for (var i = 0, len = coupons.length; i < len; i++) {
                    domstr += '\n                            <tr>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].productName + '</td>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].quantity + '</td>\n                                <td style="border:1px solid #ccc;font-size:14px">' + coupons[i].amount / 100 + '</td>\n                            </tr>';
                }
                domstr += '</table>';

                window.method5($(domstr)[0]);
            });
        },
        // 员工导出excel
        staff2Excel: function staff2Excel() {
            if (!this.staffArr[0]) {
                this.$message({
                    message: '无数据可导出',
                    customClass: 'error'
                });
                return;
            }

            var data = this.staffArr;
            var domstr = '<table style="border-collapse: collapse;">';
            domstr += '<tr>\n                            <th style="font-size:16px">\u5458\u5DE5\u540D\u79F0</th>\n                            <th style="font-size:16px">\u8BA2\u5355\u6570\u91CF</th>\n                            <th style="font-size:16px">\u9500\u552E\u91D1\u989D</th>\n                        </tr>';
            for (var i = 0, len = data.length; i < len; i++) {
                domstr += '<tr>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].creatorName + '</td>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].orderCount + '</td>\n                            <td style="border:1px solid #ccc;font-size:14px">' + data[i].totalAmount + '</td>\n                        </tr>';
            }

            domstr += '</table>';

            window.method5($(domstr)[0]);
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.workData.push({});
        }
    },
    activated: function activated() {
        this.getWordData();
        console.log(this.$route);
    }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    components: { cartInfo: __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo___default.a },
    data: function data() {
        return {
            nowSelStartExcWork: "",
            nowSelEndExcWork: "",
            startExcWorks: [],
            endExcWorks: [],
            // 
            nowSelFilter: "",
            lastExTime: "",
            nowSelMobile: '',
            nowSelName: '',
            empMobile: "ALL",
            emps: [],
            totalBonusAmount: 0,
            totalChargeAmount: 0,
            totalChargeCount: 0,
            nowExcInfo: {}, //当前查看详情的会员信息
            showCartInfo: false,
            stateInfo: {
                "DEPOSIT": "储值",
                "WITHDRAW": "消费",
                "REFUND": "退款"
            },
            exchangeList: [], // 核销详情
            nowType: "TIME_RANGE",
            startTime: '', //按时间段查询的起始时间
            endTime: '', //按时间段查询的结束时间
            pickerOptions: {
                // disabledDate(time) {
                //     return time.getTime() > Date.now();
                // }
            },
            dateStr: new Date().Format("yyyy-MM"),
            currentPage: 1,
            totalElements: 0, //数据总条数
            canClick: true,
            searchPhone: "" //会员搜索手机号
        };
    },

    watch: {
        dateStr: function dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM"));
            var nowDate = new Date(val).Format("yyyy-MM");
            this.dateStr = nowDate;
            // this.getChargeInfo(0, nowDate);
        },
        showCartInfo: function showCartInfo(val) {
            if (!val) {
                this.nowSelMobile = "";
                this.nowSelName = "";
                this.nowExcInfo = {};
            }
        },
        startTime: function startTime(val) {
            this.nowSelStartExcWork = "";
            if (val) {
                var date = new Date(val);
                var time = date.Format("yyyy-MM-dd");
                var beginTime = time + " 00:00:00";
                var endTime = time + " 23:59:59";
                this.getExcWorks("start", { beginTime: beginTime, endTime: endTime });
            }
        },
        endTime: function endTime(val) {
            this.nowSelEndExcWork = "";
            if (val) {
                var date = new Date(val);
                var time = date.Format("yyyy-MM-dd");
                var beginTime = time + " 00:00:00";
                var endTime = time + " 23:59:59";
                this.getExcWorks("end", { beginTime: beginTime, endTime: endTime });
            }
        }
    },
    methods: {
        filter: function filter(type) {
            var timeRangeArr = [];
            this.nowSelFilter = type;
            switch (type) {
                case "today":
                    // this.yearMonth = new Date().Format("yyyy-MM");
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    // let year = new Date().Format("yyyy");
                    // let month = new Date().Format("MM");
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "lastDay":
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 00:00:00';
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "week":
                    timeRangeArr = this.$dateRange.getThisWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "lastWeek":
                    timeRangeArr = this.$dateRange.getLastWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "month":
                    timeRangeArr = this.$dateRange.getThisMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                case "lastMonth":
                    timeRangeArr = this.$dateRange.getLastMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.getdata("timeRange");
                    break;
                default:
                    break;
            }
        },
        getEmps: function getEmps() {
            var _this = this;

            this.$http({
                url: "employees",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    enabled: true
                }
            }).then(function (res) {
                _this.emps = res.data;
            });
        },
        showExcInfo: function showExcInfo(item) {
            var _this2 = this;

            var beginTime = new Date(this.nowSelStartExcWork).Format("yyyy-MM-dd hh:mm:ss");
            var endTime = new Date(this.nowSelEndExcWork).Format("yyyy-MM-dd hh:mm:ss");
            this.nowSelMobile = item.mobile;
            this.nowSelName = item.name;
            this.$http({
                url: "workshift/choose/details",
                method: "GET",
                params: {
                    mobile: item.mobile,
                    begin: beginTime,
                    end: endTime,
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                // if(res.data.code == 200){
                _this2.nowExcInfo = res.data;
                setTimeout(function () {
                    _this2.showCartInfo = true;
                }, 300);
                // }
            });
        },
        doSearch: function doSearch() {
            if (this.canClick) {
                this.canClick = false;
                this.getChargeInfo(0, this.dateStr);
            }
        },

        //分页方法
        handleCurrentChange: function handleCurrentChange(val) {
            console.log('\u5F53\u524D\u9875: ' + val);
            console.log(this.dateStr);
            this.getChargeInfo(val - 1, this.dateStr, "MONTH");
            // if(this.nowType == "MONTH"){
            //     this.getChargeInfo(val - 1, this.dateStr,"MONTH");
            // }else{
            //     this.getChargeInfo(val - 1, this.dateStr,"ARB");
            // }
        },

        // 搜索
        searchConfirm: function searchConfirm() {
            if (!this.nowSelStartExcWork || !this.nowSelEndExcWork) {
                this.$message({
                    message: '请选择查询起始班次和结束班次',
                    customClass: 'error'
                });
                return;
            }
            if (this.canClick) {
                this.canClick = false;
                this.getChargeInfo(0, this.dateStr, "ARB");
            }
            return;

            if (new Date(this.endTime).getTime() - new Date(this.startTime).getTime() > 1000 * 60 * 60 * 24 * 35) {
                this.$message({
                    message: '只能查询35天内的数据',
                    customClass: 'error'
                });
                return;
            }

            if (this.startTime !== '' && this.endTime !== '') {
                if (new Date(this.startTime) > new Date(this.endTime)) {
                    this.$message({
                        message: '结束时间不能比开始时间小',
                        customClass: 'error'
                    });
                    return;
                }
                if (new Date(this.startTime).getTime() > new Date(this.lastExTime).getTime() || new Date(this.endTime).getTime() > new Date(this.lastExTime).getTime()) {
                    this.$message({
                        message: '当前选择时间无交班信息',
                        customClass: 'error'
                    });
                    // this.$message({
                    //     message: '选择时间不能大于最后一次交班时间',
                    //     customClass: 'error'
                    // });
                    // this.endTime = this.lastExTime;
                    return;
                }
                if (this.canClick) {
                    this.canClick = false;
                    this.getChargeInfo(0, this.dateStr, "ARB");
                }
            } else {
                this.$message({
                    message: '请选择查询时间段',
                    customClass: 'error'
                });
                return;
            }
        },
        // 获取核销详情
        getChargeInfo: function getChargeInfo(page, date) {
            var _this3 = this;

            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "MONTH";

            var params = void 0;
            // if(this.empMobile){
            // if(!/^(\d){11}$/.test(this.searchPhone)){
            //     this.$message({
            //         message: '手机号输入有误',
            //         customClass: 'error'
            //     })
            //     setTimeout(()=>{
            //         this.canClick = true;
            //     },500);
            //     return;
            // }
            var beginTime = new Date(this.nowSelStartExcWork).Format("yyyy-MM-dd hh:mm:ss");
            var endTime = new Date(this.nowSelEndExcWork).Format("yyyy-MM-dd hh:mm:ss");
            if (!this.startTime || this.startTime == "" || !this.endTime || this.endTime == "") {
                this.$message({
                    message: '请选择时间',
                    customClass: 'error'
                });
                this.canClick = true;
                return;
            }
            params = {
                storeId: this.curStoreId,
                begin: beginTime,
                end: endTime
                // openMobile:this.empMobile

                // }else{
                //     let beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                //     let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                //     params = {
                //         storeId:this.curStoreId,
                //         beginTime,
                //         endTime,
                //         openMobile:"ALL"
                //     }
                // }


            };this.$http({
                url: "get-emp",
                method: "GET",
                params: params
            }).then(function (res) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
                console.log(res.data);
                // return;
                var body = res.data;
                // if(body.code == 200){
                _this3.exchangeList = body;
                // this.totalChargeCount = body.data.totalCount;
                // this.totalChargeAmount = body.data.totalAmount;
                // this.totalBonusAmount = body.data.totalBonusAmount;
                var number = _this3.pageSize - _this3.exchangeList.length;
                // this.totalElements = body.data.totalElements;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this3.exchangeList.push({
                            amount: "",
                            mobile: "",
                            name: ""
                        });
                    }
                }
                // }else{
                //     this.$message({
                //         message: body.msg,
                //         customClass: 'error'
                //     });
                // }
            }).catch(function (err) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
            });
        },
        getLastExTime: function getLastExTime() {
            var _this4 = this;

            this.$http({
                url: "get-endTime",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                var date = new Date(res.data);
                var time = date.Format("yyyy/MM/dd");
                _this4.startTime = time + " 00:00:00";
                _this4.endTime = date.Format("yyyy/MM/dd hh:mm:ss");
                _this4.lastExTime = res.data;
                _this4.pickerOptions = {
                    disabledDate: function disabledDate(time) {
                        return time.getTime() > new Date(res.data);
                    }
                };
            });
        },
        getExcWorks: function getExcWorks() {
            var _this5 = this;

            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";
            var _ref = arguments[1];
            var beginTime = _ref.beginTime,
                endTime = _ref.endTime;

            this.$http({
                url: "get/by/time",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    beginTime: beginTime,
                    endTime: endTime
                }
            }).then(function (res) {
                console.log(res);
                if (type == "all") {
                    _this5.startExcWorks = res.data;
                    _this5.endExcWorks = res.data;
                }
                if (type == "start") {
                    _this5.startExcWorks = res.data;
                } else {
                    _this5.endExcWorks = res.data;
                }
            });
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.exchangeList.push({
                workShift: {
                    closeUsername: "",
                    beginTime: "",
                    endTime: "",
                    total: 0
                }
            });
        }
        // 获取员工列表
    },
    mounted: function mounted() {
        // this.getLastExTime();
        var date = new Date();
        var time = date.Format("yyyy/MM/dd");
        // this.startTime = time+" 00:00:00";
        // this.endTime = time+" 23:59:59";
        // this.getExcWorks();
    },

    activated: function activated() {
        this.getEmps();
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "dailyGrade",
  props: ["curStoreId"],
  data: function data() {
    return {
      doShowOrderDetail: false,
      orderDetailData: [],
      sourceType: { // 订单来源类型
        POS: "收银台",
        WEB: "电脑点单",
        EMPLOYEE: "店员宝",
        WEIXIN: "微信点单",
        CONSUMER: "消费者，微信",
        TAKEOUT: "三方外卖"
      },
      workShiftId: "", //当前班次id
      pieForIncome: null, //收入饼状图
      pieForOut: null, //支出饼状图
      currentPage: 1,
      pageSize: 10,
      gradeDataForPie: {
        adminPayBill: {
          ali: 0,
          cash: 0,
          returnTotal: 0,
          wx: 0
        },
        refundTotalAmount: 0, //退总款金额
        successTotalAmount: 0 //总收入
      }, //经营日报的数据
      gradeListData: [], //经营日报列表数据
      searchOrderId: "", //所搜索的订单id
      payType: {
        "CASH": "现金",
        "ALIPAY": "支付宝",
        "WECHATPAY": "微信",
        "UNIONPAY": "银联",
        "pay.weixin.micropay": "微信刷卡",
        "pay.wechat.micropay": "微信刷卡",
        "pay.alipay.micropay": "支付宝刷卡",
        "pay.jdpay.micropay": "京东刷卡",
        "pay.qq.micropay": "QQ钱包刷卡",
        "pay.shiming.micropay": "会员卡",
        "pay.unionpay.micropay": "银联支付",
        "pay.bestpay.micropay": "翼支付",
        "pay.weixin.native": "微信扫码",
        "pay.wechat.native": "微信扫码",
        "pay.alipay.native": "支付宝扫码",
        "ALIPAY_CASH": "支付宝线下",
        "WECHATPAY_CASH": "微信线下",
        "COUPON": "优惠券",
        "MEMBER": "会员",
        "pay.wechat.jspay": "微信网页支付",
        "pay.alipay.jspay": "支付宝网页支付"
      },
      totalElements: 0, //数据总条数
      loading: true,
      showPie: false //在没有数据的情况下是否显示饼状图
    };
  },

  methods: {
    showOrderDetail: function showOrderDetail(item) {
      var _this = this;

      this.$http({
        url: "get-item",
        method: "GET",
        params: {
          orderId: item.orderId
        }
      }).then(function (res) {
        _this.doShowOrderDetail = true;
        _this.orderDetailData = res.data;
      });
    },

    //按订单查询
    searchByOrderId: function searchByOrderId() {
      var _this2 = this;

      this.$http({
        url: "get-storeBill",
        method: "GET",
        params: {
          orderId: this.searchOrderId
        }
      }).then(function (res) {
        console.log(res);
        _this2.gradeListData = res.data.data;
        _this2.totalElements = 0;
      });
    },

    //分页方法
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: " + val);
      this.getData(val - 1, false);
    },
    drawPieForIncome: function drawPieForIncome(data, incomeData) {
      var _this3 = this;

      if (this.pieForIncome) {
        this.pieForIncome.dispose();
      }
      this.pieForIncome = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(document.getElementById("income-pie"));
      var legendData = [];
      for (var i = 0; i < incomeData.length; i++) {
        legendData.push(incomeData[i].name);
      }
      var option = {
        title: {
          text: "\u603B\u6536\u5165:" + Number(data.successTotalAmount).toFixed(2) + "( " + data.successCount + "\u7B14 )",
          x: "left",
          padding: 15,
          textStyle: {
            color: "#000",
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} "
        },
        legend: {
          orient: "vertical",
          right: "20%",
          data: legendData,
          top: "middle",
          type: "scroll"
        },
        color: ["#55a8dc", "#6fcd58", "#e78d61", "#000000"],
        series: [{
          name: "收入来源",
          type: "pie",
          radius: "55%",
          center: ["35%", "50%"],
          label: {
            normal: {
              position: "inner",
              show: false
            }
          },
          data: incomeData,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      setTimeout(function () {
        _this3.pieForIncome.setOption(option);
      }, 200);
    },
    drawPieForOut: function drawPieForOut(data) {
      var _this4 = this;

      if (this.pieForOut) {
        this.pieForOut.dispose();
      }
      this.pieForOut = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(document.getElementById("out-pie"));
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        title: {
          text: "\u9000\u5355:" + Number(data.refundTotalAmount).toFixed(2) + "( " + data.refundCount + "\u7B14 )",
          x: "left",
          padding: 15,
          textStyle: {
            color: "#000",
            fontSize: 16
          }
        },
        color: ["#37d6b7"],
        series: [{
          name: "退单",
          type: "pie",
          radius: ["30%", "55%"],
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center"
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "30",
                fontWeight: "bold"
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [{ value: data.refundTotalAmount, name: "退款" }]
        }]
      };
      setTimeout(function () {
        _this4.pieForOut.setOption(option);
      }, 200);
    },

    //获取数据
    getData: function getData() {
      var _this5 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var isUpdatePie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.loading = true;
      this.$http({
        url: "get-storeBill",
        method: "GET",
        params: {
          workShiftId: this.$route.query.workShiftId,
          page: page,
          size: this.pageSize,
          source: "workShift"
        }
      }).then(function (res) {
        if (res.status === 200) {
          console.log(res);
          _this5.gradeDataForPie = res.data;
          _this5.gradeListData = res.data.data;
          _this5.totalElements = res.data.totalElements;
          //绘制饼图

          var data = res.data;
          var billInfo = JSON.parse(data.adminPayBill);
          console.log(billInfo);
          var incomeData = [];
          if (billInfo.adminPayBill.length) {
            _this5.showPie = true;
            // 提取信息
            for (var i = 0; i < billInfo.adminPayBill.length; i++) {
              var amountObj = {};
              amountObj.value = Number(billInfo.adminPayBill[i].amount).toFixed(2);
              amountObj.count = billInfo.adminPayBill[i].count;
              switch (billInfo.adminPayBill[i].channel) {
                // case "pay.weixin.micropay":
                //   amountObj.name = "微信刷卡";
                //   amountObj.itemStyle = { normal: { color: "#e29fbf" } };
                //   break;
                // case "pay.alipay.micropay":
                //   amountObj.name = "支付宝刷卡";
                //   amountObj.itemStyle = { normal: { color: "#d69947" } };
                //   break;
                // case "pay.jdpay.micropay":
                //   amountObj.name = "京东刷卡";
                //   amountObj.itemStyle = { normal: { color: "#d17c42" } };
                //   break;
                case "jdMicroPay":
                  amountObj.name = "京东刷卡";
                  amountObj.itemStyle = { normal: { color: "#d17c42" } };
                  break;
                // case "pay.qq.micropay":
                //   amountObj.name = "QQ钱包刷卡";
                //   amountObj.itemStyle = { normal: { color: "#b3c125" } };
                //   break;
                case "qqMicroPay":
                  amountObj.name = "QQ钱包刷卡";
                  amountObj.itemStyle = { normal: { color: "#b3c125" } };
                  break;
                // case "pay.shiming.micropay":
                //   amountObj.name = "会员卡";
                //   amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                //   break;
                case "smMicroPay":
                  amountObj.name = "会员卡";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                // case "pay.unionpay.micropay":
                //   amountObj.name = "银联支付";
                //   amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                //   break;
                case "unionPay":
                  amountObj.name = "银联支付";
                  amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                  break;
                // case "pay.bestpay.micropay":
                //   amountObj.name = "翼支付";
                //   amountObj.itemStyle = { normal: { color: "#ea7f5e" } };
                //   break;
                case "wingPayAmount":
                  amountObj.name = "翼支付";
                  amountObj.itemStyle = { normal: { color: "#ea7f5e" } };
                  break;
                // case "pay.weixin.native":
                //   amountObj.name = "微信扫码";
                //   amountObj.itemStyle = { normal: { color: "#8ecc52" } };
                //   break;
                // case "pay.alipay.native":
                //   amountObj.name = "支付宝扫码";
                //   amountObj.itemStyle = { normal: { color: "#41bbd8" } };
                //   break;
                case "CASH":
                  amountObj.name = "现金";
                  amountObj.itemStyle = { normal: { color: "#3bbddb" } };
                  break;
                case "cashAmount":
                  amountObj.name = "现金";
                  amountObj.itemStyle = { normal: { color: "#3bbddb" } };
                  break;
                case "WECHATPAY":
                  amountObj.name = "微信";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "wechatAmount":
                  amountObj.name = "微信";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "ALIPAY":
                  amountObj.name = "支付宝";
                  amountObj.itemStyle = { normal: { color: "#d69947" } };
                  break;
                case "alipayAmount":
                  amountObj.name = "支付宝";
                  amountObj.itemStyle = { normal: { color: "#56abe4" } };
                  break;
                case "UNIONPAY":
                  amountObj.name = "银联";
                  amountObj.itemStyle = { normal: { color: "#ff9e9c" } };
                  break;
                case "ALIPAY_CASH":
                  amountObj.name = "支付宝线下";
                  amountObj.itemStyle = { normal: { color: "#d69947" } };
                  break;
                case "WECHATPAY_CASH":
                  amountObj.name = "微信线下";
                  amountObj.itemStyle = { normal: { color: "#51c332" } };
                  break;
                case "COUPON":
                  amountObj.name = "优惠券";
                  amountObj.itemStyle = { normal: { color: "#619ce2" } };
                  break;
                case "couponAmount":
                  amountObj.name = "优惠券";
                  amountObj.itemStyle = { normal: { color: "#619ce2" } };
                  break;
                case "MEMBER":
                  amountObj.name = "会员";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                case "memberAmount":
                  amountObj.name = "会员";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                case "memberRechargeAmount":
                  amountObj.name = "会员充值";
                  amountObj.itemStyle = { normal: { color: "#1c9cba" } };
                  break;
                default:
                  break;
              }
              amountObj.name = amountObj.name + ":" + amountObj.value + "\u5143(" + amountObj.count + "\u7B14)";
              // amountObj[billInfo.amount[i][0]] =  billInfo.amount[i][1];
              incomeData.push(amountObj);
            }
            console.log(incomeData);
            if (isUpdatePie) {
              setTimeout(function () {
                _this5.drawPieForIncome(data, incomeData);
                _this5.drawPieForOut(_this5.gradeDataForPie);
              }, 150);
            }
            _this5.loading = false;
          } else {
            _this5.loading = false;
            _this5.showPie = false;
            if (_this5.pieForIncome) {
              _this5.pieForIncome.dispose();
            }
            if (isUpdatePie) {
              setTimeout(function () {
                _this5.drawPieForOut(_this5.gradeDataForPie);
              }, 150);
            }
          }
        } else if (res.status === 500) {
          _this5.loading = false;
          _this5.$message({
            message: "系统运行错误",
            customClass: "error",
            showClose: true
          });
        }
      });
    }
  },
  mounted: function mounted() {
    // 获取数据初进页面，没有订单号查询
    this.workShiftId = this.$route.query.workShiftId;
    this.getData();
    console.log(this.$route.query);
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            progressBtn: false, //进度条按钮
            showPutAllMask: false, //商品详情按钮

            curOrderData: [],
            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            workData: [],
            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0, //总共条
            paytype: { //支付类型
                ALIPAY: '支付宝',
                WECHATPAY: '微信',
                CASH: '现金',
                MEMBER: '会员支付',
                ALIPAY_CASH: '线下支付宝',
                WECHATPAY_CASH: '线下微信'
            },
            typeType: { 'MEMBER_DEPOSIT': '充值', 'SALES': '消费' }, //订单类型
            sourcetype: { //订单来源
                POS: "收银台",
                WEB: "电脑点单",
                EMPLOYEE: "店员宝",
                WEIXIN: "微信点单",
                CONSUMER: "消费者，微信",
                TAKEOUT: "三方外卖"
            },
            statustype: { //支付状态
                UNSETTLED: "未结算",
                UNFINISHED: "未处理",
                FINISHED: "已处理",
                CANCELED: "已取消",
                REFUNDED: "已退",
                FAIL: "失败",
                NOTSURE: "支付中"
            },
            getBtn: true, // 控制翻页请求

            timeFrom: '', //开始时间
            timeTo: '', //截止时间
            //来源
            sourceOptions: [{ value: '', label: '全部' }, { value: 'POS', label: '收银台' }, { value: 'WEB', label: '电脑点单' }, { value: 'EMPLOYEE', label: '店员宝' }, { value: 'WEIXIN', label: '微信点单' }],
            sourceValue: '',
            //支付类型
            payOptions: [{ value: '', label: '全部' }, { value: 'CASH', label: '现金' }, { value: 'ALIPAY', label: '支付宝' }, { value: 'WECHATPAY', label: '微信' }, { value: 'MEMBER', label: '会员支付' }],
            payValue: '',
            //交易状态
            statusOptions: [{ value: '', label: '全部' }, { value: 'UNSETTLED', label: '未结算' }, { value: 'UNFINISHED', label: '未处理' }, { value: 'CANCELED', label: '已取消' }, { value: 'FINISHED', label: '已处理' }, { value: 'REFUNDED', label: '已退' }, { value: 'FAIL', label: '失败' }, { value: 'NOTSURE', label: '支付中' }],
            statusValue: '',
            progressNum: 10, //进度条
            doubleQ: true,
            searchUrl: ''
        };
    },

    methods: {
        getSearch: function getSearch() {
            var _this = this;

            if (this.timeTo && this.timeFrom) {
                if (new Date(this.timeFrom) > new Date(this.timeTo)) {
                    this.$message({
                        message: '结束时间不能比开始时间小',
                        customClass: 'error'
                    });
                    return;
                }
            } else {
                this.$message({
                    message: '必须输入开始时间和结束时间!',
                    customClass: 'error'
                });
                return;
            }
            this.conditionFn();
            this.curPage = 0;
            setTimeout(function () {
                _this.getWordData();
            }, 10);
        },

        //列表翻页
        changePage: function changePage(boo) {
            if (!this.doubleQ) {
                return;
            }
            this.doubleQ = false;
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }

            this.getWordData();
        },
        //搜索条件
        conditionFn: function conditionFn() {
            var URL = '';
            this.timeFrom ? URL += '?from=' + new Date(this.timeFrom).Format('yyyy-MM-dd hh:mm:ss') : '';
            this.timeTo ? URL += '&to=' + new Date(this.timeTo).Format('yyyy-MM-dd hh:mm:ss') : '';
            this.sourceValue ? URL += '&source=' + this.sourceValue : '';
            this.payValue ? URL += '&channel=' + this.payValue : '';
            this.statusValue ? URL += '&status=' + this.statusValue : '';
            this.searchUrl = URL;
        },

        //获取消费记录列表
        getWordData: function getWordData() {
            var _this2 = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.workData = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
            this.$http.get(this.curStoreId + '/order/list' + this.searchUrl + '&pageNumber=' + this.curPage + '&pageSize=' + this.pageSize).then(function (res) {
                _this2.workData = res.data.orders;
                _this2.totalPage = res.data.totalPages >= 1 ? res.data.totalPages : 1;
                _this2.totalElements = res.data.totalElements;
                if (_this2.workData.length < _this2.pageSize) {
                    for (var i = 0, len = _this2.pageSize - _this2.workData.length; i < len; i++) {
                        _this2.workData.push({});
                    }
                }
                setTimeout(function () {
                    _this2.doubleQ = true;
                }, 500);
                _this2.getBtn = true;
            }).catch(function () {
                _this2.getBtn = true;
            });
        },

        //导出按钮
        excel: function excel() {
            var _this3 = this;

            if (!this.timeTo || !this.timeFrom) {
                this.$message({
                    message: '必须输入搜索时间',
                    customClass: 'error'
                });
                return;
            };
            if (this.totalElements <= 0) {
                this.$message({
                    message: '暂无数据！',
                    customClass: 'error'
                });
                return;
            };
            if (this.totalElements >= 10050) {
                this.$message({
                    message: '数据量太大，请细化检索条件！',
                    customClass: 'error'
                });
                return;
            };
            this.$http.get(this.curStoreId + '/order/list' + this.searchUrl + '&pageNumber=0' + '&pageSize=' + this.totalElements).then(function (res) {
                // this.progressNum = 0;
                var data = res.data.orders;
                var html = '<tr>' + '<td>交易时间</td>' + '<td>订单号</td>' + '<td>订单类型</td>' + '<td>订单来源</td>' + '<td>支付类型</td>' + '<td>交易状态</td>' + '<td>交易金额</td>' + '<td>优惠金额</td>' + '<td>实收金额</td>' + '</tr>';
                for (var i = 0; i < data.length; i++) {
                    html += '<tr>' + '<td>' + new Date(data[i].paymentTime).Format('yyyy-MM-dd hh:mm:ss') + '</td>' + '<td>' + data[i].code + '</td>' + '<td>' + _this3.typeType[data[i].type] + '</td>' + '<td>' + _this3.sourcetype[data[i].source] + '</td>' + '<td>' + _this3.paytype[data[i].channel] + '</td>' + '<td>' + _this3.statustype[data[i].status] + '</td>' + '<td>' + data[i].total + '</td>' + '<td>' + data[i].discount + '</td>' + '<td>' + data[i].amount + '</td>' + '</tr>';
                }
                document.getElementById('scrollBox').innerHTML = html;
                // this.progressNum = 100;
                window.method5(scrollBox);
            });
        },
        orderDetail: function orderDetail(id) {
            var _this4 = this;

            this.$http.get('orders/' + id).then(function (res) {
                _this4.showPutAllMask = true;
                _this4.curOrderData = res.data;
            });
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.workData.push({});
        }
    },
    mounted: function mounted() {
        // this.getWordData();
    }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ringReport",
  props: ["curStoreId"],
  data: function data() {
    return {
      dateStr: new Date().Format("yyyy-MM-dd"),
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() + 24 * 60 * 60 * 1000 > Date.now();
        }
      },
      week: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      startSalesItem: [],
      endSalesItem: [],
      nowDate: "",
      ringDate: "",
      nowDay: 0, //星期
      ringDay: 0 //星期
    };
  },

  watch: {
    dateStr: function dateStr(val) {
      console.log(new Date(val).Format("yyyy-MM-dd"));
      var nowDate = new Date(val).Format("yyyy-MM-dd");
      var prevTime = new Date(val).getTime() - 7 * 24 * 60 * 60 * 1000;
      var prevDate = new Date(prevTime).Format("yyyy-MM-dd");

      var date = new Date(val);
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      var day = date.getDate();

      // 同期时间
      var ringDateTimestamp = date.getTime() - 7 * 24 * 60 * 60 * 1000;
      var ringDate = new Date(ringDateTimestamp);
      var ringMonth = ringDate.getMonth() + 1;
      var ringYear = ringDate.getFullYear();
      var ringDay = ringDate.getDate();

      this.nowDay = date.getDay();
      this.ringDay = ringDate.getDay();

      this.nowDate = month + "月" + day + "日";
      this.ringDate = ringMonth + "月" + ringDay + "日";

      this.dateStr = nowDate;
      this.getData(nowDate + " 00:00:00", prevDate + " 00:00:00");
    }
  },
  methods: {
    getData: function getData(nowDate, prevDate) {
      var _this = this;

      this.$http({
        url: "get-sales",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          startTime: nowDate,
          endTime: prevDate
        }
      }).then(function (res) {
        _this.startSalesItem = res.data.startSalesItem;
        _this.endSalesItem = res.data.endSalesItem;
      });
    }
  },
  activated: function activated() {

    //初始化时间
    var date = new Date();
    //获取当前时间（不包含时分秒）的时间戳
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var day = date.getDate();
    var nowTimestamp = new Date(year + "/" + month + "/" + day).getTime();
    //计算出昨天的时间戳,之前只能查询前一天的数据，所以这里计算了一下时间，现在可以查当日的数据
    var prevDateTimestamp = nowTimestamp - 24 * 60 * 60 * 1000;
    // 同期时间
    var ringDateTimestamp = prevDateTimestamp - 7 * 24 * 60 * 60 * 1000;

    var prevDate = new Date(prevDateTimestamp);
    var prevMonth = prevDate.getMonth() + 1;
    var prevYear = prevDate.getFullYear();
    var prevDay = prevDate.getDate();

    // 同期时间
    var ringDate = new Date(ringDateTimestamp);
    var ringMonth = ringDate.getMonth() + 1;
    var ringYear = ringDate.getFullYear();
    var ringDay = ringDate.getDate();

    this.nowDate = prevMonth + "月" + prevDay + "日";
    this.ringDate = ringMonth + "月" + ringDay + "日";
    this.nowDay = prevDate.getDay();
    this.ringDay = ringDate.getDay();

    var dateParam = prevYear + "-" + (prevMonth > 9 ? prevMonth : '0' + prevMonth) + "-" + (prevDay > 9 ? prevDay : '0' + prevDay) + " 00:00:00";
    var ringDateParam = ringYear + "-" + (ringMonth > 9 ? ringMonth : '0' + ringMonth) + "-" + (ringDay > 9 ? ringDay : '0' + ringDay) + " 00:00:00";
    this.dateStr = prevYear + "-" + (prevMonth > 9 ? prevMonth : '0' + prevMonth) + "-" + (prevDay > 9 ? prevDay : '0' + prevDay);
    this.getData(dateParam, ringDateParam);
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    components: { cartInfo: __WEBPACK_IMPORTED_MODULE_1__cartInfo_cartInfo___default.a },
    data: function data() {
        return {
            fee: 0.004,
            lastExTime: "",
            nowSelMobile: '',
            nowSelName: '',
            empMobile: "ALL",
            emps: [],
            totalBonusAmount: 0,
            totalChargeAmount: 0,
            totalChargeCount: 0,
            nowExcInfo: {}, //当前查看详情的会员信息
            showCartInfo: false,
            stateInfo: {
                "DEPOSIT": "储值",
                "WITHDRAW": "消费",
                "REFUND": "退款"
            },
            exchangeList: [], // 核销详情
            nowType: "MONTH",
            startTime: '', //按时间段查询的起始时间
            endTime: '', //按时间段查询的结束时间
            pickerOptions: {
                disabledDate: function disabledDate(time) {
                    var date = new Date();
                    var month = date.getMonth();
                    return time.getMonth() >= month;
                }
            },
            dateStr: "",
            currentPage: 1,
            totalElements: 0, //数据总条数
            canClick: true,
            searchPhone: "", //会员搜索手机号
            nowSettleInfo: {
                amount: 0,
                begin: "",
                end: ""
            }
        };
    },

    watch: {
        dateStr: function dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM"));
            var nowDate = new Date(val).Format("yyyy-MM");
            this.dateStr = nowDate;
            this.getSettleInfo(nowDate);
        },
        showCartInfo: function showCartInfo(val) {
            if (!val) {
                this.nowSelMobile = "";
                this.nowSelName = "";
                this.nowExcInfo = {};
            }
        }
    },
    methods: {
        getSettleInfo: function getSettleInfo(nowDate) {
            var _this = this;

            this.$http({
                url: "get-online",
                method: "GET",
                params: {
                    time: nowDate + '-09 00:00:00',
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                console.log(res);
                if (res.data.code == 200) {
                    _this.nowSettleInfo = res.data.data;
                } else {
                    _this.$message({
                        message: "暂无数据",
                        customClass: 'error'
                    });
                    return;
                }
            });
        },
        getEmps: function getEmps() {
            var _this2 = this;

            this.$http({
                url: "employees",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    enabled: true
                }
            }).then(function (res) {
                _this2.emps = res.data;
            });
        },
        showExcInfo: function showExcInfo(item) {
            var _this3 = this;

            var beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
            var endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
            this.nowSelMobile = item.mobile;
            this.nowSelName = item.name;
            this.$http({
                url: "workshift/choose/details",
                method: "GET",
                params: {
                    mobile: item.mobile,
                    begin: beginTime,
                    end: endTime,
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                // if(res.data.code == 200){
                _this3.nowExcInfo = res.data;
                setTimeout(function () {
                    _this3.showCartInfo = true;
                }, 300);
                // }
            });
        },
        doSearch: function doSearch() {
            if (this.canClick) {
                this.canClick = false;
                this.getChargeInfo(0, this.dateStr);
            }
        },

        //分页方法
        handleCurrentChange: function handleCurrentChange(val) {
            console.log('\u5F53\u524D\u9875: ' + val);
            console.log(this.dateStr);
            this.getChargeInfo(val - 1, this.dateStr, "MONTH");
            // if(this.nowType == "MONTH"){
            //     this.getChargeInfo(val - 1, this.dateStr,"MONTH");
            // }else{
            //     this.getChargeInfo(val - 1, this.dateStr,"ARB");
            // }
        },

        // 搜索
        searchConfirm: function searchConfirm() {
            if (new Date(this.endTime).getTime() - new Date(this.startTime).getTime() > 1000 * 60 * 60 * 24 * 35) {
                this.$message({
                    message: '只能查询35天内的数据',
                    customClass: 'error'
                });
                return;
            }

            if (this.startTime !== '' && this.endTime !== '') {
                if (new Date(this.startTime) > new Date(this.endTime)) {
                    this.$message({
                        message: '结束时间不能比开始时间小',
                        customClass: 'error'
                    });
                    return;
                }
                if (new Date(this.startTime).getTime() > new Date(this.lastExTime).getTime() || new Date(this.endTime).getTime() > new Date(this.lastExTime).getTime()) {
                    this.$message({
                        message: '当前选择时间无交班信息',
                        customClass: 'error'
                    });
                    return;
                }
                if (this.canClick) {
                    this.canClick = false;
                    this.getChargeInfo(0, this.dateStr, "ARB");
                }
            } else {
                this.$message({
                    message: '请选择查询时间段',
                    customClass: 'error'
                });
                return;
            }
        },
        // 获取核销详情
        getChargeInfo: function getChargeInfo(page, date) {
            var _this4 = this;

            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "MONTH";

            var params = void 0;
            // if(this.empMobile){
            // if(!/^(\d){11}$/.test(this.searchPhone)){
            //     this.$message({
            //         message: '手机号输入有误',
            //         customClass: 'error'
            //     })
            //     setTimeout(()=>{
            //         this.canClick = true;
            //     },500);
            //     return;
            // }
            var beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
            var endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
            if (!this.startTime || this.startTime == "" || !this.endTime || this.endTime == "") {
                this.$message({
                    message: '请选择时间',
                    customClass: 'error'
                });
                this.canClick = true;
                return;
            }
            params = {
                storeId: this.curStoreId,
                begin: beginTime,
                end: endTime
                // openMobile:this.empMobile

                // }else{
                //     let beginTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                //     let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                //     params = {
                //         storeId:this.curStoreId,
                //         beginTime,
                //         endTime,
                //         openMobile:"ALL"
                //     }
                // }


            };this.$http({
                url: "get-emp",
                method: "GET",
                params: params
            }).then(function (res) {
                setTimeout(function () {
                    _this4.canClick = true;
                }, 500);
                console.log(res.data);
                // return;
                var body = res.data;
                // if(body.code == 200){
                _this4.exchangeList = body;
                // this.totalChargeCount = body.data.totalCount;
                // this.totalChargeAmount = body.data.totalAmount;
                // this.totalBonusAmount = body.data.totalBonusAmount;
                var number = _this4.pageSize - _this4.exchangeList.length;
                // this.totalElements = body.data.totalElements;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this4.exchangeList.push({
                            amount: "",
                            mobile: "",
                            name: ""
                        });
                    }
                }
                // }else{
                //     this.$message({
                //         message: body.msg,
                //         customClass: 'error'
                //     });
                // }
            }).catch(function (err) {
                setTimeout(function () {
                    _this4.canClick = true;
                }, 500);
            });
        },
        getLastExTime: function getLastExTime() {
            var _this5 = this;

            this.$http({
                url: "get-endTime",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                var date = new Date(res.data);
                var time = date.Format("yyyy-MM-dd");
                _this5.startTime = time + " 00:00:00";
                _this5.endTime = date.Format("yyyy-MM-dd hh:mm:ss");
                _this5.lastExTime = res.data;
                // this.pickerOptions = {
                //     disabledDate(time) {
                //         return time.getTime() > new Date(res.data);
                //     }
                // }
            });
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.exchangeList.push({
                workShift: {
                    closeUsername: "",
                    beginTime: "",
                    endTime: "",
                    total: 0
                }
            });
        }
        // 获取员工列表
    },
    mounted: function mounted() {
        this.getLastExTime();
    },

    activated: function activated() {
        this.getEmps();
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            valueForMonth: "",
            vipList: [],
            showVipList: false,
            nowSelVip: { id: "" },
            searchPhone: "", //会员搜索手机号
            pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            pickerOptionsForTimeRange: {
                disabledDate: function disabledDate(time) {

                    //    let date = (new Date(time));
                    // //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
                    // //    let newDate = new Date(dateStr).getTime();
                    // //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
                    // //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
                    //     let curDate = (new Date()).getTime();
                    //     let three = 30 * 24 * 3600 * 1000;
                    //     let threeDays = curDate - three;
                    //     return time.getTime() > Date.now() || time.getTime() < threeDays;
                }
            },
            nowDay: '', //当前日期
            searchByWhichType: "dayOrMonth", //按照时间段或者是日月报的形式查询，dayOrMonth,timeRange
            curSelItem: {},
            endTimeForThisItem: "",
            showModify: false,
            statusData: {
                0: '正常',
                1: '核销',
                2: '过期'
            },
            memberPhone: "",
            depositList: [], // 核销详情
            depositListForBar: [],
            nowType: "STOCK",
            startTime: '', //按时间段查询的起始时间
            endTime: '', //按时间段查询的结束时间
            pickerOptions: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            dateStr: new Date().Format("yyyy-MM-dd"),
            currentPage: 1,
            totalElements: 0, //数据总条数
            canClick: true,
            totalInfo: {},
            totalInfoForBar: {}
        };
    },

    watch: {
        dateStr: function dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM-dd"));
            var nowDate = new Date(val).Format("yyyy-MM-dd");
            this.dateStr = nowDate;
            this.getrDepositList(0, "");
        },
        showModify: function showModify(val) {
            if (!val) {
                this.curSelItem = {};
                this.endTimeForThisItem = "";
            }
        },
        memberPhone: function memberPhone(val) {
            console.log(val);
            if (val == this.nowSelVip.mobile) {
                this.showVipList = false;
                return;
            }
            if (val == "") {
                this.showVipList = false;
                this.nowSelVip = { id: "" };
                return;
            }
            this.getVipList(val);
        }
    },
    methods: {
        excel: function excel() {
            var data = this.nowType == "STOCK" ? this.depositList : this.depositListForBar;
            console.log(data);
            // return;
            var html = void 0;
            if (this.nowType == "STOCK") {
                html = '<tr>' + '<td style="font-size:18px">商品名称</td>' + '<td style="font-size:18px">上月余存</td>' + '<td style="font-size:18px">采购入库</td>' + '<td style="font-size:18px">盘点入库</td>' + '<td style="font-size:18px">调拨入库</td>' + '<td style="font-size:18px">吧台退回</td>' + '<td style="font-size:18px">出货至吧台</td>' + '<td style="font-size:18px">盘点出库</td>' + '<td style="font-size:18px">退货出库</td>' + '<td style="font-size:18px">调拨出库</td>' + '<td style="font-size:18px">本月余存</td>' + '<td style="font-size:18px">剩余价值</td>' + '</tr>';
            } else {
                html = '<tr>' + '<td style="font-size:18px">商品名称</td>' + '<td style="font-size:18px">上月余存</td>' + '<td style="font-size:18px">吧台上架</td>' + '<td style="font-size:18px">仓库至吧台</td>' + '<td style="font-size:18px">盘点入库</td>' + '<td style="font-size:18px">退单入库</td>' + '<td style="font-size:18px">销售出库</td>' + '<td style="font-size:18px">吧台下架</td>' + '<td style="font-size:18px">吧台退回仓库</td>' + '<td style="font-size:18px">盘点出库</td>' + '<td style="font-size:18px">本月余存</td>' + '<td style="font-size:18px">剩余价值</td>' + '</tr>';
            }
            if (this.nowType == "STOCK") {
                for (var i = 0; i < data.length; i++) {
                    if (!data[i].skuName) {
                        continue;
                    }
                    html += '<tr>' + '<td>' + data[i].skuName + '</td>' + '<td>' + data[i].lastQty + '</td>' + '<td>' + data[i].purchaseInQty + '</td>' + '<td>' + data[i].checkInQty + '</td>' + '<td>' + data[i].allocationInQty + '</td>' + '<td>' + data[i].barInQty + '</td>' + '<td>' + data[i].innerOutQty + '</td>' + '<td>' + data[i].checkoutQty + '</td>' + '<td>' + data[i].refundOutQty + '</td>' + '<td>' + data[i].allocationOutQty + '</td>' + '<td>' + data[i].nowQty + '</td>' + '<td>' + data[i].value + '</td>' + '</tr>';
                }
            } else {
                for (var _i = 0; _i < data.length; _i++) {
                    if (!data[_i].skuName) {
                        continue;
                    }
                    html += '<tr>' + '<td>' + data[_i].skuName + '</td>' + '<td>' + data[_i].lastQty + '</td>' + '<td>' + data[_i].innerInQty + '</td>' + '<td>' + data[_i].stockInnerInQty + '</td>' + '<td>' + data[_i].checkInQty + '</td>' + '<td>' + data[_i].refundInQty + '</td>' + '<td>' + data[_i].salesOutQty + '</td>' + '<td>' + data[_i].innerOutQty + '</td>' + '<td>' + data[_i].barOutQty + '</td>' + '<td>' + data[_i].checkoutQty + '</td>' + '<td>' + data[_i].nowQty + '</td>' + '<td>' + data[_i].value + '</td>' + '</tr>';
                }
            }

            if (this.nowType == "STOCK") {
                html += '<tr>' + '<td> </td>' + '<td> </td>' + '<td> </td>' + '<td> </td>' + '<td> </td>' + '<td>总库存剩余数:' + this.totalInfo.totalCount + '</td>' + '<td>总库存价值:' + this.totalInfo.totalMoney + '</td>' + '</tr>';
            } else {
                html += '<tr>' + '<td> </td>' + '<td> </td>' + '<td> </td>' + '<td> </td>' + '<td> </td>' + '<td>总库存剩余数:' + this.totalInfoForBar.totalCount + '</td>' + '<td>总库存价值:' + this.totalInfoForBar.totalMoney + '</td>' + '</tr>';
            }
            document.getElementById('scrollBox').innerHTML = html;
            window.method5(scrollBox);
        },
        selNowVip: function selNowVip(item) {
            this.nowSelVip = item;
            this.memberPhone = item.mobile;
            this.vipList = [];
        },
        getVipList: function getVipList(val) {
            var _this = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["a" /* BASE_URL */] + "/v1/pos/members",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    q: val
                }
            }).then(function (res) {
                _this.vipList = res.data;
                _this.showVipList = true;
            });
        },
        modifyThisItem: function modifyThisItem() {
            var _this2 = this;

            if (!this.endTimeForThisItem || this.endTimeForThisItem == "") {
                this.$message({
                    message: '请选择到期时间',
                    customClass: 'error'
                });
                return;
            }
            this.$http({
                url: "update-postage",
                method: "POST",
                data: {
                    id: this.curSelItem.id,
                    endTime: new Date(this.endTimeForThisItem).Format("yyyy-MM-dd hh:mm:ss")
                }
            }).then(function (res) {
                if (res.data.code == 200) {
                    _this2.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    _this2.showModify = false;
                    _this2.currentPage = 1;
                    if (_this2.memberPhone != "") {
                        _this2.search();
                        return;
                    }
                    // this.getrDepositList(0,"");
                    var date = new Date(_this2.nowDay).Format("yyyy-MM-dd");
                    var dateForMonth = new Date(_this2.valueForMonth).Format("yyyy-MM");
                    if (_this2.searchByWhichType === "dayOrMonth") {
                        if (_this2.nowType == 'BAR') {
                            if (!_this2.valueForMonth) {
                                _this2.$message({
                                    message: '请选择查询时间',
                                    customClass: 'error'
                                });
                                return;
                            }
                            if (dateForMonth) {
                                _this2.getrDepositList(0, dateForMonth, "MONTH", _this2.memberPhone);
                                // this.getWordData();
                                // this.getSales();
                            } else {
                                _this2.$message({
                                    message: '请选择查询时间',
                                    customClass: 'error'
                                });
                            }
                        } else {
                            if (!_this2.nowDay) {
                                _this2.$message({
                                    message: '请选择查询时间',
                                    customClass: 'error'
                                });
                                return;
                            }
                            if (date) {
                                _this2.getrDepositList(0, date, "STOCK", _this2.memberPhone);
                                // this.getWordData();
                                // this.getSales();
                            } else {
                                _this2.$message({
                                    message: '请选择查询时间',
                                    customClass: 'error'
                                });
                            }
                        }
                    } else {
                        if (_this2.startTime !== '' && _this2.endTime !== '') {
                            if (new Date(_this2.startTime) > new Date(_this2.endTime)) {
                                _this2.$message({
                                    message: '结束时间不能比开始时间小',
                                    customClass: 'error'
                                });
                                return;
                            }
                            var days = 1000 * 60 * 60 * 24 * 45;
                            if (new Date(_this2.endTime) - new Date(_this2.startTime) > days) {
                                _this2.$message({
                                    message: '查询时间段最多45天',
                                    customClass: 'error'
                                });
                                return;
                            }
                            //起止时间
                            var startTime = new Date(_this2.startTime).Format("yyyy-MM-dd hh:mm:ss");
                            var endTime = new Date(_this2.endTime).Format("yyyy-MM-dd hh:mm:ss");
                            _this2.getrDepositList(0, { startTime: startTime, endTime: endTime }, "ELSE", _this2.memberPhone);
                        } else {
                            _this2.$message({
                                message: '请选择查询时间段',
                                customClass: 'error'
                            });
                            return;
                        }
                    }
                    return;
                } else if (res.data.code == 400) {
                    _this2.$message({
                        message: res.data.msg,
                        customClass: 'error'
                    });
                    return;
                }
            });
        },
        modify: function modify(item) {
            this.curSelItem = item;
            this.showModify = true;
        },
        search: function search() {
            if (this.memberPhone == "") {
                this.getrDepositList(0, "");
                return;
            }
            if (!/^\d{11}$/.test(this.memberPhone)) {
                this.$message({
                    message: '手机号输入有误',
                    customClass: 'error'
                });
                return;
            }
            this.getrDepositList(0, this.memberPhone);
        },

        //分页方法
        handleCurrentChange: function handleCurrentChange(val) {
            if (this.memberPhone != "" && !/^\d{11}$/.test(this.memberPhone)) {
                this.$message({
                    message: '手机号输入有误',
                    customClass: 'error'
                });
                return;
            }
            console.log('\u5F53\u524D\u9875: ' + val);
            console.log(this.dateStr);
            this.searchConfirm(val - 1);
        },

        // 搜索
        searchConfirm: function searchConfirm(page) {
            if (this.memberPhone != "" && !/^\d{11}$/.test(this.memberPhone)) {
                this.$message({
                    message: '手机号输入有误',
                    customClass: 'error'
                });
                return;
            }

            var date = new Date(this.nowDay).Format("yyyy-MM-dd");
            var dateForMonth = new Date(this.valueForMonth).Format("yyyy-MM");
            // 
            // let timeStr = new Date(date).getTime() + "-" + new Date(date).getTime();
            // let nowTime = new Date().getTime();
            // if(!(this.$canClickSelect("depositData",timeStr,nowTime))){
            //     this.$message({
            //         message: '5秒内禁止重复查询数据',
            //         customClass: 'error'
            //     });
            //     return;
            // }
            //

            if (this.searchByWhichType === "dayOrMonth") {
                if (this.nowType == 'BAR') {
                    if (!this.valueForMonth) {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                        return;
                    }
                    if (dateForMonth) {
                        this.getrDepositList(page, dateForMonth, "MONTH", this.memberPhone);
                        // this.getWordData();
                        // this.getSales();
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                    }
                } else {
                    if (!this.nowDay) {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                        return;
                    }
                    if (date) {
                        this.getrDepositList(page, date, "STOCK", this.memberPhone);
                        // this.getWordData();
                        // this.getSales();
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                    }
                }
            } else {
                if (this.startTime !== '' && this.endTime !== '') {
                    if (new Date(this.startTime) > new Date(this.endTime)) {
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        });
                        return;
                    }
                    var days = 1000 * 60 * 60 * 24 * 45;
                    if (new Date(this.endTime) - new Date(this.startTime) > days) {
                        this.$message({
                            message: '查询时间段最多45天',
                            customClass: 'error'
                        });
                        return;
                    }
                    //起止时间
                    var startTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    var endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    this.getrDepositList(page, { startTime: startTime, endTime: endTime }, "ELSE", this.memberPhone);
                } else {
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    });
                    return;
                }
            }
        },
        lastTime: function lastTime(year, month) {
            if (String(month).length <= 1) {
                month = "0" + month;
            }
            var day = new Date(year, month, 0);
            var lastdate = year + "-" + month + "-" + day.getDate();
            var lastTime = lastdate + " 23:59:59";
            // return new Date(lastTime).getTime() / 1000;
            return lastTime;
        },

        // 获取核销详情
        getrDepositList: function getrDepositList(page, date, source, mobile) {
            var _this3 = this;

            // let params;
            // if(type == "STOCK"){
            //     params = {
            //         storeId:this.curStoreId,
            //         time:date,
            //         type,
            //         page,
            //         size: this.pageSize,
            //     }
            // }else{
            //     let begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
            //     let end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
            //     params = {
            //         storeId:this.curStoreId,
            //         begin,
            //         end,
            //         type,
            //         page,
            //         size: this.pageSize,
            //     }
            // }
            var params = void 0;
            if (this.searchByWhichType === "dayOrMonth") {
                if (source == "STOCK") {
                    params = {
                        storeId: this.curStoreId,
                        time: date,
                        source: source,
                        mobile: mobile,
                        page: page,
                        size: this.pageSize
                    };
                } else {
                    var dateObj = new Date(date);
                    var _year = dateObj.getFullYear();
                    var _month = _year + '-' + (dateObj.getMonth() + 1);
                    params = {
                        storeId: this.curStoreId,
                        month: _month,
                        source: source,
                        mobile: mobile,
                        page: page,
                        size: this.pageSize
                    };
                }
            } else {
                var _dateObj = date;
                var _startTime = date.startTime;
                var _endTime = date.endTime;
                params = {
                    storeId: this.curStoreId,
                    from: _startTime,
                    to: _endTime,
                    source: source,
                    mobile: mobile,
                    page: page,
                    size: this.pageSize
                };
            }
            var startTime = new Date(this.valueForMonth).Format("yyyy-MM") + '-01 00:00:00';
            var year = new Date(this.valueForMonth).getFullYear();
            var month = new Date(this.valueForMonth).getMonth() + 1;
            var endTime = this.lastTime(year, month);
            var nowMoth = new Date().getMonth() + 1;
            var data = {
                storeId: this.curStoreId,
                beginTime: startTime,
                endTime: endTime,
                type: this.nowType == "STOCK" ? 2 : 1
                // type:nowMoth==month?0:1,
                // level:this.nowType=="STOCK"?"WAREHOUSE":"BAR"
            };
            console.log(data);
            if (!this.canClick) {
                return;
            }
            this.canClick = false;
            this.$http({
                url: "product/inv/count",
                method: "GET",
                params: data
            }).then(function (res) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
                var body = res.data;
                if (_this3.nowType == "STOCK") {
                    _this3.depositList = body;
                    var totalCount = 0;
                    var totalMoney = 0;
                    for (var i = 0; i < body.length; i++) {
                        totalCount += Number(body[i].nowQty);
                        totalMoney += Number(body[i].value);
                    }
                    _this3.totalInfo = {
                        totalCount: totalCount,
                        totalMoney: totalMoney
                    };
                } else {
                    _this3.depositListForBar = body;
                    var _totalCount = 0;
                    var _totalMoney = 0;
                    for (var _i2 = 0; _i2 < body.length; _i2++) {
                        _totalCount += Number(body[_i2].nowQty);
                        _totalMoney += Number(body[_i2].value);
                    }
                    _this3.totalInfoForBar = {
                        totalCount: _totalCount,
                        totalMoney: _totalMoney
                    };
                }
                var number = _this3.pageSize - body.length;
                // this.totalElements = body.totalElements;
                if (number > 0) {
                    for (var _i3 = 0; _i3 < number; _i3++) {
                        if (_this3.nowType == "STOCK") {
                            _this3.depositList.push({
                                id: '', // 员工id
                                name: '', // 员工姓名
                                code: '', // 编号
                                mobile: '', // 手机
                                groupName: '' // 岗位id
                            });
                        } else {
                            _this3.depositListForBar.push({
                                id: '', // 员工id
                                name: '', // 员工姓名
                                code: '', // 编号
                                mobile: '', // 手机
                                groupName: '' // 岗位id
                            });
                        }
                    }
                }
            }).catch(function (err) {
                setTimeout(function () {
                    _this3.canClick = true;
                }, 500);
            });
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.depositList.push({
                id: '', // 员工id
                name: '', // 员工姓名
                code: '', // 编号
                mobile: '', // 手机
                groupName: '' // 岗位id
            });
        }
        // this.getrDepositList(page,date,source,mobile);
    },
    activated: function activated() {
        this.nowDay = new Date();
        this.valueForMonth = new Date();

        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
        this.searchConfirm(0);
    }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "stockSummary",
    props: ['curStoreId'],
    data: function data() {
        return {
            nowMonth: new Date().Format("yyyy-MM"), //当前日期
            pickerOptions: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now() || time.getTime() < new Date("2017,01,01").getTime();
                }
            },
            num: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'], //月份string
            curMonth: parseInt(new Date().getMonth() + 1), //当前月份
            sumList: [], //汇总列表数据
            pageSize: 10, //每页数据大小
            nowPage: 0,
            sourceType: {
                PURCHASE_IN: '采购入库',
                ALLOCATION_IN: '调拨入库',
                CHECK_IN: '盘点入库',
                INNER_IN: '吧台到仓库',
                CHECK_OUT: '盘点出库',
                INNER_OUT: '仓库至吧台',
                REFUND_OUT: '退货出库',
                ALLOCATION_OUT: '调拨出库'
            },
            stockType: {
                STOCK_IN: "入库",
                STOCK_OUT: "出库"
            },
            totalElements: 0,
            totalAmount: 0, //总金额
            totalCount: 0 //总数量
        };
    },

    watch: {
        nowMonth: function nowMonth(val) {
            console.log(val);
            var date = new Date(val).Format("yyyy-MM");
            var year = date.split("-")[0];
            var month = date.split("-")[1];
            this.getStockSumList(year, month, 0);
            this.getTotalInfo(year, month);
        }
    },
    methods: {
        //   更改当前日期
        changeMonth: function changeMonth(changeType) {
            console.log(this.nowMonth);
            this.nowMonth = new Date(this.nowMonth).Format("yyyy-MM"); //给日期插件赋值为选择时间
            var year = this.nowMonth.split('-')[0]; //选择的年
            var month = this.nowMonth.split('-')[1]; //选则的月
            if (changeType === "last") {
                //上月
                if (new Date('2017,01,01').Format("yyyy-MM") == new Date(this.nowMonth).Format("yyyy-MM")) {
                    this.$message({
                        message: '不能选择2017年以前的时间!',
                        customClass: 'error'
                    });
                    return;
                }
                this.curMonth--;
                if (this.curMonth == 0) {
                    year = parseInt(year) - 1;
                    this.curMonth = 12;
                }
            } else if (changeType === "next") {
                //下月
                if (new Date().Format("yyyy-MM") == new Date(this.nowMonth).Format("yyyy-MM")) {
                    this.$message({
                        message: '已经是最新一个月了！',
                        customClass: 'error'
                    });
                    return;
                }
                this.curMonth++;
                if (this.curMonth == 13) {
                    year = parseInt(year) + 1;
                    this.curMonth = 1;
                }
            }
            this.nowMonth = year + '-' + this.num[parseInt(this.curMonth) - 1];
        },

        // 获取列表数据
        getStockSumList: function getStockSumList(year, month, page) {
            var _this = this;

            this.$http({
                url: "get-stockList",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    year: year,
                    month: month,
                    page: page,
                    size: this.pageSize
                }
            }).then(function (res) {
                console.log(res);
                _this.totalElements = res.data.totalElements;
                _this.sumList = res.data.content;
            });
        },

        // 获取总计信息
        getTotalInfo: function getTotalInfo(year, month) {
            var _this2 = this;

            this.$http({
                url: "get-Statistics",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    year: year,
                    month: month
                }
            }).then(function (res) {
                console.log(res);
                if (_this2.totalAmount == null) {
                    _this2.totalAmount = 0;
                } else {
                    _this2.totalAmount = res.data.amount;
                }
                if (res.data.count == null) {
                    _this2.totalCount = 0;
                } else {
                    _this2.totalCount = res.data.count;
                }
            });
        },
        handleCurrentChange: function handleCurrentChange(page) {
            console.log(page);
            var date = new Date(this.nowMonth).Format("yyyy-MM");
            var year = date.split("-")[0];
            var month = date.split("-")[1];
            this.getStockSumList(year, month, page - 1);
        },

        // 导出Excel
        excel: function excel() {
            var _this3 = this;

            console.log(this.nowMonth);
            var date = new Date(this.nowMonth).Format("yyyy-MM");
            var year = date.split("-")[0];
            var month = date.split("-")[1];
            var sumData = void 0;
            this.$http({
                url: "get-stockList",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    year: year,
                    month: month,
                    page: 0,
                    size: 100000
                }
            }).then(function (res) {
                sumData = res.data.content;
                if (!sumData) {
                    _this3.$message({
                        message: '无数据可导出',
                        customClass: 'error'
                    });
                    return;
                }
                var data = sumData;
                var num = 0,
                    price = 0;
                var html = '<tr>' + '<td style="font-size:18px">名称</td>' + '<td style="font-size:18px">件数</td>' + '<td style="font-size:18px">类型</td>' + '<td style="font-size:18px">原因</td>' + '<td style="font-size:18px">备注</td>' + '<td style="font-size:18px">时间</td>' + '<td style="font-size:18px">操作人员</td>' + '</tr>';
                for (var i = 0; i < data.length; i++) {
                    if (!data[i].skuName) {
                        continue;
                    }
                    var _date = new Date(data[i].addTime);
                    var _year = _date.getFullYear();
                    var _month = _date.getMonth() + 1 > 9 ? _date.getMonth() + 1 : "0" + (_date.getMonth() + 1);
                    var day = _date.getDate() > 9 ? _date.getDate() : "0" + _date.getDate();
                    var hours = _date.getHours();
                    var minutes = _date.getMinutes() > 9 ? _date.getMinutes() : "0" + _date.getMinutes();
                    var seconds = _date.getSeconds() > 9 ? _date.getSeconds() : "0" + _date.getSeconds();
                    var addTime = _year + "-" + _month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
                    html += '<tr>' + '<td>' + data[i].skuName + '</td>' + '<td>' + data[i].quantity + '</td>' + '<td>' + _this3.stockType[data[i].type] + '</td>' + '<td>' + _this3.sourceType[data[i].source] + '</td>' + '<td>' + data[i].notes + '</td>' + '<td>' + addTime + '</td>' + '<td>' + data[i].operatorName + '</td>' + '</tr>';
                }
                html += '<tr style="font-size:18px;color:red;">' + '<td></td>' + '<td></td>' + '<td></td>' + '<td>总金额：' + Number(_this3.totalAmount).toFixed(2) + '</td>' + '<td></td>' + '<td>总数量：' + _this3.totalCount + '</td>' + '<td></td>' + '</tr>';
                document.getElementById('sum').innerHTML = html;
                window.method5(sum);
            });
        }
    },
    activated: function activated() {
        var year = this.nowMonth.split("-")[0];
        var month = this.nowMonth.split("-")[1];
        this.getStockSumList(year, month, 0);
        this.getTotalInfo(year, month);
    }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            channelInfo: null,
            orderSource: "ALL",
            orderSourceOptions: [{
                label: "全部",
                value: "ALL"
            }, {
                label: "收银端",
                value: "POS"
            }, {
                label: "店员宝",
                value: "EMPLOYEE"
            }, {
                label: "微信点单",
                value: "WEIXIN"
            }, {
                label: "客户端点单",
                value: "WEB"
            }],
            nowSelFilter: "today",
            isSelAll: true,
            selType: [],
            showType: false,
            rangeTime: [], //时间段的值
            isUseRangeTime: false, //是否使用时间段
            workDataForTimeRange: [],
            allAmountForTimeRange: 0,
            allQtyForTimeRange: 0,
            startTime: '', //开始时间
            endTime: '', //结束时间
            nowTimeRange: "",
            searchByWhichType: "timeRange", //按照时间段或者是日月报的形式查询，dayOrMonth,timeRange
            valueForMonth: '', //月份信息
            workDataForMonth: [], //月报数据
            allAmountForMonth: 0, //月报总金额
            allAmount: 0, //总金额
            allQtyForMonth: 0, //月报总数量
            allQty: 0, //总数量
            nowDay: '', //当前日期
            nowType: "day", //当前查询方式，如日报，月报
            workData: [],
            workCalculateData: {
                amount: 0,
                quantity: 0
            },
            getBtn: true, // 控制翻页请求
            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            pickerOptionsForTimeRange: {
                disabledDate: function disabledDate(time) {

                    //    let date = (new Date(time));
                    // //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
                    // //    let newDate = new Date(dateStr).getTime();
                    // //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
                    // //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
                    //     let curDate = (new Date()).getTime();
                    //     let three = 30 * 24 * 3600 * 1000;
                    //     let threeDays = curDate - three;
                    //     return time.getTime() > Date.now() || time.getTime() < threeDays;
                }
            },
            pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            salesData: {
                turnInAmount: 0,
                cashAmount: 0,
                wechatAmount: 0,
                alipayAmount: 0,
                memberAmount: 0,
                couponAmount: 0,
                wechatCashAmount: 0,
                alipayCashAmount: 0
            }, //销售数据

            typeList: [{
                name: '全部',
                id: ''
            }], // 分类

            timeFrom: '', //开始时间
            timeTo: '', //截止时间
            typeId: ['ALL'], // 分类id
            goodId: '', // 商品id
            searchKeywords: '', // 搜索关键字
            searchList: [], // 搜索结果数组
            goodSearchBtn: true, // 控制搜索框
            canSearch: true, //
            options: []
        };
    },

    watch: {
        selType: function selType(val) {
            console.log(val);
            if (val.length == this.options.length) {
                this.isSelAll = true;
            } else {
                this.isSelAll = false;
            }
        },
        isUseRangeTime: function isUseRangeTime(val) {
            this.startTime = '';
            this.endTime = '';
        },

        searchKeywords: function searchKeywords(val) {
            if (this.canSearch) {
                this.goodSearch();
            } else {
                this.canSearch = true;
            }
        },
        endTime: function endTime(val) {
            console.log(val);
            var days = 1000 * 60 * 60 * 24 * 45;
            if (this.startTime !== "") {
                if (new Date(val) - new Date(this.startTime) > days) {
                    this.$message({
                        message: '查询时间段最多45天',
                        customClass: 'error'
                    });
                }
            } else {
                this.$message({
                    message: '请选择起始时间',
                    customClass: 'error'
                });
            }

            //    let dateStrForNextMonth = date.getFullYear()+'-'+(date.getMonth()+2)+'-'+'00';
            //    console.log(dateStrForNextMonth)
            //    let newDateForNextMonth = new Date(2018,11,0).getTime();
            //    let date = new Date(newDateForNextMonth);
            //    console.log(date.getDate())
        }
    },
    methods: {
        filter: function filter(type) {
            var timeRangeArr = [];
            this.nowSelFilter = type;
            switch (type) {
                case "today":
                    // this.yearMonth = new Date().Format("yyyy-MM");
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    // let year = new Date().Format("yyyy");
                    // let month = new Date().Format("MM");
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastDay":
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 00:00:00';
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "week":
                    timeRangeArr = this.$dateRange.getThisWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastWeek":
                    timeRangeArr = this.$dateRange.getLastWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "month":
                    timeRangeArr = this.$dateRange.getThisMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastMonth":
                    timeRangeArr = this.$dateRange.getLastMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                default:
                    break;
            }
        },
        selAll: function selAll() {
            this.isSelAll = !this.isSelAll;
            if (this.isSelAll) {
                var selType = [];
                for (var i = 0; i < this.options.length; i++) {
                    selType.push(this.options[i].value);
                }
                this.selType = selType;
            } else {
                this.selType = [];
            }
        },

        selGood: function selGood(item) {
            this.canSearch = false;
            this.searchKeywords = item.name;
            this.goodId = item.id;
            this.searchList = [];
        },
        // 商品检索
        goodSearch: function goodSearch() {
            var _this = this;

            var val = this.searchKeywords;
            if (!val) {
                this.searchList = [];
                return;
            }
            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http.get('products/search?storeId=' + this.curStoreId + '&q=' + encodeURI(val)).then(function (res) {
                _this.searchList = res.data;
                for (var i = 0, len = _this.searchList.length; i < len; i++) {
                    if (_this.searchKeywords == _this.searchList[i].name) {
                        _this.goodId = _this.searchList[i].id;
                        break;
                    } else {
                        _this.goodId = '';
                    }
                }
                _this.goodSearchBtn = true;
            }).catch(function () {
                _this.goodSearchBtn = true;
            });
        },
        // 搜索
        searchConfirm: function searchConfirm() {
            var date = new Date(this.nowDay).Format("yyyy-MM-dd");
            var dateForMonth = new Date(this.valueForMonth).Format("yyyy-MM");

            //分类形式
            // let type = this.typeId[0];
            if (this.selType.length == 0) {
                this.$message({
                    message: '请选择分类',
                    customClass: 'error'
                });
                return;
            }
            var type = this.selType.join(",");
            console.log(type);
            // return;
            if (this.searchByWhichType === "dayOrMonth") {
                if (this.nowType == 'month') {
                    if (dateForMonth) {
                        this.getSalesCount(dateForMonth, type, "MONTH");
                        // this.getWordData();
                        // this.getSales();
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                    }
                } else {
                    if (date) {
                        this.getSalesCount(date, type, "DAY");
                        // this.getWordData();
                        // this.getSales();
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        });
                    }
                }
            } else {
                if (this.startTime !== '' && this.endTime !== '') {
                    if (new Date(this.startTime) > new Date(this.endTime)) {
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        });
                        return;
                    }
                    if (this.isUseRangeTime) {
                        if (!this.rangeTime || this.rangeTime.length < 2) {
                            this.$message({
                                message: '请选择每一天的时间段',
                                customClass: 'error'
                            });
                            return;
                        }
                        // let fromSecond = new Date(this.rangeTime[0]).getTime();
                        // let toSecond = new Date(this.rangeTime[1]).getTime();
                        // if(fromSecond>toSecond){
                        //     this.$message({
                        //         message: '起始时间应该小于截止时间',
                        //         customClass: 'error'
                        //     })
                        //     return;
                        // }
                    }
                    // if((new Date(this.startTime).getMonth()+1)!==(new Date(this.endTime).getMonth()+1)){
                    //     this.$message({
                    //         message: '只能选择所选月份内的时间段，不可跨月查询。',
                    //         customClass: 'error'
                    //     })
                    //     return;
                    // }
                    var days = 1000 * 60 * 60 * 24 * 45;
                    if (new Date(this.endTime) - new Date(this.startTime) > days) {
                        this.$message({
                            message: '查询时间段最多45天',
                            customClass: 'error'
                        });
                        return;
                    }
                    //起止时间
                    var startTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    var endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    if (this.isUseRangeTime) {
                        startTime = new Date(this.startTime).Format("yyyy-MM-dd") + " 00:00:00";
                        endTime = new Date(this.endTime).Format("yyyy-MM-dd") + " 23:59:59";
                    }
                    this.getSalesCount({ startTime: startTime, endTime: endTime }, type, "timeRange");
                } else {
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    });
                    return;
                }
            }

            // if(this.timeTo&&this.timeFrom){
            //     if(new Date(this.timeFrom)>new Date(this.timeTo)){
            //         this.$message({
            //             message: '结束时间不能比开始时间小',
            //             customClass: 'error'
            //         })
            //         return;
            //     }
            //     this.getWordData();
            //     this.getSales();
            // } else {
            //     this.$message({
            //         message: '请选择查询时间段',
            //         customClass: 'error'
            //     })
            // }
        },
        getSalesCount: function getSalesCount(date, type, source) {
            var _this2 = this;

            var params = void 0;
            if (this.searchByWhichType === "dayOrMonth") {
                if (source == "DAY") {
                    params = {
                        storeId: this.curStoreId,
                        time: date,
                        type: type,
                        source: source
                        // 
                    };var timeStr = new Date(date).getTime() + "-" + type + "-" + new Date(date).getTime();
                    var nowTime = new Date().getTime();
                    if (!this.$canClickSelect("totalSalesDay", timeStr, nowTime)) {
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    // 
                } else {
                    var dateObj = new Date(date);
                    var year = dateObj.getFullYear();
                    var month = dateObj.getMonth() + 1;
                    params = {
                        storeId: this.curStoreId,
                        type: type,
                        year: year,
                        month: month,
                        source: source
                        // 
                    };var _timeStr = new Date(date).getTime() + "-" + type + "-" + new Date(date).getTime();
                    var _nowTime = new Date().getTime();
                    if (!this.$canClickSelect("totalSalesMonth", _timeStr, _nowTime)) {
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    //
                }
            } else {
                var _dateObj = date;
                var startTime = date.startTime;
                var endTime = date.endTime;
                var judge = this.isUseRangeTime;
                var fromSecond = 0;
                var toSecond = 0;
                var nowDate = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
                if (this.isUseRangeTime) {
                    fromSecond = parseInt((this.rangeTime[0] - nowDate) / 1000);
                    toSecond = parseInt((this.rangeTime[1] - nowDate) / 1000);
                }
                params = {
                    storeId: this.curStoreId,
                    type: type,
                    from: startTime,
                    to: endTime,
                    source: source,
                    judge: judge,
                    fromSecond: fromSecond,
                    toSecond: toSecond
                    // 
                };var _timeStr2 = new Date(startTime).getTime() + "-" + type + "-" + new Date(endTime).getTime();
                var _nowTime2 = new Date().getTime();
                if (!this.$canClickSelect("totalSalesTimeRange", _timeStr2, _nowTime2)) {
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                //
            }
            params["orderSource"] = this.orderSource;
            if (this.isSelAll) {
                params["typeAll"] = "ALL";
            } else {
                params["typeAll"] = "ELSE";
            }
            this.$http({
                url: "get-salesCount",
                method: "GET",
                params: params
            }).then(function (res) {
                console.log(res);
                _this2.channelInfo = res.data.channel;
                if (_this2.searchByWhichType === "dayOrMonth") {
                    if (source == "DAY") {
                        _this2.workData = res.data.data;
                        _this2.allAmount = res.data.allAmount;
                        _this2.allQty = res.data.allQty;
                    } else {
                        _this2.workDataForMonth = res.data.data;
                        _this2.allAmountForMonth = res.data.allAmount;
                        _this2.allQtyForMonth = res.data.allQty;
                    }
                } else {
                    _this2.workDataForTimeRange = res.data.data;
                    _this2.allAmountForTimeRange = res.data.allAmount;
                    _this2.allQtyForTimeRange = res.data.allQty;
                }
            });
        },

        //搜索条件
        conditionFn: function conditionFn() {
            // console.log(this.typeId);
            var URL = '';
            this.timeFrom ? URL += '?from=' + new Date(this.timeFrom).Format('yyyy-MM-dd hh:mm:ss') : '';
            this.timeTo ? URL += '&to=' + new Date(this.timeTo).Format('yyyy-MM-dd hh:mm:ss') : '';
            URL += '&productTypeId=' + this.typeId[this.typeId.length - 1] + '&productId=' + this.goodId;
            return URL;
        },

        //获取消费记录列表
        getWordData: function getWordData() {
            var _this3 = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.workCalculateData.amount = 0;
            this.workCalculateData.quantity = 0;
            var url = this.conditionFn();
            this.$http.get(this.curStoreId + '/product-sales' + url).then(function (res) {
                _this3.workData = res.data;
                if (_this3.workData.length < _this3.pageSize) {
                    for (var i = 0, len = _this3.pageSize - _this3.workData.length; i < len; i++) {
                        _this3.workData.push({});
                    }
                }
                for (var _i = 0, _len = _this3.workData.length; _i < _len; _i++) {
                    if (_this3.workData[_i].productId) {
                        _this3.workData[_i].single = (_this3.workData[_i].amount / _this3.workData[_i].quantity).toFixed(2);
                        _this3.workCalculateData.amount += _this3.workData[_i].amount;
                        _this3.workCalculateData.quantity += _this3.workData[_i].quantity;
                    }
                }
                _this3.getBtn = true;
                _this3.workCalculateData.amount = _this3.workCalculateData.toFixed(2);
                _this3.workCalculateData.quantity = _this3.workCalculateData.quantity.toFixed(2);
            }).catch(function () {
                _this3.getBtn = true;
            });
        },
        getSales: function getSales() {
            var _this4 = this;

            var url = this.conditionFn();
            this.$http.get(this.curStoreId + '/sales-total' + url).then(function (res) {
                _this4.salesData = res.data;
            });
        },

        //导出按钮
        excel: function excel() {
            var data = void 0,
                amount = void 0,
                qty = void 0;
            console.log(this.nowType);
            if (this.searchByWhichType === "dayOrMonth") {
                if (this.nowType == "day") {
                    console.log("执行了");
                    if (!this.workData[0].name) {
                        this.$message({
                            message: '无数据可导出',
                            customClass: 'error'
                        });
                        return;
                    }
                    data = this.workData;
                    amount = this.allAmount;
                    qty = this.allQty;
                } else {
                    if (!this.workDataForMonth[0].name) {
                        this.$message({
                            message: '无数据可导出',
                            customClass: 'error'
                        });
                        return;
                    }
                    data = this.workDataForMonth;
                    amount = this.allAmountForMonth;
                    qty = this.allQtyForMonth;
                }
            } else {
                if (!this.workDataForTimeRange[0].name) {
                    this.$message({
                        message: '无数据可导出',
                        customClass: 'error'
                    });
                    return;
                }
                data = this.workDataForTimeRange;
                amount = this.allAmountForTimeRange;
                qty = this.allQtyForTimeRange;
            }

            var num = 0,
                price = 0;
            var html = '<tr>' + '<td style="font-size:18px">商品名称</td>' + '<td style="font-size:18px">售价</td>' + '<td style="font-size:18px">数量</td>' + '<td style="font-size:18px">一级分类</td>' + '<td style="font-size:18px">二级名字</td>' + '<td style="font-size:18px">总计</td>' + '</tr>';
            for (var i = 0; i < data.length; i++) {
                if (!data[i].name) {
                    continue;
                }

                num += data[i].qty;
                price += data[i].amount;
                html += '<tr>' + '<td>' + data[i].name + '</td>' + '<td>' + data[i].salesPrice + '</td>' + '<td>' + data[i].qty + '</td>' + '<td>' + data[i].parentTypeName + '</td>' + '<td>' + data[i].typeName + '</td>' + '<td>' + data[i].amount + '</td>' + '</tr>';
            }
            html += '<tr>' + '<td style="font-size:16px">总金额</td>' + '<td></td>' + '<td></td>' + '<td>' + amount + '</td>' + '</tr>';
            if (this.channelInfo && this.channelInfo.memberAmount) {
                html += '<tr>' + '<td style="font-size:16px">总实收</td>' + '<td></td>' + '<td></td>' + '<td>' + Number(Number(amount) - Number(this.channelInfo.memberAmount)).toFixed(2) + '</td>' + '</tr>';
            }
            html += '<tr>' + '<td style="font-size:16px">总数量</td>' + '<td></td>' + '<td></td>' + '<td>' + qty + '</td>' + '</tr>';
            document.getElementById('scrollBox').innerHTML = html;
            window.method5(scrollBox);
        }
    },
    created: function created() {
        var _this5 = this;

        for (var i = 0; i < this.pageSize; i++) {}
        // this.workData.push({});


        //获取商品分类
        this.$http.get('/product-types-all?storeId=' + this.curStoreId + '&parentId=' + '').then(function (res) {
            _this5.typeList = _this5.typeList.concat(res.data);

            // this.options.push({label: '全部',value: 'ALL'});
            for (var i = 0; i < res.data.length; i++) {
                var obj = {
                    value: res.data[i].name,
                    label: res.data[i].name
                    // if(res.data[i].productTypeVos.length){
                    //     let son = res.data[i].productTypeVos;
                    //     let arr = [
                    //         {value:res.data[i].id,label:res.data[i].name}
                    //     ];
                    //     for (var j = 0; j < son.length; j++) {
                    //          let sonobj={
                    //             value:son[j].id,
                    //             label:"- "+son[j].name
                    //         }
                    //         arr.push(sonobj)
                    //     }
                    //     obj.children = arr;
                    // }
                };_this5.selType.push(res.data[i].name);
                _this5.options.push(obj);
            }
        });
    },
    mounted: function mounted() {
        this.nowDay = new Date();
        this.valueForMonth = new Date();
        // let date = new Date().Format("yyyy-MM-dd");
        // let dateForMonth = new Date().Format("yyyy-MM");
        // this.getSalesCount(date,"ALL");
        console.log(this.workData.length);
        this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
        var year = new Date().Format("yyyy");
        var month = new Date().Format("MM");
        this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
    }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_imgCrop_imgCrop_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_imgCrop_imgCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_imgCrop_imgCrop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__urlConfig_index_js__ = __webpack_require__(6);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    components: { imgCrop: __WEBPACK_IMPORTED_MODULE_2__components_imgCrop_imgCrop_vue___default.a },
    props: ['curStoreId', 'storeData', 'pageSize'],
    data: function data() {
        var _ref;

        return _ref = {
            returnCallEnabled: true,
            posCallEnabled: "ON",
            pcOrderEnabled: "OFF",
            voiceEnabled: "OFF",
            autoPrintEnabled: "OFF",
            globalRate: "",
            deliveryEnabled: false,
            frontMessage: "工作人员请注意,",
            backMessage: ",请及时清理桌面保持卫生",
            // 
            voiceNotify: false,
            dateOpen: false,
            timeArr: [],
            //
            allowProductCancelSale: true,
            upLoadImgType: "logo",
            summary: '',
            hotTitle: "",
            rollTitle: '',
            rollNotice: "",
            storeQrCode: "",
            logoUrl: "",
            showCrop: false, // 控制图片裁剪显示隐藏

            refundSwitch: "",
            isOpenPrevPrint: "OFF",
            notesArr: [{
                id: '',
                message: ''
            }],
            printEr: [{
                id: "",
                name: "",
                ipAddress: "",
                port: ""
            }],
            discountPwd: "",
            limitRechargeMoney: 0,
            storeType: [],
            newStore: {
                "name": "", // 店铺名称
                "typeId": "", // 店铺类型id
                "addr": "", // 店铺地址
                "referralCode": "" // 邀请码
            },
            initBtn1: true,
            clerkCashSales: '', // 店员宝现金支付开关
            initBtn2: true,
            stockLimitSales: '', // 库存开关
            initBtn3: true,
            initBtn9: true,
            customSwitch: '', //系统网费
            initBtn4: true,
            // clerkMember:'',//店员宝会员
            payModeSwitch: '', //收款方式
            infoload: false, // loading
            codeBtn: false,
            isCancle: false,
            memberEnabled: false,
            code: '', //验证码
            isSendCodeBtn: true,
            isSendCodeTimer: 59,

            isCASHIERBtn: false,

            couponSwitch: 'OFF', //是否给新增会员派发优惠券
            initBtn5: true,
            couponModel: '',
            curCouponData: { id: '' },
            couponListMoreBtn: false,
            couponList: [],
            curCouponPage: 0,
            coverImgMaxSize: 5 * 1024 * 1024, // 图片最大字节数
            oldImgBase64: '' }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showCrop', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'curCropW', 600), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'curCropH', 600), _ref;
    },

    watch: {
        refundSwitch: function refundSwitch(val) {
            console.log(val);
            if (this.initBtn9) {
                this.initBtn9 = false;
                return;
            }
            var refundSwitch = void 0;
            if (val == 'ON') {
                refundSwitch = true;
            } else if (val == 'OFF') {
                refundSwitch = false;
            }
            this.$http.get('/stores/refund-switch?refundSwitch=' + refundSwitch + '&storeId=' + this.curStoreId).then(function (res) {});
        },
        couponSwitch: function couponSwitch(val) {
            var _this = this;

            if (this.initBtn5) {
                this.initBtn5 = false;
                return;
            }
            if (val == 'ON') {
                this.curCouponPage = 0;
            } else if (val == 'OFF') {
                var body = {
                    storeId: this.curStoreId,
                    giveCouponId: ''
                };
                this.$http.post('stores-config', body).then(function (res) {
                    _this.curCouponData = {};
                    _this.couponModel = '';
                });
            }
        },
        couponModel: function couponModel(val) {
            this.curCouponData = JSON.parse(val);
        },
        clerkCashSales: function clerkCashSales(val) {
            var status = false;
            if (val == "OFF") {
                status = false;
            } else if (val == "ON") {
                status = true;
            }

            if (this.initBtn1) {
                this.initBtn1 = false;
                return;
            }
            this.$http.put('stores/' + this.curStoreId + '/cash-switch?switch=' + status).then(function (res) {}).catch(function () {});
        },
        stockLimitSales: function stockLimitSales(val) {
            var status = false;
            if (val == "OFF") {
                status = false;
            } else if (val == "ON") {
                status = true;
            }
            if (this.initBtn2) {
                this.initBtn2 = false;
                return;
            }
            this.$http.put('stores/' + this.curStoreId + '/stock-switch?switch=' + status).then(function (res) {}).catch(function () {});
        },
        customSwitch: function customSwitch(val) {
            var status = false;
            if (val == "OFF") {
                status = false;
            } else if (val == "ON") {
                status = true;
            }
            if (this.initBtn3) {
                this.initBtn3 = false;
                return;
            }
            this.$http.put('stores/' + this.curStoreId + '/product-switch?switch=' + status).then(function (res) {}).catch(function () {});
        }
    },
    methods: {
        saveReturnCallEnabled: function saveReturnCallEnabled() {
            var _this2 = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_3__urlConfig_index_js__["b" /* API_BASE_URL */] + 'v1/call/return/enabled',
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    returnCallEnabled: this.returnCallEnabled ? true : false
                }
            }).then(function (res) {
                _this2.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
            });
        },

        // 
        changePosCallEnabled: function changePosCallEnabled() {
            console.log("posCallEnabled", this.posCallEnabled);
            this.$http({
                url: "pos/call",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    posCallEnabled: this.posCallEnabled == "ON" ? true : false
                }
            }).then(function (res) {});
        },

        // 
        saveAutoPrint: function saveAutoPrint() {
            var _this3 = this;

            this.$http({
                url: "auto/print",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    autoPrintEnabled: this.autoPrintEnabled == "ON" ? true : false
                }
            }).then(function (res) {
                _this3.$message({
                    message: res.data,
                    customClass: 'success'
                });
            });
        },

        // 
        saveGlobalRate: function saveGlobalRate() {
            var _this4 = this;

            if (!/^(0|[1-9][0-9]{0,9})$/.test(this.globalRate)) {
                this.$message({
                    message: "请正确填写提成比例，比例为正整数",
                    customClass: 'error'
                });
                return;
            }
            if (this.globalRate < 0 || this.globalRate > 100) {
                this.$message({
                    message: "请正确填写提成比例，比例为正整数",
                    customClass: 'error'
                });
                return;
            }
            this.$http({
                url: "global/rate",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    globalRate: (this.globalRate / 100).toFixed(2)
                }
            }).then(function (res) {
                _this4.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
            });
        },

        // 
        saveMem: function saveMem() {
            var _this5 = this;

            this.$http({
                url: "member/enabled",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    memberEnabled: this.memberEnabled
                }
            }).then(function (res) {
                _this5.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
            });
        },
        saveDelivery: function saveDelivery() {
            var _this6 = this;

            this.$http({
                url: "delivery",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    deliveryEnabled: this.deliveryEnabled
                }
            }).then(function (res) {
                _this6.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                if (_this6.deliveryEnabled) {
                    _this6.saveGlobalRate();
                }
            });
        },

        // 
        saveAllowProductCancelSale: function saveAllowProductCancelSale() {
            var _this7 = this;

            this.$http({
                url: "allowProductCancelSale",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    allowProductCancelSale: this.allowProductCancelSale
                }
            }).then(function (res) {
                _this7.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
            });
        },
        saveCallInfo: function saveCallInfo() {
            var _this8 = this;

            this.$http({
                url: "setup-call",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    logo: this.logoUrl,
                    summary: this.summary,
                    title: this.hotTitle,
                    notice: this.rollNotice,
                    // qr_code:this.storeQrCode,
                    storeCodeImage: this.storeQrCode,
                    net_title: this.rollTitle
                }
            }).then(function (res) {
                _this8.$message({
                    message: res.data,
                    customClass: 'success'
                });
            });
        },

        // 获得裁剪后图片base64
        getCropImgBase: function getCropImgBase(imgUrl) {
            if (this.upLoadImgType == "logo") {
                this.logoUrl = imgUrl;
            } else {
                this.storeQrCode = imgUrl;
            }
        },
        coverImg: function coverImg(e, type) {
            this.upLoadImgType = type;
            var reader = new FileReader();
            var that = this;
            var fileObj = e.target.files[0];

            if (e.target.files.length == 0) {
                return false;
            }

            // 判断图片大小
            if (fileObj.size > this.coverImgMaxSize) {
                this.errorMsg = '上传图片的大小不能超过5MB';
                this.openErrorTip = true;
                this.$message({
                    message: '上传图片的大小不能超过5MB',
                    customClass: 'error'
                });
                return false;
            }

            reader.onload = function (file) {
                return function (e) {
                    var that2 = this; // 缓存当前this
                    var img = new Image();
                    img.src = this.result;
                    img.onload = function () {
                        var imgBase64 = that2.result; //获得图片的base64的数据
                        // 判断是否是移动端设备
                        var sUserAgent = navigator.userAgent.toLowerCase();
                        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
                        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                        var bIsAndroid = sUserAgent.match(/android/i) == "android";
                        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                            that.mobileUploadImg(imgBase64);
                        } else {
                            that.oldImgBase64 = imgBase64;
                            that.showCrop = true;
                        }
                    };
                    $('.pcImgFile').val('');
                    $('.mobileImgFile').val('');
                };
            }(e.target.files[0]);
            reader.readAsDataURL(e.target.files[0]);
        },
        // 
        savePcOrderEnabled: function savePcOrderEnabled() {
            var _this9 = this;

            this.$http({
                url: "pc/order",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    pcOrderEnabled: this.pcOrderEnabled == "ON" ? true : false
                }
            }).then(function (res) {
                _this9.$message({
                    message: res.data,
                    customClass: 'success'
                });
            });
        },

        // 
        saveIsOpenVoiceSel: function saveIsOpenVoiceSel() {
            var _this10 = this;

            this.$http({
                url: "voice",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    voiceEnabled: this.voiceEnabled == "ON" ? true : false
                }
            }).then(function (res) {
                _this10.$message({
                    message: res.data,
                    customClass: 'success'
                });
            });
        },

        // 
        saveIsOpenPrevPrint: function saveIsOpenPrevPrint() {
            var _this11 = this;

            this.$http({
                url: "pre-enabled",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    preEnabled: this.isOpenPrevPrint == "ON" ? true : false
                }
            }).then(function (res) {
                _this11.$message({
                    message: res.data,
                    customClass: 'success'
                });
            });
        },
        delPrintEr: function delPrintEr(item, index) {
            var _this12 = this;

            if (!item.id) {
                var printEr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.printEr));
                printEr.splice(index, 1);
                this.printEr = printEr;
                return;
            }
            this.$http({
                url: "delete-ip",
                method: "POST",
                data: {
                    id: item.id
                }
            }).then(function (res) {
                console.log(res);
                if (res.data.code == 200) {
                    _this12.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    _this12.getPrintIpInfo();
                    return;
                } else {
                    _this12.$message({
                        message: res.data.msg,
                        customClass: 'error'
                    });
                    return;
                }
            });
        },
        saveTime: function saveTime() {
            var _this13 = this;

            var timeArr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.timeArr));
            console.log(timeArr);
            if (timeArr && Array.isArray(timeArr)) {
                var minutes = [];
                var flag = false;
                timeArr.forEach(function (it) {
                    if (it.m < 0 || it.m == 0) {
                        flag = true;
                    }
                    minutes.push(it.m);
                });
                if (flag) {
                    this.$message({
                        message: "分钟数填写错误",
                        customClass: 'error'
                    });
                    return;
                }
                var message = "";
                if (this.voiceNotify) {
                    if (!String(this.frontMessage).trim() || !String(this.backMessage).trim()) {
                        this.$message({
                            message: "请正确填写下机播报内容",
                            customClass: 'error'
                        });
                        return;
                    }
                    var frontMessage = this.frontMessage.replace(/，/g, ",");
                    var backMessage = this.backMessage.replace(/，/g, ",");
                    message = frontMessage + '**\u53F7\u673A\u5DF2\u4E0B\u673A' + backMessage;
                }

                this.$http({
                    url: "store-region-config",
                    method: "POST",
                    data: {
                        storeId: this.curStoreId,
                        voiceNotify: this.voiceNotify,
                        dateOpen: this.dateOpen,
                        message: message,
                        minutes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(minutes)
                    }
                }).then(function (res) {
                    console.log(res);
                    _this13.$message({
                        message: "操作成功",
                        customClass: 'success'
                    });
                });
            }
        },
        getTime: function getTime() {
            var _this14 = this;

            this.$http({
                url: "store-region-config",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                console.log(res);
                _this14.voiceNotify = res.data.voiceNotify;
                _this14.dateOpen = res.data.dateOpen;
                if (res.data.message) {
                    var message = res.data.message.split("**号机已下机");
                    if (message && Array.isArray(message) && message.length > 1) {
                        _this14.frontMessage = message[0];
                        _this14.backMessage = message[1];
                    }
                }
                if (res.data.minutes) {

                    var minutes = JSON.parse(res.data.minutes);
                    console.log(minutes);
                    var temp = [];
                    if (minutes && Array.isArray(minutes)) {
                        minutes.forEach(function (it) {
                            temp.push({
                                id: "",
                                m: it
                            });
                        });
                    }
                    _this14.timeArr = temp;
                }
            });
        },
        delTime: function delTime(index) {
            var timeArr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.timeArr));
            timeArr.splice(index, 1);
            this.timeArr = timeArr;
        },
        delNotes: function delNotes(item) {
            var _this15 = this;

            this.$http({
                url: "delete-msg",
                method: "POST",
                data: {
                    id: item.id
                }
            }).then(function (res) {
                console.log(res);
                if (res.status == 200) {
                    _this15.$message({
                        message: "删除成功",
                        customClass: 'success'
                    });
                    _this15.getNotesInfo();
                    return;
                }
            });
        },
        saveNotes: function saveNotes(item) {
            var _this16 = this;

            var data = void 0;
            console.log(item.id);
            if (!item.message) {
                this.$message({
                    message: "请输入备注内容",
                    customClass: 'error'
                });
                return;
            }
            if (item.id != "") {
                data = {
                    message: item.message,
                    id: item.id,
                    storeId: this.curStoreId
                };
            } else {
                data = {
                    message: item.message,
                    id: 0,
                    storeId: this.curStoreId
                };
            }

            this.$http({
                url: "merge-msg",
                method: "POST",
                data: data
            }).then(function (res) {
                console.log(res);
                if (res.status == 200) {
                    _this16.$message({
                        message: "添加修改成功",
                        customClass: 'success'
                    });
                    _this16.getNotesInfo();
                }
            });
        },
        savePrintEr: function savePrintEr(item) {
            var _this17 = this;

            var data = void 0;
            console.log(item.id);
            if (item.id != "") {
                data = {
                    port: item.port,
                    ipAddress: item.ipAddress,
                    name: item.name,
                    id: item.id,
                    storeId: this.curStoreId
                };
            } else {
                data = {
                    port: item.port,
                    ipAddress: item.ipAddress,
                    name: item.name,
                    id: 0,
                    storeId: this.curStoreId
                };
            }

            if (!this.checkPrintSet(item)) {
                return;
            }
            this.$http({
                url: "merge-ip",
                method: "POST",
                data: data
            }).then(function (res) {
                console.log(res);
                if (res.data.code == 200) {
                    _this17.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    _this17.getPrintIpInfo();
                    return;
                } else {
                    _this17.$message({
                        message: res.data.msg,
                        customClass: 'error'
                    });
                    return;
                }
            });
        },
        getPrintIpInfo: function getPrintIpInfo() {
            var _this18 = this;

            this.$http({
                url: "ip-list",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this18.printEr = res.data;
                console.log(res);
            });
        },
        getNotesInfo: function getNotesInfo() {
            var _this19 = this;

            this.$http({
                url: "get-store-msg",
                method: "GET",
                params: {
                    storeId: this.curStoreId
                }
            }).then(function (res) {
                _this19.notesArr = res.data;
                console.log(res);
            });
        },
        checkPrintSet: function checkPrintSet(item) {
            var ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            var portReg = /^\d{1,}$/;
            if (item.name.trim() == "") {
                this.$message({
                    message: '请填写打印机名字',
                    customClass: 'error'
                });
                return false;
            }
            if (!ipReg.test(item.ipAddress)) {
                this.$message({
                    message: 'ip地址有误',
                    customClass: 'error'
                });
                return false;
            }
            if (!portReg.test(item.port)) {
                this.$message({
                    message: '端口填写错误',
                    customClass: 'error'
                });
                return false;
            }
            return true;
        },
        savePwd: function savePwd() {
            var _this20 = this;

            if (!this.discountPwd) {
                this.$message({
                    message: '请输入密码',
                    customClass: 'error'
                });
                return;
            }
            var pwd = new Base64();
            var pwdStr = 'hxbs 123.999' + pwd.encode(this.discountPwd);
            this.$http({
                url: "set-psw",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    psw: pwdStr
                }
            }).then(function (res) {
                if (res.data.code == 200) {
                    _this20.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                }
            });
        },
        saveLimit: function saveLimit() {
            var _this21 = this;

            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.limitRechargeMoney)) {
                this.$message({
                    message: '价格格式有误',
                    customClass: 'error'
                });
                return;
            }
            this.$http({
                url: "/update-recharge",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    rechargeLimit: this.limitRechargeMoney
                }
            }).then(function (res) {
                console.log(_this21.storeData);
                _this21.$message({
                    message: '操作成功！',
                    customClass: 'success'
                });
                sessionStorage.setItem("rechargeLimit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this21.limitRechargeMoney));
            });
        },
        configCoupon: function configCoupon() {
            var _this22 = this;

            if (!this.curCouponData) {
                this.$message({
                    message: '请选择优惠券！',
                    customClass: 'error'
                });
                return;
            }
            var body = {
                storeId: this.curStoreId,
                giveCouponId: this.curCouponData.id ? this.curCouponData.id : ''
            };
            this.$http.post('stores-config', body).then(function (res) {
                _this22.$message({
                    message: '操作成功！',
                    customClass: 'success'
                });
            });
        },
        getconfigCoupon: function getconfigCoupon() {
            var _this23 = this;

            this.$http.get('coupon/stores-config?storeId=' + this.curStoreId).then(function (res) {
                if (res.data && res.data.couponId) {
                    _this23.couponSwitch = "ON";
                    _this23.couponModel = res.data.title;
                    _this23.curCouponData.id = res.data.couponId;
                }
            });
        },

        print: function print() {
            this.curCouponPage++;
            this.sendCoupon();
        },
        sendCoupon: function sendCoupon() {
            var _this24 = this;

            this.$http.get('coupon/list?storeId=' + this.curStoreId + '&page=' + this.curCouponPage + '&pageSize=' + this.pageSize).then(function (res) {
                _this24.couponList = _this24.couponList.concat(res.data.content);
                if (res.data.content.length >= 10) {
                    _this24.couponListMoreBtn = true;
                } else {
                    _this24.couponListMoreBtn = false;
                }
                _this24.couponBtn = true;
                _this24.curCouponData = { id: '' };
            }).catch(function () {});
        },

        //获取店主短信验证码
        getCode: function getCode() {
            var _this25 = this;

            this.$http.post(this.curStoreId + '/verify-code').then(function (res) {
                _this25.$message({
                    message: '发送成功！',
                    customClass: 'success'
                });
                _this25.isSendCodeBtn = false;
                var timer = void 0;
                timer = setInterval(function () {
                    _this25.isSendCodeTimer--;
                    if (_this25.isSendCodeTimer == 0) {
                        clearInterval(timer);
                        _this25.isSendCodeTimer = 59;
                        _this25.isSendCodeBtn = true;
                    }
                }, 1000);
            }).catch(function () {
                _this25.initBtn4 = true;
            });
        },
        closeDialog: function closeDialog() {
            this.code = '';
            this.payModeSwitch = 'THIRD_PARTY';
            this.isCancle = true;
        },
        codes: function codes(val) {
            var _this26 = this;

            if (val == 'CASHIER') {
                this.codeBtn = true;
            } else if (val == "THIRD_PARTY") {
                var body = {
                    payMode: 'THIRD_PARTY',
                    code: this.code
                };
                this.$http.put('stores/' + this.curStoreId + '/payMode-switch', body).then(function (res) {
                    _this26.isCASHIERBtn = false;
                }).catch(function (err) {});
            }
        },
        codeFn: function codeFn() {
            var _this27 = this;

            this.code = this.code.replace(/(^\s*)|(\s*$)/g, "");
            if (!/^\d{4}$/.test(this.code)) {
                this.$message({
                    message: '验证码格式有误！',
                    customClass: 'error'
                });
                return;
            }
            var body = {
                payMode: 'CASHIER',
                code: this.code
            };
            this.$http.put('stores/' + this.curStoreId + '/payMode-switch', body).then(function (res) {
                _this27.codeBtn = false;
                _this27.isCASHIERBtn = true;
            }).catch(function (err) {});
        },

        // 保存修改店铺信息
        saveStore: function saveStore() {
            var _this28 = this;

            if (!this.newStore.name) {
                this.$message({
                    message: '请输入店铺名',
                    customClass: 'error'
                });
                return;
            }
            if (!this.newStore.addr) {
                this.$message({
                    message: '请输入店铺地址',
                    customClass: 'error'
                });
                return;
            };
            if (!this.curStoreId) {
                this.curStoreId = this.$uuid.create(1).hex;
            };
            var curStore = {
                "name": this.newStore.name, // 店铺名称
                "typeId": this.newStore.typeId, // 店铺类型id
                "addr": this.newStore.addr, // 店铺地址
                "storeId": this.curStoreId
                // "referralCode": this.newStore.referralCode  // 邀请码

                //将code 转换成id
            };for (var i = 0, len = this.storeType.length; i < len; i++) {
                if (curStore.typeId == this.storeType[i].code) {
                    curStore.typeId = this.storeType[i].id;
                }
            }
            // this.$http.put('/stores/'+this.curStoreId, curStore).then((res)=>{
            //     this.$message({
            //         message: '操作成功！',
            //         customClass: 'success'
            //     });
            //     // this.newStore = {
            //     //     "name": res.data.name, // 店铺名称
            //     //     "typeId": res.data.typeCode, // 店铺类型id
            //     //     "addr": res.data.addr, // 店铺地址
            //     //     "referralCode": res.data.referralCode// 邀请码
            //     // }
            // }).catch((err) => {

            // })
            this.$http.post('/update-store', curStore).then(function (res) {
                _this28.$message({
                    message: res.data.result.msg,
                    customClass: 'success'
                });
                // this.newStore = {
                //     "name": res.data.name, // 店铺名称
                //     "typeId": res.data.typeCode, // 店铺类型id
                //     "addr": res.data.addr, // 店铺地址
                //     "referralCode": res.data.referralCode// 邀请码
                // }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        var _this29 = this;

        this.$http.get('/store-types').then(function (res) {
            _this29.storeType = res.data;
            _this29.$http.get('/stores/' + _this29.curStoreId).then(function (res) {
                _this29.newStore = {
                    "name": res.data.name, // 店铺名称
                    "typeId": res.data.typeCode, // 店铺类型id
                    "addr": res.data.addr, // 店铺地址
                    "referralCode": res.data.referralCode // 邀请码
                };
                _this29.returnCallEnabled = res.data.returnCallEnabled;
                _this29.clerkCashSales = res.data.clerkCashSales ? 'ON' : 'OFF';
                _this29.stockLimitSales = res.data.stockLimitSales ? 'ON' : 'OFF';
                _this29.customSwitch = res.data.sysProductEnabled ? 'ON' : 'OFF';
                _this29.isOpenPrevPrint = res.data.preEnabled ? "ON" : "OFF";
                _this29.refundSwitch = res.data.refundPswEnabled ? "ON" : "OFF";
                _this29.posCallEnabled = res.data.posCallEnabled ? "ON" : "OFF";
                // 
                _this29.voiceEnabled = res.data.voiceEnabled ? "ON" : "OFF";
                // this.autoPrintEnabled = res.data.autoPrintEnabled?"ON":"OFF";
                _this29.pcOrderEnabled = res.data.pcOrderEnabled ? "ON" : "OFF";
                // 
                _this29.allowProductCancelSale = res.data.allowProductCancelSale;
                _this29.deliveryEnabled = res.data.deliveryEnabled ? res.data.deliveryEnabled : false;
                _this29.memberEnabled = res.data.memberEnabled ? res.data.memberEnabled : false;
                _this29.globalRate = res.data.globalRate ? (res.data.globalRate * 100).toFixed(0) : 0;
                // this.clerkMember = res.data.clerkMemberSwitch?'ON':'OFF';
                if (res.data.payMode == 'THIRD_PARTY') {
                    _this29.isCASHIERBtn = false;
                } else if (res.data.payMode == 'CASHIER') {
                    _this29.isCASHIERBtn = true;
                }
                _this29.logoUrl = res.data.storeLogo;
                _this29.summary = res.data.summary;
                _this29.hotTitle = res.data.title;
                _this29.rollTitle = res.data.netTitle;
                _this29.rollNotice = res.data.notice;
                _this29.storeQrCode = res.data.storeCodeImage;
            });
        }).catch(function (err) {
            // console.log(err)
        });
        this.getconfigCoupon();
        this.sendCoupon();
        // 进入界面时请求店铺类型
        // this.getKitchenPsrint();
        var rechargeLimit = JSON.parse(sessionStorage.getItem("rechargeLimit"));
        this.limitRechargeMoney = rechargeLimit;
    },
    mounted: function mounted() {
        this.getTime();
        // setTimeout(() => {
        this.getPrintIpInfo();
        // }, 300);
        this.getNotesInfo();
    }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'storeData'],
    data: function data() {
        return {
            //
            seriesData: [],
            xAxisData: [], //日期数据
            legendData: [], //分类数据
            nowDataType: "SEVEN",
            // 
            histogram: null, //柱状图
            pie: null, //饼状图
            // storeData:{},//当前店铺信息
            totalData: {
                total: 0, // 实收
                cash: 0, // 现金
                wechat: 0, // 微信
                alipay: 0 // 支付宝
            }, // 半年数据总和
            dates: [],
            aDates: {}
        };
    },

    watch: {
        nowDataType: function nowDataType(val) {
            this.getData(val);
        }
    },
    methods: {
        getData: function getData(val) {
            var _this = this;

            this.$http({
                url: "get-day",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    type: val
                }
            }).then(function (res) {
                if (res.data.code == 200) {
                    if (res.data.data.length) {
                        var data = res.data.data;
                        var legendData = [];
                        var xAxisData = [];
                        var seriesData = [];
                        // 筛选分类数据和日期
                        for (var i = 0; i < data.length; i++) {
                            xAxisData.push(data[i].date);
                            for (var j = 0; j < data[i].list.length; j++) {
                                if (legendData.length) {
                                    var flag = false;
                                    for (var y = 0; y < legendData.length; y++) {
                                        if (legendData[y] == data[i].list[j].typeName) {
                                            flag = true;
                                        }
                                    }
                                    if (!flag) {
                                        legendData.push(data[i].list[j].typeName);
                                    }
                                } else {
                                    if (data[i].list[j]) {
                                        legendData.push(data[i].list[j].typeName);
                                    }
                                }
                            }
                        }
                        // 按照分类来筛选每个分类的具体时间销售金额
                        for (var _i = 0; _i < legendData.length; _i++) {
                            var obj = {
                                name: legendData[_i],
                                type: "line",
                                // stack: '总量',
                                data: []
                            };
                            seriesData.push(obj);
                        }
                        // // // 重新整理数据
                        // let newData = [];
                        // for(let i=0;i<data.length;i++){
                        //     if(data[i].list.length){
                        //         let obj = {
                        //             date:data[i].date,
                        //             list:[]
                        //         }
                        //         for(let x=0;x<seriesData.length;x++){
                        //             for(let j=0;j<data[i].list.length;j++){
                        //                 if(seriesData[x].name == data[i].list[j].typeName){
                        //                     obj.list.push({
                        //                         amount:data[i].list[j].amount,
                        //                         date: "",
                        //                         id: 0,
                        //                         qty: data[i].list[j].qty,
                        //                         storeId: "",
                        //                         typeName: seriesData[x].name,
                        //                     });
                        //                 }
                        //             }
                        //         }
                        //         newData.push(obj);
                        //     }else{
                        //         let obj = {
                        //             date:data[i].date,
                        //             list:[]
                        //         }
                        //        for(let x=0;x<seriesData.length;x++){
                        //             obj.list.push({
                        //                 amount:0,
                        //                 date: "",
                        //                 id: 0,
                        //                 qty: 0,
                        //                 storeId: "",
                        //                 typeName: seriesData[x].name,
                        //             });
                        //        } 
                        //         newData.push(obj);
                        //     }

                        // }
                        // console.log(newData);
                        // return;
                        for (var _i2 = 0; _i2 < seriesData.length; _i2++) {
                            for (var _j = 0; _j < data.length; _j++) {
                                for (var x = 0; x < data[_j].list.length; x++) {
                                    if (seriesData[_i2].name == data[_j].list[x].typeName) {
                                        seriesData[_i2].data.push('' + data[_j].list[x].amount);
                                    }
                                }
                            }
                        }
                        // for(let i=0;i<seriesData.length;i++){
                        //     for(let j=0;j<newData.length;j++){
                        //         for(let x=0;x<newData[j].list.length;x++){
                        //             if(seriesData[i].name == newData[j].list[x].typeName){
                        //                 seriesData[i].data.push(`${newData[j].list[x].amount}`);
                        //             }
                        //         }
                        //     }
                        // }
                        console.log("分类数据：");
                        console.log(legendData);
                        console.log("日期数据：");
                        console.log(xAxisData);
                        console.log("数据：");
                        console.log(seriesData);
                        _this.legendData = legendData;
                        _this.seriesData = seriesData;
                        _this.xAxisData = xAxisData;
                        if (val == "SEVEN" || val == "FIFTEEN") {
                            _this.drawLine(legendData, xAxisData, seriesData);
                        } else {
                            _this.drawLine(legendData, xAxisData, seriesData, true);
                        }
                    }
                }
            });
        },
        drawLine: function drawLine(legendData, xAxisData, seriesData) {
            var isRotate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            var axisLabelData = {};
            if (!isRotate) {
                axisLabelData = {
                    interval: 0,
                    rotate: 0
                };
            } else {
                axisLabelData = {
                    interval: 0,
                    rotate: 45
                };
            }
            var othis = this;
            if (this.histogram) {
                this.histogram.dispose();
            }
            this.histogram = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(document.getElementById('histogram'));
            setTimeout(function () {
                //setTimeout避免拿不到店铺信息
                othis.histogram.setOption({
                    title: {
                        text: '金额',
                        top: 20
                    },
                    color: ["#ff9494", "#72f6c6", "#769aff", "#7c2222", "#6c57d9", "#261095", "#7c5708", "#f1a80b", "#42cf7e", "#3b5245", "#de3b0f", "#4e3e08", "#df4aa5", "#c852bc", "#230f62", "#8d0d40", "#542200", "#b44b06", "#f94e62", "#000000"],
                    tooltip: {
                        trigger: 'axis',
                        formatter: function formatter(params) {
                            // params为悬浮框上的全部数据
                            console.log(params);
                            // return;
                            var newParams = [];

                            var paramsData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(params, 'value'); // 根据value值升序，_.sortBy为lodash的方法
                            console.log(paramsData);
                            paramsData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reverse(paramsData); // 将数据降序，_.reverse为lodash的方法

                            paramsData.sort(function (a, b) {
                                return Number(b.value) - Number(a.value);
                            });

                            paramsData.forEach(function (p) {
                                // p.marker为对应数据线的颜色的圆点 
                                // p.seriesName为对应数据的数据名称
                                // p.value为对应数据的值
                                var cont = p.marker + ' ' + p.seriesName + ': ' + p.value + ' 元<br/>';
                                newParams.push(cont);
                            });
                            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.join(newParams, ''); // 这里是需要将数组转化成字符串显示，如果不转化，每个数据前面都会出现一个逗号（，），_.join为lodash的方法
                        }
                    },
                    legend: {
                        type: "scroll",
                        data: legendData,
                        top: 0
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    // toolbox: {
                    //     feature: {
                    //         saveAsImage: {}
                    //     }
                    // },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xAxisData,
                        axisLabel: axisLabelData
                        // max:"dataMax",
                        // splitNumber:1,
                        // boundaryGap:['3%','3%'],
                        // maxInterval:3600 * 24 * 1000
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: seriesData
                });
            }, 200);
        },
        drawPie: function drawPie(datas) {
            var storeName = this.storeData.name;
            var othis = this;
            var seriesData = [{ value: datas.lost_count, name: '流失' }, { value: datas.new_count, name: '新增' }, { value: datas.active_count, name: '活跃' }];
            if (this.pie) {
                this.pie.dispose();
            }
            this.pie = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(document.getElementById('pie'));
            setTimeout(function () {
                othis.pie.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    color: ["#ff9494", "#72f6c6", "#769aff"],
                    legend: {
                        orient: 'horizontal',
                        // x: 'left',
                        bottom: '2%',
                        data: ['流失', '新增', '活跃']
                    },
                    series: [{
                        name: storeName,
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                formatter: '{c}',
                                textStyle: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: seriesData
                    }]
                });
            }, 200);
        },

        //柱状图
        drawHistogram: function drawHistogram(datas) {
            var othis = this;
            var newCountArr = []; //新增
            var activeCountArr = []; //活跃
            var lostCountArr = []; //流失
            var monthArr = []; //每月总销售额数据数组

            var sssss = [];
            for (var i = 0, len = datas.length; i < len; i++) {
                //获取每月总销售额
                newCountArr.push(datas[i].new_count);
                activeCountArr.push(datas[i].active_count);
                lostCountArr.push(datas[i].lost_count);
                monthArr.push(new Date(datas[i].biz_date).getMonth() + 1 + '-' + new Date(datas[i].biz_date).getDate());
            }
            if (this.histogram) {
                this.histogram.dispose();
            }
            this.histogram = __WEBPACK_IMPORTED_MODULE_0_echarts___default.a.init(document.getElementById('histogram'));
            setTimeout(function () {
                //setTimeout避免拿不到店铺信息
                othis.histogram.setOption({
                    tooltip: {},
                    color: ["#87a2ea"],
                    legend: {
                        data: ['流失', '新增', '活跃'],
                        y: 'bottom'
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        bottom: '10%',
                        top: '8%',
                        containLabel: true
                    },
                    xAxis: {
                        data: monthArr,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#ddd"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#444"
                            }
                        },
                        type: 'category'
                        // boundaryGap: false,
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#ddd'
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            textStyle: {
                                color: "#444",
                                fontSize: 12
                            }
                        }
                    },
                    series: [{
                        color: ["#ff9494"],
                        name: '流失',
                        type: 'bar',
                        barWidth: '15%',
                        data: lostCountArr,
                        itemStyle: {
                            normal: {
                                barBorderRadius: [5, 5, 0, 0]
                            },
                            emphasis: {
                                // backgroundImage: linearGradient(to bottom, #30bdff, #3068ff)
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                formatter: '{c}' // 这里是数据展示的时候显示的数据
                            }
                        }
                    }, {
                        name: '新增',
                        color: ["#72f6c6"],
                        type: 'bar',
                        barWidth: '15%',
                        data: newCountArr,
                        itemStyle: {
                            normal: {
                                barBorderRadius: [5, 5, 0, 0]
                            },
                            emphasis: {
                                // backgroundImage: linearGradient(to bottom, #30bdff, #3068ff)
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                formatter: '{c}' // 这里是数据展示的时候显示的数据
                            }
                        }
                    }, {
                        name: '活跃',
                        type: 'line',
                        data: activeCountArr,
                        smooth: true,
                        label: {
                            normal: {
                                show: true,
                                position: 'outside',
                                formatter: '{c}' // 这里是数据展示的时候显示的数据
                            }
                        }
                    }]
                });
            }, 200);
        }
    },
    created: function created() {},

    mounted: function mounted() {
        this.getData("SEVEN");
        console.log(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy);
        // this.storeData.name = this.storeData.name;
        // this.$http.get(this.curStoreId+'/daily-member-statics').then((res)=>{
        //     this.dates = res.data;
        //     for(var i = 0,len=7-res.data.length;i<len;i++){
        //         let obj = {
        //             active_count:0,
        //             biz_date:(new Date().getTime()-24*3600*1000*(7-i)),
        //             lost_count:0,
        //             new_count:0,
        //             sleep_count:0,
        //             total:0
        //         }
        //         this.dates.splice(i,0,obj);
        //     }
        //     this.drawPie(this.dates[this.dates.length-1]);
        //     this.aDates = this.dates[this.dates.length-1];
        //     this.drawHistogram(this.dates);
        // })
    }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize', 'storeData'],
    data: function data() {
        return {
            addEmplVisible: false,
            imgUrl: '', //支付二维码
            payType: 'false',
            scanId: '', //轮询id
            num: 0, //控制待支付时间
            storeLV: {
                'ONE': "免费版",
                'TWO': "基础版",
                'THREE': "高级版"
            },
            LV: '',
            curMoney: {
                'ONE': "0.00",
                'TWO': "1200.00",
                'THREE': "3200.00",
                'UP': "2000.00"
            },
            curLV: this.storeData.level, //当前预付费版本
            upLvBtn: false
        };
    },

    watch: {
        payType: function payType(val) {}
    },
    methods: {
        //切换版本
        cutEdition: function cutEdition(lv) {
            this.curLV = lv;
        },

        //生成二维码
        createdCode: function createdCode() {
            var _this = this;

            var lv = {
                'ONE': "",
                'TWO': "SECOND_LEVEL",
                'THREE': "THREE_LEVEL",
                'UP': "UPGRADE"
            };
            this.$http.get(__WEBPACK_IMPORTED_MODULE_0__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/pay/web/scan-code?storeId=' + this.curStoreId + '&type=' + this.payType + '&rechargeType=' + lv[this.curLV]).then(function (res) {
                _this.imgUrl = res.data.url;
                _this.addEmplVisible = true;
                _this.scanId = res.data.id;
                _this.getTopUpData();
            });
        },

        //轮询
        getTopUpData: function getTopUpData() {
            var _this2 = this;

            this.$http.get(__WEBPACK_IMPORTED_MODULE_0__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/pay/scan-code/web-query?id=' + this.scanId).then(function (res) {
                if (res.status == 202) {
                    if (!_this2.addEmplVisible) {
                        return;
                    }
                    setTimeout(function () {
                        _this2.num++;
                        if (_this2.num >= 30) {
                            _this2.$message({
                                message: '二维码过期',
                                customClass: 'error'
                            });
                            return;
                        }
                        _this2.getTopUpData();
                    }, 2000);
                } else if (res.status == 200) {
                    _this2.addEmplVisible = false;
                    _this2.$message({
                        message: '支付成功',
                        customClass: 'success'
                    });
                }
            });
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this3 = this;

        if (this.storeData.level) {
            if (this.storeData.level == 'ONE' || this.storeData.level == 'TWO') {
                this.curLV = 'THREE';
            } else {
                this.curLV = this.storeData.level;
            }
        } else {
            this.$http.get('/stores/' + this.curStoreId).then(function (res) {
                _this3.storeData = res.data;
                if (_this3.storeData.level == 'ONE' || _this3.storeData.level == 'TWO') {
                    _this3.curLV = 'THREE';
                } else {
                    _this3.curLV = _this3.storeData.level;
                }
            });
        }
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            nowSelFilter: "month",
            totalDiscountAmount: 0, //总的赠送金额
            totalChargeAmount: 0, //总的充值金额
            verifiList: [], // 核销详情
            nowType: "TIME_RANGE",
            startTime: '', //按时间段查询的起始时间
            endTime: '', //按时间段查询的结束时间
            pickerOptions: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            dateStr: new Date().Format("yyyy-MM"),
            currentPage: 1,
            totalElements: 0, //数据总条数
            canClick: true,
            searchPhone: "" //会员搜索手机号
        };
    },

    watch: {
        dateStr: function dateStr(val) {
            console.log(new Date(val).Format("yyyy-MM"));
            var nowDate = new Date(val).Format("yyyy-MM");
            this.dateStr = nowDate;
            // this.getChargeInfo(0, nowDate);
        }
    },
    methods: {
        filter: function filter(type) {
            var timeRangeArr = [];
            this.nowSelFilter = type;
            switch (type) {
                case "today":
                    // this.yearMonth = new Date().Format("yyyy-MM");
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    // let year = new Date().Format("yyyy");
                    // let month = new Date().Format("MM");
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastDay":
                    this.startTime = new Date().Format("yyyy/MM/dd") + ' 00:00:00';
                    this.startTime = new Date(new Date(this.startTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 00:00:00';
                    this.endTime = new Date().Format("yyyy/MM/dd") + ' 23:59:59';
                    this.endTime = new Date(new Date(this.endTime).getTime() - 1000 * 60 * 60 * 24).Format("yyyy/MM/dd") + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "week":
                    timeRangeArr = this.$dateRange.getThisWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastWeek":
                    timeRangeArr = this.$dateRange.getLastWeek();
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "month":
                    timeRangeArr = this.$dateRange.getThisMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                case "lastMonth":
                    timeRangeArr = this.$dateRange.getLastMonth();
                    console.log(timeRangeArr);
                    this.startTime = timeRangeArr[0] + ' 00:00:00';
                    this.endTime = timeRangeArr[1] + ' 23:59:59';
                    this.searchConfirm();
                    break;
                default:
                    break;
            }
        },
        doSearch: function doSearch() {
            var timeStr = new Date(this.dateStr).getTime() + "-" + new Date(this.dateStr).getTime();
            var nowTime = new Date().getTime();
            if (!this.$canClickSelect("chargeInfoMonth", timeStr, nowTime)) {
                this.$message({
                    message: '5秒内禁止重复查询相同数据',
                    customClass: 'error'
                });
                return;
            }
            if (this.canClick) {
                this.canClick = false;
                this.getChargeInfo(0, this.dateStr);
            }
        },

        //分页方法
        handleCurrentChange: function handleCurrentChange(val) {
            console.log('\u5F53\u524D\u9875: ' + val);
            console.log(this.dateStr);
            if (this.nowType == "MONTH") {
                this.getChargeInfo(val - 1, this.dateStr, "MONTH");
            } else {
                this.getChargeInfo(val - 1, this.dateStr, "ARB");
            }
        },

        // 搜索
        searchConfirm: function searchConfirm() {
            // 
            var timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
            var nowTime = new Date().getTime();
            if (!this.$canClickSelect("chargeInfoTimeRange", timeStr, nowTime)) {
                this.$message({
                    message: '5秒内禁止重复查询相同数据',
                    customClass: 'error'
                });
                return;
            }
            // 


            if (new Date(this.endTime).getTime() - new Date(this.startTime).getTime() > 1000 * 60 * 60 * 24 * 35) {
                this.$message({
                    message: '只能查询35天内的数据',
                    customClass: 'error'
                });
                return;
            }
            if (this.startTime !== '' && this.endTime !== '') {
                if (new Date(this.startTime) > new Date(this.endTime)) {
                    this.$message({
                        message: '结束时间不能比开始时间小',
                        customClass: 'error'
                    });
                    return;
                }
                if (this.canClick) {
                    this.canClick = false;
                    this.getChargeInfo(0, this.dateStr, "ARB");
                }
            } else {
                this.$message({
                    message: '请选择查询时间段',
                    customClass: 'error'
                });
                return;
            }
        },
        // 获取核销详情
        getChargeInfo: function getChargeInfo(page, date) {
            var _this = this;

            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "MONTH";

            var params = void 0;
            if (this.searchPhone) {
                if (!/^(\d){11}$/.test(this.searchPhone)) {
                    this.$message({
                        message: '手机号输入有误',
                        customClass: 'error'
                    });
                    setTimeout(function () {
                        _this.canClick = true;
                    }, 500);
                    return;
                }
                if (type == "MONTH") {
                    params = {
                        storeId: this.curStoreId,
                        time: date,
                        type: type,
                        page: page,
                        size: this.pageSize,
                        mobile: this.searchPhone
                    };
                } else {
                    var begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    var end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    params = {
                        storeId: this.curStoreId,
                        begin: begin,
                        end: end,
                        type: type,
                        page: page,
                        size: this.pageSize,
                        mobile: this.searchPhone
                    };
                }
            } else {
                if (type == "MONTH") {
                    params = {
                        storeId: this.curStoreId,
                        time: date,
                        type: type,
                        page: page,
                        size: this.pageSize
                    };
                } else {
                    var _begin = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    var _end = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    params = {
                        storeId: this.curStoreId,
                        begin: _begin,
                        end: _end,
                        type: type,
                        page: page,
                        size: this.pageSize
                    };
                }
            }

            this.$http({
                url: "get-charge",
                method: "GET",
                params: params
            }).then(function (res) {
                setTimeout(function () {
                    _this.canClick = true;
                }, 500);
                var body = res.data;
                if (body.result.code == 200) {
                    _this.verifiList = body.data;
                    var number = _this.pageSize - _this.verifiList.length;
                    _this.totalElements = body.totalElements;
                    _this.totalChargeAmount = body.amount;
                    _this.totalDiscountAmount = body.discount;
                    if (number > 0) {
                        for (var i = 0; i < number; i++) {
                            _this.verifiList.push({
                                id: '', // 员工id
                                name: '', // 员工姓名
                                code: '', // 编号
                                mobile: '', // 手机
                                groupName: '' // 岗位id
                            });
                        }
                    }
                } else {
                    _this.$message({
                        message: body.result.msg,
                        customClass: 'error'
                    });
                }
            }).catch(function (err) {
                setTimeout(function () {
                    _this.canClick = true;
                }, 500);
            });
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.verifiList.push({
                id: '', // 员工id
                name: '', // 员工姓名
                code: '', // 编号
                mobile: '', // 手机
                groupName: '' // 岗位id
            });
        }
        // 获取员工列表
        this.startTime = new Date().Format("yyyy/MM") + '-01 00:00:00';
        var year = new Date().Format("yyyy");
        var month = new Date().Format("MM");
        this.endTime = new Date(year, month, 0).Format("yyyy/MM/dd") + ' 23:59:59';
    },
    mounted: function mounted() {
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize', 'storeData'],
    data: function data() {
        return {
            sendPwd: "",
            nowAddTimeSort: "DOWN",
            canClick: true,
            qty: 1,
            qtyOptions: [],
            pageSize: 10,
            timeSort: false,
            addTimeSort: false,
            nowTimeSort: "DOWN",
            totalAmount: 0, //会员总金额
            nowVipIndex: 0,
            searchPhone: "",
            searchData: [],
            couponCount: 0, //优惠券总数量
            usedCount: 0, //已使用数量
            hasCount: 0, //未使用数量
            couponDetailArr: [], //优惠券详情
            showCouponDetail: false,
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 24 * 3600000;
                }
            },
            showSureDistribute: false,
            vipOrderProductArr: [],
            vipOrderProductBtn: false,
            dialogVisible: false,
            vipData: [], //会员数据
            vipDataLength: 0,
            curCheckArr: [], //当前选择的
            allCheckArr: false, //全选所有
            couponList: [],
            couponType: {
                'GET_ITEM_FREE': '商品抵用券',
                'REDUCE': '代金券'
            },
            couponModel: '', //当前优惠券模型
            curCouponData: '', //当前优惠券
            curCouponPage: 0, //下拉框中当前优惠券的页码
            couponListMoreBtn: false, //下拉框中是否有更多优惠券

            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0, //总共条
            vipType: 'all', //会员类型
            couponBtn: false, //优惠券派发弹出框
            weChatBtn: false, //微信群发弹出框
            payHostBtn: false, //充值历史记录
            payHostArr: [],
            infoload: false,

            vipDetailArr: [], //消费详情数据
            vipDetailBtn: false,
            memberDetailId: '', //某会员id
            WKcurPage: 0, //消费详情当前页，用于切换页码
            WKtotalPage: 1, //消费详情总共页
            WKtotalElements: 0, //消费详情总共条

            PAYcurPage: 0, //消费详情当前页，用于切换页码
            PAYtotalPage: 1, //消费详情总共页
            PAYtotalElements: 0, //消费详情总共条

            notesBtn: false, //
            notes: {
                name: '',
                mobile: '',
                type: 'name'
            },
            clickBtn: true,
            weChatModel: {
                name: '',
                ACtitle: '',
                timeFrom: '',
                timeTo: '',
                address: '',
                rules: '',
                BG: ''
            },
            weChatShowRules: '',
            payUrl: '',
            payTimer: '',
            payData: {},
            curBgIndex: 0,
            bgArr: ['https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/53fd6f57d35c4e07a68e41a16d4f6369.jpg', 'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/e1fb020b84f3466eb48db9a3fb56b7f4.jpg', 'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/341a0335c4604ba4977411ce60750c76.jpg', 'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/8b51e5f483de483d86154d1978011b0d.jpg', 'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/9b708dc5d64d474c87e63b0d5bb78987.jpg', 'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/1b4b2e7e39574f1584e713b19367426c.jpg', 'https://images.huoxingy.com/image/f6706240-7f24-11e7-8738-6539b23612c0/6242fe1ef1be48899959caf05f27898d.jpg'],
            seep: 1
        };
    },

    watch: {
        'weChatModel.rules': function weChatModelRules(val) {
            this.weChatShowRules = '';
            var oldCode = encodeURI(val);
            var arr = oldCode.split('%0A');
            for (var i = 0, len = arr.length; i < len; i++) {
                this.weChatShowRules += "<p style='margin:5px 0;'>" + decodeURI(arr[i]) + "</p>";
            }
        },
        vipType: function vipType(val) {
            this.curPage = 0;
            this.curCheckArr = [];
            this.getVipData("AMOUNT", "DOWN");
        },
        couponModel: function couponModel(val) {
            this.curCouponData = JSON.parse(val);
        },
        curCheckArr: function curCheckArr(val) {
            if (this.vipDataLength > 0) {
                if (val.length >= this.vipDataLength) {
                    this.allCheckArr = true;
                } else {
                    this.allCheckArr = false;
                }
            }
        },
        searchPhone: function searchPhone(val) {
            if (!val) {
                this.searchData = [];
                this.getVipData("AMOUNT", "DOWN");
                return;
            }
            this.searchVip();
        },
        nowTimeSort: function nowTimeSort(val) {
            this.getVipData("TIME", val);
        },
        nowAddTimeSort: function nowAddTimeSort(val) {
            this.getVipData("addTime", val);
        },
        couponBtn: function couponBtn(val) {
            if (!val) {
                this.couponList = [];
                this.curCouponPage = 0;
                this.qty = 1;
            }
        }
    },
    methods: {
        //导出按钮
        excel: function excel() {
            var _this = this;

            this.$http({
                url: this.curStoreId + '/member',
                method: "GET",
                params: {
                    page: 0,
                    pageSize: 100000,
                    type: this.vipType,
                    source: "AMOUNT",
                    direction: this.nowTimeSort
                }
            }).then(function (res) {
                var data = res.data.data;
                console.log(data);
                var html = '<tr>' + '<td style="font-size:18px">会员备注名</td>' + '<td style="font-size:18px">电话</td>' + '<td style="font-size:18px">余额</td>' + '<td style="font-size:18px">最后一次消费时间</td>' + '</tr>';
                for (var i = 0; i < data.length; i++) {
                    if (!data[i].memberId) {
                        continue;
                    }
                    html += '<tr>' + '<td>' + data[i].memberName + '</td>' + '<td>' + data[i].mobile + '</td>' + '<td>' + data[i].amount + '</td>' + '<td>' + _this.toOtherDay(data[i].time) + '</td>' + '</tr>';
                }
                console.log(document.getElementById('scrollBox'));
                document.getElementById('scrollBox').innerHTML = html;
                window.method5(scrollBox);
            });
        },

        toOtherDay: function toOtherDay(val) {
            if (!val) {
                return '';
            }
            var dateArr = val.split('.');
            var dateStr = dateArr[0];
            var date = new Date(dateStr.replace(/-/g, "/")).getTime();
            var nowDate = new Date().getTime();
            var timeStr = nowDate - date;
            var oneDay = 1000 * 60 * 60 * 24;
            var day = Math.floor(timeStr / oneDay);
            var hours = Math.floor(timeStr % oneDay / (3600 * 1000));
            if (day > 0) {
                return day + "天前";
            } else {
                return "今天";
            }
        },
        setNowSearchVip: function setNowSearchVip(item) {
            this.searchData = [];
            this.vipData = [];
            this.totalAmount = item.amount;
            this.vipDataLength = 1;
            this.totalElements = 1;
            this.totalPage = 1;
            this.vipData.push({
                "id": item.id,
                "memberId": item.id,
                "memberName": item.name,
                "storeId": '',
                "code": item.code,
                "referralMemberId": '', //推荐人id
                "mobile": item.mobile, //推荐人name
                "frequency": '', //频次
                "allFrequency": '', //总次数
                "amount": item.amount //金额
            });
            for (var i = 1, len = 10; i < len; i++) {
                this.vipData.push({
                    "id": '',
                    "memberId": '',
                    "memberName": '',
                    "storeId": '',
                    "code": '',
                    "referralMemberId": '', //推荐人id
                    "mobile": '', //推荐人name
                    "frequency": '', //频次
                    "allFrequency": '', //总次数
                    "amount": '' //金额
                });
            }
        },
        searchVip: function searchVip() {
            var _this2 = this;

            this.$http({
                url: __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + "v1/pos/members",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    q: this.searchPhone
                }
            }).then(function (res) {
                _this2.searchData = res.data;
            });
        },
        couponDetail: function couponDetail(item) {
            this.getCouponList(item);
            this.showCouponDetail = true;
        },
        getCouponList: function getCouponList(item) {
            var _this3 = this;

            this.$http({
                url: "get-coupon",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    memberId: item.memberId
                }
            }).then(function (res) {
                _this3.couponDetailArr = res.data.res;
                _this3.usedCount = res.data.use;
                _this3.hasCount = res.data.has;
            });
        },

        // 显示是否打开派发优惠券弹窗
        doShowCoupon: function doShowCoupon() {
            var _this4 = this;

            if (!this.curCouponData) {
                this.$message({
                    message: '请选择会员券',
                    customClass: 'error'
                });
                return;
            }
            if (!this.curCheckArr.length) {
                if (!String(this.sendPwd).trim()) {
                    this.$message({
                        message: '请输入密码',
                        customClass: 'error'
                    });
                    return;
                }
                var pwd = new Base64();
                var pwdStr = 'hxbs 123.999' + pwd.encode(this.sendPwd);
                this.$http({
                    url: "judge-psw",
                    method: "POST",
                    data: {
                        storeId: this.curStoreId,
                        judgePsw: pwdStr
                    }
                }).then(function (res) {
                    if (res.data.code == 400) {
                        _this4.$message({
                            message: res.data.msg,
                            showClose: true,
                            customClass: 'error'
                        });
                        return;
                    } else if (res.data.code == 200) {
                        _this4.showSureDistribute = true;
                    }
                });
                return;
            }
            this.showSureDistribute = true;
        },

        //充值记录
        payHost: function payHost() {
            var _this5 = this;

            this.$http.get(this.curStoreId + '/store-orders' + '?page=' + this.PAYcurPage + '&pageSize=' + this.pageSize).then(function (res) {
                _this5.payHostBtn = true;
                _this5.payHostArr = res.data.content;
                _this5.PAYtotalElements = res.data.totalElements;
                _this5.PAYtotalPage = res.data.totalPages;
            });
        },

        //点击全选
        isAll: function isAll() {
            if (this.allCheckArr) {
                this.allCheckArr = false;
                this.curCheckArr = [];
            } else {
                this.allCheckArr = true;
                for (var i = this.vipData.length - 1; i >= 0; i--) {
                    if (this.vipData[i].memberId) {
                        this.curCheckArr.push(this.vipData[i].memberId);
                    }
                }
            }
        },

        //下拉框中是否有更多优惠券
        print: function print() {
            this.curCouponPage++;
            this.sendCoupon();
        },
        //列表翻页
        payHostPage: function payHostPage(boo) {
            var _this6 = this;

            if (!this.clickBtn) {
                return;
            }
            this.clickBtn = false;
            setTimeout(function () {
                _this6.clickBtn = true;
            }, 800);
            if (boo) {
                if (this.PAYcurPage + 1 >= this.PAYtotalPage) {
                    return;
                }
                this.PAYcurPage++;
            } else {
                if (this.PAYcurPage <= 0) {
                    return;
                }
                this.PAYcurPage--;
            }
            this.payHost();
        }, //列表翻页
        changePage: function changePage(boo) {
            var _this7 = this;

            if (!this.clickBtn) {
                return;
            }
            this.clickBtn = false;
            this.curCheckArr = [];
            this.allCheckArr = false;
            setTimeout(function () {
                _this7.clickBtn = true;
            }, 800);
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            if (this.timeSort) {
                this.getVipData("TIME", this.nowTimeSort);
            } else if (this.addTimeSort) {
                this.getVipData("addTime", this.nowAddTimeSort);
            } else {
                this.getVipData("AMOUNT", "DOWN");
            }
        },
        //明细翻页
        changeDetailPage: function changeDetailPage(boo) {
            var _this8 = this;

            if (!this.clickBtn) {
                return;
            }
            this.clickBtn = false;
            setTimeout(function () {
                _this8.clickBtn = true;
            }, 800);
            if (boo) {
                if (this.WKcurPage + 1 >= this.WKtotalPage) {
                    return;
                }
                this.WKcurPage++;
            } else {
                if (this.WKcurPage <= 0) {
                    return;
                }
                this.WKcurPage--;
            }
            this.vipDetail();
        },
        //发券
        couponUpdate: function couponUpdate() {
            var _this9 = this;

            if (!this.curCouponData) {
                this.$message({
                    message: '请选择会员券',
                    customClass: 'error'
                });
                return;
            }
            // if(!this.curCheckArr.length){
            //     this.$message({
            //         message: '请选择会员',
            //         customClass: 'error'
            //     })
            //     return;
            // }
            if (!this.canClick) {
                return;
            }
            this.canClick = false;
            var type = '';
            if (this.vipType == 'all') {
                type = this.curCheckArr.length == 0 ? 'ALL' : "SINGLE";
            } else if (this.vipType == 'lost') {
                type = this.curCheckArr.length == 0 ? 'SLEEP' : "SINGLE";
            }
            var body = {
                storeId: this.curStoreId,
                couponId: this.curCouponData.id,
                distributeType: type,
                memeberIds: this.curCheckArr,
                qty: this.qty
            };
            this.$http.post('distribute-coupon', body).then(function (res) {
                setTimeout(function () {
                    _this9.canClick = true;
                }, 1000);
                _this9.couponBtn = false;
                _this9.curCouponPage = 0;
                _this9.curCouponData = {};
                _this9.$message({
                    message: '操作成功',
                    customClass: 'success'
                });
                _this9.curCheckArr = [];
                _this9.showSureDistribute = false;
            }).catch(function (err) {
                setTimeout(function () {
                    _this9.canClick = true;
                }, 1000);
            });
        },

        //发券  // 获取优惠券列表
        sendCoupon: function sendCoupon() {
            var _this10 = this;

            if (this.vipDataLength <= 0) {
                this.$message({
                    message: '暂无会员可派发优惠券',
                    customClass: 'error'
                });
                return;
            }
            this.couponModel = '';
            this.$http.get('coupon/list?storeId=' + this.curStoreId + '&page=' + this.curCouponPage + '&pageSize=' + this.pageSize).then(function (res) {
                _this10.couponList = _this10.couponList.concat(res.data.content);

                if (res.data.content.length >= 10) {
                    _this10.couponListMoreBtn = true;
                } else {
                    _this10.couponListMoreBtn = false;
                }
                _this10.couponBtn = true;
                _this10.curCouponData = '';
            }).catch(function () {});
        },

        //微信群发
        sendWechat: function sendWechat() {
            var _this11 = this;

            this.weChatBtn = true;
            this.curBgIndex = 0;
            this.$http.get('estimate/store-orders?storeId=' + this.curStoreId).then(function (res) {
                _this11.payData = res.data;
            });
            this.weChatModel = {
                name: this.storeData.name,
                ACtitle: '',
                timeFrom: new Date(),
                timeTo: new Date(),
                address: this.storeData.addr,
                rules: '',
                BG: ''
            };
        },

        //关闭微信群发支付弹框
        closePay: function closePay() {
            clearInterval(this.payTimer);
            this.seep = 1;
            this.weChatBtn = false;
        },

        //切换背景
        cutBg: function cutBg(item, ind) {
            this.curBgIndex = ind;
            $('#shell-box-innerBg').css('background-image', 'url(' + item + ')');
        },

        //微信群发
        wxUP: function wxUP() {
            var _this12 = this;

            this.weChatModel.name = this.weChatModel.name.replace(/(^\s*)|(\s*$)/g, "");
            if (!this.weChatModel.name) {
                this.$message({
                    message: '请输入店铺名称',
                    customClass: 'error'
                });
                return;
            }
            this.weChatModel.ACtitle = this.weChatModel.ACtitle.replace(/(^\s*)|(\s*$)/g, "");
            if (!this.weChatModel.ACtitle) {
                this.$message({
                    message: '请输入活动主题',
                    customClass: 'error'
                });
                return;
            }
            this.weChatModel.address = this.weChatModel.address.replace(/(^\s*)|(\s*$)/g, "");
            if (!this.weChatModel.address) {
                this.$message({
                    message: '请输入店铺地址',
                    customClass: 'error'
                });
                return;
            }
            this.weChatModel.rules = this.weChatModel.rules.replace(/(^\s*)|(\s*$)/g, "");
            if (!this.weChatModel.rules) {
                this.$message({
                    message: '请输入活动内容或规则',
                    customClass: 'error'
                });
                return;
            }
            if (new Date(this.weChatModel.timeFrom).getTime() > new Date(this.weChatModel.timeTo).getTime()) {
                this.$message({
                    message: '活动开始时间应小于结束时间!',
                    customClass: 'error'
                });
                return;
            }
            var oldCode = encodeURI(this.weChatModel.rules);
            var arr = oldCode.split('%0A');
            var contentCode = '';
            var viceContentCode = '';
            for (var i = 0, len = arr.length; i < len; i++) {
                viceContentCode += '<p>' + decodeURI(arr[i]) + '</p>';
                contentCode += decodeURI(arr[i]) + '\n';
            }
            var body = {
                id: this.$uuid.create(1).hex,
                storeId: this.curStoreId,
                storeName: this.weChatModel.name,
                theme: this.weChatModel.ACtitle, //主题
                time: new Date(this.weChatModel.timeFrom).Format('yyyy.MM.dd') + '-' + new Date(this.weChatModel.timeTo).Format('yyyy.MM.dd'), //时间
                address: this.weChatModel.address,
                content: contentCode,
                viceContent: viceContentCode,
                contextUrl: this.bgArr[this.curBgIndex]
            };
            this.$http.post('wechat-send-template', body).then(function (res) {
                _this12.$message({
                    message: '提交成功，请及时支付！',
                    customClass: 'success'
                });
                _this12.payUrl = res.data.url;
                _this12.seep = 2;
                _this12.payTimer = setInterval(function () {
                    _this12.$http.get('query/store-orders?id=' + res.data.id).then(function (ress) {

                        if (ress.status == 200) {
                            clearInterval(_this12.payTimer);
                            _this12.$message({
                                message: '支付成功！',
                                customClass: 'success'
                            });
                            _this12.seep = 1;
                            _this12.weChatBtn = false;
                        }
                    }).catch(function (err) {
                        clearInterval(_this12.payTimer);
                    });
                }, 2000);
            });
        },

        //修改备注
        notesFn1: function notesFn1(item, type) {
            if (type == 'name') {
                this.notes.name = item.name;
                this.notes.mobile = '';
            } else if (type == 'mobile') {
                this.notes.mobile = item.mobile;
                this.notes.name = '';
            }
            this.notes.type = type;
            this.notesBtn = true;
            this.memberDetailId = item.memberId;
        },

        //修改备注
        notesFn: function notesFn() {
            var _this13 = this;

            if (this.notes.type == 'mobile') {
                if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.notes.mobile)) {
                    this.$message({
                        message: "请输入正确的手机号",
                        customClass: "error"
                    });
                    return;
                }
            }
            if (this.notes.type == 'name') {
                this.notes.name = this.notes.name.replace(/(^\s*)|(\s*$)/g, "");
                if (!this.notes.name) {
                    this.$message({
                        message: "名字格式不对",
                        customClass: "error"
                    });
                    return;
                }
            }
            var body = {
                storeId: this.curStoreId,
                memberId: this.memberDetailId,
                name: this.notes.name,
                mobile: this.notes.mobile
            };
            this.$http.post('remark-member', body).then(function (res) {
                _this13.notesBtn = false;
                _this13.notes.name = '';
                _this13.notes.mobile = '';
                _this13.curPage = 0;
                if (_this13.timeSort) {
                    _this13.getVipData("TIME", _this13.nowTimeSort);
                } else if (_this13.addTimeSort) {
                    _this13.getVipData("addTime", _this13.nowAddTimeSort);
                } else {
                    _this13.getVipData("AMOUNT", "DOWN");
                }
            });
        },

        //查看会员商品数据
        vipOrderProductDetail: function vipOrderProductDetail(item) {
            this.vipOrderProductArr = item;
            this.vipOrderProductBtn = true;
        },

        //获取会员详情  数据
        vipDetail: function vipDetail() {
            var _this14 = this;

            this.vipDetailArr = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
            this.$http.get('/member-sales?storeId=' + this.curStoreId + '&page=' + this.WKcurPage + '&pageSize=' + this.pageSize + '&memberId=' + this.memberDetailId).then(function (res) {
                _this14.vipDetailArr = res.data.content;
                _this14.WKtotalPage = res.data.totalPages;
                _this14.WKtotalElements = res.data.totalElements;
                _this14.vipDetailBtn = true;
                if (_this14.vipDetailArr.length < _this14.pageSize) {
                    for (var i = 0, len = _this14.pageSize - _this14.vipDetailArr.length; i < len; i++) {
                        _this14.vipDetailArr.push({});
                    }
                }
            }).catch(function (res) {});
        },

        //获取会员详情memberId
        vipDetail1: function vipDetail1(item) {
            this.WKcurPage = 0;
            this.memberDetailId = item.memberId;
            this.vipDetail();
        },

        //获取会员资料
        getVipData: function getVipData(source, direction) {
            var _this15 = this;

            this.vipData = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

            this.$http({
                url: this.curStoreId + '/member',
                method: "GET",
                params: {
                    page: this.curPage,
                    pageSize: 10,
                    type: this.vipType,
                    source: source,
                    direction: direction
                }
            }).then(function (res) {
                // this.vipData = res.data.consumptions;
                _this15.totalAmount = res.data.amount;
                _this15.vipData = res.data.data;
                // this.vipDataLength = res.data.consumptions.length;
                _this15.vipDataLength = res.data.data.length;
                _this15.totalElements = res.data.totalElements;
                _this15.totalPage = res.data.totalPages;
                for (var i = 0, len = _this15.vipData.length; i < len; i++) {
                    _this15.vipData[i].amountBonus = (_this15.vipData[i].bonus + _this15.vipData[i].amount).toFixed(2);
                }
                if (_this15.vipData.length < _this15.pageSize) {
                    for (var _i = 0, _len = _this15.pageSize - _this15.vipData.length; _i < _len; _i++) {
                        _this15.vipData.push({
                            "id": '',
                            "memberId": '',
                            "memberName": '',
                            "storeId": '',
                            "code": '',
                            "referralMemberId": '', //推荐人id
                            "mobile": '', //推荐人name
                            "frequency": '', //频次
                            "allFrequency": '', //总次数
                            "amount": '' //金额
                        });
                    }
                }
            });

            // this.$http.get(this.curStoreId+'/member?page='+this.curPage+'&type='+this.vipType).then((res)=>{
            //     // this.vipData = res.data.consumptions;
            //     this.totalAmount = res.data.amount;
            //     this.vipData = res.data.data;
            //     // this.vipDataLength = res.data.consumptions.length;
            //     this.vipDataLength = res.data.data.length;
            //     this.totalElements = res.data.totalElements;
            //     this.totalPage = res.data.totalPages;
            //     for(let i = 0, len = this.vipData.length; i < len; i++){
            //         this.vipData[i].amountBonus =  (this.vipData[i].bonus+this.vipData[i].amount).toFixed(2)
            //     }
            //     if( this.vipData.length < this.pageSize ){
            //         for(let i = 0, len = this.pageSize - this.vipData.length; i < len; i++){
            //             this.vipData.push({
            //                 "id": '',
            //                 "memberId": '',
            //                 "memberName": '',
            //                 "storeId": '',
            //                 "code": '',
            //                 "referralMemberId": '',//推荐人id
            //                 "mobile": '',//推荐人name
            //                 "frequency": '',//频次
            //                 "allFrequency": '',//总次数
            //                 "amount": '',//金额
            //             })
            //         }
            //     }
            // })
        }
    },
    created: function created() {
        console.log(this.storeData);
        for (var i = 0; i < this.pageSize; i++) {
            this.vipData.push({});
        }
    },
    activated: function activated() {
        if (this.$route.params.type == 'LOST') {
            this.vipType = 'lost';
        }
        var qtyOptions = [];
        for (var i = 0; i < 30; i++) {
            var obj = {
                title: i + 1 + '\u5F20',
                value: i + 1
            };
            qtyOptions.push(obj);
        }
        this.qtyOptions = qtyOptions;
        this.getVipData("AMOUNT", "DOWN");
    }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            showPutAllMask: false, //交班明细控制按钮
            workData: [],
            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0, //总共条
            paytype: { 'MEMBER_DEPOSIT': '充值', 'SALES': '消费' },
            getBtn: true, // 控制翻页请求

            inventoryList: [], //交班明细
            allarr: [],
            WKcurPage: 0, //当前页，用于切换页码
            WKtotalPage: 1, //总共页
            WKtotalElements: 0 //总共条
        };
    },

    methods: {
        //列表翻页
        changePage: function changePage(boo) {
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            this.getWordData();
        },
        //明细翻页
        changeDetailPage: function changeDetailPage(boo) {
            if (boo) {
                if (this.WKcurPage + 1 >= this.WKtotalPage) {
                    return;
                }
                this.WKcurPage++;
            } else {
                if (this.WKcurPage <= 0) {
                    return;
                }
                this.WKcurPage--;
            }
            this.getDetail();
        },
        //获取消费记录列表
        getWordData: function getWordData() {
            var _this = this;

            if (!this.getBtn) {
                return;
            }
            this.getBtn = false;
            this.$http.get('/member-sales?storeId=' + this.curStoreId + '&page=' + this.curPage + '&pageSize=' + this.pageSize).then(function (res) {
                _this.workData = res.data.content;
                _this.totalPage = res.data.totalPages;
                _this.totalElements = res.data.totalElements;
                if (_this.workData.length < _this.pageSize) {
                    for (var i = 0, len = _this.pageSize - _this.workData.length; i < len; i++) {
                        _this.workData.push({});
                    }
                }
                for (var _i = 0, _len = _this.workData.length; _i < _len; _i++) {
                    if (_this.workData[_i].id) {
                        _this.workData[_i].amount = _this.workData[_i].amount.toFixed(2);
                    }
                }
                _this.getBtn = true;
            }).catch(function () {
                _this.getBtn = true;
            });
        },

        //更换某消费明细的id
        cutDetail: function cutDetail(item) {
            this.WKcurPage = 0;
            this.allarr = item.items;
            this.showPutAllMask = true;
            this.WKtotalPage = item.items.length % 10 == 0 ? parseInt(item.items.length / 10) : parseInt(item.items.length / 10) + 1;
            this.WKtotalElements = item.items.length;
            this.getDetail();
        },

        //分页函数
        getDetail: function getDetail() {
            this.inventoryList = [];
            var starNum = this.WKcurPage * 10; //开始页码
            var endNum = starNum + 10 >= this.WKtotalElements ? this.WKtotalElements : this.WKcurPage + 10; //最后页码
            for (var i = starNum; i < endNum; i++) {
                if (this.allarr[i]) {
                    // this.allarr[i].salesPrice = this.allarr[i].salesPrice.toFixed(2);
                    this.inventoryList.push(this.allarr[i]);
                }
            }
        }

    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.workData.push({});
        }
    },
    mounted: function mounted() {
        this.getWordData();
    }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize'],
    data: function data() {
        return {
            dialogVisible: false,
            vipData: []
        };
    },

    methods: {
        getVipData: function getVipData() {
            var _this = this;

            this.$http.get('/members?storeId=' + this.curStoreId).then(function (res) {
                _this.vipData = res.data;
                for (var i = 0, len = _this.vipData.length; i < len; i++) {
                    _this.vipData[i].amountBonus = (_this.vipData[i].bonus + _this.vipData[i].amount).toFixed(2);
                }
                if (_this.vipData.length < _this.pageSize) {
                    for (var _i = 0, _len = _this.pageSize - _this.vipData.length; _i < _len; _i++) {
                        _this.vipData.push({});
                    }
                }
            });
        },

        // 删除会员
        delteVipMan: function delteVipMan(item) {
            var _this2 = this;

            this.$confirm('此操作将删除该会员, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.$http.delete('/members/' + item.id).then(function (res) {
                    _this2.getVipData();
                });
            }).catch(function () {});
        },
        addVipMan: function addVipMan() {
            var vipMan = {
                "id": this.$uuid.create(1).hex,
                "name": '酱HMP',
                "storeId": this.curStoreId,
                "code": this.$uuid.create(1).hex,
                "referralMemberId": '', //推荐人id
                "referralMemberName": 'yuzijiang', //推荐人name
                "points": 3, //积分
                "amount": 30 //金额
            };
            this.$http.put('/members', vipMan).then(function (res) {
                console.log(res);
            });
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.vipData.push({});
        }
    },
    mounted: function mounted() {
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-qihuan');
            $('.el-message-box__header .el-message-box__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
        this.getVipData();
        // this.addVipMan();
    }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['pageSize', 'curStoreId'],
    data: function data() {
        return {
            dialogVisible: false,
            addRechargeBtn: false, //添加规则按钮
            rulesData: [], //规则列表
            deposit: '', //充值金额
            bonus: '', //赠送金额
            name: '充值' + (this.deposit ? this.deposit : 0) + '送' + (this.bonus ? this.bonus : 0), //显示名字
            rulesId: '' //规则id
        };
    },


    watch: {
        deposit: function deposit(val) {
            this.name = '充值' + (val ? val : 0) + '送' + (this.bonus ? this.bonus : 0);
        },
        bonus: function bonus(val) {
            this.name = '充值' + (this.deposit ? this.deposit : 0) + '送' + (val ? val : 0);
        }
    },
    methods: {
        //删除规则
        delRules: function delRules(item) {
            var _this = this;

            this.$confirm('此操作将删除该充值规则, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                //删除规则
                _this.$http.delete('charge-rules/' + item.id).then(function (res) {
                    _this.getRules();
                });
            }).catch(function () {});
        },

        //新建或更新规则
        rechargeFn: function rechargeFn(id) {
            var _this2 = this;

            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.deposit)) {
                this.$message({
                    message: '充值金额格式有误',
                    customClass: 'error'
                });
                return;
            }
            if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.bonus)) {
                this.$message({
                    message: '赠送金额格式有误',
                    customClass: 'error'
                });
                return;
            }
            var sendBody = {
                "storeId": this.curStoreId,
                "name": this.name,
                "depositAmount": parseFloat(this.deposit),
                "bonusAmount": parseFloat(this.bonus)
            };
            this.$http.put('charge-rules/' + this.rulesId, sendBody).then(function (res) {
                _this2.getRules();
                _this2.addRechargeBtn = false;
                _this2.deposit = '';
                _this2.bonus = '';
                _this2.$message({
                    message: '操作成功！',
                    customClass: 'success'
                });
            });
        },
        showUpBox: function showUpBox(item) {
            this.name = item.name;
            this.rulesId = item.id ? item.id : this.$uuid.create(1).hex;
            this.addRechargeBtn = true;
        },
        getRules: function getRules() {
            var _this3 = this;

            //获取规则列表
            this.$http.get('charge-rules?storeId=' + this.curStoreId).then(function (res) {
                _this3.rulesData = res.data;
                if (_this3.rulesData.length < _this3.pageSize) {
                    for (var i = 0, len = _this3.pageSize - _this3.rulesData.length; i < len; i++) {
                        _this3.rulesData.push({});
                    }
                }
            });
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.rulesData.push({});
        }
    },
    activated: function activated() {
        this.getRules();
    }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['curStoreId', 'pageSize', 'storeData'],
    data: function data() {
        return {
            count: 0,
            nowCodeName: "", //当前二维码的名称
            isOuting: true, //正在导出中
            isOutSuc: true,
            allCodeList: [], //所有的二维码地址
            codeInfo: "",
            wechatList: [],
            infoload: false, // loading
            codeBtn: false,
            tableNo: "",
            name: "",
            showCode: false,
            totalElements: 0,
            nowPage: 0,
            curItem: { id: null }
        };
    },

    watch: {
        codeBtn: function codeBtn(val) {
            if (!val) {
                console.log(val);
                this.curItem = { id: null };
                this.tableNo = "";
            }
        }
    },
    methods: {
        saveImg: function saveImg() {
            // html2canvas($("#img-info"),{
            //     height: $("#img-info").outerHeight() + 20,  
            //     width: $("#img-info").outerWidth() + 20  ,
            //     onrendered: function(canvas) {
            //         //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
            //         var timestamp = Date.parse(new Date());
            //         //把截取到的图片替换到a标签的路径下载  
            //         $("#down-img").attr('href',canvas.toDataURL());  
            //         //下载下来的图片名字  
            //         $("#down-img").attr('download',timestamp + '.png');
            //     }
            // });
            html2canvas(document.querySelector("#img-info")).then(function (canvas) {
                $("#down-img").attr('href', canvas.toDataURL());
                var timestamp = Date.parse(new Date());
                $("#down-img").attr('download', timestamp + '.png');
            });
        },

        // 批量导出start
        outAll: function outAll() {
            var _this = this;

            // 首先获取所有的二维码地址
            this.$http({
                url: "url-order",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: 0,
                    size: 500
                }
            }).then(function (res) {
                _this.allCodeList = res.data.content;
            });
        },
        out: function out() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var zip, cache, arr, allCodeList, i, forDrawRes;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this2.isOutSuc = false;
                                zip = new __WEBPACK_IMPORTED_MODULE_3_jszip___default.a();
                                cache = {};
                                arr = [];
                                allCodeList = [];

                                _this2.count = 0;

                                for (i = 0; i < _this2.allCodeList.length; i++) {
                                    if (_this2.allCodeList[i].id) {
                                        allCodeList.push(_this2.allCodeList[i]);
                                    }
                                }
                                _context.next = 9;
                                return _this2.forDraw(allCodeList, cache, arr, zip);

                            case 9:
                                forDrawRes = _context.sent;


                                console.log("------------------------------------");
                                console.log(cache);

                                _context.next = 14;
                                return _this2.doPackge(zip);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        forDraw: function forDraw(allCodeList, cache, arr, zip) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var i, codeRes, canvas, saveRes, _codeRes, _canvas, _saveRes;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                i = 0;

                            case 1:
                                if (!(i < allCodeList.length)) {
                                    _context2.next = 20;
                                    break;
                                }

                                console.log(decodeURIComponent(allCodeList[i].name));
                                _this3.nowCodeName = decodeURIComponent(allCodeList[i].name);
                                // 生成二维码
                                console.log("生成二维码");
                                _context2.next = 7;
                                return _this3.createCode(allCodeList[i]);

                            case 7:
                                codeRes = _context2.sent;

                                // 画图
                                console.log("画图");
                                _context2.next = 11;
                                return _this3.drawImg();

                            case 11:
                                canvas = _context2.sent;

                                // 存储在对象中
                                console.log("存储在对象中");
                                // console.log(canvas);
                                _context2.next = 15;
                                return _this3.savePack(allCodeList[i], cache, canvas, arr, zip, i);

                            case 15:
                                saveRes = _context2.sent;

                                _this3.count++;

                            case 17:
                                i++;
                                _context2.next = 1;
                                break;

                            case 20:
                                if (!allCodeList.length) {
                                    _context2.next = 35;
                                    break;
                                }

                                console.log(decodeURIComponent(allCodeList[0].name));
                                _this3.nowCodeName = decodeURIComponent(allCodeList[0].name);
                                // 生成二维码
                                console.log("生成二维码");
                                _context2.next = 26;
                                return _this3.createCode(allCodeList[0]);

                            case 26:
                                _codeRes = _context2.sent;

                                // 画图
                                console.log("画图");
                                _context2.next = 30;
                                return _this3.drawImg();

                            case 30:
                                _canvas = _context2.sent;

                                // 存储在对象中
                                console.log("存储在对象中");
                                // console.log(canvas);
                                _context2.next = 34;
                                return _this3.savePack(allCodeList[0], cache, _canvas, arr, zip, 0);

                            case 34:
                                _saveRes = _context2.sent;

                            case 35:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },

        //打包    
        savePack: function savePack(item, cache, canvas, arr, zip, i) {
            var timestamp = Date.parse(new Date());
            // let file_name = decodeURIComponent(item.name)+'_'+timestamp; // 获取文件名
            var file_name = decodeURIComponent(item.name); // 获取文件名
            zip.file(file_name + '.png', canvas.toDataURL('image/jpeg').replace('data:image/jpeg;base64,', ''), {
                base64: true
            });
            // 逐个添加文件
            cache[file_name] = canvas;
            // console.log(cache);
            // arr.push(i);
        },

        // 生成二维码
        createCode: function createCode(item) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var doCode;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                doCode = function doCode(item) {
                                    document.getElementById("qrcode-all").innerHTML = "";
                                    var qrcode = new QRCode("qrcode-all", {
                                        text: item.url,
                                        width: 200,
                                        height: 200,
                                        colorDark: "#000000",
                                        colorLight: "#ffffff",
                                        correctLevel: QRCode.CorrectLevel.H
                                    });
                                };

                                _context3.next = 3;
                                return doCode(item);

                            case 3:
                                return _context3.abrupt('return', _context3.sent);

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },

        // 画图
        drawImg: function drawImg() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var doRraw;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                doRraw = function doRraw() {
                                    return html2canvas(document.querySelector("#img-info-all")).then(function (canvas) {
                                        // canvas.width = 200;
                                        // canvas.height = 200;
                                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(canvas);
                                    });
                                };

                                _context4.next = 3;
                                return doRraw();

                            case 3:
                                return _context4.abrupt('return', _context4.sent);

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },

        // 批量导出end
        doChange: function doChange(item) {
            this.codeBtn = true;
            this.tableNo = decodeURIComponent(item.name);
            this.curItem = item;
        },

        // 打包
        doPackge: function doPackge(zip) {
            console.log(zip);
            // 打包
            zip.generateAsync({
                type: "blob"
            }).then(function (content) {
                // 生成二进制流
                __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(content, "qrcode.zip"); // 利用file-saver保存文件
            });
            this.isOutSuc = true;
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.getWechatList(val - 1);
            this.nowPage = val;
        },
        showCodeImg: function showCodeImg(item) {
            var _this6 = this;

            this.showCode = true;
            this.codeInfo = decodeURIComponent(item.name);
            // this.codeInfo = item.name;
            setTimeout(function () {
                $('#qrcode')[0].innerHTML = '';
            }, 300);

            setTimeout(function () {
                var qrcode = new QRCode("qrcode", {
                    text: item.url,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H
                });
            }, 500);

            setTimeout(function () {
                _this6.saveImg();
            }, 1000);
        },
        addWechatOrder: function addWechatOrder() {
            var _this7 = this;

            if (!this.tableNo) {
                this.$message({
                    message: '请填写桌号',
                    customClass: 'error'
                });
                return;
            }
            this.$http({
                url: "url-merge",
                method: "POST",
                data: {
                    id: this.curItem.id ? this.curItem.id : 0,
                    storeId: this.curStoreId,
                    tableNo: encodeURIComponent(this.tableNo),
                    name: encodeURIComponent(this.tableNo)
                }
            }).then(function (res) {
                if (res.data.code == 200) {
                    _this7.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    _this7.curItem = { id: null };
                    _this7.tableNo = "";
                    _this7.codeBtn = false;
                    _this7.getWechatList(_this7.nowPage - 1);
                } else if (res.data.code == 400) {
                    _this7.$message({
                        message: res.data.msg,
                        customClass: 'error'
                    });
                }
            });
        },
        doActive: function doActive(item) {
            var _this8 = this;

            this.$confirm('此操作将删除该桌号的微信点单, 确认此操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this8.$http({
                    url: "url-delete",
                    method: "POST",
                    data: {
                        id: item.id
                    }
                }).then(function (res) {
                    _this8.$message({
                        message: '操作成功',
                        customClass: 'success'
                    });
                    _this8.getWechatList(_this8.nowPage - 1);
                });
            }).catch(function () {});
        },
        getWechatList: function getWechatList(page) {
            var _this9 = this;

            this.$http({
                url: "url-order",
                method: "GET",
                params: {
                    storeId: this.curStoreId,
                    page: page,
                    size: this.pageSize
                }
            }).then(function (res) {
                _this9.wechatList = res.data.content;
                _this9.totalElements = res.data.totalElements;
                var number = _this9.pageSize - _this9.wechatList.length;
                if (number > 0) {
                    for (var i = 0; i < number; i++) {
                        _this9.wechatList.push({});
                    }
                }
                _this9.outAll();
            });
        }
    },
    activated: function activated() {
        for (var i = 0; i < this.pageSize; i++) {
            this.wechatList.push({});
        }

        this.getWechatList(0);
    },
    mounted: function mounted() {
        // this.outAll();
        // 改变关闭样式
        $(document).ready(function () {
            $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
        });
    }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_imgCrop_imgCrop_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_imgCrop_imgCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_imgCrop_imgCrop_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "voiceCall",
    components: { imgCrop: __WEBPACK_IMPORTED_MODULE_0__components_imgCrop_imgCrop_vue___default.a },
    props: ['curStoreId'],
    data: function data() {
        return {
            nowFontCount: 0,
            desc: "",
            showCrop: false,
            oldImgBase64: "",
            curCropW: 600, // 裁剪宽度
            curCropH: 600, // 裁剪高度
            logoImgUrl: ""
        };
    },

    watch: {
        desc: function desc(val) {
            this.nowFontCount = val.length;
            if (val.length >= 300) {
                this.$message({
                    message: '已达到最大字数限制',
                    customClass: 'error'
                });
            }
        }
    },
    methods: {
        //上传图片
        cropImg: function cropImg(e) {
            var reader = new FileReader();
            var that = this;
            var fileObj = e.target.files[0];

            if (e.target.files.length == 0) {
                return false;
            }

            // 判断图片大小
            if (fileObj.size > this.coverImgMaxSize) {
                this.errorMsg = '上传图片的大小不能超过5MB';
                this.openErrorTip = true;
                this.$message({
                    message: '上传图片的大小不能超过5MB',
                    customClass: 'error'
                });
                return false;
            }

            reader.onload = function (file) {
                return function (e) {
                    var _this = this; // 缓存当前this
                    var img = new Image();
                    img.src = this.result;
                    img.onload = function () {
                        var imgBase64 = _this.result; //获得图片的base64的数据
                        that.oldImgBase64 = imgBase64;
                        that.showCrop = true;
                    };
                };
            }(e.target.files[0]);

            reader.readAsDataURL(e.target.files[0]);
        },

        // 获得裁剪后图片base64
        getCropImgBase: function getCropImgBase(imgUrl) {
            this.logoImgUrl = imgUrl;
        },

        // 上传店铺信息
        uploadStoreInfo: function uploadStoreInfo() {
            var _this2 = this;

            this.$http({
                url: "update-storeDetail",
                method: "POST",
                data: {
                    storeId: this.curStoreId,
                    detail: this.desc,
                    logo: this.logoImgUrl
                }
            }).then(function (res) {
                console.log(res);
                if (res.status == 200) {
                    _this2.$message({
                        message: res.data,
                        customClass: 'success'
                    });
                }
            });
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        this.$http({
            url: "stores/" + this.curStoreId,
            method: "GET"
        }).then(function (res) {
            console.log(res);
            if (res.status == 200) {
                _this3.logoImgUrl = res.data.storeLogo;
                _this3.desc = res.data.summary;
            }
        });
    }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    components: { imgCrop: __WEBPACK_IMPORTED_MODULE_1__components_imgCrop_imgCrop_vue___default.a },
    props: ['pageSize', 'curStoreId'],
    data: function data() {
        return {
            selectItem: null,
            isChangeCoupon: false,
            dialogVisible: false,
            addCouponBtn: false, //添加规则按钮
            couponList: [], //规则列表
            rulesId: '', //规则id
            couponType: 'GET_ITEM_FREE',
            couponTypeText: {
                'GET_ITEM_FREE': '商品抵用券'
            },
            newCoupon: {
                name: "",
                startAmount: "",
                useAmount: "",
                giveAmount: "",
                startTime: "",
                endTime: ""
            },
            shareable: 'OFF', // 是否可分享
            goodCheckArr: [], // 商品检索数组
            keyWords: '', // 商品检索关键字
            goodSearchBtn: true, // 控制商品检索请求
            curGoodIdx: 0, // 商品检索索引

            coverImgMaxSize: 200 * 1024, // 图片最大字节数
            oldImgBase64: '', // 原图base64
            showCrop: false, // 控制图片裁剪显示隐藏
            curCropW: 600, // 裁剪宽度
            curCropH: 600, // 裁剪高度
            infoload: false, // loading

            curPage: 0, //当前页，用于切换页码
            totalPage: 1, //总共页
            totalElements: 0, //总共条

            addCouponApiBtn: true, // 控制新增接口

            pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 86400000;
                }
            },
            timeFromTo: ['', ''],
            startTime: '',
            endTime: ''
        };
    },


    watch: {
        keyWords: function keyWords(val) {
            if (this.newCoupon.productName == this.keyWords) {
                this.goodCheckArr = [];
                return;
            }
            this.goodSearch();
        },
        addCouponBtn: function addCouponBtn(val) {
            if (!val) {
                this.isChangeCoupon = false;
            }
        }
    },
    methods: {
        showUpBox: function showUpBox(item) {
            this.timeTo = '';
            this.timeFrom = '';
            this.addCouponBtn = true;
            this.newCoupon = {
                id: this.$uuid.create(1).hex, // 新优惠券id
                title: '', // 名称
                notice: '1、每位会员每单限使用一张，不可叠加使用。 2、本券不可兑换现金且不退不换，不与其它活动同享，使用本券不提供发票。 3、由网管通过店员宝向顾客派发本券。 4、一切解释权归发行方所有', // 使用说明
                description: '', // 详细说明
                type: 'GET_ITEM_FREE', // 优惠券类型
                productId: '', // 商品id
                productName: '', // 商品名称
                source: 'STORE', // 优惠券来源
                storeId: this.curStoreId, // 店铺id
                shareable: true, // 是否可分享
                expireDays: 1, // 过期时间
                logoURL: 'https://hxypic.oss-cn-hangzhou.aliyuncs.com/image/660e7964-7f08-11e7-b600-15739cd8b3d5/4db97466006a4e6daad1c71370ba8333.jpg' // 优惠券图片
            };
            this.keyWords = '';
            this.shareable = 'ON';
        },

        // 保存代金券
        saveCoupon: function saveCoupon() {
            var _this = this;

            if (!this.newCoupon.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return;
            }

            if (!this.startTime) {
                this.$message({
                    message: '请选择代金券使用开始时间',
                    customClass: 'error'
                });
                return;
            }
            if (!this.endTime) {
                this.$message({
                    message: '请选择代金券过期时间',
                    customClass: 'error'
                });
                return;
            }
            if (new Date(this.endTime).getTime() < new Date(this.startTime).getTime()) {
                this.$message({
                    message: '开始时间不能大于过期时间',
                    customClass: 'error'
                });
                return;
            }
            if (!this.addCouponApiBtn) {
                return;
            }
            this.addCouponApiBtn = false;
            var storeName = JSON.parse(sessionStorage.getItem("storeName"));
            if (!storeName) {
                this.$message({
                    message: '请重新登录后执行添加操作',
                    customClass: 'error'
                });
                return;
            }
            if (!this.isChangeCoupon) {
                var aNewCoupon = {
                    couponName: this.newCoupon.name,
                    startAmount: this.newCoupon.startAmount,
                    giveAmount: this.newCoupon.giveAmount,
                    useAmount: this.newCoupon.useAmount,
                    startTime: new Date(this.startTime).Format('yyyy-MM-dd'),
                    endTime: new Date(this.endTime).Format('yyyy-MM-dd'),
                    storeId: this.curStoreId,
                    storeName: storeName
                };
                this.$http.post('add-coupon', aNewCoupon).then(function (res) {
                    _this.addCouponApiBtn = true;
                    _this.addCouponBtn = false;
                    _this.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    _this.getCouponList();
                    return;
                }).catch(function () {
                    _this.addCouponApiBtn = true;
                });
            } else {
                var _aNewCoupon = {
                    couponName: this.newCoupon.name,
                    startAmount: this.newCoupon.startAmount,
                    giveAmount: this.newCoupon.giveAmount,
                    useAmount: this.newCoupon.useAmount,
                    startTime: new Date(this.startTime).Format('yyyy-MM-dd'),
                    endTime: new Date(this.endTime).Format('yyyy-MM-dd'),
                    id: this.selectItem.id
                };
                this.$http.post('update-coupon', _aNewCoupon).then(function (res) {
                    _this.addCouponApiBtn = true;
                    _this.addCouponBtn = false;
                    _this.$message({
                        message: res.data.msg,
                        customClass: 'success'
                    });
                    _this.getCouponList();
                    _this.isChangeCoupon = false;
                    return;
                }).catch(function () {
                    _this.addCouponApiBtn = true;
                });
            }
        },
        // 删除优惠券
        delCoupon: function delCoupon(couponId) {
            var _this2 = this;

            this.$confirm('此操作将删除该代金券, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.$http.post('delete-coupon', { id: couponId }).then(function (res) {
                    _this2.$message({
                        message: '删除成功',
                        customClass: 'success'
                    });
                    _this2.getCouponList();
                });
            }).catch(function () {});
        },

        // 修改优惠券
        uploadCoupon: function uploadCoupon(item) {
            this.selectItem = item;
            if (!item.startTime) {
                this.startTime = '';
                this.endTime = '';
            } else {
                this.startTime = new Date(item.startTime);
                this.endTime = new Date(item.endTime);
            }
            this.newCoupon = {
                name: item.couponName,
                startAmount: item.startAmount,
                giveAmount: item.giveAmount,
                useAmount: item.useAmount
            };
            this.addCouponBtn = true;
            this.isChangeCoupon = true;
        },
        //列表翻页
        changePage: function changePage(boo) {
            if (boo) {
                if (this.curPage + 1 >= this.totalPage) {
                    return;
                }
                this.curPage++;
            } else {
                if (this.curPage <= 0) {
                    return;
                }
                this.curPage--;
            }
            this.getCouponList();
        },
        // 获取优惠券列表
        getCouponList: function getCouponList() {
            var _this3 = this;

            this.$http.get('all-coupon?storeId=' + this.curStoreId).then(function (res) {
                _this3.couponList = res.data;
            }).catch(function () {});
        },
        // 选择检索商品
        selSearchGood: function selSearchGood(item) {
            // console.log(item);
            this.newCoupon.productName = item.name;
            this.newCoupon.productId = item.id;
            this.keyWords = item.name;
            this.goodCheckArr = [];
        },
        // 商品检索
        goodSearch: function goodSearch() {
            var _this4 = this;

            var val = this.keyWords;
            if (!val) {
                this.goodCheckArr = [];
                return;
            }
            if (!this.goodSearchBtn) {
                return;
            }
            this.goodSearchBtn = false;
            this.$http.get('products/search?storeId=' + this.curStoreId + '&q=' + encodeURI(val)).then(function (res) {
                _this4.goodCheckArr = res.data;
                var btn = true;
                for (var i = 0, len = _this4.goodCheckArr.length; i < len; i++) {
                    if (_this4.keyWords == _this4.goodCheckArr[i].name) {
                        _this4.newCoupon.productId = _this4.goodCheckArr[i].id;
                        _this4.newCoupon.productName = _this4.goodCheckArr[i].name;
                        btn = false;
                        break;
                    }
                }
                if (btn) {
                    _this4.newCoupon.productName = '';
                    _this4.newCoupon.productId = '';
                }

                setTimeout(function () {
                    var that = _this4;
                    $('.goodCheckList li').hover(function () {
                        that.curGoodIdx = $(this).index() - 1;
                    }, function () {
                        that.curGoodIdx = 0;
                    });
                }, 0);
                _this4.goodSearchBtn = true;
            }).catch(function () {
                _this4.goodSearchBtn = true;
            });
        },
        coverImg: function coverImg(e) {
            var reader = new FileReader();
            var that = this;
            var fileObj = e.target.files[0];

            if (e.target.files.length == 0) {
                return false;
            }

            // 判断图片大小
            if (fileObj.size > this.coverImgMaxSize) {
                this.errorMsg = '上传图片的大小不能超过200KB';
                this.openErrorTip = true;
                this.$message({
                    message: '上传图片的大小不能超过200KB',
                    customClass: 'error'
                });
                return false;
            }

            reader.onload = function (file) {
                return function (e) {
                    var that2 = this; // 缓存当前this
                    var img = new Image();
                    img.src = this.result;
                    img.onload = function () {
                        var imgBase64 = that2.result; //获得图片的base64的数据


                        // 判断是否是移动端设备
                        var sUserAgent = navigator.userAgent.toLowerCase();
                        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
                        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                        var bIsAndroid = sUserAgent.match(/android/i) == "android";
                        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                            that.mobileUploadImg(imgBase64);
                        } else {
                            that.oldImgBase64 = imgBase64;
                            that.showCrop = true;
                        }
                    };
                    $('.pcImgFile').val('');
                    $('.mobileImgFile').val('');
                };
            }(e.target.files[0]);
            reader.readAsDataURL(e.target.files[0]);
        },
        // 移动端上传图片
        mobileUploadImg: function mobileUploadImg(imgBase64) {
            var _this5 = this;

            this.infoload = true;
            this.$http.post(__WEBPACK_IMPORTED_MODULE_2__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/image/json/upload?storeId=' + this.curStoreId, { file: imgBase64 }).then(function (res) {
                _this5.newCoupon.logoURL = res.data.path;
                _this5.infoload = false;
            }).catch(function () {
                _this5.infoload = false;
            });
        },
        // 获得裁剪后图片base64
        getCropImgBase: function getCropImgBase(imgUrl) {
            this.newCoupon.logoURL = imgUrl;
        }
    },
    created: function created() {
        for (var i = 0; i < this.pageSize; i++) {
            this.couponList.push({});
        }
    },
    mounted: function mounted() {
        this.getCouponList();
    }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_url_js__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            newBatchSite: {
                regionId: "",
                beginIp: "",
                count: ""
            },
            showModifySiteBatch: false,
            siteType: "",
            nowSelRegion: null,
            newSite: {
                name: '',
                id: 0,
                regionId: "",
                ipAddress: "",
                queue: 0
            },
            showModifySite: false,
            // 
            addJobVisible: false,
            btn: false, //分类下拉三角样式
            typeData: [],
            obj: {
                id: 0,
                area: "",
                // qty:"",
                numBegin: ""
            },
            typeBtn: '',
            typeName: '',
            addJobBtn: true,
            systemData: [],
            typeOptions: [],
            typeNameFormat: {}
        };
    },

    watch: {
        showModifySite: function showModifySite(val) {
            if (!val) {
                this.newSite = {
                    name: '',
                    id: 0,
                    regionId: "",
                    ipAddress: "",
                    queue: 0
                };
            }
        }
    },
    methods: {
        getOptions: function getOptions() {
            var _this = this;

            this.$http({
                url: "schedul/type/list",
                method: "GET",
                params: {
                    storeId: this.$route.params.id
                }
            }).then(function (res) {
                var typeNameFormat = {};
                if (Array.isArray(res.data)) {
                    res.data.forEach(function (it) {
                        typeNameFormat[it.id] = it.name;
                    });
                }
                _this.typeNameFormat = typeNameFormat;
                _this.typeOptions = res.data;
            });
        },
        addSiteBatch: function addSiteBatch(item) {
            this.newBatchSite.regionId = item.id;
            this.showModifySiteBatch = true;
        },

        // 
        check: function check() {
            //正则验证方法
            if (!this.obj.area) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            // if(!/^[1-9]\d*|0$/.test(this.obj.qty)){
            //     this.$message({
            //         message: '最大容纳人数输入有误',
            //         customClass: 'error'
            //     })
            //     return true;
            // }
            if (!/^[A-Z]$/.test(this.obj.numBegin)) {
                this.$message({
                    message: '排号起始字母输入有误',
                    customClass: 'error'
                });
                return true;
            }
            return false;
        },
        addDiscount: function addDiscount() {
            var _this2 = this;

            if (this.check()) {
                return;
            }
            this.$http({
                url: "schedul/edit",
                method: "POST",
                data: {
                    storeId: this.$route.params.id,
                    area: this.obj.area,
                    //   qty:this.obj.qty,
                    numBegin: this.obj.numBegin,
                    id: this.obj.id,
                    typeId: this.obj.typeId ? this.obj.typeId : undefined,
                    typeName: this.obj.typeId ? this.typeNameFormat[this.obj.typeId] : undefined
                }
            }).then(function (res) {
                _this2.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                _this2.addJobVisible = false;
                _this2.obj.queue = "";
                _this2.initData();
                _this2.getDataList();
            });
        },
        initData: function initData() {
            this.obj = {
                id: 0,
                area: "",
                // qty:"",
                numBegin: ""
            };
        },

        //添加或者修改分类
        addJob: function addJob() {
            var _this3 = this;

            if (!this.obj.name) {
                this.$message({
                    message: '分类名称有误',
                    customClass: 'error'
                });
                return;
            }
            this.$set(this.obj, "name", this.obj.name.replace(/\s*/g, ""));
            if (this.typeBtn == 1) {
                //添加父类
                var data = {
                    "id": this.$uuid.create(1).hex,
                    "sequence": -1,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": ''
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', data).then(function (res) {
                    _this3.getDataList();
                    _this3.addJobVisible = false;
                    _this3.addJobBtn = true;
                }).catch(function () {
                    _this3.addJobBtn = true;
                });
            } else if (this.typeBtn == 2) {
                //添加子类
                var _data = {
                    "id": this.$uuid.create(1).hex,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.id
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data).then(function (res) {
                    _this3.getDataList();
                    _this3.addJobVisible = false;
                    _this3.addJobBtn = true;
                }).catch(function () {
                    _this3.addJobBtn = true;
                });
            } else if (this.typeBtn == 3) {
                //、、修改父类
                var _data2 = {
                    "id": this.obj.id,
                    "sequence": this.obj.sequence,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": ''
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data2).then(function (res) {
                    _this3.getDataList();
                    _this3.addJobVisible = false;
                    _this3.addJobBtn = true;
                }).catch(function () {
                    _this3.addJobBtn = true;
                });
            } else if (this.typeBtn == 4) {
                //、、修改子类
                var _data3 = {
                    "id": this.obj.id,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.arId
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data3).then(function (res) {
                    _this3.getDataList();
                    _this3.addJobVisible = false;
                    _this3.addJobBtn = true;
                }).catch(function () {
                    _this3.addJobBtn = true;
                });
            }
        },
        sortingChild: function sortingChild(boo, item, ind, pItem) {
            var _this4 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = pItem.children.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": pItem.children[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == pItem.children.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i = 0, _len = pItem.children.length; _i < _len; _i++) {
                    var _body = {
                        "productTypeId": pItem.children[_i].id,
                        "sequence": _i
                    };
                    list.push(_body);
                    if (ind == _i) {
                        list[_i].sequence = _i + 1;
                        num = _i + 1;
                    }
                    if (num == _i) {
                        list[num].sequence = _i - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this4.getDataList();
            }).catch(function (err) {});
        },

        //排序
        sorting: function sorting(boo, item, ind) {
            var _this5 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = this.typeData.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": this.typeData[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == this.typeData.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i2 = 0, _len2 = this.typeData.length; _i2 < _len2; _i2++) {
                    var _body2 = {
                        "productTypeId": this.typeData[_i2].id,
                        "sequence": _i2
                    };
                    list.push(_body2);
                    if (ind == _i2) {
                        list[_i2].sequence = _i2 + 1;
                        num = _i2 + 1;
                    }
                    if (num == _i2) {
                        list[num].sequence = _i2 - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this5.getDataList();
            }).catch(function (err) {});
        },
        getDataList: function getDataList() {
            var _this6 = this;

            this.$http({
                url: "schedul/list",
                method: "GET",
                params: {
                    storeId: this.$route.params.id
                }
            }).then(function (res) {
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        it.children = [];
                        it.isOpen = true;
                        _this6.btn = true;
                        if (it.nums && Array.isArray(it.nums)) {
                            it.children = it.nums;
                        }
                    });
                }
                _this6.typeData = res.data;
            });
        },
        addClassify: function addClassify(id) {
            //添加分类
            this.typeName = "添加/编辑";
            this.obj = {
                name: '',
                id: '',
                arId: ''
            };
            this.addJobVisible = true;
            this.obj.id = id ? id : '';
            this.typeBtn = id ? 2 : 1;
        },
        checkSite: function checkSite() {
            //正则验证方法
            var ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            if (!this.newSite.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            if (!ipReg.test(this.newSite.ipAddress)) {
                this.$message({
                    message: 'ip地址有误',
                    customClass: 'error'
                });
                return true;
            }
            // if(!/^[1-9]\d*|0$/.test(this.newSite.queue)){
            //     this.$message({
            //         message: '排序值输入有误',
            //         customClass: 'error'
            //     })
            //     return true;
            // }
            // 
            if (this.siteType != "edit") {
                if (this.typeData && Array.isArray(this.typeData)) {
                    var typeData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.typeData));
                    var ips = [];
                    typeData.forEach(function (it) {
                        if (it.nums && Array.isArray(it.nums)) {
                            it.nums.forEach(function (ite) {
                                ips.push(ite.ipAddress);
                            });
                        }
                    });
                    if (ips.indexOf(this.newSite.ipAddress) != -1) {
                        this.$message({
                            message: '已添加过此IP',
                            customClass: 'error'
                        });
                        return true;
                    }
                }
            }

            // 
            return false;
        },
        doAddNewSiteBatch: function doAddNewSiteBatch() {
            var _this7 = this;

            var ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            if (!ipReg.test(this.newBatchSite.beginIp)) {
                this.$message({
                    message: 'ip地址有误',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.newBatchSite.count || this.newBatchSite.count < 1) {
                this.$message({
                    message: '数量填写有误',
                    customClass: 'error'
                });
                return true;
            }
            this.$http({
                url: "region/batch/add/num",
                method: "POST",
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.newBatchSite)
            }).then(function (res) {
                _this7.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                _this7.newBatchSite = {
                    regionId: "",
                    beginIp: "",
                    count: ""
                };
                _this7.showModifySiteBatch = false;
                _this7.getDataList();
            });
        },
        doAddNewSite: function doAddNewSite() {
            var _this8 = this;

            if (this.checkSite()) {
                return;
            }
            this.$http({
                url: this.siteType ? "region/edit/num" : "region/add/num",
                method: "POST",
                data: {
                    storeId: this.$route.params.id,
                    name: this.newSite.name,
                    id: this.newSite.id,
                    regionId: this.nowSelRegion.id,
                    ipAddress: this.newSite.ipAddress,
                    queue: this.newSite.queue
                }
            }).then(function (res) {
                _this8.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                if (_this8.siteType == "edit") {
                    _this8.showModifySite = false;
                    _this8.initDataForSite();
                }
                _this8.siteType = "";
                _this8.getDataList();
            });
        },
        initDataForSite: function initDataForSite() {
            this.newSite = {
                name: '',
                id: 0,
                regionId: "",
                ipAddress: "",
                queue: ""
            };
        },
        addSite: function addSite(item) {
            this.siteType = "";
            this.nowSelRegion = item;
            this.showModifySite = true;
        },
        upClassify: function upClassify(item, oitem) {
            //修改分类
            this.typeName = "修改";
            if (!oitem) {
                this.obj = {
                    id: item.id,
                    typeId: item.typeId,
                    area: item.area,
                    qty: item.qty,
                    numBegin: item.numBegin
                };
                this.addJobVisible = true;
                this.typeBtn = oitem ? 4 : 3;
            }
        },
        modifySite: function modifySite(item, oitem) {
            this.nowSelRegion = item;
            this.newSite = {
                name: oitem.name,
                id: oitem.id,
                regionId: item.id,
                ipAddress: oitem.ipAddress,
                queue: oitem.queue
            };
            this.showModifySite = true;
            this.siteType = "edit";
        },
        delSite: function delSite(item, oitem) {
            var _this9 = this;

            this.$confirm("\u662F\u5426\u5220\u9664\u8BE5\u673A\u4F4D", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this9.$http({
                    url: "region/delete/num",
                    method: "POST",
                    data: {
                        id: oitem.id
                    }
                }).then(function (res) {
                    _this9.getDataList();
                });
            }).catch(function () {});
        },
        delClassify: function delClassify(item, oitem) {
            var _this10 = this;

            this.$confirm("\u662F\u5426\u5220\u9664 " + (item ? item.area + ' 区域?' : "该区域"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this10.$http({
                    url: "schedul/del",
                    method: "POST",
                    data: {
                        id: item.id
                    }
                }).then(function (res) {
                    _this10.getDataList();
                });
            }).catch(function () {});
        },
        handle: function handle(item, ind) {
            if (this.typeData[ind].isOpen) {
                this.btn = !this.btn;
            } else {
                this.btn = true;
            }
            for (var i = 0, len = this.typeData.length; i < len; i++) {
                this.typeData[i].isOpen = false;
            }
            this.typeData[ind].isOpen = true;
        }
    },
    activated: function activated() {
        var _this11 = this;

        try {
            this.getOptions();
        } catch (error) {}
        //就怕sequence会大于数组的长度
        this.$http.get('/product-types?storeId=' + this.$route.params.id + '&parentId=' + '').then(function (res) {
            console.log(res.data);
            var body = res.data.data;
            _this11.systemData = res.data.systemData;
            var newArr = [];
            for (var i = 0, len = body.length; i < len; i++) {
                if (!body[i].parent) {
                    body[i].isOpen = false;
                    newArr.push(body[i]);
                    newArr[newArr.length - 1].children = [];
                    for (var j = 0, _len3 = body.length; j < _len3; j++) {
                        if (body[j].parent && body[i].id == body[j].parent.id) {
                            newArr[newArr.length - 1].children.push(body[j]);
                        }
                    }
                }
            }
            var list = [];
            for (var _i3 = 0, _len4 = newArr.length; _i3 < _len4; _i3++) {
                var bodys = {
                    "productTypeId": newArr[_i3].id,
                    "sequence": _i3
                };
                list.push(bodys);
            }
            if (!list.length) {
                return;
            }
            _this11.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this11.getDataList();
            }).catch(function (err) {});
        }).catch(function (err) {});
    }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_url_js__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            newBatchSite: {
                regionId: "",
                beginIp: "",
                count: ""
            },
            showModifySiteBatch: false,
            siteType: "",
            nowSelRegion: null,
            newSite: {
                name: '',
                id: 0,
                regionId: "",
                ipAddress: "",
                queue: 0
            },
            showModifySite: false,
            // 
            addJobVisible: false,
            btn: false, //分类下拉三角样式
            typeData: [],
            obj: {
                id: 0,
                name: ""
            },
            typeBtn: '',
            typeName: '',
            addJobBtn: true,
            systemData: []
        };
    },

    watch: {
        showModifySite: function showModifySite(val) {
            if (!val) {
                this.newSite = {
                    name: '',
                    id: 0,
                    regionId: "",
                    ipAddress: "",
                    queue: 0
                };
            }
        }
    },
    methods: {
        addSiteBatch: function addSiteBatch(item) {
            this.newBatchSite.regionId = item.id;
            this.showModifySiteBatch = true;
        },

        // 
        check: function check() {
            //正则验证方法
            if (!this.obj.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            return false;
        },
        addDiscount: function addDiscount() {
            var _this = this;

            if (this.check()) {
                return;
            }
            this.$http({
                url: "schedul/type/edit",
                method: "POST",
                data: {
                    storeId: this.$route.params.id,
                    name: this.obj.name,
                    id: this.obj.id
                }
            }).then(function (res) {
                _this.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                _this.addJobVisible = false;
                _this.obj.queue = "";
                _this.initData();
                _this.getDataList();
            });
        },
        initData: function initData() {
            this.obj = {
                id: 0,
                area: "",
                // qty:"",
                numBegin: ""
            };
        },

        //添加或者修改分类
        addJob: function addJob() {
            var _this2 = this;

            if (!this.obj.name) {
                this.$message({
                    message: '分类名称有误',
                    customClass: 'error'
                });
                return;
            }
            this.$set(this.obj, "name", this.obj.name.replace(/\s*/g, ""));
            if (this.typeBtn == 1) {
                //添加父类
                var data = {
                    "id": this.$uuid.create(1).hex,
                    "sequence": -1,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": ''
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', data).then(function (res) {
                    _this2.getDataList();
                    _this2.addJobVisible = false;
                    _this2.addJobBtn = true;
                }).catch(function () {
                    _this2.addJobBtn = true;
                });
            } else if (this.typeBtn == 2) {
                //添加子类
                var _data = {
                    "id": this.$uuid.create(1).hex,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.id
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data).then(function (res) {
                    _this2.getDataList();
                    _this2.addJobVisible = false;
                    _this2.addJobBtn = true;
                }).catch(function () {
                    _this2.addJobBtn = true;
                });
            } else if (this.typeBtn == 3) {
                //、、修改父类
                var _data2 = {
                    "id": this.obj.id,
                    "sequence": this.obj.sequence,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": ''
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data2).then(function (res) {
                    _this2.getDataList();
                    _this2.addJobVisible = false;
                    _this2.addJobBtn = true;
                }).catch(function () {
                    _this2.addJobBtn = true;
                });
            } else if (this.typeBtn == 4) {
                //、、修改子类
                var _data3 = {
                    "id": this.obj.id,
                    "name": this.obj.name,
                    "storeId": this.$route.params.id,
                    "parentId": this.obj.arId
                };
                if (!this.addJobBtn) {
                    return;
                }
                this.addJobBtn = false;
                this.$http.put('/product-types', _data3).then(function (res) {
                    _this2.getDataList();
                    _this2.addJobVisible = false;
                    _this2.addJobBtn = true;
                }).catch(function () {
                    _this2.addJobBtn = true;
                });
            }
        },
        sortingChild: function sortingChild(boo, item, ind, pItem) {
            var _this3 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = pItem.children.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": pItem.children[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == pItem.children.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i = 0, _len = pItem.children.length; _i < _len; _i++) {
                    var _body = {
                        "productTypeId": pItem.children[_i].id,
                        "sequence": _i
                    };
                    list.push(_body);
                    if (ind == _i) {
                        list[_i].sequence = _i + 1;
                        num = _i + 1;
                    }
                    if (num == _i) {
                        list[num].sequence = _i - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this3.getDataList();
            }).catch(function (err) {});
        },

        //排序
        sorting: function sorting(boo, item, ind) {
            var _this4 = this;

            var list = [];
            if (boo) {
                //上移
                for (var i = 0, len = this.typeData.length; i < len; i++) {
                    if (ind == 0) {
                        this.$message({
                            message: '已经是第一项了',
                            customClass: 'error'
                        });
                        return;
                    }
                    var body = {
                        "productTypeId": this.typeData[i].id,
                        "sequence": i
                    };
                    list.push(body);
                    if (ind == i) {
                        list[i].sequence = i - 1;
                        list[i - 1].sequence = i;
                    }
                }
            } else {
                if (ind == this.typeData.length - 1) {
                    this.$message({
                        message: '已经是最后一项了',
                        customClass: 'error'
                    });
                    return;
                }
                var num = -1;
                for (var _i2 = 0, _len2 = this.typeData.length; _i2 < _len2; _i2++) {
                    var _body2 = {
                        "productTypeId": this.typeData[_i2].id,
                        "sequence": _i2
                    };
                    list.push(_body2);
                    if (ind == _i2) {
                        list[_i2].sequence = _i2 + 1;
                        num = _i2 + 1;
                    }
                    if (num == _i2) {
                        list[num].sequence = _i2 - 1;
                    }
                }
            }
            this.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this4.getDataList();
            }).catch(function (err) {});
        },
        getDataList: function getDataList() {
            var _this5 = this;

            this.$http({
                url: "schedul/type/list",
                method: "GET",
                params: {
                    storeId: this.$route.params.id
                }
            }).then(function (res) {
                if (res.data && Array.isArray(res.data) && res.data.length) {
                    res.data.forEach(function (it) {
                        it.children = [];
                        it.isOpen = true;
                        _this5.btn = true;
                        if (it.nums && Array.isArray(it.nums)) {
                            it.children = it.nums;
                        }
                    });
                }
                _this5.typeData = res.data;
            });
        },
        addClassify: function addClassify(id) {
            //添加分类
            this.typeName = "添加/编辑";
            this.obj = {
                name: '',
                id: '',
                arId: ''
            };
            this.addJobVisible = true;
            this.obj.id = id ? id : '';
            this.typeBtn = id ? 2 : 1;
        },
        checkSite: function checkSite() {
            //正则验证方法
            var ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            if (!this.newSite.name) {
                this.$message({
                    message: '请输入名称',
                    customClass: 'error'
                });
                return true;
            }
            if (!ipReg.test(this.newSite.ipAddress)) {
                this.$message({
                    message: 'ip地址有误',
                    customClass: 'error'
                });
                return true;
            }
            // if(!/^[1-9]\d*|0$/.test(this.newSite.queue)){
            //     this.$message({
            //         message: '排序值输入有误',
            //         customClass: 'error'
            //     })
            //     return true;
            // }
            // 
            if (this.siteType != "edit") {
                if (this.typeData && Array.isArray(this.typeData)) {
                    var typeData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.typeData));
                    var ips = [];
                    typeData.forEach(function (it) {
                        if (it.nums && Array.isArray(it.nums)) {
                            it.nums.forEach(function (ite) {
                                ips.push(ite.ipAddress);
                            });
                        }
                    });
                    if (ips.indexOf(this.newSite.ipAddress) != -1) {
                        this.$message({
                            message: '已添加过此IP',
                            customClass: 'error'
                        });
                        return true;
                    }
                }
            }

            // 
            return false;
        },
        doAddNewSiteBatch: function doAddNewSiteBatch() {
            var _this6 = this;

            var ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            if (!ipReg.test(this.newBatchSite.beginIp)) {
                this.$message({
                    message: 'ip地址有误',
                    customClass: 'error'
                });
                return true;
            }
            if (!this.newBatchSite.count || this.newBatchSite.count < 1) {
                this.$message({
                    message: '数量填写有误',
                    customClass: 'error'
                });
                return true;
            }
            this.$http({
                url: "region/batch/add/num",
                method: "POST",
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.newBatchSite)
            }).then(function (res) {
                _this6.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                _this6.newBatchSite = {
                    regionId: "",
                    beginIp: "",
                    count: ""
                };
                _this6.showModifySiteBatch = false;
                _this6.getDataList();
            });
        },
        doAddNewSite: function doAddNewSite() {
            var _this7 = this;

            if (this.checkSite()) {
                return;
            }
            this.$http({
                url: this.siteType ? "region/edit/num" : "region/add/num",
                method: "POST",
                data: {
                    storeId: this.$route.params.id,
                    name: this.newSite.name,
                    id: this.newSite.id,
                    regionId: this.nowSelRegion.id,
                    ipAddress: this.newSite.ipAddress,
                    queue: this.newSite.queue
                }
            }).then(function (res) {
                _this7.$message({
                    message: "操作成功",
                    customClass: 'success'
                });
                if (_this7.siteType == "edit") {
                    _this7.showModifySite = false;
                    _this7.initDataForSite();
                }
                _this7.siteType = "";
                _this7.getDataList();
            });
        },
        initDataForSite: function initDataForSite() {
            this.newSite = {
                name: '',
                id: 0,
                regionId: "",
                ipAddress: "",
                queue: ""
            };
        },
        addSite: function addSite(item) {
            this.siteType = "";
            this.nowSelRegion = item;
            this.showModifySite = true;
        },
        upClassify: function upClassify(item, oitem) {
            //修改分类
            this.typeName = "修改";
            if (!oitem) {
                this.obj = {
                    id: item.id,
                    name: item.name,
                    qty: item.qty,
                    numBegin: item.numBegin
                };
                this.addJobVisible = true;
                this.typeBtn = oitem ? 4 : 3;
            }
        },
        modifySite: function modifySite(item, oitem) {
            this.nowSelRegion = item;
            this.newSite = {
                name: oitem.name,
                id: oitem.id,
                regionId: item.id,
                ipAddress: oitem.ipAddress,
                queue: oitem.queue
            };
            this.showModifySite = true;
            this.siteType = "edit";
        },
        delSite: function delSite(item, oitem) {
            var _this8 = this;

            this.$confirm("\u662F\u5426\u5220\u9664\u8BE5\u673A\u4F4D", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this8.$http({
                    url: "region/delete/num",
                    method: "POST",
                    data: {
                        id: oitem.id
                    }
                }).then(function (res) {
                    _this8.getDataList();
                });
            }).catch(function () {});
        },
        delClassify: function delClassify(item, oitem) {
            var _this9 = this;

            this.$confirm("\u662F\u5426\u5220\u9664 " + (item ? item.name + ' 区域分类?' : "该区域分类"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this9.$http({
                    url: "schedul/type/del",
                    method: "POST",
                    data: {
                        id: item.id
                    }
                }).then(function (res) {
                    _this9.getDataList();
                });
            }).catch(function () {});
        },
        handle: function handle(item, ind) {
            if (this.typeData[ind].isOpen) {
                this.btn = !this.btn;
            } else {
                this.btn = true;
            }
            for (var i = 0, len = this.typeData.length; i < len; i++) {
                this.typeData[i].isOpen = false;
            }
            this.typeData[ind].isOpen = true;
        }
    },
    activated: function activated() {
        var _this10 = this;

        //就怕sequence会大于数组的长度
        this.$http.get('/product-types?storeId=' + this.$route.params.id + '&parentId=' + '').then(function (res) {
            console.log(res.data);
            var body = res.data.data;
            _this10.systemData = res.data.systemData;
            var newArr = [];
            for (var i = 0, len = body.length; i < len; i++) {
                if (!body[i].parent) {
                    body[i].isOpen = false;
                    newArr.push(body[i]);
                    newArr[newArr.length - 1].children = [];
                    for (var j = 0, _len3 = body.length; j < _len3; j++) {
                        if (body[j].parent && body[i].id == body[j].parent.id) {
                            newArr[newArr.length - 1].children.push(body[j]);
                        }
                    }
                }
            }
            var list = [];
            for (var _i3 = 0, _len4 = newArr.length; _i3 < _len4; _i3++) {
                var bodys = {
                    "productTypeId": newArr[_i3].id,
                    "sequence": _i3
                };
                list.push(bodys);
            }
            if (!list.length) {
                return;
            }
            _this10.$http.put('/product-sequence', { "products": list }).then(function (res) {
                _this10.getDataList();
            }).catch(function (err) {});
        }).catch(function (err) {});
    }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['storeId', 'nowSelClass', 'nowSelClassGoods', "isDiscount", "seledGoods"],

  data: function data() {
    return {
      searchVal: "",
      size: 8,
      types: [], //分类列表
      showTypesList: false, //是否显示分类列表
      curSelType: null,
      goodsList: [],
      totalPage: 0,
      totalElements: 0,
      nowPage: 0,
      canChangePage: true,
      nowSelectGoods: [],
      isSearch: false,
      matData: [],
      unitOptions: [],
      unitFormat: {}
    };
  },

  watch: {
    curSelType: function curSelType(val) {
      console.log(val);
      this.nowPage = 0;
      this.getGoods(0);
      this.isSearch = false;
    },
    searchVal: function searchVal(val) {
      this.searchGoods();
    }
  },
  methods: {
    // 商品检索
    searchGoods: function searchGoods() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // let typeId = this.curSelType?this.curSelType.id:"";
      this.nowPage = page;
      this.isSearch = true;
      this.$http({
        url: "products/stores-search",
        params: {
          storeId: this.storeId,
          q: this.searchVal,
          // matchProductEnabled:true,
          stockEnabled: false
          // typeId:"",
          // page:this.nowPage,
          // size:1000
        }
      }).then(function (res) {
        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].productMaterialId = goodsList[i].id;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this.goodsList = goodsList;
        _this.totalPage = res.data.totalPage;
        _this.totalElements = res.data.totalElements;
        _this.canChangePage = true;
      });
    },
    modifyItem: function modifyItem(type, item) {
      console.log(item);
      if (item.lowerShelf) {
        this.$message({
          message: "此商品已下架!",
          showClose: true,
          customClass: 'error'
        });
        return;
      }
      if (!this.isDiscount) {
        if (item.setMealEnabled) {
          this.$message({
            message: "此商品为套餐，不可加入其它套餐!",
            showClose: true,
            customClass: 'error'
          });
          return;
        }
      }
      var nowSelectGoods = this.nowSelectGoods;
      if (type == 'add') {

        var flag = false;
        var index = void 0;
        for (var i = 0; i < nowSelectGoods.length; i++) {
          if (nowSelectGoods[i].id == item.id) {
            flag = true;
            index = i;
          }
        }
        if (flag) {
          if (nowSelectGoods[index].count >= 1) {
            return;
          }
          nowSelectGoods[index].count++;
        } else {
          item.count++;
          nowSelectGoods.push(item);
        }
        this.nowSelectGoods = nowSelectGoods;
      } else {
        // console.log(nowSelectGoods)
        // console.log(item);
        // return
        var _flag = false;
        var _index = void 0;
        console.log(item.productMaterialId);
        for (var _i = 0; _i < nowSelectGoods.length; _i++) {
          if (nowSelectGoods[_i].id == item.id) {
            _flag = true;
            _index = _i;
          }
        }
        console.log(_index);

        if (this.isDiscount) {
          nowSelectGoods.splice(_index, 1);
        } else {
          if (_flag) {
            nowSelectGoods[_index].count--;
            if (nowSelectGoods[_index].count <= 0) {
              nowSelectGoods.splice(_index, 1);
            }
          }
        }
        this.nowSelectGoods = nowSelectGoods;
      }
    },
    changePage: function changePage(type) {
      if (!this.canChangePage) {
        console.log("k");
        return;
      }
      var page = void 0;
      if (type == 'next') {
        page = this.nowPage + 1;
        if (page >= this.totalPage) {
          return;
        }
      } else {
        page = this.nowPage - 1;
        if (page < 0) {
          return;
        }
      }
      this.canChangePage = false;
      if (this.isSearch) {
        this.searchGoods(page);
      } else {
        this.getGoods(page);
      }
      this.nowPage = page;
    },
    close: function close() {
      this.$emit("closeSelGoods", "");
    },
    selOk: function selOk() {
      var proIds = [];
      for (var i = 0; i < this.nowSelectGoods.length; i++) {
        if (this.isDiscount) {
          if (!this.nowSelectGoods[i].setMealEnabled) {
            var obj = {
              productId: this.nowSelectGoods[i].id,
              setMealQty: this.nowSelectGoods[i].count
              // productName:this.nowSelectGoods[i].productName,
            };
            proIds.push(obj);
          }
        } else {
          var _obj = {
            productId: this.nowSelectGoods[i].id,
            setMealQty: this.nowSelectGoods[i].count
            // productName:this.nowSelectGoods[i].productName,
          };
          proIds.push(_obj);
        }
      }
      console.log(proIds);
      // this.$http({
      //   url:"/meal/add-pro",
      //   method:"POST",
      //   data:{
      //     id:this.nowSelClass.id,
      //     proIds
      //   }
      // }).then(res=>{
      //   if(res.data.code == 200){
      //   }
      // });
      this.$emit("selOk", { "nowSelectGoods": this.nowSelectGoods, "proIds": proIds });
    },

    // 获取商品
    getGoods: function getGoods(page) {
      var _this2 = this;

      console.log(this.curSelType);
      var typeId = this.curSelType ? this.curSelType.id : "";
      this.$http({
        url: 'material/search/list',
        method: 'GET',
        params: {
          storeId: this.storeId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        // this.goodsList = res.data.data;
        // let goodsList = res.data.data;
        // for(let i=0;i<goodsList.length;i++){
        //     goodsList[i].count = 0;
        // }

        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this2.goodsList = goodsList;
        _this2.totalPage = res.data.totalPage;
        _this2.totalElements = res.data.totalElements;
        _this2.canChangePage = true;
      });
    },

    // 获取商品分类
    getType: function getType() {
      var _this3 = this;

      this.$http({
        url: "get-type",
        method: "GET",
        params: {
          storeId: this.storeId
        }
      }).then(function (res) {
        _this3.types = res.data;
      });
    },
    getUnitList: function getUnitList() {
      var _this4 = this;

      this.$http({
        url: "material/unit/list",
        method: "GET",
        params: {
          storeId: this.storeId,
          page: 0,
          size: 10000
        }
      }).then(function (res) {
        _this4.unitOptions = res.data;
        var unitFormat = {};
        if (res.data && Array.isArray(res.data) && res.data.length) {
          res.data.forEach(function (it) {
            unitFormat[it.id] = it.name;
          });
        }
        console.log(unitFormat);
        _this4.unitFormat = unitFormat;
        _this4.getDataList();
      });
    },
    getDataList: function getDataList() {
      var _this5 = this;

      this.$http({
        url: "get-ps",
        method: "GET",
        params: {
          storeId: this.storeId
          // matchProductEnabled:true,
        }
      }).then(function (res) {
        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].productMaterialId = goodsList[i].id;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this5.goodsList = goodsList;
        _this5.totalPage = res.data.totalPage;
        _this5.totalElements = res.data.totalElements;
        _this5.canChangePage = true;
      });
    }
  },
  mounted: function mounted() {
    this.getDataList();
    // this.getUnitList();
    // this.getType();
    if (this.seledGoods.length) {
      var nowSelClassGoods = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seledGoods));
      // for(let i=0;i<this.nowSelClassGoods.length;i++){
      //   if(this.nowSelClassGoods[i].id){
      //     nowSelClassGoods[i].productName = this.nowSelClassGoods[i].name;
      //     nowSelClassGoods[i].productId = this.nowSelClassGoods[i].id;
      //   }
      // }
      this.nowSelectGoods = nowSelClassGoods;
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['storeId', 'nowSelClass', 'nowSelClassGoods', "isDiscount", "seledGoods"],

  data: function data() {
    return {
      searchVal: "",
      size: 8,
      types: [], //分类列表
      showTypesList: false, //是否显示分类列表
      curSelType: null,
      goodsList: [],
      totalPage: 0,
      totalElements: 0,
      nowPage: 0,
      canChangePage: true,
      nowSelectGoods: [],
      isSearch: false,
      matData: [],
      unitOptions: [],
      unitFormat: {}
    };
  },

  watch: {
    curSelType: function curSelType(val) {
      console.log(val);
      this.nowPage = 0;
      this.getGoods(0);
      this.isSearch = false;
    },
    searchVal: function searchVal(val) {
      this.searchGoods();
    }
  },
  methods: {
    // 原料检索
    searchGoods: function searchGoods() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // let typeId = this.curSelType?this.curSelType.id:"";
      this.nowPage = page;
      this.isSearch = true;
      this.$http({
        url: "material/query/list",
        params: {
          storeId: this.storeId,
          name: this.searchVal
          // typeId:"",
          // page:this.nowPage,
          // size:1000
        }
      }).then(function (res) {
        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].productMaterialId = goodsList[i].id;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this.goodsList = goodsList;
        _this.totalPage = res.data.totalPage;
        _this.totalElements = res.data.totalElements;
        _this.canChangePage = true;
      });
    },
    modifyItem: function modifyItem(type, item) {
      console.log(item);
      if (item.lowerShelf) {
        this.$message({
          message: "此原料已下架!",
          showClose: true,
          customClass: 'error'
        });
        return;
      }
      if (!this.isDiscount) {
        if (item.setMealEnabled) {
          this.$message({
            message: "此原料为套餐，不可加入其它套餐!",
            showClose: true,
            customClass: 'error'
          });
          return;
        }
      }
      var nowSelectGoods = this.nowSelectGoods;
      if (type == 'add') {
        var flag = false;
        var index = void 0;
        for (var i = 0; i < nowSelectGoods.length; i++) {
          if (nowSelectGoods[i].productMaterialId == item.productMaterialId) {
            flag = true;
            index = i;
          }
        }
        if (flag) {
          nowSelectGoods[index].count++;
        } else {
          item.count++;
          nowSelectGoods.push(item);
        }
        this.nowSelectGoods = nowSelectGoods;
      } else {
        // console.log(nowSelectGoods)
        // console.log(item);
        // return
        var _flag = false;
        var _index = void 0;
        console.log(item.productMaterialId);
        for (var _i = 0; _i < nowSelectGoods.length; _i++) {
          if (nowSelectGoods[_i].productMaterialId == item.productMaterialId) {
            _flag = true;
            _index = _i;
          }
        }
        console.log(_index);

        if (this.isDiscount) {
          nowSelectGoods.splice(_index, 1);
        } else {
          if (_flag) {
            nowSelectGoods[_index].count--;
            if (nowSelectGoods[_index].count <= 0) {
              nowSelectGoods.splice(_index, 1);
            }
          }
        }
        this.nowSelectGoods = nowSelectGoods;
      }
    },
    changePage: function changePage(type) {
      if (!this.canChangePage) {
        console.log("k");
        return;
      }
      var page = void 0;
      if (type == 'next') {
        page = this.nowPage + 1;
        if (page >= this.totalPage) {
          return;
        }
      } else {
        page = this.nowPage - 1;
        if (page < 0) {
          return;
        }
      }
      this.canChangePage = false;
      if (this.isSearch) {
        this.searchGoods(page);
      } else {
        this.getGoods(page);
      }
      this.nowPage = page;
    },
    close: function close() {
      this.$emit("closeSelGoods", "");
    },
    selOk: function selOk() {
      var proIds = [];
      for (var i = 0; i < this.nowSelectGoods.length; i++) {
        if (this.isDiscount) {
          if (!this.nowSelectGoods[i].setMealEnabled) {
            var obj = {
              productId: this.nowSelectGoods[i].id,
              setMealQty: this.nowSelectGoods[i].count
              // productName:this.nowSelectGoods[i].productName,
            };
            proIds.push(obj);
          }
        } else {
          var _obj = {
            productId: this.nowSelectGoods[i].id,
            setMealQty: this.nowSelectGoods[i].count
            // productName:this.nowSelectGoods[i].productName,
          };
          proIds.push(_obj);
        }
      }
      console.log(proIds);
      // this.$http({
      //   url:"/meal/add-pro",
      //   method:"POST",
      //   data:{
      //     id:this.nowSelClass.id,
      //     proIds
      //   }
      // }).then(res=>{
      //   if(res.data.code == 200){
      //   }
      // });
      this.$emit("selOk", { "nowSelectGoods": this.nowSelectGoods, "proIds": proIds });
    },

    // 获取原料
    getGoods: function getGoods(page) {
      var _this2 = this;

      console.log(this.curSelType);
      var typeId = this.curSelType ? this.curSelType.id : "";
      this.$http({
        url: 'material/search/list',
        method: 'GET',
        params: {
          storeId: this.storeId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        // this.goodsList = res.data.data;
        // let goodsList = res.data.data;
        // for(let i=0;i<goodsList.length;i++){
        //     goodsList[i].count = 0;
        // }

        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this2.goodsList = goodsList;
        _this2.totalPage = res.data.totalPage;
        _this2.totalElements = res.data.totalElements;
        _this2.canChangePage = true;
      });
    },

    // 获取原料分类
    getType: function getType() {
      var _this3 = this;

      this.$http({
        url: "get-type",
        method: "GET",
        params: {
          storeId: this.storeId
        }
      }).then(function (res) {
        _this3.types = res.data;
      });
    },
    getUnitList: function getUnitList() {
      var _this4 = this;

      this.$http({
        url: "material/unit/list",
        method: "GET",
        params: {
          storeId: this.storeId,
          page: 0,
          size: 10000
        }
      }).then(function (res) {
        _this4.unitOptions = res.data;
        var unitFormat = {};
        if (res.data && Array.isArray(res.data) && res.data.length) {
          res.data.forEach(function (it) {
            unitFormat[it.id] = it.name;
          });
        }
        console.log(unitFormat);
        _this4.unitFormat = unitFormat;
        _this4.getDataList();
      });
    },
    getDataList: function getDataList() {
      var _this5 = this;

      this.$http({
        url: "material/search/list",
        method: "GET",
        params: {
          storeId: this.storeId,
          page: this.nowPage,
          size: this.size
        }
      }).then(function (res) {
        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].productMaterialId = goodsList[i].id;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this5.goodsList = goodsList;
        _this5.totalPage = res.data.totalPage;
        _this5.totalElements = res.data.totalElements;
        _this5.canChangePage = true;
      });
    }
  },
  mounted: function mounted() {
    this.getUnitList();
    // this.getType();
    if (this.seledGoods.length) {
      var nowSelClassGoods = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seledGoods));
      // for(let i=0;i<this.nowSelClassGoods.length;i++){
      //   if(this.nowSelClassGoods[i].id){
      //     nowSelClassGoods[i].productName = this.nowSelClassGoods[i].name;
      //     nowSelClassGoods[i].productId = this.nowSelClassGoods[i].id;
      //   }
      // }
      this.nowSelectGoods = nowSelClassGoods;
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['storeId', 'nowSelClass', 'nowSelClassGoods', "isDiscount", "seledGoods"],

  data: function data() {
    return {
      searchVal: "",
      size: 8,
      types: [], //分类列表
      showTypesList: false, //是否显示分类列表
      curSelType: null,
      goodsList: [],
      totalPage: 0,
      totalElements: 0,
      nowPage: 0,
      canChangePage: true,
      nowSelectGoods: [],
      isSearch: false,
      matData: [],
      unitOptions: [],
      unitFormat: {}
    };
  },

  watch: {
    curSelType: function curSelType(val) {
      console.log(val);
      this.nowPage = 0;
      this.getGoods(0);
      this.isSearch = false;
    },
    searchVal: function searchVal(val) {
      this.searchGoods();
    }
  },
  methods: {
    // 配品检索
    searchGoods: function searchGoods() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // let typeId = this.curSelType?this.curSelType.id:"";
      this.nowPage = page;
      this.isSearch = true;
      this.$http({
        url: "products/stores-search",
        params: {
          storeId: this.storeId,
          q: this.searchVal,
          matchProductEnabled: true,
          stockEnabled: false
          // typeId:"",
          // page:this.nowPage,
          // size:1000
        }
      }).then(function (res) {
        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].productMaterialId = goodsList[i].id;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this.goodsList = goodsList;
        _this.totalPage = res.data.totalPage;
        _this.totalElements = res.data.totalElements;
        _this.canChangePage = true;
      });
    },
    modifyItem: function modifyItem(type, item) {
      console.log(item);
      if (item.lowerShelf) {
        this.$message({
          message: "此配品已下架!",
          showClose: true,
          customClass: 'error'
        });
        return;
      }
      if (!this.isDiscount) {
        if (item.setMealEnabled) {
          this.$message({
            message: "此配品为套餐，不可加入其它套餐!",
            showClose: true,
            customClass: 'error'
          });
          return;
        }
      }
      var nowSelectGoods = this.nowSelectGoods;
      if (type == 'add') {

        var flag = false;
        var index = void 0;
        for (var i = 0; i < nowSelectGoods.length; i++) {
          if (nowSelectGoods[i].id == item.id) {
            flag = true;
            index = i;
          }
        }
        if (flag) {
          if (nowSelectGoods[index].count >= 1) {
            return;
          }
          nowSelectGoods[index].count++;
        } else {
          item.count++;
          nowSelectGoods.push(item);
        }
        this.nowSelectGoods = nowSelectGoods;
      } else {
        // console.log(nowSelectGoods)
        // console.log(item);
        // return
        var _flag = false;
        var _index = void 0;
        console.log(item.productMaterialId);
        for (var _i = 0; _i < nowSelectGoods.length; _i++) {
          if (nowSelectGoods[_i].id == item.id) {
            _flag = true;
            _index = _i;
          }
        }
        console.log(_index);

        if (this.isDiscount) {
          nowSelectGoods.splice(_index, 1);
        } else {
          if (_flag) {
            nowSelectGoods[_index].count--;
            if (nowSelectGoods[_index].count <= 0) {
              nowSelectGoods.splice(_index, 1);
            }
          }
        }
        this.nowSelectGoods = nowSelectGoods;
      }
    },
    changePage: function changePage(type) {
      if (!this.canChangePage) {
        console.log("k");
        return;
      }
      var page = void 0;
      if (type == 'next') {
        page = this.nowPage + 1;
        if (page >= this.totalPage) {
          return;
        }
      } else {
        page = this.nowPage - 1;
        if (page < 0) {
          return;
        }
      }
      this.canChangePage = false;
      if (this.isSearch) {
        this.searchGoods(page);
      } else {
        this.getGoods(page);
      }
      this.nowPage = page;
    },
    close: function close() {
      this.$emit("closeSelGoods", "");
    },
    selOk: function selOk() {
      var proIds = [];
      for (var i = 0; i < this.nowSelectGoods.length; i++) {
        if (this.isDiscount) {
          if (!this.nowSelectGoods[i].setMealEnabled) {
            var obj = {
              productId: this.nowSelectGoods[i].id,
              setMealQty: this.nowSelectGoods[i].count
              // productName:this.nowSelectGoods[i].productName,
            };
            proIds.push(obj);
          }
        } else {
          var _obj = {
            productId: this.nowSelectGoods[i].id,
            setMealQty: this.nowSelectGoods[i].count
            // productName:this.nowSelectGoods[i].productName,
          };
          proIds.push(_obj);
        }
      }
      console.log(proIds);
      // this.$http({
      //   url:"/meal/add-pro",
      //   method:"POST",
      //   data:{
      //     id:this.nowSelClass.id,
      //     proIds
      //   }
      // }).then(res=>{
      //   if(res.data.code == 200){
      //   }
      // });
      this.$emit("selOk", { "nowSelectGoods": this.nowSelectGoods, "proIds": proIds });
    },

    // 获取配品
    getGoods: function getGoods(page) {
      var _this2 = this;

      console.log(this.curSelType);
      var typeId = this.curSelType ? this.curSelType.id : "";
      this.$http({
        url: 'material/search/list',
        method: 'GET',
        params: {
          storeId: this.storeId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        // this.goodsList = res.data.data;
        // let goodsList = res.data.data;
        // for(let i=0;i<goodsList.length;i++){
        //     goodsList[i].count = 0;
        // }

        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this2.goodsList = goodsList;
        _this2.totalPage = res.data.totalPage;
        _this2.totalElements = res.data.totalElements;
        _this2.canChangePage = true;
      });
    },

    // 获取配品分类
    getType: function getType() {
      var _this3 = this;

      this.$http({
        url: "get-type",
        method: "GET",
        params: {
          storeId: this.storeId
        }
      }).then(function (res) {
        _this3.types = res.data;
      });
    },
    getUnitList: function getUnitList() {
      var _this4 = this;

      this.$http({
        url: "material/unit/list",
        method: "GET",
        params: {
          storeId: this.storeId,
          page: 0,
          size: 10000
        }
      }).then(function (res) {
        _this4.unitOptions = res.data;
        var unitFormat = {};
        if (res.data && Array.isArray(res.data) && res.data.length) {
          res.data.forEach(function (it) {
            unitFormat[it.id] = it.name;
          });
        }
        console.log(unitFormat);
        _this4.unitFormat = unitFormat;
        _this4.getDataList();
      });
    },
    getDataList: function getDataList() {
      var _this5 = this;

      this.$http({
        url: "get-ps",
        method: "GET",
        params: {
          storeId: this.storeId,
          matchProductEnabled: true
        }
      }).then(function (res) {
        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].productMaterialId = goodsList[i].id;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this5.goodsList = goodsList;
        _this5.totalPage = res.data.totalPage;
        _this5.totalElements = res.data.totalElements;
        _this5.canChangePage = true;
      });
    }
  },
  mounted: function mounted() {
    this.getDataList();
    // this.getUnitList();
    // this.getType();
    if (this.seledGoods.length) {
      var nowSelClassGoods = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seledGoods));
      // for(let i=0;i<this.nowSelClassGoods.length;i++){
      //   if(this.nowSelClassGoods[i].id){
      //     nowSelClassGoods[i].productName = this.nowSelClassGoods[i].name;
      //     nowSelClassGoods[i].productId = this.nowSelClassGoods[i].id;
      //   }
      // }
      this.nowSelectGoods = nowSelClassGoods;
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['storeId', 'nowSelClass', 'nowSelClassGoods', "isDiscount", "seledGoods"],

  data: function data() {
    return {
      searchVal: "",
      size: 8,
      types: [], //分类列表
      showTypesList: false, //是否显示分类列表
      curSelType: null,
      goodsList: [],
      totalPage: 0,
      totalElements: 0,
      nowPage: 0,
      canChangePage: true,
      nowSelectGoods: [],
      isSearch: false,
      matData: [],
      unitOptions: [],
      unitFormat: {}
    };
  },

  watch: {
    curSelType: function curSelType(val) {
      console.log(val);
      this.nowPage = 0;
      this.getGoods(0);
      this.isSearch = false;
    },
    searchVal: function searchVal(val) {
      this.searchGoods();
    }
  },
  methods: {
    // 配品检索
    searchGoods: function searchGoods() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // let typeId = this.curSelType?this.curSelType.id:"";
      this.nowPage = page;
      this.isSearch = true;
      this.$http({
        url: "products/stores-search",
        params: {
          storeId: this.storeId,
          q: this.searchVal,
          matchProductEnabled: true,
          stockEnabled: false
          // typeId:"",
          // page:this.nowPage,
          // size:1000
        }
      }).then(function (res) {
        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].productMaterialId = goodsList[i].id;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }

        _this.goodsList = goodsList;
        _this.totalPage = res.data.totalPage;
        _this.totalElements = res.data.totalElements;
        _this.canChangePage = true;
      });
    },
    modifyItem: function modifyItem(type, item) {
      console.log(item);
      var nowSelectGoods = this.nowSelectGoods;
      if (type == 'add') {

        var flag = false;
        var index = void 0;
        for (var i = 0; i < nowSelectGoods.length; i++) {
          if (nowSelectGoods[i].id == item.id) {
            flag = true;
            index = i;
          }
        }
        if (flag) {
          if (nowSelectGoods[index].count >= 1) {
            return;
          }
          nowSelectGoods[index].count++;
        } else {
          item.count++;
          nowSelectGoods.push(item);
        }
        this.nowSelectGoods = nowSelectGoods;
      } else {

        var _flag = false;
        var _index = void 0;
        for (var _i = 0; _i < nowSelectGoods.length; _i++) {
          if (nowSelectGoods[_i].id == item.id) {
            _flag = true;
            _index = _i;
          }
        }

        console.log(nowSelectGoods);

        if (this.isDiscount) {
          nowSelectGoods.splice(_index, 1);
        } else {
          if (_flag) {
            nowSelectGoods[_index].count--;
            if (nowSelectGoods[_index].count <= 0) {
              nowSelectGoods.splice(_index, 1);
            }
          }
        }
        this.nowSelectGoods = nowSelectGoods;
      }
    },
    changePage: function changePage(type) {
      if (!this.canChangePage) {
        console.log("k");
        return;
      }
      var page = void 0;
      if (type == 'next') {
        page = this.nowPage + 1;
        if (page >= this.totalPage) {
          return;
        }
      } else {
        page = this.nowPage - 1;
        if (page < 0) {
          return;
        }
      }
      this.canChangePage = false;
      if (this.isSearch) {
        this.searchGoods(page);
      } else {
        this.getGoods(page);
      }
      this.nowPage = page;
    },
    close: function close() {
      this.$emit("closeSelGoods", "");
    },
    selOk: function selOk() {
      var proIds = [];
      for (var i = 0; i < this.nowSelectGoods.length; i++) {
        if (this.isDiscount) {
          if (!this.nowSelectGoods[i].setMealEnabled) {
            var obj = {
              productId: this.nowSelectGoods[i].id,
              setMealQty: this.nowSelectGoods[i].count
              // productName:this.nowSelectGoods[i].productName,
            };
            proIds.push(obj);
          }
        } else {
          var _obj = {
            productId: this.nowSelectGoods[i].id,
            setMealQty: this.nowSelectGoods[i].count
            // productName:this.nowSelectGoods[i].productName,
          };
          proIds.push(_obj);
        }
      }
      console.log(proIds);
      // this.$http({
      //   url:"/meal/add-pro",
      //   method:"POST",
      //   data:{
      //     id:this.nowSelClass.id,
      //     proIds
      //   }
      // }).then(res=>{
      //   if(res.data.code == 200){
      //   }
      // });
      this.$emit("selOk", { "nowSelectGoods": this.nowSelectGoods, "proIds": proIds });
    },

    // 获取配品
    getGoods: function getGoods(page) {
      var _this2 = this;

      console.log(this.curSelType);
      var typeId = this.curSelType ? this.curSelType.id : "";
      this.$http({
        url: 'material/search/list',
        method: 'GET',
        params: {
          storeId: this.storeId,
          page: page,
          size: this.size
        }
      }).then(function (res) {
        // this.goodsList = res.data.data;
        // let goodsList = res.data.data;
        // for(let i=0;i<goodsList.length;i++){
        //     goodsList[i].count = 0;
        // }

        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }
        _this2.goodsList = goodsList;
        _this2.totalPage = res.data.totalPage;
        _this2.totalElements = res.data.totalElements;
        _this2.canChangePage = true;
      });
    },

    // 获取配品分类
    getType: function getType() {
      var _this3 = this;

      this.$http({
        url: "get-type",
        method: "GET",
        params: {
          storeId: this.storeId
        }
      }).then(function (res) {
        _this3.types = res.data;
      });
    },
    getUnitList: function getUnitList() {
      var _this4 = this;

      this.$http({
        url: "material/unit/list",
        method: "GET",
        params: {
          storeId: this.storeId,
          page: 0,
          size: 10000
        }
      }).then(function (res) {
        _this4.unitOptions = res.data;
        var unitFormat = {};
        if (res.data && Array.isArray(res.data) && res.data.length) {
          res.data.forEach(function (it) {
            unitFormat[it.id] = it.name;
          });
        }
        console.log(unitFormat);
        _this4.unitFormat = unitFormat;
        _this4.getDataList();
      });
    },
    getDataList: function getDataList() {
      var _this5 = this;

      this.$http({
        url: "spec/list",
        method: "POST",
        data: {
          storeId: this.storeId
        }
      }).then(function (res) {
        var goodsList = res.data;
        for (var i = 0; i < goodsList.length; i++) {
          goodsList[i].count = 0;
          goodsList[i].productMaterialId = goodsList[i].id;
          if (goodsList[i].setMealEnabled) {
            goodsList[i].productId = goodsList[i].setMealId;
          }
        }
        _this5.goodsList = goodsList;
        _this5.totalPage = res.data.totalPage;
        _this5.totalElements = res.data.totalElements;
        _this5.canChangePage = true;
      });
    }
  },
  mounted: function mounted() {
    this.getDataList();
    // this.getUnitList();
    // this.getType();
    if (this.seledGoods.length) {
      var nowSelClassGoods = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seledGoods));
      for (var i = 0; i < nowSelClassGoods.length; i++) {
        if (nowSelClassGoods[i].id) {
          nowSelClassGoods[i].count = 1;
        }
      }
      console.log(nowSelClassGoods);
      this.nowSelectGoods = nowSelClassGoods;
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['storeData'],
    data: function data() {
        return {
            btn: true,
            sideBarData: [
            //    {
            //         name:"交易趋势",
            //         iconClass: "iconfont icon-shouye",
            //         son:[

            //         ],
            //         fixedSon:null,
            //         isOpen:false,
            //         routeName:`/sys/${this.$route.params.id}/Statement`,
            //         isActive:0, 
            //     },
            {
                name: "店铺报表",
                iconClass: "iconfont icon-dianpufenxi",
                son: [],
                isOpen: false,
                routeName: '/sys/' + this.$route.params.id + '/statement',
                isActive: 0
            }, {
                name: "员工管理",
                iconClass: "iconfont icon-admin_man",
                son: [{ name: '员工列表', routeName: '/sys/' + this.$route.params.id + '/employee', isActive: 0 }, { name: '员工业绩', routeName: '/sys/' + this.$route.params.id + '/achievement', isActive: 0 }, { name: '微信通知', routeName: '/sys/' + this.$route.params.id + '/wechatList', isActive: 0 }, { name: '岗位设置', routeName: '/sys/' + this.$route.params.id + '/jobs', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: 0
            },
            // {
            //     name:"岗位管理",
            //     iconClass: "iconfont icon-gangweibiandong",
            //     son:[
            //         {name:'岗位',routeName:`/sys/${this.$route.params.id}/jobs`,isActive:false}
            //     ],
            //     fixedSon:null,
            //     isOpen:false,
            //     routeName:'',
            //     isActive:0, 
            // },
            {
                name: "会员管理",
                iconClass: "iconfont icon-huiyuanguanli",
                son: [
                // {name:'会员资料',routeName:`/sys/${this.$route.params.id}/vipMan`,isActive:false},
                { name: '会员资料', routeName: '/sys/' + this.$route.params.id + '/lostVip/ALL', isActive: false }, { name: '会员充值规则', routeName: '/sys/' + this.$route.params.id + '/vipRecharge', isActive: false }, { name: '会员充值记录', routeName: '/sys/' + this.$route.params.id + '/chargeInfo', isActive: false }, { name: '微信点单', routeName: '/sys/' + this.$route.params.id + '/wechatOrder', isActive: false }],
                isOpen: false,
                routeName: '',
                isActive: false
            }, {
                name: "商品管理",
                iconClass: "iconfont icon-shangpinguanli",
                son: [{ name: '商品资料', routeName: '/sys/' + this.$route.params.id + '/goodsInfo', isActive: false }, { name: '商品分类', routeName: '/sys/' + this.$route.params.id + '/goodsClassify', isActive: false }, { name: '规格管理', routeName: '/sys/' + this.$route.params.id + '/spec', isActive: false },
                // {name:'排单机',routeName:`/sys/${this.$route.params.id}/bigScreenGoods`,isActive:false},
                { name: '捕获率商品管理', routeName: '/sys/' + this.$route.params.id + '/catchRateGoods', isActive: false }, { name: '销售时段管理', routeName: '/sys/' + this.$route.params.id + '/goodsInterval', isActive: false }, { name: '商品变动记录', routeName: '/sys/' + this.$route.params.id + '/goodsLog', isActive: false }],
                fixedSon: [{ name: '库存管理' }],
                isOpen: false,
                routeName: '',
                isActive: false
            },
            // 
            // 
            {
                name: "交易管理",
                iconClass: "iconfont icon-shujufenxi",
                son: [{ name: '对账单', routeName: '/sys/' + this.$route.params.id + '/dailyGrade', isActive: false }, { name: '同期日报表(周)', routeName: '/sys/' + this.$route.params.id + '/ringReport', isActive: false }, { name: '交接班记录', routeName: '/sys/' + this.$route.params.id + '/exchangeWork', isActive: false }, { name: '班次销售统计', routeName: '/sys/' + this.$route.params.id + '/exchangeWorkNew', isActive: false },
                //    {name:'订单流水',routeName:`/sys/${this.$route.params.id}/orderSearch`,isActive:false},
                { name: '销售汇总', routeName: '/sys/' + this.$route.params.id + '/totalSales', isActive: false }, { name: '库存汇总', routeName: '/sys/' + this.$route.params.id + '/stockData', isActive: false }, { name: '电子对账单', routeName: '/sys/' + this.$route.params.id + '/elecSales', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: 0
            },
            // 
            {
                name: "机位管理",
                iconClass: "iconfont icon-1",
                son: [{ name: '机位设置', routeName: '/sys/' + this.$route.params.id + '/region', isActive: false }, { name: '机位大屏', routeName: '/sys/' + this.$route.params.id + '/bigScreen', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: false
            }, {
                name: "原料管理",
                iconClass: "iconfont icon-1",
                son: [{ name: '原料单位', routeName: '/sys/' + this.$route.params.id + '/matUnit', isActive: false }, { name: '原料商品', routeName: '/sys/' + this.$route.params.id + '/matGoods', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: false
            }, {
                name: "排队等号管理",
                iconClass: "iconfont icon-1",
                son: [{ name: '区域分类', routeName: '/sys/' + this.$route.params.id + '/regionType', isActive: false }, { name: '排号管理', routeName: '/sys/' + this.$route.params.id + '/waitRegion', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: false
            }, {
                name: "配品管理",
                iconClass: "iconfont icon-1",
                son: [{ name: '配品列表', routeName: '/sys/' + this.$route.params.id + '/peiGoods', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: false
            }, {
                name: "活动管理",
                iconClass: "iconfont icon-1",
                son: [{ name: '第二份优惠', routeName: '/sys/' + this.$route.params.id + '/second', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: false
            },
            // {
            //     name:"库存管理",
            //     iconClass: "iconfont icon-kucun",
            //     son:[
            //         {name:'商品入库',routeName:`/sys/${this.$route.params.id}/invAdd`,isActive:false},
            //         {name:'入库记录',routeName:`/sys/${this.$route.params.id}/invList`,isActive:false},
            //         {name:'库存详情',routeName:`/sys/${this.$route.params.id}/invDetails`,isActive:false}
            //     ],
            //     isOpen:false,
            //     routeName:'',
            //     isActive:false, 
            // }, 
            // 交易管理原始位置
            // {
            //     name:"原料商城",
            //     iconClass: "iconfont icon-shangcheng",
            //     son:[
            //        {name:'原料商城',routeName:`/sys/${this.$route.params.id}/market`,isActive:false},
            //        {name:'收货地址',routeName:`/sys/${this.$route.params.id}/address`,isActive:false},
            //     ],
            //     fixedSon:null,
            //     isOpen:false,
            //     routeName:'',
            //     isActive:0, 
            // },

            {
                name: "优惠券管理",
                iconClass: "iconfont icon-youhuiquan",
                son: [{ name: '创建中心', routeName: '/sys/' + this.$route.params.id + '/addcoupon', isActive: false },
                // {name:'派发记录',routeName:`/sys/${this.$route.params.id}/couponDetail`,isActive:false},
                { name: '核销统计', routeName: '/sys/' + this.$route.params.id + '/verifiCoupon', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: false
            },
            // {
            //     name:"代金券管理",
            //     iconClass: "iconfont icon-youhuiquanyouhuiquandaijinquan",
            //     son:[
            //         {name:'创建中心',routeName:`/sys/${this.$route.params.id}/voucher`,isActive:false},
            //     ],
            //     fixedSon:null,
            //     isOpen:false,
            //     routeName:'',
            //     isActive:false,  
            // },
            // {
            //     name:"商户资料",
            //     iconClass: "iconfont icon-ecmerchants",
            //     son:[
            //        {name:'商户认证',routeName:`/sys/${this.$route.params.id}/merCert`,isActive:false},
            //        // {name:'秘钥认证',routeName:`/sys/${this.$route.params.id}/keyCert`,isActive:false},
            //     ],
            //     fixedSon:null,
            //     isOpen:false,
            //     routeName:'',
            //     isActive:0, 
            // },
            // {
            //     name:"充值中心",
            //     iconClass: "iconfont icon-xufei",
            //     son:[

            //     ],
            //     fixedSon:null,
            //     isOpen:false,
            //     routeName:`/sys/${this.$route.params.id}/topUp`,
            //     isActive:0, 
            // },
            {
                name: "下载中心",
                iconClass: "iconfont icon-qrcode",
                son: [],
                fixedSon: null,
                isOpen: false,
                routeName: '/sys/' + this.$route.params.id + '/createCode',
                isActive: 0
            }, {
                name: "系统设置",
                iconClass: "iconfont icon-set",
                son: [],
                fixedSon: null,
                isOpen: false,
                routeName: '/sys/' + this.$route.params.id + '/setting',
                isActive: false
            }]
        };
    },

    methods: {
        handle: function handle(item, ind) {
            if (item.routeName) {
                //没有子导航类
                this.$router.push(item.routeName);
            }
            if (this.sideBarData[ind].isOpen) {
                //点击有父类导航切换收拢打开。
                this.btn = !this.btn;
            } else {
                this.btn = true;
            }
            for (var i = 0, len = this.sideBarData.length; i < len; i++) {
                this.sideBarData[i].isOpen = false;
            }
            this.sideBarData[ind].isOpen = true;
        },

        //点击去库存管理
        goInv: function goInv() {
            window.open('https://inventory.huoxingy.com/#/login');
        },
        noCall: function noCall(value) {
            switch (true) {
                case value == 'rewardInfo':
                    this.$router.push('/sys/' + this.$route.params.id + '/Statement');
                    break;
                case value == 'getWithdraw':
                    this.$router.push('/sys/' + this.$route.params.id + '/Statement');
                    break;
                case value == 'putWithdraw':
                    this.$router.push('/sys/' + this.$route.params.id + '/Statement');
                    break;
                case value == 'setWithdraw':
                    this.$router.push('/sys/' + this.$route.params.id + '/Statement');
                    break;
                case value == 'ratingInfo':
                    this.$router.push('/sys/' + this.$route.params.id + '/Statement');
                case value == 'settleCount':
                    this.$router.push('/sys/' + this.$route.params.id + '/Statement');
                    break;
            };
        }
    },
    created: function created() {
        for (var i = 0; i < this.sideBarData.length; i++) {
            if (this.sideBarData[i].son.length) {
                for (var ii = 0; ii < this.sideBarData[i].son.length; ii++) {
                    if (this.$route.fullPath.split(this.$route.params.id + '/')[1] == this.sideBarData[i].son[ii].routeName.split(this.$route.params.id + '/')[1]) {
                        this.sideBarData[i].isOpen = true;
                    }
                }
            } else {
                if (this.$route.fullPath.split(this.$route.params.id + '/')[1] == this.sideBarData[i].routeName.split(this.$route.params.id + '/')[1]) {
                    this.sideBarData[i].isOpen = true;
                }
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        // console.log(JSON.parse(sessionStorage.getItem("call")))
        // console.log(JSON.parse(sessionStorage.getItem("purchase")))
        if (JSON.parse(sessionStorage.getItem("call"))) {
            var sideBarData = this.sideBarData;
            var callBar = {
                name: "呼叫&打赏",
                iconClass: "iconfont icon-dashang",
                son: [{ name: '打赏记录', routeName: '/sys/' + this.$route.params.id + '/rewardInfo', isActive: false }, { name: '评价记录', routeName: '/sys/' + this.$route.params.id + '/ratingInfo', isActive: false }, { name: '提现记录', routeName: '/sys/' + this.$route.params.id + '/getWithdraw', isActive: false }, { name: '我要提现', routeName: '/sys/' + this.$route.params.id + '/putWithdraw', isActive: false }, { name: '设置提现信息', routeName: '/sys/' + this.$route.params.id + '/setWithdraw', isActive: false }],
                fixedSon: null,
                isOpen: false,
                routeName: '',
                isActive: 0
            };
            sideBarData.splice(6, 0, callBar);
            this.sideBarData = sideBarData;
        } else {
            this.noCall(this.$route.name);
        }
        setTimeout(function () {
            if (JSON.parse(sessionStorage.getItem("isSettleCount"))) {
                var _sideBarData = _this.sideBarData;
                for (var i = 0; i < _sideBarData.length; i++) {
                    if (_sideBarData[i].name == "交易管理") {
                        _sideBarData[i].son.splice(1, 0, { name: '结算查询', routeName: '/sys/' + _this.$route.params.id + '/settleCount', isActive: false });
                    }
                }
                _this.sideBarData = _sideBarData;
            } else {
                _this.noCall(_this.$route.name);
            }
        }, 500);

        setTimeout(function () {
            if (JSON.parse(sessionStorage.getItem("purchase")) || _this.storeData.purchaseEnabled) {
                var _sideBarData2 = _this.sideBarData;
                var storeBar = {
                    name: "原料商城",
                    iconClass: "iconfont icon-shangcheng",
                    son: [{ name: '原料商城', routeName: '/sys/' + _this.$route.params.id + '/market', isActive: false }, { name: '收货地址', routeName: '/sys/' + _this.$route.params.id + '/address', isActive: false }, { name: '订单记录', routeName: '/sys/' + _this.$route.params.id + '/orderInfo', isActive: false }],
                    fixedSon: null,
                    isOpen: false,
                    routeName: '',
                    isActive: 0
                };
                _sideBarData2.splice(7, 0, storeBar);
                _this.sideBarData = _sideBarData2;
            }
            if (_this.storeData.makeEnabled && _this.storeData.makeEndTime && new Date(_this.storeData.makeEndTime).getTime() > new Date().getTime()) {
                var _sideBarData3 = _this.sideBarData;
                for (var i = 0; i < _sideBarData3.length; i++) {
                    if (_sideBarData3[i].name == "商品管理") {
                        _sideBarData3[i].son.splice(2, 0, { name: '排单机', routeName: '/sys/' + _this.$route.params.id + '/bigScreenGoods', isActive: false });
                    }
                }
                _this.sideBarData = _sideBarData3;
            }
            // 
            try {
                var leaseProductEnabled = sessionStorage.getItem("leaseProductEnabled");
                if (leaseProductEnabled == "true") {
                    var _sideBarData4 = _this.sideBarData;
                    var menuBar = {
                        name: "租赁管理",
                        iconClass: "iconfont icon-zulin",
                        son: [{ name: '商品管理', routeName: '/sys/' + _this.$route.params.id + '/rentGoods', isActive: false }, { name: '租赁商品变动记录', routeName: '/sys/' + _this.$route.params.id + '/goodsLogForRent', isActive: false }, { name: '分类管理', routeName: '/sys/' + _this.$route.params.id + '/rentCate', isActive: false }, { name: '计费规则', routeName: '/sys/' + _this.$route.params.id + '/rentRule', isActive: false }, { name: '租赁明细', routeName: '/sys/' + _this.$route.params.id + '/rentOrder', isActive: false }, { name: '租赁汇总', routeName: '/sys/' + _this.$route.params.id + '/rentDetail', isActive: false }],
                        isOpen: false,
                        routeName: '',
                        isActive: false
                    };
                    _sideBarData4.splice(4, 0, menuBar);
                    _this.sideBarData = _sideBarData4;
                } else {
                    var _sideBarData5 = _this.sideBarData;
                    var _menuBar = {
                        name: "租赁管理",
                        iconClass: "iconfont icon-zulin",
                        son: [{ name: '联系开通', routeName: '/sys/' + _this.$route.params.id + '/rentHello', isActive: false }],
                        isOpen: false,
                        routeName: '',
                        isActive: false
                    };
                    _sideBarData5.splice(4, 0, _menuBar);
                    _this.sideBarData = _sideBarData5;
                }
                _this.$forceUpdate();
            } catch (error) {
                console.log("error", error);
            }
            // 
        }, 500);
    }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_url_js__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['crumbs', 'storeData', 'openSelfCenter', 'tab'],
    data: function data() {
        return {
            tabNamesList: [],
            nameTree: '',
            selfCenterBtn: false,
            username: '', // 当前登录帐号
            nowTabPath: ''
        };
    },

    watch: {
        crumbs: function crumbs(val) {
            this.crumbsFn(val);
        },
        openSelfCenter: function openSelfCenter(val) {
            this.selfCenterBtn = val;
        },
        tab: function tab(val) {
            var tabNamesList = [];
            if (JSON.parse(sessionStorage.getItem("tabNames"))) {
                tabNamesList = JSON.parse(sessionStorage.getItem("tabNames"));
            }
            this.tabNamesList = tabNamesList;
            this.nowTabPath = this.$route.path;
        }
    },
    methods: {
        toScrollX: function toScrollX(type) {
            var scrollX = $("#scroll-x").scrollLeft();
            if (type == 'left') {
                $("#scroll-x").scrollLeft(scrollX - 200);
            } else {
                $("#scroll-x").scrollLeft(scrollX + 200);
            }
        },
        toThisTab: function toThisTab(item) {
            this.$router.push({ path: item.path });
        },
        closeTab: function closeTab(item) {
            var tabNamesList = JSON.parse(sessionStorage.getItem("tabNames"));
            var index = -1;
            for (var i = 0; i < tabNamesList.length; i++) {
                if (tabNamesList[i].meta.tabName == item.meta.tabName) {
                    index = i;
                }
            }
            tabNamesList.splice(index, 1);
            console.log(tabNamesList);
            this.tabNamesList = tabNamesList;
            sessionStorage.setItem("tabNames", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tabNamesList));
        },

        showSideBar: function showSideBar() {
            this.$emit('showSideBar', true);
        },
        goHome: function goHome() {
            this.$router.push({ path: './home' });
        },
        // 退出登录
        logout: function logout() {
            var _this = this;

            this.$http.post('/logout', {}).then(function (res) {
                localStorage.clear();
                sessionStorage.clear();
                _this.$router.push({ path: '/login' });
            }).catch(function (err) {});
        },
        crumbsFn: function crumbsFn(value) {
            var nameTree = '';
            switch (true) {
                case value == 'Statement':
                    nameTree = "<i class='iconfont icon-shouye'></i><span>交易趋势</span>";break;
                case value == 'statement':
                    nameTree = "<i class='iconfont icon-dianpufenxi'></i><span>店铺报表</span>";break;
                case value == 'employee':
                    nameTree = "<i class='iconfont icon-admin_man'></i><span>员工管理 > 员工列表</span>";break;
                case value == 'achievement':
                    nameTree = "<i class='iconfont icon-admin_man'></i><span>员工管理 > 员工业绩</span>";break;
                case value == 'jobs':
                    nameTree = "<i class='iconfont icon-gangweibiandong'></i><span>岗位管理 > 岗位</span>";break;
                case value == 'lostVip':
                    nameTree = "<i class='iconfont icon-huiyuanguanli'></i><span>会员管理 > 会员资料</span>";break;
                case value == 'vipCons':
                    nameTree = "<i class='iconfont icon-huiyuanguanli'></i><span>会员管理 > 会员消费记录</span>";break;
                case value == 'vipRecharge':
                    nameTree = "<i class='iconfont icon-huiyuanguanli'></i><span>会员管理 > 会员充值规则</span>";break;
                case value == 'goodsInfo':
                    nameTree = "<i class='iconfont icon-shangpinguanli'></i><span>商品管理 > 商品资料</span>";break;
                case value == 'goodsClassify':
                    nameTree = "<i class='iconfont icon-shangpinguanli'></i><span>商品管理 > 商品分类</span>";break;
                case value == 'goodsInterval':
                    nameTree = "<i class='iconfont icon-shangpinguanli'></i><span>商品管理 > 销售时段管理</span>";break;
                case value == 'dailyGrade':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>对账单</span>";break;
                case value == 'exchangeWork':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>交接班记录</span>";break;
                case value == 'staffGrade':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>对账单</span>";break;
                case value == 'orderSearch':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>订单流水" + "<span style='color:red'>（检索订单必须有起止时间，每次导出数据控制在10000条以内!）</span></span>";break;
                case value == 'totalSales':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>销售汇总</span>";break;
                case value == 'stockSummary':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>采购汇总</span>";break;
                case value == 'invList':
                    nameTree = "<i class='iconfont icon-kucun'></i><span>库存管理 > 入库记录</span>";break;
                case value == 'invAdd':
                    nameTree = "<i class='iconfont icon-kucun'></i><span>库存管理 > 商品入库</span>";break;
                case value == 'invDetails':
                    nameTree = "<i class='iconfont icon-kucun'></i><span>库存管理 > 库存详情</span>";break;
                case value == 'merCert':
                    nameTree = "<i class='iconfont icon-ecmerchants'></i><span>商户资料 >商户认证" + "<span style='color:red'></span></span>";break;
                case value == 'keyCert':
                    nameTree = "<i class='iconfont icon-ecmerchants'></i><span>商户资料 >秘钥认证</span>" + "<span style='color:red'>（您的资料提交后会收到来自13980547109(微信同号)的电话确认，请您放心接听!）</span></span>";break;
                case value == 'createCode':
                    nameTree = "<i class='iconfont icon-qrcode'></i><span>下载中心</span>";break;
                case value == 'topUp':
                    nameTree = "<i class='iconfont icon-xufei'></i><span>充值中心</span>";break;
                case value == 'setting':
                    nameTree = "<i class='iconfont icon-set'></i><span>系统设置</span>";break;
                case value == 'addcoupon':
                    nameTree = "<i class='iconfont icon-youhuiquan'></i><span>优惠券管理 > 创建中心</span>";break;
                case value == 'couponDetail':
                    nameTree = "<i class='iconfont icon-youhuiquan'></i><span>优惠券管理 > 派发记录</span>";break;
                case value == 'voiceCall':
                    nameTree = "<i class='iconfont icon-yuyin'></i><span>语音呼叫</span>";break;
                case value == 'rewardInfo':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>打赏记录</span>";break;
                case value == 'ratingInfo':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>评价记录</span>";break;
                case value == 'getWithdraw':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>提现记录</span>";break;
                case value == 'putWithdraw':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>我要提现</span>";break;
                case value == 'setWithdraw':
                    nameTree = "<i class='iconfont icon-shujufenxi'></i><span>提现信息</span>";break;
                case value == 'market':
                    nameTree = "<i class='iconfont icon-shangcheng'></i><span>原料商城</span>";break;
            };
            this.nameTree = nameTree;
        }
    },
    created: function created() {
        this.crumbsFn(this.$route.name);
        this.username = localStorage.getItem('username');
        var tabNamesList = [];
        if (JSON.parse(sessionStorage.getItem("tabNames"))) {
            tabNamesList = JSON.parse(sessionStorage.getItem("tabNames"));
        }
        this.tabNamesList = tabNamesList;
    }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isFirstAddStore: false, // 是否第一次添加店铺
            isEnterInviteCode: true, // 是否在输入邀请码界面
            storeType: [],
            newStore: {
                "name": "", // 店铺名称
                "typeId": "", // 店铺类型id
                "addr": "", // 店铺地址
                "referralCode": "" // 邀请码
            },
            curStoreId: '', // 当前店铺id
            addStoreCtrlBtn: true
        };
    },

    methods: {
        // 校验邀请码
        checkInviteCode: function checkInviteCode() {
            var _this = this;

            if (!this.newStore.referralCode) {
                this.$message({
                    message: '请输入邀请码',
                    customClass: 'error'
                });
                return;
            }
            var that = this;
            this.$http.get('/validate-referral-code?code=' + this.newStore.referralCode).then(function (res) {
                _this.isEnterInviteCode = false;
            }).catch(function (err) {});
        },
        // 添加店铺
        addStore: function addStore() {
            var _this2 = this;

            console.log(123);
            if (!this.newStore.name) {
                this.$message({
                    message: '请输入店铺名',
                    customClass: 'error'
                });
                return;
            }
            if (!this.newStore.addr) {
                this.$message({
                    message: '请输入店铺地址',
                    customClass: 'error'
                });
                return;
            };
            if (!this.curStoreId) {
                this.curStoreId = this.$uuid.create(1).hex;
            };
            if (!this.addStoreCtrlBtn) {
                return;
            };
            this.addStoreCtrlBtn = false;
            // let msg = this.$message({
            //     message: '店铺创建中，请耐心等待。',
            //     duration:0,
            //     customClass: 'success'
            // });
            var loading = this.$loading({
                lock: true,
                text: '店铺创建中，请耐心等待。',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.put('/stores/' + this.curStoreId, this.newStore).then(function (res) {
                _this2.addStoreCtrlBtn = true;
                loading.close();
                _this2.$router.push({ path: '/store' });
            }).catch(function (err) {
                loading.close();
                _this2.addStoreCtrlBtn = true;
            });
        }
    },
    created: function created() {
        var _this3 = this;

        if (this.$route.params.isFirst) {
            this.isFirstAddStore = true;
        }

        // 进入界面时请求店铺类型
        this.$http.get('/store-types').then(function (res) {
            _this3.storeType = res.data;
            if (_this3.storeType && _this3.storeType[0]) {
                _this3.newStore.typeId = _this3.storeType[0].id;
            };
        }).catch();
    }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sideBar_sideBar_vue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sideBar_sideBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sideBar_sideBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLogo_topLogo_vue__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLogo_topLogo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_topLogo_topLogo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__(168);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: { sideBar: __WEBPACK_IMPORTED_MODULE_1__components_sideBar_sideBar_vue___default.a, topLogo: __WEBPACK_IMPORTED_MODULE_2__components_topLogo_topLogo_vue___default.a },
    data: function data() {
        return {
            noCommonRouter: ["bigScreenFrontEnd", "bigScreenFrontEndWithoutAutoScreen", "goodsBigScreen"],
            tab: 0,
            curStoreId: '',
            pageSize: 10,
            crumbs: '',
            storeData: {}, // 当前店铺信息
            openSelfCenter: false // 控制个人中心
        };
    },

    methods: {
        showSideBar: function showSideBar(data) {
            var screenWidth = $(window).width();
            if (parseInt($('.leftSidePart').css('left')) < 0) {
                $('.leftSidePart').css({ 'left': 0 });
            } else {
                if (screenWidth <= 374) {
                    $('.leftSidePart').css({ 'left': '-45%' });
                } else if (screenWidth <= 570) {
                    $('.leftSidePart').css({ 'left': '-40%' });
                } else if (screenWidth <= 768) {
                    $('.leftSidePart').css({ 'left': '-30%' });
                }
            }
        },
        changeSelfCenter: function changeSelfCenter(data) {
            this.openSelfCenter = !data;
        }
    },
    watch: {
        '$route': function $route(val) {
            this.crumbs = val.name;
        }
    },
    created: function created() {
        var _this = this;

        if (this.$route.name == 'bigScreenFrontEnd') {
            this.curStoreId = this.$route.params['id'];
            return;
        }
        if (!localStorage.getItem('token')) {
            this.$router.push({ path: '/login' });
        }
        console.log(this.$route);
        this.curStoreId = this.$route.params['id'];

        this.$http.get('/stores/' + this.curStoreId).then(function (res) {
            if (res.status == 200) {
                _this.storeData = res.data;
                sessionStorage.setItem("call", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.call));
                sessionStorage.setItem("isSettleCount", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.onlineEnabled));
                sessionStorage.setItem("purchase", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.purchaseEnabled));
                sessionStorage.setItem("rechargeLimit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.rechargeLimit));
                if (res.data.leaseProductEnabled) {
                    sessionStorage.setItem("leaseProductEnabled", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.leaseProductEnabled));
                    try {
                        if (res.data.leaseEndDate) {
                            if (new Date().getTime() > new Date(res.data.leaseEndDate).getTime()) {
                                sessionStorage.setItem("leaseProductEnabled", "false");
                            } else {
                                sessionStorage.setItem("leaseProductEnabled", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.leaseProductEnabled));
                            }
                        }
                    } catch (error) {}
                } else {
                    sessionStorage.setItem("leaseProductEnabled", "false");
                }
            }
        }).catch(function (err) {
            console.log(err.response);
            if (err.response.status == 400) {
                _this.$router.push({ path: '/login' });
                _this.$message({
                    message: err.response.data,
                    customClass: 'error'
                });
            }
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        if (this.$route.name == 'bigScreenFrontEnd') {
            return;
        }
        this.tab++;
        $(document).ready(function () {
            $('.system').on('click', function () {
                var screenWidth = $(window).width();
                if (parseInt($('.leftSidePart').css('left')) <= 0) {
                    return;
                }
                if (screenWidth <= 374) {
                    $('.leftSidePart').css({ 'left': '-45%' });
                } else if (screenWidth <= 570) {
                    $('.leftSidePart').css({ 'left': '-40%' });
                } else if (screenWidth <= 768) {
                    $('.leftSidePart').css({ 'left': '-30%' });
                } else {
                    return;
                }
            });
            $('.leftSidePart').on('touchend', function (e) {
                e.stopPropagation();
            });
            $('.system').on('touchend', function (e) {
                var screenWidth = $(window).width();
                if (screenWidth <= 374) {
                    $('.leftSidePart').css({ 'left': '-45%' });
                } else if (screenWidth <= 570) {
                    $('.leftSidePart').css({ 'left': '-40%' });
                } else if (screenWidth <= 768) {
                    $('.leftSidePart').css({ 'left': '-30%' });
                } else {
                    return;
                }
            });
        });
        // 多标签
        //路由中meta标签的tabName为标签名
        __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */].beforeEach(function (to, from, next) {
            if (to.meta.isKeep) {
                _this2.tab++;
                console.log(to);
                var obj = {
                    name: to.name,
                    path: to.path,
                    meta: to.meta
                };
                var tabNames = JSON.parse(sessionStorage.getItem("tabNames"));
                if (tabNames) {
                    // 判断当前是否已经有该标签
                    var flag = false;
                    for (var i = 0; i < tabNames.length; i++) {
                        if (tabNames[i].name == to.name) {
                            flag = true;
                            break;
                        }
                    }
                    if (!flag) {
                        tabNames.push(obj);
                        sessionStorage.setItem("tabNames", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(tabNames));
                    }
                } else {
                    var _tabNames = [];
                    _tabNames.push(obj);
                    sessionStorage.setItem("tabNames", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_tabNames));
                }
            }
            next();
        });
    }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            checked: true,
            isMsg: false, // 是否是短信登录
            isGetCode: false,
            time: 60,
            phone: '', // 手机号
            code: '', // 验证码
            password: '' // 密码
        };
    },

    methods: {
        changeUrl: function changeUrl() {
            window.location.href = "https://table-admin.huoxingy.com";
        },

        changeLoginType: function changeLoginType(val) {
            this.isMsg = val;
        },
        getCode: function getCode() {// 获得验证码事件

        },
        login: function login() {
            var _this = this;

            // 登录事件
            this.phone = this.phone.replace(/\s+/g, "");
            if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.phone)) {
                this.$message({
                    message: "请输入正确的手机号",
                    customClass: "error"
                });
                return;
            }
            if (!this.password) {
                this.$message({
                    message: "请输入密码",
                    customClass: "error"
                });
            }
            var data = {
                "username": this.phone,
                // "password": hex_md5(this.password),
                "password": this.password
            };
            var b = new Base64();
            var authStr = 'Basic ' + b.encode(data.username + ':' + data.password);

            var loginUrl = 'login';
            if (window.location.href.split('?')[1]) {
                loginUrl = loginUrl + '?openid=' + window.location.href.split('?')[1].split('=')[1];
            }
            this.$http.post(loginUrl, {}, {
                auth: data // 添加登录验证
            }).then(function (res) {
                localStorage.setItem('token', authStr);
                localStorage.setItem('username', _this.phone);
                _this.$router.push({ path: '/store' });
            }).catch(function (err) {
                if (err.response) {
                    if (err.response.status == 401) {
                        _this.$message({
                            message: "帐号或者密码有误",
                            customClass: 'error'
                        });
                    } else if (err.response.status == 403) {
                        _this.$message({
                            message: "权限不足",
                            customClass: 'error'
                        });
                    } else {
                        _this.$message({
                            message: err.response.data,
                            customClass: 'error'
                        });
                    }
                }
            });
        }
    },
    created: function created() {
        // if ( localStorage.getItem('token') && localStorage.getItem('username') ) {
        //     this.$router.push('store');
        // }
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        if (width >= 450) {
            localStorage.removeItem('token');
        }
        if (localStorage.getItem('token')) {
            this.$router.push({ path: '/store' });
        }
    },
    mounted: function mounted() {
        window.scrollTo(0, 0);
        $(document).ready(function () {
            $('.login-form').height($(window).height());
        });
    }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlConfig_index__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isShowCodeTip: false, // 是否显示验证嘛提示
            isGetCode: false, // 是否获取验证码
            time: 60,
            phone: '', // 手机号
            password: '', // 密码
            code: '', // 验证码
            status: '' //注册或者重置密码控制
        };
    },

    methods: {
        reWord: function reWord() {},

        getCode: function getCode() {
            var _this = this;

            this.phone = this.phone.replace(/\s+/g, "");
            if (/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.phone)) {
                this.isGetCode = true;
                this.$http.post(__WEBPACK_IMPORTED_MODULE_1__urlConfig_index__["b" /* API_BASE_URL */] + 'v1/verify-code?mobile=' + this.phone + '&type=ACCOUNT').then(function (res) {
                    _this.isShowCodeTip = true;
                    var intervalCode = setInterval(function () {
                        _this.time--;
                        if (_this.time <= 0) {
                            _this.isGetCode = false;
                            _this.isShowCodeTip = false;
                            _this.time = 60;
                            clearInterval(intervalCode);
                        }
                    }, 1000);
                }).catch(function (err) {
                    _this.isGetCode = false;
                    _this.isShowCodeTip = false;
                });
            } else {
                this.$message({
                    message: '请输入正确的手机号',
                    customClass: 'error'
                });
                return;
            }
        },
        register: function register() {
            var _this2 = this;

            if (!/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.phone)) {
                this.$message({
                    message: '请输入正确的手机号',
                    customClass: 'error'
                });
                return;
            }
            if (!this.code || this.code.length !== 4) {
                this.$message({
                    message: '请填写正确的验证码',
                    customClass: 'error'
                });
                return;
            }
            if (!this.password) {
                this.$message({
                    message: '请输入密码',
                    customClass: 'error'
                });
                return;
            }
            /*验证密码*/
            var data = {
                "username": this.phone,
                "verCode": this.code,
                // "password": hex_md5(this.password)
                "password": this.password
            };
            if (this.status) {
                //是  重置密码
                var resetData = {
                    "mobile": this.phone,
                    "verifyCode": this.code,
                    // "password": hex_md5(this.password)
                    "pwd": this.password
                };
                this.$http.post('reset-pwd', resetData).then(function (res) {
                    _this2.$message({
                        message: "重置密码成功,请登录",
                        customClass: "success"
                    });
                    _this2.$router.push({ path: '/login' });
                }).catch(function (err) {});
            } else {
                this.$message({
                    message: "正在注册中，请等待页面自动跳转...",
                    customClass: "success",
                    duration: 5000
                });
                //否  注册
                this.$http.post('sign-up', data).then(function (res) {
                    _this2.login();
                }).catch(function (err) {});
            }
        },
        login: function login() {
            var _this3 = this;

            // 登录事件
            var data = {
                "username": this.phone,
                // "password": hex_md5(this.password),
                "password": this.password
            };
            var b = new Base64();
            var authStr = 'Basic ' + b.encode(data.username + ':' + data.password);
            this.$http.post('login', {}, {
                auth: data // 添加登录验证
            }).then(function (res) {
                localStorage.setItem('token', authStr);
                localStorage.setItem('username', _this3.phone);
                _this3.$router.push({ path: '/store' });
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.status = this.$route.params.foo == 'reset';
    }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_url_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            storeList: [], // 店铺列表
            curIndex: 0 //当前店铺索引
        };
    },

    methods: {
        // 进入后台管理系统
        enterSystem: function enterSystem(item) {
            var _this = this;

            localStorage.setItem("storeId", item.id);
            sessionStorage.setItem("call", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.call));
            sessionStorage.setItem("storeName", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.name));
            sessionStorage.setItem("purchase", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.purchaseEnabled));
            sessionStorage.setItem("tabNames", "[]");
            this.$http.post('authorize?storeId=' + item.id, {}).then(function () {
                _this.$router.push({ path: '/sys/' + item.id });
            });
        },
        // 编辑店铺
        editStore: function editStore(storeId) {
            this.$router.push({ path: './addStore/' + storeId });
        },
        // 返回登录
        returnToLogin: function returnToLogin() {
            localStorage.clear();
            this.$router.push({ path: '/login' });
        }
    },
    created: function created() {
        var _this2 = this;

        this.$http.get('/stores').then(function (res) {
            _this2.storeList = res.data;
            if (!_this2.storeList || !_this2.storeList[0]) {
                _this2.$router.push({ path: '/addStore/true' });
            }
        }).catch(function (err) {});
    }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_tv_focusable__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_tv_focusable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_tv_focusable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__urlConfig_index__ = __webpack_require__(6);











__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_tv_focusable___default.a, {
    // 可选配置项（根据需求调整）
    focusClassName: 'tv-focus', // 自定义焦点样式类名（默认 'focus'）
    initDisplacement: 1, // 初始移动步长（默认 1）
    enterToClick: true, // 回车键触发点击事件（默认 true）
    longPressTime: 500 // 长按判定时间（毫秒，默认 500）
    // 其他配置...
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function inserted(el) {
        // 聚焦元素
        el.focus();
    }
});
// import Mock from './mock/mock'
// Mock.mockData()

/*
    图片上传，获取验证码两个接口不使用根路径
*/
// axios.defaults.baseURL = 'https://api.huoxingy.com/v1/admin/';
// axios.defaults.baseURL = BASE_URL+'/v1/admin/';
// 
// 根据环境来选择api地址
var baseUrl = window.location.hostname;
console.log(baseUrl);
switch (baseUrl) {
    case "localhost":
        // axios.defaults.baseURL = 'https://prod-api.huoxingy.com/v1/admin/';
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.baseURL = 'https://staging-api.huoxingy.com/v1/admin/';
        // axios.defaults.baseURL = 'http://192.168.0.107:9090/v1/admin/';
        break;
    case "10.0.0.23":
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.baseURL = 'https://staging-api.huoxingy.com/v1/admin/';
        break;
    case "192.168.2.68":
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.baseURL = 'https://staging-api.huoxingy.com/v1/admin/';
        break;
    case "staging-admin.huoxingy.com":
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.baseURL = 'https://staging-api.huoxingy.com/v1/admin/';
        break;
    case "prod-test-admin.huoxingy.com":
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.baseURL = 'https://prod-test-api.huoxingy.com/v1/admin/';
        break;
    default:
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.baseURL = 'https://prod-api.huoxingy.com/v1/admin/';
        break;
}
//
// 
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.headers.post['Content-Type'] = 'application/json';

/*
    设置请求拦截器
*/
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.interceptors.request.use(function (config) {
    // console.log(config);

    // 获取验证码，注册不能带token验证
    /*if ( config.url.indexOf('v1/verify-code') >= 0 || config.url.indexOf('v1/admin/sign-up') >= 0 ) {
        return config;
    }*/
    var token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

/*
    添加响应拦截器
*/
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response) {
        var tipText = void 0;
        error.response.data.message ? tipText = error.response.data.message : tipText = error.response.data;
        if (error.response.status == 401) {
            window.location.href = window.location.href.split('#')[0] + '#/login';
            tipText = '帐号失效，请重新登录';
        } else if (error.response.status == 403) {
            // window.location.href = window.location.href.split('#')[0]+'#/login';
            tipText = '权限不足';
        } else if (error.response.status == 404) {
            // window.location.href = window.location.href.split('#')[0]+'#/login';
            tipText = '请尽快上传资料';
        } else if (error.response.status == 503) {
            // window.location.href = window.location.href.split('#')[0]+'#/login';
            tipText = '请尽22快上传资料';
        }

        __WEBPACK_IMPORTED_MODULE_5_element_ui___default.a.Message.error({
            message: tipText,
            customClass: 'error'
        });
    }
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

Date.prototype.Format = function (fmt) {
    //author: meizz 
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }return fmt;
};

/*
    添加自定义过滤器
*/

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('toFixedNum', function (value) {
    // if (!value) return 0;
    value = Number(value);
    return value.toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('numberToDate', function (val) {
    if (!val) {
        return '';
    }
    var date = new Date(val);
    var dateStr = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    return dateStr;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('numberToAllDate', function (val) {
    if (!val) {
        return '';
    }
    var date = new Date(val);
    var dateStr = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + ' ' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    return dateStr;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('numberToMonthDate', function (val) {
    if (!val) {
        return '';
    }
    var date = new Date(val);
    var dateStr = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '-' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':' + (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return dateStr;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('numberToTime', function (val) {
    if (!val) {
        return '';
    }
    var date = new Date(val);
    var dateStr = date.getMonth() + 1 + '.' + date.getDate() + '-' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    return dateStr;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('dateForGradePage', function (value) {
    if (!value) return '';
    var date = new Date(value);
    var year = date.getFullYear();
    var month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    var day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
    var seconds = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('numberToMuchDay', function (val) {
    if (!val) {
        return '';
    }
    var dateArr = val.split('.');
    var dateStr = dateArr[0];
    var date = new Date(dateStr.replace(/-/g, "/")).getTime();
    var nowDate = new Date().getTime();
    var timeStr = nowDate - date;
    var oneDay = 1000 * 60 * 60 * 24;
    var day = Math.floor(timeStr / oneDay);
    var hours = Math.floor(timeStr % oneDay / (3600 * 1000));
    if (day > 0) {
        return day + "天前";
    } else {
        return "今天";
    }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$uuid = __WEBPACK_IMPORTED_MODULE_8_uuid_js___default.a;
/*
  生产UUID：this.$uuid.create(1)
*/

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (to.name == "rewardInfo" || to.name == "ratingInfo" || to.name == "getWithdraw" || to.name == "putWithdraw" || to.name == "setWithdraw" || to.name == "dlCall") {
        if (JSON.parse(sessionStorage.getItem("call"))) {
            return next();
        } else {
            return next({ path: "/" });
        }
    }
    next();
});
__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (to.name == "bigScreenFrontEnd") {
        next();
        return;
    }
    next();
});
__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (to.name == "market" || to.name == "address" || to.name == "orderInfo") {
        if (JSON.parse(sessionStorage.getItem("purchase"))) {
            return next();
        } else {
            return next({ path: "/" });
        }
    }
    next();
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_7_axios___default.a;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_5_element_ui___default.a.Message;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$canClickSelect = function (sessionStorageName, timeStr, nowTime) {
    var sessionStorageData = sessionStorage.getItem(sessionStorageName);
    var defaultTimeRange = 5 * 1000; //默认30秒
    if (sessionStorageData) {
        var localData = JSON.parse(sessionStorageData);
        var timeRange = nowTime - localData.localTime;
        console.log(localData.localTime);
        if (localData.timeStr == timeStr && timeRange < defaultTimeRange) {
            return false;
        }
        var data = {
            sessionStorageName: sessionStorageName,
            timeStr: timeStr,
            localTime: nowTime
        };
        sessionStorage.setItem(sessionStorageName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        return true;
    } else {
        // 首次点击的时间
        var localTime = new Date().getTime();
        // 
        var _data = {
            sessionStorageName: sessionStorageName,
            timeStr: timeStr,
            localTime: localTime
        };
        sessionStorage.setItem(sessionStorageName, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_data));
        return true;
    }
};
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

var dateRange = {
    currentDate: new Date(),
    millisecond: 1000 * 60 * 60 * 24, //一天的毫秒数
    getThisWeek: function getThisWeek() {
        //起止日期数组
        var startStop = new Array();
        //返回date是一周中的某一天
        var week = dateRange.currentDate.getDay();
        //减去的天数
        var minusDay = week != 0 ? week - 1 : 6;
        //本周 周一
        var monday = new Date(dateRange.currentDate.getTime() - minusDay * dateRange.millisecond);
        //本周 周日
        var sunday = new Date(monday.getTime() + 6 * dateRange.millisecond);
        //添加本周时间
        startStop.push(dateRange.formatterDate(monday)); //本周起始时间
        //添加本周最后一天时间
        startStop.push(dateRange.formatterDate(sunday)); //本周终止时间
        //返回
        return startStop;
    },
    /**
     * 获得上一周的起止日期
     */
    getLastWeek: function getLastWeek() {
        //起止日期数组
        var startStop = new Array();
        //返回date是一周中的某一天
        var week = dateRange.currentDate.getDay();
        //减去的天数
        var minusDay = week != 0 ? week - 1 : 6;
        //获得当前周的第一天
        var currentWeekDayOne = new Date(dateRange.currentDate.getTime() - dateRange.millisecond * minusDay);
        //上周最后一天即本周开始的前一天
        var priorWeekLastDay = new Date(currentWeekDayOne.getTime() - dateRange.millisecond);
        //上周的第一天
        var priorWeekFirstDay = new Date(priorWeekLastDay.getTime() - dateRange.millisecond * 6);

        startStop.push(dateRange.formatterDate(priorWeekFirstDay));
        startStop.push(dateRange.formatterDate(priorWeekLastDay));
        //返回
        return startStop;
    },
    /**
     * 获得这个月的起止日期
     */
    getThisMonth: function getThisMonth() {
        var startStop = new Array();
        //获得当前月份0-11
        var currentMonth = dateRange.currentDate.getMonth();
        //获得当前年份4位年
        var currentYear = dateRange.currentDate.getFullYear();
        //求出本月第一天
        var firstDay = new Date(currentYear, currentMonth, 1);
        //当为12月的时候年份需要加1
        //月份需要更新为0 也就是下一年的第一个月
        //否则只是月份增加,以便求的下一月的第一天
        if (currentMonth == 11) {
            currentYear++;
            currentMonth = 0;
        } else {
            currentMonth++;
        }
        //下月的第一天
        var nextMonthDayOne = new Date(currentYear, currentMonth, 1);
        //求出上月的最后一天
        var lastDay = new Date(nextMonthDayOne.getTime() - dateRange.millisecond);

        startStop.push(dateRange.formatterDate(firstDay));
        startStop.push(dateRange.formatterDate(lastDay));
        //返回
        return startStop;
    },
    /**
     * 获得上个月的起止日期
     */
    getLastMonth: function getLastMonth() {
        var startStop = new Array();
        //获得当前月份0-11
        var currentMonth = dateRange.currentDate.getMonth();
        //获得当前年份4位年
        var currentYear = dateRange.currentDate.getFullYear();
        var currentDay = new Date(currentYear, currentMonth, 1);
        //上个月的第一天
        //年份为0代表,是本年的第一月,所以不能减
        if (currentMonth == 0) {
            currentMonth = 11; //月份为上年的最后月份
            currentYear--; //年份减1
        } else {
            currentMonth--;
        }
        var firstDay = new Date(currentYear, currentMonth, 1);
        //求出上月的最后一天
        var lastDay = new Date(currentDay.getTime() - dateRange.millisecond);

        startStop.push(dateRange.formatterDate(firstDay));
        startStop.push(dateRange.formatterDate(lastDay));
        //返回
        return startStop;
    },
    /**
     * 格式化日期（不含时间）
     */
    formatterDate: function formatterDate(date) {
        var datetime = date.getFullYear() + "/" // "年"
        + (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" // "月"
        + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
        return datetime;
    }
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$dateRange = dateRange;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAQCAYAAADj5tSrAAAAAXNSR0IArs4c6QAAAR9JREFUOBHllLFKw1AUhu9/cokdVNBBpWQxTYgPoHPJqnOGLu0r6OySzU3wJXyDzpnFQKYMhVCXCmrRUnBR7DneBMwL9Dr1TocL9/vvf869P9I0pcFweEqCCyg6VJaWKH5lyDjy/UedJInW4sSi5BJQu5Y0FARLMD7zPC9QQ6uqOlgRRbTCvi0RIn5n5kkYhnNbzA3hNDMxXpFlT1ue9+Pa8j2b6e84Pv4yPDHwTHuePwA1r6trS0QEz8Lqrige7qmFQv25arfWK6TlNUX9Ifv9kftf7Vrvsht3uplJHSvMdAJgz1YH2JEPx8RKEARvKMvS7XS2r0xAXhuRHVsiSmRpvt/NYjG/rZ1gMp2emag/N1F/ZEvERP0LKx5HvV7+C1sUZl6pOCAJAAAAAElFTkSuQmCC"

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screen_normal.b3f1a57.png";

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(785)
  __webpack_require__(784)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(962),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-734ae8b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(748)
  __webpack_require__(747)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(927),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18e4ed37",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(753)
  __webpack_require__(752)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(931),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e3f5282",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(953),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-649f099a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(949),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(801)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(978),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b7b6698e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(770)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(948),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(750)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(929),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c9f0ceb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(766)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(944),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(941),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42cb9d1f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(788)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(745)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(925),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(967),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e417b76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(743)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(923),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(921),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(971),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(984),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(810)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(987),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(946),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(789)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(966),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e1b981c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(779)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(957),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(778)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(956),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(919),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(738)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(918),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c0d54a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(935),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f4b8c3e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(963),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(920),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(755)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(933),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(742)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(922),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(802)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(809)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(986),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(754)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(932),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(968),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(729)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(910),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(795)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(972),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(734)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(915),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(764)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(942),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(985),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(736)
  __webpack_require__(737)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(917),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(981),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(975),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9dc5a6a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(983),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(793)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(970),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(751)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(930),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(954),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(947),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(772)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(797)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(974),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-98a46564",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(799)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(976),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9e8cfb38",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(756)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(934),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(796)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(973),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-96d5113c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(732)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(913),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0625042c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(746)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(926),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(911),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(813)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(990),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(780)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(916),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(988),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(909),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(800)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(977),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(731)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(912),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(759)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(937),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(733)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(914),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(777)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-686efdf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(991),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(805)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(982),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(959),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(938),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(761)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(939),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(924),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16264210",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(758)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(936),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(951),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(928),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c292d25",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(787)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(964),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(945),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4aa079b9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(774)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(952),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-645eec85",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(783)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71959aa9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lostVip",
    on: {
      "click": function($event) {
        _vm.searchData = []
      }
    }
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left search",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchPhone),
      expression: "searchPhone"
    }],
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入会员手机号码."
    },
    domProps: {
      "value": (_vm.searchPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchPhone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.searchData.length > 0) ? _c('div', {
    staticClass: "vip-list-wrap"
  }, [_c('div', {
    staticClass: "vip-list"
  }, [_c('ul', _vm._l((_vm.searchData), function(item, index) {
    return _c('li', {
      key: index,
      class: _vm.nowVipIndex == index ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.setNowSearchVip(item)
        },
        "mouseenter": function($event) {
          _vm.nowVipIndex = index
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "phone-num right"
    }, [_vm._v(_vm._s(item.mobile))])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "right sendBtn",
    on: {
      "click": _vm.sendCoupon
    }
  }, [_c('i', {
    staticClass: "iconfont icon--youhuijuanjihuoma"
  }), _vm._v("派发优惠卷")]), _vm._v(" "), _c('span', {
    staticClass: "right all-amount"
  }, [_vm._v("会员余额总额："), _c('b', [_vm._v(_vm._s((_vm.totalAmount).toFixed(2)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_c('span', {
    staticClass: "aCheckbox",
    on: {
      "click": _vm.isAll
    }
  }, [_c('label', {
    class: {
      show: _vm.allCheckArr
    }
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("备注名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("电话")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("余额")]), _c('i', {
    staticClass: "iconfont icon-sanjiaoxing",
    staticStyle: {
      "font-size": "14px",
      "color": "#4a90e2",
      "cursor": "pointer"
    },
    attrs: {
      "title": "点击排序"
    },
    on: {
      "click": function($event) {
        _vm.timeSort = false;
        _vm.addTimeSort = false;
        _vm.getVipData('AMOUNT', 'DOWN');
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("消费时间")]), _c('i', {
    class: _vm.nowTimeSort == 'DOWN' ? 'arrow arrow-back iconfont icon-sanjiaoxing' : 'arrow iconfont icon-sanjiaoxing',
    staticStyle: {
      "font-size": "14px",
      "color": "#4a90e2",
      "cursor": "pointer"
    },
    attrs: {
      "title": "点击排序"
    },
    on: {
      "click": function($event) {
        _vm.timeSort = true;
        _vm.addTimeSort = false;
        _vm.nowTimeSort == 'DOWN' ? _vm.nowTimeSort = 'UP' : _vm.nowTimeSort = 'DOWN'
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("注册时间")]), _c('i', {
    class: _vm.nowAddTimeSort == 'DOWN' ? 'arrow arrow-back iconfont icon-sanjiaoxing' : 'arrow iconfont icon-sanjiaoxing',
    staticStyle: {
      "font-size": "14px",
      "color": "#4a90e2",
      "cursor": "pointer"
    },
    attrs: {
      "title": "点击排序"
    },
    on: {
      "click": function($event) {
        _vm.timeSort = false;
        _vm.addTimeSort = true;
        _vm.nowAddTimeSort == 'DOWN' ? _vm.nowAddTimeSort = 'UP' : _vm.nowAddTimeSort = 'DOWN'
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("消费详情")])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.vipData.length > _vm.pageSize
    }
  }, _vm._l((_vm.vipData), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [(item.memberId) ? _c('span', {
      staticClass: "aCheckbox",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.curCheckArr),
        expression: "curCheckArr"
      }],
      staticStyle: {
        "position": "absolute",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "type": "checkbox",
        "id": 'inventory' + ind
      },
      domProps: {
        "value": item.memberId,
        "checked": Array.isArray(_vm.curCheckArr) ? _vm._i(_vm.curCheckArr, item.memberId) > -1 : (_vm.curCheckArr)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.curCheckArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.memberId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.curCheckArr = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.curCheckArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.curCheckArr = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        show: item.memberId == _vm.curCheckArr[ind]
      },
      attrs: {
        "for": 'inventory' + ind
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [(item.memberId) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.pageSize * _vm.curPage)
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.memberName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%",
        "text-align": "left"
      }
    }, [(item.memberId) ? _c('i', {
      staticClass: "iconfont icon-bianji",
      staticStyle: {
        "color": "#9FBCFB",
        "cursor": "pointer"
      },
      attrs: {
        "title": '修改备注'
      },
      on: {
        "click": function($event) {
          return _vm.notesFn1(item, 'name')
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.mobile)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.memberId) ? _c('span', {
      domProps: {
        "textContent": _vm._s(item.amount)
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.memberId) ? _c('span', [_vm._v(_vm._s(_vm._f("numberToMuchDay")(item.time)))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [(item.memberId) ? _c('span', [_vm._v(_vm._s(_vm._f("numberToMuchDay")(item.addTime)))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [(item.memberId) ? _c('span', {
      staticStyle: {
        "color": "#3068fe",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.vipDetail1(item)
        }
      }
    }, [_vm._v("-查看-")]) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "left out-excel"
  }, [_c('span', {
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出excel")])]), _vm._v(" "), _c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "coupons",
    attrs: {
      "title": '派发优惠券',
      "visible": _vm.couponBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.couponBtn = $event
      }
    }
  }, [_c('div', {
    staticClass: "inners"
  }, [_c('div', {
    staticClass: "coupon-tip"
  }, [_vm._v("请选择优惠券:")]), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.couponModel),
      callback: function($$v) {
        _vm.couponModel = $$v
      },
      expression: "couponModel"
    }
  }, [_vm._l((_vm.couponList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": JSON.stringify(item)
      }
    })
  }), _vm._v(" "), (_vm.couponListMoreBtn) ? _c('li', {
    staticStyle: {
      "color": "#999",
      "padding": "10px 0",
      "text-align": "center",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('span', [_vm._v("更多优惠券...")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "coupon-tip"
  }, [_vm._v("请选择优惠券数量:")]), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.qty),
      callback: function($$v) {
        _vm.qty = $$v
      },
      expression: "qty"
    }
  }, _vm._l((_vm.qtyOptions), function(item) {
    return _c('el-option', {
      key: item.title,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (!_vm.curCheckArr.length) ? [_c('div', {
    staticClass: "coupon-tip"
  }, [_vm._v("请输入密码:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.sendPwd),
      callback: function($$v) {
        _vm.sendPwd = $$v
      },
      expression: "sendPwd"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "coupon-info"
  }, [_c('div', {
    staticClass: "coupon-info-item clearfix"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("优惠卷类型")]), _vm._v(" "), _c('span', {
    staticClass: "right",
    domProps: {
      "textContent": _vm._s(_vm.curCouponData.type ? _vm.couponType[_vm.curCouponData.type] : '-')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "coupon-info-item clearfix"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("过期天数")]), _vm._v(" "), _c('span', {
    staticClass: "right",
    domProps: {
      "textContent": _vm._s(_vm.curCouponData.expireDays ? _vm.curCouponData.expireDays + '天' : '-')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "coupon-info-item clearfix"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("抵扣商品")]), _vm._v(" "), _c('span', {
    staticClass: "right",
    domProps: {
      "textContent": _vm._s(_vm.curCouponData.productName ? _vm.curCouponData.productName : '-')
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.couponBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doShowCoupon
    }
  }, [_vm._v("提交")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "消费详情",
      "visible": _vm.vipDetailBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.vipDetailBtn = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("流水号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("商品")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.vipDetailArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(item.id) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.pageSize * _vm.WKcurPage)
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("numberToDate")(item.createTime, '')))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.code)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.amount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [(item.id) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.vipOrderProductDetail(item.items)
        }
      }
    }, [_vm._v("详情")]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pag flex flex-align-center",
    attrs: {
      "id": "pag"
    }
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: _vm.WKcurPage > 0
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.changeDetailPage(false)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.WKcurPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left"
  }, [_c('i', {
    staticClass: "el-icon-arrow-right",
    class: {
      havePage: ((_vm.WKcurPage + 1) < _vm.WKtotalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changeDetailPage(true)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.WKtotalElements > 0 ? (_vm.WKcurPage + 1) : '0') + ' / ' + _vm.WKtotalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.WKtotalElements + '条')
    }
  })])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '优惠券详情(已使用：' + _vm.usedCount + '张,' + '未使用：' + _vm.hasCount + '张)',
      "visible": _vm.showCouponDetail,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showCouponDetail = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("优惠券名字")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("过期时间")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll",
    staticStyle: {
      "height": "500px",
      "overflow-y": "scroll"
    }
  }, [_c('table', [_c('tbody', _vm._l((_vm.couponDetailArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.start)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#000"
      },
      domProps: {
        "textContent": _vm._s(item.end)
      }
    })])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pag flex flex-align-center",
    attrs: {
      "id": "pag"
    }
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "商品详情",
      "visible": _vm.vipOrderProductBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.vipOrderProductBtn = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner",
    staticStyle: {
      "padding": "20px 60px 40px"
    }
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("合计")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.vipOrderProductArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.quantity)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    })])])
  }), 0)])])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "codes",
    attrs: {
      "title": _vm.notes.type == 'name' ? '备注会员名' : '修改手机号',
      "visible": _vm.notesBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.notesBtn = $event
      }
    }
  }, [_c('div', {
    staticClass: "inners"
  }, [(_vm.notes.type == 'name') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes.name),
      expression: "notes.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入备注"
    },
    domProps: {
      "value": (_vm.notes.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.notes, "name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notes.type == 'mobile') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes.mobile),
      expression: "notes.mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入电话"
    },
    domProps: {
      "value": (_vm.notes.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.notes, "mobile", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.notesBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.notesFn
    }
  }, [_vm._v("提交")])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "codes",
    attrs: {
      "title": '确认派发优惠券吗?',
      "visible": _vm.showSureDistribute,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showSureDistribute = $event
      }
    }
  }, [(!_vm.curCheckArr || !_vm.curCheckArr.length) ? _c('div', {
    staticClass: "inners"
  }, [_c('p', [_vm._v("重要提示：确认派发给"), _c('b', {
    staticStyle: {
      "color": "red",
      "padding": "0 5px"
    }
  }, [_vm._v("“所有会员”")]), _vm._v("吗 ？")])]) : _c('div', {
    staticClass: "inners"
  }, [_c('p', [_vm._v("确认派发优惠券给所选择的"), _c('b', {
    staticStyle: {
      "color": "red",
      "padding": "0 5px"
    }
  }, [_vm._v(_vm._s(_vm.curCheckArr.length))]), _vm._v("个会员吗 ？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showSureDistribute = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.couponUpdate
    }
  }, [_vm._v("确认")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "群发记录",
      "visible": _vm.payHostBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.payHostBtn = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner",
    staticStyle: {
      "padding": "20px 60px 40px"
    }
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("充值项目")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("会员数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("充值时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.payHostArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.type == 'WECHAT' ? '微信群发' : '-')
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("numberToMonthDate")(item.updateTime, '')))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.amount / 100)
      }
    })])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pag flex flex-align-center",
    attrs: {
      "id": "pag"
    }
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: _vm.PAYcurPage > 0
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.payHostPage(false)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.PAYcurPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left"
  }, [_c('i', {
    staticClass: "el-icon-arrow-right",
    class: {
      havePage: ((_vm.PAYcurPage + 1) < _vm.PAYtotalPage)
    },
    on: {
      "click": function($event) {
        return _vm.payHostPage(true)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.PAYtotalElements > 0 ? (_vm.PAYcurPage + 1) : '0') + ' / ' + _vm.PAYtotalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.PAYtotalElements + '条')
    }
  })])])]), _vm._v(" "), (_vm.weChatBtn) ? _c('div', {
    staticClass: "weChatOuter",
    on: {
      "click": function($event) {
        _vm.weChatBtn = false
      }
    }
  }, [(_vm.seep == 1) ? _c('div', {
    staticClass: "position-middle-center clearfix",
    staticStyle: {
      "width": "720px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wx-box left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("微信群发"), _c('span', {
    staticClass: "title-notes"
  }, [_vm._v("每条0.05元")]), _c('div', {
    staticClass: "title-close-btn",
    on: {
      "click": function($event) {
        _vm.weChatBtn = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "wx-content"
  }, [_c('div', {
    staticClass: "wx-cont-item"
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v("网吧")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weChatModel.name),
      expression: "weChatModel.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入店铺名称"
    },
    domProps: {
      "value": (_vm.weChatModel.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.weChatModel, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wx-cont-item"
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v("主题")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weChatModel.ACtitle),
      expression: "weChatModel.ACtitle"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入活动主题（8-14字为佳）"
    },
    domProps: {
      "value": (_vm.weChatModel.ACtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.weChatModel, "ACtitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wx-cont-item"
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v("时间")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "time",
    attrs: {
      "editable": false,
      "picker-options": _vm.pickerOptions0,
      "type": "date",
      "placeholder": "请输入开始时间"
    },
    model: {
      value: (_vm.weChatModel.timeFrom),
      callback: function($$v) {
        _vm.$set(_vm.weChatModel, "timeFrom", $$v)
      },
      expression: "weChatModel.timeFrom"
    }
  }), _vm._v(" "), _c('span', [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "time",
    attrs: {
      "editable": false,
      "picker-options": _vm.pickerOptions0,
      "type": "date",
      "placeholder": "请输入结束时间"
    },
    model: {
      value: (_vm.weChatModel.timeTo),
      callback: function($$v) {
        _vm.$set(_vm.weChatModel, "timeTo", $$v)
      },
      expression: "weChatModel.timeTo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wx-cont-item"
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v("地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weChatModel.address),
      expression: "weChatModel.address"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入活动地址"
    },
    domProps: {
      "value": (_vm.weChatModel.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.weChatModel, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wx-cont-item"
  }, [_c('span', {
    staticClass: "span",
    staticStyle: {
      "position": "relative",
      "top": "-90px"
    }
  }, [_vm._v("内容")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weChatModel.rules),
      expression: "weChatModel.rules"
    }],
    attrs: {
      "name": "",
      "id": "",
      "placeholder": "请输入活动内容或规则"
    },
    domProps: {
      "value": (_vm.weChatModel.rules)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.weChatModel, "rules", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wx-cont-item"
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v("背景")]), _vm._v(" "), _vm._l((_vm.bgArr), function(item, ind) {
    return _c('span', {
      class: ['bgType', {
        AC_BG: _vm.curBgIndex == ind
      }],
      domProps: {
        "textContent": _vm._s('背景' + (ind + 1))
      },
      on: {
        "click": function($event) {
          return _vm.cutBg(item, ind)
        }
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "wx-footer clearfix"
  }, [_c('div', {
    staticClass: "left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s('会员总数：' + _vm.payData.memberCount)
    }
  }), _c('p', {
    staticStyle: {
      "margin-top": "5px",
      "color": "red"
    },
    domProps: {
      "textContent": _vm._s('费用：' + _vm.payData.amount / 100 + '元')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "sure",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.wxUP
    }
  }, [_vm._v("提交")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "cancle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.weChatBtn = false
      }
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right shell-box"
  }, [_c('div', {
    staticClass: "shell-box-topBG"
  }), _vm._v(" "), _c('div', {
    staticClass: "shell-box-innerBg",
    attrs: {
      "id": "shell-box-innerBg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shell-box-innerCont"
  }, [_c('div', {
    staticClass: "shell-name",
    domProps: {
      "textContent": _vm._s(_vm.weChatModel.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shell-title",
    domProps: {
      "textContent": _vm._s(_vm.weChatModel.ACtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shell-time"
  }, [(new Date(_vm.weChatModel.timeFrom).getTime() == new Date(_vm.weChatModel.timeTo).getTime()) ? _c('span', {
    domProps: {
      "textContent": _vm._s(new Date(_vm.weChatModel.timeFrom).Format('yyyy.MM.dd'))
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(new Date(_vm.weChatModel.timeFrom).Format('yyyy.MM.dd') + '-' + new Date(_vm.weChatModel.timeTo).Format('yyyy.MM.dd'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shell-rules-title"
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('div', {
    staticClass: "shell-rules-cont",
    domProps: {
      "innerHTML": _vm._s(_vm.weChatShowRules)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shell-addr",
    domProps: {
      "textContent": _vm._s('地址：' + _vm.weChatModel.address)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.seep == 2) ? _c('div', {
    staticClass: "pay position-middle-center",
    staticStyle: {
      "width": "300px",
      "height": "310px",
      "background": "#fff",
      "border-radius": "5px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "imgbox",
    staticStyle: {
      "width": "300px",
      "height": "20px",
      "position": "relative",
      "text-align": "center",
      "font-size": "18px",
      "margin-top": "10px"
    }
  }, [_vm._v("\n                请用微信扫码支付\n                "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "right": "5px",
      "top": "-5px",
      "font-size": "24px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.closePay
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "300px",
      "height": "300px"
    },
    attrs: {
      "src": _vm.payUrl,
      "alt": ""
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "market"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "fliter type"
  }, [_vm._v("\n                        分类选择：\n                        "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.fliter_type),
      callback: function($$v) {
        _vm.fliter_type = $$v
      },
      expression: "fliter_type"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fliterGoods
    }
  }, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn cart"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGoods
    }
  }, [_c('i', {
    staticClass: "iconfont icon-gouwuche"
  }), _vm._v(" "), _c('span', [_vm._v("购物车")]), _vm._v(" "), (_vm.seledGoodCount > 0) ? _c('span', {
    staticClass: "cart-count"
  }, [_c('b', [_vm._v(_vm._s(_vm.seledGoodCount))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.vipData.length > 6
    }
  }, _vm._l((_vm.vipData), function(item, idx) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "4%"
      },
      domProps: {
        "textContent": _vm._s(item.id ? (idx + 1) : '')
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "img",
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": "点击查看大图"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "img_box",
      on: {
        "click": function($event) {
          return _vm.bigImg(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.productName
      },
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.productTypeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.spec)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      },
      domProps: {
        "textContent": _vm._s(item.amount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_c('span', {
      class: item.notice ? 'notice active' : 'notice'
    }, [_vm._v(_vm._s(item.id ? (item.notice ? item.notice : "暂无备注") : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "add-count",
      staticStyle: {
        "width": "6%"
      }
    }, [(item.id) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.count),
        expression: "item.count"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.count)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "count", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline add-cart",
      on: {
        "click": function($event) {
          return _vm.addCart(item)
        }
      }
    }, [_c('span', {
      staticClass: "iconfont icon-jiarugouwuche",
      attrs: {
        "title": "加入购物车"
      }
    }, [_vm._v("添加至购物车")])]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": '购物车',
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "cart-info"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('ul', {
    staticClass: "head"
  }, [_c('li', [_c('span', {
    staticStyle: {}
  }, [_vm._v("序号")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }, [_vm._v("图片")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }, [_vm._v("商品名")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }, [_vm._v("单价")])])]), _vm._v(" "), (_vm.cartList.length) ? _c('div', {
    staticClass: "goods-list"
  }, [_c('ul', _vm._l((_vm.cartList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "goods-img"
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('span', {
      staticClass: "goods-count"
    }, [_c('i', {
      staticClass: "iconfont icon-jianshao",
      on: {
        "click": function($event) {
          return _vm.reduCount(item)
        }
      }
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-tianjia-xue",
      on: {
        "click": function($event) {
          return _vm.addCount(item)
        }
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.amount))])])
  }), 0)]) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_vm._v("\n                    暂无选购商品\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("请选择收货地址：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    model: {
      value: (_vm.addr),
      callback: function($$v) {
        _vm.addr = $$v
      },
      expression: "addr"
    }
  }, _vm._l((_vm.addrList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.address,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "total-money"
  }, [_vm._v("\n                    总金额：" + _vm._s(_vm.totalAmount) + "\n                ")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goSelPayType
    }
  }, [_vm._v("结账")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "备注",
      "visible": _vm.showNotice,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showNotice = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "1%"
    }
  }, [_vm._v(_vm._s(_vm.note))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showNotice = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showNotice = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择支付方式",
      "visible": _vm.showPayType,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPayType = $event
      }
    }
  }, [_c('div', {
    staticClass: "pay-type"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "wechat",
    on: {
      "click": function($event) {
        return _vm.selPayType('wechat')
      }
    }
  }, [_vm._v("微信")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ali",
    on: {
      "click": function($event) {
        return _vm.selPayType('ali')
      }
    }
  }, [_vm._v("支付宝")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "other",
    on: {
      "click": function($event) {
        return _vm.selPayType('other')
      }
    }
  }, [_vm._v("先下单后结账")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "支付二维码",
      "visible": _vm.showPayCode,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPayCode = $event
      }
    }
  }, [_c('div', {
    staticClass: "pay-code"
  }, [_c('div', {
    staticClass: "pay-time"
  }, [_vm._v("支付剩余时间:" + _vm._s(_vm.payOutTime))]), _vm._v(" "), (_vm.showPayCode) ? _c('div', {
    attrs: {
      "id": "qrCode"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.showBigImg) ? _c('div', {
    staticClass: "big-img",
    on: {
      "click": function($event) {
        _vm.showBigImg = false;
      }
    }
  }, [_c('div', {
    staticClass: "big-img-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.bigImgUrl,
      "alt": ""
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("规格")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("备注")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("购买数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-summary"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "search-header"
  }, [_c('div', {
    staticClass: "selsect-month"
  }, [_c('span', {
    staticClass: "change-month last",
    on: {
      "click": function($event) {
        return _vm.changeMonth('last')
      }
    }
  }, [_vm._v("上一月")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "format": "yyyy-MM",
      "value-format": "yyyy-MM",
      "picker-options": _vm.pickerOptions,
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.nowMonth),
      callback: function($$v) {
        _vm.nowMonth = $$v
      },
      expression: "nowMonth"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "change-month next",
    on: {
      "click": function($event) {
        return _vm.changeMonth('next')
      }
    }
  }, [_vm._v("下一月")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "list-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "table-cont"
  }, [(_vm.sumList.length > 0) ? _c('table', {
    staticStyle: {
      "table-layout": "fixed"
    }
  }, _vm._l((_vm.sumList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(((_vm.nowPage - 1) * _vm.pageSize + index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.skuName))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.stockType[item.type]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(_vm.sourceType[item.source]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.notes === "" ? "暂无备注" : item.notes))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.addTime)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.operatorName))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("暂无记录")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sum-total"
  }, [_c('span', {
    staticClass: "total-money"
  }, [_vm._v("总金额：")]), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.totalAmount)))]), _vm._v(" "), _c('span', {
    staticClass: "total-count"
  }, [_vm._v("总数量：")]), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.totalCount))])]), _vm._v(" "), _c('span', {
    staticClass: "excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出excel")]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.nowPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.nowPage = $event
      },
      "update:current-page": function($event) {
        _vm.nowPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "sum"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-header"
  }, [_c('table', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("件数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("原因")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("备注")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("操作人员")])])])])
}]}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipMan"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.vipData.length > _vm.pageSize
    }
  }, _vm._l((_vm.vipData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%"
      },
      domProps: {
        "textContent": _vm._s(item.code)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.memberName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.mobile)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.amountBonus)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [(item.addTime) ? _c('span', [_vm._v(_vm._s(_vm._f("numberToDate")(item.addTime, '')))]) : _vm._e(), _vm._v(" "), (!item.addTime) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.referralUserName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [(item.code) ? _c('span', [_vm._v("-")]) : _vm._e()])])
  }), 0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("会员号码")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("会员名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("电话")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("余额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("入会时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("推荐人")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("电子券数量")])])])
}]}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settleCount",
    attrs: {
      "id": "charge-info"
    }
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "89.3%",
      "position": "relative",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'MONTH') ? _c('div', {
    staticClass: "date-filter"
  }, [_c('span', [_vm._v("选择时间:")]), _vm._v(" "), _c('el-date-picker', {
    ref: "dateInput",
    attrs: {
      "type": "month",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "placeholder": "请选择选择日期"
    },
    model: {
      value: (_vm.dateStr),
      callback: function($$v) {
        _vm.dateStr = $$v
      },
      expression: "dateStr"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("交易时间：" + _vm._s(_vm._f("dateForGradePage")(_vm.nowSettleInfo.begin)) + " 至 ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowSettleInfo.end)))])], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'TIME_RANGE') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('span', [_vm._v("起始时间:")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptions,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptions,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "panle"
  }, [_c('div', {
    staticClass: "panle-item"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "item-val"
  }, [_vm._v("￥" + _vm._s(Number(_vm.nowSettleInfo.amount).toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "panle-item"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "item-val"
  }, [_vm._v("￥" + _vm._s(Number(Number(_vm.nowSettleInfo.amount) * _vm.fee).toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panle"
  }, [_c('div', {
    staticClass: "panle-item flex-all"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "item-val"
  }, [_vm._v("￥" + _vm._s(Number(Number(_vm.nowSettleInfo.amount) * (1 - _vm.fee)).toFixed(2)))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-name"
  }, [_c('i', {
    staticClass: "iconfont icon-jine"
  }), _vm._v(" "), _c('span', [_vm._v("交易净额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-name"
  }, [_c('i', {
    staticClass: "iconfont icon-daishoujine"
  }), _vm._v(" "), _c('span', [_vm._v("支付手续费")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "item-name"
  }, [_c('i', {
    staticClass: "iconfont icon-jine1"
  }), _vm._v(" "), _c('span', [_vm._v("结算金额")])])
}]}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wechat-order"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.codeBtn = true;
      }
    }
  }, [_vm._v("添加微信点单")])]), _vm._v(" "), _c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.out
    }
  }, [_vm._v("批量导出")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.wechatList.length > _vm.pageSize
    }
  }, _vm._l((_vm.wechatList), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(item.id ? ((index + 1) + (_vm.nowPage - 1) * _vm.pageSize) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(item.id ? decodeURIComponent(item.name) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [(item.id) ? _c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showCodeImg(item)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.addTime)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      staticClass: "change",
      on: {
        "click": function($event) {
          return _vm.doChange(item)
        }
      }
    }, [(item.id) ? _c('i', {
      staticClass: "iconfont icon-bianji",
      staticStyle: {
        "color": "#333"
      }
    }) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          return _vm.doActive(item)
        }
      }
    }, [(item.id) ? _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      staticStyle: {
        "color": "#333"
      }
    }) : _vm._e()])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.nowPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.nowPage = $event
      },
      "update:current-page": function($event) {
        _vm.nowPage = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "codes",
    attrs: {
      "title": "微信点单",
      "visible": _vm.codeBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.codeBtn = $event
      }
    }
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("桌号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableNo),
      expression: "tableNo"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入桌号"
    },
    domProps: {
      "value": (_vm.tableNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tableNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.codeBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addWechatOrder
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "codes",
    attrs: {
      "title": '打开微信可扫描二维码',
      "visible": _vm.showCode,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showCode = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [_c('span', [_vm._v("保存为图片(建议使用谷歌浏览器，如使用的360等浏览器，请打开极速模式。)")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-wrap"
  }, [_c('div', {
    staticClass: "inners",
    attrs: {
      "id": "img-info"
    }
  }, [_c('div', {
    staticClass: "inner-top"
  }, [_c('div', {
    staticClass: "inner-tit"
  }, [_vm._v("扫码点餐买单")]), _vm._v(" "), _c('div', {
    staticClass: "code-wrap"
  }, [_c('div', {
    attrs: {
      "id": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-code"
  }, [_vm._v(_vm._s(_vm.codeInfo))])]), _vm._v(" "), _c('div', {
    staticClass: "inner-bot"
  }, [_c('div', {
    staticClass: "code-info"
  }, [_c('span', {
    staticClass: "wechat"
  }, [_c('i', {
    staticClass: "iconfont icon-weixinzhifu"
  }), _c('b', [_vm._v("微信支付")])]), _vm._v(" "), _c('span', {
    staticClass: "huoxing"
  }, [_c('i', {
    staticClass: "iconfont icon-huoxingbushoulogo"
  }), _c('b', [_vm._v("火星捕手")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "save-img"
  }, [_c('a', {
    attrs: {
      "href": "",
      "id": "down-img",
      "download": ""
    }
  }, [_vm._v("保存图片")])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-wrap-all",
    staticStyle: {
      "height": "0px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "inners",
    attrs: {
      "id": "img-info-all"
    }
  }, [_c('div', {
    staticClass: "inner-top"
  }, [_c('div', {
    staticClass: "inner-tit"
  }, [_vm._v("扫码点餐买单")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-code"
  }, [_vm._v(_vm._s(_vm.nowCodeName))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), (!_vm.isOutSuc) ? _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "mask-info"
  }, [_vm._v("\n            请稍等...正在打包中...(" + _vm._s(_vm.count) + "/" + _vm._s(_vm.allCodeList.length) + ")\n        ")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("桌号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("二维码")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("添加时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-wrap"
  }, [_c('div', {
    staticClass: "qr-code-img-wrap",
    attrs: {
      "id": "qrcode-all"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-bot"
  }, [_c('div', {
    staticClass: "code-info"
  }, [_c('span', {
    staticClass: "wechat"
  }, [_c('i', {
    staticClass: "iconfont icon-weixinzhifu"
  }), _c('b', [_vm._v("微信支付")])]), _vm._v(" "), _c('span', {
    staticClass: "huoxing"
  }, [_c('i', {
    staticClass: "iconfont icon-huoxingbushoulogo"
  }), _c('b', [_vm._v("火星捕手")])])])])
}]}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discount"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("\n                        原料商品管理\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      staticStyle: {
        "height": "9%"
      }
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      staticStyle: {
        "height": "100%"
      }
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      staticStyle: {
        "width": "33%",
        "text-align": "left",
        "padding-left": "15%"
      }
    }, [_c('span', {
      staticClass: "parent_default type_name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      staticStyle: {
        "width": "33%",
        "text-align": "left",
        "padding-left": "15%"
      }
    }, [_c('span', {
      staticClass: "parent_default type_name"
    }, [_vm._v(_vm._s(_vm.unitFormat[item.unitId]))])]), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
    }, [_c('i', {
      staticClass: "iconfont icon-bianji",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑",
      "visible": _vm.addJobVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("原料名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDiscount.name),
      expression: "newDiscount.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.newDiscount.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDiscount, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("原料单位")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择单位"
    },
    model: {
      value: (_vm.newDiscount.unitId),
      callback: function($$v) {
        _vm.$set(_vm.newDiscount, "unitId", $$v)
      },
      expression: "newDiscount.unitId"
    }
  }, _vm._l((_vm.unitOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "优惠商品详情",
      "visible": _vm.mealInfo,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.mealInfo = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "meal-goods"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('table', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("所属分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.mealInfoData.length) ? _c('table', _vm._l((_vm.mealInfoData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.setMealQty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%",
        "color": "#3068ff",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.delMealGoods(item)
        }
      }
    }, [_vm._v("删除")])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.mealInfoData.length) ? _c('div', {
    staticStyle: {
      "padding": "10px 0",
      "text-align": "center"
    }
  }, [_vm._v("\n                            暂无商品\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.showSelGoods) ? _c('div', {
    staticClass: "sel-goods"
  }, [_c('selGoods', {
    attrs: {
      "isDiscount": true,
      "nowSelClassGoods": _vm.nowSelClassGoods,
      "storeId": _vm.curStoreId,
      "nowSelClass": _vm.nowSelClass
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": _vm.closeSelGoods
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "33%",
      "text-align": "left",
      "padding-left": "15%"
    }
  }, [_vm._v("原料名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%",
      "text-align": "left",
      "padding-left": "11.5%"
    }
  }, [_vm._v("原料单位")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "2%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statement"
  }, [_c('div', {
    staticClass: "statement-inner-box"
  }, [_c('div', {
    staticClass: "pie clearfix"
  }, [_c('div', {
    staticClass: "totalMsg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nowDataType = 'SEVEN'
      }
    }
  }, [_c('div', {
    class: _vm.nowDataType == 'SEVEN' ? 'totalMsgInner active' : 'totalMsgInner'
  }, [_vm._v("\n                    最近7天\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "totalMsg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nowDataType = 'FIFTEEN'
      }
    }
  }, [_c('div', {
    class: _vm.nowDataType == 'FIFTEEN' ? 'totalMsgInner active' : 'totalMsgInner'
  }, [_vm._v("\n                    最近15天\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "totalMsg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nowDataType = 'THIRTY'
      }
    }
  }, [_c('div', {
    class: _vm.nowDataType == 'THIRTY' ? 'totalMsgInner active' : 'totalMsgInner'
  }, [_vm._v("\n                    最近30天\n                ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "totalMsg titinfo"
  }, [_c('span', [_c('i', [_vm._v("● 每条曲线对应一个分类")]), _c('br'), _c('i', [_vm._v(" ● 鼠标停留在圆点展示每个分类数据")])]), _vm._v(" "), _c('span', [_c('i', [_vm._v(" ● 每个圆点对应当天分类销售额")]), _c('br'), _c('i', [_vm._v(" ● 点击分类名可关闭或单独显示某个分类数据")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "histogram-wrap"
  }, [_c('div', {
    attrs: {
      "id": "histogram"
    }
  })])
}]}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showUpBox(null)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加租赁商品\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.listData.length > 10
    }
  }, _vm._l((_vm.listData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "img_box"
    }, [_c('img', {
      staticStyle: {
        "width": "50px",
        "height": "50px",
        "margin": "20px 0"
      },
      attrs: {
        "src": item.image + '?x-oss-process=image/resize,l_300',
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productTypeName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.queue)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.totalCount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [(item.id) ? _c('span', {
      style: (item.showPcEnabled ? 'color:green' : 'color:red')
    }, [_vm._v(_vm._s(item.showPcEnabled ? "是" : "否"))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "left",
        "padding-left": "1%"
      }
    }, [(item.id) ? _c('span', {
      style: (item.buyEnabled ? 'color:green' : 'color:red')
    }, [_vm._v(_vm._s(item.buyEnabled ?
      "是" : "否"))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "right",
        "padding-right": "5%"
      }
    }, [(item.id) ? _c('span', {
      staticStyle: {
        "margin": "0 2%",
        "cursor": "pointer"
      },
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.showUpBox(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]) : _vm._e(), _vm._v(" "), (item.id) ? _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '添加/编辑租赁商品',
      "visible": _vm.addAddrBtn,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addAddrBtn = $event
      }
    }
  }, [_c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品分类")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.form.productTypeId),
      callback: function($$v) {
        _vm.$set(_vm.form, "productTypeId", $$v)
      },
      expression: "form.productTypeId"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("排序值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.queue),
      expression: "form.queue"
    }],
    staticClass: "itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.queue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "queue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("总库存数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalCount),
      expression: "form.totalCount"
    }],
    staticClass: "itemInput",
    attrs: {
      "type": "number",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.totalCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalCount", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("展示到PC")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.form.showPcEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "showPcEnabled", $$v)
      },
      expression: "form.showPcEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.form.showPcEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "showPcEnabled", $$v)
      },
      expression: "form.showPcEnabled"
    }
  }, [_vm._v("否")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("是否能购买")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.form.buyEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "buyEnabled", $$v)
      },
      expression: "form.buyEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.form.buyEnabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "buyEnabled", $$v)
      },
      expression: "form.buyEnabled"
    }
  }, [_vm._v("否")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "msgItem",
    staticStyle: {
      "justify-content": "normal",
      "margin-bottom": "0px"
    }
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品押金")]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.modifyExtra('add')
      }
    }
  }, [_vm._v("添加数据")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "msgItem",
    staticStyle: {
      "justify-content": "normal",
      "margin-bottom": "0px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cont-list"
  }, [(_vm.showRule) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.extras,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "押金金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (scope.row.amount),
            callback: function($$v) {
              _vm.$set(scope.row, "amount", $$v)
            },
            expression: "scope.row.amount"
          }
        })]
      }
    }], null, false, 3878719626)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "计费方式",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": function (e) { return _vm.changeItemRule(e, scope.row); }
          },
          model: {
            value: (scope.row.ruleId),
            callback: function($$v) {
              _vm.$set(scope.row, "ruleId", $$v)
            },
            expression: "scope.row.ruleId"
          }
        }, _vm._l((_vm.ruleList), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)]
      }
    }], null, false, 1925993299)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "适用区域（仅针对PC客户端）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "multiple": "",
            "placeholder": "不选择区域，则默认为全场..."
          },
          model: {
            value: (scope.row.options),
            callback: function($$v) {
              _vm.$set(scope.row, "options", $$v)
            },
            expression: "scope.row.options"
          }
        }, _vm._l((_vm.regionData), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)], 1)]
      }
    }], null, false, 510709140)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "PC默认规则",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          model: {
            value: (scope.row.defaultPcRule),
            callback: function($$v) {
              _vm.$set(scope.row, "defaultPcRule", $$v)
            },
            expression: "scope.row.defaultPcRule"
          }
        })]
      }
    }], null, false, 3155441348)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.modifyExtra('del', scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 947840140)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "msgWrap"
  }, [_c('div', {
    staticClass: "msgBox img_box clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品图片")]), _vm._v(" "), _c('div', {
    staticClass: "left img",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "img_item left"
  }, [(_vm.form.image) ? _c('img', {
    ref: "goodsImg",
    attrs: {
      "src": _vm.form.image + '?x-oss-process=image/resize,l_300',
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.image) ? _c('span', {
    staticClass: "del-img",
    on: {
      "click": _vm.delImg
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img_up_btn left"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai"
  }), _vm._v(" "), _c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mobileImgFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.coverImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "uploadImgTip"
  }, [_vm._v("\n              支持JPG、JPEG、PNG格式，单张大小不超过5M，建议尺寸 600*600 px\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox img_box clearfix"
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addAddrBtn = false
      }
    }
  }, [_vm._v("\n        取消\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addFn
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                商品图片\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                商品名称\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                分类名称\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                排序值\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                总库存数\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                展示至PC\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "left",
      "padding-left": "1%"
    }
  }, [_vm._v("\n                允许购买\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "right",
      "padding-right": "5%"
    }
  }, [_vm._v("\n                操作\n              ")])])])
}]}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pcOrder"
  }, [_c('p', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-top": "10px",
      "color": "red"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select-wrap",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-cont"
  }, [_c('div', {
    staticClass: "goods-left"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "活动区域"
    },
    model: {
      value: (_vm.typeId),
      callback: function($$v) {
        _vm.typeId = $$v
      },
      expression: "typeId"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.getGoods
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_c('el-button', {
    staticClass: "upLoad",
    attrs: {
      "type": "danger",
      "size": ""
    },
    on: {
      "click": _vm.coverImg
    }
  }, [_c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v("上传背景")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openBigScreen
    }
  }, [_vm._v("查看大屏")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clearBg
    }
  }, [_vm._v("恢复默认样式")]), _vm._v(" "), _c('span', {
    staticClass: "txt-color",
    staticStyle: {
      "height": "37px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.isBold),
      callback: function($$v) {
        _vm.isBold = $$v
      },
      expression: "isBold"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "-1"
    }
  }, [_vm._v("默认字体")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("加粗字体")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "txt-color"
  }, [_vm._v("选择字体颜色:"), _c('el-color-picker', {
    model: {
      value: (_vm.textColor),
      callback: function($$v) {
        _vm.textColor = $$v
      },
      expression: "textColor"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    attrs: {
      "data": _vm.tableData,
      "row-key": _vm.getRowKeys,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.productName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "分类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参与排单"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (scope.row.schedulingEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "schedulingEnabled", $$v)
            },
            expression: "scope.row.schedulingEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参与制作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (scope.row.makeEnable),
            callback: function($$v) {
              _vm.$set(scope.row, "makeEnable", $$v)
            },
            expression: "scope.row.makeEnable"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "450",
      "label": "商品宣传语"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "form-item",
          staticStyle: {
            "display": "flex"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "text",
            "placeholder": "请输入第一句描述",
            "maxlength": 12,
            "size": "small",
            "show-word-limit": ""
          },
          model: {
            value: (scope.row.tips[0]),
            callback: function($$v) {
              _vm.$set(scope.row.tips, 0, $$v)
            },
            expression: "scope.row.tips[0]"
          }
        }), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "margin": "0 10px"
          },
          attrs: {
            "type": "text",
            "placeholder": "请输入第二句描述",
            "maxlength": 12,
            "size": "small",
            "show-word-limit": ""
          },
          model: {
            value: (scope.row.tips[1]),
            callback: function($$v) {
              _vm.$set(scope.row.tips, 1, $$v)
            },
            expression: "scope.row.tips[1]"
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.saveTips(scope.row)
            }
          }
        }, [_vm._v("保存")])], 1)]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wechat-list"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.codeBtn = true
      }
    }
  }, [_vm._v("\n              添加通知微信\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.wechatList.length > _vm.pageSize
    }
  }, _vm._l((_vm.wechatList), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(item.id ? index + 1 : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (false) ? _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_c('img', {
      style: (item.id ? 'width:50px;height:50px;' : ''),
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm._f("dateForGradePage")(item.addTime)) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      class: item.enabled ? 'do-active' : 'do-active not-active',
      attrs: {
        "title": '删除'
      },
      on: {
        "click": function($event) {
          return _vm.doActive(item)
        }
      }
    }, [(item.id) ? _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      staticStyle: {
        "color": "#333"
      }
    }) : _vm._e()])])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "codes",
    attrs: {
      "title": '请打开微信扫描二维码',
      "visible": _vm.codeBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.codeBtn = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("输入姓名后，点按回车键并扫描二维码")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "15px"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doShowQrcode.apply(null, arguments)
      }
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入姓名",
      "type": "text"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)]), _vm._v(" "), (_vm.showQrCode) ? _c('div', {
    staticClass: "inners"
  }, [_c('div', {
    attrs: {
      "id": "qrcode"
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("添加时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background-color": "#f6f7fb"
    }
  }, [(_vm.$route.name === 'goodsLog') ? _c('div', {
    staticClass: "goodsLog"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left search flex flex-align-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goods),
      expression: "goods"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.goods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goods = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.searchGoods
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search",
    style: ({
      display: (_vm.goodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.curGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.goodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item)
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, index) {
    return _c('tr', {
      key: index
    }, [(item.id) ? _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(index + 1 + (_vm.curPage) * _vm.pageSize))]) : _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "55%",
        "line-height": "19px"
      },
      domProps: {
        "innerHTML": _vm._s(item.notice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.addTime)))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "销售明细",
      "visible": _vm.showPutAllMask1,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask1 = $event
      },
      "close": _vm.closeSaleDetail
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "couponBox right"
  }, [_c('div', {
    staticClass: "changeWorkTitle",
    staticStyle: {
      "margin-bottom": "10px",
      "font-weight": "600"
    }
  }, [_vm._v("优惠券核销统计")]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, _vm._l((_vm.salesData.coupons), function(item, ind) {
    return _c('div', [_c('div', {
      staticClass: "couponItem clearfix"
    }, [_c('span', {
      staticClass: "name left",
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "price right",
      domProps: {
        "textContent": _vm._s('￥' + item.amount / 100)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "number right",
      domProps: {
        "textContent": _vm._s('X' + item.quantity)
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "goodTypeBox left"
  }, [_c('div', {
    staticClass: "changeWorkTitle",
    staticStyle: {
      "margin-bottom": "10px",
      "font-weight": "600"
    }
  }, [_vm._v("分类列表")]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("火星网费：")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(_vm.salesData.cost.cashAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("会员支付网费:")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(_vm.salesData.net.amount)))]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(",数量:")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.salesData.net.qty))])]), _vm._v(" "), _c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("会员充值金额：")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")((_vm.salesData.memberDepositAmount) / 100)))])]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "value": _vm.nowTypeName,
      "accordion": ""
    },
    on: {
      "change": _vm.getNowTypeProducts
    }
  }, _vm._l((_vm.salesData.itemDetails), function(item, ind) {
    return _c('el-collapse-item', {
      key: 'big' + ind,
      attrs: {
        "name": item.typeName
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("\n                                    " + _vm._s(item.typeName) + "：￥" + _vm._s(_vm._f("toFixedNum")(item.amount)) + "\n                                ")]), _vm._v(" "), _vm._l((_vm.nowItem), function(bigGood) {
      return _c('div', {
        staticClass: "goodItem clearfix"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(bigGood.qty + ' × ' + bigGood.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "right"
      }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(bigGood.amount)))])])
    })], 2)
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "员工销售",
      "visible": _vm.showPutAllMask2,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("员工名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("订单数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("销售金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.staffArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.pageSize * _vm.salesCurPage)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.creatorName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.orderCount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.totalAmount)
      }
    })])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.staff2Excel
    }
  }, [_vm._v("导出Excel")])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "stock",
    attrs: {
      "title": "库存记录",
      "visible": _vm.showStock,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showStock = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("分类名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("库存剩余")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.stockArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    })])])
  }), 0)])])])])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("记录")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("操作时间")])])])
}]}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discount"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("\n                        机位管理\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      staticStyle: {
        "height": "9%"
      }
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      staticStyle: {
        "height": "100%"
      }
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      staticStyle: {
        "width": "33%",
        "text-align": "left",
        "padding-left": "15%"
      }
    }, [_c('span', {
      staticClass: "parent_default type_name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      staticStyle: {
        "width": "33%",
        "text-align": "left",
        "padding-left": "15%"
      }
    }, [_c('span', {
      staticClass: "parent_default type_name"
    }, [_vm._v(_vm._s(_vm.unitFormat[item.unitId]))])]), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
    }, [_c('i', {
      staticClass: "iconfont icon-bianji",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑",
      "visible": _vm.addJobVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("机位名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDiscount.name),
      expression: "newDiscount.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.newDiscount.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDiscount, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDiscount.ipAddress),
      expression: "newDiscount.ipAddress"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.newDiscount.ipAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDiscount, "ipAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("排序")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDiscount.queue),
      expression: "newDiscount.queue"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.newDiscount.queue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDiscount, "queue", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("所属区域")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newDiscount.unitId),
      callback: function($$v) {
        _vm.$set(_vm.newDiscount, "unitId", $$v)
      },
      expression: "newDiscount.unitId"
    }
  }, _vm._l((_vm.unitOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "优惠商品详情",
      "visible": _vm.mealInfo,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.mealInfo = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "meal-goods"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('table', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("所属分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.mealInfoData.length) ? _c('table', _vm._l((_vm.mealInfoData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.setMealQty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%",
        "color": "#3068ff",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.delMealGoods(item)
        }
      }
    }, [_vm._v("删除")])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.mealInfoData.length) ? _c('div', {
    staticStyle: {
      "padding": "10px 0",
      "text-align": "center"
    }
  }, [_vm._v("\n                            暂无商品\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.showSelGoods) ? _c('div', {
    staticClass: "sel-goods"
  }, [_c('selGoods', {
    attrs: {
      "isDiscount": true,
      "nowSelClassGoods": _vm.nowSelClassGoods,
      "storeId": _vm.curStoreId,
      "nowSelClass": _vm.nowSelClass
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": _vm.closeSelGoods
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "33%",
      "text-align": "left",
      "padding-left": "15%"
    }
  }, [_vm._v("机位名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%",
      "text-align": "left",
      "padding-left": "11.5%"
    }
  }, [_vm._v("所属区域")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "2%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interval"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加时段")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable jobConTable",
    class: {
      overLengthTable: _vm.jobsList.length > _vm.pageSize
    }
  }, _vm._l((_vm.jobsList), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "left1",
      staticStyle: {
        "width": "20%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "65%"
      },
      domProps: {
        "textContent": _vm._s(item.time)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('span', {
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.getCurJob(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]), _vm._v(" "), _c('span', {
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delJob(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.curJobId ? '修改时段' : '添加时段',
      "visible": _vm.addJobVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeName),
      expression: "timeName"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入时段名称"
    },
    domProps: {
      "value": (_vm.timeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.timeName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix groupRoles"
  }, [_c('span', {
    staticClass: "left itemName permissions"
  }, [_c('i', [_vm._v("*")]), _vm._v("开始时间")]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "rowItem"
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入时",
      "clearable": ""
    },
    model: {
      value: (_vm.time.beginHour),
      callback: function($$v) {
        _vm.$set(_vm.time, "beginHour", $$v)
      },
      expression: "time.beginHour"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("时")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入分",
      "clearable": ""
    },
    model: {
      value: (_vm.time.beginMinute),
      callback: function($$v) {
        _vm.$set(_vm.time, "beginMinute", $$v)
      },
      expression: "time.beginMinute"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("分")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix groupRoles",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticClass: "left itemName permissions"
  }, [_c('i', [_vm._v("*")]), _vm._v("结束时间")]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "rowItem"
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入时",
      "clearable": ""
    },
    model: {
      value: (_vm.time.endHour),
      callback: function($$v) {
        _vm.$set(_vm.time, "endHour", $$v)
      },
      expression: "time.endHour"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("时")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入分",
      "clearable": ""
    },
    model: {
      value: (_vm.time.endMinute),
      callback: function($$v) {
        _vm.$set(_vm.time, "endMinute", $$v)
      },
      expression: "time.endMinute"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("分")])], 1)])])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addJob
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable jobTitleTable"
  }, [_c('tr', [_c('th', {
    staticClass: "left1",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("\n                        机位设置\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      style: ({
        height: (item.isOpen && _vm.btn ? ((item.children.length + 1) * 9 + '%') : '9%')
      })
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      style: ({
        height: (item.isOpen && _vm.btn ? (100 / (item.children.length + 1) + '%') : '100%')
      })
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      on: {
        "click": function($event) {
          return _vm.handle(item, ind)
        }
      }
    }, [_c('i', {
      staticClass: "i",
      class: {
        'el-icon-caret-right': item.children.length && (!item.isOpen || !_vm.btn),
        'el-icon-caret-bottom': item.children.length && (!item.isOpen || _vm.btn)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "parent_default type_name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right ss flex flex-align-center flex-pack-center"
    }), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center",
      staticStyle: {
        "width": "120px",
        "display": "flex"
      }
    }, [_c('span', {
      staticClass: "left",
      staticStyle: {
        "font-size": "14px",
        "white-space": "nowrap",
        "width": "150px"
      }
    }, [_vm._v("排序值：" + _vm._s(item.queue))]), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon02",
      staticStyle: {
        "padding-left": "50px"
      },
      attrs: {
        "title": "添加"
      },
      on: {
        "click": function($event) {
          return _vm.addSiteBatch(item)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-bianji",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])]), _vm._v(" "), (item.isOpen && _vm.btn) ? _c('div', {
      staticClass: "type_child",
      style: ({
        height: (100 - 100 / (item.children.length + 1) + '%')
      })
    }, _vm._l((item.children), function(oitem, oInd) {
      return _c('div', {
        staticClass: "type_child_item",
        style: ({
          height: (100 / (item.children.length) + '%')
        })
      }, [_c('div', {
        staticClass: "type_child_left left flex flex-align-center"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(oitem.name)
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "flex",
          "margin-right": "170px"
        }
      }, [_c('span', {
        staticClass: "left",
        staticStyle: {
          "font-size": "14px",
          "padding-right": "100px",
          "white-space": "nowrap"
        }
      }, [_vm._v("IP地址：" + _vm._s(oitem.ipAddress))]), _vm._v(" "), _c('span', {
        staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
      }, [_c('i', {
        staticClass: "iconfont icon-bianji",
        staticStyle: {
          "padding-right": "10px",
          "cursor": "pointer"
        },
        attrs: {
          "title": "修改"
        },
        on: {
          "click": function($event) {
            return _vm.modifySite(item, oitem)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "iconfont icon-icon1460188478041",
        staticStyle: {
          "padding-right": "10px",
          "cursor": "pointer"
        },
        attrs: {
          "title": "删除"
        },
        on: {
          "click": function($event) {
            return _vm.delSite(item, oitem)
          }
        }
      })])])])
    }), 0) : _vm._e()])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑",
      "visible": _vm.addJobVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("区域名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.name),
      expression: "obj.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.obj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("排序值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.queue),
      expression: "obj.queue"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.obj.queue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "queue", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "批量添加机位",
      "visible": _vm.showModifySiteBatch
    },
    on: {
      "update:visible": function($event) {
        _vm.showModifySiteBatch = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("起始IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBatchSite.beginIp),
      expression: "newBatchSite.beginIp"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "如：192.168.1.1"
    },
    domProps: {
      "value": (_vm.newBatchSite.beginIp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBatchSite, "beginIp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "110px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("生成机位数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBatchSite.count),
      expression: "newBatchSite.count"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "placeholder": "如:50"
    },
    domProps: {
      "value": (_vm.newBatchSite.count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBatchSite, "count", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModifySiteBatch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doAddNewSiteBatch
    }
  }, [_vm._v("生成")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑机位",
      "visible": _vm.showModifySite
    },
    on: {
      "update:visible": function($event) {
        _vm.showModifySite = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("机位名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSite.name),
      expression: "newSite.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.newSite.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSite, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSite.ipAddress),
      expression: "newSite.ipAddress"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.newSite.ipAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSite, "ipAddress", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModifySite = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doAddNewSite
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', [_vm._v("区域名称")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-open-book",
    attrs: {
      "id": "selGoods"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sel-goods-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "common-tit"
  }, [_c('span', {
    staticClass: "tit-info"
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    staticClass: "left-cont common-cont"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'cont-list over' : 'cont-list'
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "80%",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "add",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.modifyItem('add', item)
        }
      }
    }, [_vm._v("添加")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 9 ? 'right-cont common-cont over' : 'right-cont common-cont'
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cont-list"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 10 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.nowSelectGoods), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "ruduce",
      staticStyle: {
        "width": "20%"
      },
      on: {
        "click": function($event) {
          return _vm.modifyItem('reduce', item)
        }
      }
    }, [_c('span', [_vm._v("删减")])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-set"
  }, [_c('button', {
    staticStyle: {
      "background": "#ccc"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.selOk
    }
  }, [_vm._v("完成")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit active"
  }, [_c('span', [_vm._v("可选规格组")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit"
  }, [_c('span', [_vm._v("已选规格组")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])
}]}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reward"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem",
    on: {
      "click": function($event) {
        _vm.searchList = []
      }
    }
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "change-type"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'day'
      }
    }
  }, [_vm._v("按日查询")]), _vm._v(" "), _c('span', {
    class: _vm.nowType == 'day' ? 'type-wrap' : 'type-wrap to-right',
    on: {
      "click": function($event) {
        _vm.nowType == 'day' ? _vm.nowType = 'month' : _vm.nowType = 'day'
      }
    }
  }, [_c('i', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'month'
      }
    }
  }, [_vm._v("按月查询")])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "month-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy-MM",
      "format": "yyyy 年 MM 月",
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.valueForMonth),
      callback: function($$v) {
        _vm.valueForMonth = $$v
      },
      expression: "valueForMonth"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "day-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptionsForDay
    },
    model: {
      value: (_vm.nowDay),
      callback: function($$v) {
        _vm.nowDay = $$v
      },
      expression: "nowDay"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_vm._v("\n                        员工：\n                        "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.judge),
      callback: function($$v) {
        _vm.judge = $$v
      },
      expression: "judge"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "全部",
      "value": "ALL"
    }
  }), _vm._v(" "), _vm._l((_vm.empList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.empName,
        "value": item.empId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.rewardData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.rewardData.length > 10
    }
  }, _vm._l((_vm.rewardData), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "25%",
        "text-align": "left"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.amount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.empName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    })])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.rewardDataForMonth.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.rewardDataForMonth.length > 10
    }
  }, _vm._l((_vm.rewardDataForMonth), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.amount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.empName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    })])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQty)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("总收入:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmount)))])])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQtyForMonth)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("总收入:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmountForMonth)))])])])]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%",
      "text-align": "left"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("会员名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("员工姓名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("数量")])])])
}]}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stockData",
    attrs: {
      "id": "depositData"
    }
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showVipList = false;
      }
    }
  }, [(_vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "change-type"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'STOCK'
      }
    }
  }, [_vm._v("仓库")]), _vm._v(" "), _c('span', {
    class: _vm.nowType == 'STOCK' ? 'type-wrap' : 'type-wrap to-right',
    on: {
      "click": function($event) {
        _vm.nowType == 'STOCK' ? _vm.nowType = 'BAR' : _vm.nowType = 'STOCK'
      }
    }
  }, [_c('i', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'BAR'
      }
    }
  }, [_vm._v("吧台")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "month-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy-MM",
      "format": "yyyy 年 MM 月",
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.valueForMonth),
      callback: function($$v) {
        _vm.valueForMonth = $$v
      },
      expression: "valueForMonth"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchConfirm(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.nowType == 'STOCK') ? _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.depositList.length > _vm.pageSize
    }
  }, _vm._l((_vm.depositList), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (ind + 1) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      },
      attrs: {
        "title": item.skuName
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.skuName) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.lastQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.purchaseInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.checkInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.allocationInQty) : ""))]), _vm._v(" "), _c('td', {
      class: item.skuName ? 'border' : '',
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.barInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.innerOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.checkoutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.refundOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.allocationOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.nowQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.value) : ""))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'BAR') ? _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.depositListForBar.length > _vm.pageSize
    }
  }, _vm._l((_vm.depositListForBar), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (ind + 1) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      },
      attrs: {
        "title": item.skuName
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.skuName) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.lastQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.innerInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.stockInnerInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.checkInQty) : ""))]), _vm._v(" "), _c('td', {
      class: item.skuName ? 'border' : '',
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.refundInQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.salesOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.innerOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.barOutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.checkoutQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.nowQty) : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7.5%"
      }
    }, [_vm._v(_vm._s(item.skuName ? (item.value) : ""))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [(_vm.nowType == 'BAR') ? _c('span', [_vm._v("总库存剩余数：" + _vm._s(_vm.totalInfoForBar.totalCount) + " ，总库存价值：" + _vm._s(_vm.totalInfoForBar.totalMoney))]) : _c('span', [_vm._v("总库存剩余数：" + _vm._s(_vm.totalInfo.totalCount) + " ，总库存价值：" + _vm._s(_vm.totalInfo.totalMoney))])]), _vm._v(" "), _c('div', {
    staticClass: "out-excel"
  }, [_c('span', {
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出excel")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改到期时间",
      "visible": _vm.showModify,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModify = $event
      }
    }
  }, [_c('div', {
    staticClass: "end-time"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("请设置到期时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间",
      "default-time": "12:00:00"
    },
    model: {
      value: (_vm.endTimeForThisItem),
      callback: function($$v) {
        _vm.endTimeForThisItem = $$v
      },
      expression: "endTimeForThisItem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modify-btn"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showModify = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "sure",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.modifyThisItem.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "7.5%",
      "color": "#2b7fec",
      "border-right": "2px solid #ddd"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%",
      "color": "#2b7fec"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("出库")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("上月余存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("采购入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("盘点入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("调拨入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%",
      "border-right": "2px solid #ddd"
    }
  }, [_vm._v("吧台退回")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("出货至吧台")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("盘点出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("退货出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("调拨出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("本月余存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("剩余价值")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "7.5%",
      "color": "#2b7fec",
      "border-right": "2px solid #ddd"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%",
      "color": "#2b7fec"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("出库")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("上月余存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("吧台上架")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("仓库至吧台")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("盘点入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%",
      "border-right": "2px solid #ddd"
    }
  }, [_vm._v("退单入库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("销售出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("吧台下架")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("吧台退回仓库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("盘点出库")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("本月余存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7.5%"
    }
  }, [_vm._v("剩余价值")])])])
}]}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-screen",
    attrs: {
      "id": "bigScreen"
    }
  }, [_c('div', {
    staticClass: "canvas-wrap",
    attrs: {
      "id": "canvasWrap"
    },
    on: {
      "dblclick": function($event) {
        $event.stopPropagation();
        return _vm.doFullScreen.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.showMask) ? _c('div', {
    staticClass: "maskDebug"
  }) : _vm._e(), _vm._v(" "), (!_vm.showMask) ? _c('span', {
    staticClass: "fullScreen",
    class: {
      show: !_vm.fullScreen
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doFullScreen.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(!_vm.fullScreen ? "全屏" : "取消全屏"))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "flex-align-center flex-pack-center",
    attrs: {
      "type": "flex"
    }
  }, [_c('div', {
    staticClass: "addStore"
  }, [(_vm.isEnterInviteCode) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("请输入邀请码")]) : _vm._e(), _vm._v(" "), (!_vm.isEnterInviteCode) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("添加店铺")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back",
    on: {
      "click": function () {
        _vm.$router.push({
          path: '/login'
        })
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-return"
  }), _vm._v(" "), _c('span', [_vm._v("返回")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.isEnterInviteCode) ? _c('div', {
    staticClass: "inviteCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.referralCode),
      expression: "newStore.referralCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入您的邀请码"
    },
    domProps: {
      "value": (_vm.newStore.referralCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkInviteCode.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "referralCode", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEnterInviteCode) ? _c('div', {
    staticClass: "storeMsg"
  }, [_c('div', {
    staticClass: "storeMsgItem nameInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.name),
      expression: "newStore.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入店铺名"
    },
    domProps: {
      "value": (_vm.newStore.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "storeMsgItem"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择店铺类型"
    },
    model: {
      value: (_vm.newStore.typeId),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "typeId", $$v)
      },
      expression: "newStore.typeId"
    }
  }, _vm._l((_vm.storeType), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "storeMsgItem addrInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.addr),
      expression: "newStore.addr"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入地址"
    },
    domProps: {
      "value": (_vm.newStore.addr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "addr", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "confirmBtn"
  }, [(_vm.isEnterInviteCode) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.checkInviteCode
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (!_vm.isEnterInviteCode) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addStore,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addStore.apply(null, arguments)
      }
    }
  }, [_vm._v("下一步")]) : _vm._e()])])]), _vm._v(" "), (_vm.isFirstAddStore) ? _c('div', {
    staticClass: "noStoreMask"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(829),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "noStoreBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("添加店铺")]), _vm._v(" "), _c('div', {
    staticClass: "tipText"
  }, [_vm._v("暂无相关店铺数据，请新建店铺信息")]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isFirstAddStore = false
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-add"
  }), _vm._v("\n                    新建店铺\n                ")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dl-call"
  }, [_c('div', {
    staticClass: "dl-wrap"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "item client"
  }, [_c('a', {
    attrs: {
      "href": 'https://images.huoxingy.com/callClient/' + _vm.curStoreId + '.zip'
    }
  }, [_vm._v("客户端下载")])]), _vm._v(" "), _c('div', {
    staticClass: "item service"
  }, [_c('a', {
    attrs: {
      "href": 'https://images.huoxingy.com/service/' + _vm.curStoreId + '.zip'
    }
  }, [_vm._v("服务端(Win7/Win10)下载")])])])])])
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jobs"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("规则管理")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加规则\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable jobConTable",
    class: {
      overLengthTable: _vm.rulesList.length > _vm.pageSize
    }
  }, _vm._l((_vm.rulesList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "left1",
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.id ? index + 1 : ""))]), _vm._v(" "), _c('td', {
      staticClass: "left1",
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('span', {
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.getCurTable(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]), _vm._v(" "), _c('span', {
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delRules(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.curTableId ? '修改桌位' : '添加桌位',
      "visible": _vm.addTableVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTableVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTable.numName),
      expression: "newTable.numName"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入桌位名称"
    },
    domProps: {
      "value": (_vm.newTable.numName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTable, "numName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("所属区域")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.newTable.parId),
      callback: function($$v) {
        _vm.$set(_vm.newTable, "parId", $$v)
      },
      expression: "newTable.parId"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.partitionName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("排序值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTable.sort),
      expression: "newTable.sort"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入排序值"
    },
    domProps: {
      "value": (_vm.newTable.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newTable, "sort", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addTableVisible = false
      }
    }
  }, [_vm._v("\n        取消\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addTable
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showRuleInfo) ? _c('div', {
    staticClass: "mask-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRuleInfo = false
      }
    }
  }, [_c('div', {
    staticClass: "rules common-dialog",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('span', {
    staticClass: "tit-cont"
  }, [_vm._v("计费规则")]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showRuleInfo = false
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-cont"
  }, [_c('div', {
    staticClass: "set-item"
  }, [_c('span', {
    staticClass: "item-left"
  }, [_vm._v("\n            计费方式：\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "item-right"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleInfo.countType),
      callback: function($$v) {
        _vm.$set(_vm.ruleInfo, "countType", $$v)
      },
      expression: "ruleInfo.countType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("按时计费")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("按次计费")])], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "set-item"
  }, [_c('span', {
    staticClass: "item-left"
  }, [_vm._v("计费方式名称：")]), _vm._v(" "), _c('span', {
    staticClass: "item-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.ruleName),
      expression: "ruleInfo.ruleName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleInfo.ruleName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ruleInfo, "ruleName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "set-item"
  }, [_c('span', {
    staticClass: "item-left"
  }, [_vm._v("\n            " + _vm._s(_vm.ruleInfo.countType == 1 ? '每次' : '每小时') + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "item-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.perHourMoney),
      expression: "ruleInfo.perHourMoney"
    }],
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleInfo.perHourMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ruleInfo, "perHourMoney", $event.target.value)
      }
    }
  }), _vm._v("\n            元\n          ")])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "set-item"
  }, [_c('span', {
    staticClass: "item-left"
  }, [_c('i', {
    class: _vm.ruleInfo.upTopFee ?
      'iconfont icon-Raidobox-xuanzhong' :
      'iconfont icon-Raidobox-weixuan',
    on: {
      "click": function($event) {
        _vm.ruleInfo.upTopFee = !_vm.ruleInfo.upTopFee
      }
    }
  }), _vm._v("\n            费用封顶：\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "item-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.upTopFeeMoney),
      expression: "ruleInfo.upTopFeeMoney"
    }],
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text",
      "disabled": !_vm.ruleInfo.upTopFee
    },
    domProps: {
      "value": (_vm.ruleInfo.upTopFeeMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ruleInfo, "upTopFeeMoney", $event.target.value)
      }
    }
  }), _vm._v("\n            元\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "set-item other-style"
  }, [_c('span', {
    staticClass: "item-left"
  }, [_vm._v(" 开单后： ")]), _vm._v(" "), _c('span', {
    staticClass: "item-right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.openAfter.minute),
      expression: "ruleInfo.openAfter.minute"
    }],
    staticStyle: {
      "width": "150px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.openAfter, "minute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.minutes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  })], 2), _vm._v("\n            分钟之内，按\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.openAfter.money),
      expression: "ruleInfo.openAfter.money"
    }],
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleInfo.openAfter.money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ruleInfo.openAfter, "money", $event.target.value)
      }
    }
  }), _vm._v("\n            元计费;\n          ")])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "fee-style"
  }, [_c('div', {
    staticClass: "panle-change"
  }, [_c('span', {
    class: _vm.nowFeeSty == 'hour' ? 'hour active' : 'hour',
    on: {
      "click": function($event) {
        _vm.nowFeeSty = 'hour'
      }
    }
  }, [_vm._v("按小时计费")])]), _vm._v(" "), (_vm.nowFeeSty == 'hour') ? _c('div', {
    staticClass: "hour-set-cont panle-cont"
  }, [_c('div', {
    staticClass: "per-hour"
  }, [_c('span', [_vm._v("\n                每小时\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.perHourMoney),
      expression: "ruleInfo.perHourMoney"
    }],
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleInfo.perHourMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ruleInfo, "perHourMoney", $event.target.value)
      }
    }
  }), _vm._v("\n                元\n              ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cont-item sty"
  }, [_c('i', {
    class: _vm.ruleInfo.actualEnabled ?
      'iconfont icon-Raidobox-xuanzhong' :
      'iconfont icon-Raidobox-weixuan',
    on: {
      "click": function($event) {
        _vm.ruleInfo.actualEnabled = true;
        _vm.ruleInfo.sectionEnabled = false;
      }
    }
  }), _vm._v("\n              消费超出1小时，按实际分钟数计费。\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "cont-item"
  }, [_c('i', {
    class: _vm.ruleInfo.sectionEnabled ?
      'iconfont icon-Raidobox-xuanzhong' :
      'iconfont icon-Raidobox-weixuan',
    on: {
      "click": function($event) {
        _vm.ruleInfo.sectionEnabled = true;
        _vm.ruleInfo.actualEnabled = false;
      }
    }
  }), _vm._v("\n              消费超出1小时，按超出分钟数区间计费。\n            ")]), _vm._v(" "), (_vm.ruleInfo.sectionEnabled) ? _c('div', {
    staticClass: "item-set-cont"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.sectionInfo.sectionFrom),
      expression: "ruleInfo.sectionInfo.sectionFrom"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.sectionInfo, "sectionFrom", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.minutes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2), _vm._v("\n              分钟之内免费；超过" + _vm._s(_vm.ruleInfo.sectionInfo.sectionFrom) + "分钟至\n              "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.sectionInfo.sectionTo),
      expression: "ruleInfo.sectionInfo.sectionTo"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.sectionInfo, "sectionTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.minutes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2), _vm._v("\n              分钟，按" + _vm._s(_vm.ruleInfo.sectionInfo.sectionTo) + " 分钟计费；超过" + _vm._s(_vm.ruleInfo.sectionInfo.sectionTo) + "分钟，按60分钟计费；\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.nowFeeSty == 'timerange') ? _c('div', {
    staticClass: "timerange-set-cont panle-cont"
  }, [_c('div', {
    staticClass: "per-hour"
  }, [_c('span', [_vm._v("\n                每"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.setHourRange),
      expression: "ruleInfo.setHourRange"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo, "setHourRange", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.hours), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                    " + _vm._s(item) + "\n                  ")])
  })], 2), _vm._v("小时\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.perSetHourRangeMoney),
      expression: "ruleInfo.perSetHourRangeMoney"
    }],
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleInfo.perSetHourRangeMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ruleInfo, "perSetHourRangeMoney", $event.target.value)
      }
    }
  }), _vm._v("\n                元\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "cont-tit"
  }, [_c('span', [_vm._v("超出" + _vm._s(_vm.ruleInfo.setHourRange) + "小时的计费方式")])]), _vm._v(" "), _c('div', {
    staticClass: "cont-item sty"
  }, [_c('i', {
    class: _vm.ruleInfo.actualEnabled ?
      'iconfont icon-Raidobox-xuanzhong' :
      'iconfont icon-Raidobox-weixuan',
    on: {
      "click": function($event) {
        _vm.ruleInfo.actualEnabled = true;
        _vm.ruleInfo.sectionEnabled = false;
      }
    }
  }), _vm._v("\n              消费超出" + _vm._s(_vm.ruleInfo.setHourRange) + "小时，按实际分钟数计费。\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "cont-item"
  }, [_c('i', {
    class: _vm.ruleInfo.sectionEnabled ?
      'iconfont icon-Raidobox-xuanzhong' :
      'iconfont icon-Raidobox-weixuan',
    on: {
      "click": function($event) {
        _vm.ruleInfo.sectionEnabled = true;
        _vm.ruleInfo.actualEnabled = false;
      }
    }
  }), _vm._v("\n              消费超出" + _vm._s(_vm.ruleInfo.setHourRange) + "小时，按每小时"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.perHourMoney),
      expression: "ruleInfo.perHourMoney"
    }],
    staticClass: "inp",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleInfo.perHourMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ruleInfo, "perHourMoney", $event.target.value)
      }
    }
  }), _vm._v("\n              元计费，超出的分钟数按区间计费。\n            ")]), _vm._v(" "), (_vm.ruleInfo.sectionEnabled) ? _c('div', {
    staticClass: "item-set-cont"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.sectionInfo.sectionFrom),
      expression: "ruleInfo.sectionInfo.sectionFrom"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.sectionInfo, "sectionFrom", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.minutes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2), _vm._v("\n              分钟之内免费；超过" + _vm._s(_vm.ruleInfo.sectionInfo.sectionFrom) + "分钟至\n              "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.sectionInfo.sectionTo),
      expression: "ruleInfo.sectionInfo.sectionTo"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.sectionInfo, "sectionTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.minutes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2), _vm._v("\n              分钟，按" + _vm._s(_vm.ruleInfo.sectionInfo.sectionTo) + " 分钟计费；超过" + _vm._s(_vm.ruleInfo.sectionInfo.sectionTo) + "分钟，按60分钟计费；\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "service"
  }, [_c('div', {
    staticClass: "cont-item sty"
  }, [_c('i', {
    class: _vm.ruleInfo.serviceEnabled ?
      'iconfont icon-Raidobox-xuanzhong' :
      'iconfont icon-Raidobox-weixuan',
    on: {
      "click": function($event) {
        _vm.ruleInfo.serviceEnabled = !_vm.ruleInfo.serviceEnabled
      }
    }
  }), _vm._v("\n              加收服务费"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.serviceInfo.serviceBegin),
      expression: "ruleInfo.serviceInfo.serviceBegin"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.serviceInfo, "serviceBegin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "00:00"
    }
  }, [_vm._v("0点")]), _vm._v(" "), _vm._l((_vm.serviceHours), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item < 10 ? ("0" + item + ":00") : (item + ":00")
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "点\n                ")])
  })], 2), _vm._v("至"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.serviceInfo.serviceEnd),
      expression: "ruleInfo.serviceInfo.serviceEnd"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.serviceInfo, "serviceEnd", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "00:00"
    }
  }, [_vm._v("0点")]), _vm._v(" "), _vm._l((_vm.serviceHours), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item < 10 ? ("0" + item + ":00") : (item + ":00")
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "点\n                ")])
  })], 2)]), _vm._v(" "), (_vm.ruleInfo.serviceEnabled) ? _c('div', {
    staticClass: "per-hour service-amount"
  }, [_c('span', [_vm._v("\n                服务费:\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.serviceInfo.serviceAmount),
      expression: "ruleInfo.serviceInfo.serviceAmount"
    }],
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ruleInfo.serviceInfo.serviceAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ruleInfo.serviceInfo, "serviceAmount", $event.target.value)
      }
    }
  }), _vm._v("\n                元 / 每小时\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.ruleInfo.serviceEnabled) ? _c('div', {
    staticClass: "item-set-cont"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.serviceInfo.serviceFrom),
      expression: "ruleInfo.serviceInfo.serviceFrom"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.serviceInfo, "serviceFrom", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.minutes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2), _vm._v("\n              分钟之内免费；超过" + _vm._s(_vm.ruleInfo.serviceInfo.serviceFrom) + "分钟至\n              "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleInfo.serviceInfo.serviceTo),
      expression: "ruleInfo.serviceInfo.serviceTo"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ruleInfo.serviceInfo, "serviceTo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((_vm.minutes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })], 2), _vm._v("\n              分钟，按" + _vm._s(_vm.ruleInfo.serviceInfo.serviceTo) + " 分钟计费；超过" + _vm._s(_vm.ruleInfo.serviceInfo.serviceTo) + "分钟，按60分钟计费；\n            ")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "confirm-box"
  }, [_c('div', {
    staticClass: "btn-wrap"
  }, [_c('span', {
    staticClass: "btn cancel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showRuleInfo = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "btn save",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveRules.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable jobTitleTable"
  }, [_c('tr', [_c('th', {
    staticClass: "left1",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticClass: "left1",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("计费名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit"
  }, [_c('span', [_vm._v("超出1小时的计费方式")])])
}]}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-screen",
    attrs: {
      "id": "bigScreen"
    }
  }, [_c('div', {
    staticClass: "canvas-wrap",
    attrs: {
      "id": "canvasWrap"
    },
    on: {
      "dblclick": function($event) {
        $event.stopPropagation();
        return _vm.doFullScreen.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.showMask) ? _c('div', {
    staticClass: "maskDebug"
  }) : _vm._e(), _vm._v(" "), (!_vm.showMask) ? _c('span', {
    staticClass: "fullScreen",
    class: {
      show: !_vm.fullScreen
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doFullScreen.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(!_vm.fullScreen ? "全屏" : "取消全屏"))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jobs"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加岗位")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable jobConTable",
    class: {
      overLengthTable: _vm.jobsList.length > _vm.pageSize
    }
  }, _vm._l((_vm.jobsList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "left1",
      staticStyle: {
        "width": "66%",
        "text-align": "left"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "center"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-switch', {
      attrs: {
        "title": '当前岗位是否开启呼叫',
        "on-text": "",
        "off-text": "",
        "on-color": "#51BE7E",
        "off-color": "#E06C6C"
      },
      on: {
        "change": function($event) {
          return _vm.changeReward(item)
        }
      },
      model: {
        value: (item.reward),
        callback: function($$v) {
          _vm.$set(item, "reward", $$v)
        },
        expression: "item.reward"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "text-align": "center"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-switch', {
      attrs: {
        "title": '当前岗位是否展示在语音呼叫客户端',
        "on-text": "",
        "off-text": "",
        "on-color": "#51BE7E",
        "off-color": "#E06C6C"
      },
      on: {
        "change": function($event) {
          return _vm.changeShowStatue(item)
        }
      },
      model: {
        value: (item.show),
        callback: function($$v) {
          _vm.$set(item, "show", $$v)
        },
        expression: "item.show"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('span', {
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.getCurJob(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji",
      staticStyle: {
        "margin-right": "10%"
      }
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delJob(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.curJobId ? '修改岗位' : '添加岗位',
      "visible": _vm.addJobVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newJob.name),
      expression: "newJob.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入岗位名称"
    },
    domProps: {
      "value": (_vm.newJob.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newJob, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix groupRoles"
  }, [_c('span', {
    staticClass: "left itemName permissions"
  }, [_c('i', [_vm._v("*")]), _vm._v("选择权限")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.newJob.groupRoles),
      callback: function($$v) {
        _vm.$set(_vm.newJob, "groupRoles", $$v)
      },
      expression: "newJob.groupRoles"
    }
  }, [_c('div', {
    staticClass: "rowItem rowItemDisabled"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_CLERK",
      "disabled": ""
    }
  }, [_vm._v("店员宝登录（关注公众号'店员宝'）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowItem"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_POS"
    }
  }, [_vm._v("收银端登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowItem"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_PARTNER"
    }
  }, [_vm._v("我的店铺（关注公众号'店员宝'-'我的店铺'")])], 1), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "opacity": "0"
    }
  }, [_vm._v("我的店铺店铺")]), _vm._v(" "), _c('span', [_vm._v("适应于 老板/股东 查看报表）")])]), _vm._v(" "), _c('div', {
    staticClass: "rowItem"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_STOCK"
    }
  }, [_vm._v("库存管理权限")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowItem"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "ROLE_ADMIN"
    }
  }, [_vm._v("后台管理系统登录")])], 1)])], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addJob
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable jobTitleTable"
  }, [_c('tr', [_c('th', {
    staticClass: "left1",
    staticStyle: {
      "width": "66%",
      "text-align": "left"
    }
  }, [_vm._v("岗位名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "center"
    }
  }, [_vm._v("是否开启呼叫")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%",
      "text-align": "center"
    }
  }, [_vm._v("展示在呼叫客户端")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-info"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left search flex flex-align-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goods),
      expression: "goods"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.goods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goods = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.searchGoods
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search",
    style: ({
      display: (_vm.goodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.curGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.goodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'search')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fliter type"
  }, [_vm._v("\n                        分类选择：\n                        "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.fliter_type),
      callback: function($$v) {
        _vm.fliter_type = $$v
      },
      expression: "fliter_type"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "fliter"
  }, [_vm._v("\n                        管理库存：\n                        "), _c('el-select', {
    model: {
      value: (_vm.fliter_stock),
      callback: function($$v) {
        _vm.fliter_stock = $$v
      },
      expression: "fliter_stock"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "true",
    attrs: {
      "label": "是",
      "value": "true"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "false",
    attrs: {
      "label": "否",
      "value": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "fliter"
  }, [_vm._v("\n                        厨房打印：\n                        "), _c('el-select', {
    model: {
      value: (_vm.fliter_kitchen),
      callback: function($$v) {
        _vm.fliter_kitchen = $$v
      },
      expression: "fliter_kitchen"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "true",
    attrs: {
      "label": "是",
      "value": "true"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "false",
    attrs: {
      "label": "否",
      "value": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fliterGoods
    }
  }, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGoods
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加商品")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.vipData.length > 6
    }
  }, _vm._l((_vm.vipData), function(item, idx) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "4%"
      },
      domProps: {
        "textContent": _vm._s(item.id ? (idx + 1) : '')
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "img",
      staticStyle: {
        "width": "8%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "img_box"
    }, [_c('img', {
      attrs: {
        "src": item.imageURL + '?x-oss-process=image/resize,l_300',
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      },
      domProps: {
        "textContent": _vm._s(item.sort)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [(item.id && item.supplyTimes && JSON.parse(item.supplyTimes).length) ? _c('span', _vm._l((JSON.parse(item.supplyTimes)), function(oitem) {
      return _c('span', {
        domProps: {
          "textContent": _vm._s((oitem.beginHour < 10 ? '0' + oitem.beginHour : oitem.beginHour) + ':' +
            (oitem.beginMinute < 10 ? '0' + oitem.beginMinute : oitem.beginMinute) + '~' +
            (oitem.endHour < 10 ? '0' + oitem.endHour : oitem.endHour) + ':' +
            (oitem.endMinute < 10 ? '0' + oitem.endMinute : oitem.endMinute) + ',')
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), ((item.id && !item.supplyTimes) || item.supplyTimes == '[]') ? _c('span', [_vm._v("全天")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [(item.id && item.disShow) ? _c('span', [_c('span', [_vm._v(_vm._s(item.nowHours + '~' + item.tomorrowHour))])]) : _vm._e(), _vm._v(" "), ((item.id && !item.disShow)) ? _c('span', [_vm._v("暂无")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.memberShow
      },
      domProps: {
        "textContent": _vm._s(item.memberShow ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.disShow
      },
      domProps: {
        "textContent": _vm._s(item.disShow ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.kitchenPrintEnabled
      },
      domProps: {
        "textContent": _vm._s(item.kitchenPrintEnabled ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.labelEnabled
      },
      domProps: {
        "textContent": _vm._s(item.labelEnabled ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "goods_status_on",
      class: {
        goods_status_off: !item.stockEnabled
      },
      domProps: {
        "textContent": _vm._s(item.stockEnabled ? '是' : '否')
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-button', {
      attrs: {
        "type": "text",
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.uploadGood(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delGoods(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])], 1) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": _vm.btnId ? '修改商品' : '添加商品',
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix",
    on: {
      "click": _vm.hideSearchList
    }
  }, [_c('div', {
    staticClass: "left msgItem clearfix searchbox"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.name),
      expression: "newGoods.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.newGoods.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search add_details_search",
    style: ({
      display: (_vm.addGoodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.addCurGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.addGoodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'add')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix searchbox"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("商品描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.note),
      expression: "newGoods.note"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品描述"
    },
    domProps: {
      "value": (_vm.newGoods.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "note", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品分类")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "请选择商品分类"
    },
    model: {
      value: (_vm.newGoods.productTypeId),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "productTypeId", $$v)
      },
      expression: "newGoods.productTypeId"
    }
  }, [_vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("数量/价格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.productQty),
      expression: "newGoods.productQty"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "数量"
    },
    domProps: {
      "value": (_vm.newGoods.productQty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "productQty", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left"
  }, [_vm._v("个")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.salesPrice),
      expression: "newGoods.salesPrice"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "价格"
    },
    domProps: {
      "value": (_vm.newGoods.salesPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "salesPrice", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left"
  }, [_vm._v("元")])]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品排序")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.sort),
      expression: "newGoods.sort"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "text",
      "placeholder": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.newGoods.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("管理库存")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.isStock),
      callback: function($$v) {
        _vm.isStock = $$v
      },
      expression: "isStock"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.isStock),
      callback: function($$v) {
        _vm.isStock = $$v
      },
      expression: "isStock"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.isStock == 'ON') ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("库存告警值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.threshold),
      expression: "newGoods.threshold"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "100px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "数量"
    },
    domProps: {
      "value": (_vm.newGoods.threshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "threshold", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("厨房打印")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.kitchenPrintEnabled),
      callback: function($$v) {
        _vm.kitchenPrintEnabled = $$v
      },
      expression: "kitchenPrintEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.kitchenPrintEnabled),
      callback: function($$v) {
        _vm.kitchenPrintEnabled = $$v
      },
      expression: "kitchenPrintEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.kitchenPrintEnabled == 'ON') ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("打印机")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "请选择打印机"
    },
    model: {
      value: (_vm.newGoods.ipId),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "ipId", $$v)
      },
      expression: "newGoods.ipId"
    }
  }, [_c('el-option', {
    key: -1,
    attrs: {
      "label": '无',
      "value": ''
    }
  }), _vm._v(" "), _vm._l((_vm.printEr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("标签打印")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.newGoods.labelEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "labelEnabled", $$v)
      },
      expression: "newGoods.labelEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.newGoods.labelEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "labelEnabled", $$v)
      },
      expression: "newGoods.labelEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("岗位提成\n                         "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "开启岗位提成后，固定提成、时间段提成无效。",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wenhao-yuankuang"
  })])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newGoods.postEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "postEnabled", $$v)
      },
      expression: "newGoods.postEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newGoods.postEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "postEnabled", $$v)
      },
      expression: "newGoods.postEnabled"
    }
  }, [_vm._v("否")]), _vm._v(" "), (_vm.newGoods.postEnabled == true) ? _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "30px",
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCommJob.apply(null, arguments)
      }
    }
  }, [_vm._v("添加")]) : _vm._e()], 1), _vm._v(" "), (_vm.newGoods.postEnabled == false) ? [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("时段提成\n                            "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "开启时段提成后，岗位提成、固定提成无效。",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wenhao-yuankuang"
  })])], 1), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newGoods.timeRangeComm),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "timeRangeComm", $$v)
      },
      expression: "newGoods.timeRangeComm"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newGoods.timeRangeComm),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "timeRangeComm", $$v)
      },
      expression: "newGoods.timeRangeComm"
    }
  }, [_vm._v("否")]), _vm._v(" "), (_vm.newGoods.timeRangeComm == true) ? _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "30px",
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCommTime.apply(null, arguments)
      }
    }
  }, [_vm._v("添加")]) : _vm._e()], 1), _vm._v(" "), (_vm.newGoods.timeRangeComm == false) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品提成")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.commission),
      expression: "newGoods.commission"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入提成",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.newGoods.commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "commission", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("元")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.newGoods.timeRangeComm == true && _vm.newGoods.postEnabled == false) ? _vm._l((_vm.newTimeListForComm), function(timeItem, timeIndex) {
    return _c('div', {
      key: timeIndex
    }, [_c('div', {
      staticClass: "left msgItem clearfix",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('span', {
      staticClass: "left itemName"
    }, [_c('i', [_vm._v("*")]), _vm._v("商品提成")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (timeItem.commission),
        expression: "timeItem.commission"
      }],
      staticClass: "left itemInput",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "text",
        "placeholder": "请输入提成",
        "maxlength": "6"
      },
      domProps: {
        "value": (timeItem.commission)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(timeItem, "commission", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "left",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "left msgItem clearfix saleTimes",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticClass: "left itemName"
    }, [_vm._v("提成时间段")]), _vm._v(" "), _c('div', {
      staticClass: "left timesBox clearfix"
    }, [_c('span', {
      staticClass: "itemSelect left"
    }, [_c('el-time-picker', {
      attrs: {
        "is-range": "",
        "format": "HH:mm",
        "range-separator": "至",
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "placeholder": "选择时间范围"
      },
      model: {
        value: (timeItem.timeRange),
        callback: function($$v) {
          _vm.$set(timeItem, "timeRange", $$v)
        },
        expression: "timeItem.timeRange"
      }
    })], 1)]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delTimeList(timeItem, timeIndex)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }) : _vm._e(), _vm._v(" "), (_vm.newGoods.postEnabled == true) ? _vm._l((_vm.newJobListForComm), function(jobComItem, jobComIndex) {
    return _c('div', {
      key: jobComIndex
    }, [_c('div', {
      staticClass: "left msgItem clearfix saleTimes",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticClass: "left itemName"
    }, [_vm._v("岗位：")]), _vm._v(" "), _c('div', {
      staticClass: "left timesBox clearfix"
    }, [_c('el-select', {
      staticClass: "itemSelect",
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "placeholder": "请选择岗位"
      },
      model: {
        value: (jobComItem.groupId),
        callback: function($$v) {
          _vm.$set(jobComItem, "groupId", $$v)
        },
        expression: "jobComItem.groupId"
      }
    }, _vm._l((_vm.jobTypeList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "left msgItem clearfix",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('span', {
      staticClass: "left itemName"
    }, [_c('i', [_vm._v("*")]), _vm._v("商品提成")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (jobComItem.commission),
        expression: "jobComItem.commission"
      }],
      staticClass: "left itemInput",
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "type": "text",
        "placeholder": "请输入提成",
        "maxlength": "6"
      },
      domProps: {
        "value": (jobComItem.commission)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(jobComItem, "commission", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "left",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("元"), _c('el-button', {
      staticStyle: {
        "padding-left": "5px"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delJobComList(jobComItem, jobComIndex)
        }
      }
    }, [_vm._v("删除")])], 1)])])
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("会员价")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.vipEnable),
      callback: function($$v) {
        _vm.vipEnable = $$v
      },
      expression: "vipEnable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.vipEnable),
      callback: function($$v) {
        _vm.vipEnable = $$v
      },
      expression: "vipEnable"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.vipEnable) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("会员价格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vipPrice),
      expression: "vipPrice"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入会员价格",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.vipPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vipPrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("元")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("展示在呼叫端")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newGoods.salesEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "salesEnabled", $$v)
      },
      expression: "newGoods.salesEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newGoods.salesEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "salesEnabled", $$v)
      },
      expression: "newGoods.salesEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.newGoods.salesEnabled) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("展示销售数量")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newGoods.salesShowEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "salesShowEnabled", $$v)
      },
      expression: "newGoods.salesShowEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newGoods.salesShowEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "salesShowEnabled", $$v)
      },
      expression: "newGoods.salesShowEnabled"
    }
  }, [_vm._v("否")])], 1) : _vm._e(), _vm._v(" "), (_vm.newGoods.salesEnabled && _vm.newGoods.salesShowEnabled) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("基础销售数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.salesCount),
      expression: "newGoods.salesCount"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "text",
      "placeholder": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.newGoods.salesCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "salesCount", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("显示在客户端")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.pcEnable),
      callback: function($$v) {
        _vm.pcEnable = $$v
      },
      expression: "pcEnable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.pcEnable),
      callback: function($$v) {
        _vm.pcEnable = $$v
      },
      expression: "pcEnable"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("客户端允许购买")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.pcBuyEnable),
      callback: function($$v) {
        _vm.pcBuyEnable = $$v
      },
      expression: "pcBuyEnable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.pcBuyEnable),
      callback: function($$v) {
        _vm.pcBuyEnable = $$v
      },
      expression: "pcBuyEnable"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("开启折扣")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.discountEnable),
      callback: function($$v) {
        _vm.discountEnable = $$v
      },
      expression: "discountEnable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.discountEnable),
      callback: function($$v) {
        _vm.discountEnable = $$v
      },
      expression: "discountEnable"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("折扣百分比")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountPrice),
      expression: "discountPrice"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "type": "text",
      "placeholder": "折扣",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.discountPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discountPrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("%")])]) : _vm._e(), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("折扣后商品提成")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disCom),
      expression: "disCom"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "type": "text",
      "placeholder": "提成",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.disCom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.disCom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("元")])]) : _vm._e(), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%",
      "min-height": "32px"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("折扣星期选择")]), _vm._v(" "), _c('div', [_c('el-checkbox', {
    on: {
      "change": _vm.handleChangeWeeksAll
    },
    model: {
      value: (_vm.isAllWeek),
      callback: function($$v) {
        _vm.isAllWeek = $$v
      },
      expression: "isAllWeek"
    }
  }, [_vm._v("全选")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%",
      "min-height": "32px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "10%"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleChangeWeeks
    },
    model: {
      value: (_vm.newGoods.week),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "week", $$v)
      },
      expression: "newGoods.week"
    }
  }, _vm._l((_vm.weeks), function(weekItem) {
    return _c('el-checkbox', {
      key: weekItem,
      attrs: {
        "label": weekItem
      }
    }, [_vm._v(_vm._s(weekItem))])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.discountEnable) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "1rem",
      "text-align": "right",
      "width": "16.79%"
    }
  }, [_c('i', {
    staticStyle: {
      "color": "#d65252"
    }
  }, [_vm._v("*")]), _vm._v("折扣时间")]), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "placeholder": "起始时间"
    },
    model: {
      value: (_vm.beginTime),
      callback: function($$v) {
        _vm.beginTime = $$v
      },
      expression: "beginTime"
    }
  }), _vm._v(" "), _c('el-time-picker', {
    attrs: {
      "arrow-control": "",
      "placeholder": "截止时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix saleTimes"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("销售时间")]), _vm._v(" "), _c('div', {
    staticClass: "left timesBox clearfix"
  }, [_c('div', {
    staticClass: "left addTimeBox",
    class: {
      addTimeBoxChoiced: _vm.timeChoiceBtn
    },
    on: {
      "click": _vm.addTimes
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加\n                        ")]), _vm._v(" "), (!_vm.timeChoiceBtn && !_vm.newTimeList.length) ? _c('span', {
    staticClass: "allDay"
  }, [_vm._v("默认全天")]) : _vm._e(), _vm._v(" "), (_vm.timeChoiceBtn) ? _c('span', {
    staticClass: "itemSelect left"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择时间段"
    },
    model: {
      value: (_vm.timeChoice),
      callback: function($$v) {
        _vm.timeChoice = $$v
      },
      expression: "timeChoice"
    }
  }, _vm._l((_vm.timeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": (item.beginHour < 10 ? '0' + item.beginHour : item.beginHour) + ':' +
          (item.beginMinute < 10 ? '0' + item.beginMinute : item.beginMinute) + '~' +
          (item.endHour < 10 ? '0' + item.endHour : item.endHour) + ':' +
          (item.endMinute < 10 ? '0' + item.endMinute : item.endMinute),
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "-12px",
      "right": "-6px",
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.timeChoiceBtn = false;
      }
    }
  }, [_vm._v("×")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "timesInner",
    attrs: {
      "id": "timeSales"
    }
  }, _vm._l((_vm.newTimeList), function(oitem) {
    return _c('div', {
      staticClass: "timesInnerItem clearfix"
    }, [_c('p', {
      staticClass: "left timeText",
      domProps: {
        "textContent": _vm._s((oitem.beginHour < 10 ? '0' + oitem.beginHour : oitem.beginHour) + ':' +
          (oitem.beginMinute < 10 ? '0' + oitem.beginMinute : oitem.beginMinute) + '~' +
          (oitem.endHour < 10 ? '0' + oitem.endHour : oitem.endHour) + ':' +
          (oitem.endMinute < 10 ? '0' + oitem.endMinute : oitem.endMinute) + '(' + oitem.name + ')')
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "removeBtn right",
      on: {
        "click": function($event) {
          return _vm.removeTimes(oitem)
        }
      }
    }, [_vm._v("×")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "left img_box clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品图片")]), _vm._v(" "), _c('div', {
    staticClass: "left img"
  }, [_c('div', {
    staticClass: "img_item left"
  }, [(_vm.newGoods.imageURL) ? _c('img', {
    ref: "goodsImg",
    attrs: {
      "src": _vm.newGoods.imageURL + '?x-oss-process=image/resize,l_300',
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newGoods.imageURL) ? _c('span', {
    staticClass: "del-img",
    on: {
      "click": _vm.delImg
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img_up_btn left"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai"
  }), _vm._v(" "), _c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mobileImgFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.coverImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "uploadImgTip"
  }, [_vm._v("\n                            支持JPG、JPEG、PNG格式，单张大小不超过5M，建议尺寸 600*600 px\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "left mat-goods"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("商品规格:")]), _vm._v(" "), _c('span', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledSpec), function(tag) {
    return _c('el-tag', {
      key: tag.name,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.closeSpec(tag)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tag.name) + "\n                        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addSpec
    }
  }, [_vm._v("+添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left mat-goods"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("包含原料:")]), _vm._v(" "), _c('span', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledMats), function(tag) {
    return _c('el-tag', {
      key: tag.name
    }, [_vm._v("\n                        " + _vm._s(tag.name) + "*" + _vm._s(tag.count) + "\n                        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addMatGoods
    }
  }, [_vm._v("+添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left mat-goods"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("配品:")]), _vm._v(" "), _c('span', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledPeiGoods), function(tag) {
    return _c('el-tag', {
      key: tag.name,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.closePei(tag)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tag.name) + "\n                        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addPeiGoods
    }
  }, [_vm._v("+添加")])], 1)], 2)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.beforeUpGoods
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "同步商品",
      "show-close": false,
      "before-close": _vm.cancelTb,
      "visible": _vm.shareGoods,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.shareGoods = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "label-position": 'top',
      "label-width": "80px"
    }
  }, [_c('el-form-item', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("请选择需要将此商品同步到的店铺")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.tbForm.storeIds),
      callback: function($$v) {
        _vm.$set(_vm.tbForm, "storeIds", $$v)
      },
      expression: "tbForm.storeIds"
    }
  }, _vm._l((_vm.storeList), function(item) {
    return (item.id != _vm.curStoreId) ? _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelTb
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doUpGoods
    }
  }, [_vm._v("保存")])])], 1), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMat) ? _c('selGoods', {
    attrs: {
      "seledGoods": _vm.seledMats,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": function($event) {
        _vm.showMat = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPei) ? _c('selPeiGoods', {
    attrs: {
      "seledGoods": _vm.seledPeiGoods,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOkForPei,
      "closeSelGoods": function($event) {
        _vm.showPei = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSpec) ? _c('selSpec', {
    attrs: {
      "seledGoods": _vm.seledSpec,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOkForSpec,
      "closeSelGoods": function($event) {
        _vm.showSpec = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("排序值")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("销售价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("销售时间段")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("折扣时间段")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("会员价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("折扣价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("厨房打印")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("标签打印")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("管理库存")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderSearch"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy/MM/dd-HH:mm:ss",
      "type": "datetime",
      "picker-options": _vm.pickerOptions0,
      "placeholder": "选择开始日期时间"
    },
    model: {
      value: (_vm.timeFrom),
      callback: function($$v) {
        _vm.timeFrom = $$v
      },
      expression: "timeFrom"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy/MM/dd-HH:mm:ss",
      "type": "datetime",
      "picker-options": _vm.pickerOptions0,
      "placeholder": "选择结束日期时间"
    },
    model: {
      value: (_vm.timeTo),
      callback: function($$v) {
        _vm.timeTo = $$v
      },
      expression: "timeTo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "types"
  }, [_vm._v("\n                        订单来源:\n                        "), _c('el-select', {
    model: {
      value: (_vm.sourceValue),
      callback: function($$v) {
        _vm.sourceValue = $$v
      },
      expression: "sourceValue"
    }
  }, _vm._l((_vm.sourceOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "types"
  }, [_vm._v("\n                        支付类型:\n                        "), _c('el-select', {
    model: {
      value: (_vm.payValue),
      callback: function($$v) {
        _vm.payValue = $$v
      },
      expression: "payValue"
    }
  }, _vm._l((_vm.payOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "types"
  }, [_vm._v("\n                        交易状态:\n                        "), _c('el-select', {
    model: {
      value: (_vm.statusValue),
      callback: function($$v) {
        _vm.statusValue = $$v
      },
      expression: "statusValue"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getSearch
    }
  }, [_vm._v("查询")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "5.5%"
      }
    }, [(item.id) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.curPage * _vm.pageSize)
      }
    }) : _vm._e(), _vm._v(" "), (!item.id) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10.5%"
      }
    }, [_vm._v(" " + _vm._s(_vm._f("numberToMonthDate")(item.paymentTime, '')))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "16%"
      },
      domProps: {
        "textContent": _vm._s(item.code)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(_vm.sourcetype[item.source])
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(_vm.paytype[item.channel])
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(_vm.statustype[item.status])
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.total)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.discount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.amount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "color": "#3068ff",
        "cursor": "pointer"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.id ? '详情' : '')
      },
      on: {
        "click": function($event) {
          return _vm.orderDetail(item.id)
        }
      }
    })])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center prog"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [(_vm.progressBtn) ? _c('el-progress', {
    staticClass: "progress",
    attrs: {
      "text-inside": true,
      "stroke-width": 15,
      "percentage": _vm.progressNum,
      "status": "success"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "left excels",
    staticStyle: {
      "height": "100%",
      "line-height": "30px",
      "text-align": "center",
      "cursor": "pointer",
      "width": "120px",
      "background": "green",
      "border-radius": "8px",
      "background-color": "#3068fe",
      "box-shadow": "0 2px 4px 0 #4a90e2",
      "color": "#fff"
    },
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "visible": _vm.showPutAllMask,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "lossTotal flex flex-align-center"
  }, [_c('span', {
    staticClass: "span1"
  }, [_vm._v("共")]), _vm._v(" "), _c('span', {
    staticClass: "span2 blue",
    domProps: {
      "textContent": _vm._s(_vm.curOrderData.count)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span3"
  }, [_vm._v("件商品")]), _vm._v(" "), _c('span', {
    staticClass: "span1"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "span2 red",
    domProps: {
      "textContent": _vm._s(_vm.curOrderData.total)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span3"
  }, [_vm._v("元")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', {}, [_vm._v("座位号：")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.curOrderData.tableNo)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "80%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.curOrderData.items), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "80%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.quantity)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    })])])
  }), 0)])])])])])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5.5%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10.5%"
    }
  }, [_vm._v("交易时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("订单来源")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("支付类型")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("交易状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("交易金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("优惠金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("实收金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pcOrder"
  }, [_c('p', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-top": "10px",
      "color": "red"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select-wrap",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-cont"
  }, [_c('div', {
    staticClass: "goods-left"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "活动区域"
    },
    model: {
      value: (_vm.typeId),
      callback: function($$v) {
        _vm.typeId = $$v
      },
      expression: "typeId"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.getGoods
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    attrs: {
      "data": _vm.tableData,
      "row-key": _vm.getRowKeys,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "65",
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.productName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "分类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideBar"
  }, [_c('div', {
    staticClass: "sideBarTop"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('p', {
    staticClass: "hello flex flex-align-center flex-pack-center"
  }, [_vm._v("Hello,")]), _vm._v(" "), _c('p', {
    staticClass: "storeName flex flex-align-center flex-pack-center",
    domProps: {
      "textContent": _vm._s(_vm.storeData.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "changeStore flex flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "iconfont icon-qihuan"
  }), _c('router-link', {
    attrs: {
      "tag": "span",
      "to": "/store",
      "replace": ""
    }
  }, [_vm._v("切换店铺")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navMenu"
  }, [_c('ul', {
    staticClass: "menuList"
  }, _vm._l((_vm.sideBarData), function(item, ind) {
    return _c('li', {
      staticClass: "subMenu",
      class: {
        isOpen1: (item.isOpen && item.son.length == 1 && _vm.btn),
        isOpen2: (item.isOpen && item.son.length == 2 && _vm.btn),
        isOpen3: (item.isOpen && item.son.length == 3 && _vm.btn),
        isOpen401: (item.isOpen && item.son.length == 4 && _vm.btn),
        isOpen402: (item.isOpen && item.son.length == 5 && _vm.btn),
        isOpen403: (item.isOpen && item.son.length == 6 && _vm.btn),
        isOpen404: (item.isOpen && item.son.length == 7 && _vm.btn),
        isOpen405: (item.isOpen && item.son.length == 8 && _vm.btn),
        isOpen403_: (item.isOpen && item.fixedSon && _vm.btn),
        'title-active': item.isOpen
      }
    }, [_c('div', {
      staticClass: "subMenuTitle flex flex-align-center",
      on: {
        "click": function($event) {
          return _vm.handle(item, ind)
        }
      }
    }, [_c('i', {
      class: item.iconClass
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), (item.son.length) ? _c('ul', {
      staticClass: "subSonMenu"
    }, [_vm._l((item.son), function(son, sonInd) {
      return _c('router-link', {
        key: sonInd,
        staticClass: "menuItem",
        attrs: {
          "tag": "li",
          "to": son.routeName,
          "active-class": 'son-active'
        }
      }, [_c('span', {
        staticClass: "menuItemSpan",
        domProps: {
          "textContent": _vm._s(son.name)
        }
      })])
    }), _vm._v(" "), _vm._l((item.fixedSon), function(fixedSonItem, fixedSonItemInd) {
      return _c('li', {
        staticClass: "menuItem",
        on: {
          "click": _vm.goInv
        }
      }, [_c('span', {
        staticClass: "menuItemSpan",
        domProps: {
          "textContent": _vm._s(fixedSonItem.name)
        }
      })])
    })], 2) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipRecharge"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showUpBox
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加规则")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.rulesData.length < 10
    }
  }, _vm._l((_vm.rulesData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "50%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%",
        "text-align": "right",
        "padding-right": "10%"
      }
    }, [(item.id) ? _c('span', {
      staticStyle: {
        "margin": "0 2%"
      },
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.showUpBox(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]) : _vm._e(), _vm._v(" "), (item.id) ? _c('span', {
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delRules(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加员工",
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("这是一段信息")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '添加充值规则',
      "visible": _vm.addRechargeBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addRechargeBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("充值金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deposit),
      expression: "deposit"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入充值金额"
    },
    domProps: {
      "value": (_vm.deposit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deposit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("赠送金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bonus),
      expression: "bonus"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入赠送金额"
    },
    domProps: {
      "value": (_vm.bonus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bonus = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "show-name"
  }, [_c('p', [_vm._v("充值时显示名称（可修改）")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addRechargeBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rechargeFn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("充值规则")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%",
      "text-align": "right",
      "padding-right": "10%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-open-book",
    attrs: {
      "id": "selGoods"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sel-goods-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "common-tit"
  }, [_c('span', {
    staticClass: "tit-info"
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    staticClass: "left-cont common-cont"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'cont-list over' : 'cont-list'
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "list-filter"
  }, [_c('span', {
    staticClass: "name-filter filter-normal",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchVal),
      expression: "searchVal"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchVal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "filter-normal",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticClass: "filter-normal search",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo",
    on: {
      "click": function($event) {
        return _vm.searchGoods()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "50%",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('td', {
      staticClass: "add",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.modifyItem('add', item)
        }
      }
    }, [_vm._v("添加")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 9 ? 'right-cont common-cont over' : 'right-cont common-cont'
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cont-list"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 10 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.nowSelectGoods), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('td', {
      staticClass: "ruduce",
      staticStyle: {
        "width": "25%"
      },
      on: {
        "click": function($event) {
          return _vm.modifyItem('reduce', item)
        }
      }
    }, [_c('span', [_vm._v("删减")])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-set"
  }, [_c('button', {
    staticStyle: {
      "background": "#ccc"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.selOk
    }
  }, [_vm._v("完成")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit active"
  }, [_c('span', [_vm._v("选择商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit"
  }, [_c('span', [_vm._v("已选商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])
}]}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-open-book",
    attrs: {
      "id": "selGoods"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sel-goods-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "common-tit"
  }, [_c('span', {
    staticClass: "tit-info"
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    staticClass: "left-cont common-cont"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'cont-list over' : 'cont-list'
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "list-filter"
  }, [_c('span', {
    staticClass: "name-filter filter-normal",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchVal),
      expression: "searchVal"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchVal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "filter-normal",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticClass: "filter-normal search",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo",
    on: {
      "click": function($event) {
        return _vm.searchGoods()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "50%",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('td', {
      staticClass: "add",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.modifyItem('add', item)
        }
      }
    }, [_vm._v("添加")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 9 ? 'right-cont common-cont over' : 'right-cont common-cont'
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cont-list"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 10 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.nowSelectGoods), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('td', {
      staticClass: "ruduce",
      staticStyle: {
        "width": "25%"
      },
      on: {
        "click": function($event) {
          return _vm.modifyItem('reduce', item)
        }
      }
    }, [_c('span', [_vm._v("删减")])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-set"
  }, [_c('button', {
    staticStyle: {
      "background": "#ccc"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.selOk
    }
  }, [_vm._v("完成")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit active"
  }, [_c('span', [_vm._v("可选配品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit"
  }, [_c('span', [_vm._v("已选配品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])
}]}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.imgCropload),
      expression: "imgCropload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "imgCropBox flex flex-align-center flex-pack-center"
  }, [_c('div', {
    staticClass: "imgCrop",
    attrs: {
      "id": "imgCrop"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("图片裁剪")]), _vm._v(" "), _c('div', {
    staticClass: "oldImgBox clearfix"
  }, [_c('div', {
    staticClass: "oldImg left flex flex-align-center flex-pack-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.oldImg,
      "alt": "原图片",
      "id": "targetImg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeCrop
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])])])])
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "put-with-draw"
  }, [_c('div', {
    staticClass: "panle now-money-info"
  }, [_c('div', {
    staticClass: "now-money"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("当前可提现金额")]), _vm._v(" "), _c('span', {
    staticClass: "money"
  }, [_vm._v("￥" + _vm._s(_vm.data.amount.toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panle withdraw-box"
  }, [_c('div', {
    staticClass: "withdraw"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("请输入提现金额")]), _vm._v(" "), _c('div', {
    staticClass: "put-money"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入提现金额"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isGetCode) ? _c('span', {
    staticClass: "get-code",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("立即获取")]) : _vm._e(), _vm._v(" "), (_vm.isGetCode) ? _c('span', {
    staticClass: "sendCode"
  }, [_vm._v(_vm._s(_vm.time + ' s'))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "put"
  }, [_c('button', {
    on: {
      "click": _vm.withdraw
    }
  }, [_vm._v("提现")])])])])])
},staticRenderFns: []}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-info"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left search flex flex-align-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goods),
      expression: "goods"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入配品名"
    },
    domProps: {
      "value": (_vm.goods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goods = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.searchGoods
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search",
    style: ({
      display: (_vm.goodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.curGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.goodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'search')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fliter type"
  }, [_vm._v("\n                        分类选择：\n                        "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.fliter_type),
      callback: function($$v) {
        _vm.fliter_type = $$v
      },
      expression: "fliter_type"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "fliter"
  }, [_vm._v("\n                        管理库存：\n                        "), _c('el-select', {
    model: {
      value: (_vm.fliter_stock),
      callback: function($$v) {
        _vm.fliter_stock = $$v
      },
      expression: "fliter_stock"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "true",
    attrs: {
      "label": "是",
      "value": "true"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "false",
    attrs: {
      "label": "否",
      "value": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fliterGoods
    }
  }, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGoods
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加配品")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.vipData.length > 6
    }
  }, _vm._l((_vm.vipData), function(item, idx) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "4%"
      },
      domProps: {
        "textContent": _vm._s(item.id ? (idx + 1) : '')
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-button', {
      attrs: {
        "type": "text",
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.uploadGood(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delGoods(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])], 1) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": _vm.btnId ? '修改配品' : '添加配品',
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix",
    on: {
      "click": _vm.hideSearchList
    }
  }, [_c('div', {
    staticClass: "left msgItem clearfix searchbox"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("配品名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.name),
      expression: "newGoods.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入配品名"
    },
    domProps: {
      "value": (_vm.newGoods.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search add_details_search",
    style: ({
      display: (_vm.addGoodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.addCurGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.addGoodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'add')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("配品分类")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "placeholder": "请选择配品分类"
    },
    model: {
      value: (_vm.newGoods.productTypeId),
      callback: function($$v) {
        _vm.$set(_vm.newGoods, "productTypeId", $$v)
      },
      expression: "newGoods.productTypeId"
    }
  }, [_vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("价格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGoods.salesPrice),
      expression: "newGoods.salesPrice"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "placeholder": "价格"
    },
    domProps: {
      "value": (_vm.newGoods.salesPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newGoods, "salesPrice", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left"
  }, [_vm._v("元")])]), _vm._v(" "), _c('div', {
    staticClass: "left mat-goods"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("包含原料:")]), _vm._v(" "), _c('span', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledMats), function(tag) {
    return _c('el-tag', {
      key: tag.name
    }, [_vm._v("\n                        " + _vm._s(tag.name) + "*" + _vm._s(tag.count) + "\n                        ")])
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addMatGoods
    }
  }, [_vm._v("+添加")])], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.upGoods
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMat) ? _c('selGoods', {
    attrs: {
      "seledGoods": _vm.seledMats,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": function($event) {
        _vm.showMat = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("配品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("销售价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showCartInfo ? 'show' : '',
    attrs: {
      "id": "cartInfo"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeCartInfo.apply(null, arguments)
      }
    }
  }, [_c('div', {
    class: _vm.showCartInfo ? 'cart show' : 'cart',
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.showCartInfo) ? _c('div', {
    staticClass: "cart-info"
  }, [(_vm.showType != 'packageTotalSales' && _vm.showType != 'empSalesInfo' && _vm.showType != 'secondActivity') ? _c('span', {
    staticClass: "table-info"
  }, [_vm._v(_vm._s(_vm.nowSelName) + "-" + _vm._s(_vm.titInfo[_vm.showType]))]) : _vm._e(), _vm._v(" "), (_vm.showType == 'packageTotalSales') ? _c('span', {
    staticClass: "table-info"
  }, [_vm._v(_vm._s(_vm.nowPackageTotalSalesInfo.packName))]) : _vm._e(), _vm._v(" "), (_vm.showType == 'empSalesInfo') ? _c('span', {
    staticClass: "table-info"
  }, [_vm._v("员工姓名:" + _vm._s(_vm.nowEmpSalesInfo.empName))]) : _vm._e(), _vm._v(" "), (_vm.showType == 'secondActivity') ? _c('span', {
    staticClass: "table-info"
  }, [_vm._v("优惠详情")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeCartInfo.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-info"
  }, [_c('span', {
    staticClass: "table-info"
  }, [_vm._v(_vm._s(((_vm.orderInfo.transaction.partitionName) + "-" + (_vm.orderInfo.transaction.numName))))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeCartInfo.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "common-wrap"
  }, [(_vm.showType == 'secondActivity' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("活动名称")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.secondInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.secondInfo.addTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("优惠方式")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.typeOptions[_vm.secondInfo.discountType]))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("减免金额/折扣")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.formatDiscount(_vm.secondInfo)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("生效时间")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.secondInfo)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("时间范围")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.formatTimeRange(_vm.secondInfo)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item all-width"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("星期")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.secondInfo.week))])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'vipChargeInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("充值单号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.orderCode))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("充值时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.vipInfo.chargeTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员卡号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.memberCode))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.memberName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员级别:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.memberLevel))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员手机:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.memberMobile))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("充前余额:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.beforeAmount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("充值金额:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.chargeAmount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("赠送金额:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.bonusAmount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员余额:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.afterAmount.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("备注:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipInfo.notice))])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'empSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开始时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.beginTime))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结束时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.endTime))])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'deskSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开台时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowDeskSalesInfo.begin)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("关台时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowDeskSalesInfo.end)))])]), _vm._v(" "), (_vm.nowDeskSalesInfo.memberName) ? _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.memberName))])]) : _vm._e(), _vm._v(" "), (_vm.nowDeskSalesInfo.memberMobile) ? _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员手机号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.memberMobile))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("累计时长:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalTime))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("顾客人数:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.people))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.openEmp))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("商品消费:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalAmount) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("包间费:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalRoomAmount) + "元")])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'vipConsume' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账编号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.code))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.creatorName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.vipConsumeInfo.order.addTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.vipConsumeInfo.order.paymentTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("累积时长:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.transaction.inTime))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("顾客人数:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.transaction.people))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.payName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员编号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.memberName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.memberName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("是否免单:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.mode == 1 ? "是" : "否"))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("是否挂单:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.mode == 2 ? "是" : "否"))])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "cart-detail"
  }, [_c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账编号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.id))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.empName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("开单时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(new Date(_vm.orderInfo.order.addTime).Format('yyyy-MM-dd hh:mm:ss')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账时间:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(new Date(_vm.orderInfo.order.paymentTime).Format('yyyy-MM-dd hh:mm:ss')))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("累计时长:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.inTime))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("顾客人数:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.people) + "人")])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("结账员工:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.payName))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员编号:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.memberId ? _vm.orderInfo.order.memberId : "-"))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("会员姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.memberId ? _vm.orderInfo.order.memberName : "-"))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("是否免单:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.mode == 1 ? '是' : '否'))])]), _vm._v(" "), _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }, [_vm._v("是否挂单:")]), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  }, [_vm._v(_vm._s(_vm.orderInfo.order.mode == 2 ? '是' : '否'))])])]) : _vm._e(), _vm._v(" "), (_vm.showType != 'packageTotalSales') ? _c('div', {
    staticClass: "split-line",
    attrs: {
      "data-v-1e65f96a": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "note"
  }, [_c('span', [_vm._v("备注：" + _vm._s(_vm.orderInfo.order.notes ? _vm.orderInfo.order.notes : '无'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cart-goods-detail"
  }, [(_vm.showType == 'secondActivity' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("参与优惠的商品")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(2), _vm._v(" "), _vm._l((_vm.goodsInfoForSecond.content), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.discountCommission / 100))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.count))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.nowPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.nowPage = $event
      },
      "update:current-page": function($event) {
        _vm.nowPage = $event
      }
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'secondActivity' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("活动日志")]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间选择:"
    }
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.formInline.startTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "startTime", $$v)
      },
      expression: "formInline.startTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.formInline.endTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "endTime", $$v)
      },
      expression: "formInline.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(3), _vm._v(" "), _vm._l((_vm.salesGoodsInfo.content), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.orderId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("numberToAllDate")(item.payTime)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.qty))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.nowPageForSales,
      "page-size": _vm.pageSizeForSales,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElementsForSales
    },
    on: {
      "current-change": _vm.handleCurrentChangeForSales,
      "update:currentPage": function($event) {
        _vm.nowPageForSales = $event
      },
      "update:current-page": function($event) {
        _vm.nowPageForSales = $event
      }
    }
  })], 1)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showType == 'vipChargeInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(4), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.channelType[_vm.vipInfo.channel]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.vipInfo.chargeAmount))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'vipConsume' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("收入明细")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("商品费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.productAmount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.productDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("包间费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.transaction.roomAmount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.transaction.roomDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("服务费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.transaction.serviceAmount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.transaction.serviceDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("手动优惠")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.order.allHandDiscount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("--")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("消费明细")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(6), _vm._v(" "), _vm._l((_vm.vipConsumeInfo.order.items), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.onePrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.dealPrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(_vm.vipConsumeInfo.order.mode == 0 ? '正常' : (_vm.vipConsumeInfo.order.mode == 1 ? '免单' : '挂单')))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("付款信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(7), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.channelType[_vm.vipConsumeInfo.order.channel]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s((_vm.vipConsumeInfo.order.amount).toFixed(2)))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("收入明细")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(8), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("商品费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.productAmount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.productDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("包间费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s(Number(Number(_vm.orderInfo.transaction.roomAmount) - Number(_vm.orderInfo.transaction.roomDiscount)).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.transaction.roomDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("服务费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s(Number(Number(_vm.orderInfo.transaction.serviceAmount) - Number(_vm.orderInfo.transaction.serviceDiscount)).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.transaction.serviceDiscount).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("手动优惠")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.order.allHandDiscount).toFixed(2)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("--")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品消费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(9), _vm._v(" "), _vm._l((_vm.orderInfo.order.items), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.onePrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.dealPrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(_vm.modeInfo[_vm.orderInfo.order.mode]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("计时商品消费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(10), _vm._v(" "), _vm._l((_vm.orderInfo.productTime), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.productTimeName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.ruleName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12.5%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("包间费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(11), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(((_vm.orderInfo.transaction.partitionName) + "-" + (_vm.orderInfo.transaction.numName))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.orderInfo.transaction.beginTime)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.inTime))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.rulesName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.transaction.roomAmount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("付款信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(12), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.channelType[_vm.orderInfo.order.channel]))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s((_vm.orderInfo.order.amount).toFixed(2)))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'exchangeInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("分类销售统计")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "for-goods"
  }, [_vm._m(13), _vm._v(" "), _vm._l((_vm.nowExcInfo.itemDetails), function(it, idx) {
    return _c('div', {
      key: idx,
      staticClass: "goods-detail",
      class: _vm.nowSelIndex == idx ? 'act' : ''
    }, [_c('div', {
      staticClass: "detail-tit",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showGoodsDetail(it, idx)
        }
      }
    }, [_c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%",
        "text-align": "left",
        "padding-left": "15px"
      }
    }, [_c('i', {
      staticClass: "arrow iconfont icon-sanjiaoxing",
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "10px",
        "margin-right": "5px"
      }
    }), _c('span', {
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(it.typeName))])]), _vm._v(" "), _c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(it.qty))]), _vm._v(" "), _c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(it.amount.toFixed(2)))]), _vm._v(" "), _vm._l((_vm.itemDetail), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "goods",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%",
          "cursor": "pointer"
        }
      }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(_vm._s(item.amount.toFixed(2)))])])
    })], 2)])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'empSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("详情")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(14), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("会员充值")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s((_vm.nowEmpSalesInfo.memberCharge).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("总销售")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(Number(_vm.nowEmpSalesInfo.salesTotal).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("会员消费")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(Number(_vm.nowEmpSalesInfo.totalMember).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("推荐会员数")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.memberCount))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("总开台次数")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.openNum))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("预定次数")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.nowEmpSalesInfo.bookNum))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品销售列表")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('div', {
    staticClass: "for-goods"
  }, [_vm._m(15), _vm._v(" "), _vm._l((_vm.nowEmpSalesInfo.items), function(it, idx) {
    return _c('div', {
      key: idx,
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "detail-tit",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showGoodsDetail(it, idx)
        }
      }
    }, [_c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%",
        "text-align": "left",
        "padding-left": "15px"
      }
    }, [_c('i', {
      staticClass: "arrow iconfont icon-sanjiaoxing",
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "10px",
        "margin-right": "5px"
      }
    }), _c('span', {
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(it.name))])]), _vm._v(" "), _c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(it.qty))]), _vm._v(" "), _c('div', {
      staticClass: "detail-tit-span",
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(it.amount.toFixed(2)))]), _vm._v(" "), _vm._l((it.items), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "goods",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%",
          "cursor": "pointer"
        }
      }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('div', {
        staticClass: "goods-span",
        staticStyle: {
          "width": "33.33%"
        }
      }, [_vm._v(_vm._s(item.amount.toFixed(2)))])])
    })], 2)])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'packageTotalSales' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品列表")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(16), _vm._v(" "), _vm._l((_vm.nowPackageTotalSalesInfo.itemQties), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.qty))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品消费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(17), _vm._v(" "), _vm._l((_vm.nowPackageTotalSalesInfo.resList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.amount.toFixed(2)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.numName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "16%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("naSecFilterDate")(item.addTime)))])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'deskSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("商品消费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(18), _vm._v(" "), _vm._l((_vm.nowDeskSalesInfo.orderItems), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.dealPrice.toFixed(2)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "16%"
      }
    }, [_vm._v(_vm._s(item.createName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.addTime)))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("包间费清单")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(19), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.numName))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowDeskSalesInfo.begin)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(_vm.nowDeskSalesInfo.end)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalTime))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.rulesName ? _vm.nowDeskSalesInfo.rulesName : '--'))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.nowDeskSalesInfo.totalRoomAmount))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info-wrap"
  }, [_c('div', {
    staticClass: "wrap-tit"
  }, [_vm._v("付款信息")]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('table', [_vm._m(20), _vm._v(" "), _vm._l((_vm.nowDeskSalesInfo.channel), function(ite, indx) {
    return _c('tr', {
      key: indx
    }, [_c('td', {
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(indx + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(_vm.channelType[ite.channel]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "33.333%"
      }
    }, [_vm._v(_vm._s(ite.channel ? Number(ite.amount).toFixed(2) : ''))])])
  })], 2)])])]) : _vm._e()])]), _vm._v(" "), (_vm.showType == 'vipConsume' && _vm.showCartInfo) ? _c('div', {
    staticClass: "add-or-pay-wrap"
  }, [_c('span', {
    staticClass: "total-fee"
  }, [_vm._v("\n        合计:\n        "), _c('b', [_vm._v(_vm._s((Number(_vm.vipConsumeInfo.order.amount)).toFixed(2)))]), _vm._v("元\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'deskSalesInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "add-or-pay-wrap"
  }, [_c('span', {
    staticClass: "total-fee"
  }, [_vm._v("\n        合计:\n        "), _c('b', [_vm._v(_vm._s((Number(_vm.nowDeskSalesInfo.totalAmount) + Number(_vm.nowDeskSalesInfo.totalRoomAmount)).toFixed(2)))]), _vm._v("元\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'orderInfo' && _vm.showCartInfo) ? _c('div', {
    staticClass: "add-or-pay-wrap"
  }, [_c('span', {
    staticClass: "total-fee"
  }, [_vm._v("\n        合计:\n        "), _c('b', [_vm._v(_vm._s((Number(_vm.orderInfo.order.amount)).toFixed(2)))]), _vm._v("元\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.showType == 'secondActivity' && _vm.showCartInfo && (_vm.secondInfo.promotionType == 'ing' || _vm.secondInfo.promotionType == 'no')) ? _c('div', {
    staticClass: "add-or-pay-wrap"
  }, [_c('div', {
    staticClass: "add-or-pay"
  }, [_c('button', {
    staticClass: "go-pay",
    staticStyle: {
      "background": "#d99e4c"
    },
    on: {
      "click": _vm.cancelActivity
    }
  }, [_vm._v("取消活动")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-detail-item"
  }, [_c('span', {
    staticClass: "item-tit"
  }), _vm._v(" "), _c('span', {
    staticClass: "item-cont"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("提成金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("销售数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("消费单号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("销售时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("销售数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("金额(元)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("金额(元)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("优惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("点单员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("点单时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.3%"
    }
  }, [_vm._v("优惠")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("点单员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("点单时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("计时规则")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_vm._v("点单员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("计时时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("点单时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("包间名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("入座时长")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("计费规则")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("包间费")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("应收金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "span",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("应收金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("台桌名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("操作员")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("操作员")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("包间名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("结束时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("入座时长")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("计费规则")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("包间费")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "head"
  }, [_c('th', {
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33.333%"
    }
  }, [_vm._v("金额")])])
}]}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "get-with-draw"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.withdrawData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.withdrawData.length > 10
    }
  }, _vm._l((_vm.withdrawData), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.accountPeople))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.accountingAmount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s("10%"))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(item.accountPayee))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(item.accounting ? "成功" : "提现中"))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.withdrawTime)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "change-type"
  }, [_c('span', [_vm._v("发起提现后，平台将统一于每周二划款，请注意查收。如有疑问，请电联13980547109(微信同号)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("提现人")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("提现金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("划账金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("平台扣费")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("提现账号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("提现状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("日期")])])])
}]}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "loginType clearfix"
  }, [_c('div', {
    staticClass: "loginTypeItem",
    class: {
      active: !_vm.isMsg
    },
    staticStyle: {
      "color": "#3068ff"
    },
    on: {
      "click": function($event) {
        return _vm.changeLoginType(false)
      }
    }
  }, [_vm._v("账号登录")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "inputItem clearfix"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    ref: "fInp",
    attrs: {
      "type": "tel",
      "placeholder": "请输入手机号",
      "id": "testInp",
      "autocomplete": "off",
      "onfocus": "this.type='phone'"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.isGetCode && _vm.isMsg) ? _c('span', {
    staticClass: "sendCode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.isGetCode && _vm.isMsg) ? _c('span', {
    staticClass: "sendCode"
  }, [_vm._v(_vm._s(_vm.time + ' s'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "inputItem"
  }, [(_vm.isMsg) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), (!_vm.isMsg) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "autocomplete": "off",
      "onfocus": "this.type='password'"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "forgetPW",
    staticStyle: {
      "padding-top": "9%",
      "margin-bottom": "0",
      "font-size": "20px"
    }
  }, [_vm._v("\n                酒吧/KTV/茶楼等后台登录？"), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeUrl.apply(null, arguments)
      }
    }
  }, [_vm._v("点击切换至旗舰版")])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup clearfix"
  }, [_c('button', {
    staticClass: "loginBtn right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('button', {
    staticClass: "regisBtn left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/register'
        });
      }
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "forgetPW"
  }, [_vm._v("\n                忘记密码？"), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/register/reset'
        });
      }
    }
  }, [_vm._v("重置密码 / 修改密码")]), _vm._v(" "), _c('a', {
    staticClass: "dw",
    attrs: {
      "href": "/static/火星捕手点单系统安装包_V1.1.3.exe.zip",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("下载收银端")])])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(254),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("基于云计算SaaS模式")]), _vm._v(" "), _c('p', [_vm._v("收银、营销一体化服务平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left iconSpan"
  }, [_c('i', {
    staticClass: "iconfont icon-mobile"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left iconSpan"
  }, [_c('i', {
    staticClass: "iconfont icon-mima"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-info"
  }, [_c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("蜀ICP备17028712号-1")]), _vm._v(" 火星云网络科技有限公司 huoxingy.co"), _c('a', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "target": "_blank",
      "href": "/static/bq.zip"
    }
  }, [_vm._v("m")])])])
}]}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupondetail",
    attrs: {
      "id": "coupondetail"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goodCheckArr = []
      }
    }
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'DAY') ? _c('div', {
    staticClass: "date-filter"
  }, [_c('el-date-picker', {
    ref: "dateInput",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "placeholder": "请选择选择日期"
    },
    model: {
      value: (_vm.dateStr),
      callback: function($$v) {
        _vm.dateStr = $$v
      },
      expression: "dateStr"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-jiantou",
    on: {
      "click": function($event) {
        return _vm.$refs.dateInput.handleFocus()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'TIME_RANGE') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "quick-filter"
  }, [_c('span', {
    class: _vm.nowSelFilter == 'today' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('today')
      }
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastDay' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastDay')
      }
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'week' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('week')
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastWeek' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastWeek')
      }
    }
  }, [_vm._v("上周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'month' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('month')
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastMonth' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastMonth')
      }
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('span', {
    staticClass: "filter-tit"
  }, [_vm._v("商品名:")]), _vm._v(" "), _c('div', {
    staticClass: "search",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goods),
      expression: "goods"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.goods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goods = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.searchGoods
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search",
    style: ({
      display: (_vm.goodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.curGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.goodCheckArr), function(item, ind) {
    return _c('li', {
      key: ind,
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'search')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.verifiList.length > _vm.pageSize
    }
  }, _vm._l((_vm.verifiList), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.productId ? ind + 1 : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.count))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("核销商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("核销数量")])])])
}]}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "elecSales"
  }, [_c('div', {
    staticClass: "tableConBox",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = false
      }
    }
  }, [_c('div', {
    staticClass: "tableTem",
    on: {
      "click": function($event) {
        _vm.searchList = []
      }
    }
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "month-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy-MM",
      "format": "yyyy 年 MM 月",
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.valueForMonth),
      callback: function($$v) {
        _vm.valueForMonth = $$v
      },
      expression: "valueForMonth"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "day-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptionsForDay
    },
    model: {
      value: (_vm.nowDay),
      callback: function($$v) {
        _vm.nowDay = $$v
      },
      expression: "nowDay"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchByWhichType == 'timeRange' && !_vm.isUseRangeTime),
      expression: "searchByWhichType=='timeRange'&&!isUseRangeTime"
    }],
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptions0,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptions0,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchByWhichType == 'timeRange' && _vm.isUseRangeTime),
      expression: "searchByWhichType=='timeRange'&&isUseRangeTime"
    }],
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "picker-options": _vm.pickerOptions0,
      "default-time": "00:00:00",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptions0,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), (_vm.searchByWhichType == 'timeRange' && _vm.isUseRangeTime) ? _c('el-time-picker', {
    staticClass: "dateTime",
    attrs: {
      "is-range": "",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "placeholder": "选择时间范围"
    },
    model: {
      value: (_vm.rangeTime),
      callback: function($$v) {
        _vm.rangeTime = $$v
      },
      expression: "rangeTime"
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "types"
  }, [_vm._v("\n                        分类选择：\n                        "), _vm._v(" "), _c('div', {
    staticClass: "type-sel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = !_vm.showType
      }
    }
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.isSelAll ? '全部' : (_vm.selType.length > 0 ? ((_vm.selType[0]) + "...") : '分类选择')))]), _vm._v(" "), (_vm.showType) ? _c('div', {
    staticClass: "type-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ul', [_c('li', [_c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelAll),
      expression: "isSelAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 'ALL',
      "checked": Array.isArray(_vm.isSelAll) ? _vm._i(_vm.isSelAll, 'ALL') > -1 : (_vm.isSelAll)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selAll.apply(null, arguments)
      },
      "change": function($event) {
        var $$a = _vm.isSelAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 'ALL',
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSelAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSelAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSelAll = $$c
        }
      }
    }
  }), _vm._v("全部")])]), _vm._v(" "), _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selType),
        expression: "selType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.value,
        "checked": Array.isArray(_vm.selType) ? _vm._i(_vm.selType, item.value) > -1 : (_vm.selType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selType = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selType = $$c
          }
        }
      }
    }), _vm._v(_vm._s(item.label))])])
  })], 2)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.id) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + item.totalAmountIncome / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + item.serviceChargeAmount / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + (item.totalAmountIncome - item.serviceChargeAmount) / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(new Date(item.date).Format('yyyy-MM-dd'))
      }
    })])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.id) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + item.totalAmountIncome / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + item.serviceChargeAmount / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + (item.totalAmountIncome - item.serviceChargeAmount) / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(new Date(item.date).Format('yyyy-MM-dd'))
      }
    })])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.id) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + item.totalAmountIncome / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + item.serviceChargeAmount / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s('￥' + (item.totalAmountIncome - item.serviceChargeAmount) / 100)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(new Date(item.date).Format('yyyy-MM-dd'))
      }
    })])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQty)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("总收入:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmount)))]), _vm._v(" "), (_vm.channelInfo) ? _c('span', {
    staticClass: "channel-info"
  }, [_c('span', [_vm._v("微信：" + _vm._s(_vm.channelInfo.wechatAmount))]), _vm._v(" "), _c('span', [_vm._v("、支付宝：" + _vm._s(_vm.channelInfo.aliAmount))]), _vm._v(" "), _c('span', [_vm._v("、会员支付：" + _vm._s(_vm.channelInfo.memberAmount))]), _vm._v(" "), _c('span', [_vm._v("、银联支付：" + _vm._s(_vm.channelInfo.unionpayAmount))]), _vm._v(" "), _c('span', [_vm._v("、现金支付：" + _vm._s(_vm.channelInfo.cashAmount))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQtyForMonth)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("总收入:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmountForMonth)))]), _vm._v(" "), (_vm.channelInfo) ? _c('span', {
    staticClass: "channel-info"
  }, [_c('span', [_vm._v("微信：" + _vm._s(_vm.channelInfo.wechatAmount))]), _vm._v(" "), _c('span', [_vm._v("、支付宝：" + _vm._s(_vm.channelInfo.aliAmount))]), _vm._v(" "), _c('span', [_vm._v("、会员支付：" + _vm._s(_vm.channelInfo.memberAmount))]), _vm._v(" "), _c('span', [_vm._v("、银联支付：" + _vm._s(_vm.channelInfo.unionpayAmount))]), _vm._v(" "), _c('span', [_vm._v("、现金支付：" + _vm._s(_vm.channelInfo.cashAmount))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination",
    staticStyle: {
      "text-align": "right",
      "padding-top": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "pager flex flex-align-center",
    staticStyle: {
      "height": "calc(12% - 52px)"
    }
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("收款金额:"), _c('span', {
    staticClass: "num color3"
  }, [_vm._v("￥" + _vm._s(_vm.totalAmount / 100))])]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_c('span', [_vm._v("手续费:  \n                            "), _c('span', {
    staticClass: "num color5"
  }, [_vm._v("￥" + _vm._s(_vm.serviceChargeAmount / 100))])])]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_c('span', [_vm._v("划账金额:  \n                            "), _c('span', {
    staticClass: "num color4"
  }, [_vm._v("￥" + _vm._s((_vm.totalAmount - _vm.serviceChargeAmount) / 100))])])])])]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("收款金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("手续费")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("划账金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("日期")])])])
}]}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "second"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "89.3%",
      "position": "relative",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "left search flex flex-align-center tab-item",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('span', {
    staticClass: "left-item",
    class: {
      active: _vm.nowSelType == 'no'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nowSelType = 'no'
      }
    }
  }, [_vm._v("未开始")]), _vm._v(" "), _c('span', {
    staticClass: "left-item",
    class: {
      active: _vm.nowSelType == 'ing'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nowSelType = 'ing'
      }
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c('span', {
    staticClass: "left-item",
    class: {
      active: _vm.nowSelType == 'over'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nowSelType = 'over'
      }
    }
  }, [_vm._v("已结束")]), _vm._v(" "), _c('span', {
    staticClass: "left-item",
    class: {
      active: _vm.nowSelType == 'cancel'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.nowSelType = 'cancel'
      }
    }
  }, [_vm._v("已取消")])]), _vm._v(" "), _c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modifySecond
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增优惠")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox",
    staticStyle: {
      "height": "87%"
    }
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable jobConTable",
    class: {
      overLengthTable: _vm.dataList.length > _vm.pageSize
    }
  }, _vm._l((_vm.dataList), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.typeOptions[item.discountType]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm.formatDiscount(item)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(_vm.formatTime(item)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm.formatTimeRange(item)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n                                        " + _vm._s(item.week) + "\n                                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.detail(item)
        }
      }
    }, [_vm._v("详情")])]) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), _c('cartInfo', {
    attrs: {
      "showType": 'secondActivity',
      "secondInfo": _vm.secondInfo,
      "storeId": _vm.curStoreId,
      "showCartInfo": _vm.showCartInfo
    },
    on: {
      "closeCartInfo": _vm.closeCartInfo
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.nowPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.nowPage = $event
      },
      "update:current-page": function($event) {
        _vm.nowPage = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.curJobId ? '修改时段' : '添加时段',
      "visible": _vm.addJobVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeName),
      expression: "timeName"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入时段名称"
    },
    domProps: {
      "value": (_vm.timeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.timeName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix groupRoles"
  }, [_c('span', {
    staticClass: "left itemName permissions"
  }, [_c('i', [_vm._v("*")]), _vm._v("开始时间")]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "rowItem"
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入时",
      "clearable": ""
    },
    model: {
      value: (_vm.time.beginHour),
      callback: function($$v) {
        _vm.$set(_vm.time, "beginHour", $$v)
      },
      expression: "time.beginHour"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("时")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入分",
      "clearable": ""
    },
    model: {
      value: (_vm.time.beginMinute),
      callback: function($$v) {
        _vm.$set(_vm.time, "beginMinute", $$v)
      },
      expression: "time.beginMinute"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("分")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix groupRoles",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticClass: "left itemName permissions"
  }, [_c('i', [_vm._v("*")]), _vm._v("结束时间")]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "rowItem"
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入时",
      "clearable": ""
    },
    model: {
      value: (_vm.time.endHour),
      callback: function($$v) {
        _vm.$set(_vm.time, "endHour", $$v)
      },
      expression: "time.endHour"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("时")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请输入分",
      "clearable": ""
    },
    model: {
      value: (_vm.time.endMinute),
      callback: function($$v) {
        _vm.$set(_vm.time, "endMinute", $$v)
      },
      expression: "time.endMinute"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("分")])], 1)])])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addJob
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable jobTitleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("优惠方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("减免金额/折扣")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("优惠生效时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("时间范围")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("星期")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "merInf"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "merMsg1"
  }, [_c('form', [_c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "title flex flex-align-center"
  }, [_vm._v("负责人信息（必填）")]), _vm._v(" "), _c('div', {
    staticClass: "partCon clearfix"
  }, [_c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("法人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.name),
      expression: "contact.name"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请输入法人姓名"
    },
    domProps: {
      "value": (_vm.contact.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("身份证号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.nicNumber),
      expression: "contact.nicNumber"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请输入经营者身份证号码"
    },
    domProps: {
      "value": (_vm.contact.nicNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "nicNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.mobile),
      expression: "contact.mobile"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请输入经营者手机号"
    },
    domProps: {
      "value": (_vm.contact.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "mobile", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "title flex flex-align-center"
  }, [_vm._v("商户资料（必填）")]), _vm._v(" "), _c('div', {
    staticClass: "partCon clearfix"
  }, [_c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("商户名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "需与营业执照名称一致"
    },
    domProps: {
      "value": (_vm.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("商户简称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.abbrName),
      expression: "info.abbrName"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "用于在付款页面向客户展示"
    },
    domProps: {
      "value": (_vm.info.abbrName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "abbrName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("统一社会信用代码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.licenseNumber),
      expression: "info.licenseNumber"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "统一社会信用代码"
    },
    domProps: {
      "value": (_vm.info.licenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "licenseNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("省市区")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.adName),
      expression: "info.adName"
    }],
    staticClass: "msgInput left",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择商户所在省市",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.info.adName)
    },
    on: {
      "click": function($event) {
        _vm.showSelectAdd = true;
        _vm.isBankArea = false;
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "adName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.addr),
      expression: "info.addr"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "如：XX区XX街道XX号"
    },
    domProps: {
      "value": (_vm.info.addr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "addr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("联系邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.email),
      expression: "info.email"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "接受重要信息"
    },
    domProps: {
      "value": (_vm.info.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.customerServiceTele),
      expression: "info.customerServiceTele"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "可填写手机号、座机号码"
    },
    domProps: {
      "value": (_vm.info.customerServiceTele)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "customerServiceTele", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "title flex flex-align-center"
  }, [_vm._v("添加结算银行卡信息（必填,以下信息务必填写正确,如有错误,将无法结算!）")]), _vm._v(" "), _c('div', {
    staticClass: "partCon clearfix"
  }, [_c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("开户人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.accountHolder),
      expression: "card.accountHolder"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请输入开户人姓名"
    },
    domProps: {
      "value": (_vm.card.accountHolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.card, "accountHolder", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("开户身份证")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.nicNumber),
      expression: "card.nicNumber"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请输入开户人身份证号"
    },
    domProps: {
      "value": (_vm.card.nicNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.card, "nicNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("预留手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.mobile),
      expression: "card.mobile"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请输入开户银行预留手机号"
    },
    domProps: {
      "value": (_vm.card.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.card, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("银行卡号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.debitCardNumber),
      expression: "card.debitCardNumber"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请输入银行卡号"
    },
    domProps: {
      "value": (_vm.card.debitCardNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.card, "debitCardNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("开户银行")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.bankName),
      expression: "card.bankName"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请输入开户银行"
    },
    domProps: {
      "value": (_vm.card.bankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.card, "bankName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("开户省市")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.adName),
      expression: "card.adName"
    }],
    staticClass: "msgInput left",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "text",
      "placeholder": "请选择开户省市",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.card.adName)
    },
    on: {
      "click": function($event) {
        _vm.showSelectAdd = true;
        _vm.isBankArea = true;
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.card, "adName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem left clearfix"
  }, [_c('div', {
    staticClass: "name left flex flex-align-center"
  }, [_vm._v("开户支行")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.branchBankName),
      expression: "card.branchBankName"
    }],
    staticClass: "msgInput left",
    attrs: {
      "type": "text",
      "placeholder": "请选择开户支行名称"
    },
    domProps: {
      "value": (_vm.card.branchBankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.card, "branchBankName", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "merMsg2"
  }, [_c('form', [_c('div', {
    staticClass: "part2"
  }, [_c('div', {
    staticClass: "title flex flex-align-center"
  }, [_vm._v("商户图片资料（必填）")]), _vm._v(" "), _c('div', {
    staticClass: "fileBox clearfix"
  }, [_c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传营业执照")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.businessLicenseImage) ? _c('img', {
    attrs: {
      "src": _vm.businessLicenseImage,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择营业执照"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'businessLicenseImage')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'businessLicenseImage')
      }
    }
  })])]), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传法人身份证人像面")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.nicCardUpSideImage) ? _c('img', {
    attrs: {
      "src": _vm.nicCardUpSideImage,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择身份证人像面"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'nicCardUpSideImage')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'nicCardUpSideImage')
      }
    }
  })])]), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传法人身份证国徽面")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.nicCardDownSideImage) ? _c('img', {
    attrs: {
      "src": _vm.nicCardDownSideImage,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择身份证国徽面"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'nicCardDownSideImage')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'nicCardDownSideImage')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传银行卡结算人身份证人像面")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.nicCardUpSideImageForConcat) ? _c('img', {
    attrs: {
      "src": _vm.nicCardUpSideImageForConcat,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择身份证国徽面"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'nicCardUpSideImageForConcat')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'nicCardUpSideImageForConcat')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传银行卡结算人身份证国徽面")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.nicCardDownSideImageForConcat) ? _c('img', {
    attrs: {
      "src": _vm.nicCardDownSideImageForConcat,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择身份证国徽面"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'nicCardDownSideImageForConcat')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'nicCardDownSideImageForConcat')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传门头照")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.storeImage) ? _c('img', {
    attrs: {
      "src": _vm.storeImage,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择门头照",
      "id": "image"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'storeImage')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'storeImage')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传银行卡正面照")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.bankCardImage) ? _c('img', {
    attrs: {
      "src": _vm.bankCardImage,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "",
      "id": "image"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'bankCardImage')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'bankCardImage')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传银行卡背面照")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.bankCardDowmImage) ? _c('img', {
    attrs: {
      "src": _vm.bankCardDowmImage,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "",
      "id": "image"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'bankCardDowmImage')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'bankCardDowmImage')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传吧台照片")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.barImage) ? _c('img', {
    attrs: {
      "src": _vm.barImage,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "",
      "id": "image"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'barImage')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'barImage')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("上传内景照片")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.innerImage) ? _c('img', {
    attrs: {
      "src": _vm.innerImage,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "",
      "id": "image"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'innerImage')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'innerImage')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("其他资料照片1(非必填)")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.otherImageOne) ? _c('img', {
    attrs: {
      "src": _vm.otherImageOne,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "",
      "id": "image"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'otherImageOne')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'otherImageOne')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upFile left"
  }, [_c('div', {
    staticClass: "name flex flex-pack-center flex-align-center"
  }, [_vm._v("其他资料照片2(非必填)")]), _vm._v(" "), _c('div', {
    staticClass: "flex comFile flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [(_vm.otherImageTwo) ? _c('img', {
    attrs: {
      "src": _vm.otherImageTwo,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "fileInput pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "",
      "id": "image"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'otherImageTwo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fileInput mobileImg",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'otherImageTwo')
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "nextBtn flex flex-align-center"
  }, [_c('button', {
    staticClass: "upLoad",
    on: {
      "click": _vm.upLoad
    }
  }, [_vm._v("确定上传")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "地址选择",
      "visible": _vm.showSelectAdd,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showSelectAdd = $event
      }
    }
  }, [_c('div', {
    staticClass: "selectAddBox clearfix"
  }, [_c('ul', {
    staticClass: "item province left"
  }, _vm._l((_vm.provinceList), function(item, idx) {
    return _c('li', {
      class: {
        active: (_vm.curProvinceIdx == idx)
      },
      domProps: {
        "textContent": _vm._s(item.name)
      },
      on: {
        "click": function($event) {
          return _vm.selectProvince(item, idx)
        }
      }
    })
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "item city left"
  }, _vm._l((_vm.cityList), function(item, idx) {
    return _c('li', {
      class: {
        active: (_vm.curCityIdx == idx)
      },
      domProps: {
        "textContent": _vm._s(item.name)
      },
      on: {
        "click": function($event) {
          return _vm.selectCity(item, idx)
        }
      }
    })
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "item country left"
  }, _vm._l((_vm.countryList), function(item, idx) {
    return _c('li', {
      class: {
        active: (_vm.curCountryIdx == idx)
      },
      domProps: {
        "textContent": _vm._s(item.name)
      },
      on: {
        "click": function($event) {
          return _vm.selectCountry(item, idx)
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showSelectAdd = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveAdd()
      }
    }
  }, [_vm._v("保存")])])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background-color": "#f6f7fb"
    }
  }, [(_vm.$route.name === 'exchangeWork') ? _c('div', {
    staticClass: "exchangeWork"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.closeUsername)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [(item.id) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm._f("numberToMonthDate")(item.beginTime, '')))]), _vm._v(" "), _c('span', [_vm._v("~")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("numberToMonthDate")(item.endTime, '')))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.turnInAmount)), (item.leaseAmount) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("(含租赁费:"), _c('b', [_vm._v(_vm._s(item.leaseAmount) + "元")]), _vm._v(")")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.refundAmount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#9FB2D7",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: ("/sys/" + _vm.curStoreId + "/exchangeWork/staffGrade"),
            query: {
              workShiftId: item.id,
              closeUsername: item.closeUsername,
              beginTime: item.beginTime,
              endTime: item.endTime
            }
          })
        }
      }
    }, [_vm._v("对账单")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#9FB2D7",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.cutSalesDetail(item)
        }
      }
    }, [_vm._v("销售明细")]), _vm._v(" "), (item.transactionEnable) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#9FB2D7",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.cutStockDetail(item)
        }
      }
    }, [_vm._v("库存记录")]) : _vm._e()]) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "销售明细",
      "visible": _vm.showPutAllMask1,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask1 = $event
      },
      "close": _vm.closeSaleDetail
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "couponBox right"
  }, [_c('div', {
    staticClass: "changeWorkTitle",
    staticStyle: {
      "margin-bottom": "10px",
      "font-weight": "600"
    }
  }, [_vm._v("优惠券核销统计")]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, _vm._l((_vm.salesData.coupons), function(item, ind) {
    return _c('div', [_c('div', {
      staticClass: "couponItem clearfix"
    }, [_c('span', {
      staticClass: "name left",
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "price right",
      domProps: {
        "textContent": _vm._s('￥' + item.amount / 100)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "number right",
      domProps: {
        "textContent": _vm._s('X' + item.quantity)
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "goodTypeBox left"
  }, [_c('div', {
    staticClass: "changeWorkTitle",
    staticStyle: {
      "margin-bottom": "10px",
      "font-weight": "600"
    }
  }, [_vm._v("分类列表")]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("火星网费：")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(_vm.salesData.cost.cashAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("会员支付网费:")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(_vm.salesData.net.amount)))]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(",数量:")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.salesData.net.qty))])]), _vm._v(" "), _c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("会员充值金额：")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")((_vm.salesData.memberDepositAmount) / 100)))])]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "value": _vm.nowTypeName,
      "accordion": ""
    },
    on: {
      "change": _vm.getNowTypeProducts
    }
  }, [_vm._l((_vm.rentData), function(item, ind) {
    return _c('el-collapse-item', {
      key: 'rent' + ind,
      attrs: {
        "name": item.typeName
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("\n                                    " + _vm._s(item.typeName) + "：￥" + _vm._s(_vm._f("toFixedNum")(item.amount)) + "\n                                ")]), _vm._v(" "), _vm._l((item.leaseItemList), function(bigGood) {
      return _c('div', {
        staticClass: "goodItem clearfix"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(bigGood.qty + ' × ' + bigGood.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "right"
      }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(bigGood.amount)))])])
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.salesData.itemDetails), function(item, ind) {
    return _c('el-collapse-item', {
      key: 'big' + ind,
      attrs: {
        "name": item.typeName
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("\n                                    " + _vm._s(item.typeName) + "：￥" + _vm._s(_vm._f("toFixedNum")(item.amount)) + "\n                                ")]), _vm._v(" "), _vm._l((_vm.nowItem), function(bigGood) {
      return _c('div', {
        staticClass: "goodItem clearfix"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(bigGood.qty + ' × ' + bigGood.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "right"
      }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(bigGood.amount)))])])
    })], 2)
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "员工销售",
      "visible": _vm.showPutAllMask2,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("员工名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("订单数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("销售金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.staffArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.pageSize * _vm.salesCurPage)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.creatorName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.orderCount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.totalAmount)
      }
    })])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.staff2Excel
    }
  }, [_vm._v("导出Excel")])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "stock",
    attrs: {
      "title": "库存记录",
      "visible": _vm.showStock,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showStock = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("分类名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("库存剩余")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.stockArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    })])])
  }), 0)])])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'staffGrade') ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "title_item left"
  }, [_c('i', [_vm._v("*")]), _c('span', [_vm._v("本班现金为收银员上交金额")])]), _vm._v(" "), _c('div', {
    staticClass: "title_item left"
  }, [_c('i', [_vm._v("*")]), _c('span', [_vm._v("微信和支付宝直接查阅电子对账单（公众号-'店员宝'-'我的店铺'）")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("交班员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("交接班时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("总收入")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("退单")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topLogo"
  }, [_c('el-row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    staticClass: "systemNameBox",
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 4,
      "lg": 4
    }
  }, [_c('div', {
    staticClass: "leftLogo flex flex-align-center flex-pack-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(826),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "crumbsBox",
    attrs: {
      "xs": 13,
      "sm": 13,
      "md": 17,
      "lg": 17
    }
  }, [_c('div', {
    staticClass: "search flex flex-align-center crumbs_class"
  }, [_c('div', {
    staticClass: "scroll-x-wrap",
    attrs: {
      "id": "scroll-x"
    }
  }, _vm._l((_vm.tabNamesList), function(item, index) {
    return _c('span', {
      key: index,
      class: _vm.nowTabPath == item.path ? 'item active' : 'item',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toThisTab(item)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(item.meta.tabName)), _c('i', {
      staticClass: "iconfont icon-guanbi",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.closeTab(item)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('el-col', {
    staticClass: "msgCenterBox",
    attrs: {
      "xs": 2,
      "sm": 2,
      "md": 1,
      "lg": 1
    }
  }, [(_vm.tabNamesList.length > 5) ? _c('div', {
    staticClass: "msgCenter flex flex-align-center flex-pack-center"
  }, [_c('span', {
    staticClass: "arrow"
  }, [_c('i', {
    staticClass: "iconfont icon-Arrowleftback",
    on: {
      "click": function($event) {
        return _vm.toScrollX('left')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-Arrowrightnext",
    on: {
      "click": function($event) {
        return _vm.toScrollX('right')
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "traggerSideBar",
    attrs: {
      "xs": 2,
      "sm": 2,
      "md": 1,
      "lg": 1
    }
  }, [_c('div', {
    staticClass: "listMenu flex flex-align-center flex-pack-center"
  }, [_c('div', {
    staticClass: "listMenuImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(825),
      "alt": "listMenu"
    }
  })])])]), _vm._v(" "), _c('el-col', {
    staticClass: "selfCenterBox",
    attrs: {
      "xs": 2,
      "sm": 2,
      "md": 1,
      "lg": 1
    }
  }, [_c('div', {
    staticClass: "selfCenter flex flex-align-center flex-pack-center"
  }, [_c('div', {
    staticClass: "headImg",
    attrs: {
      "title": "个人中心"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('changeSelfCenter', _vm.selfCenterBtn);
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-gerenzhongxin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "selfCenterCon",
    style: ({
      display: (_vm.selfCenterBtn ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('div', {
    staticClass: "msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("店铺名称：")]), _vm._v(" "), _c('span', {
    staticClass: "left itemVal",
    domProps: {
      "textContent": _vm._s(_vm.storeData.name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("地理位置：")]), _vm._v(" "), _c('span', {
    staticClass: "left itemVal",
    domProps: {
      "textContent": _vm._s(_vm.storeData.addr)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("创建时间：")]), _vm._v(" "), _c('span', {
    staticClass: "left itemVal"
  }, [_vm._v(_vm._s(_vm._f("numberToDate")(_vm.storeData.addTime, '')))])]), _vm._v(" "), _c('div', {
    staticClass: "msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("登录帐号：")]), _vm._v(" "), _c('span', {
    staticClass: "left itemVal",
    domProps: {
      "textContent": _vm._s(_vm.username)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-align-center flex-pack-center register-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "register"
  }, [_c('div', {
    staticClass: "returnBtn",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/login'
        })
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-return"
  })]), _vm._v(" "), _c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.status ? '重置密码' : '注册')
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register.apply(null, arguments)
      }
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "user",
    attrs: {
      "type": "tel",
      "placeholder": "请输入您的手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "code",
    attrs: {
      "type": "tel",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isGetCode) ? _c('span', {
    staticClass: "sendCode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.isGetCode) ? _c('span', {
    staticClass: "sendCode"
  }, [_vm._v(_vm._s(_vm.time + ' s'))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "getCodeTip",
    style: ({
      'visibility': (_vm.isShowCodeTip ? 'visible' : 'hidden')
    })
  }, [_vm._v("已发送验证码至您的手机")]), _vm._v(" "), _c('div', {
    staticClass: "confirmBtn"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    },
    domProps: {
      "textContent": _vm._s(_vm.status ? '提交' : '下一步')
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(828),
      "height": "56",
      "width": "184",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodsBigScreen",
    style: ({
      backgroundImage: ("url(" + _vm.backgroundImage + ")"),
      color: _vm.textColor
    }),
    attrs: {
      "id": "goodsBigScreen"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("制作中")]), _vm._v(" "), _c('div', {
    staticClass: "sub-tit"
  }, [_vm._v("PREPARING")]), _vm._v(" "), (_vm.ingOrder.length) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.ingOrder), function(it, ind) {
    return _c('span', {
      key: ind,
      staticClass: "item",
      class: {
        bold: _vm.isBold == 1
      }
    }, [_vm._v("\n        " + _vm._s(it.code) + "\n      ")])
  }), 0) : _c('div', {
    staticClass: "list no-data"
  }, [_vm._v("暂无数据...")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("请取餐")]), _vm._v(" "), _c('div', {
    staticClass: "sub-tit"
  }, [_vm._v("READY")]), _vm._v(" "), (_vm.deliveryOrder.length) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.deliveryOrder), function(it, ind) {
    return _c('span', {
      key: ind,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "cont",
      class: {
        bold: _vm.isBold == 1
      }
    }, [_vm._v("\n          " + _vm._s(it.code) + "\n          "), _c('div', {
      staticClass: "emp-name"
    }, [_vm._v("\n            (" + _vm._s(it.deliveryName ? ((it.deliveryName) + "~") : "") + _vm._s(it.tableNo ? ((it.tableNo) + "号机~") : "") + _vm._s(_vm.formatTime(it.makeTime)) + ")\n          ")])])])
  }), 0) : _c('div', {
    staticClass: "list no-data"
  }, [_vm._v("暂无数据...")]), _vm._v(" "), (_vm.showGetOrder) ? _c('div', {
    staticClass: "pls-get"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inner-wrap"
  }, [_c('div', {
    staticClass: "num"
  }, [_vm._v("\n          " + _vm._s(_vm.nowGetItem.code) + "\n          "), _c('div', {
    staticClass: "emp-name"
  }, [_vm._v(_vm._s(_vm.nowGetItem.deliveryName))])])])]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "submit-code",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkOrder.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "inp",
    attrs: {
      "id": "inp",
      "autofocus": "",
      "type": "password"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit-wrap"
  }, [_c('div', {
    staticClass: "pls-tit"
  }, [_vm._v("请取餐")]), _vm._v(" "), _c('div', {
    staticClass: "pls-sub-tit"
  }, [_vm._v("READY")])])
}]}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "daily-grade",
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goodCheckArr = []
      }
    }
  }, [_c('div', {
    staticClass: "daily-filter"
  }, [(_vm.nowType == 'DAY') ? _c('span', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('span', {
    staticClass: "filter-tit"
  }, [_vm._v("结账员工:")]), _vm._v(" "), _c('el-select', {
    staticClass: "new-inp",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.empMobile),
      callback: function($$v) {
        _vm.empMobile = $$v
      },
      expression: "empMobile"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": '全部',
      "value": ''
    }
  }), _vm._v(" "), _vm._l((_vm.emps), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.userName
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'DAY') ? _c('div', {
    staticClass: "date-filter"
  }, [_c('el-date-picker', {
    ref: "dateInput",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "placeholder": "请选择选择日期"
    },
    model: {
      value: (_vm.dateStr),
      callback: function($$v) {
        _vm.dateStr = $$v
      },
      expression: "dateStr"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-jiantou",
    on: {
      "click": function($event) {
        return _vm.$refs.dateInput.handleFocus()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'TIME_RANGE') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "filter-tit"
  }, [_vm._v("结账员工:")]), _vm._v(" "), _c('el-select', {
    staticClass: "new-inp",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.empMobile),
      callback: function($$v) {
        _vm.empMobile = $$v
      },
      expression: "empMobile"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": '全部',
      "value": ''
    }
  }), _vm._v(" "), _vm._l((_vm.emps), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.userName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "quick-filter"
  }, [_c('span', {
    class: _vm.nowSelFilter == 'today' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('today')
      }
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastDay' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastDay')
      }
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'week' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('week')
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastWeek' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastWeek')
      }
    }
  }, [_vm._v("上周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'month' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('month')
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastMonth' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastMonth')
      }
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "filter-tit"
  }, [_vm._v("商品名:")]), _vm._v(" "), _c('div', {
    staticClass: "search",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goods),
      expression: "goods"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.goods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goods = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.searchGoods
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search",
    style: ({
      display: (_vm.goodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.curGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.goodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item, 'search')
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)])]), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1) : _vm._e()]), _vm._v(" "), (_vm.showCharts) ? _c('div', {
    staticClass: "in-and-out clearfix"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("收入退单")]), _vm._v(" "), _c('div', {
    staticClass: "pie"
  }, [_c('div', {
    staticClass: "income left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPie),
      expression: "showPie"
    }],
    staticClass: "pie-for-income left",
    attrs: {
      "id": "income-pie"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPie),
      expression: "!showPie"
    }],
    staticClass: "no-income"
  }, [_c('span', [_vm._v("暂无任何收入数据")])])]), _vm._v(" "), _c('div', {
    staticClass: "out left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOutPie),
      expression: "showOutPie"
    }],
    staticClass: "pie-for-out left",
    attrs: {
      "id": "out-pie"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showOutPie),
      expression: "!showOutPie"
    }],
    staticClass: "no-income"
  }, [_c('span', [_vm._v("暂无任何退单数据")])])])])]) : _vm._e(), _vm._v(" "), (_vm.showList) ? _c('div', {
    staticClass: "in-and-out-list",
    style: (!_vm.showCharts ? 'margin-top:20px;' : '')
  }, [(_vm.showCharts) ? _c('div', {
    staticClass: "tit"
  }, [_vm._v("收入退单")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.gradeListData.length > 0) ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.gradeListData), function(item, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "index-count",
      staticStyle: {
        "width": "3%"
      }
    }, [(item.total < 0) ? _c('i', {
      staticClass: "iconfont icon-tui"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(index + 1 + (_vm.currentPage - 1) * _vm.pageSize) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(item.tableNo ? item.tableNo : "无"))]), _vm._v(" "), (item.amount < 0) ? [(!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.refundTime)))]) : _vm._e(), _vm._v(" "), (_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_c('div', [_vm._v(_vm._s(new Date(item.refundTime).Format("yyyy-MM-dd")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(new Date(item.refundTime).Format("hh:mm:ss")))])]) : _vm._e()] : [(!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.createTime)))]) : _vm._e(), _vm._v(" "), (_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_c('div', [_vm._v(_vm._s(new Date(item.createTime).Format("yyyy-MM-dd")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(new Date(item.createTime).Format("hh:mm:ss")))])]) : _vm._e()], _vm._v(" "), _c('td', {
      staticClass: "amount",
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(item.total))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(item.discount))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(item.removeZero))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.payType[item.paymentChannel]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(item.creatorName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(_vm.sourceType[item.source]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n            " + _vm._s(item.orderId) + "\n            "), _c('div', {
      staticStyle: {
        "font-size": "13px",
        "color": "#999"
      }
    }, [_vm._v("(支付单号:" + _vm._s(item.payOrderId) + ")")])]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "6%",
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showOrderDetail(item)
        }
      }
    }, [_vm._v("详情")])], 2)
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("暂无数据")])]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "loading"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单详情",
      "visible": _vm.doShowOrderDetail,
      "width": "9%"
    },
    on: {
      "update:visible": function($event) {
        _vm.doShowOrderDetail = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "300px",
      "overflow": "hidden",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("名称")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("金额")]), _vm._v(" "), _c('th', [_vm._v("会员名称")]), _vm._v(" "), _c('th', [_vm._v("会员号码")])]), _vm._v(" "), _vm._l((_vm.orderDetailData), function(item, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.memberName ? item.memberName : '无'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.mobile ? item.mobile : '无'))])])
  })], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("座号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("实收")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("应收")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("折扣")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("抹零")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("结账员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("订单来源")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("详情")])])])
}]}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voice-call"
  }, [_c('div', {
    staticClass: "info-cont"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("请选择店铺logo：")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.logoImgUrl ? _vm.logoImgUrl : ('https://hxypic.oss-cn-hangzhou.aliyuncs.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-img"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai",
    attrs: {
      "title": "上传图片"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "logo",
      "id": ""
    },
    on: {
      "change": _vm.cropImg
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("请填写店铺简介：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desc),
      expression: "desc"
    }],
    attrs: {
      "maxlength": "300",
      "name": "desc",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "这里填写店铺信息，字数限制在300字内。"
    },
    domProps: {
      "value": (_vm.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desc = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-count"
  }, [_vm._v(_vm._s(_vm.nowFontCount) + "/300")])]), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [_c('button', {
    on: {
      "click": _vm.uploadStoreInfo
    }
  }, [_vm._v("上传")])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left types",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "width": "500px"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "width": "80px"
    }
  }, [_vm._v("员工状态:")]), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "width": "130px"
    },
    model: {
      value: (_vm.employeeStatus),
      callback: function($$v) {
        _vm.employeeStatus = $$v
      },
      expression: "employeeStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("禁用")])], 1), _vm._v(" "), _c('span', [_c('el-input', {
    staticStyle: {
      "width": "230px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "请输入姓名或手机号进行搜索..."
    },
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加员工")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.employeeList.length > _vm.pageSize
    }
  }, _vm._l((_vm.employeeList), function(item) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_vm._v(_vm._s(item.mobile))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(item.groupName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [_vm._v(_vm._s(item.target))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "enabled",
      class: {
        fal: !item.enabled
      }
    }, [_vm._v(_vm._s(item.enabled ? '启用' : '禁用'))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "11%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('span', {
      staticClass: "enabled-btn",
      attrs: {
        "title": item.enabled ? '点击禁用' : '点击启用'
      },
      on: {
        "click": function($event) {
          return _vm.enabledEmployee(item)
        }
      }
    }, [_vm._v(_vm._s(item.enabled ? '禁用' : '启用'))]), _vm._v(" "), _c('span', {
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.getCurEmployee(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })])]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": '添加老板收款码',
      "visible": _vm.shopmanBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.shopmanBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left img_box clearfix",
    staticStyle: {
      "margin": "30px 0"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("收款码")]), _vm._v(" "), _c('div', {
    staticClass: "left img"
  }, [_c('div', {
    staticClass: "img_item left"
  }, [(_vm.shopman.wechatPayUrl) ? _c('img', {
    attrs: {
      "src": _vm.shopman.wechatPayUrl,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopman.wechatPayUrl) ? _c('span', {
    staticClass: "del-img",
    on: {
      "click": function($event) {
        return _vm.delImg('bossWechat')
      }
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img_up_btn left"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai"
  }), _vm._v(" "), _c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'shopmanWechatPayUrl')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mobileImgFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'shopmanWechatPayUrl')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left",
    staticStyle: {
      "width": "100%",
      "text-indent": "35%",
      "margin-top": "10px"
    }
  }, [_vm._v("\n                            微信\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "left img img_mobile"
  }, [_c('div', {
    staticClass: "img_item left"
  }, [(_vm.shopman.aliPayUrl) ? _c('img', {
    attrs: {
      "src": _vm.shopman.aliPayUrl,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopman.aliPayUrl) ? _c('span', {
    staticClass: "del-img",
    on: {
      "click": function($event) {
        return _vm.delImg('bossAli')
      }
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img_up_btn left"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai"
  }), _vm._v(" "), _c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'shopmanAliPayUrl')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mobileImgFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'shopmanAliPayUrl')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "left",
    staticStyle: {
      "width": "100%",
      "text-indent": "30%",
      "margin-top": "10px"
    }
  }, [_vm._v("\n                            支付宝\n                        ")])])])]), _vm._v(" "), (_vm.payUrlBtn) ? _c('div', {
    staticClass: "short_message"
  }, [_c('div', {
    staticClass: "disclaimer"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.disclaimer),
      callback: function($$v) {
        _vm.disclaimer = $$v
      },
      expression: "disclaimer"
    }
  }, [_vm._v("我已经详细阅读并同意")]), _c('span', {
    staticStyle: {
      "color": "#20a0ff",
      "margin-left": "5px"
    }
  }, [_vm._v("火星捕手使用许可及服务协议")])], 1)]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.shopmanBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.disclaimer) ? _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.shopmanFn
    }
  }, [_vm._v("保存")]) : _c('button', {
    staticClass: "cancel",
    staticStyle: {
      "margin-rignt": "0px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": _vm.isEdter ? '修改员工' : '添加员工',
      "visible": _vm.addEmplVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addEmplVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("工号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmployee.code),
      expression: "newEmployee.code"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入员工工号"
    },
    domProps: {
      "value": (_vm.newEmployee.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEmployee, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmployee.name),
      expression: "newEmployee.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入员工姓名"
    },
    domProps: {
      "value": (_vm.newEmployee.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEmployee, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmployee.mobile),
      expression: "newEmployee.mobile"
    }],
    staticClass: "left itemInput",
    style: ({
      display: (!_vm.isEdter ? 'block' : 'none')
    }),
    attrs: {
      "type": "text",
      "placeholder": "请输入员工电话"
    },
    domProps: {
      "value": (_vm.newEmployee.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEmployee, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmployee.mobile),
      expression: "newEmployee.mobile"
    }],
    staticClass: "left itemInput",
    style: ({
      display: (_vm.isEdter ? 'block' : 'none'),
      'border-color': (_vm.isEdter ? '#fff' : '#fff')
    }),
    attrs: {
      "type": "text",
      "placeholder": "请输入员工电话",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.newEmployee.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEmployee, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("岗位")]), _vm._v(" "), _c('el-select', {
    staticClass: "itemSelect",
    attrs: {
      "placeholder": "请选择员工岗位"
    },
    model: {
      value: (_vm.newEmployee.groupId),
      callback: function($$v) {
        _vm.$set(_vm.newEmployee, "groupId", $$v)
      },
      expression: "newEmployee.groupId"
    }
  }, _vm._l((_vm.jobsList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "45%"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("发放优惠券")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.newEmployee.sendCouponEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newEmployee, "sendCouponEnabled", $$v)
      },
      expression: "newEmployee.sendCouponEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.newEmployee.sendCouponEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newEmployee, "sendCouponEnabled", $$v)
      },
      expression: "newEmployee.sendCouponEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.deliveryEnabled) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v("是否允许配送")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newEmployee.deliveryEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newEmployee, "deliveryEnabled", $$v)
      },
      expression: "newEmployee.deliveryEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newEmployee.deliveryEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newEmployee, "deliveryEnabled", $$v)
      },
      expression: "newEmployee.deliveryEnabled"
    }
  }, [_vm._v("否")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("销售目标")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmployee.target),
      expression: "newEmployee.target"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入员工销售目标"
    },
    domProps: {
      "value": (_vm.newEmployee.target)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newEmployee, "target", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left img_box clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("员工头像")]), _vm._v(" "), _c('div', {
    staticClass: "left img"
  }, [_c('div', {
    staticClass: "img_item left"
  }, [(_vm.newEmployee.photo) ? _c('img', {
    attrs: {
      "src": _vm.newEmployee.photo,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img_up_btn left"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai"
  }), _vm._v(" "), _c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'avatar')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mobileImgFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'avatar')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left",
    staticStyle: {
      "width": "100%",
      "text-indent": "35%",
      "margin-top": "10px"
    }
  }, [_vm._v("\n                            员工头像\n                       ")])])])]), _vm._v(" "), (_vm.isEdter && _vm.payUrlBtn) ? _c('div', {
    staticClass: "short_message"
  }, [_c('div', {
    staticClass: "disclaimer"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.disclaimer),
      callback: function($$v) {
        _vm.disclaimer = $$v
      },
      expression: "disclaimer"
    }
  }, [_vm._v("我已经详细阅读并同意")]), _c('span', {
    staticStyle: {
      "color": "#20a0ff",
      "margin-left": "5px"
    }
  }, [_vm._v("火星捕手使用许可及服务协议")])], 1)]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button",
      "id": "employeeCancel"
    },
    on: {
      "click": function($event) {
        _vm.addEmplVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.disclaimer) ? _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button",
      "id": "employeeSave"
    },
    on: {
      "click": _vm.addEmployee
    }
  }, [_vm._v("保存")]) : _c('button', {
    staticClass: "cancel",
    staticStyle: {
      "margin-rignt": "0px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "codes",
    attrs: {
      "title": '验证码',
      "visible": _vm.codeBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.codeBtn = $event
      }
    }
  }, [(!_vm.isSendCodeBtn) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px",
      "font-size": "12px",
      "text-align": "center",
      "position": "absolute",
      "top": "8px",
      "left": "7em"
    }
  }, [_c('span', [_vm._v("验证码已发送到老板手机号")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("验证成功后5分钟内有效，请及时操作")])]), _vm._v(" "), _c('div', {
    staticClass: "inners"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isSendCodeBtn) ? _c('span', {
    staticClass: "sendcode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (!_vm.isSendCodeBtn) ? _c('span', {
    staticClass: "times",
    domProps: {
      "textContent": _vm._s(_vm.isSendCodeTimer + 's')
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button",
      "id": "employeeCodeSave"
    },
    on: {
      "click": function($event) {
        _vm.codeBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button",
      "id": "employeeCodeSave"
    },
    on: {
      "click": _vm.codeFn
    }
  }, [_vm._v("提交")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right tip flex flex-align-center"
  }, [_c('i', {
    staticClass: "iconfont icon-caution"
  }), _vm._v(" "), _c('span', [_vm._v("员工默认密码为：123456，请尽快修改")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("工号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("电话")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("岗位")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("销售目标(元)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "achievement"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'month') ? _c('div', {
    staticClass: "left monthBox clearfix"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.cutMonth(0)
      }
    }
  }, [_vm._v("上一月")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "left",
    attrs: {
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    on: {
      "change": _vm.cutDataFn
    },
    model: {
      value: (_vm.yearMonth),
      callback: function($$v) {
        _vm.yearMonth = $$v
      },
      expression: "yearMonth"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.cutMonth(1)
      }
    }
  }, [_vm._v("下一月")])], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'timeRange') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "quick-filter"
  }, [_c('span', {
    class: _vm.nowSelFilter == 'today' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('today')
      }
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastDay' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastDay')
      }
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'week' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('week')
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastWeek' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastWeek')
      }
    }
  }, [_vm._v("上周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'month' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('month')
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastMonth' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastMonth')
      }
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.achieveArr.length > _vm.pageSize
    }
  }, _vm._l((_vm.achieveArr), function(item) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.employeeCode)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.employeeName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "13%"
      },
      domProps: {
        "textContent": _vm._s(item.groupName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      },
      domProps: {
        "textContent": _vm._s(item.orderCount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      },
      domProps: {
        "textContent": _vm._s(item.target)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "achievement-name",
      staticStyle: {
        "width": "14%"
      },
      domProps: {
        "textContent": _vm._s(item.totalAmount)
      },
      on: {
        "click": function($event) {
          return _vm.openMoneyDetail(item)
        }
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.addMemberNumber)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "achievement-name",
      staticStyle: {
        "width": "14%"
      },
      domProps: {
        "textContent": _vm._s(item.totalCommission)
      },
      on: {
        "click": function($event) {
          _vm.curPage = 1;
          _vm.commissionDetail(item)
        }
      }
    })])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "out-excel"
  }, [_c('div', {}, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '本月业绩  ' + _vm.employeeInfo.employeeName,
      "visible": _vm.openLoss,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.openLoss = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "mobile-style"
    }
  }, [_c('div', {
    staticClass: "lossTotal flex flex-align-center"
  }, [_c('span', {
    staticClass: "span1"
  }, [_vm._v("总计")]), _c('span', {
    staticClass: "span2 blue",
    domProps: {
      "textContent": _vm._s(_vm.employeeInfo.productCount)
    }
  }), _c('span', {
    staticClass: "span3"
  }, [_vm._v("件商品")]), _vm._v(" "), _c('span', {
    staticClass: "span1"
  }, [_vm._v("合计")]), _c('span', {
    staticClass: "span2 red"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.employeeInfo.totalAmount)))]), _vm._v(" "), _c('span', {
    staticClass: "span3"
  }, [_vm._v("元")])]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "goodList"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "idx left color1"
  }, [_vm._v("序号")]), _vm._v(" "), _c('span', {
    staticClass: "data left color1"
  }, [_vm._v("时间")]), _vm._v(" "), _c('span', {
    staticClass: "name left color1"
  }, [_vm._v("订单号")]), _vm._v(" "), _c('span', {
    staticClass: "number left color1"
  }, [_vm._v("提成金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "space1"
  }), _vm._v(" "), _c('ul', {
    staticClass: "goodList"
  }, _vm._l((_vm.commissionOrder), function(item, ind) {
    return _c('li', {
      staticClass: "clearfix lis"
    }, [_c('span', {
      staticClass: "idx left",
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "data left"
    }, [_vm._v(_vm._s(_vm._f("numberToAllDate")(item.paymentTime, '')))]), _vm._v(" "), _c('span', {
      staticClass: "name left",
      domProps: {
        "textContent": _vm._s(item.code)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "number left"
    }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(item.commission)))])])
  }), 0)])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '本月营业额 ' + _vm.nowMoneyDetailName,
      "visible": _vm.moneyDetail,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.moneyDetail = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "mobile-style"
    }
  }, [_c('div', {
    staticClass: "space1",
    staticStyle: {
      "width": "100%",
      "height": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "idx left color1",
    staticStyle: {
      "width": "50%",
      "text-align": "left"
    }
  }, [_vm._v("分类名称")]), _vm._v(" "), _c('span', {
    staticClass: "data left color1",
    staticStyle: {
      "width": "10%",
      "text-align": "center"
    }
  }, [_vm._v("销售数量")]), _vm._v(" "), _c('span', {
    staticClass: "number left color1",
    staticStyle: {
      "width": "20%",
      "text-align": "center"
    }
  }, [_vm._v("销售金额")]), _vm._v(" "), _c('span', {
    staticClass: "number left color1",
    staticStyle: {
      "width": "20%",
      "text-align": "center"
    }
  }, [_vm._v("提成金额")])]), _vm._v(" "), _c('div', {
    staticClass: "space1",
    staticStyle: {
      "width": "100%",
      "height": "15px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('ul', {
    staticClass: "goodList"
  }, _vm._l((_vm.moneyDetailData), function(item, ind) {
    return _c('li', {
      staticClass: "clearfix lis p",
      on: {
        "click": function($event) {
          return _vm.doShowChild(ind)
        }
      }
    }, [_c('span', {
      staticClass: "idx left",
      staticStyle: {
        "width": "50%",
        "text-align": "left"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "data left",
      staticStyle: {
        "width": "10%",
        "text-align": "center"
      }
    }, [_vm._v("\n                                        " + _vm._s(item.qty) + "\n                                        "), (item.data && item.diffQty) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": ("其中包含" + (item.typeName) + "一级分类下的商品销售数：" + (item.diffQty)),
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "wen"
    }, [_vm._v("?")])]) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "number left",
      staticStyle: {
        "width": "20%",
        "text-align": "center"
      }
    }, [_vm._v("\n                                        ￥" + _vm._s(item.amount.toFixed(2)) + "\n                                        "), (item.data && item.diffAmount) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": ("其中包含" + (item.typeName) + "一级分类下的商品销售金额：" + (item.diffAmount.toFixed(2))),
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "wen"
    }, [_vm._v("?")])]) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "number left",
      staticStyle: {
        "width": "20%",
        "text-align": "center"
      }
    }, [_vm._v("\n                                        ￥" + _vm._s(item.commission.toFixed(2)) + "\n                                        "), (item.data && item.diffCommission) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": ("其中包含" + (item.typeName) + "一级分类下的提成金额：" + (item.diffCommission.toFixed(2))),
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "wen"
    }, [_vm._v("?")])]) : _vm._e()], 1), _vm._v(" "), (item.data && Array.isArray(item.data) && item.data.length) ? _c('div', {
      staticClass: "child",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, _vm._l((item.data), function(cIt, cInd) {
      return _c('li', {
        staticClass: "clearfix lis"
      }, [_c('span', {
        staticClass: "idx left",
        staticStyle: {
          "width": "50%",
          "text-align": "left"
        }
      }, [_vm._v("---" + _vm._s(cIt.typeName))]), _vm._v(" "), _c('span', {
        staticClass: "data left",
        staticStyle: {
          "width": "10%",
          "text-align": "center"
        }
      }, [_vm._v(_vm._s(cIt.qty))]), _vm._v(" "), _c('span', {
        staticClass: "number left",
        staticStyle: {
          "width": "20%",
          "text-align": "center"
        },
        domProps: {
          "textContent": _vm._s('￥' + cIt.amount.toFixed(2))
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "number left",
        staticStyle: {
          "width": "20%",
          "text-align": "center"
        },
        domProps: {
          "textContent": _vm._s('￥' + cIt.commission.toFixed(2))
        }
      })])
    }), 0) : _vm._e()])
  }), 0)])])])])], 1)]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("工号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("岗位")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("总订单量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("销售目标(元)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("总营业额(元)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("推荐会员数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("提成金额(元)")])])])
}]}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "setBox"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("系统设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("是否开启系统网费开关：")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.customSwitch),
      callback: function($$v) {
        _vm.customSwitch = $$v
      },
      expression: "customSwitch"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.customSwitch),
      callback: function($$v) {
        _vm.customSwitch = $$v
      },
      expression: "customSwitch"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('span', {
    staticClass: "left tip"
  }, [_vm._v("（推荐网吧开启）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "setItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("是否开启退单授权密码验证：")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.refundSwitch),
      callback: function($$v) {
        _vm.refundSwitch = $$v
      },
      expression: "refundSwitch"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.refundSwitch),
      callback: function($$v) {
        _vm.refundSwitch = $$v
      },
      expression: "refundSwitch"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "setItem clearfix",
    staticStyle: {
      "height": "36px",
      "line-height": "36px"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("新增会员派发优惠券：")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.couponSwitch),
      callback: function($$v) {
        _vm.couponSwitch = $$v
      },
      expression: "couponSwitch"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.couponSwitch),
      callback: function($$v) {
        _vm.couponSwitch = $$v
      },
      expression: "couponSwitch"
    }
  }, [_vm._v("否")]), _vm._v(" "), (_vm.couponSwitch == 'ON') ? _c('el-select', {
    staticClass: "left",
    staticStyle: {
      "margin-left": "10px"
    },
    model: {
      value: (_vm.couponModel),
      callback: function($$v) {
        _vm.couponModel = $$v
      },
      expression: "couponModel"
    }
  }, [_vm._l((_vm.couponList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": JSON.stringify(item)
      }
    })
  }), _vm._v(" "), (_vm.couponListMoreBtn) ? _c('li', {
    staticStyle: {
      "color": "#999",
      "padding": "10px 0",
      "text-align": "center",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('span', [_vm._v("更多优惠券...")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.couponSwitch == 'ON') ? _c('p', {
    staticClass: "left",
    staticStyle: {
      "color": "#fff",
      "text-align": "center",
      "cursor": "pointer",
      "margin-left": "20px",
      "background-color": "#3068ff",
      "width": "80px",
      "border-radius": "20px"
    },
    on: {
      "click": _vm.configCoupon
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("店铺设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺名称：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.name),
      expression: "newStore.name"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入店铺名"
    },
    domProps: {
      "value": (_vm.newStore.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺类型：")]), _vm._v(" "), _c('el-select', {
    staticClass: "left",
    attrs: {
      "placeholder": "请选择店铺类型"
    },
    model: {
      value: (_vm.newStore.typeId),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "typeId", $$v)
      },
      expression: "newStore.typeId"
    }
  }, _vm._l((_vm.storeType), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺地址：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.addr),
      expression: "newStore.addr"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入地址"
    },
    domProps: {
      "value": (_vm.newStore.addr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "addr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveStore
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("呼叫设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("呼叫热栏信息标题：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotTitle),
      expression: "hotTitle"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入...(如近期热销、最近更新、等等...)"
    },
    domProps: {
      "value": (_vm.hotTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hotTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("呼叫滚动信息标题：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rollTitle),
      expression: "rollTitle"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "（默认为打赏排名）请输入...(如网吧公告，等...)"
    },
    domProps: {
      "value": (_vm.rollTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rollTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("*修改为打赏排名将展示打赏排名信息")])]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix desc"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("呼叫滚动信息：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rollNotice),
      expression: "rollNotice"
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "请输入呼叫滚动信息..."
    },
    domProps: {
      "value": (_vm.rollNotice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rollNotice = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix desc"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺简介：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.summary),
      expression: "summary"
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "请输入店铺简介..."
    },
    domProps: {
      "value": (_vm.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.summary = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix logo"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺logo：")]), _vm._v(" "), (_vm.logoUrl) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "logoUrl",
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'logo')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("*请裁剪为正方形")])]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix logo"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺二维码：")]), _vm._v(" "), (_vm.storeQrCode) ? _c('img', {
    attrs: {
      "src": _vm.storeQrCode,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "storeQrCode",
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'storeQrCode')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("*店铺联系人二维码(此二维码将展示在呼叫客户端)")])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveCallInfo
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("会员充值设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("会员充值最低限额：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.limitRechargeMoney),
      expression: "limitRechargeMoney"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.limitRechargeMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.limitRechargeMoney = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveLimit
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("店铺是否开启配送员")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.deliveryEnabled),
      callback: function($$v) {
        _vm.deliveryEnabled = $$v
      },
      expression: "deliveryEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.deliveryEnabled),
      callback: function($$v) {
        _vm.deliveryEnabled = $$v
      },
      expression: "deliveryEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.deliveryEnabled) ? _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("原有提成的占比：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalRate),
      expression: "globalRate"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.globalRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalRate = $event.target.value
      }
    }
  }), _vm._v("%\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveDelivery
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户端是否开启会员支付")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.memberEnabled),
      callback: function($$v) {
        _vm.memberEnabled = $$v
      },
      expression: "memberEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.memberEnabled),
      callback: function($$v) {
        _vm.memberEnabled = $$v
      },
      expression: "memberEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveMem
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("授权密码设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountPwd),
      expression: "discountPwd"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.discountPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discountPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePwd
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否允许PC点单")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.pcOrderEnabled),
      callback: function($$v) {
        _vm.pcOrderEnabled = $$v
      },
      expression: "pcOrderEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.pcOrderEnabled),
      callback: function($$v) {
        _vm.pcOrderEnabled = $$v
      },
      expression: "pcOrderEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePcOrderEnabled
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否开启音频设备选择")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.voiceEnabled),
      callback: function($$v) {
        _vm.voiceEnabled = $$v
      },
      expression: "voiceEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.voiceEnabled),
      callback: function($$v) {
        _vm.voiceEnabled = $$v
      },
      expression: "voiceEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveIsOpenVoiceSel
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否开启租赁设备归还语音播报")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.returnCallEnabled),
      callback: function($$v) {
        _vm.returnCallEnabled = $$v
      },
      expression: "returnCallEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.returnCallEnabled),
      callback: function($$v) {
        _vm.returnCallEnabled = $$v
      },
      expression: "returnCallEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveReturnCallEnabled
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否开启交班预打印小票")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.isOpenPrevPrint),
      callback: function($$v) {
        _vm.isOpenPrevPrint = $$v
      },
      expression: "isOpenPrevPrint"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.isOpenPrevPrint),
      callback: function($$v) {
        _vm.isOpenPrevPrint = $$v
      },
      expression: "isOpenPrevPrint"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveIsOpenPrevPrint
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否允许收银端下架商品")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.allowProductCancelSale),
      callback: function($$v) {
        _vm.allowProductCancelSale = $$v
      },
      expression: "allowProductCancelSale"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.allowProductCancelSale),
      callback: function($$v) {
        _vm.allowProductCancelSale = $$v
      },
      expression: "allowProductCancelSale"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveAllowProductCancelSale
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("厨房打印机IP设置"), _c('button', {
    staticClass: "add-more",
    on: {
      "click": function($event) {
        return _vm.printEr.push({
          id: '',
          name: '',
          ipAddress: '',
          port: ''
        })
      }
    }
  }, [_vm._v("添加更多打印机")])]), _vm._v(" "), _vm._l((_vm.printEr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setItem_1 clearfix"
    }, [_c('div', {
      staticClass: "left itemName"
    }, [_vm._v("打印机名字:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "120px",
        "text-align": "center",
        "padding-left": "0"
      },
      attrs: {
        "type": "text",
        "placeholder": "自定义打印机名字"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "left itemName"
    }, [_vm._v(" IP地址:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ipAddress),
        expression: "item.ipAddress"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "120px",
        "text-align": "center",
        "padding-left": "0"
      },
      attrs: {
        "type": "text",
        "placeholder": "请输入IP地址"
      },
      domProps: {
        "value": (item.ipAddress)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ipAddress", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "left itemName"
    }, [_vm._v(" 端口号:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.port),
        expression: "item.port"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "120px",
        "text-align": "center",
        "padding-left": "0"
      },
      attrs: {
        "type": "text",
        "placeholder": "请输入端口号"
      },
      domProps: {
        "value": (item.port)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "port", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "margin-left": "15px"
      },
      on: {
        "click": function($event) {
          return _vm.savePrintEr(item)
        }
      }
    }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.delPrintEr(item, index)
        }
      }
    }, [_vm._v("删除")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("点单备注信息设置"), _c('button', {
    staticClass: "add-more",
    on: {
      "click": function($event) {
        return _vm.notesArr.push({
          id: '',
          message: ''
        })
      }
    }
  }, [_vm._v("添加更多备注")])]), _vm._v(" "), _vm._l((_vm.notesArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setItem_1 clearfix"
    }, [_c('div', {
      staticClass: "left itemName"
    }, [_vm._v("内容:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.message),
        expression: "item.message"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "350px",
        "text-align": "left",
        "padding-left": "0"
      },
      attrs: {
        "type": "text",
        "placeholder": "请填写备注内容..."
      },
      domProps: {
        "value": (item.message)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "message", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "margin-left": "15px"
      },
      on: {
        "click": function($event) {
          return _vm.saveNotes(item)
        }
      }
    }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.delNotes(item)
        }
      }
    }, [_vm._v("删除")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("机位预订时间设置"), _c('button', {
    staticClass: "add-more",
    on: {
      "click": function($event) {
        return _vm.timeArr.push({
          id: '',
          m: ''
        })
      }
    }
  }, [_vm._v("添加更多时间")])]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_vm._v("\n                        是否开启店员宝机位预订\n                        "), _c('el-radio', {
    staticClass: "radio itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.dateOpen),
      callback: function($$v) {
        _vm.dateOpen = $$v
      },
      expression: "dateOpen"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.dateOpen),
      callback: function($$v) {
        _vm.dateOpen = $$v
      },
      expression: "dateOpen"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_vm._v("\n                        是否开启下机播报\n                        "), _c('el-radio', {
    staticClass: "radio itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.voiceNotify),
      callback: function($$v) {
        _vm.voiceNotify = $$v
      },
      expression: "voiceNotify"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.voiceNotify),
      callback: function($$v) {
        _vm.voiceNotify = $$v
      },
      expression: "voiceNotify"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.voiceNotify) ? _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frontMessage),
      expression: "frontMessage"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "自定义内容..."
    },
    domProps: {
      "value": (_vm.frontMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.frontMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left itemName"
  }, [_vm._v("**号机已下机")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.backMessage),
      expression: "backMessage"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "自定义内容..."
    },
    domProps: {
      "value": (_vm.backMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.backMessage = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.timeArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setItem_1 clearfix"
    }, [_c('div', {
      staticClass: "left itemName"
    }, [_vm._v("时间（分钟）:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.m),
        expression: "item.m"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "number",
        "placeholder": "请填写时间（分钟）..."
      },
      domProps: {
        "value": (item.m)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "m", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.delTime(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveTime
    }
  }, [_vm._v("保存")])])], 2)])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "codes",
    attrs: {
      "title": '验证码',
      "visible": _vm.codeBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.codeBtn = $event
      },
      "close": _vm.closeDialog
    }
  }, [(!_vm.isSendCodeBtn) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px",
      "font-size": "12px",
      "text-align": "center",
      "position": "absolute",
      "top": "8px",
      "left": "7em"
    }
  }, [_c('span', [_vm._v("验证码已发送到老板手机号")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inners"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isSendCodeBtn) ? _c('span', {
    staticClass: "sendcode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("发送验证码")]) : _vm._e(), _vm._v(" "), (!_vm.isSendCodeBtn) ? _c('span', {
    staticClass: "times",
    domProps: {
      "textContent": _vm._s(_vm.isSendCodeTimer + 's')
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.codeBtn = false;
        _vm.code = '';
        _vm.initBtn4 = true;
        _vm.isCancle = true
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.codeFn
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("\n                        区域分类\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      style: ({
        height: (item.isOpen && _vm.btn ? ((item.children.length + 1) * 9 + '%') : '9%')
      })
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      style: ({
        height: (item.isOpen && _vm.btn ? (100 / (item.children.length + 1) + '%') : '100%')
      })
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      on: {
        "click": function($event) {
          return _vm.handle(item, ind)
        }
      }
    }, [_c('i', {
      staticClass: "i",
      class: {
        'el-icon-caret-right': item.children.length && (!item.isOpen || !_vm.btn),
        'el-icon-caret-bottom': item.children.length && (!item.isOpen || _vm.btn)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "parent_default type_name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right ss flex flex-align-center flex-pack-center"
    }), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center",
      staticStyle: {
        "width": "70px",
        "display": "flex"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])]), _vm._v(" "), (item.isOpen && _vm.btn) ? _c('div', {
      staticClass: "type_child",
      style: ({
        height: (100 - 100 / (item.children.length + 1) + '%')
      })
    }, _vm._l((item.children), function(oitem, oInd) {
      return _c('div', {
        staticClass: "type_child_item",
        style: ({
          height: (100 / (item.children.length) + '%')
        })
      }, [_c('div', {
        staticClass: "type_child_left left flex flex-align-center"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(oitem.name)
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "flex",
          "margin-right": "170px"
        }
      }, [_c('span', {
        staticClass: "left",
        staticStyle: {
          "font-size": "14px",
          "padding-right": "100px",
          "white-space": "nowrap"
        }
      }, [_vm._v("IP地址：" + _vm._s(oitem.ipAddress))]), _vm._v(" "), _c('span', {
        staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
      }, [_c('i', {
        staticClass: "iconfont icon-bianji",
        staticStyle: {
          "padding-right": "10px",
          "cursor": "pointer"
        },
        attrs: {
          "title": "修改"
        },
        on: {
          "click": function($event) {
            return _vm.modifySite(item, oitem)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "iconfont icon-icon1460188478041",
        staticStyle: {
          "padding-right": "10px",
          "cursor": "pointer"
        },
        attrs: {
          "title": "删除"
        },
        on: {
          "click": function($event) {
            return _vm.delSite(item, oitem)
          }
        }
      })])])])
    }), 0) : _vm._e()])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑",
      "visible": _vm.addJobVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "130px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("区域分类名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.name),
      expression: "obj.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.obj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "批量添加机位",
      "visible": _vm.showModifySiteBatch
    },
    on: {
      "update:visible": function($event) {
        _vm.showModifySiteBatch = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("起始IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBatchSite.beginIp),
      expression: "newBatchSite.beginIp"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "如：192.168.1.1"
    },
    domProps: {
      "value": (_vm.newBatchSite.beginIp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBatchSite, "beginIp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "110px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("生成机位数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBatchSite.count),
      expression: "newBatchSite.count"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "placeholder": "如:50"
    },
    domProps: {
      "value": (_vm.newBatchSite.count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBatchSite, "count", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModifySiteBatch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doAddNewSiteBatch
    }
  }, [_vm._v("生成")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑机位",
      "visible": _vm.showModifySite
    },
    on: {
      "update:visible": function($event) {
        _vm.showModifySite = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("机位名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSite.name),
      expression: "newSite.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.newSite.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSite, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSite.ipAddress),
      expression: "newSite.ipAddress"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.newSite.ipAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSite, "ipAddress", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModifySite = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doAddNewSite
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', [_vm._v("区域分类名称")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topUp"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix",
    attrs: {
      "id": "topUp-pc"
    }
  }, [_c('div', {
    staticClass: "left invTopItem flex flex-align-center"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('span', {
    staticClass: "num",
    domProps: {
      "textContent": _vm._s(_vm.storeData.name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left invTopItem flex flex-align-center"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("当前版本")]), _vm._v(" "), _c('span', {
    staticClass: "num",
    domProps: {
      "textContent": _vm._s(_vm.storeLV[_vm.storeData.level])
    }
  }, [_vm._v("基础版")])]), _vm._v(" "), _c('div', {
    staticClass: "left invTopItem flex flex-align-center"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("到期日期")]), _vm._v(" "), (_vm.storeData.level !== 'ONE') ? _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm._f("numberToAllDate")(_vm.storeData.expireTime, '')))]) : _c('span', {
    staticClass: "num"
  }, [_vm._v("无限")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "topUpItem clearfix"
  }, [_c('div', {
    staticClass: "name left"
  }, [_vm._v("购买版本：")]), _vm._v(" "), _c('div', {
    staticClass: "hand left"
  }, [(_vm.storeData.level != 'THREE') ? _c('span', {
    staticClass: "edition",
    class: {
      'cur-edition': _vm.curLV == 'TWO'
    },
    on: {
      "click": function($event) {
        return _vm.cutEdition('TWO')
      }
    }
  }, [_vm._v("基础版")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "edition",
    class: {
      'cur-edition': _vm.curLV == 'THREE' || _vm.curLV == 'ONE'
    },
    on: {
      "click": function($event) {
        return _vm.cutEdition('THREE')
      }
    }
  }, [_vm._v("高级版")]), _vm._v(" "), (_vm.storeData.level == 'TWO') ? _c('span', {
    staticClass: "edition",
    class: {
      'cur-edition': _vm.curLV == 'UP'
    },
    on: {
      "click": function($event) {
        return _vm.cutEdition('UP')
      }
    }
  }, [_vm._v("升为高级")]) : _vm._e()])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "topUpItem clearfix"
  }, [_c('div', {
    staticClass: "name left"
  }, [_vm._v("单价（元/年）：")]), _vm._v(" "), _c('div', {
    staticClass: "hand left",
    staticStyle: {
      "color": "#f76260"
    },
    domProps: {
      "textContent": _vm._s(_vm.curMoney[_vm.curLV])
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "topUpItem clearfix"
  }, [_c('div', {
    staticClass: "name left"
  }, [_vm._v("选择支付方式：")]), _vm._v(" "), _c('div', {
    staticClass: "hand left"
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "false"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_vm._v("微信")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "true"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_vm._v("支付宝")])], 1), _vm._v(" "), _c('div', {
    staticClass: "topUpItemBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createdCode
    }
  }, [_vm._v("充值续费")])], 1)])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "升为高级版",
      "visible": _vm.upLvBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.upLvBtn = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "topupQrcode"
    }
  }, [_vm._v("\n           4545\n        ")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请扫描二维码支付",
      "visible": _vm.addEmplVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addEmplVisible = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "topupQrcode"
    }
  }, [(_vm.num < 30) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.num == 30) ? _c('div', {
    staticClass: "expire"
  }, [_c('p', {
    staticClass: "position-middle-center"
  }, [_vm._v("二维码已过期")])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topUpItem clearfix"
  }, [_c('div', {
    staticClass: "name left"
  }, [_vm._v("购买时长：")]), _vm._v(" "), _c('div', {
    staticClass: "hand left"
  }, [_vm._v("\n                       默认一年\n                    ")])])
}]}

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "store"
  }, [_c('div', {
    staticClass: "returnBtn",
    on: {
      "click": _vm.returnToLogin
    }
  }, [_c('i', {
    staticClass: "iconfont icon-return"
  }), _vm._v("返回")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "storeListBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请选择你的店铺")]), _vm._v(" "), _c('div', {
    staticClass: "storeScrollBox"
  }, [_c('ul', {
    staticClass: "storeList"
  }, _vm._l((_vm.storeList), function(item, idx) {
    return _c('li', {
      class: {
        active: _vm.curIndex == idx
      },
      on: {
        "mousemove": function($event) {
          _vm.curIndex = idx
        },
        "click": function($event) {
          return _vm.enterSystem(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "add"
  }, [_c('div', {
    staticClass: "addBtn"
  }, [_c('i', {
    staticClass: "iconfont icon-icon02",
    on: {
      "click": function () {
        _vm.$router.push({
          path: '/addStore'
        })
      }
    }
  }), _c('span', {
    on: {
      "click": function () {
        _vm.$router.push({
          path: '/addStore'
        })
      }
    }
  }, [_vm._v("添加店铺")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(254),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("基于云计算SaaS模式")]), _vm._v(" "), _c('p', [_vm._v("收银、营销一体化服务平台")])])
}]}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-screen",
    attrs: {
      "id": "bigScreen"
    }
  }, [_c('div', {
    staticClass: "modify-wrap"
  }, [_c('el-button', {
    staticClass: "upLoad",
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.coverImg
    }
  }, [_c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v("上传背景")]), _vm._v(" "), _c('span', {
    staticClass: "txt-color"
  }, [_vm._v("填写或选择机位占用颜色:\n      "), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "机位颜色值..."
    },
    model: {
      value: (_vm.form.computerFillColor),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerFillColor", $$v)
      },
      expression: "form.computerFillColor"
    }
  }), _vm._v(" "), _c('el-color-picker', {
    on: {
      "change": _vm.changeComputerColor
    },
    model: {
      value: (_vm.form.computerFillColor),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerFillColor", $$v)
      },
      expression: "form.computerFillColor"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "txt-color"
  }, [_vm._v("填写或选择字体颜色:\n      "), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "字体颜色值..."
    },
    model: {
      value: (_vm.form.computerTextColor),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerTextColor", $$v)
      },
      expression: "form.computerTextColor"
    }
  }), _vm._v(" "), _c('el-color-picker', {
    on: {
      "change": _vm.changeComputerTextColor
    },
    model: {
      value: (_vm.form.computerTextColor),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerTextColor", $$v)
      },
      expression: "form.computerTextColor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "size",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("机位样式大小：")]), _vm._v(" "), _c('el-slider', {
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "min": 0,
      "max": 500,
      "show-input": ""
    },
    on: {
      "change": _vm.changeComputerNodeSize
    },
    model: {
      value: (_vm.form.computerNodeSize),
      callback: function($$v) {
        _vm.$set(_vm.form, "computerNodeSize", $$v)
      },
      expression: "form.computerNodeSize"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doShowDrawer.apply(null, arguments)
      }
    }
  }, [_vm._v("选择机位")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制大屏链接")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openBigScreen
    }
  }, [_vm._v("查看大屏")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "opacity": "0"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openBigScreenForAd
    }
  }, [_vm._v("大屏")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "0",
      "height": "0",
      "font-size": "0",
      "opacity": "0"
    },
    attrs: {
      "id": "copyData"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.bigScreenUrl) + "\n    ")]), _vm._v(" "), (!_vm.noData) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v("\n      双击机位图标可进行旋转和键盘细微移动，右键可进行删除\n    ")]) : _vm._e(), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v("暂未上传任何机位大屏信息")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "out-wrap",
    style: (_vm.showDrawer ? 'padding-right:450px' : '')
  }, [_c('div', {
    staticClass: "canvas-wrap",
    attrs: {
      "id": "canvasWrap"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "context-menu",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "del",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delNode.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
    staticClass: "context-menu-extra",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "del",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addExtra('text')
      }
    }
  }, [_vm._v("插入文本")]), _vm._v(" "), _c('div', {
    staticClass: "del",
    staticStyle: {
      "border-top": "1px solid #ddd"
    }
  }, [_c('input', {
    staticClass: "upImage",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.upImage
    }
  }), _vm._v("\n        插入图片\n      ")])])]), _vm._v(" "), (_vm.showDrawer) ? _c('div', {
    staticClass: "drawer-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "inner-wrap"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("选择机位")]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDrawer = false
      }
    }
  }, [_vm._v("关闭")])]), _vm._v(" "), _c('div', {
    staticClass: "drawer-cont"
  }, [_c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.sites), function(it, ind) {
    return _c('el-collapse-item', {
      key: ind,
      attrs: {
        "title": ("" + (it.name)),
        "name": ("" + (it.id))
      }
    }, _vm._l((it.nums), function(ite, inde) {
      return _c('div', {
        key: ("c_" + inde),
        staticClass: "site-img"
      }, [_c('img', {
        attrs: {
          "draggable": "true",
          "src": "/static/bigScreen/assets/computer_free.png",
          "data-ipAddress": ("" + (ite.ipAddress)),
          "data-ipNo": ("" + (_vm.computedIpNo(ite.ipAddress))),
          "data-fillName": ("" + (_vm.computedIpNo(ite.name))),
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "ip"
      }, [_vm._v(_vm._s(ite.ipAddress))])])
    }), 0)
  }), 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showExtra) ? _c('div', {
    staticClass: "my-dialog",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showExtra = false;
      }
    }
  }, [_c('div', {
    staticClass: "inner-dialog",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.extraType == 'text') ? [_c('div', {
    staticClass: "cont-item"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("请输入文本内容：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.textVal),
      callback: function($$v) {
        _vm.textVal = $$v
      },
      expression: "textVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cont-item"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("请选择字体颜色：")]), _vm._v(" "), _c('el-color-picker', {
    model: {
      value: (_vm.textColor),
      callback: function($$v) {
        _vm.textColor = $$v
      },
      expression: "textColor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cont-item"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("字体效果：")]), _vm._v(" "), _c('div', {
    style: (("color:" + _vm.textColor + ";font-size:30px;"))
  }, [_vm._v("\n            " + _vm._s(_vm.textVal) + "\n          ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showExtra = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doAddExtra
    }
  }, [_vm._v("创 建")])], 1)], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, [_c('div', {
    staticClass: "type_title clearfix"
  }, [_c('span', {
    staticClass: "left type_title_name flex flex-align-center"
  }, [_vm._v("商品")]), _vm._v(" "), _c('span', {
    staticClass: "right parent_default flex flex-align-center flex-pack-center"
  }, [_c('i', {
    staticClass: "iconfont icon-icon02",
    attrs: {
      "title": "添加"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sys-net-cost"
  }, [_c('span', [_vm._v(_vm._s(_vm.systemData[0].name))])]), _vm._v(" "), _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      style: ({
        height: (item.isOpen && _vm.btn ? ((item.children.length + 1) * 9 + '%') : '9%')
      })
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      style: ({
        height: (item.isOpen && _vm.btn ? (100 / (item.children.length + 1) + '%') : '100%')
      })
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      on: {
        "click": function($event) {
          return _vm.handle(item, ind)
        }
      }
    }, [_c('i', {
      staticClass: "i",
      class: {
        'el-icon-caret-right': item.children.length && (!item.isOpen || !_vm.btn),
        'el-icon-caret-bottom': item.children.length && (!item.isOpen || _vm.btn)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "parent_default type_name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right ss flex flex-align-center flex-pack-center"
    }), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
    }, [_c('i', {
      staticClass: "iconfont icon-icon02",
      attrs: {
        "title": "添加"
      },
      on: {
        "click": function($event) {
          return _vm.addClassify(item.id)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-bianji",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])]), _vm._v(" "), (item.isOpen && _vm.btn) ? _c('div', {
      staticClass: "type_child",
      style: ({
        height: (100 - 100 / (item.children.length + 1) + '%')
      })
    }, _vm._l((item.children), function(oitem, oInd) {
      return _c('div', {
        staticClass: "type_child_item",
        style: ({
          height: (100 / (item.children.length) + '%')
        })
      }, [_c('div', {
        staticClass: "type_child_left left flex flex-align-center"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(oitem.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "right"
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "padding-right": "20px"
        }
      }, [_c('div', {
        staticClass: "right ss flex flex-align-center flex-pack-center"
      }), _vm._v(" "), _c('span', {
        staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
      }, [_c('i', {
        staticClass: "iconfont icon-bianji",
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "title": "修改"
        },
        on: {
          "click": function($event) {
            return _vm.upClassify(item, oitem)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "iconfont icon-icon1460188478041",
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "title": "删除"
        },
        on: {
          "click": function($event) {
            return _vm.delClassify(item, oitem)
          }
        }
      })])])])
    }), 0) : _vm._e()])
  })], 2)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.typeName,
      "visible": _vm.addJobVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.name),
      expression: "obj.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.obj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("排序")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.sequence),
      expression: "obj.sequence"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.obj.sequence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "sequence", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addJob
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', [_vm._v("商品分类")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.noCommonRouter.indexOf(_vm.$route.name) == -1) ? _c('div', {
    staticClass: "system",
    on: {
      "click": function($event) {
        _vm.openSelfCenter = false
      }
    }
  }, [_c('top-logo', {
    attrs: {
      "tab": _vm.tab,
      "crumbs": _vm.crumbs,
      "storeData": _vm.storeData,
      "openSelfCenter": _vm.openSelfCenter
    },
    on: {
      "showSideBar": _vm.showSideBar,
      "changeSelfCenter": _vm.changeSelfCenter
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "systemConBox",
    attrs: {
      "type": "flex"
    },
    on: {
      "click": _vm.showSideBar
    }
  }, [_c('el-col', {
    staticClass: "leftSidePart",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 4,
      "lg": 4
    }
  }, [_c('side-bar', {
    attrs: {
      "storeData": _vm.storeData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mainPart",
    attrs: {
      "xs": 19,
      "sm": 19,
      "md": 20,
      "lg": 20
    }
  }, [_c('keep-alive', {
    attrs: {
      "exclude": "goodsBigScreen"
    }
  }, [_c('router-view', {
    attrs: {
      "curStoreId": _vm.curStoreId,
      "pageSize": _vm.pageSize,
      "storeData": _vm.storeData
    }
  })], 1)], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "width": "100vw",
      "height": "100vh"
    }
  }, [_c('router-view', {
    attrs: {
      "curStoreId": _vm.curStoreId,
      "pageSize": _vm.pageSize,
      "storeData": _vm.storeData
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reward"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem",
    on: {
      "click": function($event) {
        _vm.searchList = []
      }
    }
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left change-type"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'bar'
      }
    }
  }, [_vm._v("网吧评价")]), _vm._v(" "), _c('span', {
    class: _vm.nowType == 'bar' ? 'type-wrap' : 'type-wrap to-right',
    on: {
      "click": function($event) {
        _vm.nowType == 'bar' ? _vm.nowType = 'emp' : _vm.nowType = 'bar'
      }
    }
  }, [_c('i', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'emp'
      }
    }
  }, [_vm._v("员工评价")])]), _vm._v(" "), _c('div', {
    staticClass: "left monthBox clearfix"
  }, [_c('el-date-picker', {
    staticClass: "left",
    attrs: {
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    on: {
      "change": _vm.cutDataFn
    },
    model: {
      value: (_vm.yearMonth),
      callback: function($$v) {
        _vm.yearMonth = $$v
      },
      expression: "yearMonth"
    }
  })], 1), _vm._v(" "), (_vm.nowType != 'bar') ? _c('div', {
    staticClass: "left emp-name"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择员工"
    },
    model: {
      value: (_vm.nowEmpId),
      callback: function($$v) {
        _vm.nowEmpId = $$v
      },
      expression: "nowEmpId"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": '全部',
      "value": ''
    }
  }), _vm._v(" "), _vm._l((_vm.empNameData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('button', {
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_c('table', {
    staticClass: "titleTable"
  }, [(_vm.nowType == 'bar') ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("服务")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("流畅度")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("卫生情况")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("空气质量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("桌椅舒适度")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("设备满意度")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("桌号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("留言")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("评价时间")])]) : _c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("员工姓名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("满意度")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("桌号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("留言")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "26%"
    }
  }, [_vm._v("评价时间")])])]), _vm._v(" "), (_vm.nowType == 'bar') ? _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.ratingData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.ratingData.length > 10
    }
  }, _vm._l((_vm.ratingData), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(1 + ind + (_vm.pageForBar - 1) * _vm.size)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.rating[item.netService]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.rating[item.netFluency]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.rating[item.healthConditions]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.rating[item.airQuality]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.rating[item.comfort]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.rating[item.equipment]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(decodeURI(item.tableNo)))]), _vm._v(" "), (item.message) ? _c('td', {
      staticStyle: {
        "width": "10%",
        "cursor": "pointer",
        "color": "blue"
      },
      on: {
        "click": function($event) {
          return _vm.showText(item)
        }
      }
    }, [_vm._v("查看留言")]) : _vm._e(), _vm._v(" "), (!item.message) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("暂无留言")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.appraiseTime)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'emp') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-emp"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.ratingDataForEmp.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.ratingDataForEmp.length > 10
    }
  }, _vm._l((_vm.ratingDataForEmp), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(1 + ind + (_vm.pageForEmp - 1) * _vm.size)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.empName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(_vm.rating[item.appraise]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(decodeURI(item.tableNo)))]), _vm._v(" "), (item.message) ? _c('td', {
      staticStyle: {
        "width": "10%",
        "cursor": "pointer",
        "color": "blue"
      },
      on: {
        "click": function($event) {
          return _vm.showText(item)
        }
      }
    }, [_vm._v("查看留言")]) : _vm._e(), _vm._v(" "), (!item.message) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("暂无留言")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "26%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.appraiseTime)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "留言",
      "visible": _vm.centerDialogVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.nowText))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1), _vm._v(" "), (_vm.nowType == 'bar') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "total": _vm.totalElementsForBar,
      "current-page": _vm.pageForBar
    },
    on: {
      "update:currentPage": function($event) {
        _vm.pageForBar = $event
      },
      "update:current-page": function($event) {
        _vm.pageForBar = $event
      },
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'emp') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "total": _vm.totalElementsForEmp,
      "current-page": _vm.pageForEmp
    },
    on: {
      "update:currentPage": function($event) {
        _vm.pageForEmp = $event
      },
      "update:current-page": function($event) {
        _vm.pageForEmp = $event
      },
      "current-change": _vm.handleCurrentChangeForEmp
    }
  })], 1)])]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createCode"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "codeBox"
  }, [_c('div', {
    staticClass: "download-cont"
  }, [_c('div', {
    staticClass: "dl-btn"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.configUrl
    }
  }, [_c('div', {
    staticClass: "btn-item pc-order",
    on: {
      "click": _vm.getZip
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shoujishumadiannao"
  }), _vm._v(" "), _c('span', [_vm._v("购物点餐/呼叫客户端下载")])])]), _vm._v(" "), [_c('a', {
    attrs: {
      "href": 'https://images.huoxingy.com/service/' + _vm.curStoreId + '.zip'
    }
  }, [_vm._m(1)])]], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "downINpc"
  }, [_vm._v("\n                    客户端 请在电脑查看并下载\n                ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://images.huoxingy.com/火星捕手点单系统安装包_V1.1.2.exe.zip"
    }
  }, [_c('div', {
    staticClass: "btn-item pos-for-tag"
  }, [_c('i', {
    staticClass: "iconfont icon-qiandai"
  }), _vm._v(" "), _c('span', [_vm._v("收银端下载")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-item service"
  }, [_c('i', {
    staticClass: "iconfont icon-shoujishumadiannao"
  }), _vm._v(" "), _c('span', [_vm._v("呼叫服务端下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "codes"
  }, [_c('div', {
    staticClass: "codeImg"
  }, [_c('div', {
    staticClass: "position-middle-center",
    attrs: {
      "id": "qrcode"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeNote"
  }, [_c('span', [_vm._v("微信点单二维码")]), _vm._v(" "), _c('div', {
    staticClass: "downmobile"
  }, [_vm._v("请在电脑下载二维码")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code"
  }, [_c('div', {
    staticClass: "codes"
  }, [_c('div', {
    staticClass: "codeImg"
  }, [_c('div', {
    staticClass: "position-middle-center",
    attrs: {
      "id": "qrcodeForVip"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeNote"
  }, [_c('span', [_vm._v("店铺会员二维码")])])])])
}]}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "set-with-draw"
  }, [_c('div', {
    staticClass: "panle now-count-info"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("\n            *提现前请先设置以下信息，填写错误导致的任何问题，本公司概不负责。请谨慎填写！\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "count-info"
  }, [_c('div', {
    staticClass: "item name"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写真实姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item phone"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("手机号:")]), _vm._v(" "), ((_vm.dataInfo.username == '') || (_vm.dataInfo.username == null)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写正确的手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.dataInfo.username != null)) ? _c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.phone))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item idcard"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("身份证:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCard),
      expression: "idCard"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写正确的身份证"
    },
    domProps: {
      "value": (_vm.idCard)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idCard = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item card"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("银行卡:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card),
      expression: "card"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写正确的银行卡号"
    },
    domProps: {
      "value": (_vm.card)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.card = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item bank"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("开户银行:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bank),
      expression: "bank"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写正确的开户银行"
    },
    domProps: {
      "value": (_vm.bank)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bank = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item code"
  }, [_c('span', {
    staticClass: "item-name"
  }, [_vm._v("验证码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isGetCode) ? _c('span', {
    staticClass: "get-code",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("立即获取")]) : _vm._e(), _vm._v(" "), (_vm.isGetCode) ? _c('span', {
    staticClass: "sendCode"
  }, [_vm._v(_vm._s(_vm.time + ' s'))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "save-info"
  }, [_c('button', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])])])])
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showUpBox
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加地址")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.addressData.length < 10
    }
  }, _vm._l((_vm.addressData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "50%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.address)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "50%",
        "text-align": "right",
        "padding-right": "10%"
      }
    }, [(item.id) ? _c('span', {
      staticStyle: {
        "margin": "0 2%"
      },
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.showUpBox(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]) : _vm._e(), _vm._v(" "), (item.id) ? _c('span', {
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delAddr(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '添加收货地址',
      "visible": _vm.addAddrBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addAddrBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("收货地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addr),
      expression: "addr"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入收货地址"
    },
    domProps: {
      "value": (_vm.addr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入收货人姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入收货人手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addAddrBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addAddrFn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("收货地址")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%",
      "text-align": "right",
      "padding-right": "10%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discount"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("\n                        原料单位管理\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      staticStyle: {
        "height": "9%"
      }
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      staticStyle: {
        "height": "100%"
      }
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center"
    }, [_c('span', {
      staticClass: "parent_default type_name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right ss flex flex-align-center flex-pack-center"
    }), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
    }, [_c('i', {
      staticClass: "iconfont icon-bianji",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑",
      "visible": _vm.addJobVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("原料单位名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDiscount.name),
      expression: "newDiscount.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.newDiscount.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDiscount, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "优惠商品详情",
      "visible": _vm.mealInfo,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.mealInfo = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "meal-goods"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('table', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("所属分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("商品数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.mealInfoData.length) ? _c('table', _vm._l((_vm.mealInfoData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.setMealQty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%",
        "color": "#3068ff",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.delMealGoods(item)
        }
      }
    }, [_vm._v("删除")])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.mealInfoData.length) ? _c('div', {
    staticStyle: {
      "padding": "10px 0",
      "text-align": "center"
    }
  }, [_vm._v("\n                            暂无商品\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.showSelGoods) ? _c('div', {
    staticClass: "sel-goods"
  }, [_c('selGoods', {
    attrs: {
      "isDiscount": true,
      "nowSelClassGoods": _vm.nowSelClassGoods,
      "storeId": _vm.curStoreId,
      "nowSelClass": _vm.nowSelClass
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": _vm.closeSelGoods
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', [_vm._v("名称")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reward"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem",
    on: {
      "click": function($event) {
        _vm.searchList = []
      }
    }
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "month-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy-MM",
      "format": "yyyy 年 MM 月",
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.valueForMonth),
      callback: function($$v) {
        _vm.valueForMonth = $$v
      },
      expression: "valueForMonth"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.form.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "beginTime", $$v)
      },
      expression: "form.beginTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "day-filter"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "size": "small",
      "placeholder": "请输入手机号查询"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.tableList.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.tableList.length > 10
    }
  }, _vm._l((_vm.tableList), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.numName
      },
      domProps: {
        "textContent": _vm._s(item.numName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.productName
      },
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "title": item.ruleName
      },
      domProps: {
        "textContent": _vm._s(item.ruleName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.mobile
      },
      domProps: {
        "textContent": _vm._s(item.mobile)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.refundTime) ? _c('span', [_vm._v(_vm._s(new Date(item.refundTime).Format("yyyy/MM/dd hh:mm:ss")))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(_vm.spanTime(item.addTime, item.refundTime)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.totalAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.payAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.getAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.refundAmount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.tableList.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.tableList.length > 10
    }
  }, _vm._l((_vm.tableList), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.numName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.ruleName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.mobile)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("快乐；kll")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.totalAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.payAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.getAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.refundAmount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "left item"
  }, [_vm._v("总押金:"), _c('span', {
    staticClass: "num color3"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.totalInfo.totalAmount)))])]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("实收:"), _c('span', {
    staticClass: "num color2"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.totalInfo.getAmount)))])]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("退回押金:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.totalInfo.refundAmount)))])])]), _vm._v(" "), _c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("座位号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("租赁规则")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("顾客手机号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("退还时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("时长")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("押金金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("租赁费用")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("实收金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("退还押金")])])])
}]}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "left-tab"
  }, [_c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.showType == 'NO'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = 'NO'
      }
    }
  }, [_vm._v("未开始")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.showType == 'ING'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = 'ING'
      }
    }
  }, [_vm._v("进行中")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.showType == 'EXPIRED'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = 'EXPIRED'
      }
    }
  }, [_vm._v("已过期")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.showType == 'STOP'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = 'STOP'
      }
    }
  }, [_vm._v("已作废")])]), _vm._v(" "), _c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "right searchBtn",
    staticStyle: {
      "width": "130px"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showUpBox
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加优惠券")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable fixed-td",
    class: {
      overLengthTable: _vm.couponList.length < 10
    },
    staticStyle: {
      "table-layout": "fixed"
    }
  }, _vm._l((_vm.couponList), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.couponTypeText[item.type]))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_c('el-tooltip', {
      key: ind,
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.productName,
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "overflowText"
    }, [_vm._v(_vm._s(item.productName))])])], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('span', [_vm._v(_vm._s(item.sendCount))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('span', [_vm._v(_vm._s(item.useCount))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(item.limitCount))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [(item.id) ? [(item.id && item.startTime && item.endTime && !item.expireDay) ? _c('span', [_vm._v(_vm._s(_vm._f("numberToDate")(item.startTime, '')) + " 至 " + _vm._s(_vm._f("numberToDate")(item.endTime, '')))]) : _c('span', [_vm._v(_vm._s(item.expireDay) + "天")])] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('span', [_vm._v(_vm._s(_vm._f("numberToDate")(item.addTime, '')))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? [_c('span', [_vm._v(_vm._s(item.createName))])] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-button', {
      attrs: {
        "type": "text",
        "title": "详情"
      },
      on: {
        "click": function($event) {
          return _vm.toDetail(item)
        }
      }
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "title": "编辑"
      },
      on: {
        "click": function($event) {
          return _vm.uploadCoupon(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })])], 1) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "close-top",
    attrs: {
      "title": '优惠券',
      "visible": _vm.addCouponBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addCouponBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msg clearfix",
    on: {
      "click": function($event) {
        _vm.goodCheckArr = []
      }
    }
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("优惠券类型")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "GET_ITEM_FREE"
    },
    model: {
      value: (_vm.couponType),
      callback: function($$v) {
        _vm.couponType = $$v
      },
      expression: "couponType"
    }
  }, [_vm._v("商品抵用券")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "REDUCE"
    },
    model: {
      value: (_vm.couponType),
      callback: function($$v) {
        _vm.couponType = $$v
      },
      expression: "couponType"
    }
  }, [_vm._v("代金券")])], 1), _vm._v(" "), _c('div', {
    staticClass: "couponConBox left clearfix"
  }, [(_vm.couponType != 'REDUCE') ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("是否可分享")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.shareable),
      callback: function($$v) {
        _vm.shareable = $$v
      },
      expression: "shareable"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.shareable),
      callback: function($$v) {
        _vm.shareable = $$v
      },
      expression: "shareable"
    }
  }, [_vm._v("否")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "height": "50px",
      "line-height": "16px"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("开启每天使用数量限制")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.newCoupon.openLimitEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newCoupon, "openLimitEnabled", $$v)
      },
      expression: "newCoupon.openLimitEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.newCoupon.openLimitEnabled),
      callback: function($$v) {
        _vm.$set(_vm.newCoupon, "openLimitEnabled", $$v)
      },
      expression: "newCoupon.openLimitEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.newCoupon.openLimitEnabled) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "height": "50px",
      "line-height": "16px"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("限制数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.limitCount),
      expression: "newCoupon.limitCount"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "请输入数量"
    },
    domProps: {
      "value": (_vm.newCoupon.limitCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "limitCount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("使用数量限制")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v(_vm._s(_vm.couponType == "GET_ITEM_FREE" ? "抵用券名称" : "代金券名称"))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.title),
      expression: "newCoupon.title"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.newCoupon.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("如：奶茶" + _vm._s(_vm.couponType == "GET_ITEM_FREE" ? "抵用券" : "代金券"))])]), _vm._v(" "), (_vm.couponType == 'REDUCE') ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("代金券金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.couponAmount),
      expression: "newCoupon.couponAmount"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.newCoupon.couponAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "couponAmount", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("商品名称")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showCouponGoods = true
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("注：抵用商品(可多选)")])], 1), _vm._v(" "), (_vm.seledGoods && _vm.seledGoods.length) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "min-height": "32px",
      "height": "auto"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("已选商品")]), _vm._v(" "), _c('div', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledGoods), function(tag) {
    return _c('el-tag', {
      key: tag.name,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.cancelCouponGoods(tag)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(tag.name) + "\n                            ")])
  }), 1)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("使用时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions0,
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择开始日期"
    },
    model: {
      value: (_vm.timeFrom),
      callback: function($$v) {
        _vm.timeFrom = $$v
      },
      expression: "timeFrom"
    }
  }), _vm._v(" "), _c('span', [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "value-format": "yyyy/MM/dd",
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions0,
      "placeholder": "选择到期日期"
    },
    model: {
      value: (_vm.timeTo),
      callback: function($$v) {
        _vm.timeTo = $$v
      },
      expression: "timeTo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("有效天数")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.expireDay),
      expression: "newCoupon.expireDay"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "placeholder": "请输入有效天数"
    },
    domProps: {
      "value": (_vm.newCoupon.expireDay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "expireDay", $event.target.value)
      }
    }
  }), _vm._v("天\n                        "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("*以派发时间为起始时间")])]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("优惠说明")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.description),
      expression: "newCoupon.description"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入优惠说明(选填)"
    },
    domProps: {
      "value": (_vm.newCoupon.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("注：抵用某个现有商品（如：免费送奶茶）")])]), _vm._v(" "), _c('div', {
    staticClass: "left clearfix textareaBox msgItem"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("使用规则")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.notice),
      expression: "newCoupon.notice"
    }],
    staticClass: "left itemTextarea",
    attrs: {
      "name": "aa",
      "id": "",
      "cols": "30",
      "rows": "4",
      "placeholder": "请输入使用规则"
    },
    domProps: {
      "value": (_vm.newCoupon.notice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "notice", $event.target.value)
      }
    }
  }, [_vm._v("555")]), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("注：默认使用规则，仅供参考，请根据实际情况修改。")])]), _vm._v(" "), _c('div', {
    staticClass: "left img_box clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v(_vm._s(_vm.couponType == "GET_ITEM_FREE" ? "抵用券" : "代金券") + "图片")]), _vm._v(" "), _c('div', {
    staticClass: "left img"
  }, [_c('div', {
    staticClass: "img_item left"
  }, [(_vm.newCoupon.logoURL) ? _c('img', {
    attrs: {
      "src": _vm.newCoupon.logoURL,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img_up_btn left"
  }, [_c('i', {
    staticClass: "iconfont icon-xiazai"
  }), _vm._v(" "), _c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "mobileImgFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.coverImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left flex flex-align-center",
    staticStyle: {
      "height": "74px",
      "color": "#999"
    }
  }, [_c('span', {
    staticClass: "notice"
  }, [_vm._v("注：" + _vm._s(_vm.couponType == "GET_ITEM_FREE" ? "抵用券" : "代金券") + "的展示图，可以为某个商品的图片，也可以为默认图")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "uploadImgTip"
  }, [_vm._v("\n                                支持JPG、JPEG、PNG格式，单张大小不超过"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("200KB")])])])])])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addCouponBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveCoupon
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "close-top",
    attrs: {
      "title": '修改优惠券',
      "visible": _vm.editCouponBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.editCouponBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msg clearfix",
    on: {
      "click": function($event) {
        _vm.goodCheckArr = []
      }
    }
  }, [_c('div', {
    staticClass: "couponConBox left clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v(_vm._s(_vm.couponType == "GET_ITEM_FREE" ? "抵用券名称" : "代金券名称") + ":")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.newCoupon.title))])]), _vm._v(" "), (!_vm.isShowOld) ? [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("商品名称:")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showCouponGoods = true
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("注：抵用商品(可多选)")])], 1), _vm._v(" "), (_vm.seledGoods && _vm.seledGoods.length) ? _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "min-height": "32px",
      "height": "auto"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("已选商品:")]), _vm._v(" "), _c('div', {
    staticClass: "seled-mat-list"
  }, _vm._l((_vm.seledGoods), function(tag) {
    return _c('el-tag', {
      key: tag.name,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.cancelCouponGoods(tag)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(tag.name) + "\n                                ")])
  }), 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isShowOld) ? [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("到期时间:")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "value-format": "yyyy/MM/dd",
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions0,
      "placeholder": "选择到期日期"
    },
    model: {
      value: (_vm.timeTo),
      callback: function($$v) {
        _vm.timeTo = $$v
      },
      expression: "timeTo"
    }
  })], 1)] : _vm._e()], 2)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editCouponBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editCoupon
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCouponGoods) ? _c('selCouponGoods', {
    attrs: {
      "seledGoods": _vm.seledGoods,
      "storeId": _vm.curStoreId
    },
    on: {
      "selOk": _vm.selOk,
      "closeSelGoods": function($event) {
        _vm.showCouponGoods = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("优惠券名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("优惠券类型")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("抵用商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("已派发")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("已使用")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("每天使用数量限制")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("有效时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("操作人")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem",
    on: {
      "click": function($event) {
        _vm.searchList = []
      }
    }
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.ratingData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.ratingData.length > 10
    }
  }, _vm._l((_vm.ratingData), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(1 + ind + (_vm.nowPage - 1) * _vm.size)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.addTime)))]), _vm._v(" "), _c('td', {
      class: item.payEnabled ? 'success' : 'false',
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.payEnabled ? (item.channel ? (item.channel == "pay.wechat.native" ? "微信支付" : "支付宝支付") : "已支付") : "未支付"))]), _vm._v(" "), _c('td', {
      class: item.sendEnabled ? 'success' : 'false',
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.sendEnabled ? "已发货" : "未发货"))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.mobile))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%",
        "cursor": "pointer",
        "color": "blue"
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.doShowDetail(item)
        }
      }
    }, [_vm._v("查看详情")])])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("暂无记录")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "total": _vm.totalElements,
      "current-page": _vm.nowPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.nowPage = $event
      },
      "update:current-page": function($event) {
        _vm.nowPage = $event
      },
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单详情",
      "visible": _vm.showDetail,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDetail = $event
      }
    }
  }, [_c('div', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("商品名字")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("单位")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("发货状态")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-list"
  }, [_c('ul', _vm._l((_vm.detailInfo), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.spec))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('span', {
      class: item.sendEnabled ? 'send success' : 'send false',
      staticStyle: {
        "width": "15%",
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(item.sendEnabled ? "已发货" : "未发货"))])])
  }), 0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('span', [_vm._v("订单记录")]), _vm._v(" "), _c('div', {
    staticClass: "left monthBox clearfix"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("订单时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("支付状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("发货状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("手机")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("收货人")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("总金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("原料总数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "daily-grade",
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('div', {
    staticClass: "daily-filter"
  }, [_c('div', {
    staticClass: "date-filter"
  }, [_c('el-date-picker', {
    ref: "dateInput",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "placeholder": "请选择选择日期"
    },
    model: {
      value: (_vm.dateStr),
      callback: function($$v) {
        _vm.dateStr = $$v
      },
      expression: "dateStr"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-jiantou",
    on: {
      "click": function($event) {
        return _vm.$refs.dateInput.handleFocus()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "in-and-out clearfix"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("同期报表")]), _vm._v(" "), _c('div', {
    staticClass: "pie"
  }, [_c('div', {
    staticClass: "income left"
  }, [_c('div', {
    staticClass: "panle-tit"
  }, [_vm._v("所选时间数据," + _vm._s(_vm.nowDate) + "," + _vm._s(_vm.week[_vm.ringDay]))]), _vm._v(" "), _c('div', {
    staticClass: "panle-info"
  }, [_c('ul', _vm._l((_vm.startSalesItem), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('span', [_vm._v("数量：" + _vm._s(item.qty))]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v("金额：￥" + _vm._s(item.amount))])])
  }), 0), _vm._v(" "), (_vm.startSalesItem.length == 0) ? _c('div', [_vm._v("暂无数据")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "out left"
  }, [_c('div', {
    staticClass: "panle-tit"
  }, [_vm._v("同期数据," + _vm._s(_vm.ringDate) + "," + _vm._s(_vm.week[_vm.ringDay]))]), _vm._v(" "), _c('div', {
    staticClass: "panle-info"
  }, [_c('ul', _vm._l((_vm.endSalesItem), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.typeName))]), _vm._v(" "), _c('span', [_vm._v("数量：" + _vm._s(item.qty))]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v("金额：￥" + _vm._s(item.amount))])])
  }), 0), _vm._v(" "), (_vm.endSalesItem.length == 0) ? _c('div', [_vm._v("暂无数据")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "loading"
  })])
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exchangeWorkNew",
    attrs: {
      "id": "charge-info"
    }
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "89.3%",
      "position": "relative",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'MONTH') ? _c('div', {
    staticClass: "date-filter"
  }, [_c('el-date-picker', {
    ref: "dateInput",
    attrs: {
      "type": "month",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "placeholder": "请选择选择日期"
    },
    model: {
      value: (_vm.dateStr),
      callback: function($$v) {
        _vm.dateStr = $$v
      },
      expression: "dateStr"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-jiantou",
    on: {
      "click": function($event) {
        return _vm.$refs.dateInput.handleFocus()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'TIME_RANGE') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('span', [_vm._v("时间:")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptions,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-tit"
  }, [_vm._v("起始班次:")]), _vm._v(" "), _c('el-select', {
    staticClass: "new-inp",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.nowSelStartExcWork),
      callback: function($$v) {
        _vm.nowSelStartExcWork = $$v
      },
      expression: "nowSelStartExcWork"
    }
  }, _vm._l((_vm.startExcWorks), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": ("班次时间：" + (new Date(item.beginTime).Format('yyyy/MM/dd hh:mm:ss')) + " 至 " + (new Date(item.endTime).Format('yyyy/MM/dd hh:mm:ss'))),
        "value": item.beginTime
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 10px"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('span', [_vm._v("时间:")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptions,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-tit"
  }, [_vm._v("结束班次:")]), _vm._v(" "), _c('el-select', {
    staticClass: "new-inp",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.nowSelEndExcWork),
      callback: function($$v) {
        _vm.nowSelEndExcWork = $$v
      },
      expression: "nowSelEndExcWork"
    }
  }, _vm._l((_vm.endExcWorks), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": ("开班人：" + (item.operatorName) + "；班次时间：" + (new Date(item.beginTime).Format('yyyy/MM/dd hh:mm:ss')) + " 至 " + (new Date(item.endTime).Format('yyyy/MM/dd hh:mm:ss'))),
        "value": item.endTime
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "tableBox",
    staticStyle: {
      "height": "87%"
    }
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.exchangeList.length > _vm.pageSize
    }
  }, _vm._l((_vm.exchangeList), function(item, ind) {
    return _c('tr', {
      key: ind,
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#3068fe",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showExcInfo(item)
        }
      }
    }, [_vm._v(_vm._s(item.name ? "查看详情" : ""))])])])
  }), 0)])])])]), _vm._v(" "), _c('cartInfo', {
    attrs: {
      "nowExcInfo": _vm.nowExcInfo,
      "showType": 'exchangeInfo',
      "nowSelName": _vm.nowSelName,
      "begin": _vm.nowSelStartExcWork,
      "end": _vm.nowSelEndExcWork,
      "storeId": _vm.curStoreId,
      "mobile": _vm.nowSelMobile,
      "showCartInfo": _vm.showCartInfo
    },
    on: {
      "closeCartInfo": function($event) {
        _vm.showCartInfo = false;
        _vm.nowExcInfo = {}
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("交班员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("总收入")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rent-hello"
  }, [_vm._v("\n    尚未开通，请联系火星捕手工作人员，开通租赁管理，可以实现外设租赁和外设管理。\n")])
},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "staff-grade",
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('span', {
    staticClass: "go-back",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-fanhui"
  }), _vm._v("返回交接班记录")]), _vm._v(" "), _c('div', {
    staticClass: "staff-filter"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOrderId),
      expression: "searchOrderId"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "",
      "placeholder": "输入订单号查询"
    },
    domProps: {
      "value": (_vm.searchOrderId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchOrderId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.searchByOrderId
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "staff-info"
  }, [_c('span', {
    staticClass: "staff-name"
  }, [_vm._v("交班人：" + _vm._s(_vm.$route.query.closeUsername))]), _vm._v(" "), _c('span', {
    staticClass: "staff-time"
  }, [_vm._v("交班时间：" + _vm._s(_vm._f("numberToMonthDate")(_vm.$route.query.beginTime, '')) + "~" + _vm._s(_vm._f("numberToMonthDate")(_vm.$route.query.endTime, '')))])]), _vm._v(" "), _c('div', {
    staticClass: "in-and-out clearfix"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("收入退单")]), _vm._v(" "), _c('div', {
    staticClass: "pie"
  }, [_c('div', {
    staticClass: "income left"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPie),
      expression: "showPie"
    }],
    staticClass: "pie-for-income left",
    attrs: {
      "id": "income-pie"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPie),
      expression: "!showPie"
    }],
    staticClass: "no-income"
  }, [_c('span', [_vm._v("暂无任何收入数据")])])]), _vm._v(" "), _c('div', {
    staticClass: "out left"
  }, [_c('div', {
    staticClass: "pie-for-out left",
    attrs: {
      "id": "out-pie"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip-info left"
  }, [_c('ul', [_c('li', {
    staticClass: "out-tip"
  }, [_c('span', {
    staticClass: "tip-color"
  }), _vm._v(" "), _c('span', {
    staticClass: "tip-cont"
  }, [_vm._v("退款：" + _vm._s(_vm._f("toFixedNum")(_vm.gradeDataForPie.refundTotalAmount)) + "元")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "in-and-out-list"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("收入退单")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.gradeListData.length > 0) ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.gradeListData), function(item, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "index-count",
      staticStyle: {
        "width": "3%"
      }
    }, [(item.amount < 0) ? _c('i', {
      staticClass: "iconfont icon-tui"
    }) : _vm._e(), _vm._v("\n                  " + _vm._s(index + 1 + (_vm.currentPage - 1) * _vm.pageSize) + "\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(item.tableNo ? item.tableNo : "无"))]), _vm._v(" "), (item.amount < 0) ? _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.refundTime)))]) : _c('td', {
      staticStyle: {
        "width": "13%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.createTime)))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(item.total))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(item.discount))]), _vm._v(" "), _c('td', {
      staticClass: "amount",
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(item.removeZero))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.payType[item.paymentChannel]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(item.creatorName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(_vm.sourceType[item.source]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.orderId))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "6%",
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showOrderDetail(item)
        }
      }
    }, [_vm._v("详情")])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("暂无数据")])]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "loading"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单详情",
      "visible": _vm.doShowOrderDetail,
      "width": "15%"
    },
    on: {
      "update:visible": function($event) {
        _vm.doShowOrderDetail = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "300px",
      "overflow": "hidden",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("名称")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("金额")]), _vm._v(" "), _c('th', [_vm._v("会员名称")]), _vm._v(" "), _c('th', [_vm._v("会员号码")])]), _vm._v(" "), _vm._l((_vm.orderDetailData), function(item, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.memberName ? item.memberName : '无'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "padding": "5px 0"
      }
    }, [_vm._v(_vm._s(item.mobile ? item.mobile : '无'))])])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.doShowOrderDetail = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.doShowOrderDetail = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("座号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("实收")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("应收")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("折扣")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("抹零")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("结账员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("订单来源")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("详情")])])])
}]}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipCons"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.curPage * _vm.pageSize)
      }
    }) : _vm._e(), _vm._v(" "), (!item.id) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      },
      domProps: {
        "textContent": _vm._s(item.memberName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "16%"
      }
    }, [_vm._v(" " + _vm._s(_vm._f("numberToMonthDate")(item.paymentTime, '')))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      },
      domProps: {
        "textContent": _vm._s(item.code)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "16%"
      },
      domProps: {
        "textContent": _vm._s(item.amount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "16%"
      },
      domProps: {
        "textContent": _vm._s(_vm.paytype[item.type])
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [(item.type == 'MEMBER_DEPOSIT') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (item.type == 'SALES') ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#9FB2D7",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.cutDetail(item)
        }
      }
    }, [_vm._v("详情")]) : _vm._e()]) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "消费详情",
      "visible": _vm.showPutAllMask,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.inventoryList), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.pageSize * _vm.WKcurPage)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("numberToTime")(item.updateTime, '')))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.quantity)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    })])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pag flex flex-align-center",
    attrs: {
      "id": "pag"
    }
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: _vm.WKcurPage > 0
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": function($event) {
        return _vm.changeDetailPage(false)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.WKcurPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left"
  }, [_c('i', {
    staticClass: "el-icon-arrow-right",
    class: {
      havePage: ((_vm.WKcurPage + 1) < _vm.WKtotalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changeDetailPage(true)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.WKtotalElements > 0 ? (_vm.WKcurPage + 1) : '0') + ' / ' + (_vm.WKtotalPage) + ' 条')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.WKtotalElements + '条')
    }
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("会员")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("流水号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("结账方式")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品")])])])
}]}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discountManaEdit"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-info"
  }, [_c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "auto",
      "model": _vm.secondInfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "优惠名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.secondInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "name", $$v)
      },
      expression: "secondInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "优惠方式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.secondInfo.type),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "type", $$v)
      },
      expression: "secondInfo.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'discount'
    }
  }, [_vm._v("打折")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'reduce'
    }
  }, [_vm._v("减免金额")])], 1)], 1), _vm._v(" "), (_vm.secondInfo.type == 'discount') ? _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "折扣"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.secondInfo.discount),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "discount", $$v)
      },
      expression: "secondInfo.discount"
    }
  }), _vm._v("折\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.secondInfo.type == 'reduce') ? _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "减免金额"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.secondInfo.reduceAmount),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "reduceAmount", $$v)
      },
      expression: "secondInfo.reduceAmount"
    }
  }), _vm._v("元\n      ")], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生效时间"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.secondInfo.timeEnableType),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "timeEnableType", $$v)
      },
      expression: "secondInfo.timeEnableType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'custom'
    }
  }, [_vm._v("自定义时间")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'forever'
    }
  }, [_vm._v("永久有效")])], 1)], 1), _vm._v(" "), (_vm.secondInfo.timeEnableType == 'custom') ? _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "请选择时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "picker-options": _vm.pickerOptions,
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.secondInfo.timeForAuto),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "timeForAuto", $$v)
      },
      expression: "secondInfo.timeForAuto"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "请选择时间范围"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "is-range": "",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "placeholder": "选择时间范围"
    },
    model: {
      value: (_vm.secondInfo.timeRange),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "timeRange", $$v)
      },
      expression: "secondInfo.timeRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "星期选择"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleChangeWeeksAll
    },
    model: {
      value: (_vm.isAllWeek),
      callback: function($$v) {
        _vm.isAllWeek = $$v
      },
      expression: "isAllWeek"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleChangeWeeks
    },
    model: {
      value: (_vm.secondInfo.week),
      callback: function($$v) {
        _vm.$set(_vm.secondInfo, "week", $$v)
      },
      expression: "secondInfo.week"
    }
  }, _vm._l((_vm.weeks), function(weekItem) {
    return _c('el-checkbox', {
      key: weekItem,
      attrs: {
        "label": weekItem
      }
    }, [_vm._v(_vm._s(weekItem))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "10px",
      "color": "red",
      "width": "50%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticClass: "select-wrap",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-cont"
  }, [_c('div', {
    staticClass: "goods-left"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("商品选择")]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "row-key": _vm.getRowKeys
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "select": _vm.toggleSelection,
      "select-all": _vm.toggleSelectionAll
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55",
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salesPrice",
      "label": "价格",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提成"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.discountCommission),
            expression: "scope.row.discountCommission"
          }],
          staticStyle: {
            "width": "60px"
          },
          attrs: {
            "type": "text",
            "placeholder": "提成金额"
          },
          domProps: {
            "value": (scope.row.discountCommission)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(scope.row, "discountCommission", $event.target.value)
            }
          }
        }), _vm._v("元\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "分类"
    }
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back"
  }, [_c('span', {
    staticClass: "right"
  })])
}]}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showUpBox(null)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加规格组")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.addressData.length > 10
    }
  }, _vm._l((_vm.addressData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s((item.specs && Array.isArray(item.specs)) ? item.specs.join("、") : ""))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(item.defaultSpec))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "right",
        "padding-right": "10%"
      }
    }, [(item.id) ? _c('span', {
      staticStyle: {
        "margin": "0 2%",
        "cursor": "pointer"
      },
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.showUpBox(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]) : _vm._e(), _vm._v(" "), (item.id) ? _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delAddr(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '添加/编辑规格组',
      "visible": _vm.addAddrBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addAddrBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("规格组名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入规格组名称"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("添加规格")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoSpec),
      expression: "autoSpec"
    }],
    staticClass: "left itemInput",
    staticStyle: {
      "width": "57.89%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入规格..."
    },
    domProps: {
      "value": (_vm.autoSpec)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autoSpec = $event.target.value
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.modifySpec('add')
      }
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), (_vm.specs && Array.isArray(_vm.specs) && _vm.specs.length) ? _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("已添加规格")]), _vm._v(" "), _vm._l((_vm.specs), function(tag, index) {
    return _c('el-tag', {
      key: ("_" + index),
      staticStyle: {
        "margin": "5px"
      },
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.modifySpec('del', index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(tag) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("默认规格")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.defaultSpec),
      callback: function($$v) {
        _vm.defaultSpec = $$v
      },
      expression: "defaultSpec"
    }
  }, _vm._l((_vm.specs), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addAddrBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addAddrFn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("规格组名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("所含规格")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("默认规格")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "right",
      "padding-right": "10%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-open-book",
    attrs: {
      "id": "selGoods"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "sel-goods-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "common-tit"
  }, [_c('span', {
    staticClass: "tit-info"
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    staticClass: "left-cont common-cont"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'cont-list over' : 'cont-list'
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "list-filter"
  }, [_c('span', {
    staticClass: "name-filter filter-normal",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchVal),
      expression: "searchVal"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchVal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "filter-normal",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', {
    staticClass: "filter-normal search",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo",
    on: {
      "click": function($event) {
        return _vm.searchGoods()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: _vm.goodsList.length > 9 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "60%",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.unitFormat[item.unitId]))]), _vm._v(" "), _c('td', {
      staticClass: "add",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.modifyItem('add', item)
        }
      }
    }, [_vm._v("添加")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 9 ? 'right-cont common-cont over' : 'right-cont common-cont'
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "cont-list"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    class: _vm.nowSelectGoods.length > 10 ? 'goods-list over' : 'goods-list'
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.nowSelectGoods), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.count),
        expression: "item.count"
      }],
      staticClass: "inp",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.count)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "count", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "ruduce",
      staticStyle: {
        "width": "25%"
      },
      on: {
        "click": function($event) {
          return _vm.modifyItem('reduce', item)
        }
      }
    }, [_c('span', [_vm._v("删减")])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "confirm-set"
  }, [_c('button', {
    staticStyle: {
      "background": "#ccc"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.selOk
    }
  }, [_vm._v("完成")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit active"
  }, [_c('span', [_vm._v("可选原料")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("单位")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-tit"
  }, [_c('span', [_vm._v("已选原料")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("名称")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])
}]}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background-color": "#f6f7fb"
    }
  }, [(_vm.$route.name === 'goodsLogForRent') ? _c('div', {
    staticClass: "goodsLog"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left search flex flex-align-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goods),
      expression: "goods"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名"
    },
    domProps: {
      "value": (_vm.goods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goods = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.searchGoods
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "details_search",
    style: ({
      display: (_vm.goodCheckArr[0] ? 'block' : 'none')
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "leftIcon",
    style: ({
      top: (_vm.curGoodIdx * 40 + 'px')
    })
  }, [_c('div', {
    staticClass: "iconInner"
  })]), _vm._v(" "), _vm._l((_vm.goodCheckArr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.selSearchGood(item)
        }
      }
    }, [_c('div', {
      staticClass: "left name ellipsis",
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, index) {
    return _c('tr', {
      key: index
    }, [(item.id) ? _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(index + 1 + (_vm.curPage) * _vm.pageSize))]) : _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "55%",
        "line-height": "19px"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.notice)
      }
    }), _vm._v(" "), (item.oriImage && item.nowImage) ? _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
      }
    }, [_c('span', [_vm._v("变动前图片:")]), _c('img', {
      staticClass: "img-log",
      attrs: {
        "src": item.oriImage
      }
    }), _vm._v(" "), _c('span', [_vm._v("变动后图片:")]), _c('img', {
      staticClass: "img-log",
      attrs: {
        "src": item.nowImage
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.addTime)))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "销售明细",
      "visible": _vm.showPutAllMask1,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask1 = $event
      },
      "close": _vm.closeSaleDetail
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "couponBox right"
  }, [_c('div', {
    staticClass: "changeWorkTitle",
    staticStyle: {
      "margin-bottom": "10px",
      "font-weight": "600"
    }
  }, [_vm._v("优惠券核销统计")]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, _vm._l((_vm.salesData.coupons), function(item, ind) {
    return _c('div', [_c('div', {
      staticClass: "couponItem clearfix"
    }, [_c('span', {
      staticClass: "name left",
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "price right",
      domProps: {
        "textContent": _vm._s('￥' + item.amount / 100)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "number right",
      domProps: {
        "textContent": _vm._s('X' + item.quantity)
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "goodTypeBox left"
  }, [_c('div', {
    staticClass: "changeWorkTitle",
    staticStyle: {
      "margin-bottom": "10px",
      "font-weight": "600"
    }
  }, [_vm._v("分类列表")]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("火星网费：")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(_vm.salesData.cost.cashAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("会员支付网费:")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(_vm.salesData.net.amount)))]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(",数量:")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.salesData.net.qty))])]), _vm._v(" "), _c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("会员充值金额：")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")((_vm.salesData.memberDepositAmount) / 100)))])]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "value": _vm.nowTypeName,
      "accordion": ""
    },
    on: {
      "change": _vm.getNowTypeProducts
    }
  }, _vm._l((_vm.salesData.itemDetails), function(item, ind) {
    return _c('el-collapse-item', {
      key: 'big' + ind,
      attrs: {
        "name": item.typeName
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("\n                                    " + _vm._s(item.typeName) + "：￥" + _vm._s(_vm._f("toFixedNum")(item.amount)) + "\n                                ")]), _vm._v(" "), _vm._l((_vm.nowItem), function(bigGood) {
      return _c('div', {
        staticClass: "goodItem clearfix"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(bigGood.qty + ' × ' + bigGood.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "right"
      }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(bigGood.amount)))])])
    })], 2)
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "员工销售",
      "visible": _vm.showPutAllMask2,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("员工名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("订单数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("销售金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.staffArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.pageSize * _vm.salesCurPage)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.creatorName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.orderCount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.totalAmount)
      }
    })])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.staff2Excel
    }
  }, [_vm._v("导出Excel")])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "stock",
    attrs: {
      "title": "库存记录",
      "visible": _vm.showStock,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showStock = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("分类名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("库存剩余")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.stockArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    })])])
  }), 0)])])])])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("记录")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("操作时间")])])])
}]}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("\n                        排号管理\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      style: ({
        height: (item.isOpen && _vm.btn ? ((item.children.length + 1) * 9 + '%') : '9%')
      })
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      style: ({
        height: (item.isOpen && _vm.btn ? (100 / (item.children.length + 1) + '%') : '100%')
      })
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      on: {
        "click": function($event) {
          return _vm.handle(item, ind)
        }
      }
    }, [_c('i', {
      staticClass: "i",
      class: {
        'el-icon-caret-right': item.children.length && (!item.isOpen || !_vm.btn),
        'el-icon-caret-bottom': item.children.length && (!item.isOpen || _vm.btn)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "parent_default type_name",
      staticStyle: {
        "display": "inline-block",
        "width": "200px",
        "text-align": "left"
      },
      domProps: {
        "textContent": _vm._s(item.area)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "inline-block",
        "width": "300px",
        "text-align": "left",
        "white-space": "nowrap"
      }
    }, [_vm._v("所属区域分类：" + _vm._s(item.typeName ? item.typeName : "--"))])]), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center",
      staticStyle: {
        "width": "30%",
        "display": "flex",
        "flex-wrap": "nowrap",
        "white-space": "nowrap"
      }
    }, [_c('span', {
      staticClass: "left",
      staticStyle: {
        "font-size": "14px",
        "white-space": "nowrap",
        "width": "150px",
        "padding-right": "50px"
      }
    }, [_vm._v("排号字母：" + _vm._s(item.numBegin))]), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-bianji",
      staticStyle: {
        "margin": "0 10px"
      },
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      staticStyle: {
        "margin": "0 10px"
      },
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])]), _vm._v(" "), (item.isOpen && _vm.btn) ? _c('div', {
      staticClass: "type_child",
      style: ({
        height: (100 - 100 / (item.children.length + 1) + '%')
      })
    }, _vm._l((item.children), function(oitem, oInd) {
      return _c('div', {
        staticClass: "type_child_item",
        style: ({
          height: (100 / (item.children.length) + '%')
        })
      }, [_c('div', {
        staticClass: "type_child_left left flex flex-align-center"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(oitem.name)
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "flex",
          "margin-right": "170px"
        }
      }, [_c('span', {
        staticClass: "left",
        staticStyle: {
          "font-size": "14px",
          "padding-right": "100px",
          "white-space": "nowrap"
        }
      }, [_vm._v("IP地址：" + _vm._s(oitem.ipAddress))]), _vm._v(" "), _c('span', {
        staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
      }, [_c('i', {
        staticClass: "iconfont icon-bianji",
        staticStyle: {
          "padding-right": "10px",
          "cursor": "pointer"
        },
        attrs: {
          "title": "修改"
        },
        on: {
          "click": function($event) {
            return _vm.modifySite(item, oitem)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "iconfont icon-icon1460188478041",
        staticStyle: {
          "padding-right": "10px",
          "cursor": "pointer"
        },
        attrs: {
          "title": "删除"
        },
        on: {
          "click": function($event) {
            return _vm.delSite(item, oitem)
          }
        }
      })])])])
    }), 0) : _vm._e()])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑",
      "visible": _vm.addJobVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("区域名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.area),
      expression: "obj.area"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.obj.area)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "area", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("所属区域分类")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.obj.typeId),
      callback: function($$v) {
        _vm.$set(_vm.obj, "typeId", $$v)
      },
      expression: "obj.typeId"
    }
  }, _vm._l((_vm.typeOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("排号字母")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.numBegin),
      expression: "obj.numBegin"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "oninput": "this.value = this.value.toUpperCase()",
      "placeholder": "请输入字母"
    },
    domProps: {
      "value": (_vm.obj.numBegin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "numBegin", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "批量添加机位",
      "visible": _vm.showModifySiteBatch
    },
    on: {
      "update:visible": function($event) {
        _vm.showModifySiteBatch = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("起始IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBatchSite.beginIp),
      expression: "newBatchSite.beginIp"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "如：192.168.1.1"
    },
    domProps: {
      "value": (_vm.newBatchSite.beginIp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBatchSite, "beginIp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "110px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("生成机位数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBatchSite.count),
      expression: "newBatchSite.count"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "placeholder": "如:50"
    },
    domProps: {
      "value": (_vm.newBatchSite.count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBatchSite, "count", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModifySiteBatch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doAddNewSiteBatch
    }
  }, [_vm._v("生成")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑机位",
      "visible": _vm.showModifySite
    },
    on: {
      "update:visible": function($event) {
        _vm.showModifySite = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("机位名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSite.name),
      expression: "newSite.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.newSite.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSite, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSite.ipAddress),
      expression: "newSite.ipAddress"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.newSite.ipAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSite, "ipAddress", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModifySite = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doAddNewSite
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', [_vm._v("区域名称")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reward"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem",
    on: {
      "click": function($event) {
        _vm.searchList = []
      }
    }
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("租赁汇总")]), _vm._v(" "), _c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "month-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy-MM",
      "format": "yyyy 年 MM 月",
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.valueForMonth),
      callback: function($$v) {
        _vm.valueForMonth = $$v
      },
      expression: "valueForMonth"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.form.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "beginTime", $$v)
      },
      expression: "form.beginTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.form.endTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "endTime", $$v)
      },
      expression: "form.endTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "day-filter"
  }) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.tableList.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.tableList.length > 10
    }
  }, _vm._l((_vm.tableList), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.name
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.time
      },
      domProps: {
        "textContent": _vm._s(item.time)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.amount
      },
      domProps: {
        "textContent": _vm._s(item.amount)
      }
    })])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.tableList.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.tableList.length > 10
    }
  }, _vm._l((_vm.tableList), function(item, ind) {
    return _c('tr', {
      key: ind
    }, [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.numName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.ruleName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.mobile)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("快乐；kll")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.totalAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.payAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.getAmount)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.refundAmount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e()])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "left item"
  }, [_vm._v("总押金:"), _c('span', {
    staticClass: "num color3"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.totalInfo.totalAmount)))])]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("实收:"), _c('span', {
    staticClass: "num color2"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.totalInfo.getAmount)))])]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("退回押金:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.totalInfo.refundAmount)))])])]), _vm._v(" "), _c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("使用时长")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("实收金额")])])])
}]}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couponProfile"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "searchBox"
  }, [_c('div', {
    staticClass: "back"
  }, [_c('button', {
    staticClass: "back-arrow",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'addcoupon'
        })
      }
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('div', {
    staticClass: "coupon-info"
  }, [_c('div', {
    staticClass: "couopon-name info-item"
  }, [_vm._v("优惠券名称：" + _vm._s(_vm.$route.query.couponName))]), _vm._v(" "), _c('div', {
    staticClass: "create-name info-item"
  }, [_vm._v("创建人：" + _vm._s(_vm.$route.query.createName))]), _vm._v(" "), _c('div', {
    staticClass: "couopon-desc info-item",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', [(_vm.$route.query.startTime && _vm.$route.query.endTime && !_vm.$route.query.expireDay) ? _c('span', {
    staticClass: "time"
  }, [_vm._v("有效时间："), _c('i', [_vm._v(_vm._s(_vm._f("numberToDate")(_vm.$route.query.startTime, '')))]), _vm._v("至"), _c('i', [_vm._v(_vm._s(_vm._f("numberToDate")(_vm.$route.query.endTime, '')))])]) : _c('span', {
    staticClass: "time"
  }, [_vm._v("有效天数："), _c('i', [_vm._v(_vm._s(_vm.$route.query.expireDay) + "天")])]), _vm._v(" "), _c('span', {
    staticClass: "gift"
  }, [_vm._v(" 已派发：" + _vm._s(_vm.$route.query.sendCount) + "张")]), _vm._v(" "), _c('span', {
    staticClass: "gift"
  }, [_vm._v(" 已使用：" + _vm._s(_vm.$route.query.useCount) + "张")])]), _vm._v(" "), _c('div', {
    staticClass: "stop"
  }, [(_vm.$route.query.statusType != 'STOP' && _vm.$route.query.statusType != 'EXPIRED') ? _c('button', {
    on: {
      "click": _vm.stop
    }
  }, [_vm._v("停用")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-change"
  }, [_c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.filterStatus == 'NORMAL'
    },
    on: {
      "click": function($event) {
        return _vm.filterCoupon('NORMAL')
      }
    }
  }, [_vm._v("已派发优惠券")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.filterStatus == 'STOP'
    },
    on: {
      "click": function($event) {
        return _vm.filterCoupon('STOP')
      }
    }
  }, [_vm._v("已作废优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "coupon-filter"
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('span', [_vm._v("会员搜索：")]), _vm._v(" "), _c('div', {
    staticClass: "search",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入会员手机号码."
    },
    model: {
      value: (_vm.searchPhone),
      callback: function($$v) {
        _vm.searchPhone = $$v
      },
      expression: "searchPhone"
    }
  }), _vm._v(" "), (_vm.searchData.length > 0) ? _c('div', {
    staticClass: "vip-list-wrap"
  }, [_c('div', {
    staticClass: "vip-list"
  }, [_c('ul', _vm._l((_vm.searchData), function(item, index) {
    return _c('li', {
      key: index,
      class: _vm.nowVipIndex == index ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.setNowSearchVip(item)
        },
        "mouseenter": function($event) {
          _vm.nowVipIndex = index
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "phone-num right"
    }, [_vm._v(_vm._s(item.mobile))])])
  }), 0)])]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.couponList.length > _vm.pageSize
    }
  }, _vm._l((_vm.couponList), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticClass: "wrap",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('el-tooltip', {
      key: item.id,
      attrs: {
        "effect": "dark",
        "disabled": !item.id,
        "content": _vm.$route.query.goodsName,
        "placement": "top"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "overflowText"
    }, [_vm._v(_vm._s(_vm.$route.query.goodsName))]) : _vm._e()])], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.memberName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.mobile))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.creatorName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("numberToDate")(item.addTime, '')))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [(item.id) ? [_c('span', [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.endTime)))])] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.stautsOprions[item.stauts]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('span', [_vm._v(_vm._s(item.stauts == "VERIFIED" ? new Date(item.validateTime).Format("yyyy/MM/dd hh:mm:ss") : "--"))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [(item.id && item.stauts == 'NORMAL') ? _c('span', {
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.stopItem(item)
        }
      }
    }, [_vm._v("作废")]) : _vm._e(), _vm._v(" "), (item.id && item.stauts != 'NORMAL') ? _c('span', [_vm._v("---")]) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("抵用商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("会员名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("会员号码")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("派发员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("派发时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("到期时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("核销时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showUpBox(null)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加分类\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.listData.length > 10
    }
  }, _vm._l((_vm.listData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }, [_c('span', [_vm._v(_vm._s(item.queue))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "left",
        "padding-left": "10%"
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "text-align": "right",
        "padding-right": "10%"
      }
    }, [(item.id) ? _c('span', {
      staticStyle: {
        "margin": "0 2%",
        "cursor": "pointer"
      },
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.showUpBox(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]) : _vm._e(), _vm._v(" "), (item.id) ? _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '添加/编辑分类',
      "visible": _vm.addAddrBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addAddrBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("分类名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("分类排序")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.queue),
      expression: "form.queue"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.queue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "queue", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addAddrBtn = false
      }
    }
  }, [_vm._v("\n        取消\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addAddrFn
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("\n                分类名称\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }, [_vm._v("\n                排序值\n              ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "left",
      "padding-left": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%",
      "text-align": "right",
      "padding-right": "10%"
    }
  }, [_vm._v("\n                操作\n              ")])])])
}]}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "homeConBox"
  })])
}]}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupondetail"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.nowType == 'DAY') ? _c('div', {
    staticClass: "date-filter"
  }, [_c('el-date-picker', {
    ref: "dateInput",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "placeholder": "请选择选择日期"
    },
    model: {
      value: (_vm.dateStr),
      callback: function($$v) {
        _vm.dateStr = $$v
      },
      expression: "dateStr"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-jiantou",
    on: {
      "click": function($event) {
        return _vm.$refs.dateInput.handleFocus()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'TIME_RANGE') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "quick-filter"
  }, [_c('span', {
    class: _vm.nowSelFilter == 'today' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('today')
      }
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastDay' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastDay')
      }
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'week' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('week')
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastWeek' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastWeek')
      }
    }
  }, [_vm._v("上周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'month' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('month')
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastMonth' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastMonth')
      }
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.couponList.length > _vm.pageSize
    }
  }, _vm._l((_vm.couponList), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.couponName ? (ind + 1) : '')
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "18%"
      }
    }, [_vm._v(_vm._s(item.couponName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.giveTotalCount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.clickCount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.shareCount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.shareGiveCount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.verShareCount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.verTotalCount))])])
  }), 0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("优惠券名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("投放数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("点击数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("分享数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("分享领取数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("分享核销数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("总核销数")])])])
}]}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "charge-info",
    attrs: {
      "id": "charge-info"
    }
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchPhone),
      expression: "searchPhone"
    }],
    staticClass: "search-inp",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入会员手机号码.（选填）"
    },
    domProps: {
      "value": (_vm.searchPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchPhone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nowType == 'MONTH') ? _c('div', {
    staticClass: "date-filter"
  }, [_c('el-date-picker', {
    ref: "dateInput",
    attrs: {
      "type": "month",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "placeholder": "请选择选择日期"
    },
    model: {
      value: (_vm.dateStr),
      callback: function($$v) {
        _vm.dateStr = $$v
      },
      expression: "dateStr"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-jiantou",
    on: {
      "click": function($event) {
        return _vm.$refs.dateInput.handleFocus()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'TIME_RANGE') ? _c('div', {
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "quick-filter"
  }, [_c('span', {
    class: _vm.nowSelFilter == 'today' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('today')
      }
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastDay' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastDay')
      }
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'week' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('week')
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastWeek' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastWeek')
      }
    }
  }, [_vm._v("上周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'month' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('month')
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastMonth' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastMonth')
      }
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])])], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'MONTH') ? _c('button', {
    staticClass: "do-search",
    on: {
      "click": _vm.doSearch
    }
  }, [_vm._v("查询")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "total-charge"
  }, [_vm._v("总充值金额：" + _vm._s(_vm.totalChargeAmount.toFixed(2)))]), _vm._v(" "), _c('span', {
    staticClass: "total-charge"
  }, [_vm._v("总赠送金额：" + _vm._s(_vm.totalDiscountAmount.toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.verifiList.length > _vm.pageSize
    }
  }, _vm._l((_vm.verifiList), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.paymentTime ? ind + 1 + (_vm.currentPage - 1) * _vm.pageSize : ""))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.paymentTime)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.memberName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.mobile))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.discount))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("会员名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("会员号码")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("充值金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("赠送金额")])])])
}]}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "totalSales"
  }, [_c('div', {
    staticClass: "tableConBox",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = false
      }
    }
  }, [_c('div', {
    staticClass: "tableTem",
    on: {
      "click": function($event) {
        _vm.searchList = []
      }
    }
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [(_vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "change-type"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'day'
      }
    }
  }, [_vm._v("日报")]), _vm._v(" "), _c('span', {
    class: _vm.nowType == 'day' ? 'type-wrap' : 'type-wrap to-right',
    on: {
      "click": function($event) {
        _vm.nowType == 'day' ? _vm.nowType = 'month' : _vm.nowType = 'day'
      }
    }
  }, [_c('i', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.nowType = 'month'
      }
    }
  }, [_vm._v("月报")])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "month-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "value-format": "yyyy-MM",
      "format": "yyyy 年 MM 月",
      "picker-options": _vm.pickerOptions0,
      "type": "month",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.valueForMonth),
      callback: function($$v) {
        _vm.valueForMonth = $$v
      },
      expression: "valueForMonth"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "day-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptionsForDay
    },
    model: {
      value: (_vm.nowDay),
      callback: function($$v) {
        _vm.nowDay = $$v
      },
      expression: "nowDay"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchByWhichType == 'timeRange' && !_vm.isUseRangeTime),
      expression: "searchByWhichType=='timeRange'&&!isUseRangeTime"
    }],
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "datetime",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchByWhichType == 'timeRange' && _vm.isUseRangeTime),
      expression: "searchByWhichType=='timeRange'&&isUseRangeTime"
    }],
    staticClass: "time-range-filter"
  }, [_c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "dateTime",
    attrs: {
      "type": "date",
      "default-time": "23:59:59",
      "picker-options": _vm.pickerOptionsForTimeRange,
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('el-checkbox', {
    model: {
      value: (_vm.isUseRangeTime),
      callback: function($$v) {
        _vm.isUseRangeTime = $$v
      },
      expression: "isUseRangeTime"
    }
  }, [_vm._v("每一天的时间段")]) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange' && _vm.isUseRangeTime) ? _c('el-time-picker', {
    staticClass: "dateTime",
    attrs: {
      "is-range": "",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "placeholder": "选择时间范围"
    },
    model: {
      value: (_vm.rangeTime),
      callback: function($$v) {
        _vm.rangeTime = $$v
      },
      expression: "rangeTime"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "types"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.orderSource),
      callback: function($$v) {
        _vm.orderSource = $$v
      },
      expression: "orderSource"
    }
  }, _vm._l((_vm.orderSourceOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "types"
  }, [_vm._v("\n                        分类选择：\n                        "), _vm._v(" "), _c('div', {
    staticClass: "type-sel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showType = !_vm.showType
      }
    }
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.isSelAll ? '全部' : (_vm.selType.length > 0 ? ((_vm.selType[0]) + "...") : '分类选择')))]), _vm._v(" "), (_vm.showType) ? _c('div', {
    staticClass: "type-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ul', [_c('li', [_c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelAll),
      expression: "isSelAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 'ALL',
      "checked": Array.isArray(_vm.isSelAll) ? _vm._i(_vm.isSelAll, 'ALL') > -1 : (_vm.isSelAll)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selAll.apply(null, arguments)
      },
      "change": function($event) {
        var $$a = _vm.isSelAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 'ALL',
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSelAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSelAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSelAll = $$c
        }
      }
    }
  }), _vm._v("全部")])]), _vm._v(" "), _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selType),
        expression: "selType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.value,
        "checked": Array.isArray(_vm.selType) ? _vm._i(_vm.selType, item.value) > -1 : (_vm.selType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selType = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selType = $$c
          }
        }
      }
    }), _vm._v(_vm._s(item.label))])])
  })], 2)])]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "quick-filter"
  }, [_c('span', {
    class: _vm.nowSelFilter == 'today' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('today')
      }
    }
  }, [_vm._v("今日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastDay' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastDay')
      }
    }
  }, [_vm._v("昨日")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'week' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('week')
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastWeek' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastWeek')
      }
    }
  }, [_vm._v("上周")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'month' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('month')
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('span', {
    class: _vm.nowSelFilter == 'lastMonth' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.filter('lastMonth')
      }
    }
  }, [_vm._v("上月")])]), _vm._v(" "), _c('span', {
    staticClass: "types typesSearch"
  }, [_c('span', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchConfirm
    }
  }, [_vm._v("查询")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#f54747",
      "font-size": "14px",
      "lineHeight": "18px"
    }
  }, [_vm._v("不包含会员充值和退单数据！")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workData.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.name) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.name) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.parentTypeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.amount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workDataForMonth.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workDataForMonth.length > 10
    }
  }, _vm._l((_vm.workDataForMonth), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.name) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.name) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.parentTypeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.amount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "tableBox scrollBox tableBox-for-month"
  }, [_c('div', {
    staticClass: "scroll"
  }, [(_vm.workDataForTimeRange.length > 0) ? _c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workDataForTimeRange.length > 10
    }
  }, _vm._l((_vm.workDataForTimeRange), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.name) ? _c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    }) : _vm._e(), _vm._v(" "), (!item.name) ? _c('span') : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      domProps: {
        "textContent": _vm._s(item.salesPrice)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.parentTypeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.amount)))])])
  }), 0) : _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n                                暂无记录，请点击查询或者重新选择查询条件。\n                            ")])])]) : _vm._e()])]), _vm._v(" "), (_vm.nowType == 'day' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQty)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("总收入:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmount)))]), _vm._v(" "), (_vm.channelInfo) ? _c('span', {
    staticClass: "channel-info"
  }, [_c('span', [_vm._v("微信：" + _vm._s(_vm.channelInfo.wechatAmount))]), _vm._v(" "), _c('span', [_vm._v("、支付宝：" + _vm._s(_vm.channelInfo.aliAmount))]), _vm._v(" "), _c('span', [_vm._v("、会员支付：" + _vm._s(_vm.channelInfo.memberAmount))]), _vm._v(" "), _c('span', [_vm._v("、银联支付：" + _vm._s(_vm.channelInfo.unionpayAmount))]), _vm._v(" "), _c('span', [_vm._v("、现金支付：" + _vm._s(_vm.channelInfo.cashAmount))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.nowType == 'month' && _vm.searchByWhichType == 'dayOrMonth') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQtyForMonth)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("总收入:"), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmountForMonth)))]), _vm._v(" "), (_vm.channelInfo) ? _c('span', {
    staticClass: "channel-info"
  }, [_c('span', [_vm._v("微信：" + _vm._s(_vm.channelInfo.wechatAmount))]), _vm._v(" "), _c('span', [_vm._v("、支付宝：" + _vm._s(_vm.channelInfo.aliAmount))]), _vm._v(" "), _c('span', [_vm._v("、会员支付：" + _vm._s(_vm.channelInfo.memberAmount))]), _vm._v(" "), _c('span', [_vm._v("、银联支付：" + _vm._s(_vm.channelInfo.unionpayAmount))]), _vm._v(" "), _c('span', [_vm._v("、现金支付：" + _vm._s(_vm.channelInfo.cashAmount))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.searchByWhichType == 'timeRange') ? _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('span', {
    staticClass: "right excel",
    on: {
      "click": _vm.excel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_vm._v("数量:"), _c('span', {
    staticClass: "num color3",
    domProps: {
      "textContent": _vm._s(_vm.allQtyForTimeRange)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "left item"
  }, [_c('span', [_vm._v("总收入:  \n                            "), _c('span', {
    staticClass: "num color5"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.allAmountForTimeRange)))]), _vm._v(" "), (_vm.channelInfo && _vm.channelInfo.memberAmount) ? _c('span', {
    staticClass: "num color5",
    staticStyle: {
      "font-size": "16px",
      "padding-right": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("总实收：")]), _c('span', {
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v(_vm._s((_vm.allAmountForTimeRange - _vm.channelInfo.memberAmount).toFixed(2)))])]) : _vm._e()]), _vm._v(" "), (_vm.channelInfo) ? _c('span', {
    staticClass: "channel-info"
  }, [_c('span', [_vm._v("微信：" + _vm._s(_vm.channelInfo.wechatAmount))]), _vm._v(" "), _c('span', [_vm._v("、支付宝：" + _vm._s(_vm.channelInfo.aliAmount))]), _vm._v(" "), _c('span', [_vm._v("、会员支付：" + _vm._s(_vm.channelInfo.memberAmount))]), _vm._v(" "), _c('span', [_vm._v("、银联支付：" + _vm._s(_vm.channelInfo.unionpayAmount))]), _vm._v(" "), _c('span', [_vm._v("、现金支付：" + _vm._s(_vm.channelInfo.cashAmount))])]) : _vm._e()])])]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "scrollBox"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("售价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("一级分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("二级分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("总计")])])])
}]}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voucher"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "width": "130px"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showUpBox
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("添加代金券")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.couponList.length < 10
    }
  }, _vm._l((_vm.couponList), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.couponName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("numberToMonthDate")(item.addTime, '')))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("numberToDate")(item.startTime, '')))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm._f("numberToDate")(item.endTime, '')))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.startAmount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.useAmount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.giveAmount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('el-button', {
      attrs: {
        "type": "text",
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.uploadCoupon(item)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bianji"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delCoupon(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-icon1460188478041"
    })])], 1) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isChangeCoupon ? '修改代金券' : '添加代金券',
      "visible": _vm.addCouponBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.addCouponBtn = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msg clearfix",
    on: {
      "click": function($event) {
        _vm.goodCheckArr = []
      }
    }
  }, [_c('div', {
    staticClass: "couponConBox left clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("代金券名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.name),
      expression: "newCoupon.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入代金券名称"
    },
    domProps: {
      "value": (_vm.newCoupon.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("满值赠送")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.startAmount),
      expression: "newCoupon.startAmount"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.newCoupon.startAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "startAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("用户消费满设定的金额才能赠送代金券")])]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("使用代金券所需金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.useAmount),
      expression: "newCoupon.useAmount"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.newCoupon.useAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "useAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("用户消费满设定的金额才能使用代金券")])]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("代金券面值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCoupon.giveAmount),
      expression: "newCoupon.giveAmount"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.newCoupon.giveAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCoupon, "giveAmount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_c('i', [_vm._v("*")]), _vm._v("使用时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择开始日期"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "value-format": "yyyy/MM/dd",
      "type": "date",
      "editable": false,
      "placeholder": "选择到期日期"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addCouponBtn = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveCoupon
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("代金券名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("开始日期")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("结束日期")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("满值赠送")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("使用金额")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("面值")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ })
],[403]);


// WEBPACK FOOTER //
// static/js/app.775c97e85ade1ab44122.js